[
   {
      "type": "integration",
      "created_at": "2026-10-25T00:00:00.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "integration_type": "agilitycms",
      "integration_name": "Agility CMS"
   },
   {
      "type": "integration",
      "created_at": "2026-10-25T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "admina",
      "integration_name": "Admina by Money Forward"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "zushealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Zus Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "zushealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Zus Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "zushealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Zus Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "zushealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Zus Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "zushealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Zus Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "zushealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Zus Health"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "duration_seconds",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "answer_at",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "object",
      "object_type": "calendar_location",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "object_type": "calendar_room",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "calendar_room",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "calendar_room",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "calendar_location",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "calendar_location",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinventory",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Zoho Inventory"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinventory",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Zoho Inventory"
   },
   {
      "type": "pagination",
      "integration_type": "zohocampaigns",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_order",
      "integration_name": "Zoho Campaigns"
   },
   {
      "type": "pagination",
      "integration_type": "zohocampaigns",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_order",
      "integration_name": "Zoho Campaigns"
   },
   {
      "type": "pagination",
      "integration_type": "zohocampaigns",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_order",
      "integration_name": "Zoho Campaigns"
   },
   {
      "type": "readable_field",
      "integration_type": "yelp",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "commerce_location",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Yelp"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "welkinhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Welkin Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "welkinhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Welkin Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "welkinhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Welkin Health"
   },
   {
      "type": "object",
      "object_type": "calendar_location",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Webex"
   },
   {
      "type": "object",
      "object_type": "calendar_room",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "calendar_room",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "calendar_room",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "calendar_location",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "calendar_location",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "vonage",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Vonage"
   },
   {
      "type": "writable_field",
      "integration_type": "vonage",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "telephone",
      "integration_name": "Vonage"
   },
   {
      "type": "writable_field",
      "integration_type": "vonage",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Vonage"
   },
   {
      "type": "writable_field",
      "integration_type": "vonage",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "instructions",
      "integration_name": "Vonage"
   },
   {
      "type": "readable_field",
      "integration_type": "vonage",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Vonage"
   },
   {
      "type": "readable_field",
      "integration_type": "vonage",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "duration_seconds",
      "integration_name": "Vonage"
   },
   {
      "type": "readable_field",
      "integration_type": "vonage",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "cost_amount",
      "integration_name": "Vonage"
   },
   {
      "type": "method",
      "integration_type": "vonage",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Vonage"
   },
   {
      "type": "method",
      "integration_type": "vonage",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Vonage"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "integration_name": "Veradigm"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "integration_name": "Veradigm"
   },
   {
      "type": "readable_field",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Veradigm"
   },
   {
      "type": "readable_field",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Veradigm"
   },
   {
      "type": "readable_field",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Veradigm"
   },
   {
      "type": "readable_field",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Veradigm"
   },
   {
      "type": "readable_field",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Veradigm"
   },
   {
      "type": "readable_field",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Veradigm"
   },
   {
      "type": "readable_field",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Veradigm"
   },
   {
      "type": "method",
      "integration_type": "veradigm",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Veradigm"
   },
   {
      "type": "readable_field",
      "integration_type": "usps",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "actual_delivery_at",
      "integration_name": "USPS"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "unitedhealthcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "UnitedHealthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "unitedhealthcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "UnitedHealthcare"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "integration_type": "twitter",
      "object_type": "social_insight",
      "integration_name": "Twitter"
   },
   {
      "type": "method",
      "integration_type": "twitter",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "social_insight",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Twitter"
   },
   {
      "type": "writable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Twilio"
   },
   {
      "type": "writable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "telephone",
      "integration_name": "Twilio"
   },
   {
      "type": "writable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Twilio"
   },
   {
      "type": "writable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "instructions",
      "integration_name": "Twilio"
   },
   {
      "type": "readable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Twilio"
   },
   {
      "type": "readable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Twilio"
   },
   {
      "type": "readable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "duration_seconds",
      "integration_name": "Twilio"
   },
   {
      "type": "readable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Twilio"
   },
   {
      "type": "readable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "cost_amount",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Twilio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "integration_name": "TruBridge"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "integration_name": "TruBridge"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "integration_name": "TruBridge"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "integration_name": "TruBridge"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "integration_name": "TruBridge"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "integration_name": "TruBridge"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "integration_name": "TruBridge"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "integration_name": "TruBridge"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "integration_name": "TruBridge"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "integration_name": "TruBridge"
   },
   {
      "type": "readable_field",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "TruBridge"
   },
   {
      "type": "readable_field",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "TruBridge"
   },
   {
      "type": "readable_field",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "TruBridge"
   },
   {
      "type": "readable_field",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "TruBridge"
   },
   {
      "type": "readable_field",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "TruBridge"
   },
   {
      "type": "readable_field",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "TruBridge"
   },
   {
      "type": "readable_field",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TruBridge"
   },
   {
      "type": "method",
      "integration_type": "trubridge",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TruBridge"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_user_id",
      "integration_name": "Trello"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_company_id",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "telnyx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "duration_seconds",
      "integration_name": "Telnyx"
   },
   {
      "type": "readable_field",
      "integration_type": "telnyx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "answer_at",
      "integration_name": "Telnyx"
   },
   {
      "type": "object",
      "object_type": "calendar_room",
      "integration_type": "teem",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Teem"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_contact_id",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "Snapchat"
   },
   {
      "type": "readable_field",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "Snapchat"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "snapchat",
      "object_type": "ads_asset",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Snapchat"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "practitioner_ids",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "language",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "is_deceased",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "identifiers",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "deceased_at",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "birthdate",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "writable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "readable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "readable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "readable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "readable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "readable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "readable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "readable_field",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "method",
      "integration_type": "smartonfhir",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "calendar_room",
      "integration_type": "skedda",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Skedda"
   },
   {
      "type": "object",
      "object_type": "calendar_location",
      "integration_type": "robin",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Robin"
   },
   {
      "type": "object",
      "object_type": "calendar_room",
      "integration_type": "robin",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Robin"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "duration_seconds",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "PointClickCare"
   },
   {
      "type": "readable_field",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "PointClickCare"
   },
   {
      "type": "readable_field",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "PointClickCare"
   },
   {
      "type": "readable_field",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "PointClickCare"
   },
   {
      "type": "readable_field",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "PointClickCare"
   },
   {
      "type": "readable_field",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "PointClickCare"
   },
   {
      "type": "readable_field",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "PointClickCare"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "pointclickcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "PointClickCare"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "pointclickcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "PointClickCare"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "pointclickcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "PointClickCare"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "pointclickcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "PointClickCare"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "pointclickcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "PointClickCare"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "pointclickcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PointClickCare"
   },
   {
      "type": "method",
      "integration_type": "pointclickcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PointClickCare"
   },
   {
      "type": "writable_field",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Plivo"
   },
   {
      "type": "writable_field",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "telephone",
      "integration_name": "Plivo"
   },
   {
      "type": "writable_field",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Plivo"
   },
   {
      "type": "writable_field",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "instructions",
      "integration_name": "Plivo"
   },
   {
      "type": "readable_field",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Plivo"
   },
   {
      "type": "readable_field",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "duration_seconds",
      "integration_name": "Plivo"
   },
   {
      "type": "readable_field",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "cost_amount",
      "integration_name": "Plivo"
   },
   {
      "type": "readable_field",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "answer_at",
      "integration_name": "Plivo"
   },
   {
      "type": "method",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Plivo"
   },
   {
      "type": "method",
      "integration_type": "plivo",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Plivo"
   },
   {
      "type": "readable_field",
      "integration_type": "plaid",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "routing_number",
      "integration_name": "Plaid"
   },
   {
      "type": "readable_field",
      "integration_type": "plaid",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "bank_name",
      "integration_name": "Plaid"
   },
   {
      "type": "readable_field",
      "integration_type": "plaid",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "account_number",
      "integration_name": "Plaid"
   },
   {
      "type": "pagination",
      "integration_type": "plaid",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bankfeedaccount",
      "pagination": "slow_fields",
      "integration_name": "Plaid"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "particlehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Particle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "particlehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Particle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "particlehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Particle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "particlehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Particle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "particlehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Particle Health"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "OTYS"
   },
   {
      "type": "readable_field",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Orion Health"
   },
   {
      "type": "readable_field",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Orion Health"
   },
   {
      "type": "readable_field",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Orion Health"
   },
   {
      "type": "readable_field",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Orion Health"
   },
   {
      "type": "readable_field",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Orion Health"
   },
   {
      "type": "readable_field",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Orion Health"
   },
   {
      "type": "readable_field",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Orion Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "orionhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Orion Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "orionhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Orion Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "orionhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Orion Health"
   },
   {
      "type": "method",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Orion Health"
   },
   {
      "type": "method",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Orion Health"
   },
   {
      "type": "method",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Orion Health"
   },
   {
      "type": "method",
      "integration_type": "orionhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Orion Health"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "integration_name": "Oracle Health"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "integration_name": "Oracle Health"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "integration_name": "Oracle Health"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "integration_name": "Oracle Health"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "integration_name": "Oracle Health"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "integration_name": "Oracle Health"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Oracle Health"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Oracle Health"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Oracle Health"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Oracle Health"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Oracle Health"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Oracle Health"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Health"
   },
   {
      "type": "method",
      "integration_type": "oraclehealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Health"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclefusion",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclefusion",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclefusion",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclefusion",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "cancelled_at",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "integration_type": "oraclefusion",
      "object_type": "accounting_paymentterm",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "integration_type": "oraclefusion",
      "object_type": "accounting_organization",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "integration_type": "oraclefusion",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "integration_type": "oraclefusion",
      "object_type": "accounting_expensereport",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "writable_field",
      "integration_type": "ninjaone",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_device",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "NinjaOne"
   },
   {
      "type": "method",
      "integration_type": "ninjaone",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_device",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NinjaOne"
   },
   {
      "type": "readable_field",
      "integration_type": "nicecxone",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NICE CXone"
   },
   {
      "type": "readable_field",
      "integration_type": "nicecxone",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "NICE CXone"
   },
   {
      "type": "readable_field",
      "integration_type": "nicecxone",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "NICE CXone"
   },
   {
      "type": "readable_field",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "readable_field",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "readable_field",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "readable_field",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "readable_field",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "readable_field",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "readable_field",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "method",
      "integration_type": "nextgen",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "readable_field",
      "integration_type": "netsmart",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Netsmart"
   },
   {
      "type": "readable_field",
      "integration_type": "netsmart",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Netsmart"
   },
   {
      "type": "readable_field",
      "integration_type": "netsmart",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Netsmart"
   },
   {
      "type": "readable_field",
      "integration_type": "netsmart",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Netsmart"
   },
   {
      "type": "readable_field",
      "integration_type": "netsmart",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Netsmart"
   },
   {
      "type": "readable_field",
      "integration_type": "netsmart",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Netsmart"
   },
   {
      "type": "readable_field",
      "integration_type": "netsmart",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Netsmart"
   },
   {
      "type": "readable_field",
      "integration_type": "modmed",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "ModMed"
   },
   {
      "type": "readable_field",
      "integration_type": "modmed",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "ModMed"
   },
   {
      "type": "readable_field",
      "integration_type": "modmed",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "ModMed"
   },
   {
      "type": "readable_field",
      "integration_type": "modmed",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "ModMed"
   },
   {
      "type": "writable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mixpanel"
   },
   {
      "type": "writable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Mixpanel"
   },
   {
      "type": "writable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Mixpanel"
   },
   {
      "type": "writable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "country_code",
      "integration_name": "Mixpanel"
   },
   {
      "type": "readable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mixpanel"
   },
   {
      "type": "readable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mixpanel"
   },
   {
      "type": "readable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "country_code",
      "integration_name": "Mixpanel"
   },
   {
      "type": "readable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "country_code",
      "integration_name": "Mixpanel"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "metriport",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Metriport"
   },
   {
      "type": "readable_field",
      "integration_type": "medtech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "readable_field",
      "integration_type": "medtech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "readable_field",
      "integration_type": "medtech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "readable_field",
      "integration_type": "medtech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "readable_field",
      "integration_type": "medtech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "readable_field",
      "integration_type": "medtech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "readable_field",
      "integration_type": "medtech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "medplum",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Medplum"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "medplum",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Medplum"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "medplum",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Medplum"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "medplum",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Medplum"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "medplum",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Medplum"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "medplum",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Medplum"
   },
   {
      "type": "readable_field",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "MEDITECH"
   },
   {
      "type": "readable_field",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "MEDITECH"
   },
   {
      "type": "readable_field",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "MEDITECH"
   },
   {
      "type": "readable_field",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "MEDITECH"
   },
   {
      "type": "readable_field",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "MEDITECH"
   },
   {
      "type": "readable_field",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "MEDITECH"
   },
   {
      "type": "readable_field",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MEDITECH"
   },
   {
      "type": "method",
      "integration_type": "meditech",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MEDITECH"
   },
   {
      "type": "writable_field",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Marketing360"
   },
   {
      "type": "writable_field",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Marketing360"
   },
   {
      "type": "writable_field",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Marketing360"
   },
   {
      "type": "writable_field",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Marketing360"
   },
   {
      "type": "writable_field",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Marketing360"
   },
   {
      "type": "writable_field",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Marketing360"
   },
   {
      "type": "readable_field",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Marketing360"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "marketing360",
      "object_type": "metadata_metadata",
      "integration_name": "Marketing360"
   },
   {
      "type": "method",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Marketing360"
   },
   {
      "type": "method",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Marketing360"
   },
   {
      "type": "method",
      "integration_type": "marketing360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Marketing360"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mailchimp"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Mailchimp"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mailchimp"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "labcorp",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Labcorp"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "labcorp",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Labcorp"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "kipuhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Kipu Health"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "keka",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_job",
      "integration_name": "Keka"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "keka",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_job",
      "integration_name": "Keka"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "keka",
      "object_type": "hris_attendance",
      "integration_name": "Keka"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "keka",
      "object_type": "hris_job",
      "integration_name": "Keka"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "keka",
      "object_type": "hris_paycode",
      "integration_name": "Keka"
   },
   {
      "type": "method",
      "integration_type": "keka",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Keka"
   },
   {
      "type": "method",
      "integration_type": "keka",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Keka"
   },
   {
      "type": "method",
      "integration_type": "keka",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_paycode",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Keka"
   },
   {
      "type": "object",
      "object_type": "calendar_location",
      "integration_type": "kadence",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Kadence"
   },
   {
      "type": "object",
      "object_type": "calendar_room",
      "integration_type": "kadence",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Kadence"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ats",
         "ads",
         "passthrough"
      ],
      "integration_type": "jobcase",
      "object_type": "ads_campaign",
      "integration_name": "Jobcase"
   },
   {
      "type": "method",
      "integration_type": "jobcase",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ats",
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jobcase"
   },
   {
      "type": "method",
      "integration_type": "jobcase",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ats",
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobcase"
   },
   {
      "type": "method",
      "integration_type": "jobcase",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ats",
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobcase"
   },
   {
      "type": "method",
      "integration_type": "jobcase",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ats",
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobcase"
   },
   {
      "type": "object",
      "object_type": "calendar_room",
      "integration_type": "joan",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Joan"
   },
   {
      "type": "writable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "writable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "writable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "writable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "subject_line",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "from_email",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "integration_type": "instantlyai",
      "object_type": "hris_employee",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "humana",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Humana"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "humana",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Humana"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "humana",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Humana"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "humana",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Humana"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "humana",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Humana"
   },
   {
      "type": "writable_field",
      "integration_type": "heyreach",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HeyReach"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "heyreach",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "messaging_channel",
      "integration_name": "HeyReach"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "heyreach",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "messaging_channel",
      "integration_name": "HeyReach"
   },
   {
      "type": "readable_field",
      "integration_type": "heyreach",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HeyReach"
   },
   {
      "type": "pagination",
      "integration_type": "heyreach",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_member_id",
      "integration_name": "HeyReach"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "integration_type": "heyreach",
      "object_type": "messaging_channel",
      "integration_name": "HeyReach"
   },
   {
      "type": "method",
      "integration_type": "heyreach",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HeyReach"
   },
   {
      "type": "method",
      "integration_type": "heyreach",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "HeyReach"
   },
   {
      "type": "method",
      "integration_type": "heyreach",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "HeyReach"
   },
   {
      "type": "method",
      "integration_type": "heyreach",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HeyReach"
   },
   {
      "type": "method",
      "integration_type": "heyreach",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "martech",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HeyReach"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "healthgorilla",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Health Gorilla"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "healthgorilla",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Health Gorilla"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "healthgorilla",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Health Gorilla"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "healthgorilla",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Health Gorilla"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "healthgorilla",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Health Gorilla"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "healthgorilla",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Health Gorilla"
   },
   {
      "type": "readable_field",
      "integration_type": "greenway",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Greenway Health"
   },
   {
      "type": "readable_field",
      "integration_type": "greenway",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Greenway Health"
   },
   {
      "type": "readable_field",
      "integration_type": "greenway",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Greenway Health"
   },
   {
      "type": "readable_field",
      "integration_type": "greenway",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Greenway Health"
   },
   {
      "type": "readable_field",
      "integration_type": "greenway",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Greenway Health"
   },
   {
      "type": "readable_field",
      "integration_type": "greenway",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Greenway Health"
   },
   {
      "type": "readable_field",
      "integration_type": "greenway",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "greenhouse",
      "object_type": "hris_group",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Greenhouse"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlesa360",
      "object_type": "ads_asset",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "practitioner_ids",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "language",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "is_deceased",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "identifiers",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "deceased_at",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "birthdate",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "method",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "method",
      "integration_type": "googlecloudhealthcare",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_query",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_order",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_query",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_status",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_order",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_query",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_status",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_order",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_campaign_id",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_query",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_status",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_order",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_query",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_status",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_order",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_group_id",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googlebusiness",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Google Business Profile"
   },
   {
      "type": "readable_field",
      "integration_type": "googlebusiness",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "is_verified",
      "integration_name": "Google Business Profile"
   },
   {
      "type": "readable_field",
      "integration_type": "googlebusiness",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Google Business Profile"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Fiken"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Fiken"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Fiken"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Fiken"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "commerce_item",
      "integration_name": "Fiken"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Fiken"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Fiken"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Fiken"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Fiken"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fiken",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "commerce_item",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "project_id",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Fiken"
   },
   {
      "type": "readable_field",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_query",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_updated_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_start_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_end_lt",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_contact_id",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_updated_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_query",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_updated_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Fiken"
   },
   {
      "type": "pagination",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Fiken"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "fiken",
      "object_type": "accounting_creditmemo",
      "integration_name": "Fiken"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "fiken",
      "object_type": "accounting_quote",
      "integration_name": "Fiken"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "fiken",
      "object_type": "accounting_salesorder",
      "integration_name": "Fiken"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "fiken",
      "object_type": "accounting_project",
      "integration_name": "Fiken"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "fiken",
      "object_type": "accounting_transaction",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fiken"
   },
   {
      "type": "method",
      "integration_type": "fiken",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fiken"
   },
   {
      "type": "writable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "reference_number",
      "integration_name": "FedEx"
   },
   {
      "type": "writable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "is_signature_required",
      "integration_name": "FedEx"
   },
   {
      "type": "writable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "is_adult_signature_required",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "shipped_at",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "reference_number",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "rate_service_name",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "is_signature_required",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "is_international",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "is_adult_signature_required",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "carrier_name",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "carrier_id",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "fedex",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "actual_delivery_at",
      "integration_name": "FedEx"
   },
   {
      "type": "readable_field",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Epic"
   },
   {
      "type": "readable_field",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Epic"
   },
   {
      "type": "readable_field",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Epic"
   },
   {
      "type": "readable_field",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Epic"
   },
   {
      "type": "readable_field",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Epic"
   },
   {
      "type": "readable_field",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Epic"
   },
   {
      "type": "readable_field",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Epic"
   },
   {
      "type": "method",
      "integration_type": "epic",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "calendar_location",
      "integration_type": "envoy",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Envoy"
   },
   {
      "type": "object",
      "object_type": "calendar_room",
      "integration_type": "envoy",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Envoy"
   },
   {
      "type": "pagination",
      "integration_type": "enrichlayer",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_twitter",
      "integration_name": "Enrich Layer"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "elevancehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Elevance Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "elevancehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Elevance Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "elevancehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Elevance Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "elevancehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Elevance Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "elevancehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Elevance Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "elevancehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Elevance Health"
   },
   {
      "type": "writable_field",
      "integration_type": "dialpad",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Dialpad"
   },
   {
      "type": "writable_field",
      "integration_type": "dialpad",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Dialpad"
   },
   {
      "type": "writable_field",
      "integration_type": "dialpad",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "telephone",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "duration_seconds",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "answer_at",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "object_type": "calendar_location",
      "integration_type": "deskbird",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "deskbird"
   },
   {
      "type": "object",
      "object_type": "calendar_room",
      "integration_type": "deskbird",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "deskbird"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "cmsbluebutton",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "CMS Blue Button 2.0"
   },
   {
      "type": "readable_field",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "CharmHealth"
   },
   {
      "type": "readable_field",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "CharmHealth"
   },
   {
      "type": "readable_field",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "CharmHealth"
   },
   {
      "type": "readable_field",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "CharmHealth"
   },
   {
      "type": "readable_field",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "CharmHealth"
   },
   {
      "type": "readable_field",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "CharmHealth"
   },
   {
      "type": "readable_field",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "CharmHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "charmhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "CharmHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "charmhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "CharmHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "charmhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "CharmHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "charmhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "CharmHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "charmhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "CharmHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "charmhealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CharmHealth"
   },
   {
      "type": "method",
      "integration_type": "charmhealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CharmHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "centene",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Centene"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "centene",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Centene"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "centene",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Centene"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "centene",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Centene"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "centene",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Centene"
   },
   {
      "type": "readable_field",
      "integration_type": "canvasmedical",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Canvas Medical"
   },
   {
      "type": "readable_field",
      "integration_type": "canvasmedical",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "Canvas Medical"
   },
   {
      "type": "readable_field",
      "integration_type": "canvasmedical",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Canvas Medical"
   },
   {
      "type": "readable_field",
      "integration_type": "canvasmedical",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "Canvas Medical"
   },
   {
      "type": "readable_field",
      "integration_type": "canvasmedical",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Canvas Medical"
   },
   {
      "type": "readable_field",
      "integration_type": "canvasmedical",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Canvas Medical"
   },
   {
      "type": "readable_field",
      "integration_type": "canvasmedical",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Canvas Medical"
   },
   {
      "type": "readable_field",
      "integration_type": "cambio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "Cambio"
   },
   {
      "type": "readable_field",
      "integration_type": "cambio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "Cambio"
   },
   {
      "type": "readable_field",
      "integration_type": "cambio",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "Cambio"
   },
   {
      "type": "readable_field",
      "integration_type": "braze",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "subject_line",
      "integration_name": "Braze"
   },
   {
      "type": "readable_field",
      "integration_type": "braze",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "preview_text",
      "integration_name": "Braze"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_vendorcredit",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_vendorcredit",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Bill.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "paid_amount",
      "integration_name": "Bill.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "bill_number",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_contact_id",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_contact_id",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_contact_id",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_contact_id",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Bill.com"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "bill",
      "object_type": "accounting_vendorcredit",
      "integration_name": "Bill.com"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "bill",
      "object_type": "accounting_paymentterm",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bandwidth",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "integration_name": "Bandwidth"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "integration_type": "bandwidth",
      "object_type": "uc_call",
      "integration_name": "Bandwidth"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "integration_type": "bandwidth",
      "object_type": "uc_recording",
      "integration_name": "Bandwidth"
   },
   {
      "type": "method",
      "integration_type": "bandwidth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bandwidth"
   },
   {
      "type": "method",
      "integration_type": "bandwidth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bandwidth"
   },
   {
      "type": "method",
      "integration_type": "bandwidth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Bandwidth"
   },
   {
      "type": "method",
      "integration_type": "bandwidth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Bandwidth"
   },
   {
      "type": "method",
      "integration_type": "bandwidth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bandwidth"
   },
   {
      "type": "method",
      "integration_type": "bandwidth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bandwidth"
   },
   {
      "type": "method",
      "integration_type": "bandwidth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bandwidth"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "azurehealthdataservices",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Azure Health Data Services"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "azurehealthdataservices",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Azure Health Data Services"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "azurehealthdataservices",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Azure Health Data Services"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "azurehealthdataservices",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Azure Health Data Services"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "azurehealthdataservices",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Azure Health Data Services"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "azurehealthdataservices",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Azure Health Data Services"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "awshealthlake",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AWS HealthLake"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "awshealthlake",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AWS HealthLake"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "awshealthlake",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AWS HealthLake"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "awshealthlake",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AWS HealthLake"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "awshealthlake",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AWS HealthLake"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "awshealthlake",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AWS HealthLake"
   },
   {
      "type": "readable_field",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "athenahealth"
   },
   {
      "type": "readable_field",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "athenahealth"
   },
   {
      "type": "readable_field",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "athenahealth"
   },
   {
      "type": "readable_field",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "athenahealth"
   },
   {
      "type": "readable_field",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "athenahealth"
   },
   {
      "type": "readable_field",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "athenahealth"
   },
   {
      "type": "readable_field",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "athenahealth"
   },
   {
      "type": "method",
      "integration_type": "athenahealth",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "alayacare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AlayaCare"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "alayacare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AlayaCare"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "alayacare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AlayaCare"
   },
   {
      "type": "writable_field",
      "integration_type": "aircall",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "AirCall.io"
   },
   {
      "type": "writable_field",
      "integration_type": "aircall",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "writable_field",
      "integration_type": "aircall",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "telephone",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "duration_seconds",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "answer_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "AirCall.io"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "aidbox",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aidbox"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "aidbox",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aidbox"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "aidbox",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aidbox"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "aidbox",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aidbox"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "aidbox",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aidbox"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "aidbox",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aidbox"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "aetna",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aetna"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "aetna",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aetna"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "aetna",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aetna"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "aetna",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aetna"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "aetna",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aetna"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "aetna",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "Aetna"
   },
   {
      "type": "readable_field",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "route",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "readable_field",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "races",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "readable_field",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "readable_field",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "ethnicities",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "readable_field",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_unit",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "readable_field",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_medication",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "dose_number",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "readable_field",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_patient",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_document",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_coverage",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_procedure",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_report",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_careplan",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "method",
      "integration_type": "advancedmd",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "healthcare_goal",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "writable_field",
      "integration_type": "3cx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "3CX"
   },
   {
      "type": "writable_field",
      "integration_type": "3cx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "3CX"
   },
   {
      "type": "writable_field",
      "integration_type": "3cx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "3CX"
   },
   {
      "type": "writable_field",
      "integration_type": "3cx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "3CX"
   },
   {
      "type": "writable_field",
      "integration_type": "3cx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "3CX"
   },
   {
      "type": "readable_field",
      "integration_type": "3cx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "3CX"
   },
   {
      "type": "object",
      "created_at": "2026-10-24T23:33:15.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "3cx",
      "object_type": "hris_group",
      "integration_name": "3CX"
   },
   {
      "type": "method",
      "integration_type": "3cx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "3CX"
   },
   {
      "type": "method",
      "integration_type": "3cx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "3CX"
   },
   {
      "type": "method",
      "integration_type": "3cx",
      "created_at": "2026-10-24T23:33:15.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "3CX"
   },
   {
      "type": "object",
      "object_type": "healthcare_document",
      "integration_type": "1uphealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "1upHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_coverage",
      "integration_type": "1uphealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "1upHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_procedure",
      "integration_type": "1uphealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "1upHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_report",
      "integration_type": "1uphealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "1upHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_careplan",
      "integration_type": "1uphealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "1upHealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_goal",
      "integration_type": "1uphealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-24T23:33:15.000Z",
      "integration_name": "1upHealth"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "zushealth",
      "integration_name": "Zus Health"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "welkinhealth",
      "integration_name": "Welkin Health"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "unitedhealthcare",
      "integration_name": "UnitedHealthcare"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "messaging",
         "martech",
         "passthrough"
      ],
      "integration_type": "textrequest",
      "integration_name": "Text Request"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "messaging",
         "martech",
         "passthrough"
      ],
      "integration_type": "textit",
      "integration_name": "TextIt"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "telstra",
      "integration_name": "Telstra Messaging"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "taskip",
      "integration_name": "Taskip"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "task",
         "passthrough"
      ],
      "integration_type": "taskade",
      "integration_name": "Taskade"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "sezzle",
      "integration_name": "Sezzle"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "storage",
         "passthrough"
      ],
      "integration_type": "phraseanet",
      "integration_name": "Phraseanet"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "particlehealth",
      "integration_name": "Particle Health"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "neoncrm",
      "integration_name": "Neon CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "modelrush",
      "integration_name": "ModelRush"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "mobilepay",
      "integration_name": "Vipps MobilePay"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "mindbaz",
      "integration_name": "Mindbaz"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "microbilt",
      "integration_name": "MicroBilt"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "metriport",
      "integration_name": "Metriport"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "medplum",
      "integration_name": "Medplum"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "labcorp",
      "integration_name": "Labcorp"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "kipuhealth",
      "integration_name": "Kipu Health"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "humana",
      "integration_name": "Humana"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "healthgorilla",
      "integration_name": "Health Gorilla"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "elevancehealth",
      "integration_name": "Elevance Health"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "cmsbluebutton",
      "integration_name": "CMS Blue Button 2.0"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "cerebras",
      "integration_name": "Cerebras"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "centene",
      "integration_name": "Centene"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "bloomerang",
      "integration_name": "Bloomerang"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "billingo",
      "integration_name": "Billingo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "bexio",
      "integration_name": "bexio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "azurehealthdataservices",
      "integration_name": "Azure Health Data Services"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "awshealthlake",
      "integration_name": "AWS HealthLake"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "alayacare",
      "integration_name": "AlayaCare"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "aidbox",
      "integration_name": "Aidbox"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "aetna",
      "integration_name": "Aetna"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "6sense",
      "integration_name": "6sense"
   },
   {
      "type": "integration",
      "created_at": "2026-10-24T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "1uphealth",
      "integration_name": "1upHealth"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "tick",
      "integration_name": "Tick"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "textmagic",
      "integration_name": "Textmagic"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "terminalafrica",
      "integration_name": "Terminal Africa"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "teem",
      "integration_name": "Teem"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "tavus",
      "integration_name": "Tavus"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "swoogo",
      "integration_name": "Swoogo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "skedda",
      "integration_name": "Skedda"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "signeasy",
      "integration_name": "Signeasy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "robin",
      "integration_name": "Robin"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "resy",
      "integration_name": "Resy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "rallyup",
      "integration_name": "RallyUp"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "prembly",
      "integration_name": "Prembly"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "prefinery",
      "integration_name": "Prefinery"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "powrbot",
      "integration_name": "Powrbot"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "polly",
      "integration_name": "Polly"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "plezi",
      "integration_name": "Plezi"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "task",
         "passthrough"
      ],
      "integration_type": "planerka",
      "integration_name": "Planerka"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "pitchyes",
      "integration_name": "PitchYes"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "pims",
      "integration_name": "Pims"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "picpay",
      "integration_name": "PicPay"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "mrpeasy",
      "integration_name": "MRPeasy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "cdp",
         "martech",
         "passthrough"
      ],
      "integration_type": "moengage",
      "integration_name": "MoEngage"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "minimax",
      "integration_name": "MiniMax"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "uc",
         "calendar",
         "passthrough"
      ],
      "integration_type": "mihuai",
      "integration_name": "Mihu AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "merchantflow",
      "integration_name": "MerchantFlow"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "mensagia",
      "integration_name": "Mensagia"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "kadence",
      "integration_name": "Kadence"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "joan",
      "integration_name": "Joan"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "invoiceninja",
      "integration_name": "Invoice Ninja"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "envoy",
      "integration_name": "Envoy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dropboxteam",
      "integration_name": "Dropbox Team"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "deskbird",
      "integration_name": "deskbird"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "compxl",
      "integration_name": "CompXL"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "aimtell",
      "integration_name": "Aimtell"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "ahasend",
      "integration_name": "AhaSend"
   },
   {
      "type": "integration",
      "created_at": "2026-10-23T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "afterpay",
      "integration_name": "Afterpay"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "integration_type": "yooz",
      "object_type": "storage_file",
      "integration_name": "Yooz"
   },
   {
      "type": "method",
      "integration_type": "yooz",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Yooz"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "tally",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Tally"
   },
   {
      "type": "readable_field",
      "integration_type": "tally",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "field": "has_progress_bar",
      "integration_name": "Tally"
   },
   {
      "type": "method",
      "integration_type": "tally",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Tally"
   },
   {
      "type": "method",
      "integration_type": "tally",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Tally"
   },
   {
      "type": "method",
      "integration_type": "tally",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Tally"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_lms",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_lms",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_lms",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_lms",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "assigned_grade",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "qlik",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_order",
      "integration_name": "Qlik"
   },
   {
      "type": "pagination",
      "integration_type": "qlik",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Qlik"
   },
   {
      "type": "pagination",
      "integration_type": "qlik",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "Qlik"
   },
   {
      "type": "pagination",
      "integration_type": "qlik",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "Qlik"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Paradox"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_job_id",
      "integration_name": "Paradox"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Paradox"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "garmin",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "clubs_activity",
      "integration_name": "Garmin"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "garmin",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "clubs_activity",
      "integration_name": "Garmin"
   },
   {
      "type": "readable_field",
      "integration_type": "garmin",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "clubs_activity",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "field": "has_heartrate",
      "integration_name": "Garmin"
   },
   {
      "type": "readable_field",
      "integration_type": "garmin",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "clubs_activity",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "field": "athlete_id",
      "integration_name": "Garmin"
   },
   {
      "type": "readable_field",
      "integration_type": "canadapost",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "carrier_id",
      "integration_name": "Canada Post"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T16:29:30.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "box",
      "object_type": "hris_group",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2026-10-22T16:29:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "verifiable",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "response_completed_at",
      "integration_name": "Verifiable"
   },
   {
      "type": "readable_field",
      "integration_type": "verifiable",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "profile_name",
      "integration_name": "Verifiable"
   },
   {
      "type": "readable_field",
      "integration_type": "verifiable",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "profile_gender",
      "integration_name": "Verifiable"
   },
   {
      "type": "readable_field",
      "integration_type": "verifiable",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "profile_date_of_birth",
      "integration_name": "Verifiable"
   },
   {
      "type": "readable_field",
      "integration_type": "verifiable",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "profile_addresses",
      "integration_name": "Verifiable"
   },
   {
      "type": "readable_field",
      "integration_type": "learnupon",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "time_estimate_minutes",
      "integration_name": "LearnUpon"
   },
   {
      "type": "readable_field",
      "integration_type": "learnupon",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "published_at",
      "integration_name": "LearnUpon"
   },
   {
      "type": "readable_field",
      "integration_type": "learnupon",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "LearnUpon"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T11:36:01.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "learnupon",
      "object_type": "lms_collection",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "lms_collection",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LearnUpon"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T11:36:01.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "pagination",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T11:36:01.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "cegid_recruiting",
      "object_type": "hris_employee",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "method",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "method",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-10-22T11:36:01.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "notion",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "kms_comment",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "notion",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "kms_comment",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "notion",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "kms_comment",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2026-10-22T11:12:59.000Z",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_comment",
      "pagination": "native_webhook_parent_id",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Notion"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T11:12:59.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_location",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Freshservice"
   },
   {
      "type": "writable_field",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_location",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Freshservice"
   },
   {
      "type": "writable_field",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_location",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Freshservice"
   },
   {
      "type": "readable_field",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Freshservice"
   },
   {
      "type": "readable_field",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Freshservice"
   },
   {
      "type": "readable_field",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "Freshservice"
   },
   {
      "type": "readable_field",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Freshservice"
   },
   {
      "type": "readable_field",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Freshservice"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T11:12:59.000Z",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "integration_type": "freshservice",
      "object_type": "task_project",
      "integration_name": "Freshservice"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T11:12:59.000Z",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "integration_type": "freshservice",
      "object_type": "task_task",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_group",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_location",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_location",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_location",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "task_project",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "task_project",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "task_project",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "task_project",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshservice"
   },
   {
      "type": "method",
      "integration_type": "freshservice",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "task_task",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshservice"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "abacus",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_application",
      "integration_name": "Abacus"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "abacus",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_application",
      "integration_name": "Abacus"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T11:12:59.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "abacus",
      "object_type": "ats_application",
      "integration_name": "Abacus"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T11:12:59.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "abacus",
      "object_type": "ats_candidate",
      "integration_name": "Abacus"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T11:12:59.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "abacus",
      "object_type": "ats_job",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-10-22T11:12:59.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Abacus"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgready",
      "object_type": "hris_group",
      "integration_name": "UKG Ready"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgready",
      "object_type": "hris_job",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Ready"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "hris_job",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "hris_paycode",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_paycode",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "genai",
         "storage",
         "passthrough"
      ],
      "integration_type": "openai",
      "object_type": "storage_file",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "genai",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "genai",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "genai",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "OpenAI"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_start_gte",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_end_lt",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_limit",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_start_gte",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_end_lt",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_user_id",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_attendance",
      "pagination": "list_start_gte",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_attendance",
      "pagination": "list_end_lt",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_attendance",
      "pagination": "list_user_id",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "eurecia",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Eurécia"
   },
   {
      "type": "readable_field",
      "integration_type": "eurecia",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "approver_user_id",
      "integration_name": "Eurécia"
   },
   {
      "type": "readable_field",
      "integration_type": "eurecia",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "approved_at",
      "integration_name": "Eurécia"
   },
   {
      "type": "pagination",
      "integration_type": "eurecia",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_status",
      "integration_name": "Eurécia"
   },
   {
      "type": "writable_field",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Engagedly"
   },
   {
      "type": "writable_field",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Engagedly"
   },
   {
      "type": "writable_field",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Engagedly"
   },
   {
      "type": "writable_field",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Engagedly"
   },
   {
      "type": "writable_field",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Engagedly"
   },
   {
      "type": "pagination",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_limit",
      "integration_name": "Engagedly"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "engagedly",
      "object_type": "hris_group",
      "integration_name": "Engagedly"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "engagedly",
      "object_type": "hris_location",
      "integration_name": "Engagedly"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "engagedly",
      "object_type": "hris_job",
      "integration_name": "Engagedly"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "engagedly",
      "object_type": "lms_course",
      "integration_name": "Engagedly"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "engagedly",
      "object_type": "lms_activity",
      "integration_name": "Engagedly"
   },
   {
      "type": "object",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "engagedly",
      "object_type": "lms_student",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "lms_course",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "lms_student",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "lms_student",
      "categories": [
         "hris",
         "performance",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Engagedly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "ats_candidate",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "ats_job",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "crm_contact",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "crm_company",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "crm_deal",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "hris_employee",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "ats_candidate",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "ats_job",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "crm_contact",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "crm_company",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-22T10:19:16.000Z",
      "object_type": "crm_deal",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "boondmanager",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BoondManager"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "list_order",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-10-22T10:19:16.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "sage300people",
      "integration_name": "Sage 300 People"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "precisely",
      "integration_name": "Precisely"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "postnord",
      "integration_name": "PostNord"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "poli",
      "integration_name": "POLi"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "polarise",
      "integration_name": "Polarise"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "pidj",
      "integration_name": "Pidj"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "muro",
      "integration_name": "muro"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "modusign",
      "integration_name": "Modusign"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "looker",
      "integration_name": "Looker"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "jane",
      "integration_name": "Jane"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "integration_type": "infobip",
      "integration_name": "Infobip"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "googleplayconsole",
      "integration_name": "Google Play Console"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "chatwoot",
      "integration_name": "Chatwoot"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "careem",
      "integration_name": "Careem"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "bandwidth",
      "integration_name": "Bandwidth"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "airfocus",
      "integration_name": "airfocus"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "aftership",
      "integration_name": "AfterShip"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "affirm",
      "integration_name": "Affirm"
   },
   {
      "type": "integration",
      "created_at": "2026-10-22T00:00:00.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "integration_type": "adaptlypost",
      "integration_name": "AdaptlyPost"
   },
   {
      "type": "readable_field",
      "integration_type": "shapes",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Shapes"
   },
   {
      "type": "readable_field",
      "integration_type": "shapes",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Shapes"
   },
   {
      "type": "readable_field",
      "integration_type": "shapes",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Shapes"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "shapes",
      "object_type": "hris_location",
      "integration_name": "Shapes"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "shapes",
      "object_type": "hris_job",
      "integration_name": "Shapes"
   },
   {
      "type": "method",
      "integration_type": "shapes",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shapes"
   },
   {
      "type": "method",
      "integration_type": "shapes",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shapes"
   },
   {
      "type": "writable_field",
      "integration_type": "sendfox",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SendFox"
   },
   {
      "type": "writable_field",
      "integration_type": "sendfox",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SendFox"
   },
   {
      "type": "readable_field",
      "integration_type": "sendfox",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "SendFox"
   },
   {
      "type": "readable_field",
      "integration_type": "sendfox",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "SendFox"
   },
   {
      "type": "readable_field",
      "integration_type": "sendfox",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "SendFox"
   },
   {
      "type": "pagination",
      "integration_type": "sendfox",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_query",
      "integration_name": "SendFox"
   },
   {
      "type": "pagination",
      "integration_type": "sendfox",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "SendFox"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "sendfox",
      "object_type": "martech_campaign",
      "integration_name": "SendFox"
   },
   {
      "type": "method",
      "integration_type": "sendfox",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SendFox"
   },
   {
      "type": "method",
      "integration_type": "sendfox",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SendFox"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedintalenthub",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "LinkedIn Talent Hub"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedintalenthub",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "LinkedIn Talent Hub"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedintalenthub",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "LinkedIn Talent Hub"
   },
   {
      "type": "method",
      "integration_type": "linkedintalenthub",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn Talent Hub"
   },
   {
      "type": "method",
      "integration_type": "linkedintalenthub",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "LinkedIn Talent Hub"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Humanforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "humanforce",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "integration_name": "Humanforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "humanforce",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Humanforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "humanforce",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "integration_name": "Humanforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "humanforce",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Humanforce"
   },
   {
      "type": "readable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "readable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Humanforce"
   },
   {
      "type": "readable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "readable_field",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_location_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_job_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_location_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_group_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Humanforce"
   },
   {
      "type": "pagination",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Humanforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humanforce",
      "object_type": "hris_group",
      "integration_name": "Humanforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humanforce",
      "object_type": "hris_location",
      "integration_name": "Humanforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humanforce",
      "object_type": "hris_company",
      "integration_name": "Humanforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humanforce",
      "object_type": "hris_job",
      "integration_name": "Humanforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humanforce",
      "object_type": "hris_attendance",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Humanforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T20:57:44.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "hexnode",
      "object_type": "hris_group",
      "integration_name": "Hexnode"
   },
   {
      "type": "method",
      "integration_type": "hexnode",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Hexnode"
   },
   {
      "type": "method",
      "integration_type": "hexnode",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Hexnode"
   },
   {
      "type": "method",
      "integration_type": "hexnode",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Hexnode"
   },
   {
      "type": "method",
      "integration_type": "hexnode",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Hexnode"
   },
   {
      "type": "method",
      "integration_type": "hexnode",
      "created_at": "2026-10-21T20:57:44.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Hexnode"
   },
   {
      "type": "readable_field",
      "integration_type": "ujet",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Ujet"
   },
   {
      "type": "readable_field",
      "integration_type": "ujet",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Ujet"
   },
   {
      "type": "readable_field",
      "integration_type": "ujet",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Ujet"
   },
   {
      "type": "pagination",
      "integration_type": "ujet",
      "created_at": "2026-10-21T18:47:54.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_query",
      "integration_name": "Ujet"
   },
   {
      "type": "pagination",
      "integration_type": "ujet",
      "created_at": "2026-10-21T18:47:54.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_contact_id",
      "integration_name": "Ujet"
   },
   {
      "type": "pagination",
      "integration_type": "ujet",
      "created_at": "2026-10-21T18:47:54.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Ujet"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "creative_type",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "cards",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "asset_urls",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "oreilly",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "collection_ids",
      "integration_name": "O'Reilly"
   },
   {
      "type": "pagination",
      "integration_type": "oreilly",
      "created_at": "2026-10-21T18:47:54.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_activity",
      "pagination": "list_content_id",
      "integration_name": "O'Reilly"
   },
   {
      "type": "pagination",
      "integration_type": "oreilly",
      "created_at": "2026-10-21T18:47:54.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "list_collection_id",
      "integration_name": "O'Reilly"
   },
   {
      "type": "pagination",
      "integration_type": "oreilly",
      "created_at": "2026-10-21T18:47:54.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "O'Reilly"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T18:47:54.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T18:47:54.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "bigcommerce",
      "object_type": "commerce_review",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-21T18:47:54.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukgpro_wfm",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukgpro_wfm",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_wfm",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_location_id",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_wfm",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_wfm",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_limit",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_wfm",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_wfm",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro_wfm",
      "object_type": "hris_attendance",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_wfm",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukgpro_ats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_location",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukgpro_ats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_location",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro_ats",
      "object_type": "hris_location",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro_ats",
      "object_type": "hris_group",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro_ats",
      "object_type": "hris_company",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "sympa",
      "object_type": "hris_group",
      "integration_name": "Sympa"
   },
   {
      "type": "method",
      "integration_type": "sympa",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sympa"
   },
   {
      "type": "method",
      "integration_type": "sympa",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sympa"
   },
   {
      "type": "method",
      "integration_type": "sympa",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sympa"
   },
   {
      "type": "method",
      "integration_type": "sympa",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sympa"
   },
   {
      "type": "method",
      "integration_type": "sympa",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sympa"
   },
   {
      "type": "pagination",
      "integration_type": "snowflake",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "object_type": "datastore_database",
      "pagination": "list_query",
      "integration_name": "Snowflake"
   },
   {
      "type": "pagination",
      "integration_type": "snowflake",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "object_type": "datastore_table",
      "pagination": "list_query",
      "integration_name": "Snowflake"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_company_id",
      "integration_name": "Salesflare"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Salesflare"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "Salesflare"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_pipeline_id",
      "integration_name": "Salesflare"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Salesflare"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_pipeline_id",
      "integration_name": "Salesflare"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "salesflare",
      "object_type": "crm_pipeline",
      "integration_name": "Salesflare"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "salesflare",
      "object_type": "passthrough",
      "integration_name": "Salesflare"
   },
   {
      "type": "method",
      "integration_type": "salesflare",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesflare"
   },
   {
      "type": "writable_field",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Recharge"
   },
   {
      "type": "writable_field",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "tax_exemption",
      "integration_name": "Recharge"
   },
   {
      "type": "writable_field",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Recharge"
   },
   {
      "type": "writable_field",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Recharge"
   },
   {
      "type": "writable_field",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Recharge"
   },
   {
      "type": "writable_field",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Recharge"
   },
   {
      "type": "writable_field",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_start_gte",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_end_lt",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_start_gte",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_end_lt",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_query",
      "integration_name": "Recharge"
   },
   {
      "type": "method",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recharge"
   },
   {
      "type": "method",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recharge"
   },
   {
      "type": "method",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recharge"
   },
   {
      "type": "method",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recharge"
   },
   {
      "type": "method",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recharge"
   },
   {
      "type": "method",
      "integration_type": "recharge",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recharge"
   },
   {
      "type": "writable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Plum"
   },
   {
      "type": "writable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Plum"
   },
   {
      "type": "writable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Plum"
   },
   {
      "type": "writable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_name",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_job_id",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Plum"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "plum",
      "object_type": "hris_employee",
      "integration_name": "Plum"
   },
   {
      "type": "method",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Plum"
   },
   {
      "type": "method",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Plum"
   },
   {
      "type": "method",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Plum"
   },
   {
      "type": "method",
      "integration_type": "plum",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Plum"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outdoo",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "uc_recording",
      "integration_name": "Outdoo AI"
   },
   {
      "type": "pagination",
      "integration_type": "outdoo",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outdoo AI"
   },
   {
      "type": "pagination",
      "integration_type": "outdoo",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Outdoo AI"
   },
   {
      "type": "pagination",
      "integration_type": "mastodon",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "object_type": "social_profile",
      "pagination": "list_query",
      "integration_name": "Mastodon"
   },
   {
      "type": "pagination",
      "integration_type": "mastodon",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "object_type": "social_profile",
      "pagination": "list_limit",
      "integration_name": "Mastodon"
   },
   {
      "type": "pagination",
      "integration_type": "mastodon",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "object_type": "social_profile",
      "pagination": "list_offset",
      "integration_name": "Mastodon"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "cards",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "cards",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_org_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_limit",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_offset",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "googlephotos",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Google Photos"
   },
   {
      "type": "pagination",
      "integration_type": "googlecloudplatform",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_device",
      "pagination": "slow_fields",
      "integration_name": "Google Cloud Platform"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "eploy",
      "object_type": "ats_interview",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "integration_type": "elasticsearch",
      "object_type": "hris_group",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "integration_type": "elasticsearch",
      "object_type": "datastore_table",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "integration_type": "elasticsearch",
      "object_type": "datastore_record",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "method",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "method",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "method",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "datastore_table",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "method",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "datastore_table",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "method",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "datastore_record",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "method",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "datastore_record",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "method",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "datastore_record",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "method",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "datastore_record",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "method",
      "integration_type": "elasticsearch",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "datastore_record",
      "categories": [
         "hris",
         "datastore",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "writable_field",
      "integration_type": "ableteams",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ableteams"
   },
   {
      "type": "writable_field",
      "integration_type": "ableteams",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ableteams"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ableteams",
      "object_type": "hris_group",
      "integration_name": "Ableteams"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T16:35:08.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ableteams",
      "object_type": "hris_location",
      "integration_name": "Ableteams"
   },
   {
      "type": "method",
      "integration_type": "ableteams",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ableteams"
   },
   {
      "type": "method",
      "integration_type": "ableteams",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ableteams"
   },
   {
      "type": "method",
      "integration_type": "ableteams",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Ableteams"
   },
   {
      "type": "method",
      "integration_type": "ableteams",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Ableteams"
   },
   {
      "type": "method",
      "integration_type": "ableteams",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Ableteams"
   },
   {
      "type": "method",
      "integration_type": "ableteams",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ableteams"
   },
   {
      "type": "method",
      "integration_type": "ableteams",
      "created_at": "2026-10-21T16:35:08.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Ableteams"
   },
   {
      "type": "readable_field",
      "integration_type": "zohomeeting",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_conference",
      "integration_name": "Zoho Meeting"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohomeeting",
      "object_type": "calendar_webinar",
      "integration_name": "Zoho Meeting"
   },
   {
      "type": "method",
      "integration_type": "zohomeeting",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Meeting"
   },
   {
      "type": "method",
      "integration_type": "zohomeeting",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Meeting"
   },
   {
      "type": "method",
      "integration_type": "zohomeeting",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Meeting"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "creator_user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_company_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_contact_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "zohobooks",
      "object_type": "accounting_profitloss",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "zohobooks",
      "object_type": "accounting_trialbalance",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "zohobooks",
      "object_type": "accounting_balancesheet",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "integration_type": "xero",
      "object_type": "accounting_cashflow",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_cashflow",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_cashflow",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "hris_job",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "shipped_at",
      "integration_name": "UPS"
   },
   {
      "type": "writable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "reference_number",
      "integration_name": "UPS"
   },
   {
      "type": "writable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "is_signature_required",
      "integration_name": "UPS"
   },
   {
      "type": "writable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "is_adult_signature_required",
      "integration_name": "UPS"
   },
   {
      "type": "readable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "shipped_at",
      "integration_name": "UPS"
   },
   {
      "type": "readable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "reference_number",
      "integration_name": "UPS"
   },
   {
      "type": "readable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "rate_currency",
      "integration_name": "UPS"
   },
   {
      "type": "readable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "rate_amount",
      "integration_name": "UPS"
   },
   {
      "type": "readable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "is_signature_required",
      "integration_name": "UPS"
   },
   {
      "type": "readable_field",
      "integration_type": "ups",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "is_adult_signature_required",
      "integration_name": "UPS"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "sage200",
      "object_type": "accounting_profitloss",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "sage200",
      "object_type": "accounting_trialbalance",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "sage200",
      "object_type": "accounting_balancesheet",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_query",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_start_gte",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_end_lt",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_location_id",
      "integration_name": "Ring Central"
   },
   {
      "type": "writable_field",
      "integration_type": "motion",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Motion"
   },
   {
      "type": "writable_field",
      "integration_type": "motion",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Motion"
   },
   {
      "type": "writable_field",
      "integration_type": "motion",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Motion"
   },
   {
      "type": "writable_field",
      "integration_type": "motion",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Motion"
   },
   {
      "type": "method",
      "integration_type": "motion",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Motion"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_company_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_contact_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_company_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_contact_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_contact_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_company_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "hris_group",
      "integration_name": "Jobvite"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "hris_location",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "Iris HR"
   },
   {
      "type": "writable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_bankaccount",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_group",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_job",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_bankaccount",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_group",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_job",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "irishr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Iris HR"
   },
   {
      "type": "readable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Iris HR"
   },
   {
      "type": "readable_field",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_updated_gte",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Iris HR"
   },
   {
      "type": "pagination",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Iris HR"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "irishr",
      "object_type": "hris_bankaccount",
      "integration_name": "Iris HR"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "irishr",
      "object_type": "hris_job",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Iris HR"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "icims",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "iCIMS"
   },
   {
      "type": "writable_field",
      "integration_type": "groq",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "max_tokens",
      "integration_name": "Groq"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "FourthHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "fourthhr",
      "object_type": "hris_bankaccount",
      "integration_name": "FourthHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "fourthhr",
      "object_type": "hris_payroll",
      "integration_name": "FourthHR"
   },
   {
      "type": "method",
      "integration_type": "fourthhr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FourthHR"
   },
   {
      "type": "method",
      "integration_type": "fourthhr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "cvviz",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "CVViZ"
   },
   {
      "type": "readable_field",
      "integration_type": "cvviz",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "CVViZ"
   },
   {
      "type": "readable_field",
      "integration_type": "cvviz",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "CVViZ"
   },
   {
      "type": "pagination",
      "integration_type": "cvviz",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_job_id",
      "integration_name": "CVViZ"
   },
   {
      "type": "pagination",
      "integration_type": "cvviz",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "CVViZ"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "cvviz",
      "object_type": "ats_company",
      "integration_name": "CVViZ"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "cvviz",
      "object_type": "crm_company",
      "integration_name": "CVViZ"
   },
   {
      "type": "method",
      "integration_type": "cvviz",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CVViZ"
   },
   {
      "type": "method",
      "integration_type": "cvviz",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CVViZ"
   },
   {
      "type": "readable_field",
      "integration_type": "crustdata",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Crustdata"
   },
   {
      "type": "readable_field",
      "integration_type": "crustdata",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "twitter_url",
      "integration_name": "Crustdata"
   },
   {
      "type": "readable_field",
      "integration_type": "crustdata",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "sic_code",
      "integration_name": "Crustdata"
   },
   {
      "type": "readable_field",
      "integration_type": "crustdata",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "naics_code",
      "integration_name": "Crustdata"
   },
   {
      "type": "readable_field",
      "integration_type": "crustdata",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "crunchbase_url",
      "integration_name": "Crustdata"
   },
   {
      "type": "readable_field",
      "integration_type": "crustdata",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Crustdata"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "profile_name",
      "integration_name": "Certn"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "profile_addresses",
      "integration_name": "Certn"
   },
   {
      "type": "pagination",
      "integration_type": "certn",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "object_type": "verification_request",
      "pagination": "list_query",
      "integration_name": "Certn"
   },
   {
      "type": "pagination",
      "integration_type": "certn",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "Certn"
   },
   {
      "type": "pagination",
      "integration_type": "canva",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_type",
      "integration_name": "Canva"
   },
   {
      "type": "pagination",
      "integration_type": "canva",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_type",
      "integration_name": "Canva"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cal",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "calendar_event",
      "integration_name": "Cal.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cal",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "calendar_event",
      "integration_name": "Cal.com"
   },
   {
      "type": "readable_field",
      "integration_type": "cal",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Cal.com"
   },
   {
      "type": "pagination",
      "integration_type": "cal",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_updated_gte",
      "integration_name": "Cal.com"
   },
   {
      "type": "pagination",
      "integration_type": "cal",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_start_gte",
      "integration_name": "Cal.com"
   },
   {
      "type": "pagination",
      "integration_type": "cal",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_end_lt",
      "integration_name": "Cal.com"
   },
   {
      "type": "pagination",
      "integration_type": "cal",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_calendar_id",
      "integration_name": "Cal.com"
   },
   {
      "type": "pagination",
      "integration_type": "cal",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Cal.com"
   },
   {
      "type": "pagination",
      "integration_type": "cal",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Cal.com"
   },
   {
      "type": "pagination",
      "integration_type": "cal",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Cal.com"
   },
   {
      "type": "pagination",
      "integration_type": "cal",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Cal.com"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bunny",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Bunny.com"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bunny",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_quote",
      "integration_name": "Bunny.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bunny",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Bunny.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bunny",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_quote",
      "integration_name": "Bunny.com"
   },
   {
      "type": "pagination",
      "integration_type": "bunny",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_updated_gte",
      "integration_name": "Bunny.com"
   },
   {
      "type": "pagination",
      "integration_type": "bunny",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Bunny.com"
   },
   {
      "type": "pagination",
      "integration_type": "bunny",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bunny.com"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "integration_type": "bunny",
      "object_type": "accounting_quote",
      "integration_name": "Bunny.com"
   },
   {
      "type": "method",
      "integration_type": "bunny",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bunny.com"
   },
   {
      "type": "method",
      "integration_type": "bunny",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bunny.com"
   },
   {
      "type": "writable_field",
      "integration_type": "breathehr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "BreatheHR"
   },
   {
      "type": "writable_field",
      "integration_type": "breathehr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "BreatheHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "breathehr",
      "object_type": "hris_group",
      "integration_name": "BreatheHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "breathehr",
      "object_type": "hris_document",
      "integration_name": "BreatheHR"
   },
   {
      "type": "method",
      "integration_type": "breathehr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreatheHR"
   },
   {
      "type": "method",
      "integration_type": "breathehr",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreatheHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "BitBucket"
   },
   {
      "type": "writable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "target_branch_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "writable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "source_branch_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "writable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "repo_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "writable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "repo_organization",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_branch_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_query",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_offset",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "airtable",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Airtable"
   },
   {
      "type": "object",
      "created_at": "2026-10-21T11:36:50.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "airtable",
      "object_type": "datastore_query",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-10-21T11:36:50.000Z",
      "object_type": "datastore_query",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Airtable"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "yooz",
      "integration_name": "Yooz"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "swetrix",
      "integration_name": "Swetrix"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "roomkeypms",
      "integration_name": "RoomKey PMS"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "polinode",
      "integration_name": "Polinode"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "pointclickcare",
      "integration_name": "PointClickCare"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "plusvibe",
      "integration_name": "PlusVibe"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "piwikpro",
      "integration_name": "Piwik PRO"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "permutive",
      "integration_name": "Permutive"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "commerce",
         "crm",
         "passthrough"
      ],
      "integration_type": "mycashflow",
      "integration_name": "MyCashflow"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "mouseflow",
      "integration_name": "Mouseflow"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "calendar",
         "task",
         "passthrough"
      ],
      "integration_type": "morgen",
      "integration_name": "Morgen"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "mobilia",
      "integration_name": "Mobilia"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "maxmessenger",
      "integration_name": "Max Messenger"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "heap",
      "integration_name": "Heap"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "gradientai",
      "integration_name": "Gradient AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "googletexttospeech",
      "integration_name": "Google Cloud Text-to-Speech"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "googlemanufacturercenter",
      "integration_name": "Google Manufacturer Center"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "googlecontactcenterinsights",
      "integration_name": "Google Contact Center AI Insights"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "googlecloudtpu",
      "integration_name": "Google Cloud TPU"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "googlecloudhealthcare",
      "integration_name": "Google Cloud Healthcare API"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "addevent",
      "integration_name": "AddEvent"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "actionnetwork",
      "integration_name": "Action Network"
   },
   {
      "type": "integration",
      "created_at": "2026-10-21T00:00:00.000Z",
      "categories": [
         "messaging",
         "uc",
         "passthrough"
      ],
      "integration_type": "46elks",
      "integration_name": "46elks"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recruitee",
      "object_type": "ats_scorecard",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruitee"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "phenom",
      "object_type": "ats_company",
      "integration_name": "Phenom"
   },
   {
      "type": "method",
      "integration_type": "phenom",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Phenom"
   },
   {
      "type": "method",
      "integration_type": "phenom",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Phenom"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_start_gte",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_end_lt",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_contact_id",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_contact_id",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_start_gte",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_end_lt",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_account_id",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "paycom",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Paycom"
   },
   {
      "type": "readable_field",
      "integration_type": "paycom",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Paycom"
   },
   {
      "type": "readable_field",
      "integration_type": "paycom",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Paycom"
   },
   {
      "type": "readable_field",
      "integration_type": "paycom",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Paycom"
   },
   {
      "type": "readable_field",
      "integration_type": "paycom",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Paycom"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "cards",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "cards",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "mercuryats",
      "object_type": "ats_applicationstatus",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T22:12:29.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "atlassianconfluence",
      "object_type": "task_task",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "method",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "task_task",
      "categories": [
         "kms",
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "method",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "task_task",
      "categories": [
         "kms",
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "method",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-10-20T22:12:29.000Z",
      "object_type": "task_task",
      "categories": [
         "kms",
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "yotpo",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_order",
      "integration_name": "yotpo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "yotpo",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "yotpo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "yotpo",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_order",
      "integration_name": "yotpo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "yotpo",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_offset",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_collection_id",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_offset",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_offset",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_offset",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_limit",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_offset",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "yotpo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "calendar_event",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wix",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "calendar_event",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Wix"
   },
   {
      "type": "pagination",
      "integration_type": "wix",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_category",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_category",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "list_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "hris_job",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_category",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "TeamLeader"
   },
   {
      "type": "readable_field",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "TeamLeader"
   },
   {
      "type": "pagination",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "TeamLeader"
   },
   {
      "type": "pagination",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_contact_id",
      "integration_name": "TeamLeader"
   },
   {
      "type": "pagination",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "TeamLeader"
   },
   {
      "type": "pagination",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "TeamLeader"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "teamleader",
      "object_type": "hris_group",
      "integration_name": "TeamLeader"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "teamleader",
      "object_type": "task_task",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TeamLeader"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shippo",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "shipping_label",
      "integration_name": "Shippo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shippo",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "shipping_label",
      "integration_name": "Shippo"
   },
   {
      "type": "readable_field",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "shipping_carrier",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Shippo"
   },
   {
      "type": "readable_field",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "shipping_label",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "rate_id",
      "integration_name": "Shippo"
   },
   {
      "type": "readable_field",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "shipping_label",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "is_voided",
      "integration_name": "Shippo"
   },
   {
      "type": "readable_field",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "shipping_carrier",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Shippo"
   },
   {
      "type": "readable_field",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "shipping_carrier",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "code",
      "integration_name": "Shippo"
   },
   {
      "type": "readable_field",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "actual_delivery_at",
      "integration_name": "Shippo"
   },
   {
      "type": "pagination",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "shipping_label",
      "pagination": "list_updated_gte",
      "integration_name": "Shippo"
   },
   {
      "type": "pagination",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "shipping_label",
      "pagination": "list_offset",
      "integration_name": "Shippo"
   },
   {
      "type": "pagination",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "shipping_label",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shippo"
   },
   {
      "type": "pagination",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "shipping_label",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Shippo"
   },
   {
      "type": "pagination",
      "integration_type": "shippo",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_offset",
      "integration_name": "Shippo"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "accounting_profitloss",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "accounting_trialbalance",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "accounting_balancesheet",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "sageaccounting",
      "object_type": "accounting_profitloss",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "sageaccounting",
      "object_type": "accounting_balancesheet",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Phenom"
   },
   {
      "type": "writable_field",
      "integration_type": "paypal",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Paypal"
   },
   {
      "type": "writable_field",
      "integration_type": "paypal",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Paypal"
   },
   {
      "type": "writable_field",
      "integration_type": "paypal",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "Paypal"
   },
   {
      "type": "writable_field",
      "integration_type": "paypal",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Paypal"
   },
   {
      "type": "writable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Namely"
   },
   {
      "type": "readable_field",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Namely"
   },
   {
      "type": "method",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Namely"
   },
   {
      "type": "method",
      "integration_type": "namely",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "enconding_format",
      "integration_name": "MistralAI"
   },
   {
      "type": "writable_field",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "dimension",
      "integration_name": "MistralAI"
   },
   {
      "type": "readable_field",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "MistralAI"
   },
   {
      "type": "readable_field",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "model_id",
      "integration_name": "MistralAI"
   },
   {
      "type": "readable_field",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "model_id",
      "integration_name": "MistralAI"
   },
   {
      "type": "readable_field",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "has_vision",
      "integration_name": "MistralAI"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "mistralai",
      "object_type": "genai_agent",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MistralAI"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_contact",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_deal",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_lead",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_company",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_event",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_account",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_contact",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_deal",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_lead",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_company",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "crm_event",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_account",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "metabase",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "Metabase"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "integration_type": "metabase",
      "object_type": "hris_group",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Metabase"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "readable_field",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "method",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "method",
      "integration_type": "jungle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "readable_field",
      "integration_type": "jamf",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Jamf"
   },
   {
      "type": "readable_field",
      "integration_type": "jamf",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "has_hd_encrypted",
      "integration_name": "Jamf"
   },
   {
      "type": "readable_field",
      "integration_type": "jamf",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Jamf"
   },
   {
      "type": "pagination",
      "integration_type": "jamf",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_device",
      "pagination": "list_updated_gte",
      "integration_name": "Jamf"
   },
   {
      "type": "pagination",
      "integration_type": "jamf",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_device",
      "pagination": "list_user_id",
      "integration_name": "Jamf"
   },
   {
      "type": "pagination",
      "integration_type": "jamf",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_device",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Jamf"
   },
   {
      "type": "pagination",
      "integration_type": "jamf",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_device",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Jamf"
   },
   {
      "type": "pagination",
      "integration_type": "jamf",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "Jamf"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "guru",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Guru"
   },
   {
      "type": "pagination",
      "integration_type": "guru",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_query",
      "integration_name": "Guru"
   },
   {
      "type": "pagination",
      "integration_type": "guru",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_order",
      "integration_name": "Guru"
   },
   {
      "type": "pagination",
      "integration_type": "guru",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_name",
      "integration_name": "Guru"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "guru",
      "object_type": "kms_comment",
      "integration_name": "Guru"
   },
   {
      "type": "method",
      "integration_type": "guru",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Guru"
   },
   {
      "type": "writable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Fountain"
   },
   {
      "type": "writable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Fountain"
   },
   {
      "type": "writable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Fountain"
   },
   {
      "type": "writable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Fountain"
   },
   {
      "type": "writable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_application",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_application",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_job_id",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_limit",
      "integration_name": "Fountain"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "fountain",
      "object_type": "hris_group",
      "integration_name": "Fountain"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "fountain",
      "object_type": "hris_location",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fellow",
      "categories": [
         "calendar",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "integration_name": "Fellow"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "fellow",
      "categories": [
         "calendar",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "integration_name": "Fellow"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fellow",
      "categories": [
         "calendar",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "integration_name": "Fellow"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "fellow",
      "categories": [
         "calendar",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "integration_name": "Fellow"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "calendar",
         "task",
         "passthrough"
      ],
      "integration_type": "fellow",
      "object_type": "task_task",
      "integration_name": "Fellow"
   },
   {
      "type": "method",
      "integration_type": "fellow",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "categories": [
         "calendar",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fellow"
   },
   {
      "type": "method",
      "integration_type": "fellow",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "categories": [
         "calendar",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fellow"
   },
   {
      "type": "method",
      "integration_type": "fellow",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "task_task",
      "categories": [
         "calendar",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Fellow"
   },
   {
      "type": "readable_field",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Expensify"
   },
   {
      "type": "readable_field",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Expensify"
   },
   {
      "type": "readable_field",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Expensify"
   },
   {
      "type": "readable_field",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "reimbursed_at",
      "integration_name": "Expensify"
   },
   {
      "type": "readable_field",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Expensify"
   },
   {
      "type": "readable_field",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Expensify"
   },
   {
      "type": "readable_field",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "approver_user_id",
      "integration_name": "Expensify"
   },
   {
      "type": "readable_field",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "approved_at",
      "integration_name": "Expensify"
   },
   {
      "type": "pagination",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_user_id",
      "integration_name": "Expensify"
   },
   {
      "type": "pagination",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_org_id",
      "integration_name": "Expensify"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "expensify",
      "object_type": "accounting_category",
      "integration_name": "Expensify"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "expensify",
      "object_type": "hris_employee",
      "integration_name": "Expensify"
   },
   {
      "type": "method",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Expensify"
   },
   {
      "type": "method",
      "integration_type": "expensify",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Expensify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cultureamp",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "performance_cycle",
      "integration_name": "Culture Amp"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cultureamp",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "performance_review",
      "integration_name": "Culture Amp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cultureamp",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "performance_cycle",
      "integration_name": "Culture Amp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cultureamp",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "performance_review",
      "integration_name": "Culture Amp"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "integration_type": "cultureamp",
      "object_type": "performance_cycle",
      "integration_name": "Culture Amp"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "integration_type": "cultureamp",
      "object_type": "performance_review",
      "integration_name": "Culture Amp"
   },
   {
      "type": "method",
      "integration_type": "cultureamp",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "performance_cycle",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Culture Amp"
   },
   {
      "type": "method",
      "integration_type": "cultureamp",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "performance_cycle",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Culture Amp"
   },
   {
      "type": "method",
      "integration_type": "cultureamp",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "performance_review",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Culture Amp"
   },
   {
      "type": "method",
      "integration_type": "cultureamp",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "performance_review",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Culture Amp"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "messaging",
         "hris",
         "forms",
         "passthrough"
      ],
      "integration_type": "circle",
      "object_type": "forms_form",
      "integration_name": "Circle.so"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "messaging",
         "hris",
         "forms",
         "passthrough"
      ],
      "integration_type": "circle",
      "object_type": "forms_submission",
      "integration_name": "Circle.so"
   },
   {
      "type": "method",
      "integration_type": "circle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "forms_form",
      "categories": [
         "messaging",
         "hris",
         "forms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Circle.so"
   },
   {
      "type": "method",
      "integration_type": "circle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "forms_form",
      "categories": [
         "messaging",
         "hris",
         "forms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Circle.so"
   },
   {
      "type": "method",
      "integration_type": "circle",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "forms_submission",
      "categories": [
         "messaging",
         "hris",
         "forms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Circle.so"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "telephone",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "callswitchone",
      "object_type": "hris_group",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "method",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "method",
      "integration_type": "callswitchone",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "alibaba",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "weight_unit",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "readable_field",
      "integration_type": "alibaba",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "weight",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "readable_field",
      "integration_type": "alibaba",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "readable_field",
      "integration_type": "alibaba",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "fees",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "readable_field",
      "integration_type": "alibaba",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "pagination",
      "integration_type": "alibaba",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_query",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "pagination",
      "integration_type": "alibaba",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_collection_id",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "pagination",
      "integration_type": "alibaba",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T18:31:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "alibaba",
      "object_type": "commerce_collection",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "method",
      "integration_type": "alibaba",
      "created_at": "2026-10-20T18:31:05.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocalendar",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Zoho Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocalendar",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "send_notifications",
      "integration_name": "Zoho Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocalendar",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Zoho Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocalendar",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Zoho Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocalendar",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Zoho Calendar"
   },
   {
      "type": "method",
      "integration_type": "zohocalendar",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Calendar"
   },
   {
      "type": "method",
      "integration_type": "zohocalendar",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Workstream"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_job_id",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_status",
      "integration_name": "Workstream"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "integration_type": "myob",
      "object_type": "accounting_taxrate",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "linkedinlearning",
      "object_type": "lms_activity",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "linkedinlearning",
      "object_type": "lms_student",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "method",
      "integration_type": "linkedinlearning",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "method",
      "integration_type": "linkedinlearning",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "space_id",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_space",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_space",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_space",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "customer_id",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "customer_id",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "category_id",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "messaging_message",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "messaging_message",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_page",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_employee",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_company",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "messaging_message",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_page",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_employee",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_company",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "messaging_message",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "messaging_message",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_page",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_employee",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_company",
      "integration_name": "Intercom"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "intercom",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_group",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "is_unread",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_updated_gte",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_start_gte",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_end_lt",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "list_query",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_query",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_category_id",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_category_id",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "cdp_segment",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "crm_company",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "crm_contact",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "ticketing_category",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_space",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "kms_space",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "cdp_segment",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "cdp_segment",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "crm",
         "metadata",
         "cdp",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "pagination",
      "integration_type": "fullcontact",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_twitter",
      "integration_name": "FullContact"
   },
   {
      "type": "pagination",
      "integration_type": "fullcontact",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "FullContact"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "fullcontact",
      "object_type": "passthrough",
      "integration_name": "FullContact"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Discord"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dialpad",
      "object_type": "uc_scorecard",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_limit",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_offset",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "Deputy"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "darwinbox",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_job",
      "integration_name": "Darwinbox"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "darwinbox",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_job",
      "integration_name": "Darwinbox"
   },
   {
      "type": "readable_field",
      "integration_type": "darwinbox",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Darwinbox"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "integration_type": "darwinbox",
      "object_type": "hris_job",
      "integration_name": "Darwinbox"
   },
   {
      "type": "method",
      "integration_type": "darwinbox",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Darwinbox"
   },
   {
      "type": "writable_field",
      "integration_type": "calendarhero",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "CalendarHero"
   },
   {
      "type": "writable_field",
      "integration_type": "calendarhero",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "CalendarHero"
   },
   {
      "type": "writable_field",
      "integration_type": "calendarhero",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "CalendarHero"
   },
   {
      "type": "writable_field",
      "integration_type": "calendarhero",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "CalendarHero"
   },
   {
      "type": "writable_field",
      "integration_type": "calendarhero",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "CalendarHero"
   },
   {
      "type": "writable_field",
      "integration_type": "calendarhero",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "CalendarHero"
   },
   {
      "type": "writable_field",
      "integration_type": "calendarhero",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "CalendarHero"
   },
   {
      "type": "method",
      "integration_type": "calendarhero",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "CalendarHero"
   },
   {
      "type": "method",
      "integration_type": "calendarhero",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "CalendarHero"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "size",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_limit",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_offset",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2026-10-20T16:38:47.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2026-10-20T16:38:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "uplead",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "twitter_url",
      "integration_name": "UpLead"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "uplead",
      "object_type": "passthrough",
      "integration_name": "UpLead"
   },
   {
      "type": "writable_field",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Typeform"
   },
   {
      "type": "writable_field",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Typeform"
   },
   {
      "type": "writable_field",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "field": "has_progress_bar",
      "integration_name": "Typeform"
   },
   {
      "type": "writable_field",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Typeform"
   },
   {
      "type": "writable_field",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "field": "confirmation_redirect_url",
      "integration_name": "Typeform"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "typeform",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_submission",
      "integration_name": "Typeform"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "typeform",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_submission",
      "integration_name": "Typeform"
   },
   {
      "type": "readable_field",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "field": "has_progress_bar",
      "integration_name": "Typeform"
   },
   {
      "type": "readable_field",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "field": "confirmation_redirect_url",
      "integration_name": "Typeform"
   },
   {
      "type": "readable_field",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "field": "confirmation_message",
      "integration_name": "Typeform"
   },
   {
      "type": "pagination",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "object_type": "forms_form",
      "pagination": "list_query",
      "integration_name": "Typeform"
   },
   {
      "type": "pagination",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "object_type": "forms_submission",
      "pagination": "list_offset",
      "integration_name": "Typeform"
   },
   {
      "type": "pagination",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "object_type": "forms_submission",
      "pagination": "virtual_webhook_form_id",
      "integration_name": "Typeform"
   },
   {
      "type": "pagination",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "object_type": "forms_submission",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Typeform"
   },
   {
      "type": "pagination",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "object_type": "forms_submission",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Typeform"
   },
   {
      "type": "method",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Typeform"
   },
   {
      "type": "method",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Typeform"
   },
   {
      "type": "method",
      "integration_type": "typeform",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Typeform"
   },
   {
      "type": "readable_field",
      "integration_type": "telegram",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Telegram"
   },
   {
      "type": "readable_field",
      "integration_type": "telegram",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "mentioned_members",
      "integration_name": "Telegram"
   },
   {
      "type": "readable_field",
      "integration_type": "telegram",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Telegram"
   },
   {
      "type": "readable_field",
      "integration_type": "telegram",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Telegram"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "item_variant_id",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "identification",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "available",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Squarespace"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "rillet",
      "object_type": "accounting_profitloss",
      "integration_name": "Rillet"
   },
   {
      "type": "method",
      "integration_type": "rillet",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rillet"
   },
   {
      "type": "method",
      "integration_type": "rillet",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rillet"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recruitee",
      "object_type": "ats_company",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruitee"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "quickfile",
      "object_type": "accounting_profitloss",
      "integration_name": "QuickFile"
   },
   {
      "type": "method",
      "integration_type": "quickfile",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickFile"
   },
   {
      "type": "method",
      "integration_type": "quickfile",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickFile"
   },
   {
      "type": "writable_field",
      "integration_type": "notion",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "page_id",
      "integration_name": "Notion"
   },
   {
      "type": "writable_field",
      "integration_type": "notion",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "content",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "notion",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "datastore_record",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "notion",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "datastore_record",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "datastore_record",
      "pagination": "list_updated_gte",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "datastore_record",
      "pagination": "virtual_webhook_table_id",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "datastore_record",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "datastore_record",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Notion"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "integration_type": "myob",
      "object_type": "accounting_profitloss",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "moneybird",
      "object_type": "accounting_profitloss",
      "integration_name": "Moneybird"
   },
   {
      "type": "method",
      "integration_type": "moneybird",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Moneybird"
   },
   {
      "type": "method",
      "integration_type": "moneybird",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Moneybird"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "object_type": "accounting_profitloss",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "lucca",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Lucca"
   },
   {
      "type": "readable_field",
      "integration_type": "lucca",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Lucca"
   },
   {
      "type": "readable_field",
      "integration_type": "lucca",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Lucca"
   },
   {
      "type": "readable_field",
      "integration_type": "lucca",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Lucca"
   },
   {
      "type": "method",
      "integration_type": "lucca",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lucca"
   },
   {
      "type": "method",
      "integration_type": "lucca",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lucca"
   },
   {
      "type": "readable_field",
      "integration_type": "indeed",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "Indeed"
   },
   {
      "type": "readable_field",
      "integration_type": "indeed",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Indeed"
   },
   {
      "type": "readable_field",
      "integration_type": "indeed",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Indeed"
   },
   {
      "type": "readable_field",
      "integration_type": "indeed",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Indeed"
   },
   {
      "type": "readable_field",
      "integration_type": "indeed",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Indeed"
   },
   {
      "type": "readable_field",
      "integration_type": "indeed",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Indeed"
   },
   {
      "type": "readable_field",
      "integration_type": "indeed",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Indeed"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "exactonline",
      "object_type": "accounting_profitloss",
      "integration_name": "Exact Online"
   },
   {
      "type": "method",
      "integration_type": "exactonline",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Exact Online"
   },
   {
      "type": "method",
      "integration_type": "exactonline",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Exact Online"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "cherry",
      "object_type": "accounting_profitloss",
      "integration_name": "Cherry"
   },
   {
      "type": "method",
      "integration_type": "cherry",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cherry"
   },
   {
      "type": "method",
      "integration_type": "cherry",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cherry"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "campfire",
      "object_type": "accounting_profitloss",
      "integration_name": "Campfire"
   },
   {
      "type": "method",
      "integration_type": "campfire",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Campfire"
   },
   {
      "type": "method",
      "integration_type": "campfire",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Campfire"
   },
   {
      "type": "readable_field",
      "integration_type": "bitwarden",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Bitwarden"
   },
   {
      "type": "readable_field",
      "integration_type": "bitwarden",
      "created_at": "2026-10-20T15:37:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Bitwarden"
   },
   {
      "type": "pagination",
      "integration_type": "bitwarden",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Bitwarden"
   },
   {
      "type": "pagination",
      "integration_type": "bitwarden",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Bitwarden"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_query",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_end_lt",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-10-20T15:37:41.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_order",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T12:42:51.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-20T09:33:08.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "dhl",
      "created_at": "2026-10-20T09:33:08.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "special_instructions",
      "integration_name": "DHL"
   },
   {
      "type": "writable_field",
      "integration_type": "dhl",
      "created_at": "2026-10-20T09:33:08.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "reference_number",
      "integration_name": "DHL"
   },
   {
      "type": "writable_field",
      "integration_type": "dhl",
      "created_at": "2026-10-20T09:33:08.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "insurance",
      "integration_name": "DHL"
   },
   {
      "type": "writable_field",
      "integration_type": "dhl",
      "created_at": "2026-10-20T09:33:08.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "customs",
      "integration_name": "DHL"
   },
   {
      "type": "readable_field",
      "integration_type": "dhl",
      "created_at": "2026-10-20T09:33:08.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "field": "tracking_url",
      "integration_name": "DHL"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "teachable",
      "integration_name": "Teachable"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "printavo",
      "integration_name": "Printavo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "piriod",
      "integration_name": "Piriod"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "task",
         "passthrough"
      ],
      "integration_type": "pipefy",
      "integration_name": "Pipefy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "phaxio",
      "integration_name": "Phaxio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "myfatoorah",
      "integration_name": "MyFatoorah"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "monei",
      "integration_name": "MONEI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "integration_type": "mixpost",
      "integration_name": "Mixpost"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "mixedbread",
      "integration_name": "Mixedbread"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "integration_type": "milkee",
      "integration_name": "MILKEE"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "gupshup",
      "integration_name": "Gupshup"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "groupsio",
      "integration_name": "Groups.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "auth",
         "ads",
         "crm",
         "passthrough"
      ],
      "integration_type": "googlelocalservices",
      "integration_name": "Google Local Services Ads"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "googlekubernetesengine",
      "integration_name": "Google Kubernetes Engine"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "googlecloudrun",
      "integration_name": "Google Cloud Run"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "googleauthorizedbuyers",
      "integration_name": "Google Authorized Buyers"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "task",
         "passthrough"
      ],
      "integration_type": "gmelius",
      "integration_name": "Gmelius"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "drips",
      "integration_name": "Drips"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "boletocloud",
      "integration_name": "Boleto Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-10-20T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "awork",
      "integration_name": "awork"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zendesk"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zendesk"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "zendesk",
      "object_type": "metadata_metadata",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zendesk"
   },
   {
      "type": "writable_field",
      "integration_type": "zambion",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "readable_field",
      "integration_type": "zambion",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "writable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "WooCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "WooCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "writable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "writable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "writable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "writable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "writable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "readable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "readable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "readable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "readable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "readable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "readable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "pagination",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "pagination",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "pagination",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "pagination",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "slow_fields",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "pagination",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "taleo",
      "object_type": "metadata_metadata",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "writable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "smartrecruiters",
      "object_type": "metadata_metadata",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "method",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "method",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "method",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "method",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "sendgrid",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SendGrid"
   },
   {
      "type": "readable_field",
      "integration_type": "sendgrid",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "martech",
         "metadata",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "slow_fields",
      "integration_name": "SendGrid"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "martech",
         "metadata",
         "passthrough"
      ],
      "integration_type": "sendgrid",
      "object_type": "metadata_metadata",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SendGrid"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "slow_fields",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "slow_fields",
      "integration_name": "Salesloft"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "salesloft",
      "object_type": "metadata_metadata",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "slow_fields",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "metadata_metadata",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "remote",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Remote.com"
   },
   {
      "type": "pagination",
      "integration_type": "remote",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Remote.com"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "remote",
      "object_type": "metadata_metadata",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Remote.com"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "slow_fields",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "slow_fields",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "metadata_metadata",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "pylon",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pylon"
   },
   {
      "type": "writable_field",
      "integration_type": "pylon",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pylon"
   },
   {
      "type": "readable_field",
      "integration_type": "pylon",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pylon"
   },
   {
      "type": "readable_field",
      "integration_type": "pylon",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pylon"
   },
   {
      "type": "pagination",
      "integration_type": "pylon",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "slow_fields",
      "integration_name": "Pylon"
   },
   {
      "type": "pagination",
      "integration_type": "pylon",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "slow_fields",
      "integration_name": "Pylon"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "pylon",
      "object_type": "metadata_metadata",
      "integration_name": "Pylon"
   },
   {
      "type": "method",
      "integration_type": "pylon",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pylon"
   },
   {
      "type": "method",
      "integration_type": "pylon",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pylon"
   },
   {
      "type": "method",
      "integration_type": "pylon",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pylon"
   },
   {
      "type": "writable_field",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "writable_field",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "writable_field",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "writable_field",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "slow_fields",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "slow_fields",
      "integration_name": "Outreach.io"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "integration_type": "outreach",
      "object_type": "metadata_metadata",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Outreach.io"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "metadata_metadata",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "namely",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Namely"
   },
   {
      "type": "pagination",
      "integration_type": "namely",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Namely"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "namely",
      "object_type": "metadata_metadata",
      "integration_name": "Namely"
   },
   {
      "type": "method",
      "integration_type": "namely",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Namely"
   },
   {
      "type": "method",
      "integration_type": "namely",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Namely"
   },
   {
      "type": "method",
      "integration_type": "namely",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Namely"
   },
   {
      "type": "method",
      "integration_type": "namely",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Namely"
   },
   {
      "type": "writable_field",
      "integration_type": "lightfield",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lightfield"
   },
   {
      "type": "writable_field",
      "integration_type": "lightfield",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lightfield"
   },
   {
      "type": "writable_field",
      "integration_type": "lightfield",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lightfield"
   },
   {
      "type": "readable_field",
      "integration_type": "lightfield",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lightfield"
   },
   {
      "type": "readable_field",
      "integration_type": "lightfield",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lightfield"
   },
   {
      "type": "readable_field",
      "integration_type": "lightfield",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lightfield"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "lightfield",
      "object_type": "metadata_metadata",
      "integration_name": "Lightfield"
   },
   {
      "type": "method",
      "integration_type": "lightfield",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightfield"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lever"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "lever",
      "object_type": "metadata_metadata",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lattice"
   },
   {
      "type": "pagination",
      "integration_type": "lattice",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Lattice"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "integration_type": "lattice",
      "object_type": "metadata_metadata",
      "integration_name": "Lattice"
   },
   {
      "type": "method",
      "integration_type": "lattice",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lattice"
   },
   {
      "type": "writable_field",
      "integration_type": "karbonhq",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "readable_field",
      "integration_type": "karbonhq",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "pagination",
      "integration_type": "karbonhq",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "slow_fields",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "karbonhq",
      "object_type": "metadata_metadata",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "method",
      "integration_type": "karbonhq",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "method",
      "integration_type": "karbonhq",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "method",
      "integration_type": "karbonhq",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "slow_fields",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "metadata_metadata",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Insightly"
   },
   {
      "type": "writable_field",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Insightly"
   },
   {
      "type": "writable_field",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Insightly"
   },
   {
      "type": "writable_field",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "slow_fields",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "Insightly"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "insightly",
      "object_type": "metadata_metadata",
      "integration_name": "Insightly"
   },
   {
      "type": "method",
      "integration_type": "insightly",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Insightly"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "slow_fields",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "HighLevel"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "highlevel",
      "object_type": "metadata_metadata",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "heavenhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HeavenHR"
   },
   {
      "type": "pagination",
      "integration_type": "heavenhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "HeavenHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "heavenhr",
      "object_type": "metadata_metadata",
      "integration_name": "HeavenHR"
   },
   {
      "type": "method",
      "integration_type": "heavenhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HeavenHR"
   },
   {
      "type": "readable_field",
      "integration_type": "haileyhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HaileyHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "haileyhr",
      "object_type": "metadata_metadata",
      "integration_name": "HaileyHR"
   },
   {
      "type": "method",
      "integration_type": "haileyhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HaileyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "googledirectory",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "saml",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "saml",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "auth",
         "saml",
         "metadata",
         "passthrough"
      ],
      "integration_type": "googledirectory",
      "object_type": "metadata_metadata",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "auth",
         "saml",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "auth",
         "saml",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "auth",
         "saml",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "auth",
         "saml",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "slow_fields",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "slow_fields",
      "integration_name": "Gong"
   },
   {
      "type": "writable_field",
      "integration_type": "goco",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "readable_field",
      "integration_type": "goco",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "pagination",
      "integration_type": "goco",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "goco",
      "object_type": "metadata_metadata",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "method",
      "integration_type": "goco",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gem"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "integration_type": "gem",
      "object_type": "metadata_metadata",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "freshdesk"
   },
   {
      "type": "pagination",
      "integration_type": "freshdesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "slow_fields",
      "integration_name": "freshdesk"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "freshdesk",
      "object_type": "metadata_metadata",
      "integration_name": "freshdesk"
   },
   {
      "type": "method",
      "integration_type": "freshdesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "freshdesk"
   },
   {
      "type": "method",
      "integration_type": "freshdesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "freshdesk"
   },
   {
      "type": "method",
      "integration_type": "freshdesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "freshdesk"
   },
   {
      "type": "method",
      "integration_type": "freshdesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Firefish"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "firefish",
      "object_type": "metadata_metadata",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "factorialhr",
      "object_type": "metadata_metadata",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ELMO"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "elmo",
      "object_type": "metadata_metadata",
      "integration_name": "ELMO"
   },
   {
      "type": "method",
      "integration_type": "elmo",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ELMO"
   },
   {
      "type": "writable_field",
      "integration_type": "dropbox",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Dropbox"
   },
   {
      "type": "writable_field",
      "integration_type": "dropbox",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Dropbox"
   },
   {
      "type": "writable_field",
      "integration_type": "dropbox",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Dropbox"
   },
   {
      "type": "writable_field",
      "integration_type": "dropbox",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Dropbox"
   },
   {
      "type": "writable_field",
      "integration_type": "dropbox",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "data",
      "integration_name": "Dropbox"
   },
   {
      "type": "readable_field",
      "integration_type": "dropbox",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Dropbox"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dropbox",
      "object_type": "metadata_metadata",
      "integration_name": "Dropbox"
   },
   {
      "type": "method",
      "integration_type": "dropbox",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Dropbox"
   },
   {
      "type": "method",
      "integration_type": "dropbox",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Dropbox"
   },
   {
      "type": "method",
      "integration_type": "dropbox",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "storage",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Dropbox"
   },
   {
      "type": "writable_field",
      "integration_type": "docusign",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DocuSign"
   },
   {
      "type": "readable_field",
      "integration_type": "docusign",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DocuSign"
   },
   {
      "type": "readable_field",
      "integration_type": "docusign",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "signing_template",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "slow_fields",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "docusign",
      "object_type": "metadata_metadata",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DocuSign"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Deel"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "deel",
      "object_type": "metadata_metadata",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Deel"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Crelate"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "crelate",
      "object_type": "metadata_metadata",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "constantcontact",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ConstantContact"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "ConstantContact"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "ConstantContact"
   },
   {
      "type": "readable_field",
      "integration_type": "constantcontact",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ConstantContact"
   },
   {
      "type": "pagination",
      "integration_type": "constantcontact",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "slow_fields",
      "integration_name": "ConstantContact"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "constantcontact",
      "object_type": "metadata_metadata",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ConstantContact"
   },
   {
      "type": "writable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "Close"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "closeio",
      "object_type": "metadata_metadata",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ClickUp"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "clickup",
      "object_type": "metadata_metadata",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "slow_fields",
      "integration_name": "CATS"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "cats",
      "object_type": "metadata_metadata",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "BigCommerce"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "bigcommerce",
      "object_type": "metadata_metadata",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "performance",
         "metadata",
         "passthrough",
         "auth"
      ],
      "field": "metadata",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "performance",
         "metadata",
         "passthrough",
         "auth"
      ],
      "field": "metadata",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "metadata",
         "passthrough",
         "auth"
      ],
      "integration_type": "bamboohr",
      "object_type": "metadata_metadata",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "performance",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "performance",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "performance",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "create",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "performance",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "update",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "performance",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "remove",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "atlassianservicedesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianservicedesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "ticketing",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "atlassianservicedesk",
      "object_type": "metadata_metadata",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "method",
      "integration_type": "atlassianservicedesk",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "15Five"
   },
   {
      "type": "readable_field",
      "integration_type": "15five",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "15Five"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T21:30:30.000Z",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "integration_type": "15five",
      "object_type": "metadata_metadata",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-10-19T21:30:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoom"
   },
   {
      "type": "writable_field",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "slow_fields",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "object_type": "calendar_webinar",
      "pagination": "slow_fields",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "integration_type": "zoom",
      "object_type": "metadata_metadata",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoom"
   },
   {
      "type": "writable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "writable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "pagination",
      "integration_type": "zendesksell",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "pagination",
      "integration_type": "zendesksell",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "zendesksell",
      "object_type": "metadata_metadata",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "method",
      "integration_type": "zendesksell",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zellis",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zellis"
   },
   {
      "type": "readable_field",
      "integration_type": "zellis",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zellis"
   },
   {
      "type": "pagination",
      "integration_type": "zellis",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Zellis"
   },
   {
      "type": "pagination",
      "integration_type": "zellis",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "slow_fields",
      "integration_name": "Zellis"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "zellis",
      "object_type": "metadata_metadata",
      "integration_name": "Zellis"
   },
   {
      "type": "method",
      "integration_type": "zellis",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zellis"
   },
   {
      "type": "writable_field",
      "integration_type": "yardstik",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Yardstik"
   },
   {
      "type": "readable_field",
      "integration_type": "yardstik",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Yardstik"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "verification",
         "metadata",
         "passthrough"
      ],
      "integration_type": "yardstik",
      "object_type": "metadata_metadata",
      "integration_name": "Yardstik"
   },
   {
      "type": "method",
      "integration_type": "yardstik",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "verification",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Yardstik"
   },
   {
      "type": "writable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "writable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_group",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "writable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "writable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_company",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "readable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "readable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "readable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_group",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "readable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "readable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_company",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "readable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "kms_page",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "readable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_project",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "readable_field",
      "integration_type": "xurrent",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_task",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Xurrent"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Workstream"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Workstream"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Workstream"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "workstream",
      "object_type": "metadata_metadata",
      "integration_name": "Workstream"
   },
   {
      "type": "method",
      "integration_type": "workstream",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workstream"
   },
   {
      "type": "method",
      "integration_type": "workstream",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workstream"
   },
   {
      "type": "method",
      "integration_type": "workstream",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workstream"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "slow_fields",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Vincere"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "vincere",
      "object_type": "metadata_metadata",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ukgpro",
      "object_type": "metadata_metadata",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "traffit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Traffit"
   },
   {
      "type": "readable_field",
      "integration_type": "traffit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Traffit"
   },
   {
      "type": "readable_field",
      "integration_type": "traffit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Traffit"
   },
   {
      "type": "readable_field",
      "integration_type": "traffit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Traffit"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_project",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_project",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "metadata_metadata",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "techwolf",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Techwolf"
   },
   {
      "type": "readable_field",
      "integration_type": "techwolf",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Techwolf"
   },
   {
      "type": "pagination",
      "integration_type": "techwolf",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Techwolf"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "techwolf",
      "object_type": "metadata_metadata",
      "integration_name": "Techwolf"
   },
   {
      "type": "method",
      "integration_type": "techwolf",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Techwolf"
   },
   {
      "type": "method",
      "integration_type": "techwolf",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Techwolf"
   },
   {
      "type": "method",
      "integration_type": "techwolf",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Techwolf"
   },
   {
      "type": "method",
      "integration_type": "techwolf",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Techwolf"
   },
   {
      "type": "writable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "writable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "writable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_deal",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "writable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_project",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "writable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_project",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "writable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "readable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "readable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "readable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_deal",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "readable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_project",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "readable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_project",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "readable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "pagination",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Team Software"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "integration_type": "teamsoftware",
      "object_type": "metadata_metadata",
      "integration_name": "Team Software"
   },
   {
      "type": "method",
      "integration_type": "teamsoftware",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Team Software"
   },
   {
      "type": "writable_field",
      "integration_type": "taleez",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Taleez"
   },
   {
      "type": "readable_field",
      "integration_type": "taleez",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Taleez"
   },
   {
      "type": "readable_field",
      "integration_type": "taleez",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Taleez"
   },
   {
      "type": "pagination",
      "integration_type": "taleez",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Taleez"
   },
   {
      "type": "pagination",
      "integration_type": "taleez",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Taleez"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "taleez",
      "object_type": "metadata_metadata",
      "integration_name": "Taleez"
   },
   {
      "type": "method",
      "integration_type": "taleez",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Taleez"
   },
   {
      "type": "writable_field",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_reservation",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_item",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_location",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SquareUp"
   },
   {
      "type": "pagination",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "slow_fields",
      "integration_name": "SquareUp"
   },
   {
      "type": "pagination",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "slow_fields",
      "integration_name": "SquareUp"
   },
   {
      "type": "pagination",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "SquareUp"
   },
   {
      "type": "pagination",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "slow_fields",
      "integration_name": "SquareUp"
   },
   {
      "type": "pagination",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "slow_fields",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "integration_type": "squareup",
      "object_type": "metadata_metadata",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "snipeit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Snipe-IT"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "snipeit",
      "object_type": "metadata_metadata",
      "integration_name": "Snipe-IT"
   },
   {
      "type": "method",
      "integration_type": "snipeit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snipe-IT"
   },
   {
      "type": "method",
      "integration_type": "snipeit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snipe-IT"
   },
   {
      "type": "method",
      "integration_type": "snipeit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Snipe-IT"
   },
   {
      "type": "method",
      "integration_type": "snipeit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Snipe-IT"
   },
   {
      "type": "method",
      "integration_type": "snipeit",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Snipe-IT"
   },
   {
      "type": "readable_field",
      "integration_type": "skillsoft",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Skillsoft (Percipio)"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "lms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "skillsoft",
      "object_type": "metadata_metadata",
      "integration_name": "Skillsoft (Percipio)"
   },
   {
      "type": "method",
      "integration_type": "skillsoft",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Skillsoft (Percipio)"
   },
   {
      "type": "writable_field",
      "integration_type": "shortcut",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Shortcut"
   },
   {
      "type": "readable_field",
      "integration_type": "shortcut",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Shortcut"
   },
   {
      "type": "pagination",
      "integration_type": "shortcut",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "slow_fields",
      "integration_name": "Shortcut"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "shortcut",
      "object_type": "metadata_metadata",
      "integration_name": "Shortcut"
   },
   {
      "type": "method",
      "integration_type": "shortcut",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shortcut"
   },
   {
      "type": "method",
      "integration_type": "shortcut",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shortcut"
   },
   {
      "type": "method",
      "integration_type": "shortcut",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Shortcut"
   },
   {
      "type": "method",
      "integration_type": "shortcut",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Shortcut"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "sevenrooms",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_reservation",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SevenRooms"
   },
   {
      "type": "readable_field",
      "integration_type": "savvycal",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SavvyCal"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "calendar",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "savvycal",
      "object_type": "metadata_metadata",
      "integration_name": "SavvyCal"
   },
   {
      "type": "method",
      "integration_type": "savvycal",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "calendar",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SavvyCal"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "salesforcemarketingcloud",
      "object_type": "metadata_metadata",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforcedatacloud",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "cdp_profile",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce Data Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcedatacloud",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "object_type": "cdp_profile",
      "pagination": "slow_fields",
      "integration_name": "Salesforce Data Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "integration_type": "salesforcedatacloud",
      "object_type": "metadata_metadata",
      "integration_name": "Salesforce Data Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcedatacloud",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce Data Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "recurly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recurly"
   },
   {
      "type": "readable_field",
      "integration_type": "recurly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recurly"
   },
   {
      "type": "readable_field",
      "integration_type": "recurly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recurly"
   },
   {
      "type": "readable_field",
      "integration_type": "recurly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recurly"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recurly",
      "object_type": "metadata_metadata",
      "integration_name": "Recurly"
   },
   {
      "type": "method",
      "integration_type": "recurly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recurly"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recruitwizard",
      "object_type": "metadata_metadata",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Recruitee"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Recruitee"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recruitee"
   },
   {
      "type": "writable_field",
      "integration_type": "quo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QUO"
   },
   {
      "type": "readable_field",
      "integration_type": "quo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QUO"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "uc",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "quo",
      "object_type": "metadata_metadata",
      "integration_name": "QUO"
   },
   {
      "type": "method",
      "integration_type": "quo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "uc",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QUO"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "is_required",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "posthog",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "PostHog"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "analytics",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "posthog",
      "object_type": "metadata_metadata",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "analytics",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "analytics",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "analytics",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "method": "remove",
      "integration_name": "Pinpoint"
   },
   {
      "type": "writable_field",
      "integration_type": "phoneburner",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "readable_field",
      "integration_type": "phoneburner",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "pagination",
      "integration_type": "phoneburner",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "uc",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "slow_fields",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "uc",
         "metadata",
         "passthrough"
      ],
      "integration_type": "phoneburner",
      "object_type": "metadata_metadata",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "method",
      "integration_type": "phoneburner",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "method",
      "integration_type": "phoneburner",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "method",
      "integration_type": "phoneburner",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "method",
      "integration_type": "phoneburner",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "method",
      "integration_type": "phoneburner",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "uc",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "writable_field",
      "integration_type": "personio",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "PeopleHR"
   },
   {
      "type": "readable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "PeopleHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "peoplehr",
      "object_type": "metadata_metadata",
      "integration_name": "PeopleHR"
   },
   {
      "type": "method",
      "integration_type": "peoplehr",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PeopleHR"
   },
   {
      "type": "writable_field",
      "integration_type": "peopleforce",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "PeopleForce"
   },
   {
      "type": "pagination",
      "integration_type": "peopleforce",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "PeopleForce"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "peopleforce",
      "object_type": "metadata_metadata",
      "integration_name": "PeopleForce"
   },
   {
      "type": "method",
      "integration_type": "peopleforce",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PeopleForce"
   },
   {
      "type": "method",
      "integration_type": "peopleforce",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "PeopleForce"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "analytics",
         "metadata",
         "passthrough"
      ],
      "integration_type": "pendo",
      "object_type": "metadata_metadata",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "analytics",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "analytics",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "analytics",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pendo"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "paylocity",
      "object_type": "metadata_metadata",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paylocity"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "metadata_metadata",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "opensearch",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "OpenSearch"
   },
   {
      "type": "writable_field",
      "integration_type": "onlyfy",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "onlyfy"
   },
   {
      "type": "writable_field",
      "integration_type": "onlyfy",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "onlyfy"
   },
   {
      "type": "readable_field",
      "integration_type": "onlyfy",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "onlyfy"
   },
   {
      "type": "readable_field",
      "integration_type": "onlyfy",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "onlyfy"
   },
   {
      "type": "pagination",
      "integration_type": "onlyfy",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "onlyfy"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "onlyfy",
      "object_type": "metadata_metadata",
      "integration_name": "onlyfy"
   },
   {
      "type": "method",
      "integration_type": "onlyfy",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "onlyfy"
   },
   {
      "type": "method",
      "integration_type": "onlyfy",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "onlyfy"
   },
   {
      "type": "writable_field",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Okta"
   },
   {
      "type": "writable_field",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Okta"
   },
   {
      "type": "readable_field",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Okta"
   },
   {
      "type": "readable_field",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Okta"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "integration_type": "okta",
      "object_type": "metadata_metadata",
      "integration_name": "Okta"
   },
   {
      "type": "method",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Okta"
   },
   {
      "type": "method",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Okta"
   },
   {
      "type": "method",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Okta"
   },
   {
      "type": "method",
      "integration_type": "okta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "saml",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Okta"
   },
   {
      "type": "writable_field",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Occupop"
   },
   {
      "type": "readable_field",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Occupop"
   },
   {
      "type": "readable_field",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Occupop"
   },
   {
      "type": "pagination",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Occupop"
   },
   {
      "type": "pagination",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Occupop"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "occupop",
      "object_type": "metadata_metadata",
      "integration_name": "Occupop"
   },
   {
      "type": "method",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Occupop"
   },
   {
      "type": "method",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Occupop"
   },
   {
      "type": "method",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Occupop"
   },
   {
      "type": "method",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Occupop"
   },
   {
      "type": "method",
      "integration_type": "occupop",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Occupop"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Monday"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Monday"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "objects",
      "integration_name": "Monday"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Monday"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Monday"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Monday"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "is_required",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "writable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercadolibre",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mercado Libre"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "mercadolibre",
      "object_type": "metadata_metadata",
      "integration_name": "Mercado Libre"
   },
   {
      "type": "method",
      "integration_type": "mercadolibre",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mercado Libre"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Manatal"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Manatal"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Manatal"
   },
   {
      "type": "writable_field",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mambu"
   },
   {
      "type": "writable_field",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mambu"
   },
   {
      "type": "readable_field",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mambu"
   },
   {
      "type": "readable_field",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mambu"
   },
   {
      "type": "readable_field",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mambu"
   },
   {
      "type": "readable_field",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mambu"
   },
   {
      "type": "readable_field",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Mambu"
   },
   {
      "type": "pagination",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "Mambu"
   },
   {
      "type": "pagination",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "slow_fields",
      "integration_name": "Mambu"
   },
   {
      "type": "pagination",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Mambu"
   },
   {
      "type": "pagination",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "slow_fields",
      "integration_name": "Mambu"
   },
   {
      "type": "pagination",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "slow_fields",
      "integration_name": "Mambu"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "mambu",
      "object_type": "metadata_metadata",
      "integration_name": "Mambu"
   },
   {
      "type": "method",
      "integration_type": "mambu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mambu"
   },
   {
      "type": "readable_field",
      "integration_type": "magento",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "readable_field",
      "integration_type": "magento",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "pagination",
      "integration_type": "magento",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "slow_fields",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "pagination",
      "integration_type": "magento",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "slow_fields",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "integration_type": "magento",
      "object_type": "metadata_metadata",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "method",
      "integration_type": "magento",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "method",
      "integration_type": "magento",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "method",
      "integration_type": "magento",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "method",
      "integration_type": "magento",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "readable_field",
      "integration_type": "lytics",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "cdp_profile",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lytics"
   },
   {
      "type": "pagination",
      "integration_type": "lytics",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "object_type": "cdp_profile",
      "pagination": "slow_fields",
      "integration_name": "Lytics"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "integration_type": "lytics",
      "object_type": "metadata_metadata",
      "integration_name": "Lytics"
   },
   {
      "type": "method",
      "integration_type": "lytics",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lytics"
   },
   {
      "type": "method",
      "integration_type": "lytics",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Lytics"
   },
   {
      "type": "method",
      "integration_type": "lytics",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Lytics"
   },
   {
      "type": "method",
      "integration_type": "lytics",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Lytics"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lemlist"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lemlist"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lemlist"
   },
   {
      "type": "readable_field",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lemlist"
   },
   {
      "type": "readable_field",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lemlist"
   },
   {
      "type": "readable_field",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "slow_fields",
      "integration_name": "Lemlist"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "lemlist",
      "object_type": "metadata_metadata",
      "integration_name": "Lemlist"
   },
   {
      "type": "method",
      "integration_type": "lemlist",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lemlist"
   },
   {
      "type": "writable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Klaviyo"
   },
   {
      "type": "writable_field",
      "integration_type": "kevel",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Kevel"
   },
   {
      "type": "writable_field",
      "integration_type": "kevel",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Kevel"
   },
   {
      "type": "writable_field",
      "integration_type": "kevel",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Kevel"
   },
   {
      "type": "readable_field",
      "integration_type": "kevel",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Kevel"
   },
   {
      "type": "readable_field",
      "integration_type": "kevel",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Kevel"
   },
   {
      "type": "readable_field",
      "integration_type": "kevel",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Kevel"
   },
   {
      "type": "writable_field",
      "integration_type": "keap",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Keap"
   },
   {
      "type": "writable_field",
      "integration_type": "keap",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Keap"
   },
   {
      "type": "writable_field",
      "integration_type": "keap",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Keap"
   },
   {
      "type": "writable_field",
      "integration_type": "keap",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Keap"
   },
   {
      "type": "writable_field",
      "integration_type": "keap",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "justworks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Justworks"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "justworks",
      "object_type": "metadata_metadata",
      "integration_name": "Justworks"
   },
   {
      "type": "method",
      "integration_type": "justworks",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Justworks"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "is_required",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "icontact",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "iContact"
   },
   {
      "type": "writable_field",
      "integration_type": "icontact",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "iContact"
   },
   {
      "type": "writable_field",
      "integration_type": "icontact",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "iContact"
   },
   {
      "type": "writable_field",
      "integration_type": "icontact",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "iContact"
   },
   {
      "type": "method",
      "integration_type": "icontact",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "iContact"
   },
   {
      "type": "method",
      "integration_type": "icontact",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "iContact"
   },
   {
      "type": "method",
      "integration_type": "icontact",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "iContact"
   },
   {
      "type": "readable_field",
      "integration_type": "homerun",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Homerun"
   },
   {
      "type": "pagination",
      "integration_type": "homerun",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Homerun"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gorgias"
   },
   {
      "type": "writable_field",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "slow_fields",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "slow_fields",
      "integration_name": "Gorgias"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "gorgias",
      "object_type": "metadata_metadata",
      "integration_name": "Gorgias"
   },
   {
      "type": "method",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gorgias"
   },
   {
      "type": "method",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gorgias"
   },
   {
      "type": "method",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gorgias"
   },
   {
      "type": "method",
      "integration_type": "gorgias",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Gorgias"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "gladly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "slow_fields",
      "integration_name": "Gladly"
   },
   {
      "type": "writable_field",
      "integration_type": "getresponse",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "GetResponse"
   },
   {
      "type": "writable_field",
      "integration_type": "getresponse",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "GetResponse"
   },
   {
      "type": "writable_field",
      "integration_type": "getresponse",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "GetResponse"
   },
   {
      "type": "writable_field",
      "integration_type": "getresponse",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "GetResponse"
   },
   {
      "type": "writable_field",
      "integration_type": "getresponse",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "GetResponse"
   },
   {
      "type": "method",
      "integration_type": "getresponse",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "GetResponse"
   },
   {
      "type": "method",
      "integration_type": "getresponse",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "GetResponse"
   },
   {
      "type": "method",
      "integration_type": "getresponse",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "martech",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GetResponse"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "foundU"
   },
   {
      "type": "writable_field",
      "integration_type": "firstadvantage",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "First Advantage"
   },
   {
      "type": "readable_field",
      "integration_type": "firstadvantage",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "First Advantage"
   },
   {
      "type": "writable_field",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Fireberry"
   },
   {
      "type": "writable_field",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Fireberry"
   },
   {
      "type": "writable_field",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Fireberry"
   },
   {
      "type": "writable_field",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Fireberry"
   },
   {
      "type": "writable_field",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Fireberry"
   },
   {
      "type": "writable_field",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "is_required",
      "integration_name": "Fireberry"
   },
   {
      "type": "writable_field",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Fireberry"
   },
   {
      "type": "method",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Fireberry"
   },
   {
      "type": "method",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Fireberry"
   },
   {
      "type": "method",
      "integration_type": "fireberry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Fireberry"
   },
   {
      "type": "writable_field",
      "integration_type": "fibery",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Fibery"
   },
   {
      "type": "writable_field",
      "integration_type": "fibery",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Fibery"
   },
   {
      "type": "writable_field",
      "integration_type": "fibery",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Fibery"
   },
   {
      "type": "method",
      "integration_type": "fibery",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Fibery"
   },
   {
      "type": "method",
      "integration_type": "fibery",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Fibery"
   },
   {
      "type": "method",
      "integration_type": "fibery",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Fibery"
   },
   {
      "type": "writable_field",
      "integration_type": "engagedly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Engagedly"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "integration_type": "engagedly",
      "object_type": "metadata_metadata",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "performance",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Employment Hero"
   },
   {
      "type": "pagination",
      "integration_type": "employmenthero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Employment Hero"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "employmenthero",
      "object_type": "metadata_metadata",
      "integration_name": "Employment Hero"
   },
   {
      "type": "method",
      "integration_type": "employmenthero",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Employment Hero"
   },
   {
      "type": "writable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Eightfold"
   },
   {
      "type": "writable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_refund",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dualentry",
      "object_type": "metadata_metadata",
      "integration_name": "DualEntry"
   },
   {
      "type": "method",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DualEntry"
   },
   {
      "type": "method",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "DualEntry"
   },
   {
      "type": "method",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "DualEntry"
   },
   {
      "type": "method",
      "integration_type": "dualentry",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DualEntry"
   },
   {
      "type": "writable_field",
      "integration_type": "dexcrm",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Dex CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "dexcrm",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Dex CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "dexcrm",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Dex CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "dexcrm",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Dex CRM"
   },
   {
      "type": "method",
      "integration_type": "dexcrm",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Dex CRM"
   },
   {
      "type": "method",
      "integration_type": "dexcrm",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Dex CRM"
   },
   {
      "type": "method",
      "integration_type": "dexcrm",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Dex CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "customerio",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Customer.io"
   },
   {
      "type": "readable_field",
      "integration_type": "customerio",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Customer.io"
   },
   {
      "type": "writable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "lms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Cornerstone"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "cornerstone",
      "object_type": "metadata_metadata",
      "integration_name": "Cornerstone"
   },
   {
      "type": "method",
      "integration_type": "cornerstone",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "lms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cornerstone"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "connecteam",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Connecteam"
   },
   {
      "type": "writable_field",
      "integration_type": "connecteam",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "field": "is_required",
      "integration_name": "Connecteam"
   },
   {
      "type": "writable_field",
      "integration_type": "connecteam",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Connecteam"
   },
   {
      "type": "method",
      "integration_type": "connecteam",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Connecteam"
   },
   {
      "type": "method",
      "integration_type": "connecteam",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Connecteam"
   },
   {
      "type": "writable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "writable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "writable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "chargify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "readable_field",
      "integration_type": "chargify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "readable_field",
      "integration_type": "chargify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "pagination",
      "integration_type": "chargify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "slow_fields",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "pagination",
      "integration_type": "chargify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "chargify",
      "object_type": "metadata_metadata",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "payment",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "readable_field",
      "integration_type": "cascade",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Cascade"
   },
   {
      "type": "readable_field",
      "integration_type": "cascade",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Cascade"
   },
   {
      "type": "pagination",
      "integration_type": "cascade",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "slow_fields",
      "integration_name": "Cascade"
   },
   {
      "type": "pagination",
      "integration_type": "cascade",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "slow_fields",
      "integration_name": "Cascade"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "cascade",
      "object_type": "metadata_metadata",
      "integration_name": "Cascade"
   },
   {
      "type": "method",
      "integration_type": "cascade",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cascade"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Carerix"
   },
   {
      "type": "writable_field",
      "integration_type": "campfire",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Campfire"
   },
   {
      "type": "readable_field",
      "integration_type": "campfire",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Campfire"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "campfire",
      "object_type": "metadata_metadata",
      "integration_name": "Campfire"
   },
   {
      "type": "method",
      "integration_type": "campfire",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Campfire"
   },
   {
      "type": "writable_field",
      "integration_type": "brex",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Brex"
   },
   {
      "type": "readable_field",
      "integration_type": "brex",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Brex"
   },
   {
      "type": "readable_field",
      "integration_type": "brex",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Brex"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "is_required",
      "integration_name": "Attio"
   },
   {
      "type": "method",
      "integration_type": "attio",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "applicantstack",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "writable_field",
      "integration_type": "applicantstack",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "readable_field",
      "integration_type": "applicantstack",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "readable_field",
      "integration_type": "applicantstack",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "writable_field",
      "integration_type": "apollo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Apollo.io"
   },
   {
      "type": "writable_field",
      "integration_type": "apollo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Apollo.io"
   },
   {
      "type": "writable_field",
      "integration_type": "apollo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Apollo.io"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "crm",
         "metadata",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "agencyzoom",
      "object_type": "hris_employee",
      "integration_name": "AgencyZoom"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "crm",
         "metadata",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "agencyzoom",
      "object_type": "task_task",
      "integration_name": "AgencyZoom"
   },
   {
      "type": "method",
      "integration_type": "agencyzoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "metadata",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AgencyZoom"
   },
   {
      "type": "method",
      "integration_type": "agencyzoom",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "metadata",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AgencyZoom"
   },
   {
      "type": "writable_field",
      "integration_type": "adobesign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "readable_field",
      "integration_type": "adobesign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "pagination",
      "integration_type": "adobesign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "slow_fields",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "acerta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Acerta"
   },
   {
      "type": "pagination",
      "integration_type": "acerta",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Acerta"
   },
   {
      "type": "readable_field",
      "integration_type": "absorb",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "hris_employee",
      "categories": [
         "lms",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Absorb"
   },
   {
      "type": "pagination",
      "integration_type": "absorb",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "lms",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Absorb"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T20:45:13.000Z",
      "categories": [
         "lms",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "absorb",
      "object_type": "metadata_metadata",
      "integration_name": "Absorb"
   },
   {
      "type": "method",
      "integration_type": "absorb",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "lms",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Absorb"
   },
   {
      "type": "method",
      "integration_type": "absorb",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "lms",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Absorb"
   },
   {
      "type": "method",
      "integration_type": "absorb",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "lms",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Absorb"
   },
   {
      "type": "method",
      "integration_type": "absorb",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "lms",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Absorb"
   },
   {
      "type": "writable_field",
      "integration_type": "8x8",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "readable_field",
      "integration_type": "8x8",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "method",
      "integration_type": "8x8",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "method",
      "integration_type": "8x8",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "method",
      "integration_type": "8x8",
      "created_at": "2026-10-19T20:45:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomcalendar",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoom"
   },
   {
      "type": "writable_field",
      "integration_type": "talentlyft",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TalentLyft"
   },
   {
      "type": "readable_field",
      "integration_type": "talentlyft",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TalentLyft"
   },
   {
      "type": "readable_field",
      "integration_type": "talentlyft",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "TalentLyft"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T14:09:01.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "talentlyft",
      "object_type": "metadata_metadata",
      "integration_name": "TalentLyft"
   },
   {
      "type": "method",
      "integration_type": "talentlyft",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TalentLyft"
   },
   {
      "type": "method",
      "integration_type": "talentlyft",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TalentLyft"
   },
   {
      "type": "method",
      "integration_type": "talentlyft",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TalentLyft"
   },
   {
      "type": "method",
      "integration_type": "talentlyft",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TalentLyft"
   },
   {
      "type": "readable_field",
      "integration_type": "leapsome",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Leapsome"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T14:09:01.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T14:09:01.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "googlevertexai",
      "object_type": "genai_embedding",
      "integration_name": "Google Vertex AI"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T14:09:01.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "googlevertexai",
      "object_type": "genai_memory",
      "integration_name": "Google Vertex AI"
   },
   {
      "type": "method",
      "integration_type": "googlevertexai",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Vertex AI"
   },
   {
      "type": "method",
      "integration_type": "googlevertexai",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Vertex AI"
   },
   {
      "type": "method",
      "integration_type": "googlevertexai",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Vertex AI"
   },
   {
      "type": "method",
      "integration_type": "googlevertexai",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Vertex AI"
   },
   {
      "type": "method",
      "integration_type": "googlevertexai",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Vertex AI"
   },
   {
      "type": "method",
      "integration_type": "googlevertexai",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Vertex AI"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T14:09:01.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "devin",
      "object_type": "genai_memory",
      "integration_name": "Devin"
   },
   {
      "type": "method",
      "integration_type": "devin",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Devin"
   },
   {
      "type": "method",
      "integration_type": "devin",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Devin"
   },
   {
      "type": "method",
      "integration_type": "devin",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Devin"
   },
   {
      "type": "method",
      "integration_type": "devin",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Devin"
   },
   {
      "type": "method",
      "integration_type": "devin",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Devin"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T14:09:01.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "anthropicclaude",
      "object_type": "genai_memory",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "method",
      "integration_type": "anthropicclaude",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "method",
      "integration_type": "anthropicclaude",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "method",
      "integration_type": "anthropicclaude",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "method",
      "integration_type": "anthropicclaude",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "method",
      "integration_type": "anthropicclaude",
      "created_at": "2026-10-19T14:09:01.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "microsoftfoundry",
      "object_type": "genai_memory",
      "integration_name": "Microsoft Foundry"
   },
   {
      "type": "method",
      "integration_type": "microsoftfoundry",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Foundry"
   },
   {
      "type": "method",
      "integration_type": "microsoftfoundry",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Foundry"
   },
   {
      "type": "method",
      "integration_type": "microsoftfoundry",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Foundry"
   },
   {
      "type": "method",
      "integration_type": "microsoftfoundry",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Foundry"
   },
   {
      "type": "method",
      "integration_type": "microsoftfoundry",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Foundry"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "devin",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Devin"
   },
   {
      "type": "readable_field",
      "integration_type": "devin",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Devin"
   },
   {
      "type": "pagination",
      "integration_type": "devin",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_task",
      "pagination": "slow_fields",
      "integration_name": "Devin"
   },
   {
      "type": "pagination",
      "integration_type": "devin",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_agent",
      "pagination": "list_limit",
      "integration_name": "Devin"
   },
   {
      "type": "pagination",
      "integration_type": "devin",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_agent",
      "pagination": "list_offset",
      "integration_name": "Devin"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "cloudflareworkersai",
      "object_type": "genai_memory",
      "integration_name": "Cloudflare Workers AI"
   },
   {
      "type": "method",
      "integration_type": "cloudflareworkersai",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cloudflare Workers AI"
   },
   {
      "type": "method",
      "integration_type": "cloudflareworkersai",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cloudflare Workers AI"
   },
   {
      "type": "method",
      "integration_type": "cloudflareworkersai",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Cloudflare Workers AI"
   },
   {
      "type": "method",
      "integration_type": "cloudflareworkersai",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cloudflare Workers AI"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "Clear Company"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "clearcompany",
      "object_type": "metadata_metadata",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clear Company"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "byteplus",
      "object_type": "genai_memory",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "method",
      "integration_type": "byteplus",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "method",
      "integration_type": "byteplus",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "method",
      "integration_type": "byteplus",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "method",
      "integration_type": "byteplus",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "method",
      "integration_type": "byteplus",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "augure",
      "object_type": "genai_memory",
      "integration_name": "Augure"
   },
   {
      "type": "method",
      "integration_type": "augure",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Augure"
   },
   {
      "type": "method",
      "integration_type": "augure",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Augure"
   },
   {
      "type": "method",
      "integration_type": "augure",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Augure"
   },
   {
      "type": "method",
      "integration_type": "augure",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Augure"
   },
   {
      "type": "method",
      "integration_type": "augure",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Augure"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "anthropicagents",
      "object_type": "genai_memory",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "anthropicagents",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "anthropicagents",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "anthropicagents",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "anthropicagents",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "anthropicagents",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T13:08:39.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "alibabacloud",
      "object_type": "genai_memory",
      "integration_name": "Alibaba Cloud Model Studio"
   },
   {
      "type": "method",
      "integration_type": "alibabacloud",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Alibaba Cloud Model Studio"
   },
   {
      "type": "method",
      "integration_type": "alibabacloud",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Alibaba Cloud Model Studio"
   },
   {
      "type": "method",
      "integration_type": "alibabacloud",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Alibaba Cloud Model Studio"
   },
   {
      "type": "method",
      "integration_type": "alibabacloud",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Alibaba Cloud Model Studio"
   },
   {
      "type": "method",
      "integration_type": "alibabacloud",
      "created_at": "2026-10-19T13:08:39.000Z",
      "object_type": "genai_memory",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Alibaba Cloud Model Studio"
   },
   {
      "type": "object",
      "created_at": "2026-10-19T09:56:19.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "previsto",
      "integration_name": "Previsto"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "pretix",
      "integration_name": "pretix"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "precisefp",
      "integration_name": "PreciseFP"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "planka",
      "integration_name": "Planka"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "harpoon",
      "integration_name": "Harpoon"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "gridfox",
      "integration_name": "Gridfox"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "googlecomputeengine",
      "integration_name": "Google Compute Engine"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "googlecloudtalentsolution",
      "integration_name": "Google Cloud Talent Solution"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "googlecloudfunctions",
      "integration_name": "Google Cloud Functions"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "googleappengine",
      "integration_name": "Google App Engine"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "crm",
         "payment",
         "passthrough"
      ],
      "integration_type": "gofundmepro",
      "integration_name": "GoFundMe Pro"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "integration_type": "buddypt",
      "integration_name": "BuddyPT"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "billsby",
      "integration_name": "Billsby"
   },
   {
      "type": "integration",
      "created_at": "2026-10-19T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "accelo",
      "integration_name": "Accelo"
   },
   {
      "type": "object",
      "object_type": "genai_memory",
      "integration_type": "mem0",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-10-18T21:23:43.000Z",
      "integration_name": "Mem0"
   },
   {
      "type": "object",
      "created_at": "2026-10-18T21:23:43.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "ELMO"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "ELMO"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "ELMO"
   },
   {
      "type": "pagination",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_status",
      "integration_name": "ELMO"
   },
   {
      "type": "object",
      "created_at": "2026-10-18T21:23:43.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "elmo",
      "object_type": "hris_location",
      "integration_name": "ELMO"
   },
   {
      "type": "object",
      "created_at": "2026-10-18T21:23:43.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "elmo",
      "object_type": "hris_job",
      "integration_name": "ELMO"
   },
   {
      "type": "object",
      "created_at": "2026-10-18T21:23:43.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "elmo",
      "object_type": "hris_company",
      "integration_name": "ELMO"
   },
   {
      "type": "method",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ELMO"
   },
   {
      "type": "method",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ELMO"
   },
   {
      "type": "method",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ELMO"
   },
   {
      "type": "method",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "object_type": "hris_job",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ELMO"
   },
   {
      "type": "method",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ELMO"
   },
   {
      "type": "method",
      "integration_type": "elmo",
      "created_at": "2026-10-18T21:23:43.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ELMO"
   },
   {
      "type": "object",
      "object_type": "genai_memory",
      "integration_type": "amazonbedrockagentcore",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-10-18T21:23:43.000Z",
      "integration_name": "Amazon Bedrock AgentCore"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "JazzHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-18T06:27:01.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Helpscout"
   },
   {
      "type": "writable_field",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Helpscout"
   },
   {
      "type": "writable_field",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Helpscout"
   },
   {
      "type": "writable_field",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Helpscout"
   },
   {
      "type": "writable_field",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Helpscout"
   },
   {
      "type": "readable_field",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Helpscout"
   },
   {
      "type": "method",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Helpscout"
   },
   {
      "type": "method",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Helpscout"
   },
   {
      "type": "method",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Helpscout"
   },
   {
      "type": "method",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Helpscout"
   },
   {
      "type": "method",
      "integration_type": "helpscout",
      "created_at": "2026-10-18T06:27:01.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Helpscout"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "clubs",
         "hris",
         "passthrough"
      ],
      "integration_type": "teamup",
      "integration_name": "TeamUp"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "ticketing",
         "crm",
         "passthrough"
      ],
      "integration_type": "syncro",
      "integration_name": "Syncro"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "printful",
      "integration_name": "Printful"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "integration_type": "postproxy",
      "integration_name": "Postproxy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "postal",
      "integration_name": "Postal"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "popl",
      "integration_name": "Popl"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "task",
         "passthrough"
      ],
      "integration_type": "podio",
      "integration_name": "Podio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "clubs",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "pike13",
      "integration_name": "Pike13"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "metronome",
      "integration_name": "Metronome"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "mem0",
      "integration_name": "Mem0"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "meistertask",
      "integration_name": "MeisterTask"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "gsengage",
      "integration_name": "GS Engage"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "gopay",
      "integration_name": "GoPay"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "googlevertexai",
      "integration_name": "Google Vertex AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "googleadsense",
      "integration_name": "Google AdSense"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "googleadmob",
      "integration_name": "Google AdMob"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "catalogmachine",
      "integration_name": "Catalog Machine"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "cartesia",
      "integration_name": "Cartesia"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "captivated",
      "integration_name": "Captivated"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "cantrip",
      "integration_name": "Cantrip"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "canarics",
      "integration_name": "Canarics"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "boomerangme",
      "integration_name": "Boomerangme"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "augure",
      "integration_name": "Augure"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "amazonbedrockagentcore",
      "integration_name": "Amazon Bedrock AgentCore"
   },
   {
      "type": "integration",
      "created_at": "2026-10-18T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "agendor",
      "integration_name": "Agendor"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "threemabroadcast",
      "integration_name": "Threema Broadcast"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "tazworks",
      "integration_name": "Tazworks"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "smily",
      "integration_name": "Smily"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "resistantai",
      "integration_name": "Resistant AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "planday",
      "integration_name": "Planday"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "placetel",
      "integration_name": "Placetel"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "operapms",
      "integration_name": "Oracle OPERA Cloud PMS"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "openedx",
      "integration_name": "Open edX"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "makesure",
      "integration_name": "Makesure"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "inqom",
      "integration_name": "Inqom"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "groove",
      "integration_name": "Groove"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "storage",
         "hris",
         "forms",
         "passthrough"
      ],
      "integration_type": "grm",
      "integration_name": "GRM"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "caspio",
      "integration_name": "Caspio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "integration_type": "canhelpto",
      "integration_name": "canhelpto"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "candis",
      "integration_name": "Candis"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "callfire",
      "integration_name": "CallFire"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "buymeacoffee",
      "integration_name": "Buy Me a Coffee"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "busybusy",
      "integration_name": "busybusy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "burq",
      "integration_name": "Burq"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "bulkgate",
      "integration_name": "BulkGate"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "bukku",
      "integration_name": "Bukku"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "buckaroo",
      "integration_name": "Buckaroo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "bubble",
      "integration_name": "Bubble"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "bring",
      "integration_name": "Bring"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "braintree",
      "integration_name": "Braintree"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "bouncewatch",
      "integration_name": "BounceWatch"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "botify",
      "integration_name": "Botify"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "boomtown",
      "integration_name": "BoomTown"
   },
   {
      "type": "integration",
      "created_at": "2026-10-17T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "automata",
      "integration_name": "Automata"
   },
   {
      "type": "pagination",
      "integration_type": "zoominfo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "interview_id",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "recommendation",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_application",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_job",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_application",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "approver_user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "approved_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "slow_fields",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_job",
      "pagination": "list_updated_gte",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_job",
      "pagination": "virtual_webhook_group_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_job",
      "pagination": "virtual_webhook_location_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Wave"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Wave"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "wave",
      "object_type": "accounting_taxrate",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wave"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukgpro_ats",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukgpro_ats",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgpro_ats",
      "object_type": "ats_interview",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "writable_field",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "taleo",
      "object_type": "ats_interview",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "taleo",
      "object_type": "ats_scorecard",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "taleo",
      "object_type": "ats_applicationstatus",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_sort_by_created_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_sort_by_created_at",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "streamtime",
      "object_type": "hris_location",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Streamtime"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_order",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_name",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "crm_contact",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "task_task",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "spott",
      "object_type": "hris_group",
      "integration_name": "Spott"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "spott",
      "object_type": "hris_location",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spott"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_limit",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_offset",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Recruitee"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "commerce_item",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "commerce_location",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_account",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_journal",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_contact",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_bill",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_employee",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_expense",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_category",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_attendance",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "commerce_item",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "commerce_location",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_account",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_journal",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_transaction",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_contact",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_bill",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_paymentterm",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "hris_employee",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_expense",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_category",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "hris_timeshift",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "hris_attendance",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "payment_payment",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "kandji",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "writable_field",
      "integration_type": "kandji",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "asset_tag",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "readable_field",
      "integration_type": "kandji",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "method",
      "integration_type": "kandji",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "method",
      "integration_type": "kandji",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "readable_field",
      "integration_type": "indeed",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Indeed"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "iCIMS"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "integration_type": "hunter",
      "object_type": "crm_contact",
      "integration_name": "Hunter.io"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "integration_type": "hunter",
      "object_type": "crm_company",
      "integration_name": "Hunter.io"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "integration_type": "hunter",
      "object_type": "passthrough",
      "integration_name": "Hunter.io"
   },
   {
      "type": "method",
      "integration_type": "hunter",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Hunter.io"
   },
   {
      "type": "method",
      "integration_type": "hunter",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Hunter.io"
   },
   {
      "type": "method",
      "integration_type": "hunter",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Hunter.io"
   },
   {
      "type": "method",
      "integration_type": "hunter",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Hunter.io"
   },
   {
      "type": "method",
      "integration_type": "hunter",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Hunter.io"
   },
   {
      "type": "method",
      "integration_type": "hunter",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Hunter.io"
   },
   {
      "type": "method",
      "integration_type": "hunter",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Hunter.io"
   },
   {
      "type": "method",
      "integration_type": "hunter",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Hunter.io"
   },
   {
      "type": "method",
      "integration_type": "hunter",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Hunter.io"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "haileyhr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "HaileyHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "haileyhr",
      "object_type": "hris_bankaccount",
      "integration_name": "HaileyHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "haileyhr",
      "object_type": "hris_company",
      "integration_name": "HaileyHR"
   },
   {
      "type": "method",
      "integration_type": "haileyhr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HaileyHR"
   },
   {
      "type": "method",
      "integration_type": "haileyhr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HaileyHR"
   },
   {
      "type": "method",
      "integration_type": "haileyhr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HaileyHR"
   },
   {
      "type": "method",
      "integration_type": "haileyhr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HaileyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "grok",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "max_tokens",
      "integration_name": "X.ai Grok"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "grok",
      "object_type": "genai_embedding",
      "integration_name": "X.ai Grok"
   },
   {
      "type": "method",
      "integration_type": "grok",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "X.ai Grok"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Classroom"
   },
   {
      "type": "writable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Google Classroom"
   },
   {
      "type": "writable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Google Classroom"
   },
   {
      "type": "writable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "categories",
      "integration_name": "Google Classroom"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Google Classroom"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Google Classroom"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Google Classroom"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "assigned_grade",
      "integration_name": "Google Classroom"
   },
   {
      "type": "pagination",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "object_type": "lms_activity",
      "pagination": "list_content_id",
      "integration_name": "Google Classroom"
   },
   {
      "type": "method",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Classroom"
   },
   {
      "type": "method",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Classroom"
   },
   {
      "type": "method",
      "integration_type": "googleclassroom",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "lms_collection",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Classroom"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "fireflies",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_query",
      "integration_name": "Fireflies"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "integration_type": "fireflies",
      "object_type": "hris_group",
      "integration_name": "Fireflies"
   },
   {
      "type": "method",
      "integration_type": "fireflies",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fireflies"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_url",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "application_id",
      "integration_name": "Eightfold"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "lost_reason",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_contact_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_pipeline_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_pipeline_id",
      "integration_name": "Copper"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "copper",
      "object_type": "crm_pipeline",
      "integration_name": "Copper"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "copper",
      "object_type": "task_project",
      "integration_name": "Copper"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "copper",
      "object_type": "task_task",
      "integration_name": "Copper"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "copper",
      "object_type": "metadata_metadata",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Copper"
   },
   {
      "type": "method",
      "integration_type": "copper",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "contactout",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "year_founded",
      "integration_name": "ContactOut"
   },
   {
      "type": "readable_field",
      "integration_type": "contactout",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "ContactOut"
   },
   {
      "type": "readable_field",
      "integration_type": "contactout",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "logo_url",
      "integration_name": "ContactOut"
   },
   {
      "type": "readable_field",
      "integration_type": "contactout",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "ContactOut"
   },
   {
      "type": "readable_field",
      "integration_type": "contactout",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "ContactOut"
   },
   {
      "type": "pagination",
      "integration_type": "contactout",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_name",
      "integration_name": "ContactOut"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "tip_amount",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "salesorder_id",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "public_name",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "device_id",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "card_last4",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "card_brand",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "object_type": "payment_refund",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "object_type": "commerce_inventory",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "object_type": "crm_contact",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_refund",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "payment_refund",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "crm_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_application",
      "integration_name": "Checkr"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_application",
      "integration_name": "Checkr"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_application",
      "integration_name": "Checkr"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "integration_type": "checkr",
      "object_type": "hris_group",
      "integration_name": "Checkr"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "integration_type": "checkr",
      "object_type": "hris_location",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Checkr"
   },
   {
      "type": "writable_field",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "Chargebee"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "chargebee",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Chargebee"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "chargebee",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_start_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_end_lt",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Chargebee"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "chargebee",
      "object_type": "accounting_creditmemo",
      "integration_name": "Chargebee"
   },
   {
      "type": "method",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Chargebee"
   },
   {
      "type": "method",
      "integration_type": "chargebee",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Chargebee"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "careerplug",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "CareerPlug"
   },
   {
      "type": "pagination",
      "integration_type": "careerplug",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "CareerPlug"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "careerplug",
      "object_type": "hris_group",
      "integration_name": "CareerPlug"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "careerplug",
      "object_type": "hris_location",
      "integration_name": "CareerPlug"
   },
   {
      "type": "method",
      "integration_type": "careerplug",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CareerPlug"
   },
   {
      "type": "method",
      "integration_type": "careerplug",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CareerPlug"
   },
   {
      "type": "method",
      "integration_type": "careerplug",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CareerPlug"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "meeting_url",
      "integration_name": "Ashby"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ashby",
      "object_type": "hris_location",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "8x8xcaas",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "8x8xcaas",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "8x8xcaas",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "8x8xcaas",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "8x8xcaas",
      "object_type": "hris_location",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T16:59:41.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "8x8xcaas",
      "object_type": "hris_group",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "method",
      "integration_type": "8x8xcaas",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "method",
      "integration_type": "8x8xcaas",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_location",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "method",
      "integration_type": "8x8xcaas",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "method",
      "integration_type": "8x8xcaas",
      "created_at": "2026-10-16T16:59:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T08:19:55.000Z",
      "categories": [
         "auth",
         "social",
         "passthrough"
      ],
      "integration_type": "youtube",
      "object_type": "social_post",
      "integration_name": "YouTube"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T08:19:55.000Z",
      "categories": [
         "auth",
         "social",
         "passthrough"
      ],
      "integration_type": "youtube",
      "object_type": "social_profile",
      "integration_name": "YouTube"
   },
   {
      "type": "method",
      "integration_type": "youtube",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "social_post",
      "categories": [
         "auth",
         "social",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "YouTube"
   },
   {
      "type": "method",
      "integration_type": "youtube",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "social_post",
      "categories": [
         "auth",
         "social",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "YouTube"
   },
   {
      "type": "method",
      "integration_type": "youtube",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "social_post",
      "categories": [
         "auth",
         "social",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "YouTube"
   },
   {
      "type": "method",
      "integration_type": "youtube",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "social_profile",
      "categories": [
         "auth",
         "social",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "YouTube"
   },
   {
      "type": "method",
      "integration_type": "youtube",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "social_profile",
      "categories": [
         "auth",
         "social",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "YouTube"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "recommendation",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "interview_id",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "comment",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_interview",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_interview",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "application_id",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "whatsapp",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "WhatsApp"
   },
   {
      "type": "readable_field",
      "integration_type": "whatsapp",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "has_subchannels",
      "integration_name": "WhatsApp"
   },
   {
      "type": "method",
      "integration_type": "whatsapp",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "WhatsApp"
   },
   {
      "type": "object",
      "created_at": "2026-10-16T08:19:55.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-10-16T08:19:55.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_offset",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-10-16T08:19:55.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "webdam",
      "integration_name": "Webdam"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "sympla",
      "integration_name": "Sympla"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "saponprem",
      "integration_name": "SAP S/4HANA (On-prem)"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "integration_type": "microsoftexchangeonprem",
      "integration_name": "Microsoft Exchange (on-prem)"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "ticketing",
         "crm",
         "passthrough"
      ],
      "integration_type": "halopsa",
      "integration_name": "HaloPSA"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "goodday",
      "integration_name": "GoodDay"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "repo",
         "hris",
         "passthrough"
      ],
      "integration_type": "gogs",
      "integration_name": "Gogs"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "dub",
      "integration_name": "Dub"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "droppery",
      "integration_name": "Droppery"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "dhlecommercenl",
      "integration_name": "DHL eCommerce Netherlands"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "denodeploy",
      "integration_name": "Deno Deploy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "defguard",
      "integration_name": "Defguard"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "dealhub",
      "integration_name": "DealHub"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "buttondown",
      "integration_name": "Buttondown"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "bulksms",
      "integration_name": "BulkSMS"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "brandlovers",
      "integration_name": "BrandLovers"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "storage",
         "passthrough"
      ],
      "integration_type": "brandfolder",
      "integration_name": "Brandfolder"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "bookstack",
      "integration_name": "BookStack"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "bonusly",
      "integration_name": "Bonusly"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "forms",
         "crm",
         "passthrough"
      ],
      "integration_type": "boast",
      "integration_name": "Boast"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "bluetick",
      "integration_name": "Bluetick.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "blueshift",
      "integration_name": "Blueshift"
   },
   {
      "type": "integration",
      "created_at": "2026-10-16T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "blueink",
      "integration_name": "Blueink"
   },
   {
      "type": "pagination",
      "integration_type": "zinc",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "object_type": "verification_request",
      "pagination": "list_limit",
      "integration_name": "Zinc"
   },
   {
      "type": "pagination",
      "integration_type": "zinc",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "object_type": "verification_request",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zinc"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "list_limit",
      "integration_name": "Trello"
   },
   {
      "type": "pagination",
      "integration_type": "timelinesai",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_limit",
      "integration_name": "TimelinesAI"
   },
   {
      "type": "pagination",
      "integration_type": "timelinesai",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_limit",
      "integration_name": "TimelinesAI"
   },
   {
      "type": "pagination",
      "integration_type": "timelinesai",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "TimelinesAI"
   },
   {
      "type": "pagination",
      "integration_type": "talkpush",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Talkpush"
   },
   {
      "type": "pagination",
      "integration_type": "talkpush",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Talkpush"
   },
   {
      "type": "pagination",
      "integration_type": "talkpush",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Talkpush"
   },
   {
      "type": "pagination",
      "integration_type": "talkpush",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Talkpush"
   },
   {
      "type": "pagination",
      "integration_type": "sendfox",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_limit",
      "integration_name": "SendFox"
   },
   {
      "type": "pagination",
      "integration_type": "sendfox",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_limit",
      "integration_name": "SendFox"
   },
   {
      "type": "pagination",
      "integration_type": "redtail",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "object_type": "crm_deal",
      "pagination": "list_limit",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "pagination",
      "integration_type": "quintadb",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "object_type": "datastore_database",
      "pagination": "list_limit",
      "integration_name": "QuintaDB"
   },
   {
      "type": "pagination",
      "integration_type": "peopleforce",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "PeopleForce"
   },
   {
      "type": "pagination",
      "integration_type": "pageup",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "PageUp"
   },
   {
      "type": "pagination",
      "integration_type": "outplay",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "martech",
         "task",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "Outplay"
   },
   {
      "type": "pagination",
      "integration_type": "outplay",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "martech",
         "task",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "Outplay"
   },
   {
      "type": "pagination",
      "integration_type": "outplay",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "martech",
         "task",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_limit",
      "integration_name": "Outplay"
   },
   {
      "type": "pagination",
      "integration_type": "outplay",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "martech",
         "task",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_limit",
      "integration_name": "Outplay"
   },
   {
      "type": "pagination",
      "integration_type": "outplay",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "martech",
         "task",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_limit",
      "integration_name": "Outplay"
   },
   {
      "type": "pagination",
      "integration_type": "orderlord",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_limit",
      "integration_name": "OrderLord"
   },
   {
      "type": "pagination",
      "integration_type": "orderlord",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "OrderLord"
   },
   {
      "type": "pagination",
      "integration_type": "numier",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_limit",
      "integration_name": "Numier"
   },
   {
      "type": "pagination",
      "integration_type": "numier",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_limit",
      "integration_name": "Numier"
   },
   {
      "type": "pagination",
      "integration_type": "numier",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Numier"
   },
   {
      "type": "pagination",
      "integration_type": "numier",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_limit",
      "integration_name": "Numier"
   },
   {
      "type": "pagination",
      "integration_type": "numier",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Numier"
   },
   {
      "type": "pagination",
      "integration_type": "linode",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "object_type": "compute_instance",
      "pagination": "list_limit",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "pagination",
      "integration_type": "linode",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "object_type": "compute_template",
      "pagination": "list_limit",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "pagination",
      "integration_type": "linode",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "object_type": "compute_volume",
      "pagination": "list_limit",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "pagination",
      "integration_type": "linode",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "object_type": "compute_key",
      "pagination": "list_limit",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "pagination",
      "integration_type": "learnupon",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "list_limit",
      "integration_name": "LearnUpon"
   },
   {
      "type": "pagination",
      "integration_type": "learnupon",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "list_limit",
      "integration_name": "LearnUpon"
   },
   {
      "type": "pagination",
      "integration_type": "learnupon",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_activity",
      "pagination": "list_limit",
      "integration_name": "LearnUpon"
   },
   {
      "type": "pagination",
      "integration_type": "learnupon",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "list_limit",
      "integration_name": "LearnUpon"
   },
   {
      "type": "pagination",
      "integration_type": "learnupon",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "LearnUpon"
   },
   {
      "type": "pagination",
      "integration_type": "lawmatics",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "object_type": "legal_matter",
      "pagination": "list_limit",
      "integration_name": "Lawmatics"
   },
   {
      "type": "pagination",
      "integration_type": "lawmatics",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "object_type": "legal_practicearea",
      "pagination": "list_limit",
      "integration_name": "Lawmatics"
   },
   {
      "type": "pagination",
      "integration_type": "lawmatics",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "object_type": "legal_timeentry",
      "pagination": "list_limit",
      "integration_name": "Lawmatics"
   },
   {
      "type": "pagination",
      "integration_type": "lawmatics",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "object_type": "legal_expense",
      "pagination": "list_limit",
      "integration_name": "Lawmatics"
   },
   {
      "type": "pagination",
      "integration_type": "lawmatics",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Lawmatics"
   },
   {
      "type": "pagination",
      "integration_type": "lawmatics",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_limit",
      "integration_name": "Lawmatics"
   },
   {
      "type": "object",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "pagination",
      "integration_type": "hiboutik",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_limit",
      "integration_name": "Hiboutik"
   },
   {
      "type": "pagination",
      "integration_type": "hiboutik",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_limit",
      "integration_name": "Hiboutik"
   },
   {
      "type": "pagination",
      "integration_type": "hiboutik",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_limit",
      "integration_name": "Hiboutik"
   },
   {
      "type": "pagination",
      "integration_type": "hiboutik",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_limit",
      "integration_name": "Hiboutik"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_cashflow",
      "pagination": "list_limit",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_balancesheet",
      "pagination": "list_limit",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_trialbalance",
      "pagination": "list_limit",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_profitloss",
      "pagination": "list_limit",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "forcemanager",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "ForceManager"
   },
   {
      "type": "pagination",
      "integration_type": "forcemanager",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ForceManager"
   },
   {
      "type": "pagination",
      "integration_type": "forcemanager",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "ForceManager"
   },
   {
      "type": "pagination",
      "integration_type": "forcemanager",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ForceManager"
   },
   {
      "type": "pagination",
      "integration_type": "forcemanager",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_limit",
      "integration_name": "ForceManager"
   },
   {
      "type": "pagination",
      "integration_type": "forcemanager",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ForceManager"
   },
   {
      "type": "pagination",
      "integration_type": "forcemanager",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "ForceManager"
   },
   {
      "type": "pagination",
      "integration_type": "forcemanager",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ForceManager"
   },
   {
      "type": "pagination",
      "integration_type": "docketwise",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "object_type": "legal_matter",
      "pagination": "list_limit",
      "integration_name": "Docketwise"
   },
   {
      "type": "pagination",
      "integration_type": "docketwise",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "object_type": "legal_practicearea",
      "pagination": "list_limit",
      "integration_name": "Docketwise"
   },
   {
      "type": "pagination",
      "integration_type": "docketwise",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Docketwise"
   },
   {
      "type": "pagination",
      "integration_type": "crisp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "kms",
         "martech",
         "analytics",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_limit",
      "integration_name": "Crisp"
   },
   {
      "type": "pagination",
      "integration_type": "crisp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "kms",
         "martech",
         "analytics",
         "hris",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "list_limit",
      "integration_name": "Crisp"
   },
   {
      "type": "pagination",
      "integration_type": "crisp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "kms",
         "martech",
         "analytics",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_category",
      "pagination": "list_limit",
      "integration_name": "Crisp"
   },
   {
      "type": "pagination",
      "integration_type": "crisp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "kms",
         "martech",
         "analytics",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_limit",
      "integration_name": "Crisp"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "list_limit",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_quote",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bankfeedaccount",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bankfeedtransaction",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "axonaut",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "applicantstack",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_limit",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_limit",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "a3erp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_limit",
      "integration_name": "a3ERP"
   },
   {
      "type": "pagination",
      "integration_type": "a3erp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_limit",
      "integration_name": "a3ERP"
   },
   {
      "type": "pagination",
      "integration_type": "a3erp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_limit",
      "integration_name": "a3ERP"
   },
   {
      "type": "pagination",
      "integration_type": "a3erp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_quote",
      "pagination": "list_limit",
      "integration_name": "a3ERP"
   },
   {
      "type": "pagination",
      "integration_type": "a3erp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_limit",
      "integration_name": "a3ERP"
   },
   {
      "type": "pagination",
      "integration_type": "a3erp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_limit",
      "integration_name": "a3ERP"
   },
   {
      "type": "pagination",
      "integration_type": "a3erp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_limit",
      "integration_name": "a3ERP"
   },
   {
      "type": "pagination",
      "integration_type": "a3erp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_limit",
      "integration_name": "a3ERP"
   },
   {
      "type": "pagination",
      "integration_type": "a3erp",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "a3ERP"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "performance_cycle",
      "pagination": "list_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "performance_cycle",
      "pagination": "virtual_webhook_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "performance_review",
      "pagination": "list_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "performance_review",
      "pagination": "virtual_webhook_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "performance_goal",
      "pagination": "list_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "performance_goal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "performance_feedback",
      "pagination": "list_limit",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-15T13:32:37.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "performance_feedback",
      "pagination": "virtual_webhook_limit",
      "integration_name": "15Five"
   },
   {
      "type": "object",
      "created_at": "2026-10-15T10:20:01.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-15T10:20:01.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "hireology",
      "object_type": "ats_applicationstatus",
      "integration_name": "Hireology"
   },
   {
      "type": "method",
      "integration_type": "hireology",
      "created_at": "2026-10-15T10:20:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Hireology"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "younium",
      "integration_name": "Younium"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "calendar",
         "uc",
         "passthrough"
      ],
      "integration_type": "vonagevideo",
      "integration_name": "Vonage Video API"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "upsales",
      "integration_name": "Upsales"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "trybloyalty",
      "integration_name": "TRYB Loyalty"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "tietoevry",
      "integration_name": "TietoEVRY Lifecare"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "symphonymessaging",
      "integration_name": "Symphony Messaging"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "superoffice",
      "integration_name": "SuperOffice"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "crm",
         "martech",
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "sarbacaneengage",
      "integration_name": "Sarbacane Engage"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "poweroffice",
      "integration_name": "PowerOffice"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "payfactory",
      "integration_name": "Payfactory"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "orionhealth",
      "integration_name": "Orion Health"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "mailgun",
      "integration_name": "Mailgun"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ifsapplications",
      "integration_name": "IFS Applications"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "fenerum",
      "integration_name": "Fenerum"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "experiandataquality",
      "integration_name": "Experian Data Quality"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "kms",
         "auth",
         "passthrough"
      ],
      "integration_type": "evernote",
      "integration_name": "Evernote"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "integration_type": "dubble",
      "integration_name": "Dubble"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "messaging",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "drift",
      "integration_name": "Drift"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "doubleverify",
      "integration_name": "DoubleVerify"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "dotpay",
      "integration_name": "Dotpay"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "crm",
         "payment",
         "passthrough"
      ],
      "integration_type": "donorsync",
      "integration_name": "DonorSync"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "docurex",
      "integration_name": "Docurex"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "ticketing",
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "dixa",
      "integration_name": "Dixa"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "discourse",
      "integration_name": "Discourse"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "dimescheduler",
      "integration_name": "Dime.Scheduler"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "deutschlandgpt",
      "integration_name": "DeutschlandGPT"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "detrack",
      "integration_name": "Detrack"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "healthcare",
         "messaging",
         "passthrough"
      ],
      "integration_type": "dentimax",
      "integration_name": "DentiMax"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "dentally",
      "integration_name": "Dentally"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "deliveryhero",
      "integration_name": "Delivery Hero"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "deepsearch",
      "integration_name": "DeepSearch"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "deepgram",
      "integration_name": "Deepgram"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "deepai",
      "integration_name": "DeepAI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "dealpath",
      "integration_name": "Dealpath"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "dayschedule",
      "integration_name": "DaySchedule"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "datfreight",
      "integration_name": "DAT Freight & Analytics"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "datahyena",
      "integration_name": "Datahyena"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "calendar",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "dandelion",
      "integration_name": "Dandelion"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "dana",
      "integration_name": "DANA"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "dalux",
      "integration_name": "Dalux"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "conta",
      "integration_name": "Conta"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "clientify",
      "integration_name": "Clientify"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "bokio",
      "integration_name": "Bokio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "billwerkplus",
      "integration_name": "Billwerk+"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "agoraio",
      "integration_name": "Agora.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "accesspaysuite",
      "integration_name": "Access PaySuite"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "integration_type": "abowire",
      "integration_name": "Abowire"
   },
   {
      "type": "integration",
      "created_at": "2026-10-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "24sevenoffice",
      "integration_name": "24SevenOffice"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "zohobooks",
      "object_type": "accounting_creditmemo",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "zohobooks",
      "object_type": "accounting_project",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_review",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_item",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_contact",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_item",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_contact",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_review",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_item",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_contact",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_parent_id",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_query",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_order",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_sort_by_created_at",
      "integration_name": "WooCommerce"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "integration_type": "woocommerce",
      "object_type": "commerce_review",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "commerce_review",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "tribepad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Tribepad"
   },
   {
      "type": "pagination",
      "integration_type": "tribepad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "Tribepad"
   },
   {
      "type": "pagination",
      "integration_type": "tribepad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Tribepad"
   },
   {
      "type": "method",
      "integration_type": "tribepad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Tribepad"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "servicenow",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "hris_employee",
      "integration_name": "ServiceNow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "servicenow",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "ServiceNow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "servicenow",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "kms_page",
      "integration_name": "ServiceNow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "servicenow",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "kms_space",
      "integration_name": "ServiceNow"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "servicenow",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "hris_employee",
      "integration_name": "ServiceNow"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "servicenow",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "ServiceNow"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "servicenow",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "kms_page",
      "integration_name": "ServiceNow"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "servicenow",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "kms_space",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_updated_gte",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_customer_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_updated_gte",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_space_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "list_updated_gte",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "kms_page",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "kms_space",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ServiceNow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_recording",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_scorecard",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_recording",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_scorecard",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "uc_recording",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "uc_scorecard",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "summary",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "metadata",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_job",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "metadata",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_company",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "metadata",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "education",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "summary",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "metadata",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_job",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "metadata",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_company",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "metadata",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "education",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_project",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_task",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_project",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_task",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "integration_type": "odoo",
      "object_type": "task_project",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "integration_type": "odoo",
      "object_type": "task_task",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "monday",
      "object_type": "task_comment",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "object_type": "hris_device",
      "pagination": "list_query",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "object_type": "hris_device",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "integration_type": "microsoft_ad",
      "object_type": "hris_company",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "method",
      "integration_type": "microsoft_ad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "method",
      "integration_type": "microsoft_ad",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "reply_to_email",
      "integration_name": "Klaviyo"
   },
   {
      "type": "writable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Klaviyo"
   },
   {
      "type": "writable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "from_name",
      "integration_name": "Klaviyo"
   },
   {
      "type": "writable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "from_email",
      "integration_name": "Klaviyo"
   },
   {
      "type": "writable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "reply_to_email",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "list_ids",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "from_name",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "from_email",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_order",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_sort_by_name",
      "integration_name": "Klaviyo"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "pagination",
      "integration_type": "googletasks",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "Google Tasks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "uc",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_recording",
      "integration_name": "Google Meet"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "uc",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_recording",
      "integration_name": "Google Meet"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "calendar",
         "uc",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlemeet",
      "object_type": "uc_recording",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_recording",
      "categories": [
         "calendar",
         "uc",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "uc_recording",
      "categories": [
         "calendar",
         "uc",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Meet"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "integration_type": "googleanalyticsadmin",
      "object_type": "analytics_property",
      "integration_name": "Google Analytics (Admin)"
   },
   {
      "type": "method",
      "integration_type": "googleanalyticsadmin",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Analytics (Admin)"
   },
   {
      "type": "method",
      "integration_type": "googleanalyticsadmin",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Analytics (Admin)"
   },
   {
      "type": "method",
      "integration_type": "googleanalyticsadmin",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Analytics (Admin)"
   },
   {
      "type": "method",
      "integration_type": "googleanalyticsadmin",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Analytics (Admin)"
   },
   {
      "type": "writable_field",
      "integration_type": "googleanalytics",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Google Analytics"
   },
   {
      "type": "writable_field",
      "integration_type": "googleanalytics",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Google Analytics"
   },
   {
      "type": "writable_field",
      "integration_type": "googleanalytics",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Analytics"
   },
   {
      "type": "writable_field",
      "integration_type": "googleanalytics",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Google Analytics"
   },
   {
      "type": "writable_field",
      "integration_type": "googleanalytics",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Google Analytics"
   },
   {
      "type": "method",
      "integration_type": "googleanalytics",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Analytics"
   },
   {
      "type": "method",
      "integration_type": "googleanalytics",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Analytics"
   },
   {
      "type": "writable_field",
      "integration_type": "facebook",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "scheduled_at",
      "integration_name": "Facebook"
   },
   {
      "type": "readable_field",
      "integration_type": "facebook",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Facebook"
   },
   {
      "type": "readable_field",
      "integration_type": "facebook",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "scheduled_at",
      "integration_name": "Facebook"
   },
   {
      "type": "readable_field",
      "integration_type": "facebook",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "phone",
      "integration_name": "Facebook"
   },
   {
      "type": "readable_field",
      "integration_type": "facebook",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "parent_post_id",
      "integration_name": "Facebook"
   },
   {
      "type": "readable_field",
      "integration_type": "facebook",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Facebook"
   },
   {
      "type": "readable_field",
      "integration_type": "facebook",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Facebook"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "docusign",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "signing_template",
      "integration_name": "DocuSign"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "docusign",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "signing_template",
      "integration_name": "DocuSign"
   },
   {
      "type": "readable_field",
      "integration_type": "docusign",
      "created_at": "2026-10-14T17:13:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_updated_gte",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "virtual_webhook_limit",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-10-14T17:13:06.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "DocuSign"
   },
   {
      "type": "writable_field",
      "integration_type": "zoomcalendar",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "zoomcalendar",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "zoomcalendar",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "method",
      "integration_type": "zoomcalendar",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "method",
      "integration_type": "zoomcalendar",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "method",
      "integration_type": "zoomcalendar",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "method",
      "integration_type": "zoomcalendar",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "messaging",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohomail",
      "object_type": "hris_employee",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "messaging",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohomail",
      "object_type": "task_task",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "method",
      "integration_type": "zohomail",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "method",
      "integration_type": "zohomail",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "method",
      "integration_type": "zohomail",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_task",
      "categories": [
         "messaging",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "method",
      "integration_type": "zohomail",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_task",
      "categories": [
         "messaging",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "method",
      "integration_type": "zohomail",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_task",
      "categories": [
         "messaging",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Wealthbox"
   },
   {
      "type": "writable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Wealthbox"
   },
   {
      "type": "writable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Wealthbox"
   },
   {
      "type": "writable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Wealthbox"
   },
   {
      "type": "writable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Wealthbox"
   },
   {
      "type": "writable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Wealthbox"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wealthbox",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_project",
      "integration_name": "Wealthbox"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wealthbox",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_project",
      "integration_name": "Wealthbox"
   },
   {
      "type": "readable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Wealthbox"
   },
   {
      "type": "readable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Wealthbox"
   },
   {
      "type": "readable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_user_id",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Wealthbox"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "wealthbox",
      "object_type": "task_project",
      "integration_name": "Wealthbox"
   },
   {
      "type": "method",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wealthbox"
   },
   {
      "type": "method",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wealthbox"
   },
   {
      "type": "method",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Wealthbox"
   },
   {
      "type": "method",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Wealthbox"
   },
   {
      "type": "method",
      "integration_type": "wealthbox",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "task",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Wealthbox"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Recruitee"
   },
   {
      "type": "pagination",
      "integration_type": "recruitee",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Recruitee"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recruitee",
      "object_type": "metadata_metadata",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruitee"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_job_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Lever"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Humi"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "googleslides",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Slides"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "googleslides",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Slides"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "googleslides",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Slides"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "googlesheets",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Sheets"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "googlesheets",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Sheets"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "googlesheets",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Sheets"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "googledrive",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Drive"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "googledrive",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Drive"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "googledrive",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Drive"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "googledocs",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Docs"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "googledocs",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Docs"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "googledocs",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Docs"
   },
   {
      "type": "writable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Close"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_event",
      "integration_name": "Close"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_event",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_company_id",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_company_id",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "Close"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "closeio",
      "object_type": "crm_event",
      "integration_name": "Close"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "closeio",
      "object_type": "hris_group",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "brex",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Brex"
   },
   {
      "type": "writable_field",
      "integration_type": "brex",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Brex"
   },
   {
      "type": "writable_field",
      "integration_type": "brex",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Brex"
   },
   {
      "type": "writable_field",
      "integration_type": "brex",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Brex"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "azureopenai",
      "object_type": "genai_embedding",
      "integration_name": "Azure OpenAI"
   },
   {
      "type": "method",
      "integration_type": "azureopenai",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Azure OpenAI"
   },
   {
      "type": "writable_field",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage"
      ],
      "field": "type",
      "integration_name": "Amazon S3"
   },
   {
      "type": "writable_field",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage"
      ],
      "field": "parent_id",
      "integration_name": "Amazon S3"
   },
   {
      "type": "writable_field",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage"
      ],
      "field": "name",
      "integration_name": "Amazon S3"
   },
   {
      "type": "writable_field",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage"
      ],
      "field": "mime_type",
      "integration_name": "Amazon S3"
   },
   {
      "type": "writable_field",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage"
      ],
      "field": "data",
      "integration_name": "Amazon S3"
   },
   {
      "type": "pagination",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "storage"
      ],
      "object_type": "storage_file",
      "pagination": "list_offset",
      "integration_name": "Amazon S3"
   },
   {
      "type": "pagination",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "storage"
      ],
      "object_type": "storage_file",
      "pagination": "list_query",
      "integration_name": "Amazon S3"
   },
   {
      "type": "method",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage"
      ],
      "method": "create",
      "integration_name": "Amazon S3"
   },
   {
      "type": "method",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage"
      ],
      "method": "update",
      "integration_name": "Amazon S3"
   },
   {
      "type": "method",
      "integration_type": "awss3",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage"
      ],
      "method": "remove",
      "integration_name": "Amazon S3"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianservicedesk",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "ticketing",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_category_id",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "appleicloud",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_event",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "appleicloud",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_event",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "appleicloud",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "calendar_event",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "pagination",
      "integration_type": "appleicloud",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_calendar_id",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "pagination",
      "integration_type": "appleicloud",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_pipeline_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_pipeline_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_company_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "15Five"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "integration_name": "15Five"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "integration_name": "15Five"
   },
   {
      "type": "readable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "15Five"
   },
   {
      "type": "readable_field",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_user_id",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-10-14T14:48:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "15Five"
   },
   {
      "type": "object",
      "created_at": "2026-10-14T03:36:26.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "calendly",
      "created_at": "2026-10-14T03:36:26.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "field": "calendar_id",
      "integration_name": "Calendly"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "webexcontactcenter",
      "integration_name": "Webex Contact Center"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "vicidial",
      "integration_name": "VICIdial"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "kms",
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "verint",
      "integration_name": "Verint"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "trackdrive",
      "integration_name": "TrackDrive"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "tldcrm",
      "integration_name": "TLDialer"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "messaging",
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "textcom",
      "integration_name": "Text.com"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "tcn",
      "integration_name": "TCN"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "sumble",
      "integration_name": "Sumble"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "regalvoice",
      "integration_name": "Regal Voice"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "mightycall",
      "integration_name": "MightyCall"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "genesyscloud",
      "integration_name": "Genesys Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "framepayments",
      "integration_name": "Frame Payments"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "crm",
         "passthrough"
      ],
      "integration_type": "dialedin",
      "integration_name": "DialedIn"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "crm",
         "passthrough"
      ],
      "integration_type": "convoso",
      "integration_name": "Convoso"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "ciscofinesse",
      "integration_name": "Cisco Finesse"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "calltrackingmetrics",
      "integration_name": "CallTrackingMetrics"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "calltools",
      "integration_name": "CallTools"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "broadworksxsi",
      "integration_name": "BroadWorks XSI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "asterisk",
      "integration_name": "Asterisk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "amazonconnect",
      "integration_name": "Amazon Connect"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_location_id",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "zoomphone",
      "object_type": "uc_contact",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "method",
      "integration_type": "zoomphone",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "method",
      "integration_type": "zoomphone",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "method",
      "integration_type": "zoomphone",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "method",
      "integration_type": "zoomphone",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "method",
      "integration_type": "zoomphone",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Vincere"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "twilio",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Twilio"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "tribepad",
      "object_type": "ats_company",
      "integration_name": "Tribepad"
   },
   {
      "type": "method",
      "integration_type": "tribepad",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Tribepad"
   },
   {
      "type": "method",
      "integration_type": "tribepad",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Tribepad"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sagehr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Sage HR"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "paradox",
      "object_type": "ats_document",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paradox"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "kms_page",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "kms_page",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "space_id",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "kms_page",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "kms_page",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "kms_page",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "googlegemini",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "max_tokens",
      "integration_name": "Google Gemini"
   },
   {
      "type": "readable_field",
      "integration_type": "googlegemini",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "Google Gemini"
   },
   {
      "type": "readable_field",
      "integration_type": "googlegemini",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "Google Gemini"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "integration_type": "googledirectory",
      "object_type": "hris_location",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "integration_type": "googledirectory",
      "object_type": "hris_device",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "method",
      "integration_type": "googledirectory",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Google Contacts"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecontacts",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Google Contacts"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecontacts",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "google",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Google"
   },
   {
      "type": "writable_field",
      "integration_type": "google",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Google"
   },
   {
      "type": "writable_field",
      "integration_type": "google",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Google"
   },
   {
      "type": "writable_field",
      "integration_type": "google",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Google"
   },
   {
      "type": "readable_field",
      "integration_type": "google",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Google"
   },
   {
      "type": "readable_field",
      "integration_type": "google",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Google"
   },
   {
      "type": "writable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "writable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "writable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "method",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "method",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "writable_field",
      "integration_type": "githubapp",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "writable_field",
      "integration_type": "githubapp",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "writable_field",
      "integration_type": "githubapp",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "method",
      "integration_type": "githubapp",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "method",
      "integration_type": "githubapp",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "writable_field",
      "integration_type": "github",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "GitHub"
   },
   {
      "type": "writable_field",
      "integration_type": "github",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "GitHub"
   },
   {
      "type": "writable_field",
      "integration_type": "github",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "GitHub"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "freshdesk"
   },
   {
      "type": "method",
      "integration_type": "freshdesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "freshdesk"
   },
   {
      "type": "method",
      "integration_type": "freshdesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ats_job",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_employee",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "ats_job",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_employee",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "integration_name": "Autodesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_project",
      "integration_name": "Autodesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Autodesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_order",
      "integration_name": "Autodesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Autodesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "integration_name": "Autodesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_project",
      "integration_name": "Autodesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Autodesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_order",
      "integration_name": "Autodesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "autodesk",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Autodesk"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "autodesk",
      "object_type": "task_project",
      "integration_name": "Autodesk"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "autodesk",
      "object_type": "accounting_project",
      "integration_name": "Autodesk"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "autodesk",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Autodesk"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "autodesk",
      "object_type": "accounting_order",
      "integration_name": "Autodesk"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "autodesk",
      "object_type": "hris_timeshift",
      "integration_name": "Autodesk"
   },
   {
      "type": "object",
      "created_at": "2026-10-13T18:29:13.000Z",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "autodesk",
      "object_type": "storage_file",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_project",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_project",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_order",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "accounting_order",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "storage_file",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Autodesk"
   },
   {
      "type": "method",
      "integration_type": "autodesk",
      "created_at": "2026-10-13T18:29:13.000Z",
      "object_type": "storage_file",
      "categories": [
         "auth",
         "task",
         "accounting",
         "storage",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Autodesk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "vultr",
      "integration_name": "Vultr"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "verda",
      "integration_name": "Verda"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "upcloud",
      "integration_name": "UpCloud"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "thrio",
      "integration_name": "Thrio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "passthrough"
      ],
      "integration_type": "talentlynk",
      "integration_name": "TalentLynk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "sangoma",
      "integration_name": "Sangoma"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "integration_type": "quill",
      "integration_name": "Quill"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "task",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "procore",
      "integration_name": "Procore"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "legal",
         "passthrough"
      ],
      "integration_type": "prevail",
      "integration_name": "Prevail"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "opendental",
      "integration_name": "Open Dental"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "integration_type": "netlify",
      "integration_name": "Netlify"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "livevox",
      "integration_name": "LiveVox"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "integration_type": "lawvu",
      "integration_name": "LawVu"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "lambda",
      "integration_name": "Lambda"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "intakeq",
      "integration_name": "IntakeQ"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "hyperstack",
      "integration_name": "Hyperstack"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "healthie",
      "integration_name": "Healthie"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "hris",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "hcss",
      "integration_name": "HCSS"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "foundationsoftware",
      "integration_name": "Foundation Software"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "flyio",
      "integration_name": "Fly.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "exaktime",
      "integration_name": "ExakTime"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "cmic",
      "integration_name": "CMiC"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "civo",
      "integration_name": "Civo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "charmhealth",
      "integration_name": "CharmHealth"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "legal",
         "passthrough"
      ],
      "integration_type": "captorra",
      "integration_name": "Captorra"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "canvasmedical",
      "integration_name": "Canvas Medical"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "legal",
         "passthrough"
      ],
      "integration_type": "brightflag",
      "integration_name": "Brightflag"
   },
   {
      "type": "integration",
      "created_at": "2026-10-13T00:00:00.000Z",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "integration_type": "azurecompute",
      "integration_name": "Azure Virtual Machines"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "zanda",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Zanda"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "zanda",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Zanda"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "zanda",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Zanda"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "zanda",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Zanda"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "zanda",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Zanda"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "integration_type": "xero",
      "object_type": "hris_earning",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "hris_attendance",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "hris_attendance",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wheniwork",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "When I Work"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "wheniwork",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "When I Work"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "wheniwork",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "When I Work"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wheniwork",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "When I Work"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "wheniwork",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "When I Work"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "wheniwork",
      "object_type": "hris_attendance",
      "integration_name": "When I Work"
   },
   {
      "type": "method",
      "integration_type": "wheniwork",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "When I Work"
   },
   {
      "type": "method",
      "integration_type": "wheniwork",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "When I Work"
   },
   {
      "type": "method",
      "integration_type": "wheniwork",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "When I Work"
   },
   {
      "type": "method",
      "integration_type": "wheniwork",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "When I Work"
   },
   {
      "type": "method",
      "integration_type": "wheniwork",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "When I Work"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "wellskypersonalcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "WellSky Personal Care"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "wellskypersonalcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "WellSky Personal Care"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "wellskypersonalcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "WellSky Personal Care"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "wellskypersonalcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "WellSky Personal Care"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "wellskypersonalcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "WellSky Personal Care"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "wellskypersonalcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "WellSky Personal Care"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "wellskypersonalcare",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "WellSky Personal Care"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "vercelsandbox",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vercel Sandbox"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "vercelsandbox",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vercel Sandbox"
   },
   {
      "type": "object",
      "object_type": "compute_snapshot",
      "integration_type": "vercelsandbox",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vercel Sandbox"
   },
   {
      "type": "object",
      "object_type": "compute_usage",
      "integration_type": "vercelsandbox",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vercel Sandbox"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "vercel",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_service",
      "integration_name": "Vercel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "vercel",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_service",
      "integration_name": "Vercel"
   },
   {
      "type": "object",
      "object_type": "compute_service",
      "integration_type": "vercel",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vercel"
   },
   {
      "type": "object",
      "object_type": "compute_deployment",
      "integration_type": "vercel",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vercel"
   },
   {
      "type": "object",
      "object_type": "compute_domain",
      "integration_type": "vercel",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vercel"
   },
   {
      "type": "object",
      "object_type": "compute_envvar",
      "integration_type": "vercel",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_service",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "list",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_service",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "get",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_service",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "create",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_service",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "update",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_service",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "remove",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_deployment",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "list",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_deployment",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "get",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_deployment",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "update",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_deployment",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "remove",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_domain",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "list",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_domain",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "get",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_domain",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "create",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_domain",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "update",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_domain",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "remove",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_envvar",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "list",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_envvar",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "get",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_envvar",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "create",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_envvar",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "update",
      "integration_name": "Vercel"
   },
   {
      "type": "method",
      "integration_type": "vercel",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_envvar",
      "categories": [
         "auth",
         "passthrough",
         "compute"
      ],
      "method": "remove",
      "integration_name": "Vercel"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "veradigm",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Veradigm"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "vastai",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vast.ai"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "vastai",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vast.ai"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "vastai",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vast.ai"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "vastai",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vast.ai"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "vastai",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vast.ai"
   },
   {
      "type": "object",
      "object_type": "compute_usage",
      "integration_type": "vastai",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Vast.ai"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "tsheets",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "QuickBooks Time"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "tsheets",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "QuickBooks Time"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "tsheets",
      "object_type": "hris_attendance",
      "integration_name": "QuickBooks Time"
   },
   {
      "type": "method",
      "integration_type": "tsheets",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks Time"
   },
   {
      "type": "method",
      "integration_type": "tsheets",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks Time"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "trubridge",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TruBridge"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "timesolv",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TimeSolv"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "timesolv",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TimeSolv"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "timesolv",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TimeSolv"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "telushealthchr",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "tebra",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Tebra"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "tebra",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Tebra"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "tebra",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Tebra"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "tebra",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Tebra"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "smokeball",
      "categories": [
         "legal",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Smokeball"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "smokeball",
      "categories": [
         "legal",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Smokeball"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "smokeball",
      "categories": [
         "legal",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Smokeball"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "smokeball",
      "categories": [
         "legal",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Smokeball"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "smartonfhir",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "smartadvocate",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SmartAdvocate"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "smartadvocate",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SmartAdvocate"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "smartadvocate",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SmartAdvocate"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "smartadvocate",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SmartAdvocate"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "sfcompute",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SF Compute"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "sfcompute",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SF Compute"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "sfcompute",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SF Compute"
   },
   {
      "type": "object",
      "object_type": "compute_usage",
      "integration_type": "sfcompute",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "SF Compute"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "semble",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Semble"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "semble",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Semble"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "semble",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Semble"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "semble",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Semble"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "semble",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Semble"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "scaleway",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Scaleway"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "scaleway",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Scaleway"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "scaleway",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Scaleway"
   },
   {
      "type": "object",
      "object_type": "compute_snapshot",
      "integration_type": "scaleway",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Scaleway"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "scaleway",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Scaleway"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "scaleway",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Scaleway"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "uc",
         "martech",
         "hris",
         "passthrough"
      ],
      "integration_type": "salesfinity",
      "object_type": "uc_scorecard",
      "integration_name": "Salesfinity"
   },
   {
      "type": "method",
      "integration_type": "salesfinity",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "uc",
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesfinity"
   },
   {
      "type": "method",
      "integration_type": "salesfinity",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "uc",
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesfinity"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "runpod",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "RunPod"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "runpod",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "RunPod"
   },
   {
      "type": "object",
      "object_type": "compute_region",
      "integration_type": "runpod",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "RunPod"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "runpod",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "RunPod"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "runpod",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "RunPod"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "runpod",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "RunPod"
   },
   {
      "type": "object",
      "object_type": "compute_usage",
      "integration_type": "runpod",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "RunPod"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "runloop",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Runloop"
   },
   {
      "type": "object",
      "object_type": "compute_snapshot",
      "integration_type": "runloop",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Runloop"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "runloop",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Runloop"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "runloop",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Runloop"
   },
   {
      "type": "object",
      "object_type": "compute_usage",
      "integration_type": "runloop",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Runloop"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "revelsystems",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Revel Systems"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "revelsystems",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Revel Systems"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "integration_type": "revelsystems",
      "object_type": "hris_attendance",
      "integration_name": "Revel Systems"
   },
   {
      "type": "method",
      "integration_type": "revelsystems",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Revel Systems"
   },
   {
      "type": "method",
      "integration_type": "revelsystems",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Revel Systems"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "render",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Render"
   },
   {
      "type": "object",
      "object_type": "compute_service",
      "integration_type": "render",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Render"
   },
   {
      "type": "object",
      "object_type": "compute_deployment",
      "integration_type": "render",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Render"
   },
   {
      "type": "object",
      "object_type": "compute_domain",
      "integration_type": "render",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Render"
   },
   {
      "type": "object",
      "object_type": "compute_envvar",
      "integration_type": "render",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Render"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooksworkforce",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "QuickBooks Workforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooksworkforce",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "QuickBooks Workforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "quickbooksworkforce",
      "object_type": "hris_attendance",
      "integration_name": "QuickBooks Workforce"
   },
   {
      "type": "method",
      "integration_type": "quickbooksworkforce",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks Workforce"
   },
   {
      "type": "method",
      "integration_type": "quickbooksworkforce",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks Workforce"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "practicepanther",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "PracticePanther"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "practicepanther",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "PracticePanther"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "practicepanther",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "PracticePanther"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "analytics",
         "hris",
         "passthrough"
      ],
      "integration_type": "powerbi",
      "object_type": "analytics_event",
      "integration_name": "Microsoft Power BI"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "analytics",
         "hris",
         "passthrough"
      ],
      "integration_type": "powerbi",
      "object_type": "analytics_property",
      "integration_name": "Microsoft Power BI"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "analytics",
         "hris",
         "passthrough"
      ],
      "integration_type": "powerbi",
      "object_type": "analytics_visitor",
      "integration_name": "Microsoft Power BI"
   },
   {
      "type": "method",
      "integration_type": "powerbi",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Power BI"
   },
   {
      "type": "method",
      "integration_type": "powerbi",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Power BI"
   },
   {
      "type": "method",
      "integration_type": "powerbi",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Power BI"
   },
   {
      "type": "readable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "PeopleHR"
   },
   {
      "type": "readable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "PeopleHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "payspace",
      "object_type": "hris_earning",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Payspace"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Outreach.io"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "passthrough"
      ],
      "integration_type": "outreach",
      "object_type": "calendar_recording",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "crm",
         "hris",
         "uc",
         "calendar",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Outreach.io"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "oraclehealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Oracle Health"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "nooks",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "integration_name": "Nooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "nooks",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "integration_name": "Nooks"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "nooks",
      "object_type": "uc_scorecard",
      "integration_name": "Nooks"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "nooks",
      "object_type": "uc_scorecardtemplate",
      "integration_name": "Nooks"
   },
   {
      "type": "method",
      "integration_type": "nooks",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Nooks"
   },
   {
      "type": "method",
      "integration_type": "nooks",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Nooks"
   },
   {
      "type": "method",
      "integration_type": "nooks",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecardtemplate",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Nooks"
   },
   {
      "type": "method",
      "integration_type": "nooks",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecardtemplate",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Nooks"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "nibelis",
      "object_type": "hris_attendance",
      "integration_name": "Nibelis"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "nibelis",
      "object_type": "hris_earning",
      "integration_name": "Nibelis"
   },
   {
      "type": "method",
      "integration_type": "nibelis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Nibelis"
   },
   {
      "type": "method",
      "integration_type": "nibelis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Nibelis"
   },
   {
      "type": "method",
      "integration_type": "nibelis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Nibelis"
   },
   {
      "type": "method",
      "integration_type": "nibelis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Nibelis"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "nextgen",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "netsmart",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Netsmart"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "netsmart",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Netsmart"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "netsmart",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Netsmart"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "netsmart",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Netsmart"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "netsmart",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Netsmart"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "netsmart",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Netsmart"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "netsmart",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Netsmart"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "netsmart",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Netsmart"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "netsmart",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Netsmart"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "nebius",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Nebius AI Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "nebius",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Nebius AI Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "nebius",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Nebius AI Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "nebius",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Nebius AI Cloud"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "mycase",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MyCase"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "mycase",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MyCase"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "mycase",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MyCase"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "mycase",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MyCase"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "modmed",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "ModMed"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "modmed",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "ModMed"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "modmed",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "ModMed"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "modmed",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "ModMed"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "modmed",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "ModMed"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "modmed",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "ModMed"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "modmed",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "ModMed"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "modmed",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "ModMed"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "modmed",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "ModMed"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscontactcenter",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscontactcenter",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecardtemplate",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscontactcenter",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscontactcenter",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecardtemplate",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicscontactcenter",
      "object_type": "uc_scorecard",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicscontactcenter",
      "object_type": "uc_scorecardtemplate",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscontactcenter",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscontactcenter",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscontactcenter",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecardtemplate",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscontactcenter",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecardtemplate",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "medtech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "meditech",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "MEDITECH"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "linode",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "linode",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "object",
      "object_type": "compute_region",
      "integration_type": "linode",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "linode",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "linode",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "linode",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "leap",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "LEAP"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "leap",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "LEAP"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "leap",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "LEAP"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "leap",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "LEAP"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "lawmatics",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Lawmatics"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "lawmatics",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Lawmatics"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "lawmatics",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Lawmatics"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "lawmatics",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Lawmatics"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "lawcus",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Lawcus"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "lawcus",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Lawcus"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "lawcus",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Lawcus"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "lawcus",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Lawcus"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "ats",
         "accounting",
         "passthrough"
      ],
      "integration_type": "hrworks",
      "object_type": "hris_earning",
      "integration_name": "HR WORKS"
   },
   {
      "type": "method",
      "integration_type": "hrworks",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HR WORKS"
   },
   {
      "type": "method",
      "integration_type": "hrworks",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HR WORKS"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "hetznercloud",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Hetzner Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "hetznercloud",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Hetzner Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_region",
      "integration_type": "hetznercloud",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Hetzner Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "hetznercloud",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Hetzner Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_snapshot",
      "integration_type": "hetznercloud",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Hetzner Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "hetznercloud",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Hetzner Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "hetznercloud",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Hetzner Cloud"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "halaxy",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Halaxy"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "halaxy",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Halaxy"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "halaxy",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Halaxy"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "halaxy",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Halaxy"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "halaxy",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Halaxy"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "greenway",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "greenway",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "greenway",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "greenway",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "greenway",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "greenway",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "greenway",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "greenway",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "greenway",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Greenway Health"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "greenshades",
      "object_type": "hris_earning",
      "integration_name": "Greenshades"
   },
   {
      "type": "method",
      "integration_type": "greenshades",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Greenshades"
   },
   {
      "type": "method",
      "integration_type": "greenshades",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Greenshades"
   },
   {
      "type": "method",
      "integration_type": "greenshades",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Greenshades"
   },
   {
      "type": "method",
      "integration_type": "greenshades",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Greenshades"
   },
   {
      "type": "method",
      "integration_type": "greenshades",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Greenshades"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "gentu",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Gentu"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "gentu",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Gentu"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "gentu",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Gentu"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "gentu",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Gentu"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "gentu",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Gentu"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "filevine",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Filevine"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "filevine",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Filevine"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "filevine",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Filevine"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "filevine",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Filevine"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "epic",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Epic"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "emis",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "EMIS"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "emis",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "EMIS"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "emis",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "EMIS"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "emis",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "EMIS"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "emis",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "EMIS"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "emis",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "EMIS"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "elation",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Elation Health"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "e2b",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "E2B"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "e2b",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "E2B"
   },
   {
      "type": "object",
      "object_type": "compute_snapshot",
      "integration_type": "e2b",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "E2B"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "e2b",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "E2B"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "e2b",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "E2B"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "drchrono",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DrChrono"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "docplanner",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Docplanner"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "docplanner",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Docplanner"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "docplanner",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Docplanner"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "docplanner",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Docplanner"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "docketwise",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Docketwise"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "docketwise",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Docketwise"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "digitalocean",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "digitalocean",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "object",
      "object_type": "compute_region",
      "integration_type": "digitalocean",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "digitalocean",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "object",
      "object_type": "compute_snapshot",
      "integration_type": "digitalocean",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "digitalocean",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "digitalocean",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_instance",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_instance",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_instance",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_instance",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_instance",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_template",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_template",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_template",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_template",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_gputype",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_region",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_volume",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_volume",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_volume",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_volume",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_volume",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_snapshot",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_snapshot",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_snapshot",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_key",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_key",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_key",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_key",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "method",
      "integration_type": "digitalocean",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "compute_key",
      "categories": [
         "auth",
         "compute",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dialpad",
      "object_type": "uc_scorecardtemplate",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecardtemplate",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecardtemplate",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "daytona",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Daytona"
   },
   {
      "type": "object",
      "object_type": "compute_region",
      "integration_type": "daytona",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Daytona"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "daytona",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Daytona"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "daytona",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Daytona"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "daytona",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Daytona"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "crusoe",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Crusoe Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "crusoe",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Crusoe Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_region",
      "integration_type": "crusoe",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Crusoe Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "crusoe",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Crusoe Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "crusoe",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Crusoe Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "crusoe",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Crusoe Cloud"
   },
   {
      "type": "object",
      "object_type": "compute_usage",
      "integration_type": "crusoe",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Crusoe Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "calendar_event",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "matter_id",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_practicearea",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_practicearea",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "integration_name": "Clio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "integration_name": "Clio"
   },
   {
      "type": "readable_field",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "calendar_event",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "matter_id",
      "integration_name": "Clio"
   },
   {
      "type": "pagination",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_matter_id",
      "integration_name": "Clio"
   },
   {
      "type": "pagination",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_matter_id",
      "integration_name": "Clio"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Clio"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Clio"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Clio"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "clio",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_matter",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_practicearea",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_practicearea",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_practicearea",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_practicearea",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_practicearea",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_timeentry",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clio"
   },
   {
      "type": "method",
      "integration_type": "clio",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "legal_expense",
      "categories": [
         "legal",
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clio"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "cliniko",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cliniko"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "cliniko",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cliniko"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "cliniko",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cliniko"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "cliniko",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cliniko"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "cliniko",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cliniko"
   },
   {
      "type": "object",
      "object_type": "healthcare_slot",
      "integration_type": "cliniko",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cliniko"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "cezannehr",
      "object_type": "hris_earning",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "method",
      "integration_type": "cezannehr",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "method",
      "integration_type": "cezannehr",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "method",
      "integration_type": "cezannehr",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "method",
      "integration_type": "cezannehr",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "casepeer",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "CASEpeer"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "casepeer",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "CASEpeer"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "cambio",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cambio"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "cambio",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cambio"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "cambio",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cambio"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "cambio",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cambio"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "cambio",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cambio"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "cambio",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cambio"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "cambio",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Cambio"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "object_type": "compute_instance",
      "integration_type": "awsec2",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AWS EC2"
   },
   {
      "type": "object",
      "object_type": "compute_gputype",
      "integration_type": "awsec2",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AWS EC2"
   },
   {
      "type": "object",
      "object_type": "compute_region",
      "integration_type": "awsec2",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AWS EC2"
   },
   {
      "type": "object",
      "object_type": "compute_volume",
      "integration_type": "awsec2",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AWS EC2"
   },
   {
      "type": "object",
      "object_type": "compute_snapshot",
      "integration_type": "awsec2",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AWS EC2"
   },
   {
      "type": "object",
      "object_type": "compute_template",
      "integration_type": "awsec2",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AWS EC2"
   },
   {
      "type": "object",
      "object_type": "compute_key",
      "integration_type": "awsec2",
      "categories": [
         "compute",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AWS EC2"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "object",
      "object_type": "healthcare_appointment",
      "integration_type": "athenahealth",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "athenahealth"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "alexis",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Alexis"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "alexis",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Alexis"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "alexis",
      "object_type": "hris_earning",
      "integration_name": "Alexis"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "alexis",
      "object_type": "hris_attendance",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Alexis"
   },
   {
      "type": "object",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "aircall",
      "object_type": "uc_scorecard",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AirCall.io"
   },
   {
      "type": "object",
      "object_type": "healthcare_patient",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_practitioner",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_location",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_encounter",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_condition",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_allergy",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_medication",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_observation",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "healthcare_immunization",
      "integration_type": "advancedmd",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "object",
      "object_type": "legal_matter",
      "integration_type": "actionstep",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Actionstep"
   },
   {
      "type": "object",
      "object_type": "legal_practicearea",
      "integration_type": "actionstep",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Actionstep"
   },
   {
      "type": "object",
      "object_type": "legal_timeentry",
      "integration_type": "actionstep",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Actionstep"
   },
   {
      "type": "object",
      "object_type": "legal_expense",
      "integration_type": "actionstep",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-12T10:12:42.000Z",
      "integration_name": "Actionstep"
   },
   {
      "type": "readable_field",
      "integration_type": "3cx",
      "created_at": "2026-10-12T10:12:42.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_start_gte",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_end_lt",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-10-12T10:12:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "3CX"
   },
   {
      "type": "integration",
      "created_at": "2026-10-12T00:00:00.000Z",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "integration_type": "rocketmatter",
      "integration_name": "Rocket Matter"
   },
   {
      "type": "integration",
      "created_at": "2026-10-12T00:00:00.000Z",
      "categories": [
         "legal",
         "passthrough"
      ],
      "integration_type": "lawruler",
      "integration_name": "Law Ruler"
   },
   {
      "type": "integration",
      "created_at": "2026-10-12T00:00:00.000Z",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "integration_type": "elite3e",
      "integration_name": "Elite 3E"
   },
   {
      "type": "integration",
      "created_at": "2026-10-12T00:00:00.000Z",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "integration_type": "centerbase",
      "integration_name": "Centerbase"
   },
   {
      "type": "integration",
      "created_at": "2026-10-12T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "carta",
      "integration_name": "Carta"
   },
   {
      "type": "integration",
      "created_at": "2026-10-12T00:00:00.000Z",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "integration_type": "bill4time",
      "integration_name": "Bill4Time"
   },
   {
      "type": "integration",
      "created_at": "2026-10-11T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "integration_type": "tallyprime",
      "integration_name": "TallyPrime"
   },
   {
      "type": "integration",
      "created_at": "2026-10-11T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "calendar",
         "kms",
         "auth",
         "passthrough"
      ],
      "integration_type": "macro",
      "integration_name": "Macro"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "zanda",
      "integration_name": "Zanda"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "martech",
         "metadata",
         "passthrough"
      ],
      "integration_type": "windsor",
      "integration_name": "Windsor.ai"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "wellskypersonalcare",
      "integration_name": "WellSky Personal Care"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "vercelsandbox",
      "integration_name": "Vercel Sandbox"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "veradigm",
      "integration_name": "Veradigm"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "vastai",
      "integration_name": "Vast.ai"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "uploadpost",
      "integration_name": "Upload-Post"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "trubridge",
      "integration_name": "TruBridge"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "integration_type": "timesolv",
      "integration_name": "TimeSolv"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "timecamp",
      "integration_name": "TimeCamp"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "telushealthchr",
      "integration_name": "TELUS Health CHR"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "tebra",
      "integration_name": "Tebra"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "teamwork",
      "integration_name": "Teamwork"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "teamcamp",
      "integration_name": "Teamcamp"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "integration_type": "statsig",
      "integration_name": "Statsig"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "smokeball",
      "integration_name": "Smokeball"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "smartonfhir",
      "integration_name": "SMART on FHIR"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "integration_type": "smartadvocate",
      "integration_name": "SmartAdvocate"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "simpleanalytics",
      "integration_name": "Simple Analytics"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "sfcompute",
      "integration_name": "SF Compute"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "servicetitan",
      "integration_name": "ServiceTitan"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "semble",
      "integration_name": "Semble"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "scaleway",
      "integration_name": "Scaleway"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "runpod",
      "integration_name": "RunPod"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "runloop",
      "integration_name": "Runloop"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "rudderstack",
      "integration_name": "RudderStack"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "rocketlane",
      "integration_name": "Rocketlane"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "render",
      "integration_name": "Render"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "ads",
         "commerce",
         "passthrough"
      ],
      "integration_type": "rakutenadvertising",
      "integration_name": "Rakuten Advertising"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "projectbubble",
      "integration_name": "ProProfs Project"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "processstreet",
      "integration_name": "Process Street"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "practicepanther",
      "integration_name": "PracticePanther"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "social",
         "martech",
         "passthrough"
      ],
      "integration_type": "postpone",
      "integration_name": "Postpone"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "postiz",
      "integration_name": "Postiz"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "plausible",
      "integration_name": "Plausible Analytics"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "integration_type": "planly",
      "integration_name": "Planly"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "oraclehealth",
      "integration_name": "Oracle Health"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "onlysocial",
      "integration_name": "OnlySocial"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "oneupapp",
      "integration_name": "OneUp Social"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "nozbeteams",
      "integration_name": "Nozbe Teams"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "nextgen",
      "integration_name": "NextGen Healthcare"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "netsmart",
      "integration_name": "Netsmart"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "nebius",
      "integration_name": "Nebius AI Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "mycase",
      "integration_name": "MyCase"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "modmed",
      "integration_name": "ModMed"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "medtech",
      "integration_name": "Medtech ALEX"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "meditech",
      "integration_name": "MEDITECH"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "maintainx",
      "integration_name": "MaintainX"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "magnetic",
      "integration_name": "Magnetic"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "integration_type": "lookerstudio",
      "integration_name": "Looker Studio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "livesession",
      "integration_name": "LiveSession"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "linode",
      "integration_name": "Linode (Akamai)"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "leiga",
      "integration_name": "Leiga"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "integration_type": "leap",
      "integration_name": "LEAP"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "calendar",
         "passthrough"
      ],
      "integration_type": "lawmatics",
      "integration_name": "Lawmatics"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "integration_type": "lawcus",
      "integration_name": "Lawcus"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "hris",
         "passthrough"
      ],
      "integration_type": "klipfolio",
      "integration_name": "Klipfolio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "keenio",
      "integration_name": "Keen.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "kanbanize",
      "integration_name": "Kanbanize"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "itmplatform",
      "integration_name": "ITM Platform"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "hrpartner",
      "integration_name": "HR Partner"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "hris",
         "passthrough"
      ],
      "integration_type": "hex",
      "integration_name": "Hex"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "hetznercloud",
      "integration_name": "Hetzner Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "halaxy",
      "integration_name": "Halaxy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "greenway",
      "integration_name": "Greenway Health"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "gosquared",
      "integration_name": "GoSquared"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "integration_type": "googlesearchconsole",
      "integration_name": "Google Search Console"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "gentu",
      "integration_name": "Gentu"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "fullstory",
      "integration_name": "FullStory"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "integration_type": "filevine",
      "integration_name": "Filevine"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "fibery",
      "integration_name": "Fibery"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "epic",
      "integration_name": "Epic"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "emis",
      "integration_name": "EMIS"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "elation",
      "integration_name": "Elation Health"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "passthrough"
      ],
      "integration_type": "edworking",
      "integration_name": "Edworking"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "e2b",
      "integration_name": "E2B"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "drchrono",
      "integration_name": "DrChrono"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "docplanner",
      "integration_name": "Docplanner"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "integration_type": "docketwise",
      "integration_name": "Docketwise"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "desktime",
      "integration_name": "DeskTime"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "daytona",
      "integration_name": "Daytona"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "integration_type": "databox",
      "integration_name": "Databox"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "dart",
      "integration_name": "Dart"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "crusoe",
      "integration_name": "Crusoe Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "contentstudio",
      "integration_name": "ContentStudio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "clockify",
      "integration_name": "Clockify"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "cliniko",
      "integration_name": "Cliniko"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "chartmogul",
      "integration_name": "ChartMogul"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "hris",
         "passthrough"
      ],
      "integration_type": "casepeer",
      "integration_name": "CASEpeer"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "canny",
      "integration_name": "Canny"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "cambio",
      "integration_name": "Cambio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "bulkpublish",
      "integration_name": "BulkPublish"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "martech",
         "social",
         "auth",
         "passthrough"
      ],
      "integration_type": "buffer",
      "integration_name": "Buffer"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "breeze",
      "integration_name": "Breeze"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "integration_type": "bingwebmastertools",
      "integration_name": "Bing Webmaster Tools"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "crm",
         "passthrough"
      ],
      "integration_type": "baselinker",
      "integration_name": "BaseLinker"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "basecamp",
      "integration_name": "Basecamp"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "analytics",
         "payment",
         "passthrough"
      ],
      "integration_type": "baremetrics",
      "integration_name": "Baremetrics"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "integration_type": "ayrshare",
      "integration_name": "Ayrshare"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "compute",
         "passthrough"
      ],
      "integration_type": "awsec2",
      "integration_name": "AWS EC2"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "athenahealth",
      "integration_name": "athenahealth"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "commerce",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "apaleo",
      "integration_name": "Apaleo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "amazingmarvin",
      "integration_name": "Amazing Marvin"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "healthcare",
         "passthrough"
      ],
      "integration_type": "advancedmd",
      "integration_name": "AdvancedMD"
   },
   {
      "type": "integration",
      "created_at": "2026-10-10T00:00:00.000Z",
      "categories": [
         "legal",
         "auth",
         "passthrough"
      ],
      "integration_type": "actionstep",
      "integration_name": "Actionstep"
   },
   {
      "type": "object",
      "created_at": "2026-10-09T16:28:31.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "hris_earning",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-10-09T16:28:31.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-10-09T16:28:31.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "hris_earning",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_earning",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "is_unread",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_company",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_company",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_company",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "created_at": "2026-10-09T16:28:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "object_type": "accounting_taxrate",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-10-09T16:28:31.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "JobDiva"
   },
   {
      "type": "object",
      "created_at": "2026-10-09T16:28:31.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "homerun",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Homerun"
   },
   {
      "type": "readable_field",
      "integration_type": "homerun",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Homerun"
   },
   {
      "type": "pagination",
      "integration_type": "homerun",
      "created_at": "2026-10-09T16:28:31.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Homerun"
   },
   {
      "type": "object",
      "object_type": "uc_scorecard",
      "integration_type": "gong",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "integration_name": "Gong"
   },
   {
      "type": "object",
      "object_type": "uc_scorecardtemplate",
      "integration_type": "gong",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "integration_name": "Gong"
   },
   {
      "type": "method",
      "integration_type": "gong",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gong"
   },
   {
      "type": "method",
      "integration_type": "gong",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "uc_scorecardtemplate",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "erecruiter",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "eRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "erecruiter",
      "created_at": "2026-10-09T16:28:31.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "eRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bite",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "BITE"
   },
   {
      "type": "pagination",
      "integration_type": "bite",
      "created_at": "2026-10-09T16:28:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "BITE"
   },
   {
      "type": "object",
      "object_type": "uc_scorecard",
      "integration_type": "avoma",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "integration_name": "Avoma"
   },
   {
      "type": "object",
      "object_type": "uc_scorecardtemplate",
      "integration_type": "avoma",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-09T16:28:31.000Z",
      "integration_name": "Avoma"
   },
   {
      "type": "method",
      "integration_type": "avoma",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "uc_scorecard",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Avoma"
   },
   {
      "type": "method",
      "integration_type": "avoma",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "uc_scorecardtemplate",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Avoma"
   },
   {
      "type": "method",
      "integration_type": "avoma",
      "created_at": "2026-10-09T16:28:31.000Z",
      "object_type": "uc_scorecardtemplate",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Avoma"
   },
   {
      "type": "object",
      "created_at": "2026-10-09T12:45:15.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "proliant",
      "object_type": "hris_earning",
      "integration_name": "Proliant"
   },
   {
      "type": "method",
      "integration_type": "proliant",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Proliant"
   },
   {
      "type": "method",
      "integration_type": "proliant",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Proliant"
   },
   {
      "type": "method",
      "integration_type": "proliant",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Proliant"
   },
   {
      "type": "method",
      "integration_type": "proliant",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Proliant"
   },
   {
      "type": "method",
      "integration_type": "proliant",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Proliant"
   },
   {
      "type": "object",
      "created_at": "2026-10-09T12:45:15.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "oysterhr",
      "object_type": "hris_earning",
      "integration_name": "Oyster HR"
   },
   {
      "type": "method",
      "integration_type": "oysterhr",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oyster HR"
   },
   {
      "type": "method",
      "integration_type": "oysterhr",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oyster HR"
   },
   {
      "type": "method",
      "integration_type": "oysterhr",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oyster HR"
   },
   {
      "type": "method",
      "integration_type": "oysterhr",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oyster HR"
   },
   {
      "type": "method",
      "integration_type": "oysterhr",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oyster HR"
   },
   {
      "type": "readable_field",
      "integration_type": "onlyfy",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "onlyfy"
   },
   {
      "type": "pagination",
      "integration_type": "onlyfy",
      "created_at": "2026-10-09T12:45:15.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "onlyfy"
   },
   {
      "type": "readable_field",
      "integration_type": "journeyfront",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Journeyfront"
   },
   {
      "type": "pagination",
      "integration_type": "journeyfront",
      "created_at": "2026-10-09T12:45:15.000Z",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Journeyfront"
   },
   {
      "type": "object",
      "created_at": "2026-10-09T12:45:15.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Apploi"
   },
   {
      "type": "writable_field",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Apploi"
   },
   {
      "type": "writable_field",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Apploi"
   },
   {
      "type": "writable_field",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Apploi"
   },
   {
      "type": "writable_field",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Apploi"
   },
   {
      "type": "writable_field",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Apploi"
   },
   {
      "type": "readable_field",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Apploi"
   },
   {
      "type": "object",
      "created_at": "2026-10-09T12:45:15.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "apploi",
      "object_type": "ats_document",
      "integration_name": "Apploi"
   },
   {
      "type": "object",
      "created_at": "2026-10-09T12:45:15.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "apploi",
      "object_type": "ats_interview",
      "integration_name": "Apploi"
   },
   {
      "type": "method",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Apploi"
   },
   {
      "type": "method",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apploi"
   },
   {
      "type": "method",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Apploi"
   },
   {
      "type": "method",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Apploi"
   },
   {
      "type": "method",
      "integration_type": "apploi",
      "created_at": "2026-10-09T12:45:15.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Apploi"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "worksnaps",
      "integration_name": "Worksnaps"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "whop",
      "integration_name": "Whop"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "ticktick",
      "integration_name": "TickTick"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "talenthr",
      "integration_name": "TalentHR"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "slite",
      "integration_name": "Slite"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "signing",
         "hris",
         "passthrough"
      ],
      "integration_type": "signwell",
      "integration_name": "SignWell"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "shipengine",
      "integration_name": "ShipEngine"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "refiner",
      "integration_name": "Refiner"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "payhere",
      "integration_name": "PayHere"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "commerce",
         "shipping",
         "accounting",
         "passthrough"
      ],
      "integration_type": "orderdesk",
      "integration_name": "Order Desk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "onlyofficedocspace",
      "integration_name": "ONLYOFFICE DocSpace"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "neetoform",
      "integration_name": "NeetoForm"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "moltsets",
      "integration_name": "MoltSets"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "kms",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftonenote",
      "integration_name": "Microsoft OneNote"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "membervault",
      "integration_name": "MemberVault"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "memberspot",
      "integration_name": "Memberspot"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "integration_type": "mem",
      "integration_name": "Mem"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "lodgify",
      "integration_name": "Lodgify"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "kobotoolbox",
      "integration_name": "KoboToolbox"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "iterate",
      "integration_name": "Iterate"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "icebergdb",
      "integration_name": "Iceberg Database"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "kms",
         "auth",
         "passthrough"
      ],
      "integration_type": "hackmd",
      "integration_name": "HackMD"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "gelato",
      "integration_name": "Gelato"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "formdesk",
      "integration_name": "Formdesk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "flexisign",
      "integration_name": "FlexiSign"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "fillout",
      "integration_name": "Fillout"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "feathery",
      "integration_name": "Feathery"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "endorsal",
      "integration_name": "Endorsal"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "dpd",
      "integration_name": "DPD"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "commcare",
      "integration_name": "CommCare"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "claricopilot",
      "integration_name": "Clari Copilot"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "chorus",
      "integration_name": "Chorus"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "cabinpanda",
      "integration_name": "CabinPanda"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "btcpayserver",
      "integration_name": "BTCPay Server"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "booqable",
      "integration_name": "Booqable"
   },
   {
      "type": "integration",
      "created_at": "2026-10-09T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "boloforms",
      "integration_name": "BoloForms"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "object_type": "hris_job",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-08T19:56:17.000Z",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_job",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_job",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "object_type": "hris_earning",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-08T19:56:17.000Z",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "object_type": "hris_earning",
      "integration_type": "remote",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-08T19:56:17.000Z",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Remote.com"
   },
   {
      "type": "object",
      "object_type": "hris_earning",
      "integration_type": "paylocity",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-08T19:56:17.000Z",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "object_type": "hris_earning",
      "integration_type": "paycor",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-08T19:56:17.000Z",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "object_type": "hris_earning",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-08T19:56:17.000Z",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paychex"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T19:56:17.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "object_type": "hris_earning",
      "integration_type": "employmentheropayroll",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-08T19:56:17.000Z",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "object",
      "object_type": "hris_earning",
      "integration_type": "checkhq",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-08T19:56:17.000Z",
      "integration_name": "Check"
   },
   {
      "type": "method",
      "integration_type": "checkhq",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Check"
   },
   {
      "type": "method",
      "integration_type": "checkhq",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Check"
   },
   {
      "type": "method",
      "integration_type": "checkhq",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Check"
   },
   {
      "type": "method",
      "integration_type": "checkhq",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Check"
   },
   {
      "type": "object",
      "object_type": "hris_earning",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-08T19:56:17.000Z",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-10-08T19:56:17.000Z",
      "object_type": "hris_earning",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "uc_call",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "telephone",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-10-08T17:12:04.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_start_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-10-08T17:12:04.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_end_lt",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-10-08T17:12:04.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T17:12:04.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "HighLevel"
   },
   {
      "type": "sign-in",
      "integration_type": "acerta",
      "created_at": "2026-10-08T17:12:04.000Z",
      "integration_name": "Acerta",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "object",
      "created_at": "2026-10-08T17:12:04.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "acerta",
      "object_type": "hris_employee",
      "integration_name": "Acerta"
   },
   {
      "type": "method",
      "integration_type": "acerta",
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Acerta"
   },
   {
      "type": "method",
      "integration_type": "acerta",
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Acerta"
   },
   {
      "type": "readable_field",
      "integration_type": "3cx",
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "3CX"
   },
   {
      "type": "readable_field",
      "integration_type": "3cx",
      "created_at": "2026-10-08T17:12:04.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "call_id",
      "integration_name": "3CX"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lightspeedretailrseries",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Lightspeed Retail R-Series"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lightspeedretailrseries",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Lightspeed Retail R-Series"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "lightspeedretailrseries",
      "object_type": "accounting_taxrate",
      "integration_name": "Lightspeed Retail R-Series"
   },
   {
      "type": "method",
      "integration_type": "lightspeedretailrseries",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed Retail R-Series"
   },
   {
      "type": "method",
      "integration_type": "lightspeedretailrseries",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lightspeed Retail R-Series"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "field": "identification",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "pagination",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "integration_type": "lightspeedpos",
      "object_type": "accounting_taxrate",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "integration_type": "lightspeedpos",
      "object_type": "hris_employee",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "integration_type": "lightspeedpos",
      "object_type": "hris_device",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "integration_type": "lightspeedpos",
      "object_type": "hris_location",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "integration_type": "lightspeedpos",
      "object_type": "payment_payment",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "hris_device",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "hris_device",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "hris_location",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "hris_location",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedpos",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "lightspeedkseries",
      "object_type": "commerce_location",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "lightspeedkseries",
      "object_type": "accounting_organization",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "lightspeedkseries",
      "object_type": "hris_company",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "lightspeedkseries",
      "object_type": "hris_location",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "commerce_location",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "hris_company",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-10-08T10:39:16.000Z",
      "object_type": "hris_location",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "object",
      "created_at": "2026-10-08T10:39:16.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "xata",
      "integration_name": "Xata"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "workiz",
      "integration_name": "Workiz"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "wildapricot",
      "integration_name": "WildApricot"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro_wfm",
      "integration_name": "UKG Pro Workforce Management"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "twenty",
      "integration_name": "Twenty"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "turso",
      "integration_name": "Turso"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "toggltrack",
      "integration_name": "Toggl Track"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "superchat",
      "integration_name": "Superchat"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "sevenio",
      "integration_name": "Seven.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "salesmate",
      "integration_name": "Salesmate"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "safetyculture",
      "integration_name": "SafetyCulture"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "crm",
         "passthrough"
      ],
      "integration_type": "respondio",
      "integration_name": "Respond.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "requesttracker",
      "integration_name": "Request Tracker"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "pushoperations",
      "integration_name": "Push Operations"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "proabono",
      "integration_name": "ProAbono"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "nocrm",
      "integration_name": "noCRM.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "ninox",
      "integration_name": "Ninox"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "neon",
      "integration_name": "Neon"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "neo4j",
      "integration_name": "Neo4j"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "msg91",
      "integration_name": "MSG91"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "mocean",
      "integration_name": "Mocean"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "mindbody",
      "integration_name": "Mindbody"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "mightynetworks",
      "integration_name": "Mighty Networks"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsgp",
      "integration_name": "Microsoft Dynamics GP"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "merchantpro",
      "integration_name": "MerchantPro"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "loyverse",
      "integration_name": "Loyverse"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "line",
      "integration_name": "LINE"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "labsmobile",
      "integration_name": "LabsMobile"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "kommunicate",
      "integration_name": "Kommunicate"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "kommo",
      "integration_name": "Kommo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "knack",
      "integration_name": "Knack"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "influxdbcloud",
      "integration_name": "InfluxDB Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "heyy",
      "integration_name": "Heyy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "helpspot",
      "integration_name": "HelpSpot"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "martech",
         "passthrough"
      ],
      "integration_type": "helloleads",
      "integration_name": "HelloLeads"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "heartbeat",
      "integration_name": "Heartbeat"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "hackerrankwork",
      "integration_name": "HackerRank Work"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "gorilladesk",
      "integration_name": "GorillaDesk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "gleap",
      "integration_name": "Gleap"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "repo",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "gitea",
      "integration_name": "Gitea"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "getform",
      "integration_name": "Getform"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "gatherup",
      "integration_name": "GatherUp"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "fusedesk",
      "integration_name": "FuseDesk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "formcrafts",
      "integration_name": "Formcrafts"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "forcemanager",
      "integration_name": "ForceManager"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "commerce",
         "task",
         "accounting",
         "passthrough"
      ],
      "integration_type": "firmao",
      "integration_name": "Firmao"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "payment",
         "passthrough"
      ],
      "integration_type": "donately",
      "integration_name": "Donately"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "documenso",
      "integration_name": "Documenso"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "delighted",
      "integration_name": "Delighted"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "databricks",
      "integration_name": "Databricks"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "signing",
         "storage",
         "passthrough"
      ],
      "integration_type": "contractbook",
      "integration_name": "Contractbook"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "contactsplus",
      "integration_name": "Contacts+"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "commercelayer",
      "integration_name": "Commerce Layer"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "clicksend",
      "integration_name": "ClickSend"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "cherry",
      "integration_name": "Cherry"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "byteforms",
      "integration_name": "ByteForms"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "bika",
      "integration_name": "Bika.ai"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "ascora",
      "integration_name": "Ascora"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "anydb",
      "integration_name": "AnyDB"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "agiled",
      "integration_name": "Agiled"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "agilecrm",
      "integration_name": "Agile CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-10-08T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "acculynx",
      "integration_name": "AccuLynx"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "integration_type": "xero",
      "object_type": "metadata_metadata",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro",
      "object_type": "hris_payslip",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "sub_type",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "smartrecruiters",
      "object_type": "ats_company",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "method",
      "integration_type": "smartrecruiters",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "Seven20",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "integration_name": "Seven20"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "Seven20",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "integration_name": "Seven20"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "Seven20",
      "object_type": "ats_activity",
      "integration_name": "Seven20"
   },
   {
      "type": "method",
      "integration_type": "Seven20",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Seven20"
   },
   {
      "type": "method",
      "integration_type": "Seven20",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "warehouse_location_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "order_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "warehouse_location_name",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "to_address",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "rate_currency",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "from_address",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "slow_fields",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforcecommercecloud",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce Commerce Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforcecommercecloud",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce Commerce Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforcecommercecloud",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce Commerce Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforcecommercecloud",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce Commerce Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "integration_type": "salesforcecommercecloud",
      "object_type": "metadata_metadata",
      "integration_name": "Salesforce Commerce Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcecommercecloud",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce Commerce Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_lead_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_lead_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "sagehr",
      "object_type": "ats_activity",
      "integration_name": "Sage HR"
   },
   {
      "type": "method",
      "integration_type": "sagehr",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "payroll_id",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "hours",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "employer_tax_amount",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "employer_contribution_amount",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "employee_tax_amount",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "deduction_amount",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "object_type": "hris_payroll",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "remote",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Remote.com"
   },
   {
      "type": "readable_field",
      "integration_type": "remote",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "net_amount",
      "integration_name": "Remote.com"
   },
   {
      "type": "object",
      "object_type": "hris_payroll",
      "integration_type": "remote",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Remote.com"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "quickbooks",
      "object_type": "metadata_metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "plum",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_application",
      "integration_name": "Plum"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "plum",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_application",
      "integration_name": "Plum"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "plum",
      "object_type": "ats_application",
      "integration_name": "Plum"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "plum",
      "object_type": "ats_applicationstatus",
      "integration_name": "Plum"
   },
   {
      "type": "method",
      "integration_type": "plum",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Plum"
   },
   {
      "type": "method",
      "integration_type": "plum",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "payment_type",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "payment_reference",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "pay_frequency",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "net_amount",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hours",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "flsa_status",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employer_tax_amount",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_tax_amount",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "details",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "deduction_amount",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Paylocity"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "paycode_id",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "amount",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "payroll_id",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "paycode_id",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "pay_frequency",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "hours",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_tax_amount",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "deduction_amount",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_type",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "object_type": "hris_payroll",
      "integration_type": "paycor",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "object_type": "hris_paycode",
      "integration_type": "paycor",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_paycode",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paychex",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "payroll_id",
      "integration_name": "Paychex"
   },
   {
      "type": "readable_field",
      "integration_type": "paychex",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hours",
      "integration_name": "Paychex"
   },
   {
      "type": "object",
      "object_type": "hris_payroll",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Paychex"
   },
   {
      "type": "object",
      "object_type": "hris_paycode",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_paycode",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_paycode",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paychex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "mercuryats",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "mercuryats",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "mercuryats",
      "object_type": "ats_scorecard",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_status",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "ats_interview",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobvite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "indeed",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Indeed"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "indeed",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Indeed"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "indeed",
      "object_type": "ats_candidate",
      "integration_name": "Indeed"
   },
   {
      "type": "method",
      "integration_type": "indeed",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Indeed"
   },
   {
      "type": "method",
      "integration_type": "indeed",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Indeed"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_company",
      "integration_name": "iCIMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_company",
      "integration_name": "iCIMS"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "icims",
      "object_type": "ats_company",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "iCIMS"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "slow_fields",
      "integration_name": "Greenhouse"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "integration_type": "factorialhr",
      "object_type": "ats_activity",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "integration_type": "factorialhr",
      "object_type": "ats_scorecard",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "object_type": "hris_payroll",
      "integration_type": "employmentheropayroll",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "object",
      "object_type": "hris_paycode",
      "integration_type": "employmentheropayroll",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "employmentheropayroll",
      "object_type": "hris_payslip",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_paycode",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_paycode",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "object",
      "object_type": "hris_payroll",
      "integration_type": "deel",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Deel"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deel",
      "object_type": "hris_company",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payroll",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Deel"
   },
   {
      "type": "object",
      "object_type": "hris_payroll",
      "integration_type": "checkhq",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Check"
   },
   {
      "type": "object",
      "object_type": "hris_paycode",
      "integration_type": "checkhq",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T22:45:04.000Z",
      "integration_name": "Check"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "net_ytd_amount",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "hours",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "gross_ytd_amount",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "employee_tax_amount",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "details",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "deduction_amount",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T22:45:04.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "ats_document",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-10-07T22:45:04.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "integration_type": "pcrecruiter",
      "object_type": "ats_applicationstatus",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "method",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "method",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "writable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Payspace"
   },
   {
      "type": "writable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Payspace"
   },
   {
      "type": "writable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Payspace"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "payspace",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Payspace"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "payspace",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "details",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_updated_gte",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Payspace"
   },
   {
      "type": "pagination",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Payspace"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "payspace",
      "object_type": "hris_group",
      "integration_name": "Payspace"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "payspace",
      "object_type": "hris_bankaccount",
      "integration_name": "Payspace"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "payspace",
      "object_type": "metadata_metadata",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Payspace"
   },
   {
      "type": "method",
      "integration_type": "payspace",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Payspace"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "openai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_task",
      "integration_name": "OpenAI"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "openai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_task",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "openai",
      "object_type": "genai_agent",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "openai",
      "object_type": "genai_task",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "openai",
      "object_type": "genai_organization",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_agent",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_organization",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_organization",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_organization",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_organization",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "genai_organization",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T17:18:43.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "icims",
      "object_type": "ats_interview",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "iCIMS"
   },
   {
      "type": "writable_field",
      "integration_type": "detris",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Detris"
   },
   {
      "type": "writable_field",
      "integration_type": "detris",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Detris"
   },
   {
      "type": "writable_field",
      "integration_type": "detris",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Detris"
   },
   {
      "type": "readable_field",
      "integration_type": "detris",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Detris"
   },
   {
      "type": "readable_field",
      "integration_type": "detris",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Detris"
   },
   {
      "type": "method",
      "integration_type": "detris",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Detris"
   },
   {
      "type": "method",
      "integration_type": "detris",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Detris"
   },
   {
      "type": "method",
      "integration_type": "detris",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Detris"
   },
   {
      "type": "method",
      "integration_type": "detris",
      "created_at": "2026-10-07T17:18:43.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Detris"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T14:27:39.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "metadata_metadata",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T14:27:39.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "integration_type": "xero",
      "object_type": "hris_payslip",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_company",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_company",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T14:27:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "successfactors",
      "object_type": "ats_company",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors_oidc",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_company",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors_oidc",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_company",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T14:27:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "successfactors_oidc",
      "object_type": "ats_company",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "method",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "method",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "receipt_number",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "purchaseorder_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Recruitee"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Recruitee"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Recruitee"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Recruitee"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Recruitee"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Recruitee"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Recruitee"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T14:27:39.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "recruitee",
      "object_type": "ats_application",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruitee"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "paylocity",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "hris_employee",
      "integration_name": "Paylocity"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "paylocity",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "hris_employee",
      "integration_name": "Paylocity"
   },
   {
      "type": "writable_field",
      "integration_type": "openai",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "OpenAI"
   },
   {
      "type": "readable_field",
      "integration_type": "openai",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "model_id",
      "integration_name": "OpenAI"
   },
   {
      "type": "readable_field",
      "integration_type": "openai",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T14:27:39.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "namely",
      "object_type": "hris_benefit",
      "integration_name": "Namely"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T14:27:39.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "namely",
      "object_type": "hris_deduction",
      "integration_name": "Namely"
   },
   {
      "type": "method",
      "integration_type": "namely",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Namely"
   },
   {
      "type": "method",
      "integration_type": "namely",
      "created_at": "2026-10-07T14:27:39.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Namely"
   },
   {
      "type": "object",
      "created_at": "2026-10-07T14:27:39.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "zulip",
      "integration_name": "Zulip"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "zixflow",
      "integration_name": "Zixflow"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "unipile",
      "integration_name": "Unipile"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "unione",
      "integration_name": "UniOne"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "timelinesai",
      "integration_name": "TimelinesAI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "tidbcloud",
      "integration_name": "TiDB Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "enrich",
         "ats",
         "passthrough"
      ],
      "integration_type": "theirstack",
      "integration_name": "TheirStack"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "taxjar",
      "integration_name": "TaxJar"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "tave",
      "integration_name": "Tave"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "surecontact",
      "integration_name": "SureContact"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "supportbee",
      "integration_name": "SupportBee"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "suitedash",
      "integration_name": "SuiteDash"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "stackby",
      "integration_name": "Stackby"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "messaging",
         "crm",
         "martech",
         "passthrough"
      ],
      "integration_type": "spoki",
      "integration_name": "Spoki"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "smtp2go",
      "integration_name": "SMTP2GO"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "simla",
      "integration_name": "Simla.com"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "servicem8",
      "integration_name": "ServiceM8"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "sequenzy",
      "integration_name": "Sequenzy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "sender",
      "integration_name": "Sender"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "sendbird",
      "integration_name": "Sendbird"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "seatable",
      "integration_name": "SeaTable"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "reteno",
      "integration_name": "Reteno"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "retable",
      "integration_name": "Retable"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "repairshopr",
      "integration_name": "RepairShopr"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "reamaze",
      "integration_name": "Re:amaze"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "raisely",
      "integration_name": "Raisely"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "ragic",
      "integration_name": "Ragic"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "quintadb",
      "integration_name": "QuintaDB"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "quaderno",
      "integration_name": "Quaderno"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "pumble",
      "integration_name": "Pumble"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "prospeo",
      "integration_name": "Prospeo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "productlane",
      "integration_name": "Productlane"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "integration_type": "plivo",
      "integration_name": "Plivo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "planyo",
      "integration_name": "Planyo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "plain",
      "integration_name": "Plain"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "pipelinecrm",
      "integration_name": "Pipeline CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "parma",
      "integration_name": "Parma"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "openrouter",
      "integration_name": "OpenRouter"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "ticketing",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "onedesk",
      "integration_name": "OneDesk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "nocodb",
      "integration_name": "NocoDB"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "metadata",
         "passthrough"
      ],
      "integration_type": "nethunt",
      "integration_name": "NetHunt CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "mailsoftly",
      "integration_name": "Mailsoftly"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "mailersend",
      "integration_name": "MailerSend"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "loops",
      "integration_name": "Loops"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "leadmagic",
      "integration_name": "LeadMagic"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "leadfeeder",
      "integration_name": "Leadfeeder"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "laposta",
      "integration_name": "Laposta"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "kapso",
      "integration_name": "Kapso"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "task",
         "passthrough"
      ],
      "integration_type": "jobnimbus",
      "integration_name": "JobNimbus"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "icypeas",
      "integration_name": "Icypeas"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "integration_type": "helpwise",
      "integration_name": "Helpwise"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "helpdesk",
      "integration_name": "HelpDesk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "grist",
      "integration_name": "Grist"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "godial",
      "integration_name": "GoDial"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "payment",
         "passthrough"
      ],
      "integration_type": "givebutter",
      "integration_name": "Givebutter"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "gigasheet",
      "integration_name": "Gigasheet"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "fromdoppler",
      "integration_name": "Doppler"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "integration_type": "formilla",
      "integration_name": "Formilla"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "folk",
      "integration_name": "Folk"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "fireberry",
      "integration_name": "Fireberry"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "espocrm",
      "integration_name": "EspoCRM"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "enrichso",
      "integration_name": "Enrich.so"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "enginemailer",
      "integration_name": "Enginemailer"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "edenai",
      "integration_name": "Eden AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "dripcel",
      "integration_name": "Dripcel"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "convoloai",
      "integration_name": "Convolo AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "clickhouse",
      "integration_name": "ClickHouse"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "clay",
      "integration_name": "Clay"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "checkhq",
      "integration_name": "Check"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "centralstationcrm",
      "integration_name": "CentralStationCRM"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "callpage",
      "integration_name": "CallPage"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "bigmailer",
      "integration_name": "BigMailer"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "baserow",
      "integration_name": "Baserow"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "apptivegrid",
      "integration_name": "ApptiveGrid"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "altoviz",
      "integration_name": "Altoviz"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "ai21studio",
      "integration_name": "AI21 Studio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "adprun",
      "integration_name": "ADP RUN"
   },
   {
      "type": "integration",
      "created_at": "2026-10-07T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "2chat",
      "integration_name": "2Chat"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Vincere"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "indeed",
      "object_type": "ats_document",
      "integration_name": "Indeed"
   },
   {
      "type": "method",
      "integration_type": "indeed",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Indeed"
   },
   {
      "type": "method",
      "integration_type": "indeed",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Indeed"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "icims",
      "object_type": "metadata_metadata",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "iCIMS"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "homerun",
      "object_type": "ats_activity",
      "integration_name": "Homerun"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "homerun",
      "object_type": "ats_document",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Homerun"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_application",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_application",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "ats_application",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "adyen",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "payment_payment",
      "integration_name": "Adyen"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "adyen",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "payment_refund",
      "integration_name": "Adyen"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "adyen",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "payment_payment",
      "integration_name": "Adyen"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "adyen",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "payment_refund",
      "integration_name": "Adyen"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "adyen",
      "object_type": "payment_payment",
      "integration_name": "Adyen"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "adyen",
      "object_type": "payment_refund",
      "integration_name": "Adyen"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T22:28:58.000Z",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "adyen",
      "object_type": "payment_subscription",
      "integration_name": "Adyen"
   },
   {
      "type": "method",
      "integration_type": "adyen",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Adyen"
   },
   {
      "type": "method",
      "integration_type": "adyen",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Adyen"
   },
   {
      "type": "method",
      "integration_type": "adyen",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Adyen"
   },
   {
      "type": "method",
      "integration_type": "adyen",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Adyen"
   },
   {
      "type": "method",
      "integration_type": "adyen",
      "created_at": "2026-10-06T22:28:58.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Adyen"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_event",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_deal",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_lead",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_company",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_contact",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "martech_list",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "martech_member",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_event",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_deal",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_lead",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_company",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "crm_contact",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "martech_list",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "martech_member",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "homerun",
      "object_type": "ats_job",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Homerun"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "kms_page",
      "integration_name": "Granola"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "storage_file",
      "integration_name": "Granola"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Granola"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "kms_page",
      "integration_name": "Granola"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "storage_file",
      "integration_name": "Granola"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "kms_page",
      "integration_name": "Granola"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "storage_file",
      "integration_name": "Granola"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Granola"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "kms_page",
      "integration_name": "Granola"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "granola",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "storage_file",
      "integration_name": "Granola"
   },
   {
      "type": "readable_field",
      "integration_type": "granola",
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Granola"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "integration_type": "granola",
      "object_type": "kms_page",
      "integration_name": "Granola"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "integration_type": "granola",
      "object_type": "kms_space",
      "integration_name": "Granola"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "integration_type": "granola",
      "object_type": "storage_file",
      "integration_name": "Granola"
   },
   {
      "type": "method",
      "integration_type": "granola",
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Granola"
   },
   {
      "type": "method",
      "integration_type": "granola",
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Granola"
   },
   {
      "type": "method",
      "integration_type": "granola",
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "kms_space",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Granola"
   },
   {
      "type": "method",
      "integration_type": "granola",
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Granola"
   },
   {
      "type": "method",
      "integration_type": "granola",
      "created_at": "2026-10-06T13:15:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "calendar",
         "kms",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Granola"
   },
   {
      "type": "pagination",
      "integration_type": "googleslides",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Google Slides"
   },
   {
      "type": "pagination",
      "integration_type": "googleslides",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Slides"
   },
   {
      "type": "pagination",
      "integration_type": "googlesheets",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Google Sheets"
   },
   {
      "type": "pagination",
      "integration_type": "googlesheets",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Sheets"
   },
   {
      "type": "pagination",
      "integration_type": "googledrive",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Google Drive"
   },
   {
      "type": "pagination",
      "integration_type": "googledrive",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Drive"
   },
   {
      "type": "pagination",
      "integration_type": "googledocs",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Google Docs"
   },
   {
      "type": "pagination",
      "integration_type": "googledocs",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Docs"
   },
   {
      "type": "pagination",
      "integration_type": "google",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Google"
   },
   {
      "type": "pagination",
      "integration_type": "google",
      "created_at": "2026-10-06T13:15:47.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T10:15:16.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "spott",
      "object_type": "ats_document",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "mime_type",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "download_url",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "data",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "size",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_reference",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_limit",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_offset",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T10:15:16.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "sap",
      "object_type": "commerce_location",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-06T10:15:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-10-06T10:15:16.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "writer",
      "integration_name": "Writer"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "woodpecker",
      "integration_name": "Woodpecker"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "wiza",
      "integration_name": "Wiza"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "vibe",
      "integration_name": "Vibe"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "vercelaigateway",
      "integration_name": "Vercel AI Gateway"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "userlist",
      "integration_name": "Userlist"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "unisender",
      "integration_name": "Unisender"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "thecompaniesapi",
      "integration_name": "The Companies API"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "uc",
         "messaging",
         "passthrough"
      ],
      "integration_type": "telnyx",
      "integration_name": "Telnyx"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "sterling",
      "integration_name": "Sterling"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "sendpulse",
      "integration_name": "SendPulse"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "sendloop",
      "integration_name": "Sendloop"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "salesrobot",
      "integration_name": "SalesRobot"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "resend",
      "integration_name": "Resend"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "remarkety",
      "integration_name": "Remarkety"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "recallai",
      "integration_name": "Recall.ai"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "predictleads",
      "integration_name": "PredictLeads"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "postmark",
      "integration_name": "Postmark"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "oceanio",
      "integration_name": "Ocean.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "minelead",
      "integration_name": "Minelead"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "manyreach",
      "integration_name": "ManyReach"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "maildroppa",
      "integration_name": "Maildroppa"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "mailcoach",
      "integration_name": "Mailcoach"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "mailbluster",
      "integration_name": "MailBluster"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "light",
      "integration_name": "Light"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "integration_type": "leexi",
      "integration_name": "Leexi"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "leadiq",
      "integration_name": "LeadIQ"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "iterable",
      "integration_name": "Iterable"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "humanitix",
      "integration_name": "Humanitix"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "greenshades",
      "integration_name": "Greenshades"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "goodbits",
      "integration_name": "Goodbits"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "fullenrich",
      "integration_name": "FullEnrich"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "fireworksai",
      "integration_name": "Fireworks AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "findymail",
      "integration_name": "Findymail"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "fal",
      "integration_name": "Fal.ai"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "explorium",
      "integration_name": "Explorium"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "eventzilla",
      "integration_name": "Eventzilla"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "erpnext",
      "integration_name": "ERPNext"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "emelia",
      "integration_name": "Emelia"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "emailoctopus",
      "integration_name": "EmailOctopus"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "elorus",
      "integration_name": "Elorus"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "elasticemail",
      "integration_name": "Elastic Email"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "integration_type": "document360",
      "integration_name": "Document360"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "directiq",
      "integration_name": "DirectIQ"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "enrich",
         "passthrough"
      ],
      "integration_type": "detris",
      "integration_name": "Detris"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "cometapi",
      "integration_name": "CometAPI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "campayn",
      "integration_name": "Campayn"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "callingly",
      "integration_name": "Callingly"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "builtwith",
      "integration_name": "BuiltWith"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "botdog",
      "integration_name": "Botdog"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "beehiiv",
      "integration_name": "Beehiiv"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "appointo",
      "integration_name": "Appointo"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "apipie",
      "integration_name": "APIpie AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "alephalpha",
      "integration_name": "Aleph Alpha"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "aimlapi",
      "integration_name": "AI/ML API"
   },
   {
      "type": "integration",
      "created_at": "2026-10-06T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "aeroleads",
      "integration_name": "AeroLeads"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "field": "start_at",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "field": "location_id",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "field": "hours",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "field": "end_at",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "field": "employee_user_id",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "field": "compensation",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "create",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "update",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats"
      ],
      "integration_type": "tribepad",
      "object_type": "ats_document",
      "integration_name": "Tribepad"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats"
      ],
      "integration_type": "tribepad",
      "object_type": "ats_applicationstatus",
      "integration_name": "Tribepad"
   },
   {
      "type": "method",
      "integration_type": "tribepad",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats"
      ],
      "method": "list",
      "integration_name": "Tribepad"
   },
   {
      "type": "method",
      "integration_type": "tribepad",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats"
      ],
      "method": "list",
      "integration_name": "Tribepad"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "metadata"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "metadata"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "metadata"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "weight_unit",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "weight",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "vendor_name",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "type",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "total_amount",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "status",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "posted_at",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "posted_at",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "paymentterm_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "organization_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "organization_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "notes",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "name",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "metadata",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "lineitems",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "is_active",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "global_code",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "description",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "created_at",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "collections",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "bill_number",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "sub_total_amount",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "status",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "posted_at",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "paymentterm_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "organization_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "organization_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "notes",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "metadata",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "metadata",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "field": "exchange_rate",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "integration_type": "sap",
      "object_type": "accounting_trialbalance",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "method": "list",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "method": "get",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "method": "create",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth"
      ],
      "method": "update",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats"
      ],
      "integration_type": "recruitee",
      "object_type": "ats_interview",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats"
      ],
      "method": "get",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats"
      ],
      "method": "list",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats"
      ],
      "method": "get",
      "integration_name": "Recruitee"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "prismhr",
      "object_type": "ats_applicationstatus",
      "integration_name": "PrismHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "prismhr",
      "object_type": "ats_company",
      "integration_name": "PrismHR"
   },
   {
      "type": "method",
      "integration_type": "prismhr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "PrismHR"
   },
   {
      "type": "method",
      "integration_type": "prismhr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "PrismHR"
   },
   {
      "type": "method",
      "integration_type": "prismhr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "PrismHR"
   },
   {
      "type": "method",
      "integration_type": "prismhr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "PrismHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pcrecruiter",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pcrecruiter",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "integration_type": "pcrecruiter",
      "object_type": "ats_scorecard",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "method",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "method",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "method",
      "integration_type": "pcrecruiter",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "method": "update",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "hris",
         "ats"
      ],
      "integration_type": "paycor",
      "object_type": "ats_applicationstatus",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "paradox",
      "object_type": "ats_interview",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "Paradox"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "integration_type": "oraclehcm",
      "object_type": "ats_activity",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "integration_type": "oraclehcm",
      "object_type": "ats_company",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "integration_type": "oraclehcm",
      "object_type": "ats_scorecard",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "crm",
         "hris"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "crm",
         "hris"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "integration_name": "Manatal"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "manatal",
      "object_type": "ats_company",
      "integration_name": "Manatal"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "manatal",
      "object_type": "ats_interview",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "Manatal"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "jobscore",
      "object_type": "ats_company",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "indeed",
      "categories": [
         "ats",
         "auth"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "integration_name": "Indeed"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "indeed",
      "categories": [
         "ats",
         "auth"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "integration_name": "Indeed"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "auth"
      ],
      "integration_type": "indeed",
      "object_type": "ats_applicationstatus",
      "integration_name": "Indeed"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "auth"
      ],
      "integration_type": "indeed",
      "object_type": "ats_interview",
      "integration_name": "Indeed"
   },
   {
      "type": "method",
      "integration_type": "indeed",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "auth"
      ],
      "method": "list",
      "integration_name": "Indeed"
   },
   {
      "type": "method",
      "integration_type": "indeed",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth"
      ],
      "method": "list",
      "integration_name": "Indeed"
   },
   {
      "type": "method",
      "integration_type": "indeed",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth"
      ],
      "method": "get",
      "integration_name": "Indeed"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats"
      ],
      "integration_type": "homerun",
      "object_type": "ats_application",
      "integration_name": "Homerun"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats"
      ],
      "integration_type": "homerun",
      "object_type": "ats_company",
      "integration_name": "Homerun"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats"
      ],
      "integration_type": "homerun",
      "object_type": "ats_scorecard",
      "integration_name": "Homerun"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats"
      ],
      "integration_type": "homerun",
      "object_type": "ats_applicationstatus",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats"
      ],
      "method": "list",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats"
      ],
      "method": "get",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats"
      ],
      "method": "list",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats"
      ],
      "method": "get",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats"
      ],
      "method": "list",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats"
      ],
      "method": "get",
      "integration_name": "Homerun"
   },
   {
      "type": "method",
      "integration_type": "homerun",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats"
      ],
      "method": "list",
      "integration_name": "Homerun"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouseingest",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouseingest",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_application",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_application",
      "integration_name": "Fountain"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "fountain",
      "object_type": "ats_application",
      "integration_name": "Fountain"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "fountain",
      "object_type": "ats_activity",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "create",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "update",
      "integration_name": "Fountain"
   },
   {
      "type": "method",
      "integration_type": "fountain",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "remove",
      "integration_name": "Fountain"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "flatchr",
      "object_type": "ats_activity",
      "integration_name": "Flatchr"
   },
   {
      "type": "method",
      "integration_type": "flatchr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "Flatchr"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms"
      ],
      "field": "title",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms"
      ],
      "field": "employment_type",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "hris",
         "ats",
         "lms"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "eploy",
      "categories": [
         "ats",
         "crm",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Eploy"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "eploy",
      "categories": [
         "ats",
         "crm",
         "hris"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Eploy"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "crm",
         "hris"
      ],
      "integration_type": "eploy",
      "object_type": "ats_scorecard",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "hris"
      ],
      "method": "get",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris"
      ],
      "method": "list",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris"
      ],
      "method": "get",
      "integration_name": "Eploy"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "eightfold",
      "object_type": "ats_interview",
      "integration_name": "Eightfold"
   },
   {
      "type": "method",
      "integration_type": "eightfold",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "Eightfold"
   },
   {
      "type": "method",
      "integration_type": "eightfold",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "get",
      "integration_name": "Eightfold"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "hris",
         "ats",
         "verification"
      ],
      "integration_type": "checkr",
      "object_type": "ats_application",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "verification"
      ],
      "method": "list",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "verification"
      ],
      "method": "get",
      "integration_name": "Checkr"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "breezyhr",
      "object_type": "ats_interview",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "integration_name": "BoondManager"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "integration_type": "boondmanager",
      "object_type": "ats_document",
      "integration_name": "BoondManager"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "integration_type": "boondmanager",
      "object_type": "ats_interview",
      "integration_name": "BoondManager"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "integration_type": "boondmanager",
      "object_type": "ats_applicationstatus",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "method": "list",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "method": "get",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "method": "list",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_interview",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "method": "get",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "method": "list",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "hris",
         "ats",
         "crm"
      ],
      "method": "get",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "airwallex",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Airwallex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "airwallex",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Airwallex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "airwallex",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Airwallex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "airwallex",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "accounting_bill",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "accounting_contact",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "accounting_expense",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "accounting_invoice",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "commerce_item",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "commerce_itemvariant",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "payment_link",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "payment_payment",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "payment_payout",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "payment_refund",
      "integration_name": "Airwallex"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T21:44:57.000Z",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "integration_type": "airwallex",
      "object_type": "payment_subscription",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "create",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "update",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "create",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "update",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "create",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "update",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_link",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_link",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_payment",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_payment",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_payout",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_payout",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_refund",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_refund",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "list",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "get",
      "integration_name": "Airwallex"
   },
   {
      "type": "method",
      "integration_type": "airwallex",
      "created_at": "2026-10-05T21:44:57.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "auth",
         "accounting",
         "commerce",
         "payment"
      ],
      "method": "remove",
      "integration_name": "Airwallex"
   },
   {
      "type": "readable_field",
      "integration_type": "typesafe",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "has_vision",
      "integration_name": "TypeSafe AI"
   },
   {
      "type": "readable_field",
      "integration_type": "typesafe",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "has_questions",
      "integration_name": "TypeSafe AI"
   },
   {
      "type": "readable_field",
      "integration_type": "talentlyft",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "TalentLyft"
   },
   {
      "type": "writable_field",
      "integration_type": "openai",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "skill_ids",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "object_type": "genai_skill",
      "integration_type": "openai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-10-05T10:15:17.000Z",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "object_type": "genai_skill",
      "integration_type": "mistralai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-10-05T10:15:17.000Z",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MistralAI"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "object_type": "genai_skill",
      "integration_type": "grok",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-10-05T10:15:17.000Z",
      "integration_name": "X.ai Grok"
   },
   {
      "type": "method",
      "integration_type": "grok",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "X.ai Grok"
   },
   {
      "type": "method",
      "integration_type": "grok",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "X.ai Grok"
   },
   {
      "type": "method",
      "integration_type": "grok",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "X.ai Grok"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Crelate"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "crelate",
      "object_type": "ats_scorecard",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_status",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_activity",
      "integration_name": "BoondManager"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "boondmanager",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_activity",
      "integration_name": "BoondManager"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "boondmanager",
      "object_type": "ats_activity",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BoondManager"
   },
   {
      "type": "writable_field",
      "integration_type": "anthropicclaude",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "skill_ids",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "object",
      "object_type": "genai_skill",
      "integration_type": "anthropicclaude",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-10-05T10:15:17.000Z",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "method",
      "integration_type": "anthropicclaude",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "method",
      "integration_type": "anthropicclaude",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "method",
      "integration_type": "anthropicclaude",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "object",
      "object_type": "genai_skill",
      "integration_type": "anthropicagents",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-10-05T10:15:17.000Z",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "anthropicagents",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "anthropicagents",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "anthropicagents",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "genai_skill",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "object",
      "created_at": "2026-10-05T10:15:17.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "integration_type": "amazonsellercentral",
      "object_type": "shipping_shipment",
      "integration_name": "Amazon Seller Central"
   },
   {
      "type": "method",
      "integration_type": "amazonsellercentral",
      "created_at": "2026-10-05T10:15:17.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Amazon Seller Central"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "tomba",
      "integration_name": "Tomba"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "theorg",
      "integration_name": "The Org"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "sendlane",
      "integration_name": "Sendlane"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping"
      ],
      "integration_type": "salesforceoms",
      "integration_name": "Salesforce OMS"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "integration_type": "persistiq",
      "integration_name": "PersistIQ"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "genai"
      ],
      "integration_type": "perplexity",
      "integration_name": "Perplexity AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "moosend",
      "integration_name": "Moosend"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "mailerlite",
      "integration_name": "MailerLite"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "lagrowthmachine",
      "integration_name": "La Growth Machine"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "commerce",
         "accounting"
      ],
      "integration_type": "joblogic",
      "integration_name": "Joblogic"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "iconik",
      "integration_name": "Iconik"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "integration_type": "etermin",
      "integration_name": "eTermin"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "esputnik",
      "integration_name": "eSputnik"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "demio",
      "integration_name": "Demio"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "curated",
      "integration_name": "Curated"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "clickmeeting",
      "integration_name": "ClickMeeting"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "bookingmood",
      "integration_name": "Bookingmood"
   },
   {
      "type": "integration",
      "created_at": "2026-10-05T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "activetrail",
      "integration_name": "ActiveTrail"
   },
   {
      "type": "integration",
      "created_at": "2026-10-04T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "cloudflareworkersai",
      "integration_name": "Cloudflare Workers AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-03T00:00:00.000Z",
      "categories": [
         "hris"
      ],
      "integration_type": "workleap",
      "integration_name": "Workleap"
   },
   {
      "type": "integration",
      "created_at": "2026-10-03T00:00:00.000Z",
      "categories": [
         "cdp",
         "crm",
         "passthrough"
      ],
      "integration_type": "warmly",
      "integration_name": "Warmly"
   },
   {
      "type": "integration",
      "created_at": "2026-10-03T00:00:00.000Z",
      "categories": [
         "crm",
         "martech",
         "task"
      ],
      "integration_type": "reply",
      "integration_name": "Reply.io"
   },
   {
      "type": "integration",
      "created_at": "2026-10-03T00:00:00.000Z",
      "categories": [
         "enrich"
      ],
      "integration_type": "reachfast",
      "integration_name": "ReachFast"
   },
   {
      "type": "integration",
      "created_at": "2026-10-03T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "pocus",
      "integration_name": "Pocus"
   },
   {
      "type": "integration",
      "created_at": "2026-10-03T00:00:00.000Z",
      "categories": [
         "crm",
         "martech",
         "task",
         "hris",
         "uc"
      ],
      "integration_type": "outplay",
      "integration_name": "Outplay"
   },
   {
      "type": "integration",
      "created_at": "2026-10-03T00:00:00.000Z",
      "categories": [
         "martech",
         "messaging",
         "task",
         "passthrough"
      ],
      "integration_type": "mixmax",
      "integration_name": "Mixmax"
   },
   {
      "type": "integration",
      "created_at": "2026-10-03T00:00:00.000Z",
      "categories": [
         "enrich",
         "crm",
         "cdp",
         "metadata",
         "passthrough"
      ],
      "integration_type": "highperformr",
      "integration_name": "Highperformr"
   },
   {
      "type": "integration",
      "created_at": "2026-10-03T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "bettercontact",
      "integration_name": "Better Contact"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zohomail",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "pagination",
      "integration_type": "zohomail",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_start_gte",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "pagination",
      "integration_type": "zohomail",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_end_lt",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "pagination",
      "integration_type": "zohomail",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "pagination",
      "integration_type": "zohomail",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "pagination",
      "integration_type": "zohomail",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "tax_exemption",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "relationships",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "pronouns",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "phone",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "payment_type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "paid_amount",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "details",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "hris_benefit",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "vonage",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Vonage"
   },
   {
      "type": "readable_field",
      "integration_type": "vonage",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Vonage"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "routing_number",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "is_primary",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "account_type",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "account_number",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "UKG Ready"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "writable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_document",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "forms_submission",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_document",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_document",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "forms_submission",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_document",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "readable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "readable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "readable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "readable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_group_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_company_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_document",
      "pagination": "list_company_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_document",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ukg_hr",
      "object_type": "hris_company",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ukg_hr",
      "object_type": "signing_document",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ukg_hr",
      "object_type": "signing_signatory",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ukg_hr",
      "object_type": "signing_template",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ukg_hr",
      "object_type": "metadata_metadata",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ukg_hr",
      "object_type": "forms_form",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ukg_hr",
      "object_type": "forms_submission",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_document",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_document",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_document",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_signatory",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_signatory",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_template",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "signing_template",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "forms_form",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "forms_form",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "forms_submission",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "forms_submission",
      "categories": [
         "hris",
         "signing",
         "forms",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "ats_applicationstatus",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Teamtailor"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "teamtailor",
      "object_type": "metadata_metadata",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Teamtailor"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "talentlyft",
      "object_type": "ats_applicationstatus",
      "integration_name": "TalentLyft"
   },
   {
      "type": "method",
      "integration_type": "talentlyft",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TalentLyft"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "payment_payout",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "payment_payment",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "payment_refund",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "payment_payout",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "payment_payout",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "payment_refund",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "payment_refund",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "identification",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "identification",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_query",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "slow_fields",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "sap",
      "object_type": "commerce_inventory",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recruitwithatlas",
      "object_type": "ats_document",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlas"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "recruitee",
      "object_type": "ats_document",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recruitee"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "crm_company",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "crm_contact",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "crm_company",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "crm_contact",
      "integration_name": "OTYS"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "integration_type": "otys",
      "object_type": "ats_document",
      "integration_name": "OTYS"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "integration_type": "otys",
      "object_type": "crm_company",
      "integration_name": "OTYS"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "integration_type": "otys",
      "object_type": "crm_contact",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclesales",
      "categories": [
         "crm",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "integration_name": "Oracle Sales"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclesales",
      "categories": [
         "crm",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "integration_name": "Oracle Sales"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "crm",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "oraclesales",
      "object_type": "storage_file",
      "integration_name": "Oracle Sales"
   },
   {
      "type": "method",
      "integration_type": "oraclesales",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Sales"
   },
   {
      "type": "method",
      "integration_type": "oraclesales",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Sales"
   },
   {
      "type": "method",
      "integration_type": "oraclesales",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oracle Sales"
   },
   {
      "type": "method",
      "integration_type": "oraclesales",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oracle Sales"
   },
   {
      "type": "method",
      "integration_type": "oraclesales",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle Sales"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "integration_type": "oraclejde",
      "object_type": "storage_file",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "method",
      "integration_type": "oraclejde",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "method",
      "integration_type": "oraclejde",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "method",
      "integration_type": "oraclejde",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "method",
      "integration_type": "oraclejde",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "storage_file",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "ats",
         "hris",
         "lms",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclefusion",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclefusion",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "integration_type": "oraclefusion",
      "object_type": "storage_file",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "method",
      "integration_type": "oraclefusion",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscontactcenter",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscontactcenter",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "jboard",
      "object_type": "ats_application",
      "integration_name": "Jboard"
   },
   {
      "type": "method",
      "integration_type": "jboard",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jboard"
   },
   {
      "type": "method",
      "integration_type": "jboard",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Jboard"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jazzhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "integration_name": "JazzHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jazzhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "integration_name": "JazzHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "jazzhr",
      "object_type": "ats_document",
      "integration_name": "JazzHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "jazzhr",
      "object_type": "ats_scorecard",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "jazzhr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "jazzhr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "jazzhr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "jazzhr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JazzHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "object_type": "messaging_channel",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "integration_type": "hubspot",
      "object_type": "messaging_channel",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "integration_type": "hubspot",
      "object_type": "messaging_message",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_message",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_message",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_message",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_call",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Gladly"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "integration_type": "gladly",
      "object_type": "messaging_channel",
      "integration_name": "Gladly"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "integration_type": "gladly",
      "object_type": "messaging_message",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_message",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_message",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_message",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "messaging_message",
      "categories": [
         "kms",
         "hris",
         "uc",
         "messaging",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Gladly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "Gem"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "gem",
      "object_type": "ats_applicationstatus",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gem"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "eightfold",
      "object_type": "ats_scorecard",
      "integration_name": "Eightfold"
   },
   {
      "type": "method",
      "integration_type": "eightfold",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Eightfold"
   },
   {
      "type": "method",
      "integration_type": "eightfold",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "digitalsamba",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Digital Samba"
   },
   {
      "type": "readable_field",
      "integration_type": "digitalsamba",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Digital Samba"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "conversation_identifier",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "integration_type": "checkr",
      "object_type": "ats_document",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Checkr"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_sort_by_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "breezyhr",
      "object_type": "ats_document",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BreezyHR"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "boondmanager",
      "object_type": "ats_company",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "BoondManager"
   },
   {
      "type": "method",
      "integration_type": "boondmanager",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BoondManager"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "atsanywhere",
      "object_type": "ats_activity",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "Alexis"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "pronouns",
      "integration_name": "Alexis"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Alexis"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Alexis"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Alexis"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "alexis",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Alexis"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "alexis",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "pronouns",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Alexis"
   },
   {
      "type": "pagination",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Alexis"
   },
   {
      "type": "pagination",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "Alexis"
   },
   {
      "type": "pagination",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_location_id",
      "integration_name": "Alexis"
   },
   {
      "type": "pagination",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "Alexis"
   },
   {
      "type": "pagination",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Alexis"
   },
   {
      "type": "pagination",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_location_id",
      "integration_name": "Alexis"
   },
   {
      "type": "pagination",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_group_id",
      "integration_name": "Alexis"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "alexis",
      "object_type": "hris_company",
      "integration_name": "Alexis"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "alexis",
      "object_type": "hris_group",
      "integration_name": "Alexis"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "alexis",
      "object_type": "hris_location",
      "integration_name": "Alexis"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "alexis",
      "object_type": "hris_timeoff",
      "integration_name": "Alexis"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "alexis",
      "object_type": "hris_timeshift",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Alexis"
   },
   {
      "type": "method",
      "integration_type": "alexis",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Alexis"
   },
   {
      "type": "object",
      "created_at": "2026-10-02T16:11:32.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "hris_benefit",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-10-02T16:11:32.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "yahoodsp",
      "integration_name": "Yahoo DSP"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "xyleme",
      "integration_name": "Xyleme"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "commerce",
         "ticketing",
         "storage",
         "calendar",
         "martech",
         "metadata",
         "passthrough"
      ],
      "integration_type": "webcrm",
      "integration_name": "webCRM"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "verifiedcredentials",
      "integration_name": "Verified Credentials"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "shippingeasy",
      "integration_name": "ShippingEasy"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "plansource",
      "integration_name": "PlanSource"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "moxiworks",
      "integration_name": "MoxiWorks"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "storage",
         "kms",
         "auth",
         "passthrough"
      ],
      "integration_type": "mijnbureau",
      "integration_name": "Mijn Bureau"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "membrain",
      "integration_name": "Membrain"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "limego",
      "integration_name": "Lime Go"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "getresponse",
      "integration_name": "GetResponse"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "fiserv",
      "integration_name": "Fiserv"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "erecruiter",
      "integration_name": "eRecruiter"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "elead",
      "integration_name": "Elead (CDK)"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "enrich",
         "crm",
         "passthrough"
      ],
      "integration_type": "demandbase",
      "integration_name": "Demandbase"
   },
   {
      "type": "integration",
      "created_at": "2026-10-02T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "activtrak",
      "integration_name": "ActivTrak"
   },
   {
      "type": "integration",
      "created_at": "2026-10-01T00:00:00.000Z",
      "categories": [
         "messaging",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "sentdm",
      "integration_name": "Sent.dm"
   },
   {
      "type": "integration",
      "created_at": "2026-10-01T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "outdoo",
      "integration_name": "Outdoo AI"
   },
   {
      "type": "integration",
      "created_at": "2026-10-01T00:00:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlechat",
      "integration_name": "Google Chat"
   },
   {
      "type": "integration",
      "created_at": "2026-10-01T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "enrichlayer",
      "integration_name": "Enrich Layer"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "lms_course",
      "integration_name": "Zoho People"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "lms_class",
      "integration_name": "Zoho People"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "lms_collection",
      "integration_name": "Zoho People"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "lms_content",
      "integration_name": "Zoho People"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "lms_instructor",
      "integration_name": "Zoho People"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "lms_student",
      "integration_name": "Zoho People"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "lms_activity",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_course",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_course",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_course",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_class",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_collection",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_content",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_instructor",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_instructor",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_student",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "vonagecontactcenter",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Vonage Contact Center"
   },
   {
      "type": "readable_field",
      "integration_type": "vonagecontactcenter",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Vonage Contact Center"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "talentreef",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "TalentReef"
   },
   {
      "type": "readable_field",
      "integration_type": "talentreef",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "TalentReef"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "messaging_channel",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "messaging_message",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_message",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_message",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_message",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_message",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_message",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "messaging",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlemerchant",
      "object_type": "commerce_item",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlemerchant",
      "object_type": "commerce_inventory",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "method",
      "integration_type": "googlemerchant",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "method",
      "integration_type": "googlemerchant",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "method",
      "integration_type": "googlemerchant",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "method",
      "integration_type": "googlemerchant",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "method",
      "integration_type": "googlemerchant",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "method",
      "integration_type": "googlemerchant",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "method",
      "integration_type": "googlemerchant",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "method",
      "integration_type": "googlemerchant",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "integration_type": "appleicloud",
      "object_type": "messaging_channel",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "object",
      "created_at": "2026-09-30T14:31:40.000Z",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "integration_type": "appleicloud",
      "object_type": "messaging_message",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2026-09-30T14:31:40.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "crm",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "integration",
      "created_at": "2026-09-30T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "targetplus",
      "integration_name": "Target Plus"
   },
   {
      "type": "integration",
      "created_at": "2026-09-30T00:00:00.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "oysterhr",
      "integration_name": "Oyster HR"
   },
   {
      "type": "integration",
      "created_at": "2026-09-30T00:00:00.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "kms",
         "martech",
         "analytics",
         "hris",
         "passthrough"
      ],
      "integration_type": "crisp",
      "integration_name": "Crisp"
   },
   {
      "type": "integration",
      "created_at": "2026-09-30T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "banqup",
      "integration_name": "Banqup"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-09-29T21:00:18.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "slow_fields",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-09-29T21:00:18.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "slow_fields",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-09-29T21:00:18.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "slow_fields",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-09-29T21:00:18.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "sap",
      "object_type": "storage_file",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "paycor",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Paycor"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "paycor",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_application",
      "integration_name": "Paycor"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "paycor",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Paycor"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "paycor",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_application",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2026-09-29T21:00:18.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "ats_candidate",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2026-09-29T21:00:18.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "ats_application",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "harver",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "verification_request",
      "categories": [
         "ats",
         "verification",
         "passthrough"
      ],
      "field": "response_redirect_url",
      "integration_name": "Harver"
   },
   {
      "type": "writable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-09-29T21:00:18.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "zohocliq",
      "integration_name": "Zoho Cliq"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "vonagecontactcenter",
      "integration_name": "Vonage Contact Center"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "trulioo",
      "integration_name": "Trulioo"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "talkdesk",
      "integration_name": "Talkdesk"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "sugarcrm",
      "integration_name": "SugarCRM"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "snovio",
      "integration_name": "Snov.io"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "similarweb",
      "integration_name": "Similarweb"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "placementsio",
      "integration_name": "Placements.io"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "pabbly",
      "integration_name": "Pabbly Email Marketing"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "nibelis",
      "integration_name": "Nibelis"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "newrelic",
      "integration_name": "New Relic"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "leadspace",
      "integration_name": "Leadspace"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "idmission",
      "integration_name": "IDmission"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "hrone",
      "integration_name": "HROne"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "gocubic",
      "integration_name": "Cubic"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "freshchat",
      "integration_name": "Freshchat"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "fattail",
      "integration_name": "FatTail AdBook"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "integration_type": "depop",
      "integration_name": "Depop"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "blackbaud",
      "integration_name": "Blackbaud Raiser's Edge NXT"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "bite",
      "integration_name": "BITE"
   },
   {
      "type": "integration",
      "created_at": "2026-09-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "adfin",
      "integration_name": "Adfin"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_salesreceipt",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_expensereport",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sap",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sap",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "object_type": "accounting_purchasereceipt",
      "integration_type": "sap",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "object_type": "accounting_expensereport",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "rydoo",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-09-28T15:56:07.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-09-28T15:56:07.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-09-28T15:56:07.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_salesreceipt",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "object_type": "accounting_purchasereceipt",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_expensereport",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_salesreceipt",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_purchasereceipt",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "navan",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Navan"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "object_type": "accounting_purchasereceipt",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_purchasereceipt",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "object",
      "object_type": "accounting_salesreceipt",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_salesreceipt",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "object",
      "object_type": "accounting_expensereport",
      "integration_type": "hrworks",
      "categories": [
         "hris",
         "ats",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "HR WORKS"
   },
   {
      "type": "method",
      "integration_type": "hrworks",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "hris",
         "ats",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HR WORKS"
   },
   {
      "type": "method",
      "integration_type": "hrworks",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "hris",
         "ats",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HR WORKS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hrcloud",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_candidate",
      "integration_name": "HR Cloud"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hrcloud",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_job",
      "integration_name": "HR Cloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hrcloud",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_candidate",
      "integration_name": "HR Cloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hrcloud",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_job",
      "integration_name": "HR Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-09-28T15:56:07.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "hrcloud",
      "object_type": "ats_candidate",
      "integration_name": "HR Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-09-28T15:56:07.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "hrcloud",
      "object_type": "ats_job",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "HR Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "harvest",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Harvest"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "darwinbox",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Darwinbox"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "darwinbox",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Darwinbox"
   },
   {
      "type": "readable_field",
      "integration_type": "darwinbox",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Darwinbox"
   },
   {
      "type": "object",
      "object_type": "accounting_expensereport",
      "integration_type": "darwinbox",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "Darwinbox"
   },
   {
      "type": "method",
      "integration_type": "darwinbox",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Darwinbox"
   },
   {
      "type": "writable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "writable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "writable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "writable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "writable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "concurcompany",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "concurcompany",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "object",
      "object_type": "accounting_expensereport",
      "integration_type": "concurcompany",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "SAP Concur"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "concur",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "SAP Concur"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "concur",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "SAP Concur"
   },
   {
      "type": "object",
      "object_type": "accounting_expensereport",
      "integration_type": "concur",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-28T15:56:07.000Z",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expensereport",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "brex",
      "created_at": "2026-09-28T15:56:07.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Brex"
   },
   {
      "type": "integration",
      "created_at": "2026-09-28T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "ollama",
      "integration_name": "Ollama"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "canva",
      "categories": [
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "storage_file",
      "integration_name": "Canva"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "canva",
      "categories": [
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "storage_file",
      "integration_name": "Canva"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T14:21:58.000Z",
      "categories": [
         "storage",
         "passthrough"
      ],
      "integration_type": "canva",
      "object_type": "storage_file",
      "integration_name": "Canva"
   },
   {
      "type": "method",
      "integration_type": "canva",
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Canva"
   },
   {
      "type": "method",
      "integration_type": "canva",
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Canva"
   },
   {
      "type": "method",
      "integration_type": "canva",
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Canva"
   },
   {
      "type": "method",
      "integration_type": "canva",
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Canva"
   },
   {
      "type": "method",
      "integration_type": "canva",
      "created_at": "2026-09-25T14:21:58.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Canva"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgpro_ats",
      "object_type": "ats_company",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "method",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "twilio",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "messaging_message",
      "integration_name": "Twilio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "twilio",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "messaging_message",
      "integration_name": "Twilio"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "twilio",
      "object_type": "messaging_channel",
      "integration_name": "Twilio"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "twilio",
      "object_type": "messaging_message",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "messaging_message",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "messaging_message",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "messaging_message",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "messaging_message",
      "categories": [
         "uc",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Twilio"
   },
   {
      "type": "readable_field",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "field": "updated_at",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "field": "created_at",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "integration_type": "redtail",
      "object_type": "crm_deal",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "integration_type": "redtail",
      "object_type": "crm_pipeline",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "integration_type": "redtail",
      "object_type": "metadata_metadata",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "create",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "update",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "remove",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "metadata",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "sources",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "otys",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "OTYS"
   },
   {
      "type": "readable_field",
      "integration_type": "otys",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "OTYS"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "otys",
      "object_type": "metadata_metadata",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OTYS"
   },
   {
      "type": "method",
      "integration_type": "otys",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "opencode",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "messages",
      "integration_name": "opencode"
   },
   {
      "type": "method",
      "integration_type": "opencode",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "opencode"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "forms_submission",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "forms_submission",
      "integration_name": "HighLevel"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "integration_type": "highlevel",
      "object_type": "forms_form",
      "integration_name": "HighLevel"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "integration_type": "highlevel",
      "object_type": "forms_submission",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "forms_form",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "forms_submission",
      "categories": [
         "crm",
         "auth",
         "hris",
         "forms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "googlejules",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "messages",
      "integration_name": "Google Jules"
   },
   {
      "type": "method",
      "integration_type": "googlejules",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Jules"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "website_url",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "phone",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Firefish"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "firefish",
      "object_type": "ats_document",
      "integration_name": "Firefish"
   },
   {
      "type": "object",
      "created_at": "2026-09-25T13:23:11.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "firefish",
      "object_type": "crm_company",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "devin",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "messages",
      "integration_name": "Devin"
   },
   {
      "type": "method",
      "integration_type": "devin",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Devin"
   },
   {
      "type": "writable_field",
      "integration_type": "cursor",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "messages",
      "integration_name": "Cursor"
   },
   {
      "type": "method",
      "integration_type": "cursor",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Cursor"
   },
   {
      "type": "writable_field",
      "integration_type": "codegen",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "messages",
      "integration_name": "Codegen"
   },
   {
      "type": "method",
      "integration_type": "codegen",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Codegen"
   },
   {
      "type": "writable_field",
      "integration_type": "anthropicagents",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "messages",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "anthropicagents",
      "created_at": "2026-09-25T13:23:11.000Z",
      "object_type": "genai_task",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-24T15:49:19.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "status",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-09-24T15:36:15.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-09-24T15:36:15.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "FactorialHR"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CATS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_interview",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_interview",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_order",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Carerix"
   },
   {
      "type": "object",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "carerix",
      "object_type": "ats_applicationstatus",
      "integration_name": "Carerix"
   },
   {
      "type": "object",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "carerix",
      "object_type": "ats_interview",
      "integration_name": "Carerix"
   },
   {
      "type": "object",
      "created_at": "2026-09-24T15:32:27.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "carerix",
      "object_type": "ats_document",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-09-24T15:32:27.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Carerix"
   },
   {
      "type": "integration",
      "created_at": "2026-09-24T00:00:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "veevacrm",
      "integration_name": "Veeva CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-09-24T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "typesafe",
      "integration_name": "TypeSafe AI"
   },
   {
      "type": "integration",
      "created_at": "2026-09-24T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "tinyfish",
      "integration_name": "TinyFish"
   },
   {
      "type": "integration",
      "created_at": "2026-09-24T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "browserbase",
      "integration_name": "Browserbase"
   },
   {
      "type": "writable_field",
      "integration_type": "etsy",
      "created_at": "2026-09-23T19:34:18.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "tracking_id",
      "integration_name": "Etsy"
   },
   {
      "type": "writable_field",
      "integration_type": "etsy",
      "created_at": "2026-09-23T19:34:18.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "packages",
      "integration_name": "Etsy"
   },
   {
      "type": "writable_field",
      "integration_type": "etsy",
      "created_at": "2026-09-23T19:34:18.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "order_id",
      "integration_name": "Etsy"
   },
   {
      "type": "writable_field",
      "integration_type": "etsy",
      "created_at": "2026-09-23T19:34:18.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "carrier_name",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-09-23T19:34:18.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Etsy"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "vismaeaccounting",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_bankfeedtransaction",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Visma eAccounting"
   },
   {
      "type": "pagination",
      "integration_type": "treasuredata",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "object_type": "cdp_segment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Treasure Data"
   },
   {
      "type": "pagination",
      "integration_type": "spiris",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bankfeedtransaction",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Spiris"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "uc",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "shoplazza",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_review",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shoplazza"
   },
   {
      "type": "pagination",
      "integration_type": "shoplazza",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shoplazza"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "procountor",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_bankfeedtransaction",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Procountor"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "opencode",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_task",
      "pagination": "virtual_webhook_limit",
      "integration_name": "opencode"
   },
   {
      "type": "pagination",
      "integration_type": "lark",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_channel_id",
      "integration_name": "Lark"
   },
   {
      "type": "pagination",
      "integration_type": "lark",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lark"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "eightfold",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Eightfold"
   },
   {
      "type": "pagination",
      "integration_type": "eightfold",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Eightfold"
   },
   {
      "type": "pagination",
      "integration_type": "eightfold",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Eightfold"
   },
   {
      "type": "pagination",
      "integration_type": "careerplug",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "CareerPlug"
   },
   {
      "type": "pagination",
      "integration_type": "careerplug",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "CareerPlug"
   },
   {
      "type": "pagination",
      "integration_type": "blueconic",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "object_type": "cdp_profile",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BlueConic"
   },
   {
      "type": "pagination",
      "integration_type": "blueconic",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "object_type": "cdp_segment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BlueConic"
   },
   {
      "type": "pagination",
      "integration_type": "blueconic",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "object_type": "cdp_event",
      "pagination": "virtual_webhook_profile_id",
      "integration_name": "BlueConic"
   },
   {
      "type": "pagination",
      "integration_type": "bazaarvoice",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_review",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Bazaarvoice"
   },
   {
      "type": "pagination",
      "integration_type": "bazaarvoice",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Bazaarvoice"
   },
   {
      "type": "pagination",
      "integration_type": "apploi",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Apploi"
   },
   {
      "type": "pagination",
      "integration_type": "apploi",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Apploi"
   },
   {
      "type": "pagination",
      "integration_type": "adobeexperienceplatform",
      "created_at": "2026-09-23T13:29:55.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "object_type": "cdp_segment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Adobe Experience Platform"
   },
   {
      "type": "integration",
      "created_at": "2026-09-23T00:00:00.000Z",
      "categories": [
         "uc",
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "vonage",
      "integration_name": "Vonage"
   },
   {
      "type": "integration",
      "created_at": "2026-09-23T00:00:00.000Z",
      "categories": [
         "hris",
         "crm",
         "signing",
         "task",
         "passthrough"
      ],
      "integration_type": "ontra",
      "integration_name": "Ontra"
   },
   {
      "type": "integration",
      "created_at": "2026-09-23T00:00:00.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "atlassianjiradatacenter",
      "integration_name": "Atlassian Jira Data Center / Server"
   },
   {
      "type": "object",
      "created_at": "2026-09-22T17:41:50.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_agedreceivable",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2026-09-22T17:41:50.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_agedpayable",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-22T17:41:50.000Z",
      "object_type": "accounting_agedreceivable",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-22T17:41:50.000Z",
      "object_type": "accounting_agedreceivable",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-22T17:41:50.000Z",
      "object_type": "accounting_agedpayable",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-09-22T17:41:50.000Z",
      "object_type": "accounting_agedpayable",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-22T17:41:50.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JobDiva"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-22T17:41:50.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-09-22T17:41:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobDiva"
   },
   {
      "type": "object",
      "created_at": "2026-09-22T17:00:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workstream",
      "object_type": "ats_activity",
      "integration_name": "Workstream"
   },
   {
      "type": "method",
      "integration_type": "workstream",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workstream"
   },
   {
      "type": "method",
      "integration_type": "workstream",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workstream"
   },
   {
      "type": "object",
      "created_at": "2026-09-22T17:00:21.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "ats_company",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-09-22T17:00:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "phenom",
      "object_type": "ats_activity",
      "integration_name": "Phenom"
   },
   {
      "type": "object",
      "created_at": "2026-09-22T17:00:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "phenom",
      "object_type": "ats_document",
      "integration_name": "Phenom"
   },
   {
      "type": "method",
      "integration_type": "phenom",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Phenom"
   },
   {
      "type": "method",
      "integration_type": "phenom",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Phenom"
   },
   {
      "type": "method",
      "integration_type": "phenom",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Phenom"
   },
   {
      "type": "writable_field",
      "integration_type": "openaiads",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "openaiads",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "goal",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "openaiads",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_strategy",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "openaiads",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "openaiads",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "goal",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "openaiads",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_strategy",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "field": "updated_at",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2026-09-22T17:00:21.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "ashby",
      "object_type": "metadata_metadata",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2026-09-22T17:00:21.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2026-09-22T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "opencode",
      "integration_name": "opencode"
   },
   {
      "type": "integration",
      "created_at": "2026-09-22T00:00:00.000Z",
      "categories": [
         "messaging",
         "martech",
         "passthrough"
      ],
      "integration_type": "onesignal",
      "integration_name": "OneSignal"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopayment",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Zoho Payments"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "is_inclusive_of_tax",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinventory",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Zoho Inventory"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinventory",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "purchaseorder_ids",
      "integration_name": "Zoho Inventory"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinventory",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Zoho Inventory"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "purchaseorder_ids",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "is_inclusive_of_tax",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "is_compound",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "country",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "books_close_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "slow_fields",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "total_rate",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "is_inclusive_of_tax",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "is_inclusive_of_tax",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "is_compound",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "effective_rate",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "components",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "books_close_at",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "region",
      "integration_name": "WooCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "is_compound",
      "integration_name": "WooCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "country",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "region",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "is_compound",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "country",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "winbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "WinBooks on Web"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "vismaeaccounting",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "field": "books_close_at",
      "integration_name": "Visma eAccounting"
   },
   {
      "type": "readable_field",
      "integration_type": "twinfield",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Twinfield"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "sumup",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "SumUp"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "region",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "net_amount",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "effective_rate",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "country",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "arrival_at",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-09-21T18:00:20.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "slow_fields",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "net_amount",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "arrival_at",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "SquareUp"
   },
   {
      "type": "pagination",
      "integration_type": "squareup",
      "created_at": "2026-09-21T18:00:20.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "slow_fields",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "spiris",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Spiris"
   },
   {
      "type": "readable_field",
      "integration_type": "spiris",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "books_close_at",
      "integration_name": "Spiris"
   },
   {
      "type": "readable_field",
      "integration_type": "shoplazza",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "Shoplazza"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "purchaseorder_ids",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "salla",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "hris",
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "country",
      "integration_name": "Salla"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "rillet",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Rillet"
   },
   {
      "type": "readable_field",
      "integration_type": "rillet",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Rillet"
   },
   {
      "type": "readable_field",
      "integration_type": "recurly",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Recurly"
   },
   {
      "type": "readable_field",
      "integration_type": "recurly",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "Recurly"
   },
   {
      "type": "readable_field",
      "integration_type": "ramp",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Ramp"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "transaction_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "total_amount",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "purchaseorder_ids",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "purchaseorder_ids",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "books_close_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "qonto",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Qonto"
   },
   {
      "type": "readable_field",
      "integration_type": "qonto",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Qonto"
   },
   {
      "type": "readable_field",
      "integration_type": "qonto",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Qonto"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "paytm",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Paytm"
   },
   {
      "type": "readable_field",
      "integration_type": "paytm",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "Paytm"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "country",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "books_close_at",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "myunisoft",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "MyUnisoft"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "is_inclusive_of_tax",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "is_inclusive_of_tax",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "moneybird",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Moneybird"
   },
   {
      "type": "readable_field",
      "integration_type": "moneris",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Moneris"
   },
   {
      "type": "readable_field",
      "integration_type": "moneris",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "Moneris"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "salesorder_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "is_inclusive_of_tax",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "lazada",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "Lazada"
   },
   {
      "type": "readable_field",
      "integration_type": "kashoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Kashoo"
   },
   {
      "type": "readable_field",
      "integration_type": "kashoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "region",
      "integration_name": "Kashoo"
   },
   {
      "type": "readable_field",
      "integration_type": "kashoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_compound",
      "integration_name": "Kashoo"
   },
   {
      "type": "readable_field",
      "integration_type": "kashoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Kashoo"
   },
   {
      "type": "readable_field",
      "integration_type": "kashoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "country",
      "integration_name": "Kashoo"
   },
   {
      "type": "readable_field",
      "integration_type": "kashoo",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "books_close_at",
      "integration_name": "Kashoo"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "purchaseorder_ids",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "books_close_at",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "hyperline",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Hyperline"
   },
   {
      "type": "readable_field",
      "integration_type": "hyperline",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "Hyperline"
   },
   {
      "type": "readable_field",
      "integration_type": "horus",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Horus"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "arrival_at",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2026-09-21T18:00:20.000Z",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "slow_fields",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "is_compound",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freeagent",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "FreeAgent"
   },
   {
      "type": "readable_field",
      "integration_type": "freeagent",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "FreeAgent"
   },
   {
      "type": "readable_field",
      "integration_type": "freeagent",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "FreeAgent"
   },
   {
      "type": "readable_field",
      "integration_type": "freeagent",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "FreeAgent"
   },
   {
      "type": "readable_field",
      "integration_type": "freeagent",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "is_compound",
      "integration_name": "FreeAgent"
   },
   {
      "type": "readable_field",
      "integration_type": "freeagent",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "FreeAgent"
   },
   {
      "type": "readable_field",
      "integration_type": "freeagent",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "FreeAgent"
   },
   {
      "type": "readable_field",
      "integration_type": "fortnox",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Fortnox"
   },
   {
      "type": "readable_field",
      "integration_type": "fortnox",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Fortnox"
   },
   {
      "type": "readable_field",
      "integration_type": "fortnox",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "is_inclusive_of_tax",
      "integration_name": "Fortnox"
   },
   {
      "type": "readable_field",
      "integration_type": "fortnox",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Fortnox"
   },
   {
      "type": "readable_field",
      "integration_type": "evoliz",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Evoliz"
   },
   {
      "type": "readable_field",
      "integration_type": "eboekhouden",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "e-Boekhouden.nl"
   },
   {
      "type": "readable_field",
      "integration_type": "ebay",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "eBay"
   },
   {
      "type": "readable_field",
      "integration_type": "ebay",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_payout",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "eBay"
   },
   {
      "type": "readable_field",
      "integration_type": "dualentry",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "DualEntry"
   },
   {
      "type": "readable_field",
      "integration_type": "datev",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "DATEV"
   },
   {
      "type": "readable_field",
      "integration_type": "clearbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "field": "transaction_at",
      "integration_name": "Clear Books"
   },
   {
      "type": "readable_field",
      "integration_type": "clearbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Clear Books"
   },
   {
      "type": "readable_field",
      "integration_type": "clearbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Clear Books"
   },
   {
      "type": "readable_field",
      "integration_type": "clearbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Clear Books"
   },
   {
      "type": "readable_field",
      "integration_type": "clearbooks",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Clear Books"
   },
   {
      "type": "readable_field",
      "integration_type": "campfire",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Campfire"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonpay",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Amazon Pay"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonpay",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "Amazon Pay"
   },
   {
      "type": "readable_field",
      "integration_type": "alegra",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "field": "sub_total_amount",
      "integration_name": "Alegra"
   },
   {
      "type": "readable_field",
      "integration_type": "alegra",
      "created_at": "2026-09-21T18:00:20.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Alegra"
   },
   {
      "type": "readable_field",
      "integration_type": "minox",
      "created_at": "2026-09-20T08:35:38.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Minox"
   },
   {
      "type": "object",
      "object_type": "genai_task",
      "integration_type": "googlejules",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "Google Jules"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "object_type": "genai_task",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "object_type": "genai_task",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "object_type": "genai_task",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2026-09-20T08:35:38.000Z",
      "object_type": "genai_task",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2026-09-20T08:35:38.000Z",
      "object_type": "genai_task",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2026-09-20T08:35:38.000Z",
      "object_type": "genai_task",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "object_type": "genai_task",
      "integration_type": "devin",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "Devin"
   },
   {
      "type": "object",
      "object_type": "genai_agent",
      "integration_type": "devin",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "Devin"
   },
   {
      "type": "object",
      "object_type": "genai_task",
      "integration_type": "cursor",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "Cursor"
   },
   {
      "type": "object",
      "object_type": "genai_task",
      "integration_type": "codegen",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "Codegen"
   },
   {
      "type": "object",
      "object_type": "genai_organization",
      "integration_type": "codegen",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "Codegen"
   },
   {
      "type": "object",
      "object_type": "genai_task",
      "integration_type": "anthropicagents",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "object",
      "object_type": "genai_agent",
      "integration_type": "anthropicagents",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "object",
      "object_type": "genai_organization",
      "integration_type": "anthropicagents",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2026-09-20T08:35:38.000Z",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "integration",
      "created_at": "2026-09-20T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "zai",
      "integration_name": "Z.ai"
   },
   {
      "type": "integration",
      "created_at": "2026-09-20T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "replicate",
      "integration_name": "Replicate"
   },
   {
      "type": "integration",
      "created_at": "2026-09-20T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "microsoftfoundry",
      "integration_name": "Microsoft Foundry"
   },
   {
      "type": "integration",
      "created_at": "2026-09-20T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "kimi",
      "integration_name": "Kimi"
   },
   {
      "type": "integration",
      "created_at": "2026-09-20T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "amazonbedrock",
      "integration_name": "Amazon Bedrock"
   },
   {
      "type": "integration",
      "created_at": "2026-09-19T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "integration_type": "orderlord",
      "integration_name": "OrderLord"
   },
   {
      "type": "integration",
      "created_at": "2026-09-19T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "googlejules",
      "integration_name": "Google Jules"
   },
   {
      "type": "integration",
      "created_at": "2026-09-19T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "devin",
      "integration_name": "Devin"
   },
   {
      "type": "integration",
      "created_at": "2026-09-19T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "cursor",
      "integration_name": "Cursor"
   },
   {
      "type": "integration",
      "created_at": "2026-09-19T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "codegen",
      "integration_name": "Codegen"
   },
   {
      "type": "integration",
      "created_at": "2026-09-19T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "avature",
      "integration_name": "Avature"
   },
   {
      "type": "integration",
      "created_at": "2026-09-19T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "anthropicagents",
      "integration_name": "Anthropic Claude Agents"
   },
   {
      "type": "pagination",
      "integration_type": "zohosign",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_status",
      "integration_name": "Zoho Sign"
   },
   {
      "type": "pagination",
      "integration_type": "zohopeople",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_status",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "yoobic",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "YOOBIC"
   },
   {
      "type": "pagination",
      "integration_type": "yoobic",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_status",
      "integration_name": "YOOBIC"
   },
   {
      "type": "pagination",
      "integration_type": "xodosign",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_status",
      "integration_name": "Xodo Sign"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_project",
      "pagination": "list_status",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "offers",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Wave"
   },
   {
      "type": "writable_field",
      "integration_type": "traffit",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Traffit"
   },
   {
      "type": "writable_field",
      "integration_type": "traffit",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Traffit"
   },
   {
      "type": "method",
      "integration_type": "traffit",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Traffit"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "net_amount",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "shortcut",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "Shortcut"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "ats_scorecard",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_status",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_status",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_status",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_status",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "radancy",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Radancy Employee Referrals"
   },
   {
      "type": "pagination",
      "integration_type": "radancy",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_status",
      "integration_name": "Radancy Employee Referrals"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "pivotaltracker",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "Pivotal Tracker"
   },
   {
      "type": "pagination",
      "integration_type": "pivotaltracker",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_status",
      "integration_name": "Pivotal Tracker"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "peopleforce",
      "object_type": "hris_timeoff",
      "integration_name": "PeopleForce"
   },
   {
      "type": "method",
      "integration_type": "peopleforce",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PeopleForce"
   },
   {
      "type": "method",
      "integration_type": "peopleforce",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PeopleForce"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_goal",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_effective_status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_effective_status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "manatal",
      "object_type": "ats_activity",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Manatal"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "social_post",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "kevel",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_status",
      "integration_name": "Kevel"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobcase",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Jobcase"
   },
   {
      "type": "pagination",
      "integration_type": "jobaffinity",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "JobAffinity"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobaffinity",
      "object_type": "ats_activity",
      "integration_name": "JobAffinity"
   },
   {
      "type": "method",
      "integration_type": "jobaffinity",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobAffinity"
   },
   {
      "type": "method",
      "integration_type": "jobaffinity",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobAffinity"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "exchange_rate",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_status",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "gr8people",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "GR8 People"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googleslides",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Slides"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "googleslides",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Slides"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googleslides",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Slides"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "googleslides",
      "object_type": "storage_file",
      "integration_name": "Google Slides"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "googleslides",
      "object_type": "hris_employee",
      "integration_name": "Google Slides"
   },
   {
      "type": "method",
      "integration_type": "googleslides",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Slides"
   },
   {
      "type": "method",
      "integration_type": "googleslides",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Slides"
   },
   {
      "type": "method",
      "integration_type": "googleslides",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Slides"
   },
   {
      "type": "method",
      "integration_type": "googleslides",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Slides"
   },
   {
      "type": "method",
      "integration_type": "googleslides",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Slides"
   },
   {
      "type": "method",
      "integration_type": "googleslides",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Slides"
   },
   {
      "type": "method",
      "integration_type": "googleslides",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Slides"
   },
   {
      "type": "pagination",
      "integration_type": "googlesa360",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_status",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlesa360",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_status",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlesa360",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_status",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googledocs",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Docs"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "googledocs",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Docs"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googledocs",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Docs"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "googledocs",
      "object_type": "storage_file",
      "integration_name": "Google Docs"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "googledocs",
      "object_type": "hris_employee",
      "integration_name": "Google Docs"
   },
   {
      "type": "method",
      "integration_type": "googledocs",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Docs"
   },
   {
      "type": "method",
      "integration_type": "googledocs",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Docs"
   },
   {
      "type": "method",
      "integration_type": "googledocs",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Docs"
   },
   {
      "type": "method",
      "integration_type": "googledocs",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Docs"
   },
   {
      "type": "method",
      "integration_type": "googledocs",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Docs"
   },
   {
      "type": "method",
      "integration_type": "googledocs",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Docs"
   },
   {
      "type": "method",
      "integration_type": "googledocs",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Docs"
   },
   {
      "type": "pagination",
      "integration_type": "googleanalytics",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_dimension",
      "integration_name": "Google Analytics"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "width",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "height",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_status",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_effective_status",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_status",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_effective_status",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_status",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_status",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_campaign_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubapp",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "freshteam",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Freshteam"
   },
   {
      "type": "pagination",
      "integration_type": "flipkart",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_status",
      "integration_name": "Flipkart"
   },
   {
      "type": "pagination",
      "integration_type": "flipkart",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "virtual_webhook_status",
      "integration_name": "Flipkart"
   },
   {
      "type": "readable_field",
      "integration_type": "exactonline",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "field": "website",
      "integration_name": "Exact Online"
   },
   {
      "type": "readable_field",
      "integration_type": "exactonline",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Exact Online"
   },
   {
      "type": "pagination",
      "integration_type": "dayforce",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_status",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "pagination",
      "integration_type": "darwinbox",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_status",
      "integration_name": "Darwinbox"
   },
   {
      "type": "pagination",
      "integration_type": "darwinbox",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_status",
      "integration_name": "Darwinbox"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Clear Company"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "brightmove",
      "object_type": "ats_activity",
      "integration_name": "BrightMove"
   },
   {
      "type": "method",
      "integration_type": "brightmove",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BrightMove"
   },
   {
      "type": "method",
      "integration_type": "brightmove",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BrightMove"
   },
   {
      "type": "method",
      "integration_type": "brightmove",
      "created_at": "2026-09-18T17:34:37.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BrightMove"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_status",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "applicantpro",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "ApplicantPro"
   },
   {
      "type": "pagination",
      "integration_type": "applicantpro",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "ApplicantPro"
   },
   {
      "type": "pagination",
      "integration_type": "appleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_status",
      "integration_name": "Apple Ads"
   },
   {
      "type": "pagination",
      "integration_type": "appleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_status",
      "integration_name": "Apple Ads"
   },
   {
      "type": "pagination",
      "integration_type": "appleads",
      "created_at": "2026-09-18T17:34:37.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_status",
      "integration_name": "Apple Ads"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "hris_timeshift",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "integration_type": "xero",
      "object_type": "hris_group",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "is_private",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "calendar_id",
      "integration_name": "Webex"
   },
   {
      "type": "readable_field",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "twitter",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "Twitter"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trinet",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "trinet",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "trinet",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trinet",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "trinet",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "pagination",
      "integration_type": "trinet",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "tribepad",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Tribepad"
   },
   {
      "type": "readable_field",
      "integration_type": "talkpush",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Talkpush"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "application_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "application_id",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "writable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "SquareUp"
   },
   {
      "type": "writable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "SquareUp"
   },
   {
      "type": "writable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "SquareUp"
   },
   {
      "type": "writable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "SquareUp"
   },
   {
      "type": "writable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "SquareUp"
   },
   {
      "type": "writable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SquareUp"
   },
   {
      "type": "writable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "is_private",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "application_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "method",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "method",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sagehr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Sage HR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sagehr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_job",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_job_id",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage HR"
   },
   {
      "type": "method",
      "integration_type": "sagehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_interview",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_interview",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_interview",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_interview",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_interview",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recruitcrm",
      "object_type": "ats_interview",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "object_type": "accounting_invoice",
      "pagination": "native_webhook_updated_gte",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "proliant",
      "object_type": "hris_timeoff",
      "integration_name": "Proliant"
   },
   {
      "type": "method",
      "integration_type": "proliant",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Proliant"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "summary",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "summary",
      "integration_name": "Pinpoint"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "hris_timeshift",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "pageup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "PageUp"
   },
   {
      "type": "pagination",
      "integration_type": "pageup",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "PageUp"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "oraclejde",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "pagination",
      "integration_type": "oraclejde",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "pagination",
      "integration_type": "oraclejde",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "pagination",
      "integration_type": "oraclejde",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "readable_field",
      "integration_type": "oleeo",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Oleeo"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "keka",
      "object_type": "hris_timeshift",
      "integration_name": "Keka"
   },
   {
      "type": "method",
      "integration_type": "keka",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Keka"
   },
   {
      "type": "readable_field",
      "integration_type": "join",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "JOIN"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "ats_scorecard",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jboard",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Jboard"
   },
   {
      "type": "readable_field",
      "integration_type": "jboard",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "Jboard"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "humanforce",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Humanforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "humanforce",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Humanforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humanforce",
      "object_type": "hris_timeshift",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Humanforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "hris_company",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gitlabdedicated",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gitlabdedicated",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "gitlabdedicated",
      "object_type": "storage_file",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "method",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "method",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gitlab",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "integration_name": "GitLab"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gitlab",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "integration_name": "GitLab"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "gitlab",
      "object_type": "storage_file",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "githubapp",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "readable_field",
      "integration_type": "githubapp",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "readable_field",
      "integration_type": "githubapp",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "accounting_account",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "accounting_category",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "commerce_item",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "commerce_item",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "accounting_account",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "accounting_category",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "commerce_item",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "integration_type": "factorialhr",
      "object_type": "hris_timeshift",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "writable_field",
      "integration_type": "facebook",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "Facebook"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "employmentheropayroll",
      "object_type": "hris_timeoff",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "method",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "employmenthero",
      "object_type": "hris_timeshift",
      "integration_name": "Employment Hero"
   },
   {
      "type": "method",
      "integration_type": "employmenthero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Employment Hero"
   },
   {
      "type": "method",
      "integration_type": "employmenthero",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "dvinci",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "d.vinci"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "integration_type": "darwinbox",
      "object_type": "hris_timeshift",
      "integration_name": "Darwinbox"
   },
   {
      "type": "method",
      "integration_type": "darwinbox",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Darwinbox"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_event",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_event",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "capsulecrm",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "capsulecrm",
      "object_type": "crm_contact",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "capsulecrm",
      "object_type": "crm_company",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "capsulecrm",
      "object_type": "crm_deal",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "capsulecrm",
      "object_type": "crm_pipeline",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "capsulecrm",
      "object_type": "crm_event",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "capsulecrm",
      "object_type": "hris_employee",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_contact",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_company",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_event",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_event",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_event",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_event",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "crm_event",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "method",
      "integration_type": "capsulecrm",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "summary",
      "integration_name": "BreezyHR"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "breathehr",
      "object_type": "hris_timeoff",
      "integration_name": "BreatheHR"
   },
   {
      "type": "method",
      "integration_type": "breathehr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreatheHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bluesky",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "Bluesky"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "integration_type": "bamboohr",
      "object_type": "hris_timeshift",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2026-09-18T12:52:11.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "storage",
         "passthrough"
      ],
      "integration_type": "azuredevops",
      "object_type": "storage_file",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "method",
      "integration_type": "azuredevops",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "task",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "method",
      "integration_type": "azuredevops",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "task",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "readable_field",
      "integration_type": "arcoro",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Arcoro"
   },
   {
      "type": "readable_field",
      "integration_type": "arcoro",
      "created_at": "2026-09-18T12:52:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Arcoro"
   },
   {
      "type": "integration",
      "created_at": "2026-09-18T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "paytabs",
      "integration_name": "PayTabs"
   },
   {
      "type": "integration",
      "created_at": "2026-09-18T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "monster",
      "integration_name": "Monster"
   },
   {
      "type": "object",
      "created_at": "2026-09-17T18:25:35.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zellis",
      "object_type": "hris_timeoff",
      "integration_name": "Zellis"
   },
   {
      "type": "method",
      "integration_type": "zellis",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zellis"
   },
   {
      "type": "object",
      "created_at": "2026-09-17T18:25:35.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zambion",
      "object_type": "hris_timeoff",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "method",
      "integration_type": "zambion",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "method",
      "integration_type": "zambion",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "readable_field",
      "integration_type": "wish",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "Wish"
   },
   {
      "type": "readable_field",
      "integration_type": "wish",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Wish"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "unit4erpx",
      "categories": [
         "hris",
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Unit4 ERPx"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "unit4erpx",
      "categories": [
         "hris",
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Unit4 ERPx"
   },
   {
      "type": "object",
      "created_at": "2026-09-17T18:25:35.000Z",
      "categories": [
         "hris",
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "integration_type": "unit4erpx",
      "object_type": "hris_timeoff",
      "integration_name": "Unit4 ERPx"
   },
   {
      "type": "method",
      "integration_type": "unit4erpx",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Unit4 ERPx"
   },
   {
      "type": "object",
      "created_at": "2026-09-17T18:25:35.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "integration_type": "tiktok",
      "object_type": "social_post",
      "integration_name": "TikTok"
   },
   {
      "type": "object",
      "created_at": "2026-09-17T18:25:35.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "integration_type": "tiktok",
      "object_type": "social_profile",
      "integration_name": "TikTok"
   },
   {
      "type": "method",
      "integration_type": "tiktok",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TikTok"
   },
   {
      "type": "method",
      "integration_type": "tiktok",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TikTok"
   },
   {
      "type": "method",
      "integration_type": "tiktok",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TikTok"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-09-17T18:25:35.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "hris_timeshift",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-09-17T18:25:35.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "foundu",
      "object_type": "hris_timeshift",
      "integration_name": "foundU"
   },
   {
      "type": "method",
      "integration_type": "foundu",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "foundU"
   },
   {
      "type": "object",
      "created_at": "2026-09-17T18:25:35.000Z",
      "categories": [
         "hris",
         "ats",
         "forms",
         "passthrough"
      ],
      "integration_type": "clayhr",
      "object_type": "hris_timeoff",
      "integration_name": "ClayHR"
   },
   {
      "type": "method",
      "integration_type": "clayhr",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "forms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ClayHR"
   },
   {
      "type": "object",
      "created_at": "2026-09-17T18:25:35.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "integration_type": "bamboohr",
      "object_type": "hris_benefit",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-09-17T18:25:35.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "hris_timeshift",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "hris_timeshift",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "rosnet",
      "object_type": "hris_timeshift",
      "integration_name": "Rosnet"
   },
   {
      "type": "method",
      "integration_type": "rosnet",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rosnet"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksworkforce",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "QuickBooks Workforce"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "tags",
      "integration_name": "Pinpoint"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "multiplier",
      "object_type": "hris_timeoff",
      "integration_name": "Multiplier"
   },
   {
      "type": "method",
      "integration_type": "multiplier",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Multiplier"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "kms_page",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "native_webhook_parent_id",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "irishr",
      "object_type": "hris_timeoff",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "humanforce",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Humanforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "humanforce",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Humanforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humanforce",
      "object_type": "hris_timeoff",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Humanforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "humaans",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Humaans"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "humaans",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Humaans"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humaans",
      "object_type": "hris_timeoff",
      "integration_name": "Humaans"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humaans",
      "object_type": "passthrough",
      "integration_name": "Humaans"
   },
   {
      "type": "method",
      "integration_type": "humaans",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Humaans"
   },
   {
      "type": "method",
      "integration_type": "humaans",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Humaans"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hrcloud",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "HR Cloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hrcloud",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "HR Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "hrcloud",
      "object_type": "hris_timeoff",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HR Cloud"
   },
   {
      "type": "method",
      "integration_type": "hrcloud",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HR Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "foundu",
      "object_type": "hris_timeoff",
      "integration_name": "foundU"
   },
   {
      "type": "method",
      "integration_type": "foundu",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "foundU"
   },
   {
      "type": "method",
      "integration_type": "flatchr",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Flatchr"
   },
   {
      "type": "method",
      "integration_type": "flatchr",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Flatchr"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "dayforce",
      "object_type": "hris_document",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T16:09:23.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "breezyhr",
      "object_type": "ats_applicationstatus",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-09-16T16:09:23.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-09-16T10:15:23.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-09-16T10:15:23.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "slow_fields",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T10:15:23.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "oreilly",
      "object_type": "hris_taxonomy",
      "integration_name": "O'Reilly"
   },
   {
      "type": "method",
      "integration_type": "oreilly",
      "created_at": "2026-09-16T10:15:23.000Z",
      "object_type": "hris_taxonomy",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "O'Reilly"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "mongodb",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-16T10:15:23.000Z",
      "object_type": "datastore_database",
      "integration_name": "MongoDB"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "mongodb",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-16T10:15:23.000Z",
      "object_type": "datastore_database",
      "integration_name": "MongoDB"
   },
   {
      "type": "pagination",
      "integration_type": "mongodb",
      "created_at": "2026-09-16T10:15:23.000Z",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "object_type": "datastore_table",
      "pagination": "list_limit",
      "integration_name": "MongoDB"
   },
   {
      "type": "object",
      "created_at": "2026-09-16T10:15:23.000Z",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "integration_type": "mongodb",
      "object_type": "hris_device",
      "integration_name": "MongoDB"
   },
   {
      "type": "method",
      "integration_type": "mongodb",
      "created_at": "2026-09-16T10:15:23.000Z",
      "object_type": "hris_device",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MongoDB"
   },
   {
      "type": "method",
      "integration_type": "mongodb",
      "created_at": "2026-09-16T10:15:23.000Z",
      "object_type": "hris_device",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MongoDB"
   },
   {
      "type": "readable_field",
      "integration_type": "justworks",
      "created_at": "2026-09-16T10:15:23.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "Justworks"
   },
   {
      "type": "pagination",
      "integration_type": "justworks",
      "created_at": "2026-09-16T10:15:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Justworks"
   },
   {
      "type": "integration",
      "created_at": "2026-09-16T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "7shifts",
      "integration_name": "7shifts"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_type",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_type",
      "integration_name": "Teamtailor"
   },
   {
      "type": "object",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "teamtailor",
      "object_type": "hris_location",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "asset_urls",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "hosting_source",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "asset_urls",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "object",
      "created_at": "2026-09-15T12:22:37.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "googlecampaignmanager360",
      "object_type": "ads_asset",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "method",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-09-15T12:22:37.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-09-14T10:32:50.000Z",
      "object_type": "ats_application",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "applied_at",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2026-09-14T10:32:50.000Z",
      "object_type": "ats_application",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "applied_at",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-09-14T10:32:50.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-09-14T10:32:50.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Eightfold"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-09-14T10:32:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "integration",
      "created_at": "2026-09-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "nicecxone",
      "integration_name": "NICE CXone"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-09-11T09:20:17.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "Teamtailor"
   },
   {
      "type": "object",
      "created_at": "2026-09-11T09:20:17.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "teamtailor",
      "object_type": "ats_company",
      "integration_name": "Teamtailor"
   },
   {
      "type": "object",
      "created_at": "2026-09-11T09:20:17.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "teamtailor",
      "object_type": "ats_activity",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-11T09:20:17.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-11T09:20:17.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-11T09:20:17.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-11T09:20:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-09-11T09:20:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "wayfair",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Wayfair"
   },
   {
      "type": "readable_field",
      "integration_type": "wayfair",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Wayfair"
   },
   {
      "type": "readable_field",
      "integration_type": "tiendanube",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Tiendanube"
   },
   {
      "type": "readable_field",
      "integration_type": "tiendanube",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Tiendanube"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shipstation",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "weight_unit",
      "integration_name": "ShipStation"
   },
   {
      "type": "readable_field",
      "integration_type": "shipstation",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "weight",
      "integration_name": "ShipStation"
   },
   {
      "type": "readable_field",
      "integration_type": "shipstation",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "ShipStation"
   },
   {
      "type": "readable_field",
      "integration_type": "shipbob",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "field": "weight_unit",
      "integration_name": "ShipBob"
   },
   {
      "type": "readable_field",
      "integration_type": "shipbob",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "field": "weight",
      "integration_name": "ShipBob"
   },
   {
      "type": "readable_field",
      "integration_type": "shipbob",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "ShipBob"
   },
   {
      "type": "readable_field",
      "integration_type": "shipbob",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "field": "requires_shipping",
      "integration_name": "ShipBob"
   },
   {
      "type": "readable_field",
      "integration_type": "shipbob",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "field": "inventory_id",
      "integration_name": "ShipBob"
   },
   {
      "type": "readable_field",
      "integration_type": "shipbob",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "ShipBob"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "weight_unit",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "weight",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "planned_spend_amount",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "frequency_cap",
      "integration_name": "Meta Ads"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "ads_target",
      "integration_name": "Meta Ads"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "ads_target",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "planned_spend_amount",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "headline",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "frequency_cap",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_updated_gte",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_limit",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_offset",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "virtual_webhook_type",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-09-10T17:31:20.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "lazada",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "weight",
      "integration_name": "Lazada"
   },
   {
      "type": "writable_field",
      "integration_type": "lazada",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "Lazada"
   },
   {
      "type": "writable_field",
      "integration_type": "lazada",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Lazada"
   },
   {
      "type": "writable_field",
      "integration_type": "lazada",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Lazada"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Keap"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_category",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "payment_payment",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_category",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "payment_payment",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_category",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "payment_payment",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "fastmag",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Fastmag"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2026-09-10T17:31:20.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "BigCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workable",
      "object_type": "ats_company",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_order",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "storage_file",
      "integration_name": "Google"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "storage_file",
      "integration_name": "Google"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "storage_file",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "storage_file",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "hris_employee",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "datastore_database",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "datastore_table",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "datastore_record",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "datastore_query",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "datastore_database",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "datastore_database",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "datastore_table",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "datastore_table",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "datastore_record",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "datastore_record",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "datastore_record",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "datastore_record",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "datastore_query",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "storage",
         "hris",
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T16:20:31.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "bullhorn",
      "object_type": "ats_scorecard",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-09-09T16:20:31.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-09T14:44:59.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-09T14:44:59.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Workable"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T14:44:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workable",
      "object_type": "ats_scorecard",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2026-09-09T14:44:59.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2026-09-09T14:44:59.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_order",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2026-09-09T14:44:59.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_order",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2026-09-09T14:44:59.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2026-09-09T14:44:59.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gmail"
   },
   {
      "type": "pagination",
      "integration_type": "google",
      "created_at": "2026-09-09T14:44:59.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "firefish",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-09T14:44:59.000Z",
      "object_type": "crm_lead",
      "integration_name": "Firefish"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "firefish",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-09T14:44:59.000Z",
      "object_type": "crm_lead",
      "integration_name": "Firefish"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T14:44:59.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "firefish",
      "object_type": "crm_lead",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-09T14:44:59.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-09T14:44:59.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-09T14:44:59.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2026-09-09T14:44:59.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-09-09T11:37:18.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "slow_fields",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "writable_field",
      "integration_type": "zohoinventory",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Zoho Inventory"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgpro",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "method",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "ats_activity",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "ats_activity",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "object",
      "created_at": "2026-09-09T11:37:18.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "smartrecruiters",
      "object_type": "ats_activity",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "method",
      "integration_type": "smartrecruiters",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "planhat",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Planhat"
   },
   {
      "type": "readable_field",
      "integration_type": "planhat",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Planhat"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Personio"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "ats_candidate",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "ats_job",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "ats_candidate",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "ats_job",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "ats_candidate",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "ats_job",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "affinity",
      "created_at": "2026-09-09T11:37:18.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Affinity"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohocampaigns",
      "integration_name": "Zoho Campaigns"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "wechatpay",
      "integration_name": "WeChat Pay"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "sailthru",
      "integration_name": "Sailthru"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "pluralsight",
      "integration_name": "Pluralsight"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "pivotaltracker",
      "integration_name": "Pivotal Tracker"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "martech",
         "commerce",
         "storage",
         "passthrough"
      ],
      "integration_type": "omnisend",
      "integration_name": "Omnisend"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "moneris",
      "integration_name": "Moneris"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "ticketing",
         "uc",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicscontactcenter",
      "integration_name": "Microsoft Dynamics 365 Contact Center"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "metamuse",
      "integration_name": "Meta Muse"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "leadfuze",
      "integration_name": "LeadFuze"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobber",
      "integration_name": "Jobber"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "glue",
      "integration_name": "Glue"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "eboekhouden",
      "integration_name": "e-Boekhouden.nl"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "martech",
         "hris",
         "passthrough"
      ],
      "integration_type": "drip",
      "integration_name": "Drip"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "crm",
         "calendar",
         "hris",
         "task",
         "accounting",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "clio",
      "integration_name": "Clio"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "chargefy",
      "integration_name": "Chargefy"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "aviato",
      "integration_name": "Aviato"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "appleads",
      "integration_name": "Apple Ads"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "amazonpay",
      "integration_name": "Amazon Pay"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "alipay",
      "integration_name": "Alipay"
   },
   {
      "type": "integration",
      "created_at": "2026-09-09T00:00:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "crm",
         "commerce",
         "passthrough"
      ],
      "integration_type": "accountingseed",
      "integration_name": "Accounting Seed"
   },
   {
      "type": "integration",
      "created_at": "2026-09-08T00:00:00.000Z",
      "categories": [
         "crm",
         "martech",
         "ticketing",
         "kms",
         "commerce",
         "passthrough"
      ],
      "integration_type": "usercom",
      "integration_name": "User.com"
   },
   {
      "type": "integration",
      "created_at": "2026-09-08T00:00:00.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "sendinblue",
      "integration_name": "Brevo"
   },
   {
      "type": "integration",
      "created_at": "2026-09-08T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "salesql",
      "integration_name": "SalesQL"
   },
   {
      "type": "integration",
      "created_at": "2026-09-08T00:00:00.000Z",
      "categories": [
         "martech",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "icontact",
      "integration_name": "iContact"
   },
   {
      "type": "integration",
      "created_at": "2026-09-08T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "fieldassist",
      "integration_name": "Field Assist"
   },
   {
      "type": "integration",
      "created_at": "2026-09-08T00:00:00.000Z",
      "categories": [
         "crm",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dexcrm",
      "integration_name": "Dex CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-09-08T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "buk",
      "integration_name": "Buk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "object",
      "created_at": "2026-09-07T13:34:27.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "ats_scorecard",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-07T13:34:27.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "ticketing_ticket",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-07T13:34:27.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "ticketing_customer",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-07T13:34:27.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "ticketing_note",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2026-09-07T13:34:27.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "ticketing_category",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "ticketing",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "rippling",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-09-07T13:34:27.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "odoo",
      "object_type": "accounting_salesorder",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-09-07T13:34:27.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "ninjaone",
      "object_type": "hris_device",
      "integration_name": "NinjaOne"
   },
   {
      "type": "method",
      "integration_type": "ninjaone",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "hris_device",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NinjaOne"
   },
   {
      "type": "method",
      "integration_type": "ninjaone",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "hris_device",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NinjaOne"
   },
   {
      "type": "readable_field",
      "integration_type": "dropbox",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "version",
      "integration_name": "Dropbox"
   },
   {
      "type": "method",
      "integration_type": "dropbox",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Dropbox"
   },
   {
      "type": "method",
      "integration_type": "dropbox",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Dropbox"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_interview",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_interview",
      "integration_name": "Crelate"
   },
   {
      "type": "object",
      "created_at": "2026-09-07T13:34:27.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "crelate",
      "object_type": "ats_interview",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2026-09-07T13:34:27.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-09-07T13:34:27.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_application_id",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "yandexads",
      "integration_name": "Yandex Ads"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "temu",
      "integration_name": "Temu"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "nutshell",
      "integration_name": "Nutshell"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "lumesse",
      "integration_name": "Lumesse TalentLink"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "limecrm",
      "integration_name": "Lime CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "helpjuice",
      "integration_name": "HelpJuice"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "cloudonix",
      "integration_name": "Cloudonix"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "basis",
      "integration_name": "Basis Technologies"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "atlashxm",
      "integration_name": "Atlas HXM"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "accounting",
         "shipping",
         "passthrough"
      ],
      "integration_type": "amazonvendorcentral",
      "integration_name": "Amazon Vendor Central"
   },
   {
      "type": "integration",
      "created_at": "2026-09-06T00:00:00.000Z",
      "categories": [
         "ads",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "adroll",
      "integration_name": "AdRoll"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "vectron",
      "integration_name": "Vectron"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "taboola",
      "integration_name": "Taboola"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "snaphire",
      "integration_name": "SnapHire"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "integration_type": "sambasafety",
      "integration_name": "SambaSafety"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ovhcloud",
      "integration_name": "OVHcloud"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "ads",
         "hris",
         "passthrough"
      ],
      "integration_type": "outbrain",
      "integration_name": "Outbrain"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "nethris",
      "integration_name": "Nethris"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "manageengine",
      "integration_name": "ManageEngine MDM"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "journeyfront",
      "integration_name": "Journeyfront"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "hravatar",
      "integration_name": "HR Avatar"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "halogen_saba",
      "integration_name": "Cornerstone Saba"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "gonnaorder",
      "integration_name": "GonnaOrder"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "equativ",
      "integration_name": "Equativ"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "eci",
      "integration_name": "ECI JobBOSS²"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "cyclance",
      "integration_name": "Cyclance MDM"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "criteo",
      "integration_name": "Criteo"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "commerce",
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "integration_type": "aquilacms",
      "integration_name": "Aquila CMS"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "applesearchads",
      "integration_name": "Apple Search Ads"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "aloha",
      "integration_name": "Aloha"
   },
   {
      "type": "integration",
      "created_at": "2026-09-05T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "adform",
      "integration_name": "Adform"
   },
   {
      "type": "object",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workstream",
      "object_type": "ats_applicationstatus",
      "integration_name": "Workstream"
   },
   {
      "type": "method",
      "integration_type": "workstream",
      "created_at": "2026-09-04T13:19:47.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_start_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_end_lt",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_approver_user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_approver_user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_account_id",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_start_gte",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_end_lt",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_account_id",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-09-04T13:19:47.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-09-04T13:19:47.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-09-04T13:19:47.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "concurcompany",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_approver_user_id",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "pagination",
      "integration_type": "concurcompany",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_approver_user_id",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_order",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_order",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-09-04T13:19:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "BreezyHR"
   },
   {
      "type": "object",
      "created_at": "2026-09-04T13:19:47.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "breezyhr",
      "object_type": "ats_scorecard",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-09-04T13:19:47.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-09-04T13:19:47.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BreezyHR"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohoinventory",
      "integration_name": "Zoho Inventory"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "integration_type": "zohobigin",
      "integration_name": "Zoho Bigin"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "wheniwork",
      "integration_name": "When I Work"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "integration_type": "verifiedfirst",
      "integration_name": "Verified First"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "verification",
         "auth",
         "passthrough"
      ],
      "integration_type": "trustid",
      "integration_name": "TrustID"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "talentreef",
      "integration_name": "TalentReef"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "sertifi",
      "integration_name": "Sertifi"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "hris",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "sentry",
      "integration_name": "Sentry"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "revver",
      "integration_name": "Revver"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "hris",
         "forms",
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "qualtrics",
      "integration_name": "Qualtrics"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "lawcruit",
      "integration_name": "LawCruit"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "clarifygo",
      "integration_name": "ClarifyGo"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "cigna",
      "integration_name": "Cigna"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "beamery",
      "integration_name": "Beamery"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "banner",
      "integration_name": "Banner"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "applicantpro",
      "integration_name": "ApplicantPro"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "hris",
         "storage",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "agendrix",
      "integration_name": "Agendrix"
   },
   {
      "type": "integration",
      "created_at": "2026-09-04T00:00:00.000Z",
      "categories": [
         "verification",
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "accurate",
      "integration_name": "Accurate"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Zoho People"
   },
   {
      "type": "writable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Zoho People"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohopeople",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_group",
      "integration_name": "Zoho People"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohopeople",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_taxonomy",
      "integration_name": "Zoho People"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohopeople",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_group",
      "integration_name": "Zoho People"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohopeople",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_taxonomy",
      "integration_name": "Zoho People"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohopeople",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Zoho People"
   },
   {
      "type": "pagination",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho People"
   },
   {
      "type": "pagination",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoho People"
   },
   {
      "type": "pagination",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Zoho People"
   },
   {
      "type": "object",
      "created_at": "2026-09-03T13:02:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "hris_group",
      "integration_name": "Zoho People"
   },
   {
      "type": "object",
      "created_at": "2026-09-03T13:02:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "hris_taxonomy",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_taxonomy",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_taxonomy",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_taxonomy",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-09-03T13:02:28.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "ats_company",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-09-03T13:02:28.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohodesk",
      "integration_name": "Zoho Desk"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "waalaxy",
      "integration_name": "Waalaxy"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "silae",
      "integration_name": "Silae"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "integration_type": "shipbob",
      "integration_name": "ShipBob"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "sailpoint",
      "integration_name": "SailPoint"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "paddle",
      "integration_name": "Paddle"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "integration_type": "overloop",
      "integration_name": "Overloop"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "outseta",
      "integration_name": "Outseta"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "myunisoft",
      "integration_name": "MyUnisoft"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "mykademy",
      "integration_name": "Mykademy"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "minox",
      "integration_name": "Minox"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "crm",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "iris",
      "integration_name": "IRIS CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "instructure",
      "integration_name": "Instructure Canvas"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "innovorder",
      "integration_name": "Innovorder"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "hiboutik",
      "integration_name": "Hiboutik"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "freewheel",
      "integration_name": "FreeWheel"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "fastmag",
      "integration_name": "Fastmag"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "factomos",
      "integration_name": "Factomos"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "ebpgestioncommerciale",
      "integration_name": "EBP Gestion Commerciale Open Line"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "cvviz",
      "integration_name": "CVViZ"
   },
   {
      "type": "integration",
      "created_at": "2026-09-03T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "benchmarkemail",
      "integration_name": "Benchmark Email"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-09-02T12:26:04.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_offset",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubapp",
      "created_at": "2026-09-02T12:26:04.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_offset",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-09-02T12:26:04.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_offset",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "careerplug",
      "created_at": "2026-09-02T12:26:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "CareerPlug"
   },
   {
      "type": "pagination",
      "integration_type": "careerplug",
      "created_at": "2026-09-02T12:26:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "CareerPlug"
   },
   {
      "type": "pagination",
      "integration_type": "careerplug",
      "created_at": "2026-09-02T12:26:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "CareerPlug"
   },
   {
      "type": "pagination",
      "integration_type": "careerplug",
      "created_at": "2026-09-02T12:26:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "CareerPlug"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-02T11:25:26.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-09-02T11:25:26.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2026-09-02T11:25:26.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "hris_payslip",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-09-02T11:25:26.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-09-02T11:25:26.000Z",
      "object_type": "hris_employee",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-09-02T11:25:26.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-09-02T11:25:26.000Z",
      "object_type": "hris_employee",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-09-02T11:25:26.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-09-02T11:25:26.000Z",
      "object_type": "hris_employee",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-09-02T11:25:26.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "HiBob"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "vosfactures",
      "integration_name": "VosFactures"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "sevdesk",
      "integration_name": "sevDesk"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "reviso",
      "integration_name": "Reviso"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "octopus",
      "integration_name": "Octopus"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "crm",
         "commerce",
         "passthrough"
      ],
      "integration_type": "mews",
      "integration_name": "Mews"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "maverickpayments",
      "integration_name": "Maverick Payments"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "commerce",
         "payment",
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "lastapp",
      "integration_name": "LastApp"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobaffinity",
      "integration_name": "JobAffinity"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "idfy",
      "integration_name": "IDfy"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "hyperline",
      "integration_name": "Hyperline"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "commerce",
         "crm",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "housecallpro",
      "integration_name": "Housecall Pro"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "feefo",
      "integration_name": "Feefo"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "dolibarr",
      "integration_name": "Dolibarr"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "crossknowledge",
      "integration_name": "CrossKnowledge"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "commerce",
         "crm",
         "passthrough"
      ],
      "integration_type": "cloudbeds",
      "integration_name": "Cloudbeds"
   },
   {
      "type": "integration",
      "created_at": "2026-09-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "a3erp",
      "integration_name": "a3ERP"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-01T17:54:05.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "type",
      "integration_name": "Pinpoint"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-01T17:54:05.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "job_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-01T17:54:05.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "job_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-01T17:54:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "external_identifier",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-09-01T17:54:05.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "application_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-09-01T17:54:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "object_type": "ats_document",
      "pagination": "list_application_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-09-01T17:54:05.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "method": "create",
      "integration_name": "Pinpoint"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "coda",
      "categories": [
         "kms",
         "passthrough"
      ],
      "created_at": "2026-09-01T17:54:05.000Z",
      "object_type": "kms_page",
      "integration_name": "Coda"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "coda",
      "categories": [
         "kms",
         "passthrough"
      ],
      "created_at": "2026-09-01T17:54:05.000Z",
      "object_type": "kms_page",
      "integration_name": "Coda"
   },
   {
      "type": "pagination",
      "integration_type": "coda",
      "created_at": "2026-09-01T17:54:05.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_space_id",
      "integration_name": "Coda"
   },
   {
      "type": "pagination",
      "integration_type": "coda",
      "created_at": "2026-09-01T17:54:05.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Coda"
   },
   {
      "type": "pagination",
      "integration_type": "coda",
      "created_at": "2026-09-01T17:54:05.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Coda"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timeoff_days_used",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timeoff_days_total",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Zoho People"
   },
   {
      "type": "pagination",
      "integration_type": "zohopeople",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Zoho People"
   },
   {
      "type": "object",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "object_type": "hris_timeoff",
      "integration_name": "Zoho People"
   },
   {
      "type": "method",
      "integration_type": "zohopeople",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho People"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "paradox",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_application",
      "integration_name": "Paradox"
   },
   {
      "type": "object",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "paradox",
      "object_type": "ats_application",
      "integration_name": "Paradox"
   },
   {
      "type": "object",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "paradox",
      "object_type": "ats_applicationstatus",
      "integration_name": "Paradox"
   },
   {
      "type": "object",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "paradox",
      "object_type": "hris_location",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Paradox"
   },
   {
      "type": "method",
      "integration_type": "paradox",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paradox"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_order",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "hireology",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Hireology"
   },
   {
      "type": "readable_field",
      "integration_type": "hireology",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Hireology"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "task_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_limit",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_offset",
      "integration_name": "ClickUp"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "careerplug",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_application",
      "integration_name": "CareerPlug"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "careerplug",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "integration_name": "CareerPlug"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "careerplug",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_application",
      "integration_name": "CareerPlug"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "careerplug",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_candidate",
      "integration_name": "CareerPlug"
   },
   {
      "type": "pagination",
      "integration_type": "careerplug",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "CareerPlug"
   },
   {
      "type": "pagination",
      "integration_type": "careerplug",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "CareerPlug"
   },
   {
      "type": "object",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "careerplug",
      "object_type": "ats_applicationstatus",
      "integration_name": "CareerPlug"
   },
   {
      "type": "object",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "careerplug",
      "object_type": "ats_company",
      "integration_name": "CareerPlug"
   },
   {
      "type": "method",
      "integration_type": "careerplug",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CareerPlug"
   },
   {
      "type": "method",
      "integration_type": "careerplug",
      "created_at": "2026-09-01T12:56:28.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CareerPlug"
   },
   {
      "type": "pagination",
      "integration_type": "agencyzoom",
      "created_at": "2026-09-01T12:56:28.000Z",
      "categories": [
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_offset",
      "integration_name": "AgencyZoom"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "zumrails",
      "integration_name": "Zūm Rails"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "worldpay",
      "integration_name": "Worldpay"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "integration_type": "wish",
      "integration_name": "Wish"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "tripletex",
      "integration_name": "Tripletex"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "hris",
         "analytics",
         "passthrough"
      ],
      "integration_type": "tableau",
      "integration_name": "Tableau"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "sumup",
      "integration_name": "SumUp"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "sterling_backcheck",
      "integration_name": "Sterling Check"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "smartlead",
      "integration_name": "SmartLead"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "reviewsio",
      "integration_name": "REVIEWS.io"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "messaging",
         "social",
         "passthrough"
      ],
      "integration_type": "podium",
      "integration_name": "Podium"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "oneup",
      "integration_name": "OneUp"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "loox",
      "integration_name": "Loox"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "judgeme",
      "integration_name": "Judge.me"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "fulll",
      "integration_name": "Fulll"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "fiken",
      "integration_name": "Fiken"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "eway",
      "integration_name": "eWay-CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "ebpcompta",
      "integration_name": "EBP Compta"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "churnzero",
      "integration_name": "ChurnZero"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "birdeye",
      "integration_name": "Birdeye"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "billit",
      "integration_name": "Billit"
   },
   {
      "type": "integration",
      "created_at": "2026-09-01T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "bazaarvoice",
      "integration_name": "Bazaarvoice"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "redtail",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_contact",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "redtail",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_company",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "redtail",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_contact",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "redtail",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_company",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "object",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "integration_type": "redtail",
      "object_type": "crm_contact",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "object",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "integration_type": "redtail",
      "object_type": "crm_company",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "object",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "integration_type": "redtail",
      "object_type": "crm_event",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "method": "create",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "method": "update",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "method": "remove",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "method",
      "integration_type": "redtail",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "pagination",
      "integration_type": "humi",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "Humi"
   },
   {
      "type": "pagination",
      "integration_type": "humi",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "field": "approved_at",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_job_id",
      "integration_name": "Clear Company"
   },
   {
      "type": "object",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "clearcompany",
      "object_type": "ats_company",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clear Company"
   },
   {
      "type": "object",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "integration_type": "bluesky",
      "object_type": "social_post",
      "integration_name": "Bluesky"
   },
   {
      "type": "object",
      "created_at": "2026-08-31T10:08:29.000Z",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "integration_type": "bluesky",
      "object_type": "social_profile",
      "integration_name": "Bluesky"
   },
   {
      "type": "method",
      "integration_type": "bluesky",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bluesky"
   },
   {
      "type": "method",
      "integration_type": "bluesky",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bluesky"
   },
   {
      "type": "method",
      "integration_type": "bluesky",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Bluesky"
   },
   {
      "type": "method",
      "integration_type": "bluesky",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bluesky"
   },
   {
      "type": "method",
      "integration_type": "bluesky",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bluesky"
   },
   {
      "type": "method",
      "integration_type": "bluesky",
      "created_at": "2026-08-31T10:08:29.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bluesky"
   },
   {
      "type": "integration",
      "created_at": "2026-08-31T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "accounting",
         "passthrough"
      ],
      "integration_type": "darwinbox",
      "integration_name": "Darwinbox"
   },
   {
      "type": "integration",
      "created_at": "2026-08-31T00:00:00.000Z",
      "categories": [
         "hris",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "crowdstrike",
      "integration_name": "CrowdStrike Falcon"
   },
   {
      "type": "integration",
      "created_at": "2026-08-31T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "baiduaicloud",
      "integration_name": "Baidu AI Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-08-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "coupa",
      "integration_name": "Coupa"
   },
   {
      "type": "integration",
      "created_at": "2026-08-28T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "wonderlic",
      "integration_name": "Wonderlic"
   },
   {
      "type": "integration",
      "created_at": "2026-08-28T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "the_predictive_index",
      "integration_name": "The Predictive Index"
   },
   {
      "type": "integration",
      "created_at": "2026-08-28T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "psi",
      "integration_name": "PSI"
   },
   {
      "type": "integration",
      "created_at": "2026-08-28T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "planhat",
      "integration_name": "Planhat"
   },
   {
      "type": "integration",
      "created_at": "2026-08-28T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "berke",
      "integration_name": "Berke Assessment"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "manager_ids",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_order",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "writable_field",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "writable_field",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "writable_field",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_content",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_course",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_content",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_course",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_content",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_course",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_activity",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "thrive",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "thrive",
      "object_type": "hris_employee",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "method",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "method",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "method",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "method",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "method",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "method",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "method",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "method",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "method",
      "integration_type": "thrive",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamleader",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_contact",
      "integration_name": "TeamLeader"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamleader",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_company",
      "integration_name": "TeamLeader"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamleader",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_deal",
      "integration_name": "TeamLeader"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamleader",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_contact",
      "integration_name": "TeamLeader"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamleader",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_company",
      "integration_name": "TeamLeader"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamleader",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_deal",
      "integration_name": "TeamLeader"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "teamleader",
      "object_type": "crm_contact",
      "integration_name": "TeamLeader"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "teamleader",
      "object_type": "crm_company",
      "integration_name": "TeamLeader"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "teamleader",
      "object_type": "crm_deal",
      "integration_name": "TeamLeader"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "teamleader",
      "object_type": "crm_pipeline",
      "integration_name": "TeamLeader"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "teamleader",
      "object_type": "hris_employee",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TeamLeader"
   },
   {
      "type": "method",
      "integration_type": "teamleader",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TeamLeader"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Spott"
   },
   {
      "type": "readable_field",
      "integration_type": "spott",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Spott"
   },
   {
      "type": "readable_field",
      "integration_type": "spott",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Spott"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Sage HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "accounting_category",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "accounting_category",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "virtual_webhook_limit",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "options",
      "integration_name": "Pinpoint"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "object_type",
      "integration_name": "Pinpoint"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "name",
      "integration_name": "Pinpoint"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "is_required",
      "integration_name": "Pinpoint"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "format",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "method": "create",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "method": "update",
      "integration_name": "Pinpoint"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "accounting_category",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "accounting_category",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "pagination",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googletasks",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_task",
      "integration_name": "Google Tasks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googletasks",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_task",
      "integration_name": "Google Tasks"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "googletasks",
      "object_type": "task_project",
      "integration_name": "Google Tasks"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "googletasks",
      "object_type": "task_task",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Tasks"
   },
   {
      "type": "method",
      "integration_type": "googletasks",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Tasks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "githubenterpriseserver",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "repo_branch",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "githubenterpriseserver",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "repo_branch",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "githubapp",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "repo_branch",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "githubapp",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "repo_branch",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "pagination",
      "integration_type": "githubapp",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "pagination",
      "integration_type": "githubapp",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "pagination",
      "integration_type": "githubapp",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "pagination",
      "integration_type": "githubapp",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "repo_branch",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "repo_branch",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "storage_file",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "storage_file",
      "integration_name": "BitBucket"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "bitbucket",
      "object_type": "task_comment",
      "integration_name": "BitBucket"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "bitbucket",
      "object_type": "storage_file",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_comment",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "task_comment",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "storage_file",
      "categories": [
         "repo",
         "task",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BitBucket"
   },
   {
      "type": "writable_field",
      "integration_type": "apploi",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Apploi"
   },
   {
      "type": "writable_field",
      "integration_type": "apploi",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "Apploi"
   },
   {
      "type": "object",
      "created_at": "2026-08-27T19:25:17.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "apploi",
      "object_type": "ats_activity",
      "integration_name": "Apploi"
   },
   {
      "type": "method",
      "integration_type": "apploi",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Apploi"
   },
   {
      "type": "method",
      "integration_type": "apploi",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apploi"
   },
   {
      "type": "method",
      "integration_type": "apploi",
      "created_at": "2026-08-27T19:25:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Apploi"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "zinc",
      "integration_name": "Zinc"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "hris",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "zenoti",
      "integration_name": "Zenoti"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "testpartnership",
      "integration_name": "Test Partnership"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "sapcommercecloud",
      "integration_name": "SAP Commerce Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "sapariba",
      "integration_name": "SAP Ariba"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "resumelibrary",
      "integration_name": "Resume-Library"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "integration_type": "pera",
      "integration_name": "Pera"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "peoplebox",
      "integration_name": "Peoplebox"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "paytm",
      "integration_name": "Paytm"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "ninjaone",
      "integration_name": "NinjaOne"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "moodle",
      "integration_name": "Moodle"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "marketo",
      "integration_name": "Marketo"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "horus",
      "integration_name": "Horus"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "glider",
      "integration_name": "Glider"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "evoliz",
      "integration_name": "Evoliz"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "accounting",
         "crm",
         "passthrough"
      ],
      "integration_type": "divalto",
      "integration_name": "Divalto"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "bridge",
      "integration_name": "Bridge"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "integration_type": "blackboard",
      "integration_name": "Blackboard Learn"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "assessfirst",
      "integration_name": "AssessFirst"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "acton",
      "integration_name": "Act-On"
   },
   {
      "type": "integration",
      "created_at": "2026-08-26T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "act",
      "integration_name": "Act!"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "hris_taxonomy",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_taxonomy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_category",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_category",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "metadata",
      "integration_name": "Pinpoint"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "metadata",
      "integration_name": "Pinpoint"
   },
   {
      "type": "writable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "metadata",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "metadata",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "metadata",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "field": "metadata",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Pinpoint"
   },
   {
      "type": "object",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "integration_type": "pinpoint",
      "object_type": "metadata_metadata",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "method": "list",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough",
         "metadata"
      ],
      "method": "get",
      "integration_name": "Pinpoint"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "linear",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_employee",
      "integration_name": "Linear"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "linear",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "task_project",
      "integration_name": "Linear"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "linear",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_employee",
      "integration_name": "Linear"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "linear",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "task_project",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_updated_gte",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_category",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_category",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "googlesheets",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Google Sheets"
   },
   {
      "type": "readable_field",
      "integration_type": "freshteam",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "Freshteam"
   },
   {
      "type": "object",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "freshteam",
      "object_type": "hris_taxonomy",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_taxonomy",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshteam"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_updated_gte",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "ELMO"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "original_type",
      "integration_name": "ELMO"
   },
   {
      "type": "readable_field",
      "integration_type": "chargebee",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "extended_notes",
      "integration_name": "Chargebee"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "field": "original_type",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2026-08-25T18:43:29.000Z",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "integration_type": "bamboohr",
      "object_type": "hris_taxonomy",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-08-25T18:43:29.000Z",
      "object_type": "hris_taxonomy",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "BambooHR"
   },
   {
      "type": "integration",
      "created_at": "2026-08-25T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "thrive",
      "integration_name": "Thrive Learning"
   },
   {
      "type": "integration",
      "created_at": "2026-08-25T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "talkpush",
      "integration_name": "Talkpush"
   },
   {
      "type": "integration",
      "created_at": "2026-08-25T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "hirebridge",
      "integration_name": "HireBridge"
   },
   {
      "type": "integration",
      "created_at": "2026-08-25T00:00:00.000Z",
      "categories": [
         "ats",
         "verification",
         "passthrough"
      ],
      "integration_type": "harver",
      "integration_name": "Harver"
   },
   {
      "type": "integration",
      "created_at": "2026-08-25T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "gr8people",
      "integration_name": "GR8 People"
   },
   {
      "type": "integration",
      "created_at": "2026-08-25T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "cegidquadra",
      "integration_name": "Cegid Quadra"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_paymentterm",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "object_type": "accounting_paymentterm",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgready",
      "object_type": "hris_timeshift",
      "integration_name": "UKG Ready"
   },
   {
      "type": "method",
      "integration_type": "ukgready",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Ready"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "twitter",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "integration_name": "Twitter"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "twitter",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "integration_name": "Twitter"
   },
   {
      "type": "object",
      "object_type": "social_post",
      "integration_type": "twitter",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Twitter"
   },
   {
      "type": "object",
      "object_type": "social_profile",
      "integration_type": "twitter",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Twitter"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "integration_type": "twitter",
      "object_type": "passthrough",
      "integration_name": "Twitter"
   },
   {
      "type": "method",
      "integration_type": "twitter",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Twitter"
   },
   {
      "type": "method",
      "integration_type": "twitter",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Twitter"
   },
   {
      "type": "method",
      "integration_type": "twitter",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Twitter"
   },
   {
      "type": "method",
      "integration_type": "twitter",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Twitter"
   },
   {
      "type": "method",
      "integration_type": "twitter",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Twitter"
   },
   {
      "type": "method",
      "integration_type": "twitter",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "enrich",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Twitter"
   },
   {
      "type": "object",
      "object_type": "social_profile",
      "integration_type": "trustpilot",
      "categories": [
         "social",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Trustpilot"
   },
   {
      "type": "object",
      "object_type": "social_review",
      "integration_type": "trustpilot",
      "categories": [
         "social",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Trustpilot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "ats_company",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "sign-in",
      "integration_type": "threads",
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Threads",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "object",
      "object_type": "social_post",
      "integration_type": "threads",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Threads"
   },
   {
      "type": "object",
      "object_type": "social_profile",
      "integration_type": "threads",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Threads"
   },
   {
      "type": "object",
      "object_type": "social_insight",
      "integration_type": "threads",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Threads"
   },
   {
      "type": "method",
      "integration_type": "threads",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Threads"
   },
   {
      "type": "method",
      "integration_type": "threads",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Threads"
   },
   {
      "type": "method",
      "integration_type": "threads",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Threads"
   },
   {
      "type": "method",
      "integration_type": "threads",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Threads"
   },
   {
      "type": "method",
      "integration_type": "threads",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Threads"
   },
   {
      "type": "method",
      "integration_type": "threads",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_insight",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Threads"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "website_url",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "application_id",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_job",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_application",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_company",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_event",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_job",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_application",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_company",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "Spott"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spott",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_event",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Spott"
   },
   {
      "type": "pagination",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Spott"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "spott",
      "object_type": "ats_applicationstatus",
      "integration_name": "Spott"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "spott",
      "object_type": "crm_contact",
      "integration_name": "Spott"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "spott",
      "object_type": "crm_company",
      "integration_name": "Spott"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "spott",
      "object_type": "crm_lead",
      "integration_name": "Spott"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "spott",
      "object_type": "crm_event",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spott"
   },
   {
      "type": "method",
      "integration_type": "spott",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spott"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "object_type": "accounting_paymentterm",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Rippling"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "object",
      "object_type": "accounting_paymentterm",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_paymentterm",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "social_post",
      "integration_type": "pinterest",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Pinterest"
   },
   {
      "type": "object",
      "object_type": "social_profile",
      "integration_type": "pinterest",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Pinterest"
   },
   {
      "type": "object",
      "object_type": "social_insight",
      "integration_type": "pinterest",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Pinterest"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "object_type": "accounting_paymentterm",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_paymentterm",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "object_type": "accounting_paymentterm",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "object_type": "social_post",
      "integration_type": "mastodon",
      "categories": [
         "social",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Mastodon"
   },
   {
      "type": "object",
      "object_type": "social_profile",
      "integration_type": "mastodon",
      "categories": [
         "social",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Mastodon"
   },
   {
      "type": "method",
      "integration_type": "mastodon",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mastodon"
   },
   {
      "type": "method",
      "integration_type": "mastodon",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mastodon"
   },
   {
      "type": "method",
      "integration_type": "mastodon",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mastodon"
   },
   {
      "type": "method",
      "integration_type": "mastodon",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Mastodon"
   },
   {
      "type": "method",
      "integration_type": "mastodon",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Mastodon"
   },
   {
      "type": "method",
      "integration_type": "mastodon",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mastodon"
   },
   {
      "type": "method",
      "integration_type": "mastodon",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mastodon"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "lucca",
      "object_type": "hris_timeoff",
      "integration_name": "Lucca"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "lucca",
      "object_type": "hris_group",
      "integration_name": "Lucca"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "lucca",
      "object_type": "hris_company",
      "integration_name": "Lucca"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "lucca",
      "object_type": "hris_location",
      "integration_name": "Lucca"
   },
   {
      "type": "method",
      "integration_type": "lucca",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lucca"
   },
   {
      "type": "method",
      "integration_type": "lucca",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lucca"
   },
   {
      "type": "method",
      "integration_type": "lucca",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lucca"
   },
   {
      "type": "method",
      "integration_type": "lucca",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lucca"
   },
   {
      "type": "object",
      "object_type": "social_post",
      "integration_type": "linkedin",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "object_type": "social_profile",
      "integration_type": "linkedin",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "object_type": "social_insight",
      "integration_type": "linkedin",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_insight",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "writable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "readable_field",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "paymentterm_id",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "object",
      "object_type": "accounting_paymentterm",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "accounting_paymentterm",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "object",
      "object_type": "social_post",
      "integration_type": "instagram",
      "categories": [
         "social",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Instagram"
   },
   {
      "type": "object",
      "object_type": "social_profile",
      "integration_type": "instagram",
      "categories": [
         "social",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Instagram"
   },
   {
      "type": "object",
      "object_type": "social_insight",
      "integration_type": "instagram",
      "categories": [
         "social",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Instagram"
   },
   {
      "type": "method",
      "integration_type": "instagram",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Instagram"
   },
   {
      "type": "method",
      "integration_type": "instagram",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Instagram"
   },
   {
      "type": "method",
      "integration_type": "instagram",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Instagram"
   },
   {
      "type": "method",
      "integration_type": "instagram",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Instagram"
   },
   {
      "type": "method",
      "integration_type": "instagram",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Instagram"
   },
   {
      "type": "method",
      "integration_type": "instagram",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_insight",
      "categories": [
         "social",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Instagram"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Humi"
   },
   {
      "type": "pagination",
      "integration_type": "humi",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "googlesheets",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "storage_file",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Google Sheets"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "kpi",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "kpi",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledrive",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Google Drive"
   },
   {
      "type": "object",
      "object_type": "social_post",
      "integration_type": "googlebusiness",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Google Business Profile"
   },
   {
      "type": "object",
      "object_type": "social_profile",
      "integration_type": "googlebusiness",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Google Business Profile"
   },
   {
      "type": "object",
      "object_type": "social_review",
      "integration_type": "googlebusiness",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Google Business Profile"
   },
   {
      "type": "object",
      "object_type": "social_insight",
      "integration_type": "googlebusiness",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Google Business Profile"
   },
   {
      "type": "object",
      "object_type": "social_post",
      "integration_type": "facebook",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Facebook"
   },
   {
      "type": "object",
      "object_type": "social_profile",
      "integration_type": "facebook",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Facebook"
   },
   {
      "type": "object",
      "object_type": "social_review",
      "integration_type": "facebook",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Facebook"
   },
   {
      "type": "object",
      "object_type": "social_insight",
      "integration_type": "facebook",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-24T17:34:52.000Z",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_post",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_profile",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_review",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_review",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Facebook"
   },
   {
      "type": "method",
      "integration_type": "facebook",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "social_insight",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Facebook"
   },
   {
      "type": "pagination",
      "integration_type": "dropbox",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_fulltext",
      "integration_name": "Dropbox"
   },
   {
      "type": "pagination",
      "integration_type": "box",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_fulltext",
      "integration_name": "Box"
   },
   {
      "type": "pagination",
      "integration_type": "box",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_expand",
      "integration_name": "Box"
   },
   {
      "type": "object",
      "created_at": "2026-08-24T17:34:52.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "hris_timeshift",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-08-24T17:34:52.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "integration",
      "created_at": "2026-08-24T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "winbooks",
      "integration_name": "WinBooks on Web"
   },
   {
      "type": "integration",
      "created_at": "2026-08-24T00:00:00.000Z",
      "categories": [
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "vivonet",
      "integration_name": "Vivonet"
   },
   {
      "type": "integration",
      "created_at": "2026-08-24T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "thefork",
      "integration_name": "TheFork"
   },
   {
      "type": "integration",
      "created_at": "2026-08-24T00:00:00.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "plane",
      "integration_name": "Plane"
   },
   {
      "type": "integration",
      "created_at": "2026-08-24T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "helcim",
      "integration_name": "Helcim"
   },
   {
      "type": "integration",
      "created_at": "2026-08-24T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "eurecia",
      "integration_name": "Eurécia"
   },
   {
      "type": "integration",
      "created_at": "2026-08-24T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "creatio",
      "integration_name": "Creatio"
   },
   {
      "type": "integration",
      "created_at": "2026-08-24T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "cegid_retail",
      "integration_name": "Cegid Retail"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "seismic",
      "integration_name": "Seismic"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "integration_type": "ooma",
      "integration_name": "Ooma Office"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "method",
      "integration_name": "Method"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "livepepper",
      "integration_name": "LivePepper"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "hris",
         "crm",
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "invenias",
      "integration_name": "Invenias"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "hygraph",
      "integration_name": "Hygraph"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "highspot",
      "integration_name": "Highspot"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "fulle",
      "integration_name": "Fülle"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "facebookmessenger",
      "integration_name": "Facebook Messenger"
   },
   {
      "type": "integration",
      "created_at": "2026-08-23T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "facebookmarketplace",
      "integration_name": "Facebook Marketplace"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "zettle",
      "integration_name": "Zettle"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "qonto",
      "integration_name": "Qonto"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "popina",
      "integration_name": "Popina"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "numier",
      "integration_name": "Numier"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "mpluskassa",
      "integration_name": "MplusKASSA"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "loop",
      "integration_name": "Loop"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "leo2",
      "integration_name": "LEO2"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "kintone",
      "integration_name": "Kintone"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "floatfinancial",
      "integration_name": "Float Financial"
   },
   {
      "type": "integration",
      "created_at": "2026-08-22T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "float",
      "integration_name": "Float"
   },
   {
      "type": "integration",
      "created_at": "2026-08-21T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "xelion",
      "integration_name": "Xelion"
   },
   {
      "type": "integration",
      "created_at": "2026-08-21T00:00:00.000Z",
      "categories": [
         "social",
         "passthrough"
      ],
      "integration_type": "trustpilot",
      "integration_name": "Trustpilot"
   },
   {
      "type": "integration",
      "created_at": "2026-08-21T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "revoxef",
      "integration_name": "Cegid Revo Xef"
   },
   {
      "type": "integration",
      "created_at": "2026-08-21T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "revoretail",
      "integration_name": "Cegid Revo Retail"
   },
   {
      "type": "integration",
      "created_at": "2026-08-21T00:00:00.000Z",
      "categories": [
         "accounting",
         "storage",
         "passthrough"
      ],
      "integration_type": "plaid",
      "integration_name": "Plaid"
   },
   {
      "type": "integration",
      "created_at": "2026-08-21T00:00:00.000Z",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "integration_type": "pinterest",
      "integration_name": "Pinterest"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "slow_fields",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "slow_fields",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "zohobooks",
      "object_type": "storage_file",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trello",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_company",
      "integration_name": "Trello"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trello",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_company",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "trello",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "trello",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Trello"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_limit",
      "integration_name": "Trello"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_offset",
      "integration_name": "Trello"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_parent_id",
      "integration_name": "Trello"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "trello",
      "object_type": "hris_company",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_company",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_company",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "shapes",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Shapes"
   },
   {
      "type": "readable_field",
      "integration_type": "shapes",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Shapes"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "shapes",
      "object_type": "hris_group",
      "integration_name": "Shapes"
   },
   {
      "type": "method",
      "integration_type": "shapes",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shapes"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "emails",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_document",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_document",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_document",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Personio"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "personio",
      "object_type": "ats_activity",
      "integration_name": "Personio"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "personio",
      "object_type": "ats_applicationstatus",
      "integration_name": "Personio"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "personio",
      "object_type": "hris_benefit",
      "integration_name": "Personio"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "personio",
      "object_type": "hris_deduction",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Personio"
   },
   {
      "type": "writable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_document",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "type",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_document",
      "pagination": "list_type",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_type",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "writable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_document",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "type",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_document",
      "pagination": "list_type",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_type",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_start_gte",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_end_lt",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_user_id",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_end_lt",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_user_id",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Dialpad"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "dayforce",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "dayforce",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_job",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "dayforce",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "dayforce",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "dayforce",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_job",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "dayforce",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "pagination",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "pagination",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "pagination",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "pagination",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "pagination",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "dayforce",
      "object_type": "hris_location",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "dayforce",
      "object_type": "hris_attendance",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "dayforce",
      "object_type": "hris_timeshift",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "dayforce",
      "object_type": "hris_timeoff",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "dayforce",
      "object_type": "hris_taxonomy",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "dayforce",
      "object_type": "passthrough",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_taxonomy",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-08-20T18:57:48.000Z",
      "object_type": "hris_taxonomy",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_contact_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_lead_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_lead_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-20T18:57:48.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "integration",
      "created_at": "2026-08-20T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "honeybook",
      "integration_name": "HoneyBook"
   },
   {
      "type": "integration",
      "created_at": "2026-08-20T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlephotos",
      "integration_name": "Google Photos"
   },
   {
      "type": "integration",
      "created_at": "2026-08-20T00:00:00.000Z",
      "categories": [
         "social",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlebusiness",
      "integration_name": "Google Business Profile"
   },
   {
      "type": "integration",
      "created_at": "2026-08-20T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "beeline",
      "integration_name": "Beeline"
   },
   {
      "type": "integration",
      "created_at": "2026-08-19T00:00:00.000Z",
      "categories": [
         "uc",
         "crm",
         "passthrough"
      ],
      "integration_type": "3cxcrm",
      "integration_name": "3CX (CRM / call journaling)"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "invoice_number",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "bill_number",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "revsport",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Rev Sport"
   },
   {
      "type": "pagination",
      "integration_type": "revsport",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Rev Sport"
   },
   {
      "type": "pagination",
      "integration_type": "revsport",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "clubs_member",
      "pagination": "slow_fields",
      "integration_name": "Rev Sport"
   },
   {
      "type": "readable_field",
      "integration_type": "posthog",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "PostHog"
   },
   {
      "type": "readable_field",
      "integration_type": "posthog",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "PostHog"
   },
   {
      "type": "readable_field",
      "integration_type": "pendo",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Pendo"
   },
   {
      "type": "readable_field",
      "integration_type": "pendo",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Pendo"
   },
   {
      "type": "readable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Mixpanel"
   },
   {
      "type": "readable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Mixpanel"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "datev",
      "object_type": "hris_employee",
      "integration_name": "DATEV"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "datev",
      "object_type": "hris_company",
      "integration_name": "DATEV"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "datev",
      "object_type": "hris_group",
      "integration_name": "DATEV"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "datev",
      "object_type": "hris_timeoff",
      "integration_name": "DATEV"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "datev",
      "object_type": "hris_payslip",
      "integration_name": "DATEV"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "datev",
      "object_type": "hris_deduction",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_company",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DATEV"
   },
   {
      "type": "method",
      "integration_type": "datev",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DATEV"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "field": "termination_reason",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "field": "employment_type",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "azuredevops",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "lines_deleted",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "readable_field",
      "integration_type": "azuredevops",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "lines_changed",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "readable_field",
      "integration_type": "azuredevops",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "lines_added",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "appleicloud",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "crm_contact",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "appleicloud",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "crm_contact",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T17:13:47.000Z",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "integration_type": "appleicloud",
      "object_type": "crm_contact",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "amplitude",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Amplitude"
   },
   {
      "type": "readable_field",
      "integration_type": "amplitude",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Amplitude"
   },
   {
      "type": "writable_field",
      "integration_type": "airtable",
      "created_at": "2026-08-18T17:13:47.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Airtable"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_class",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_class",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_course",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_activity",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "field": "started_at",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_course",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "field": "instructors",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_course",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "lms_class",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "lms_student",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_class",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_class",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_student",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "lms_student",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "dialpad",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "messaging_message",
      "integration_name": "Dialpad"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "dialpad",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "messaging_message",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "slow_fields",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_type",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dialpad",
      "object_type": "messaging_message",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dialpad",
      "object_type": "messaging_channel",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dialpad",
      "object_type": "hris_company",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dialpad",
      "object_type": "calendar_recording",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "dialpad",
      "object_type": "metadata_metadata",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "messaging_message",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "hris_company",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "hris_company",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "messaging",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "field": "education",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "field": "duration_type",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "field": "duration",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-08-18T10:52:23.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-08-18T10:52:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_job_id",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2026-08-18T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "proliant",
      "integration_name": "Proliant"
   },
   {
      "type": "integration",
      "created_at": "2026-08-18T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "accounting",
         "passthrough"
      ],
      "integration_type": "hrworks",
      "integration_name": "HR WORKS"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "integration_type": "wix",
      "object_type": "shipping_shipment",
      "integration_name": "Wix"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "integration_type": "wix",
      "object_type": "shipping_tracking",
      "integration_name": "Wix"
   },
   {
      "type": "method",
      "integration_type": "wix",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wix"
   },
   {
      "type": "method",
      "integration_type": "wix",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wix"
   },
   {
      "type": "method",
      "integration_type": "wix",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wix"
   },
   {
      "type": "method",
      "integration_type": "wix",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wix"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "tip_amount",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "salesorder_id",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "payment_method",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "guest_count",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "fulfillment_type",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "employee_user_id",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "integration_type": "squareup",
      "object_type": "shipping_shipment",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "integration_type": "squareup",
      "object_type": "shipping_tracking",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "integration_type": "squarespace",
      "object_type": "shipping_shipment",
      "integration_name": "Squarespace"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "integration_type": "squarespace",
      "object_type": "shipping_tracking",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Squarespace"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "shipping_shipment",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "shipping_tracking",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sap",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sap",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "sap",
      "object_type": "shipping_shipment",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "picqer",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "Picqer"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "picqer",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "Picqer"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "picqer",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "Picqer"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "picqer",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "Picqer"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "integration_type": "picqer",
      "object_type": "shipping_shipment",
      "integration_name": "Picqer"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "integration_type": "picqer",
      "object_type": "shipping_tracking",
      "integration_name": "Picqer"
   },
   {
      "type": "method",
      "integration_type": "picqer",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Picqer"
   },
   {
      "type": "method",
      "integration_type": "picqer",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Picqer"
   },
   {
      "type": "method",
      "integration_type": "picqer",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Picqer"
   },
   {
      "type": "method",
      "integration_type": "picqer",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Picqer"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicscustomerengagement",
      "object_type": "ticketing_ticket",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "ticketing",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "object_type": "shipping_shipment",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "etsy",
      "object_type": "shipping_shipment",
      "integration_name": "Etsy"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "etsy",
      "object_type": "shipping_tracking",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Etsy"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "ebay",
      "object_type": "shipping_shipment",
      "integration_name": "eBay"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "ebay",
      "object_type": "shipping_tracking",
      "integration_name": "eBay"
   },
   {
      "type": "method",
      "integration_type": "ebay",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "eBay"
   },
   {
      "type": "method",
      "integration_type": "ebay",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "eBay"
   },
   {
      "type": "method",
      "integration_type": "ebay",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "eBay"
   },
   {
      "type": "method",
      "integration_type": "ebay",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "eBay"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "shipping",
         "passthrough"
      ],
      "integration_type": "brightpearl",
      "object_type": "shipping_shipment",
      "integration_name": "Brightpearl"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "shipping",
         "passthrough"
      ],
      "integration_type": "brightpearl",
      "object_type": "shipping_tracking",
      "integration_name": "Brightpearl"
   },
   {
      "type": "method",
      "integration_type": "brightpearl",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Brightpearl"
   },
   {
      "type": "method",
      "integration_type": "brightpearl",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Brightpearl"
   },
   {
      "type": "method",
      "integration_type": "brightpearl",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Brightpearl"
   },
   {
      "type": "method",
      "integration_type": "brightpearl",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Brightpearl"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "bigcommerce",
      "object_type": "shipping_shipment",
      "integration_name": "BigCommerce"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "bigcommerce",
      "object_type": "shipping_tracking",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "acumatica",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "Acumatica"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "acumatica",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "Acumatica"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "acumatica",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "Acumatica"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "acumatica",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "Acumatica"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "acumatica",
      "object_type": "shipping_shipment",
      "integration_name": "Acumatica"
   },
   {
      "type": "object",
      "created_at": "2026-08-17T13:37:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "acumatica",
      "object_type": "shipping_tracking",
      "integration_name": "Acumatica"
   },
   {
      "type": "method",
      "integration_type": "acumatica",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Acumatica"
   },
   {
      "type": "method",
      "integration_type": "acumatica",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Acumatica"
   },
   {
      "type": "method",
      "integration_type": "acumatica",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Acumatica"
   },
   {
      "type": "method",
      "integration_type": "acumatica",
      "created_at": "2026-08-17T13:37:50.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "shipping",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Acumatica"
   },
   {
      "type": "integration",
      "created_at": "2026-08-17T00:00:00.000Z",
      "categories": [
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "workwave",
      "integration_name": "WorkWave Route Manager"
   },
   {
      "type": "integration",
      "created_at": "2026-08-17T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "uc",
         "passthrough"
      ],
      "integration_type": "roam",
      "integration_name": "Roam"
   },
   {
      "type": "integration",
      "created_at": "2026-08-17T00:00:00.000Z",
      "categories": [
         "crm",
         "accounting",
         "commerce",
         "hris",
         "task",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "pronto",
      "integration_name": "Pronto Xi"
   },
   {
      "type": "integration",
      "created_at": "2026-08-17T00:00:00.000Z",
      "categories": [
         "auth",
         "calendar",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "microsoftbookings",
      "integration_name": "Microsoft Bookings"
   },
   {
      "type": "integration",
      "created_at": "2026-08-17T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "integration_type": "flipkart",
      "integration_name": "Flipkart"
   },
   {
      "type": "integration",
      "created_at": "2026-08-17T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "anvil",
      "integration_name": "Anvil"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "spokeo",
      "integration_name": "Spokeo"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "ottomarket",
      "integration_name": "OTTO Market"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "integration_type": "newegg",
      "integration_name": "Newegg"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftvivalearning",
      "integration_name": "Microsoft Viva Learning"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsofttodo",
      "integration_name": "Microsoft To Do"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftforms",
      "integration_name": "Microsoft Forms"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftexcel",
      "integration_name": "Microsoft Excel"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicscustomerinsightsjourneys",
      "integration_name": "Microsoft Dynamics 365 Customer Insights - Journeys"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "faire",
      "integration_name": "Faire"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "ecwid",
      "integration_name": "Ecwid (Lightspeed)"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "coupang",
      "integration_name": "Coupang"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "clarity",
      "integration_name": "Microsoft Clarity"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "auth",
         "passthrough"
      ],
      "integration_type": "bigcartel",
      "integration_name": "Big Cartel"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "storage"
      ],
      "integration_type": "azureblobstorage",
      "integration_name": "Azure Blob Storage"
   },
   {
      "type": "integration",
      "created_at": "2026-08-16T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "allegro",
      "integration_name": "Allegro"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "zid",
      "integration_name": "Zid"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "integration_type": "zalando",
      "integration_name": "Zalando"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "webflow",
      "integration_name": "Webflow"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "vtex",
      "integration_name": "VTEX"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "tiendanube",
      "integration_name": "Tiendanube"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "hris",
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "salla",
      "integration_name": "Salla"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "kaufland",
      "integration_name": "Kaufland"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "docebo",
      "integration_name": "Docebo"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "commercetools",
      "integration_name": "commercetools"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "cdiscount",
      "integration_name": "Cdiscount"
   },
   {
      "type": "integration",
      "created_at": "2026-08-15T00:00:00.000Z",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "integration_type": "achievers",
      "integration_name": "Achievers"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-14T14:12:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-14T14:12:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "created_at": "2026-08-14T14:12:20.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "hris_payslip",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-08-14T14:12:20.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-08-14T14:12:20.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "integration",
      "created_at": "2026-08-14T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "oraclesales",
      "integration_name": "Oracle Sales"
   },
   {
      "type": "integration",
      "created_at": "2026-08-14T00:00:00.000Z",
      "categories": [
         "accounting",
         "crm",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "oraclejde",
      "integration_name": "Oracle JD Edwards EnterpriseOne"
   },
   {
      "type": "integration",
      "created_at": "2026-08-14T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "oracleccs",
      "integration_name": "Oracle Utilities Customer Cloud Service"
   },
   {
      "type": "integration",
      "created_at": "2026-08-14T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "oracleccb",
      "integration_name": "Oracle Utilities Customer Care and Billing"
   },
   {
      "type": "integration",
      "created_at": "2026-08-14T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "heyreach",
      "integration_name": "HeyReach"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wave"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wafeq",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Wafeq"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wafeq",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Wafeq"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wafeq",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Wafeq"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wafeq",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Wafeq"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "wafeq",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Wafeq"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "wafeq",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Wafeq"
   },
   {
      "type": "method",
      "integration_type": "wafeq",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wafeq"
   },
   {
      "type": "method",
      "integration_type": "wafeq",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wafeq"
   },
   {
      "type": "method",
      "integration_type": "wafeq",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wafeq"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "vismanet",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Visma.net ERP"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "vismanet",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Visma.net ERP"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "vismanet",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Visma.net ERP"
   },
   {
      "type": "method",
      "integration_type": "vismanet",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Visma.net ERP"
   },
   {
      "type": "method",
      "integration_type": "vismanet",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Visma.net ERP"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "vismaeaccounting",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Visma eAccounting"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "vismaeaccounting",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Visma eAccounting"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "vismaeaccounting",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Visma eAccounting"
   },
   {
      "type": "method",
      "integration_type": "vismaeaccounting",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Visma eAccounting"
   },
   {
      "type": "method",
      "integration_type": "vismaeaccounting",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Visma eAccounting"
   },
   {
      "type": "method",
      "integration_type": "vismaeaccounting",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Visma eAccounting"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "unit4erpx",
      "categories": [
         "hris",
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Unit4 ERPx"
   },
   {
      "type": "method",
      "integration_type": "unit4erpx",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "hris",
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Unit4 ERPx"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SquareUp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "spiris",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Spiris"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "spiris",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Spiris"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "spiris",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Spiris"
   },
   {
      "type": "method",
      "integration_type": "spiris",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spiris"
   },
   {
      "type": "method",
      "integration_type": "spiris",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spiris"
   },
   {
      "type": "method",
      "integration_type": "spiris",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spiris"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "snelstart",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "SnelStart"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "snelstart",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "SnelStart"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "snelstart",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "SnelStart"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "snelstart",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "SnelStart"
   },
   {
      "type": "method",
      "integration_type": "snelstart",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SnelStart"
   },
   {
      "type": "method",
      "integration_type": "snelstart",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SnelStart"
   },
   {
      "type": "method",
      "integration_type": "snelstart",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SnelStart"
   },
   {
      "type": "writable_field",
      "integration_type": "shortcut",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "story_points",
      "integration_name": "Shortcut"
   },
   {
      "type": "readable_field",
      "integration_type": "shortcut",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "story_points",
      "integration_name": "Shortcut"
   },
   {
      "type": "readable_field",
      "integration_type": "shortcut",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Shortcut"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sage200",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "sage200",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "sage200",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "method",
      "integration_type": "sage200",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rillet",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Rillet"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rillet",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Rillet"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "rillet",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Rillet"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "rillet",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Rillet"
   },
   {
      "type": "method",
      "integration_type": "rillet",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rillet"
   },
   {
      "type": "method",
      "integration_type": "rillet",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rillet"
   },
   {
      "type": "method",
      "integration_type": "rillet",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rillet"
   },
   {
      "type": "method",
      "integration_type": "rillet",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rillet"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "restaurant365",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Restaurant365"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "restaurant365",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Restaurant365"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "restaurant365",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Restaurant365"
   },
   {
      "type": "method",
      "integration_type": "restaurant365",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Restaurant365"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "ramp",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Ramp"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "procountor",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Procountor"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "procountor",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Procountor"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "procountor",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Procountor"
   },
   {
      "type": "method",
      "integration_type": "procountor",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Procountor"
   },
   {
      "type": "method",
      "integration_type": "procountor",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Procountor"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pennylane",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Pennylane"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "pennylane",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Pennylane"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "pennylane",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pennylane"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_item",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_location",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "payment_payment",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_item",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_location",
      "integration_name": "Odoo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "payment_payment",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "odoo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T19:22:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "odoo",
      "object_type": "commerce_item",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T19:22:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "odoo",
      "object_type": "commerce_itemvariant",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T19:22:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "odoo",
      "object_type": "commerce_collection",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T19:22:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "odoo",
      "object_type": "commerce_inventory",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T19:22:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "odoo",
      "object_type": "commerce_location",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T19:22:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "odoo",
      "object_type": "payment_payment",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "netvisor",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Visma Netvisor"
   },
   {
      "type": "method",
      "integration_type": "netvisor",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Visma Netvisor"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "moneybird",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Moneybird"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "moneybird",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Moneybird"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "moneybird",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Moneybird"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "moneybird",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Moneybird"
   },
   {
      "type": "method",
      "integration_type": "moneybird",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Moneybird"
   },
   {
      "type": "method",
      "integration_type": "moneybird",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Moneybird"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "mambu",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Mambu"
   },
   {
      "type": "method",
      "integration_type": "mambu",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mambu"
   },
   {
      "type": "method",
      "integration_type": "mambu",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mambu"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Linear"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "kashoo",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Kashoo"
   },
   {
      "type": "method",
      "integration_type": "kashoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Kashoo"
   },
   {
      "type": "method",
      "integration_type": "kashoo",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Kashoo"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "kashflow",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "KashFlow"
   },
   {
      "type": "method",
      "integration_type": "kashflow",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "KashFlow"
   },
   {
      "type": "method",
      "integration_type": "kashflow",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "KashFlow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "intuitenterprise",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "method",
      "integration_type": "intuitenterprise",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "holded",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Holded"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "FreeAgent"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "exactonline",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Exact Online"
   },
   {
      "type": "method",
      "integration_type": "exactonline",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Exact Online"
   },
   {
      "type": "method",
      "integration_type": "exactonline",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Exact Online"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "dualentry",
      "categories": [
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "DualEntry"
   },
   {
      "type": "method",
      "integration_type": "dualentry",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DualEntry"
   },
   {
      "type": "method",
      "integration_type": "dualentry",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DualEntry"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "ClickUp"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "clearbooks",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Clear Books"
   },
   {
      "type": "method",
      "integration_type": "clearbooks",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clear Books"
   },
   {
      "type": "method",
      "integration_type": "clearbooks",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clear Books"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "cegidloop",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Cegid Loop"
   },
   {
      "type": "method",
      "integration_type": "cegidloop",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cegid Loop"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "campfire",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Campfire"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "campfire",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Campfire"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "campfire",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Campfire"
   },
   {
      "type": "method",
      "integration_type": "campfire",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Campfire"
   },
   {
      "type": "method",
      "integration_type": "campfire",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Campfire"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "brightpearl",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Brightpearl"
   },
   {
      "type": "method",
      "integration_type": "brightpearl",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Brightpearl"
   },
   {
      "type": "method",
      "integration_type": "brightpearl",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Brightpearl"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "brex",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Brex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "brex",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Brex"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "brex",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Brex"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "brex",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Brex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "integration_name": "Bill.com"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "readable_field",
      "integration_type": "azuredevops",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "readable_field",
      "integration_type": "azuredevops",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "axonaut",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "integration_name": "Axonaut"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "axonaut",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Axonaut"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedtransaction",
      "integration_type": "axonaut",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Axonaut"
   },
   {
      "type": "method",
      "integration_type": "axonaut",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Axonaut"
   },
   {
      "type": "method",
      "integration_type": "axonaut",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedtransaction",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Axonaut"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "time_spent_unit",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "time_spent",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "story_points",
      "integration_name": "Asana"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "amazonsellercentral",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Amazon Seller Central"
   },
   {
      "type": "method",
      "integration_type": "amazonsellercentral",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Amazon Seller Central"
   },
   {
      "type": "method",
      "integration_type": "amazonsellercentral",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Amazon Seller Central"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "acombago",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "Acomba GO"
   },
   {
      "type": "method",
      "integration_type": "acombago",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Acomba GO"
   },
   {
      "type": "method",
      "integration_type": "acombago",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Acomba GO"
   },
   {
      "type": "object",
      "object_type": "accounting_bankfeedaccount",
      "integration_type": "accountsiq",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-13T19:22:54.000Z",
      "integration_name": "AccountsIQ"
   },
   {
      "type": "method",
      "integration_type": "accountsiq",
      "created_at": "2026-08-13T19:22:54.000Z",
      "object_type": "accounting_bankfeedaccount",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AccountsIQ"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "hris_location",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "accounting_order",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "payment_payment",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_item",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_location",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_availability",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "hris_location",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_location",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "hris_location",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_location",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "hris_group",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "hris_device",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "accounting_taxrate",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "accounting_category",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "payment_payment",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "payment_refund",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "payment_payout",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "commerce_item",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "commerce_collection",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "commerce_inventory",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "commerce_location",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-08-13T13:25:41.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "commerce_availability",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "accounting_category",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "payment_refund",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "payment_refund",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "payment_payout",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_location",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_location",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-13T13:25:41.000Z",
      "object_type": "commerce_availability",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "integration",
      "created_at": "2026-08-13T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "powerbi",
      "integration_name": "Microsoft Power BI"
   },
   {
      "type": "integration",
      "created_at": "2026-08-13T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "perforce",
      "integration_name": "Perforce Helix Swarm"
   },
   {
      "type": "integration",
      "created_at": "2026-08-13T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "peoplefirst",
      "integration_name": "People First"
   },
   {
      "type": "integration",
      "created_at": "2026-08-13T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "navan",
      "integration_name": "Navan"
   },
   {
      "type": "integration",
      "created_at": "2026-08-13T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "multiplier",
      "integration_name": "Multiplier"
   },
   {
      "type": "integration",
      "created_at": "2026-08-13T00:00:00.000Z",
      "categories": [
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftlists",
      "integration_name": "Microsoft Lists"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpodeveloper",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "martech",
         "commerce",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "Yotpo (Developer)"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpodeveloper",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "martech",
         "commerce",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Yotpo (Developer)"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpodeveloper",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "martech",
         "commerce",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Yotpo (Developer)"
   },
   {
      "type": "writable_field",
      "integration_type": "yotpo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "yotpo"
   },
   {
      "type": "writable_field",
      "integration_type": "yotpo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "yotpo"
   },
   {
      "type": "writable_field",
      "integration_type": "yotpo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_contact_id",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_query",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "hris_document",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "accounting_bill",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "accounting_contact",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "accounting_invoice",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "accounting_bill",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "payment_payment",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "ats",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_subscription",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_subscription",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "WooCommerce"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "integration_type": "woocommerce",
      "object_type": "accounting_salesorder",
      "integration_name": "WooCommerce"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "integration_type": "woocommerce",
      "object_type": "payment_subscription",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "wix",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Wix"
   },
   {
      "type": "readable_field",
      "integration_type": "wix",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Wix"
   },
   {
      "type": "readable_field",
      "integration_type": "wix",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Wix"
   },
   {
      "type": "readable_field",
      "integration_type": "wix",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Wix"
   },
   {
      "type": "writable_field",
      "integration_type": "whatsapp",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "WhatsApp"
   },
   {
      "type": "readable_field",
      "integration_type": "webex",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Wealthbox"
   },
   {
      "type": "writable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "Wealthbox"
   },
   {
      "type": "readable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Wealthbox"
   },
   {
      "type": "readable_field",
      "integration_type": "walmart",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Walmart"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "trinet",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "tip_amount",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "service_charge_amount",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "guest_count",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "employee_user_id",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "device_id",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokshop",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "TikTok Shop"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokshop",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "TikTok Shop"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokshop",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "TikTok Shop"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamsoftware",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Team Software"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamsoftware",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Team Software"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "teamsoftware",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Team Software"
   },
   {
      "type": "method",
      "integration_type": "teamsoftware",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Team Software"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_lms",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_class",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "instructors",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "card_last4",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "card_brand",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "SquareUp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "tip_amount",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "salesorder_id",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "location_id",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "device_id",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "card_last4",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "card_brand",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "squareup",
      "object_type": "accounting_salesorder",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squarespace",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "Squarespace"
   },
   {
      "type": "readable_field",
      "integration_type": "squarespace",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Squarespace"
   },
   {
      "type": "readable_field",
      "integration_type": "squarespace",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Squarespace"
   },
   {
      "type": "readable_field",
      "integration_type": "squarespace",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "refunded_amount",
      "integration_name": "Squarespace"
   },
   {
      "type": "readable_field",
      "integration_type": "squarespace",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Squarespace"
   },
   {
      "type": "readable_field",
      "integration_type": "squarespace",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Squarespace"
   },
   {
      "type": "readable_field",
      "integration_type": "squarespace",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Squarespace"
   },
   {
      "type": "readable_field",
      "integration_type": "squarespace",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "slackbot",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "uc",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "shoplazza",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "tip_amount",
      "integration_name": "Shoplazza"
   },
   {
      "type": "readable_field",
      "integration_type": "shoplazza",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Shoplazza"
   },
   {
      "type": "readable_field",
      "integration_type": "shoplazza",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Shoplazza"
   },
   {
      "type": "readable_field",
      "integration_type": "shoplazza",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "refunded_amount",
      "integration_name": "Shoplazza"
   },
   {
      "type": "readable_field",
      "integration_type": "shoplazza",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Shoplazza"
   },
   {
      "type": "readable_field",
      "integration_type": "shoplazza",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "location_id",
      "integration_name": "Shoplazza"
   },
   {
      "type": "readable_field",
      "integration_type": "shoplazza",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Shoplazza"
   },
   {
      "type": "readable_field",
      "integration_type": "shoplazza",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Shoplazza"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_subscription",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_subscription",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "tip_amount",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "location_id",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "payment_subscription",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "payment",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shoper",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Shoper"
   },
   {
      "type": "readable_field",
      "integration_type": "shopee",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "field": "fulfillment_type",
      "integration_name": "Shopee"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "shipstation",
      "object_type": "commerce_itemvariant",
      "integration_name": "ShipStation"
   },
   {
      "type": "method",
      "integration_type": "shipstation",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ShipStation"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "sap",
      "object_type": "commerce_itemvariant",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "ringover",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Ringover"
   },
   {
      "type": "writable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Ring Central"
   },
   {
      "type": "writable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "recharge",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Recharge"
   },
   {
      "type": "readable_field",
      "integration_type": "recharge",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Recharge"
   },
   {
      "type": "readable_field",
      "integration_type": "recharge",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "refunded_amount",
      "integration_name": "Recharge"
   },
   {
      "type": "readable_field",
      "integration_type": "recharge",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Recharge"
   },
   {
      "type": "readable_field",
      "integration_type": "recharge",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Recharge"
   },
   {
      "type": "readable_field",
      "integration_type": "quo",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "QUO"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbookspayment",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbookspayment",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "prestashop",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "PrestaShop"
   },
   {
      "type": "readable_field",
      "integration_type": "prestashop",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "PrestaShop"
   },
   {
      "type": "readable_field",
      "integration_type": "prestashop",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "PrestaShop"
   },
   {
      "type": "readable_field",
      "integration_type": "prestashop",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "PrestaShop"
   },
   {
      "type": "readable_field",
      "integration_type": "picqer",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Picqer"
   },
   {
      "type": "readable_field",
      "integration_type": "picqer",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Picqer"
   },
   {
      "type": "readable_field",
      "integration_type": "phoneburner",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "peoplehr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "PeopleHR"
   },
   {
      "type": "method",
      "integration_type": "peoplehr",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PeopleHR"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Pennylane"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "payworks",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Payworks"
   },
   {
      "type": "method",
      "integration_type": "payworks",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Payworks"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "parbrink",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "parbrink",
      "object_type": "commerce_inventory",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "parbrink",
      "object_type": "accounting_salesorder",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "parbrink",
      "object_type": "accounting_contact",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "parbrink",
      "object_type": "accounting_taxrate",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "parbrink",
      "object_type": "payment_payment",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "method",
      "integration_type": "parbrink",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "method",
      "integration_type": "parbrink",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "method",
      "integration_type": "parbrink",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "method",
      "integration_type": "parbrink",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "method",
      "integration_type": "parbrink",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "method",
      "integration_type": "parbrink",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "method",
      "integration_type": "parbrink",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "method",
      "integration_type": "parbrink",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "noon",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Noon"
   },
   {
      "type": "readable_field",
      "integration_type": "noon",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "location_id",
      "integration_name": "Noon"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "mollie",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "Mollie"
   },
   {
      "type": "readable_field",
      "integration_type": "mollie",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Mollie"
   },
   {
      "type": "readable_field",
      "integration_type": "mollie",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "Mollie"
   },
   {
      "type": "readable_field",
      "integration_type": "mollie",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "field": "card_last4",
      "integration_name": "Mollie"
   },
   {
      "type": "readable_field",
      "integration_type": "mollie",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "field": "card_brand",
      "integration_name": "Mollie"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "url_tags",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "external_placement_reference",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "external_creative_reference",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "creative_type",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "external_placement_reference",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "external_creative_reference",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "metaads",
      "object_type": "ads_asset",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "mercadolibre",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Mercado Libre"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "instructors",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "payments",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "location_id",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "employee_user_id",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedpos",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "device_id",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "tip_amount",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "service_charge_amount",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "location_id",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "location_id",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "guest_count",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "fulfillment_type",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "fee_amount",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_user_id",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "device_id",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "lightspeedkseries",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "method",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedecom",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Lightspeed eCom (C-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedecom",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Lightspeed eCom (C-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedecom",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Lightspeed eCom (C-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedecom",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Lightspeed eCom (C-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "learnupon",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "students",
      "integration_name": "LearnUpon"
   },
   {
      "type": "readable_field",
      "integration_type": "learnupon",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_class",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "students",
      "integration_name": "LearnUpon"
   },
   {
      "type": "readable_field",
      "integration_type": "learnupon",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "instructors",
      "integration_name": "LearnUpon"
   },
   {
      "type": "readable_field",
      "integration_type": "lazada",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Lazada"
   },
   {
      "type": "readable_field",
      "integration_type": "lazada",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Lazada"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "lazada",
      "object_type": "commerce_itemvariant",
      "integration_name": "Lazada"
   },
   {
      "type": "method",
      "integration_type": "lazada",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lazada"
   },
   {
      "type": "writable_field",
      "integration_type": "kustomer",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Kustomer"
   },
   {
      "type": "writable_field",
      "integration_type": "kustomer",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Kustomer"
   },
   {
      "type": "readable_field",
      "integration_type": "kustomer",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Kustomer"
   },
   {
      "type": "readable_field",
      "integration_type": "kustomer",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Kustomer"
   },
   {
      "type": "readable_field",
      "integration_type": "kixie",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Kixie"
   },
   {
      "type": "readable_field",
      "integration_type": "kahoot",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_class",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "instructors",
      "integration_name": "Kahoot!"
   },
   {
      "type": "readable_field",
      "integration_type": "kahoot",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "instructors",
      "integration_name": "Kahoot!"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "JustCall"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "imap",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging"
      ],
      "field": "channels",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "imap",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging"
      ],
      "field": "channels",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Holded"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "hirebee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Hirebee"
   },
   {
      "type": "method",
      "integration_type": "hirebee",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Hirebee"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "harvest",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Harvest"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "harvest",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Harvest"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "harvest",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Harvest"
   },
   {
      "type": "method",
      "integration_type": "harvest",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Harvest"
   },
   {
      "type": "method",
      "integration_type": "harvest",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Harvest"
   },
   {
      "type": "readable_field",
      "integration_type": "goto",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "GoTO"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemail",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Gmail"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "students",
      "integration_name": "Google Classroom"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "instructors",
      "integration_name": "Google Classroom"
   },
   {
      "type": "writable_field",
      "integration_type": "google",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Google"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Gong"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "goco",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "method",
      "integration_type": "goco",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "method",
      "integration_type": "goco",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "tender_type",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "freshdesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "FreeAgent"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "writable_field",
      "integration_type": "followupboss",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Follow Up Boss"
   },
   {
      "type": "readable_field",
      "integration_type": "followupboss",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Follow Up Boss"
   },
   {
      "type": "readable_field",
      "integration_type": "followupboss",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Follow Up Boss"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "etsy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Etsy"
   },
   {
      "type": "readable_field",
      "integration_type": "etsy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Etsy"
   },
   {
      "type": "readable_field",
      "integration_type": "etsy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "refunded_amount",
      "integration_name": "Etsy"
   },
   {
      "type": "readable_field",
      "integration_type": "etsy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Etsy"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "etsy",
      "object_type": "commerce_itemvariant",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Etsy"
   },
   {
      "type": "readable_field",
      "integration_type": "ebay",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "eBay"
   },
   {
      "type": "readable_field",
      "integration_type": "ebay",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "eBay"
   },
   {
      "type": "readable_field",
      "integration_type": "ebay",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "refunded_amount",
      "integration_name": "eBay"
   },
   {
      "type": "readable_field",
      "integration_type": "ebay",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "eBay"
   },
   {
      "type": "readable_field",
      "integration_type": "ebay",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "fulfillment_type",
      "integration_name": "eBay"
   },
   {
      "type": "readable_field",
      "integration_type": "ebay",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "eBay"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "ebay",
      "object_type": "commerce_itemvariant",
      "integration_name": "eBay"
   },
   {
      "type": "method",
      "integration_type": "ebay",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "eBay"
   },
   {
      "type": "method",
      "integration_type": "ebay",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "eBay"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dealcloud",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "DealCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "d2l",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "students",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "readable_field",
      "integration_type": "coursera",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "lms_class",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "instructors",
      "integration_name": "Coursera"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "connecteam",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Connecteam"
   },
   {
      "type": "method",
      "integration_type": "connecteam",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Connecteam"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "circle",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Circle.so"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "cezannehr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "method",
      "integration_type": "cezannehr",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "method",
      "integration_type": "cezannehr",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "readable_field",
      "integration_type": "boondmanager",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "crm_deal",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "BoondManager"
   },
   {
      "type": "readable_field",
      "integration_type": "boldcommerce",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "readable_field",
      "integration_type": "boldcommerce",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "readable_field",
      "integration_type": "boldcommerce",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "readable_field",
      "integration_type": "bol",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "fulfillment_type",
      "integration_name": "bol.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bol",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "bol.com"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "bloomreachdiscovery",
      "object_type": "commerce_itemvariant",
      "integration_name": "Bloomreach Discovery"
   },
   {
      "type": "method",
      "integration_type": "bloomreachdiscovery",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bloomreach Discovery"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "bloomreach",
      "object_type": "commerce_itemvariant",
      "integration_name": "Bloomreach"
   },
   {
      "type": "method",
      "integration_type": "bloomreach",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bloomreach"
   },
   {
      "type": "writable_field",
      "integration_type": "bill",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Bill.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bill",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Bill.com"
   },
   {
      "type": "object",
      "object_type": "hris_attendance",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "hris_attendance",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "task_comment",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "virtual_webhook_task_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonsellercentral",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "order_number",
      "integration_name": "Amazon Seller Central"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonsellercentral",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "fulfillment_type",
      "integration_name": "Amazon Seller Central"
   },
   {
      "type": "readable_field",
      "integration_type": "aloware",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Aloware"
   },
   {
      "type": "readable_field",
      "integration_type": "alibaba",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "readable_field",
      "integration_type": "alibaba",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "subtotal_amount",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "readable_field",
      "integration_type": "alibaba",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "acombago",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Acomba GO"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "accountsiq",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_bill",
      "integration_name": "AccountsIQ"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "accountsiq",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_bill",
      "integration_name": "AccountsIQ"
   },
   {
      "type": "object",
      "created_at": "2026-08-12T18:27:34.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "accountsiq",
      "object_type": "accounting_bill",
      "integration_name": "AccountsIQ"
   },
   {
      "type": "method",
      "integration_type": "accountsiq",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AccountsIQ"
   },
   {
      "type": "method",
      "integration_type": "accountsiq",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AccountsIQ"
   },
   {
      "type": "readable_field",
      "integration_type": "8x8xcaas",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "readable_field",
      "integration_type": "8x8",
      "created_at": "2026-08-12T18:27:34.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "integration",
      "created_at": "2026-08-12T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "oraclefusion",
      "integration_name": "Oracle Fusion ERP"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T16:38:57.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "assigned_user_ids",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "trello",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "completed_at",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "trello",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "assigned_user_ids",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "completed_at",
      "integration_name": "Monday"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_item",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "payment_payment",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_item",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clover",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "payment_payment",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "object_type": "commerce_item",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "object_type": "commerce_collection",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "object_type": "accounting_contact",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "object_type": "accounting_taxrate",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "object_type": "accounting_salesorder",
      "integration_name": "Clover"
   },
   {
      "type": "object",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "object_type": "payment_payment",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Clover"
   },
   {
      "type": "method",
      "integration_type": "clover",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Clover"
   },
   {
      "type": "writable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "writable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "writable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "writable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_group",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_comment",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_contact",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_recording",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_group",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_comment",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_contact",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_recording",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_start_gte",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_end_lt",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "object",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "cloudtalk",
      "object_type": "hris_group",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "object",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "cloudtalk",
      "object_type": "uc_comment",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "object",
      "created_at": "2026-08-11T15:05:49.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "cloudtalk",
      "object_type": "uc_recording",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_comment",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_comment",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "method",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-11T15:05:49.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "integration",
      "created_at": "2026-08-11T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "tsheets",
      "integration_name": "QuickBooks Time"
   },
   {
      "type": "integration",
      "created_at": "2026-08-11T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "teamtailorassessment",
      "integration_name": "Teamtailor Assessment"
   },
   {
      "type": "integration",
      "created_at": "2026-08-11T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "smartrecruitersassessment",
      "integration_name": "SmartRecruiters Assessment"
   },
   {
      "type": "integration",
      "created_at": "2026-08-11T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "quickbooksworkforce",
      "integration_name": "QuickBooks Workforce"
   },
   {
      "type": "integration",
      "created_at": "2026-08-11T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "paylocityassessment",
      "integration_name": "Paylocity Assessment"
   },
   {
      "type": "integration",
      "created_at": "2026-08-11T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "jobadderassessment",
      "integration_name": "JobAdder Assessment"
   },
   {
      "type": "integration",
      "created_at": "2026-08-11T00:00:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "intuitenterprise",
      "integration_name": "Intuit Enterprise Suite"
   },
   {
      "type": "integration",
      "created_at": "2026-08-11T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "atsanywhereassessment",
      "integration_name": "ATS Anywhere Assessment"
   },
   {
      "type": "writable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "writable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "writable_field",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "method",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "method",
      "integration_type": "cegid_recruiting",
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cegid_hr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "hris_document",
      "integration_name": "Cegid HR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cegid_hr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "hris_document",
      "integration_name": "Cegid HR"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_hr",
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Cegid HR"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_hr",
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Cegid HR"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_hr",
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Cegid HR"
   },
   {
      "type": "object",
      "created_at": "2026-08-10T16:16:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "cegid_hr",
      "object_type": "hris_document",
      "integration_name": "Cegid HR"
   },
   {
      "type": "method",
      "integration_type": "cegid_hr",
      "created_at": "2026-08-10T16:16:05.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cegid HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workday",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workday"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workday",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Workday"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workday",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workday"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workday",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-10T14:27:55.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-10T14:27:55.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-10T14:27:55.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-10T14:27:55.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-10T14:27:55.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-10T14:27:55.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "object_type": "performance_cycle",
      "integration_type": "lattice",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "Lattice"
   },
   {
      "type": "object",
      "object_type": "performance_review",
      "integration_type": "lattice",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "Lattice"
   },
   {
      "type": "object",
      "object_type": "performance_goal",
      "integration_type": "lattice",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "Lattice"
   },
   {
      "type": "object",
      "object_type": "performance_feedback",
      "integration_type": "lattice",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "Lattice"
   },
   {
      "type": "method",
      "integration_type": "lattice",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_cycle",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lattice"
   },
   {
      "type": "method",
      "integration_type": "lattice",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_cycle",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lattice"
   },
   {
      "type": "method",
      "integration_type": "lattice",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_review",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lattice"
   },
   {
      "type": "method",
      "integration_type": "lattice",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_goal",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lattice"
   },
   {
      "type": "method",
      "integration_type": "lattice",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_goal",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lattice"
   },
   {
      "type": "method",
      "integration_type": "lattice",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_feedback",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lattice"
   },
   {
      "type": "method",
      "integration_type": "lattice",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_feedback",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lattice"
   },
   {
      "type": "object",
      "object_type": "performance_goal",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_goal",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "object_type": "performance_feedback",
      "integration_type": "engagedly",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "Engagedly"
   },
   {
      "type": "method",
      "integration_type": "engagedly",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_feedback",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Engagedly"
   },
   {
      "type": "object",
      "object_type": "performance_goal",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_goal",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_goal",
      "categories": [
         "hris",
         "ats",
         "performance",
         "passthrough",
         "auth"
      ],
      "method": "create",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_cycle",
      "integration_name": "15Five"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_review",
      "integration_name": "15Five"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_goal",
      "integration_name": "15Five"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_feedback",
      "integration_name": "15Five"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_cycle",
      "integration_name": "15Five"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_review",
      "integration_name": "15Five"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_goal",
      "integration_name": "15Five"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_feedback",
      "integration_name": "15Five"
   },
   {
      "type": "object",
      "object_type": "performance_cycle",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "15Five"
   },
   {
      "type": "object",
      "object_type": "performance_review",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "15Five"
   },
   {
      "type": "object",
      "object_type": "performance_goal",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "15Five"
   },
   {
      "type": "object",
      "object_type": "performance_feedback",
      "integration_type": "15five",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:27:55.000Z",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_cycle",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_cycle",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_review",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_goal",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_goal",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_feedback",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_feedback",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-08-10T14:27:55.000Z",
      "object_type": "performance_feedback",
      "categories": [
         "hris",
         "performance",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "15Five"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomcalendar",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zellis",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Zellis"
   },
   {
      "type": "readable_field",
      "integration_type": "zambion",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "readable_field",
      "integration_type": "yuki",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Yuki"
   },
   {
      "type": "readable_field",
      "integration_type": "yoobic",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "YOOBIC"
   },
   {
      "type": "readable_field",
      "integration_type": "xurrent",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Xurrent"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_project",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_quote",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_agedreceivable",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_agedpayable",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_agedreceivable",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_agedreceivable",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_agedpayable",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_agedpayable",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "wecom",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "WeCom (WeChat Work)"
   },
   {
      "type": "readable_field",
      "integration_type": "webex",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Webex"
   },
   {
      "type": "readable_field",
      "integration_type": "wealthbox",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Wealthbox"
   },
   {
      "type": "readable_field",
      "integration_type": "wafeq",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Wafeq"
   },
   {
      "type": "readable_field",
      "integration_type": "vivaengage",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Viva Engage"
   },
   {
      "type": "readable_field",
      "integration_type": "vismabusinessnxt",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Visma Business NXT"
   },
   {
      "type": "readable_field",
      "integration_type": "veevavault",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Veeva Vault"
   },
   {
      "type": "readable_field",
      "integration_type": "unit4erpx",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Unit4 ERPx"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgready",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "UKG Ready"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukg_hr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "readable_field",
      "integration_type": "ujet",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Ujet"
   },
   {
      "type": "readable_field",
      "integration_type": "twinfield",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Twinfield"
   },
   {
      "type": "readable_field",
      "integration_type": "trello",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "traffit",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Traffit"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "tempworks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "TempWorks"
   },
   {
      "type": "readable_field",
      "integration_type": "techwolf",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Techwolf"
   },
   {
      "type": "readable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Team Software"
   },
   {
      "type": "object",
      "object_type": "accounting_project",
      "integration_type": "teamsoftware",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "Team Software"
   },
   {
      "type": "method",
      "integration_type": "teamsoftware",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Team Software"
   },
   {
      "type": "method",
      "integration_type": "teamsoftware",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Team Software"
   },
   {
      "type": "method",
      "integration_type": "teamsoftware",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Team Software"
   },
   {
      "type": "method",
      "integration_type": "teamsoftware",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Team Software"
   },
   {
      "type": "readable_field",
      "integration_type": "tapclicks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "TapClicks"
   },
   {
      "type": "readable_field",
      "integration_type": "tally",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Tally"
   },
   {
      "type": "readable_field",
      "integration_type": "taleo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "readable_field",
      "integration_type": "talentlyft",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "TalentLyft"
   },
   {
      "type": "readable_field",
      "integration_type": "talentech",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Talentech"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Streamtime"
   },
   {
      "type": "object",
      "object_type": "accounting_project",
      "integration_type": "streamtime",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "spott",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Spott"
   },
   {
      "type": "readable_field",
      "integration_type": "spiris",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Spiris"
   },
   {
      "type": "readable_field",
      "integration_type": "sparkhire",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Spark Hire"
   },
   {
      "type": "readable_field",
      "integration_type": "snowflake",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Snowflake"
   },
   {
      "type": "readable_field",
      "integration_type": "snipeit",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Snipe-IT"
   },
   {
      "type": "readable_field",
      "integration_type": "signrequest",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "signing",
         "storage",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "SignRequest"
   },
   {
      "type": "readable_field",
      "integration_type": "signaturely",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "signing",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Signaturely"
   },
   {
      "type": "readable_field",
      "integration_type": "shapes",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Shapes"
   },
   {
      "type": "readable_field",
      "integration_type": "sap",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "salesfinity",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Salesfinity"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "object_type": "accounting_project",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Sage HR"
   },
   {
      "type": "object",
      "object_type": "accounting_quote",
      "integration_type": "sage200sales",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "Sage 200 Sales (Spain)"
   },
   {
      "type": "readable_field",
      "integration_type": "rydoo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Rydoo"
   },
   {
      "type": "readable_field",
      "integration_type": "rotacloud",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "RotaCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "rosnet",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Rosnet"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "ringover",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Ringover"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "revsport",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Rev Sport"
   },
   {
      "type": "readable_field",
      "integration_type": "restaurant365",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Restaurant365"
   },
   {
      "type": "readable_field",
      "integration_type": "remote",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Remote.com"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Atlas"
   },
   {
      "type": "readable_field",
      "integration_type": "reachmee",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "ReachMee"
   },
   {
      "type": "readable_field",
      "integration_type": "ramp",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Ramp"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "employee_roles",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "project_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "project_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_project",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_quote",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_agedreceivable",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_agedpayable",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_quote",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_agedreceivable",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_agedreceivable",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_agedpayable",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_agedpayable",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "pylon",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Pylon"
   },
   {
      "type": "readable_field",
      "integration_type": "prismhr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "PrismHR"
   },
   {
      "type": "readable_field",
      "integration_type": "prestashop",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "PrestaShop"
   },
   {
      "type": "readable_field",
      "integration_type": "posthog",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "PostHog"
   },
   {
      "type": "readable_field",
      "integration_type": "picqer",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Picqer"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "PeopleHR"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "employee_roles",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "employee_roles",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "payworks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Payworks"
   },
   {
      "type": "readable_field",
      "integration_type": "payspace",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Payspace"
   },
   {
      "type": "readable_field",
      "integration_type": "paypal",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Paypal"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "payfit",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "PayFit"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycom",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Paycom"
   },
   {
      "type": "readable_field",
      "integration_type": "paychex",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Paychex"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "otys",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "OTYS"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "opensearch",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "OpenSearch"
   },
   {
      "type": "readable_field",
      "integration_type": "onlyfy",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "onlyfy"
   },
   {
      "type": "readable_field",
      "integration_type": "onespansign",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "signing",
         "storage",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "OneSpan"
   },
   {
      "type": "readable_field",
      "integration_type": "onelogin",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "OneLogin"
   },
   {
      "type": "readable_field",
      "integration_type": "oneflow",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "signing",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Oneflow"
   },
   {
      "type": "readable_field",
      "integration_type": "oleeo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Oleeo"
   },
   {
      "type": "readable_field",
      "integration_type": "okta",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Okta"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "notion",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Notion"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "netvisor",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Visma Netvisor"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_project",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "accounting_project",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "motion",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Motion"
   },
   {
      "type": "readable_field",
      "integration_type": "mongodb",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "MongoDB"
   },
   {
      "type": "readable_field",
      "integration_type": "modjo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Modjo"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2026-08-10T14:21:32.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2026-08-10T14:21:32.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftintune",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsfinanceoperations",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Dynamics 365 Finance and Operations"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "metabase",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Metabase"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "marketing360",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Marketing360"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "lucca",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Lucca"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "logicmelon",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "LogicMelon"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "linkedinlearning",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "linkedinlearning",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "subjects",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "short_description",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "published_at",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "provider_name",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "instructor_ids",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "external_reference",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "duration_minutes",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "difficulty",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "categories",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "pagination",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "list_query",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "pagination",
      "integration_type": "linkedinlearning",
      "created_at": "2026-08-10T14:21:32.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "list_updated_gte",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "lightspeedkseries",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "readable_field",
      "integration_type": "lightfield",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Lightfield"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "leapsome",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Leapsome"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "kula",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Kula"
   },
   {
      "type": "readable_field",
      "integration_type": "knowbe4",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "KnowBe4"
   },
   {
      "type": "readable_field",
      "integration_type": "keycloak",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Keycloak"
   },
   {
      "type": "readable_field",
      "integration_type": "kenjo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Kenjo"
   },
   {
      "type": "readable_field",
      "integration_type": "keka",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Keka"
   },
   {
      "type": "readable_field",
      "integration_type": "kashoo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Kashoo"
   },
   {
      "type": "readable_field",
      "integration_type": "kandji",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "readable_field",
      "integration_type": "justworks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Justworks"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "JustCall"
   },
   {
      "type": "readable_field",
      "integration_type": "joinwarp",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Warp"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jamf",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Jamf"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humanforce",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Humanforce"
   },
   {
      "type": "readable_field",
      "integration_type": "humaans",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris"
      ],
      "field": "employee_roles",
      "integration_name": "Humaans"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "hirebee",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Hirebee"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hexnode",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Hexnode"
   },
   {
      "type": "readable_field",
      "integration_type": "heavenhr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "HeavenHR"
   },
   {
      "type": "readable_field",
      "integration_type": "harvest",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Harvest"
   },
   {
      "type": "readable_field",
      "integration_type": "harri",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Harri"
   },
   {
      "type": "readable_field",
      "integration_type": "haileyhr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "HaileyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "guru",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Guru"
   },
   {
      "type": "readable_field",
      "integration_type": "grain",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Grain"
   },
   {
      "type": "readable_field",
      "integration_type": "grafana",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Grafana"
   },
   {
      "type": "readable_field",
      "integration_type": "goto",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "GoTO"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "goco",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "giighire",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Giig Hire"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "front",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Front"
   },
   {
      "type": "readable_field",
      "integration_type": "freshteam",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Freshteam"
   },
   {
      "type": "readable_field",
      "integration_type": "freshservice",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Freshservice"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freeagent",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "FreeAgent"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "foundU"
   },
   {
      "type": "readable_field",
      "integration_type": "fortnox",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Fortnox"
   },
   {
      "type": "readable_field",
      "integration_type": "folkshr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Folks HR"
   },
   {
      "type": "readable_field",
      "integration_type": "flatchr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Flatchr"
   },
   {
      "type": "readable_field",
      "integration_type": "firstadvantage",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "First Advantage"
   },
   {
      "type": "readable_field",
      "integration_type": "fathom",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Fathom"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "exelare",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Exelare"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "epicor",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Epicor Kinetic"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "ELMO"
   },
   {
      "type": "readable_field",
      "integration_type": "elasticsearch",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Eightfold"
   },
   {
      "type": "readable_field",
      "integration_type": "dvinci",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "d.vinci"
   },
   {
      "type": "readable_field",
      "integration_type": "dubber",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Dubber"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "employee_roles",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dashlane",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Dashlane"
   },
   {
      "type": "readable_field",
      "integration_type": "cultureamp",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Culture Amp"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "coveto",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Coveto"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstonetalentlink",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Cornerstone TalentLink"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "connecteam",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Connecteam"
   },
   {
      "type": "readable_field",
      "integration_type": "congasign",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "signing",
         "storage",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Conga Sign"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "clayhr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "forms",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "ClayHR"
   },
   {
      "type": "readable_field",
      "integration_type": "circle",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Circle.so"
   },
   {
      "type": "readable_field",
      "integration_type": "charthop",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "ChartHop"
   },
   {
      "type": "readable_field",
      "integration_type": "charliehr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "CharlieHR"
   },
   {
      "type": "readable_field",
      "integration_type": "cezannehr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Certn"
   },
   {
      "type": "readable_field",
      "integration_type": "cegid_hr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Cegid HR"
   },
   {
      "type": "readable_field",
      "integration_type": "cascade",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Cascade"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "canvas",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Canvas"
   },
   {
      "type": "readable_field",
      "integration_type": "callswitchone",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "brightmove",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "BrightMove"
   },
   {
      "type": "readable_field",
      "integration_type": "brex",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Brex"
   },
   {
      "type": "readable_field",
      "integration_type": "breathehr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "BreatheHR"
   },
   {
      "type": "readable_field",
      "integration_type": "boondmanager",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "BoondManager"
   },
   {
      "type": "readable_field",
      "integration_type": "boldsign",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "signing",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "BoldSign"
   },
   {
      "type": "readable_field",
      "integration_type": "bitwarden",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Bitwarden"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "billomat",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Billomat"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "employee_roles",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "avionte",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Avionté"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "arcoro",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Arcoro"
   },
   {
      "type": "readable_field",
      "integration_type": "aptem",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Aptem"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "ameego",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Ameego"
   },
   {
      "type": "readable_field",
      "integration_type": "aloware",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Aloware"
   },
   {
      "type": "readable_field",
      "integration_type": "alegra",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Alegra"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "afas",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "readable_field",
      "integration_type": "adyen",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Adyen"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adobeworkfront",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Adobe Workfront"
   },
   {
      "type": "readable_field",
      "integration_type": "acumatica",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Acumatica"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "abacus",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Abacus"
   },
   {
      "type": "readable_field",
      "integration_type": "8x8xcaas",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "readable_field",
      "integration_type": "3cx",
      "created_at": "2026-08-10T14:21:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "3CX"
   },
   {
      "type": "integration",
      "created_at": "2026-08-10T00:00:00.000Z",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "integration_type": "xert",
      "integration_name": "Xert"
   },
   {
      "type": "integration",
      "created_at": "2026-08-10T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "payment",
         "passthrough"
      ],
      "integration_type": "revelsystems",
      "integration_name": "Revel Systems"
   },
   {
      "type": "integration",
      "created_at": "2026-08-10T00:00:00.000Z",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "integration_type": "garmin",
      "integration_name": "Garmin"
   },
   {
      "type": "integration",
      "created_at": "2026-08-10T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "acombago",
      "integration_name": "Acomba GO"
   },
   {
      "type": "integration",
      "created_at": "2026-08-09T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "wisetail",
      "integration_name": "Wisetail"
   },
   {
      "type": "integration",
      "created_at": "2026-08-09T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "talentlms",
      "integration_name": "TalentLMS"
   },
   {
      "type": "integration",
      "created_at": "2026-08-09T00:00:00.000Z",
      "categories": [
         "crm",
         "ats",
         "passthrough"
      ],
      "integration_type": "rolepoint",
      "integration_name": "RolePoint"
   },
   {
      "type": "integration",
      "created_at": "2026-08-09T00:00:00.000Z",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "parbrink",
      "integration_name": "PAR Brink POS"
   },
   {
      "type": "integration",
      "created_at": "2026-08-09T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "litmos",
      "integration_name": "Litmos"
   },
   {
      "type": "integration",
      "created_at": "2026-08-09T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "360learning",
      "integration_name": "360Learning"
   },
   {
      "type": "integration",
      "created_at": "2026-08-08T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "sellsy",
      "integration_name": "Sellsy"
   },
   {
      "type": "integration",
      "created_at": "2026-08-08T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "sagex3",
      "integration_name": "Sage X3"
   },
   {
      "type": "integration",
      "created_at": "2026-08-08T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "sageconstructionmanagement",
      "integration_name": "Sage Construction Management"
   },
   {
      "type": "integration",
      "created_at": "2026-08-08T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "sage200sales",
      "integration_name": "Sage 200 Sales (Spain)"
   },
   {
      "type": "integration",
      "created_at": "2026-08-08T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "sage200",
      "integration_name": "Sage 200 Standard & Professional"
   },
   {
      "type": "integration",
      "created_at": "2026-08-08T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "cegidloop",
      "integration_name": "Cegid Loop"
   },
   {
      "type": "integration",
      "created_at": "2026-08-08T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "passthrough"
      ],
      "integration_type": "brightpearl",
      "integration_name": "Brightpearl"
   },
   {
      "type": "integration",
      "created_at": "2026-08-08T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "axonaut",
      "integration_name": "Axonaut"
   },
   {
      "type": "pagination",
      "integration_type": "zohosign",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_query",
      "integration_name": "Zoho Sign"
   },
   {
      "type": "pagination",
      "integration_type": "zohosign",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_order",
      "integration_name": "Zoho Sign"
   },
   {
      "type": "pagination",
      "integration_type": "zohosign",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_order",
      "integration_name": "Zoho Sign"
   },
   {
      "type": "pagination",
      "integration_type": "zohosign",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_order",
      "integration_name": "Zoho Sign"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartsearch",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "SmartSearch"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartsearch",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "SmartSearch"
   },
   {
      "type": "pagination",
      "integration_type": "smartsearch",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "SmartSearch"
   },
   {
      "type": "pagination",
      "integration_type": "smartsearch",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SmartSearch"
   },
   {
      "type": "pagination",
      "integration_type": "smartsearch",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SmartSearch"
   },
   {
      "type": "pagination",
      "integration_type": "shoplazza",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_contact_id",
      "integration_name": "Shoplazza"
   },
   {
      "type": "pagination",
      "integration_type": "shoplazza",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Shoplazza"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopee",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "payment_payout",
      "integration_name": "Shopee"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopee",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "payment_payout",
      "integration_name": "Shopee"
   },
   {
      "type": "pagination",
      "integration_type": "shopee",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "list_updated_gte",
      "integration_name": "Shopee"
   },
   {
      "type": "pagination",
      "integration_type": "shopee",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shopee"
   },
   {
      "type": "pagination",
      "integration_type": "shopee",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Shopee"
   },
   {
      "type": "pagination",
      "integration_type": "quickfile",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "QuickFile"
   },
   {
      "type": "pagination",
      "integration_type": "quickfile",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_contact_id",
      "integration_name": "QuickFile"
   },
   {
      "type": "pagination",
      "integration_type": "quickfile",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "QuickFile"
   },
   {
      "type": "pagination",
      "integration_type": "quickfile",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_contact_id",
      "integration_name": "QuickFile"
   },
   {
      "type": "pagination",
      "integration_type": "quickfile",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "QuickFile"
   },
   {
      "type": "pagination",
      "integration_type": "picqer",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Picqer"
   },
   {
      "type": "pagination",
      "integration_type": "picqer",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_contact_id",
      "integration_name": "Picqer"
   },
   {
      "type": "pagination",
      "integration_type": "picqer",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Picqer"
   },
   {
      "type": "pagination",
      "integration_type": "picqer",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_contact_id",
      "integration_name": "Picqer"
   },
   {
      "type": "pagination",
      "integration_type": "picqer",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Picqer"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_order",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oleeo",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Oleeo"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "labels",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "account_number",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "url_tags",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "labels",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "labels",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "loxo",
      "object_type": "ats_scorecard",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "creative_selection",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "creative_selection",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "keycloak",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "Keycloak"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "googlesa360",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "managers",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlesa360",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "slow_fields",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "githubenterpriseserver",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "githubenterpriseserver",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_offset",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "githubapp",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "githubapp",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "pagination",
      "integration_type": "githubapp",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_offset",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "pagination",
      "integration_type": "githubapp",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "pagination",
      "integration_type": "githubapp",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_offset",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "freeagent",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_user_id",
      "integration_name": "FreeAgent"
   },
   {
      "type": "pagination",
      "integration_type": "freeagent",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "FreeAgent"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Fountain"
   },
   {
      "type": "object",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "byteplus",
      "object_type": "genai_model",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "method",
      "integration_type": "byteplus",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "method",
      "integration_type": "byteplus",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "pagination",
      "integration_type": "bol",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_item_id",
      "integration_name": "bol.com"
   },
   {
      "type": "writable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "writable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "priority",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "applicantstack",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-08-07T15:47:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_type",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2026-08-07T15:47:05.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_type",
      "integration_name": "Akeneo"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "worktango",
      "integration_name": "WorkTango"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "lightspeedretailrseries",
      "integration_name": "Lightspeed Retail R-Series"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "commerce",
         "crm",
         "accounting",
         "passthrough"
      ],
      "integration_type": "lightspeedpos",
      "integration_name": "Lightspeed POS (X-Series)"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "kit",
      "integration_name": "Kit"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "googleplaces",
      "integration_name": "Google Places API"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "congasign",
      "integration_name": "Conga Sign"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "integration_type": "clearbooks",
      "integration_name": "Clear Books"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "charthop",
      "integration_name": "ChartHop"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "campaignmonitor",
      "integration_name": "Campaign Monitor"
   },
   {
      "type": "integration",
      "created_at": "2026-08-07T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "braze",
      "integration_name": "Braze"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_query",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_user_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_customer_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_customer_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "youtubeanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_dimension",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "youtubeanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_start_gte",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "youtubeanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_end_lt",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "youtubeanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_property_id",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "youtubeanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_type",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "yelp",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_type",
      "integration_name": "Yelp"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "whatsapp",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_parent_id",
      "integration_name": "WhatsApp"
   },
   {
      "type": "pagination",
      "integration_type": "vismabusinessnxt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Visma Business NXT"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_org_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "talentech",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Talentech"
   },
   {
      "type": "pagination",
      "integration_type": "talentech",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_company_id",
      "integration_name": "Talentech"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "list_order",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "list_order",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "list_course_id",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "virtual_webhook_course_id",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_type",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_query",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_query",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_org_id",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_query",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_campaign_id",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_org_id",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_query",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_group_id",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_campaign_id",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "stackadapt",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_org_id",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "segment",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "object_type": "cdp_activation",
      "pagination": "list_segment_id",
      "integration_name": "Twilio Segment"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_org_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_org_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sap",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_type",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_type",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_type",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_type",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "rotageek",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_user_id",
      "integration_name": "Rotageek"
   },
   {
      "type": "pagination",
      "integration_type": "rotageek",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_location_id",
      "integration_name": "Rotageek"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_type",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_type",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rillet",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Rillet"
   },
   {
      "type": "pagination",
      "integration_type": "rillet",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_type",
      "integration_name": "Rillet"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_company_id",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_pipeline_id",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_user_id",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_lead_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_contact_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_deal_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recharge",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_type",
      "integration_name": "Recharge"
   },
   {
      "type": "pagination",
      "integration_type": "pylon",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "Pylon"
   },
   {
      "type": "pagination",
      "integration_type": "pylon",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_end_lt",
      "integration_name": "Pylon"
   },
   {
      "type": "pagination",
      "integration_type": "prestashop",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_contact_id",
      "integration_name": "PrestaShop"
   },
   {
      "type": "pagination",
      "integration_type": "prestashop",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "PrestaShop"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_property_id",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_session",
      "pagination": "list_medium",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_session",
      "pagination": "list_source",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_session",
      "pagination": "list_query",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_session",
      "pagination": "list_start_gte",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_session",
      "pagination": "list_end_lt",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_session",
      "pagination": "list_property_id",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_session",
      "pagination": "list_user_id",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_session",
      "pagination": "list_visitor_id",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "list_query",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "list_property_id",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "virtual_webhook_property_id",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_property_id",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_type",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_candidate_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_application_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_job_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_type",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pendo",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_query",
      "integration_name": "Pendo"
   },
   {
      "type": "pagination",
      "integration_type": "pendo",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_start_gte",
      "integration_name": "Pendo"
   },
   {
      "type": "pagination",
      "integration_type": "pendo",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_end_lt",
      "integration_name": "Pendo"
   },
   {
      "type": "pagination",
      "integration_type": "pendo",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_type",
      "integration_name": "Pendo"
   },
   {
      "type": "pagination",
      "integration_type": "pendo",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_property_id",
      "integration_name": "Pendo"
   },
   {
      "type": "pagination",
      "integration_type": "pendo",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_visitor_id",
      "integration_name": "Pendo"
   },
   {
      "type": "pagination",
      "integration_type": "pendo",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "list_query",
      "integration_name": "Pendo"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_interview",
      "pagination": "list_application_id",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_interview",
      "pagination": "list_application_id",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "pageup",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "PageUp"
   },
   {
      "type": "pagination",
      "integration_type": "opentable",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_query",
      "integration_name": "OpenTable"
   },
   {
      "type": "pagination",
      "integration_type": "opentable",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_org_id",
      "integration_name": "OpenTable"
   },
   {
      "type": "pagination",
      "integration_type": "opentable",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_type",
      "integration_name": "OpenTable"
   },
   {
      "type": "pagination",
      "integration_type": "openaiads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_start_gte",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "pagination",
      "integration_type": "openaiads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_end_lt",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "pagination",
      "integration_type": "openaiads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_ad_id",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "pagination",
      "integration_type": "openaiads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_group_id",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "pagination",
      "integration_type": "openaiads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_campaign_id",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "okta",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "hris_group",
      "integration_name": "Okta"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "okta",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "hris_group",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_type",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_type",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "datastore_table",
      "pagination": "list_parent_id",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_type",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_type",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_type",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_dimension",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_type",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "virtual_webhook_type",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Manatal"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Manatal"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "mambu",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_account_id",
      "integration_name": "Mambu"
   },
   {
      "type": "pagination",
      "integration_type": "mambu",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_org_id",
      "integration_name": "Mambu"
   },
   {
      "type": "pagination",
      "integration_type": "magento",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_item_id",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "pagination",
      "integration_type": "magento",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_item_variant_id",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "pagination",
      "integration_type": "magento",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_location_id",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "pagination",
      "integration_type": "logicmelon",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "LogicMelon"
   },
   {
      "type": "pagination",
      "integration_type": "logicmelon",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "LogicMelon"
   },
   {
      "type": "pagination",
      "integration_type": "logicmelon",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_company_id",
      "integration_name": "LogicMelon"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_query",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "kevel",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_campaign_id",
      "integration_name": "Kevel"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "keap",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "martech_member",
      "integration_name": "Keap"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "keap",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "martech_member",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_updated_gte",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Keap"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_interview",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "hris_group",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "hris_location",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "crm_event",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_document",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_interview",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "hris_group",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "hris_location",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "crm_event",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_document",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "virtual_webhook_type",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "holded",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Holded"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "holded",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_updated_gte",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Holded"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "crm_lead",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "crm_lead",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "harri",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_company_id",
      "integration_name": "Harri"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_parent_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledirectory",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "auth",
         "saml",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_query",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "pagination",
      "integration_type": "googlecampaignmanager360",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_campaign_id",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "pagination",
      "integration_type": "googleanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_start_gte",
      "integration_name": "Google Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "googleanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_end_lt",
      "integration_name": "Google Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "googleanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_event",
      "pagination": "list_property_id",
      "integration_name": "Google Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "googleanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_start_gte",
      "integration_name": "Google Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "googleanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_end_lt",
      "integration_name": "Google Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "googleanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_property_id",
      "integration_name": "Google Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "googleanalytics",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_type",
      "integration_name": "Google Analytics"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_query",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "gainsight",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "Gainsight"
   },
   {
      "type": "pagination",
      "integration_type": "freshteam",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_type",
      "integration_name": "Freshteam"
   },
   {
      "type": "pagination",
      "integration_type": "freshteam",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_type",
      "integration_name": "Freshteam"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_contact_id",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_balancesheet",
      "pagination": "list_start_gte",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_balancesheet",
      "pagination": "list_end_lt",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_contact_id",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "esco",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_taxonomy",
      "pagination": "list_type",
      "integration_name": "ESCO"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_query",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "epicor",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Epicor Kinetic"
   },
   {
      "type": "pagination",
      "integration_type": "dualentry",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "DualEntry"
   },
   {
      "type": "pagination",
      "integration_type": "dropbox",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_expand",
      "integration_name": "Dropbox"
   },
   {
      "type": "pagination",
      "integration_type": "datev",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_org_id",
      "integration_name": "DATEV"
   },
   {
      "type": "pagination",
      "integration_type": "datev",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_org_id",
      "integration_name": "DATEV"
   },
   {
      "type": "pagination",
      "integration_type": "d2l",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "object_type": "lms_instructor",
      "pagination": "list_company_id",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "pagination",
      "integration_type": "d2l",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "list_company_id",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "pagination",
      "integration_type": "coursera",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "list_class_id",
      "integration_name": "Coursera"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clover",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Clover"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clover",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Clover"
   },
   {
      "type": "pagination",
      "integration_type": "clover",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_updated_gte",
      "integration_name": "Clover"
   },
   {
      "type": "pagination",
      "integration_type": "clover",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Clover"
   },
   {
      "type": "pagination",
      "integration_type": "clover",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Clover"
   },
   {
      "type": "pagination",
      "integration_type": "clover",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Clover"
   },
   {
      "type": "pagination",
      "integration_type": "clover",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Clover"
   },
   {
      "type": "pagination",
      "integration_type": "clover",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Clover"
   },
   {
      "type": "pagination",
      "integration_type": "cezannehr",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_deduction",
      "pagination": "list_user_id",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_activity",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "carerix",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_activity",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_order",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_type",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_query",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_query",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_order",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_order",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_order",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "apploi",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Apploi"
   },
   {
      "type": "pagination",
      "integration_type": "apploi",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Apploi"
   },
   {
      "type": "pagination",
      "integration_type": "apploi",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_company_id",
      "integration_name": "Apploi"
   },
   {
      "type": "pagination",
      "integration_type": "apploi",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Apploi"
   },
   {
      "type": "object",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "ats_activity",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-08-06T12:46:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "absorb",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "list_course_id",
      "integration_name": "Absorb"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-08-06T12:46:33.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_order",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "integration",
      "created_at": "2026-08-06T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "sagepeople",
      "integration_name": "Sage People"
   },
   {
      "type": "integration",
      "created_at": "2026-08-06T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "opensesame",
      "integration_name": "OpenSesame"
   },
   {
      "type": "integration",
      "created_at": "2026-08-06T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "folkshr",
      "integration_name": "Folks HR"
   },
   {
      "type": "sign-in",
      "integration_type": "closeio",
      "created_at": "2026-08-05T14:05:17.000Z",
      "integration_name": "Close",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "integration",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "ticketing",
         "task",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "xurrent",
      "integration_name": "Xurrent"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "external_number",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "external_number",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "integration_type": "xero",
      "object_type": "accounting_creditmemo",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "Workday"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_contact",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_contact",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_contact",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "QuickBooks"
   },
   {
      "type": "integration",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment",
         "passthrough"
      ],
      "integration_type": "netvisor",
      "integration_name": "Visma Netvisor"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "calendar_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "calendar_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "integration",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "kashoo",
      "integration_name": "Kashoo"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_order",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Jobvite"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "ats_applicationstatus",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "call_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "external_number",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "external_number",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "FreeAgent"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_journal",
      "integration_name": "FreeAgent"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "FreeAgent"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "FreeAgent"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_journal",
      "integration_name": "FreeAgent"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freeagent",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "FreeAgent"
   },
   {
      "type": "sign-in",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "integration_name": "FreeAgent",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "readable_field",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_balancesheet",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_cashflow",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_category",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_creditmemo",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_journal",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_organization",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_profitloss",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_taxrate",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_transaction",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "accounting_trialbalance",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "hris_bankaccount",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "hris_company",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "hris_device",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "hris_employee",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "hris_timeshift",
      "integration_name": "FreeAgent"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "object_type": "storage_file",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_cashflow",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_cashflow",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_company",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_device",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_device",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FreeAgent"
   },
   {
      "type": "method",
      "integration_type": "freeagent",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FreeAgent"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "etsy",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "commerce_item",
      "integration_name": "Etsy"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "etsy",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Etsy"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "etsy",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "payment_payment",
      "integration_name": "Etsy"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "etsy",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "commerce_item",
      "integration_name": "Etsy"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "etsy",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Etsy"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "etsy",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "payment_payment",
      "integration_name": "Etsy"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "etsy",
      "object_type": "commerce_item",
      "integration_name": "Etsy"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "etsy",
      "object_type": "commerce_collection",
      "integration_name": "Etsy"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "etsy",
      "object_type": "accounting_salesorder",
      "integration_name": "Etsy"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "etsy",
      "object_type": "payment_payment",
      "integration_name": "Etsy"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "etsy",
      "object_type": "passthrough",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Etsy"
   },
   {
      "type": "method",
      "integration_type": "etsy",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "payment_payment",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Etsy"
   },
   {
      "type": "pagination",
      "integration_type": "concurcompany",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_contact",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_company",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_contact",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_contact",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_company",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_contact",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "integration_type": "afas",
      "object_type": "crm_contact",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "integration_type": "afas",
      "object_type": "crm_company",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "object",
      "created_at": "2026-08-05T11:13:28.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "integration_type": "afas",
      "object_type": "accounting_contact",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_contact",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_contact",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_contact",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_contact",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_contact",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "method",
      "integration_type": "afas",
      "created_at": "2026-08-05T11:13:28.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "integration",
      "created_at": "2026-08-05T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "fellow",
      "integration_name": "Fellow"
   },
   {
      "type": "integration",
      "created_at": "2026-08-04T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "journyio",
      "integration_name": "journy.io"
   },
   {
      "type": "integration",
      "created_at": "2026-08-04T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "harvest",
      "integration_name": "Harvest"
   },
   {
      "type": "integration",
      "created_at": "2026-08-04T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "grafana",
      "integration_name": "Grafana"
   },
   {
      "type": "integration",
      "created_at": "2026-08-04T00:00:00.000Z",
      "categories": [
         "ticketing",
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "front",
      "integration_name": "Front"
   },
   {
      "type": "integration",
      "created_at": "2026-08-04T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "brightmove",
      "integration_name": "BrightMove"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "zipbooks",
      "integration_name": "ZipBooks"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "xodosign",
      "integration_name": "Xodo Sign"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "tempworks",
      "integration_name": "TempWorks"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "sparkhire",
      "integration_name": "Spark Hire"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "smartsearch",
      "integration_name": "SmartSearch"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "reachmee",
      "integration_name": "ReachMee"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "radancy",
      "integration_name": "Radancy Employee Referrals"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "quickfile",
      "integration_name": "QuickFile"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "saml"
      ],
      "integration_type": "pingidentitysaml",
      "integration_name": "Ping Identity SAML"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "integration_type": "onelogin",
      "integration_name": "OneLogin"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "oleeo",
      "integration_name": "Oleeo"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "saml",
         "passthrough"
      ],
      "integration_type": "miniorangesaml",
      "integration_name": "miniOrange"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "learn365",
      "integration_name": "Learn365"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "hris",
         "saml",
         "passthrough"
      ],
      "integration_type": "keycloak",
      "integration_name": "Keycloak"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "kenjo",
      "integration_name": "Kenjo"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "keka",
      "integration_name": "Keka"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "jobelephant",
      "integration_name": "JobElephant"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "heyrecruit",
      "integration_name": "Heyrecruit"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "freshservice",
      "integration_name": "Freshservice"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "flexmail",
      "integration_name": "Flexmail"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "deskera",
      "integration_name": "Deskera Books"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "coveto",
      "integration_name": "Coveto"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "concludis",
      "integration_name": "concludis"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "signing",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "boldsign",
      "integration_name": "BoldSign"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "billomat",
      "integration_name": "Billomat"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "auth",
         "saml",
         "passthrough"
      ],
      "integration_type": "auth0saml",
      "integration_name": "Auth0"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "arcoro",
      "integration_name": "Arcoro"
   },
   {
      "type": "integration",
      "created_at": "2026-08-03T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "accountsiq",
      "integration_name": "AccountsIQ"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohosign",
      "integration_name": "Zoho Sign"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "yukiws",
      "integration_name": "Yuki Webservices"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "yuki",
      "integration_name": "Yuki"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "signing",
         "hris",
         "passthrough"
      ],
      "integration_type": "yousign",
      "integration_name": "Yousign"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "wafeq",
      "integration_name": "Wafeq"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "twinfield",
      "integration_name": "Twinfield"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "snelstart",
      "integration_name": "SnelStart"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "signrequest",
      "integration_name": "SignRequest"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "signing",
         "storage",
         "passthrough"
      ],
      "integration_type": "signnow",
      "integration_name": "SignNow"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "signing",
         "hris",
         "passthrough"
      ],
      "integration_type": "signaturely",
      "integration_name": "Signaturely"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "shopware",
      "integration_name": "Shopware"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "procountor",
      "integration_name": "Procountor"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "picqer",
      "integration_name": "Picqer"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "passthrough"
      ],
      "integration_type": "onespansign",
      "integration_name": "OneSpan"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "signing",
         "hris",
         "passthrough"
      ],
      "integration_type": "oneflow",
      "integration_name": "Oneflow"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "lightspeedecom",
      "integration_name": "Lightspeed eCom (C-Series)"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "jotform",
      "integration_name": "Jotform"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "signing",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "getaccept",
      "integration_name": "GetAccept"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "fortnox",
      "integration_name": "Fortnox"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "shipping",
         "passthrough"
      ],
      "integration_type": "bol",
      "integration_name": "bol.com"
   },
   {
      "type": "integration",
      "created_at": "2026-08-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "alegra",
      "integration_name": "Alegra"
   },
   {
      "type": "integration",
      "created_at": "2026-08-01T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "integration_type": "shoplazza",
      "integration_name": "Shoplazza"
   },
   {
      "type": "integration",
      "created_at": "2026-08-01T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "rosnet",
      "integration_name": "Rosnet"
   },
   {
      "type": "integration",
      "created_at": "2026-08-01T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "lazada",
      "integration_name": "Lazada"
   },
   {
      "type": "integration",
      "created_at": "2026-08-01T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "kashflow",
      "integration_name": "KashFlow"
   },
   {
      "type": "integration",
      "created_at": "2026-08-01T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "alibaba",
      "integration_name": "Alibaba.com"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "mysolution",
      "integration_name": "Mysolution"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "exactonline",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Exact Online"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "exactonline",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Exact Online"
   },
   {
      "type": "object",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "exactonline",
      "object_type": "accounting_invoice",
      "integration_name": "Exact Online"
   },
   {
      "type": "object",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "exactonline",
      "object_type": "accounting_organization",
      "integration_name": "Exact Online"
   },
   {
      "type": "method",
      "integration_type": "exactonline",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Exact Online"
   },
   {
      "type": "method",
      "integration_type": "exactonline",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Exact Online"
   },
   {
      "type": "method",
      "integration_type": "exactonline",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Exact Online"
   },
   {
      "type": "method",
      "integration_type": "exactonline",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Exact Online"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "lms_student",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "lms_student",
      "integration_name": "Cornerstone"
   },
   {
      "type": "object",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "cornerstone",
      "object_type": "lms_course",
      "integration_name": "Cornerstone"
   },
   {
      "type": "object",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "cornerstone",
      "object_type": "lms_activity",
      "integration_name": "Cornerstone"
   },
   {
      "type": "object",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "cornerstone",
      "object_type": "lms_student",
      "integration_name": "Cornerstone"
   },
   {
      "type": "method",
      "integration_type": "cornerstone",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "lms_course",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cornerstone"
   },
   {
      "type": "method",
      "integration_type": "cornerstone",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "lms_course",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cornerstone"
   },
   {
      "type": "method",
      "integration_type": "cornerstone",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "lms_activity",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cornerstone"
   },
   {
      "type": "method",
      "integration_type": "cornerstone",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "lms_activity",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cornerstone"
   },
   {
      "type": "method",
      "integration_type": "cornerstone",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "lms_student",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cornerstone"
   },
   {
      "type": "method",
      "integration_type": "cornerstone",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "lms_student",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "chargify",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "chargify",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "chargify",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "chargify",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "object",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "chargify",
      "object_type": "payment_subscription",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "object",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "chargify",
      "object_type": "accounting_contact",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "object",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "chargify",
      "object_type": "accounting_invoice",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "method",
      "integration_type": "chargify",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "uc",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "callrail",
      "integration_name": "CallRail"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T12:17:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "asymbl",
      "integration_name": "Asymbl"
   },
   {
      "type": "method",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "method",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-31T12:17:08.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "spiris",
      "integration_name": "Spiris"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "shoper",
      "integration_name": "Shoper"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "shipping",
         "passthrough"
      ],
      "integration_type": "shopee",
      "integration_name": "Shopee"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "restaurant365",
      "integration_name": "Restaurant365"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T00:00:00.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "integration_type": "promptingcompany",
      "integration_name": "The Prompting Company"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "nimble",
      "integration_name": "Nimble"
   },
   {
      "type": "integration",
      "created_at": "2026-07-31T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "ergo",
      "integration_name": "Ergo"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-30T11:02:26.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-30T11:02:26.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Xero"
   },
   {
      "type": "integration",
      "created_at": "2026-07-30T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "tapclicks",
      "integration_name": "TapClicks"
   },
   {
      "type": "integration",
      "created_at": "2026-07-30T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "stackadapt",
      "integration_name": "StackAdapt"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftads",
      "created_at": "2026-07-29T15:40:53.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_ad_id",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2026-07-29T15:40:53.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2026-07-29T15:40:53.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2026-07-29T15:40:53.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-07-29T15:40:53.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "list_parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-29T15:40:53.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_order",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-29T15:40:53.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-29T15:40:53.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_created_at",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "payments",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "payments",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "is_elimination",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "allocations",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "ads_asset",
      "integration_type": "tiktokads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-07-29T10:38:14.000Z",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "code",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "list_query",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "list_sort_by_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_category",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "type",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "type",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "payments",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "payments",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "payment_terms",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "payment_terms",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "payment_terms",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "is_elimination",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "currency",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "applications",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "allocations",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "payments",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "payments",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "is_elimination",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "applications",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "applications",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "allocations",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "posthog",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "analytics_visitor",
      "integration_name": "PostHog"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "posthog",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "analytics_visitor",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "list_limit",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "list_offset",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "virtual_webhook_limit",
      "integration_name": "PostHog"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "payments",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "payments",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "is_elimination",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "allocations",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_category",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "is_elimination",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "created_at": "2026-07-29T10:38:14.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "object_type": "accounting_category",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "object_type": "ads_asset",
      "integration_type": "googleads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-29T10:38:14.000Z",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "ads_asset",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "payment_terms",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "dubber",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "uc_recording",
      "integration_name": "Dubber"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "dubber",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-29T10:38:14.000Z",
      "object_type": "uc_recording",
      "integration_name": "Dubber"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "vismanet",
      "integration_name": "Visma.net ERP"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "vismaeaccounting",
      "integration_name": "Visma eAccounting"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "vismabusinessnxt",
      "integration_name": "Visma Business NXT"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "shopline",
      "integration_name": "SHOPLINE"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "rillet",
      "integration_name": "Rillet"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "recurly",
      "integration_name": "Recurly"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "commerce",
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "prestashop",
      "integration_name": "PrestaShop"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "noonpayments",
      "integration_name": "noon payments"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "noon",
      "integration_name": "Noon"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "moneybird",
      "integration_name": "Moneybird"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "passthrough"
      ],
      "integration_type": "mollie",
      "integration_name": "Mollie"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsfinanceoperations",
      "integration_name": "Microsoft Dynamics 365 Finance and Operations"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "mercadopago",
      "integration_name": "Mercado Pago"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "mercadolibre",
      "integration_name": "Mercado Libre"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "magento",
      "integration_name": "Adobe Commerce (Magento)"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "lexwareoffice",
      "integration_name": "Lexware Office"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "gumroad",
      "integration_name": "Gumroad"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "freeagent",
      "integration_name": "FreeAgent"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "exactonline",
      "integration_name": "Exact Online"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "passthrough"
      ],
      "integration_type": "dualentry",
      "integration_name": "DualEntry"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "campfire",
      "integration_name": "Campfire"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "amperity",
      "integration_name": "Amperity"
   },
   {
      "type": "integration",
      "created_at": "2026-07-29T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "acumatica",
      "integration_name": "Acumatica"
   },
   {
      "type": "integration",
      "created_at": "2026-07-28T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "payspace",
      "integration_name": "Payspace"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-27T18:30:28.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-27T18:30:28.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2026-07-27T18:30:28.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_transaction",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2026-07-27T18:30:28.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_profitloss",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-07-27T18:30:28.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-07-27T18:30:28.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-07-27T18:30:28.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-07-27T18:30:28.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "time_spent_unit",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "story_points",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "time_spent_unit",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "time_spent",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "story_points",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "time_spent_unit",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "time_spent",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "story_points",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "progress",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "3cx",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "uc_call",
      "integration_name": "3CX"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "3cx",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "uc_recording",
      "integration_name": "3CX"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "3cx",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "uc_call",
      "integration_name": "3CX"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "3cx",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-27T13:53:42.000Z",
      "object_type": "uc_recording",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-07-27T13:53:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_updated_gte",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-07-27T13:53:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-07-27T13:53:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_limit",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-07-27T13:53:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_updated_gte",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-07-27T13:53:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "3CX"
   },
   {
      "type": "pagination",
      "integration_type": "3cx",
      "created_at": "2026-07-27T13:53:42.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "3CX"
   },
   {
      "type": "integration",
      "created_at": "2026-07-27T00:00:00.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "githubapp",
      "integration_name": "GitHub Apps"
   },
   {
      "type": "integration",
      "created_at": "2026-07-27T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "byteplus",
      "integration_name": "BytePlus ModelArk"
   },
   {
      "type": "integration",
      "created_at": "2026-07-27T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "adobeworkfront",
      "integration_name": "Adobe Workfront"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "slow_fields",
      "integration_name": "Zendesk"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "integration_type": "zendesk",
      "object_type": "storage_file",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "storage_file",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "slow_fields",
      "integration_name": "ServiceNow"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "servicenow",
      "object_type": "storage_file",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "storage_file",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "storage_file",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ServiceNow"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "accounting_category",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "accounting_category",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "accounting_category",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "pylon",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "Pylon"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "pylon",
      "object_type": "storage_file",
      "integration_name": "Pylon"
   },
   {
      "type": "method",
      "integration_type": "pylon",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "storage_file",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pylon"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "slow_fields",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "storage_file",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "storage_file",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "Gorgias"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "gorgias",
      "object_type": "storage_file",
      "integration_name": "Gorgias"
   },
   {
      "type": "method",
      "integration_type": "gorgias",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "storage_file",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gorgias"
   },
   {
      "type": "method",
      "integration_type": "gorgias",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "storage_file",
      "categories": [
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "freshdesk"
   },
   {
      "type": "pagination",
      "integration_type": "freshdesk",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "slow_fields",
      "integration_name": "freshdesk"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "integration_type": "freshdesk",
      "object_type": "storage_file",
      "integration_name": "freshdesk"
   },
   {
      "type": "method",
      "integration_type": "freshdesk",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "storage_file",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianservicedesk",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianservicedesk",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "slow_fields",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T17:15:42.000Z",
      "categories": [
         "ticketing",
         "storage",
         "passthrough"
      ],
      "integration_type": "atlassianservicedesk",
      "object_type": "storage_file",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "method",
      "integration_type": "atlassianservicedesk",
      "created_at": "2026-07-24T17:15:42.000Z",
      "object_type": "storage_file",
      "categories": [
         "ticketing",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_status",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_start_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_end_lt",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_status",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_start_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_end_lt",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "external_number",
      "integration_name": "NetSuite"
   },
   {
      "type": "integration",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "giighire",
      "integration_name": "Giig Hire"
   },
   {
      "type": "readable_field",
      "integration_type": "expensify",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Expensify"
   },
   {
      "type": "pagination",
      "integration_type": "expensify",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_status",
      "integration_name": "Expensify"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "users",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "payment_method",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "approver_users",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "pagination",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_status",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "pagination",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_status",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "integration_type": "concurcompany",
      "object_type": "accounting_contact",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "users",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "payment_method",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "approver_users",
      "integration_name": "SAP Concur"
   },
   {
      "type": "pagination",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_status",
      "integration_name": "SAP Concur"
   },
   {
      "type": "pagination",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_status",
      "integration_name": "SAP Concur"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "integration_type": "concur",
      "object_type": "accounting_contact",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP Concur"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "integration_name": "Calendly"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "integration_type": "calendly",
      "object_type": "calendar_recording",
      "integration_name": "Calendly"
   },
   {
      "type": "object",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "integration_type": "calendly",
      "object_type": "crm_contact",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Calendly"
   },
   {
      "type": "readable_field",
      "integration_type": "brex",
      "created_at": "2026-07-24T09:08:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_status",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_start_gte",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_end_lt",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2026-07-24T09:08:30.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_status",
      "integration_name": "Brex"
   },
   {
      "type": "integration",
      "created_at": "2026-07-24T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "opensearch",
      "integration_name": "OpenSearch"
   },
   {
      "type": "integration",
      "created_at": "2026-07-24T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "kibana",
      "integration_name": "Kibana"
   },
   {
      "type": "integration",
      "created_at": "2026-07-24T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "epicor",
      "integration_name": "Epicor Kinetic"
   },
   {
      "type": "integration",
      "created_at": "2026-07-24T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "elasticsearch",
      "integration_name": "Elasticsearch"
   },
   {
      "type": "integration",
      "created_at": "2026-07-24T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "dubber",
      "integration_name": "Dubber"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-07-23T16:23:34.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-07-23T16:23:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-07-23T16:23:34.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-07-23T16:23:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-23T16:23:34.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-23T16:23:34.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-23T16:23:34.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-23T16:23:34.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-23T16:23:34.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-23T16:23:34.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-23T16:23:34.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-23T16:23:34.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-07-23T16:23:34.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-23T16:23:34.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-23T16:23:34.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "external_number",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-23T16:23:34.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-07-23T15:59:35.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "slow_fields",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_url",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "postings",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-23T15:59:35.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_org_id",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wave"
   },
   {
      "type": "writable_field",
      "integration_type": "stardex",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Stardex"
   },
   {
      "type": "writable_field",
      "integration_type": "stardex",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Stardex"
   },
   {
      "type": "writable_field",
      "integration_type": "stardex",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Stardex"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "tax_exemption",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "identification",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_type",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2026-07-23T15:59:35.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "storage",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "storage_file",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2026-07-23T15:59:35.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "storage_file",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-23T15:59:35.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "integration",
      "created_at": "2026-07-23T00:00:00.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "knowbe4",
      "integration_name": "KnowBe4"
   },
   {
      "type": "integration",
      "created_at": "2026-07-23T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "digitalsamba",
      "integration_name": "Digital Samba"
   },
   {
      "type": "integration",
      "created_at": "2026-07-23T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "bitwarden",
      "integration_name": "Bitwarden"
   },
   {
      "type": "integration",
      "created_at": "2026-07-23T00:00:00.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "integration_type": "amplitude",
      "integration_name": "Amplitude"
   },
   {
      "type": "object",
      "object_type": "cdp_segment",
      "integration_type": "treasuredata",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Treasure Data"
   },
   {
      "type": "object",
      "object_type": "cdp_source",
      "integration_type": "treasuredata",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Treasure Data"
   },
   {
      "type": "object",
      "object_type": "cdp_destination",
      "integration_type": "treasuredata",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Treasure Data"
   },
   {
      "type": "object",
      "object_type": "cdp_segment",
      "integration_type": "tealium",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Tealium"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "ats_scorecard",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "hris_employee",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "skillsoft",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Skillsoft (Percipio)"
   },
   {
      "type": "readable_field",
      "integration_type": "skillsoft",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "published_at",
      "integration_name": "Skillsoft (Percipio)"
   },
   {
      "type": "readable_field",
      "integration_type": "skillsoft",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "difficulty",
      "integration_name": "Skillsoft (Percipio)"
   },
   {
      "type": "object",
      "object_type": "cdp_segment",
      "integration_type": "segment",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Twilio Segment"
   },
   {
      "type": "object",
      "object_type": "cdp_source",
      "integration_type": "segment",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Twilio Segment"
   },
   {
      "type": "object",
      "object_type": "cdp_destination",
      "integration_type": "segment",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Twilio Segment"
   },
   {
      "type": "object",
      "object_type": "cdp_activation",
      "integration_type": "segment",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Twilio Segment"
   },
   {
      "type": "object",
      "object_type": "cdp_profile",
      "integration_type": "segment",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Twilio Segment"
   },
   {
      "type": "object",
      "object_type": "cdp_source",
      "integration_type": "salesforcedatacloud",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Salesforce Data Cloud"
   },
   {
      "type": "object",
      "object_type": "cdp_activation",
      "integration_type": "salesforcedatacloud",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Salesforce Data Cloud"
   },
   {
      "type": "object",
      "object_type": "cdp_profile",
      "integration_type": "salesforcedatacloud",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Salesforce Data Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "oreilly",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "O'Reilly"
   },
   {
      "type": "readable_field",
      "integration_type": "oreilly",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "subjects",
      "integration_name": "O'Reilly"
   },
   {
      "type": "readable_field",
      "integration_type": "oreilly",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "published_at",
      "integration_name": "O'Reilly"
   },
   {
      "type": "readable_field",
      "integration_type": "oreilly",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "difficulty",
      "integration_name": "O'Reilly"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "field": "published_at",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "object_type": "cdp_source",
      "integration_type": "mparticle",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "mParticle"
   },
   {
      "type": "object",
      "object_type": "cdp_profile",
      "integration_type": "mparticle",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "mParticle"
   },
   {
      "type": "object",
      "object_type": "cdp_segment",
      "integration_type": "lytics",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Lytics"
   },
   {
      "type": "object",
      "object_type": "cdp_source",
      "integration_type": "lytics",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Lytics"
   },
   {
      "type": "object",
      "object_type": "cdp_destination",
      "integration_type": "lytics",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Lytics"
   },
   {
      "type": "object",
      "object_type": "cdp_activation",
      "integration_type": "lytics",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Lytics"
   },
   {
      "type": "object",
      "object_type": "cdp_profile",
      "integration_type": "lytics",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Lytics"
   },
   {
      "type": "readable_field",
      "integration_type": "learnupon",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "LearnUpon"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_parent_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "payment_payment",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "payment_payment",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "payment_payment",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_taxrate",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_creditmemo",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "commerce_item",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "commerce_collection",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "degreed",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Degreed"
   },
   {
      "type": "readable_field",
      "integration_type": "degreed",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "published_at",
      "integration_name": "Degreed"
   },
   {
      "type": "integration",
      "created_at": "2026-07-22T17:46:54.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "datev",
      "integration_name": "DATEV"
   },
   {
      "type": "readable_field",
      "integration_type": "d2l",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "subjects",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "readable_field",
      "integration_type": "coursera",
      "created_at": "2026-07-22T17:46:54.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "difficulty",
      "integration_name": "Coursera"
   },
   {
      "type": "object",
      "object_type": "cdp_segment",
      "integration_type": "blueconic",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "BlueConic"
   },
   {
      "type": "object",
      "object_type": "cdp_source",
      "integration_type": "blueconic",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "BlueConic"
   },
   {
      "type": "object",
      "object_type": "cdp_destination",
      "integration_type": "blueconic",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "BlueConic"
   },
   {
      "type": "object",
      "object_type": "cdp_profile",
      "integration_type": "blueconic",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "BlueConic"
   },
   {
      "type": "object",
      "object_type": "cdp_event",
      "integration_type": "blueconic",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "BlueConic"
   },
   {
      "type": "object",
      "object_type": "cdp_profile",
      "integration_type": "bloomreachengagement",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Bloomreach Engagement (Exponea)"
   },
   {
      "type": "object",
      "object_type": "cdp_event",
      "integration_type": "bloomreachengagement",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Bloomreach Engagement (Exponea)"
   },
   {
      "type": "object",
      "object_type": "cdp_segment",
      "integration_type": "adobeexperienceplatform",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Adobe Experience Platform"
   },
   {
      "type": "object",
      "object_type": "cdp_source",
      "integration_type": "adobeexperienceplatform",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Adobe Experience Platform"
   },
   {
      "type": "object",
      "object_type": "cdp_destination",
      "integration_type": "adobeexperienceplatform",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Adobe Experience Platform"
   },
   {
      "type": "object",
      "object_type": "cdp_activation",
      "integration_type": "adobeexperienceplatform",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "created_at": "2026-07-22T17:46:54.000Z",
      "integration_name": "Adobe Experience Platform"
   },
   {
      "type": "integration",
      "created_at": "2026-07-22T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "tiktokshop",
      "integration_name": "TikTok Shop"
   },
   {
      "type": "readable_field",
      "integration_type": "yoobic",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "YOOBIC"
   },
   {
      "type": "pagination",
      "integration_type": "yoobic",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "YOOBIC"
   },
   {
      "type": "pagination",
      "integration_type": "yoobic",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_assigned_user_id",
      "integration_name": "YOOBIC"
   },
   {
      "type": "readable_field",
      "integration_type": "trello",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "teamsoftware",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Team Software"
   },
   {
      "type": "pagination",
      "integration_type": "teamsoftware",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "Team Software"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "shortcut",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Shortcut"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_assigned_user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "motion",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Motion"
   },
   {
      "type": "readable_field",
      "integration_type": "motion",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Motion"
   },
   {
      "type": "pagination",
      "integration_type": "motion",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "Motion"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_assigned_user_id",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "lemlist",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Lemlist"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "googlesa360",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googlesa360",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googlesa360",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googlesa360",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_assigned_user_id",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_assigned_user_id",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "connecteam",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Connecteam"
   },
   {
      "type": "readable_field",
      "integration_type": "connecteam",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Connecteam"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cascade",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Cascade"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "azuredevops",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "readable_field",
      "integration_type": "azuredevops",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_assigned_user_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2026-07-21T15:49:15.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_assigned_user_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2026-07-21T15:49:15.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_assigned_user_id",
      "integration_name": "Asana"
   },
   {
      "type": "integration",
      "created_at": "2026-07-21T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "hirebee",
      "integration_name": "Hirebee"
   },
   {
      "type": "integration",
      "created_at": "2026-07-21T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "3cx",
      "integration_name": "3CX"
   },
   {
      "type": "integration",
      "created_at": "2026-07-20T17:06:59.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "skillcast",
      "integration_name": "Skillcast"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-20T17:06:59.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Paychex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-20T17:06:59.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Paychex"
   },
   {
      "type": "readable_field",
      "integration_type": "paychex",
      "created_at": "2026-07-20T17:06:59.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timeoff_days_total",
      "integration_name": "Paychex"
   },
   {
      "type": "pagination",
      "integration_type": "paychex",
      "created_at": "2026-07-20T17:06:59.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Paychex"
   },
   {
      "type": "object",
      "created_at": "2026-07-20T17:06:59.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paychex",
      "object_type": "hris_document",
      "integration_name": "Paychex"
   },
   {
      "type": "object",
      "created_at": "2026-07-20T17:06:59.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paychex",
      "object_type": "hris_payslip",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-07-20T17:06:59.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-07-20T17:06:59.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-07-20T17:06:59.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-07-20T17:06:59.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paychex"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-07-20T17:06:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Jobvite"
   },
   {
      "type": "integration",
      "created_at": "2026-07-20T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "justworks",
      "integration_name": "Justworks"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "vivaengage",
      "integration_name": "Microsoft Viva Engage"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "udemy",
      "integration_name": "Udemy Business"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "skillsoft",
      "integration_name": "Skillsoft (Percipio)"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "salesforcecommercecloud",
      "integration_name": "Salesforce Commerce Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough",
         "auth"
      ],
      "integration_type": "redtail",
      "integration_name": "Redtail CRM"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "linkedintalenthub",
      "integration_name": "LinkedIn Talent Hub"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "kahoot",
      "integration_name": "Kahoot!"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "ebay",
      "integration_name": "eBay"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "bloomreachengagement",
      "integration_name": "Bloomreach Engagement (Exponea)"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "bloomreachdiscovery",
      "integration_name": "Bloomreach Discovery"
   },
   {
      "type": "integration",
      "created_at": "2026-07-19T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "bloomreach",
      "integration_name": "Bloomreach"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-18T10:03:02.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-18T10:03:02.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlas"
   },
   {
      "type": "integration",
      "created_at": "2026-07-18T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "treasuredata",
      "integration_name": "Treasure Data"
   },
   {
      "type": "integration",
      "created_at": "2026-07-18T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "tealium",
      "integration_name": "Tealium"
   },
   {
      "type": "integration",
      "created_at": "2026-07-18T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "segment",
      "integration_name": "Twilio Segment"
   },
   {
      "type": "integration",
      "created_at": "2026-07-18T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "salesforcedatacloud",
      "integration_name": "Salesforce Data Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-07-18T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "mparticle",
      "integration_name": "mParticle"
   },
   {
      "type": "integration",
      "created_at": "2026-07-18T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "lytics",
      "integration_name": "Lytics"
   },
   {
      "type": "integration",
      "created_at": "2026-07-18T00:00:00.000Z",
      "categories": [
         "cdp",
         "metadata",
         "passthrough"
      ],
      "integration_type": "blueconic",
      "integration_name": "BlueConic"
   },
   {
      "type": "integration",
      "created_at": "2026-07-18T00:00:00.000Z",
      "categories": [
         "cdp",
         "passthrough"
      ],
      "integration_type": "adobeexperienceplatform",
      "integration_name": "Adobe Experience Platform"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-17T18:21:36.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-17T18:21:36.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-07-17T18:21:36.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-17T18:21:36.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Freshbooks"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_deal",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_deal",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stardex",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "ats_company",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "crm_deal",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "crm_company",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "crm_event",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "crm_pipeline",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "ats",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stardex"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "kms_space",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "kms_space",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "list_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_application",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_contact",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_application",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_contact",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_query",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_offset",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlas"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruitwithatlas",
      "object_type": "ats_activity",
      "integration_name": "Atlas"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruitwithatlas",
      "object_type": "metadata_metadata",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Atlas"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_session",
      "pagination": "list_updated_gte",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "list_updated_gte",
      "integration_name": "PostHog"
   },
   {
      "type": "pagination",
      "integration_type": "posthog",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "analytics_report",
      "pagination": "list_updated_gte",
      "integration_name": "PostHog"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_activity",
      "integration_name": "Pinpoint"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_activity",
      "integration_name": "Pinpoint"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "pinpoint",
      "object_type": "ats_activity",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pinpoint"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "integration_type": "pennylane",
      "object_type": "accounting_bill",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pendo",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "object_type": "analytics_visitor",
      "pagination": "list_updated_gte",
      "integration_name": "Pendo"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycom",
      "object_type": "hris_location",
      "integration_name": "Paycom"
   },
   {
      "type": "method",
      "integration_type": "paycom",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycom"
   },
   {
      "type": "method",
      "integration_type": "paycom",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycom"
   },
   {
      "type": "method",
      "integration_type": "paycom",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycom"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Nooks"
   },
   {
      "type": "readable_field",
      "integration_type": "nooks",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "field": "call_id",
      "integration_name": "Nooks"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "integration_type": "metabase",
      "object_type": "datastore_query",
      "integration_name": "Metabase"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "integration_type": "metabase",
      "object_type": "datastore_table",
      "integration_name": "Metabase"
   },
   {
      "type": "object",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "integration_type": "metabase",
      "object_type": "datastore_database",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "datastore_query",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "datastore_table",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "datastore_table",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "datastore_database",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Metabase"
   },
   {
      "type": "method",
      "integration_type": "metabase",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "datastore_database",
      "categories": [
         "analytics",
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Metabase"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "effective_status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "effective_status",
      "integration_name": "LinkedIn"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_interview",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_interview",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_interview",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_application",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "effective_status",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "pullrequest_ids",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "pullrequest_ids",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "pullrequest_ids",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "pullrequest_ids",
      "integration_name": "GitHub"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_group",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_event",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_group",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "crm_event",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "azuredevops",
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "field": "pullrequest_ids",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "slow_fields",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_employee",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_company",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_group",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_employee",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_company",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "afas",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-17T17:35:47.000Z",
      "object_type": "hris_group",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "pagination",
      "integration_type": "afas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "pagination",
      "integration_type": "afas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "pagination",
      "integration_type": "afas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "pagination",
      "integration_type": "afas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_updated_gte",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "pagination",
      "integration_type": "afas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "pagination",
      "integration_type": "afas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "pagination",
      "integration_type": "afas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "pagination",
      "integration_type": "afas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "pagination",
      "integration_type": "afas",
      "created_at": "2026-07-17T17:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "sign-in",
      "integration_type": "acuityscheduling",
      "created_at": "2026-07-17T17:35:47.000Z",
      "integration_name": "Acuity Scheduling",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "integration",
      "created_at": "2026-07-17T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlesites",
      "integration_name": "Google Sites"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "effective_status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "effective_status",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2026-07-15T14:36:49.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "effective_status",
      "integration_name": "Google Ads"
   },
   {
      "type": "object",
      "created_at": "2026-07-15T14:36:49.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_profitloss",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-15T14:36:49.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "slow_fields",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "object",
      "created_at": "2026-07-15T14:36:49.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "atlassianjira",
      "object_type": "metadata_metadata",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-15T14:36:49.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "integration",
      "created_at": "2026-07-15T00:00:00.000Z",
      "categories": [
         "accounting"
      ],
      "integration_type": "sage100",
      "integration_name": "Sage 100"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_vendorcredit",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_vendorcredit",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-07-14T21:29:19.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "accounting_creditmemo",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-07-14T21:29:19.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "accounting_vendorcredit",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "crm_lead",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwithatlas",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "crm_lead",
      "integration_name": "Atlas"
   },
   {
      "type": "object",
      "created_at": "2026-07-14T21:29:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruitwithatlas",
      "object_type": "crm_lead",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Phenom"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Phenom"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Phenom"
   },
   {
      "type": "method",
      "integration_type": "phenom",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Phenom"
   },
   {
      "type": "object",
      "object_type": "hris_taxonomy",
      "integration_type": "onet",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "integration_name": "O*NET"
   },
   {
      "type": "object",
      "object_type": "hris_taxonomy",
      "integration_type": "lightcast",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "integration_name": "Lightcast"
   },
   {
      "type": "object",
      "object_type": "hris_taxonomy",
      "integration_type": "esco",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "integration_name": "ESCO"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_interview",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_interview",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2026-07-14T21:29:19.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "bullhorn",
      "object_type": "ats_interview",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-07-14T21:29:19.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2026-07-14T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "onet",
      "integration_name": "O*NET"
   },
   {
      "type": "integration",
      "created_at": "2026-07-14T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "lightcast",
      "integration_name": "Lightcast"
   },
   {
      "type": "integration",
      "created_at": "2026-07-14T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "esco",
      "integration_name": "ESCO"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_message",
      "integration_name": "Zoom"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_message",
      "integration_name": "Zoom"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_event",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "integration_type": "zoom",
      "object_type": "messaging_channel",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "integration_type": "zoom",
      "object_type": "messaging_event",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "integration_type": "zoom",
      "object_type": "messaging_message",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "integration_type": "zoom",
      "object_type": "uc_contact",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "uc_contact",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "uc_contact",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "messaging",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "object_type": "hris_document",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "object_type": "hris_document",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "method",
      "integration_type": "ukg_hr",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "spotify",
      "object_type": "ads_organization",
      "integration_name": "Spotify"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "spotify",
      "object_type": "ads_campaign",
      "integration_name": "Spotify"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "spotify",
      "object_type": "ads_group",
      "integration_name": "Spotify"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "spotify",
      "object_type": "ads_ad",
      "integration_name": "Spotify"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "spotify",
      "object_type": "ads_creative",
      "integration_name": "Spotify"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "spotify",
      "object_type": "ads_target",
      "integration_name": "Spotify"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "spotify",
      "object_type": "ads_report",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Spotify"
   },
   {
      "type": "method",
      "integration_type": "spotify",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ads_report",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Spotify"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "apply_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "apply_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "hris_document",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_job",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_job",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "lms_course",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "lms_content",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "lms_activity",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "lms_course",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "lms_course",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "lms_content",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "lms_activity",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "lms_activity",
      "categories": [
         "ats",
         "hris",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "object_type": "hris_document",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "object_type": "hris_document",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_location",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_application",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_location",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_application",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Cornerstone"
   },
   {
      "type": "object",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "cornerstone",
      "object_type": "hris_location",
      "integration_name": "Cornerstone"
   },
   {
      "type": "method",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Cornerstone"
   },
   {
      "type": "method",
      "integration_type": "cornerstone",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cornerstone"
   },
   {
      "type": "object",
      "object_type": "hris_document",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "hris_document",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "task_project",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "task_project",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-13T18:38:04.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_change",
      "pagination": "list_project_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_change",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_order",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "integration",
      "created_at": "2026-07-13T18:38:04.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "alex",
      "integration_name": "Alex"
   },
   {
      "type": "integration",
      "created_at": "2026-07-13T00:00:00.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recharge",
      "integration_name": "Recharge"
   },
   {
      "type": "integration",
      "created_at": "2026-07-13T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "hris",
         "passthrough"
      ],
      "integration_type": "mambu",
      "integration_name": "Mambu"
   },
   {
      "type": "integration",
      "created_at": "2026-07-13T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "egnyte",
      "integration_name": "Egnyte"
   },
   {
      "type": "integration",
      "created_at": "2026-07-12T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "shortcut",
      "integration_name": "Shortcut"
   },
   {
      "type": "integration",
      "created_at": "2026-07-12T00:00:00.000Z",
      "categories": [
         "analytics",
         "hris",
         "passthrough"
      ],
      "integration_type": "metabase",
      "integration_name": "Metabase"
   },
   {
      "type": "integration",
      "created_at": "2026-07-12T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "degreed",
      "integration_name": "Degreed"
   },
   {
      "type": "integration",
      "created_at": "2026-07-12T00:00:00.000Z",
      "categories": [
         "hris",
         "metadata",
         "task",
         "passthrough"
      ],
      "integration_type": "connecteam",
      "integration_name": "Connecteam"
   },
   {
      "type": "integration",
      "created_at": "2026-07-11T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "cornerstonetalentlink",
      "integration_name": "Cornerstone TalentLink"
   },
   {
      "type": "integration",
      "created_at": "2026-07-11T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "brassring",
      "integration_name": "IBM Kenexa BrassRing"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "invoice_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "invoice_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "posthog",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "PostHog"
   },
   {
      "type": "writable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "property_id",
      "integration_name": "Mixpanel"
   },
   {
      "type": "writable_field",
      "integration_type": "mixpanel",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "field": "property_id",
      "integration_name": "Mixpanel"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Carerix"
   },
   {
      "type": "readable_field",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "slow_fields",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Carerix"
   },
   {
      "type": "object",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "carerix",
      "object_type": "ats_company",
      "integration_name": "Carerix"
   },
   {
      "type": "object",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "carerix",
      "object_type": "metadata_metadata",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "8x8xcaas",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "uc_recording",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "8x8xcaas",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "uc_recording",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_updated_gte",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_end_lt",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-07-09T15:53:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "8x8",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "uc_call",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "8x8",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2026-07-09T15:53:51.000Z",
      "object_type": "uc_call",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "filename",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_data",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "benefit_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "application_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "amount",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_deduction",
      "pagination": "list_user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_deduction",
      "pagination": "list_benefit_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_company_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "target_branch_id",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "source_branch_id",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_deleted",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_changed",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_added",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "branch_id",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "pagination",
      "integration_type": "gitlabdedicated",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "slow_fields",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "target_branch_id",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "source_branch_id",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_deleted",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_changed",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_added",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "branch_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "slow_fields",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "target_branch_id",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "source_branch_id",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_deleted",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_changed",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_added",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "pagination",
      "integration_type": "githubenterpriseserver",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "slow_fields",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "target_branch_id",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "source_branch_id",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_deleted",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_changed",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lines_added",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "slow_fields",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "target_branch_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "source_branch_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "lines_deleted",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "lines_changed",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "repo_commit",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "lines_added",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "slow_fields",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "task_change",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-07-09T09:27:37.000Z",
      "object_type": "task_change",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_change",
      "pagination": "native_webhook_project_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_change",
      "pagination": "list_updated_gte",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_change",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_change",
      "pagination": "virtual_webhook_task_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2026-07-09T09:27:37.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_change",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "integration",
      "created_at": "2026-07-09T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "lark",
      "integration_name": "Lark"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-07-06T18:34:04.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "slow_fields",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oreilly",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "lms_content",
      "integration_name": "O'Reilly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oreilly",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "lms_content",
      "integration_name": "O'Reilly"
   },
   {
      "type": "readable_field",
      "integration_type": "oreilly",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "O'Reilly"
   },
   {
      "type": "readable_field",
      "integration_type": "oreilly",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "O'Reilly"
   },
   {
      "type": "pagination",
      "integration_type": "oreilly",
      "created_at": "2026-07-06T18:34:04.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "list_updated_gte",
      "integration_name": "O'Reilly"
   },
   {
      "type": "pagination",
      "integration_type": "oreilly",
      "created_at": "2026-07-06T18:34:04.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "O'Reilly"
   },
   {
      "type": "pagination",
      "integration_type": "oreilly",
      "created_at": "2026-07-06T18:34:04.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "virtual_webhook_limit",
      "integration_name": "O'Reilly"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "term",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2026-07-06T18:34:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "carerix",
      "object_type": "ats_activity",
      "integration_name": "Carerix"
   },
   {
      "type": "object",
      "created_at": "2026-07-06T18:34:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "carerix",
      "object_type": "hris_employee",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Carerix"
   },
   {
      "type": "method",
      "integration_type": "carerix",
      "created_at": "2026-07-06T18:34:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Carerix"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "telegram",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "messaging_message",
      "integration_name": "Telegram"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "telegram",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "messaging_message",
      "integration_name": "Telegram"
   },
   {
      "type": "sign-in",
      "integration_type": "telegram",
      "created_at": "2026-07-03T17:41:13.000Z",
      "integration_name": "Telegram",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "object",
      "created_at": "2026-07-03T17:41:13.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "telegram",
      "object_type": "messaging_channel",
      "integration_name": "Telegram"
   },
   {
      "type": "object",
      "created_at": "2026-07-03T17:41:13.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "telegram",
      "object_type": "messaging_message",
      "integration_name": "Telegram"
   },
   {
      "type": "method",
      "integration_type": "telegram",
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Telegram"
   },
   {
      "type": "method",
      "integration_type": "telegram",
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Telegram"
   },
   {
      "type": "method",
      "integration_type": "telegram",
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Telegram"
   },
   {
      "type": "method",
      "integration_type": "telegram",
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Telegram"
   },
   {
      "type": "method",
      "integration_type": "telegram",
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Telegram"
   },
   {
      "type": "method",
      "integration_type": "telegram",
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Telegram"
   },
   {
      "type": "method",
      "integration_type": "telegram",
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Telegram"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-07-03T17:41:13.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-07-03T17:41:13.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_limit",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-07-03T17:41:13.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_offset",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-07-03T17:41:13.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_limit",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-07-03T17:41:13.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-07-03T17:41:13.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "integration",
      "created_at": "2026-07-03T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "veevavault",
      "integration_name": "Veeva Vault"
   },
   {
      "type": "integration",
      "created_at": "2026-07-03T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "oreilly",
      "integration_name": "O'Reilly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-02T17:54:02.000Z",
      "object_type": "ats_application",
      "integration_name": "Pinpoint"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-02T17:54:02.000Z",
      "object_type": "ats_application",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T17:54:02.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T17:54:02.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T17:54:02.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T17:54:02.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Pinpoint"
   },
   {
      "type": "object",
      "object_type": "accounting_vendorcredit",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-07-02T15:33:33.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "accounting_vendorcredit",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "hris_group",
      "integration_name": "Pinpoint"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "hris_group",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Pinpoint"
   },
   {
      "type": "object",
      "created_at": "2026-07-02T15:33:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "pinpoint",
      "object_type": "hris_group",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteamsbot",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "has_subchannels",
      "integration_name": "Microsoft Teams (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-07-02T15:33:33.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "has_subchannels",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2026-07-02T10:07:01.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_job_id",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2026-07-02T10:07:01.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "trakstarhire",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2026-07-02T10:07:01.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_job_id",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "onlyfy",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "onlyfy"
   },
   {
      "type": "pagination",
      "integration_type": "onlyfy",
      "created_at": "2026-07-02T10:07:01.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_job_id",
      "integration_name": "onlyfy"
   },
   {
      "type": "readable_field",
      "integration_type": "occupop",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Occupop"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2026-07-02T10:07:01.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_job_id",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-07-02T10:07:01.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_job_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-07-02T10:07:01.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "FactorialHR"
   },
   {
      "type": "integration",
      "created_at": "2026-07-02T00:00:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "integration_type": "grain",
      "integration_name": "Grain"
   },
   {
      "type": "integration",
      "created_at": "2026-07-01T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "tldv",
      "integration_name": "tl;dv"
   },
   {
      "type": "integration",
      "created_at": "2026-07-01T00:00:00.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "task",
         "payment",
         "passthrough"
      ],
      "integration_type": "teamsoftware",
      "integration_name": "Team Software"
   },
   {
      "type": "integration",
      "created_at": "2026-07-01T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "ringover",
      "integration_name": "Ringover"
   },
   {
      "type": "integration",
      "created_at": "2026-07-01T00:00:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "modjo",
      "integration_name": "Modjo"
   },
   {
      "type": "integration",
      "created_at": "2026-07-01T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "meetgeek",
      "integration_name": "MeetGeek"
   },
   {
      "type": "integration",
      "created_at": "2026-07-01T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "kixie",
      "integration_name": "Kixie"
   },
   {
      "type": "integration",
      "created_at": "2026-07-01T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "circleback",
      "integration_name": "Circleback"
   },
   {
      "type": "integration",
      "created_at": "2026-07-01T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "avoma",
      "integration_name": "Avoma"
   },
   {
      "type": "integration",
      "created_at": "2026-07-01T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "aloware",
      "integration_name": "Aloware"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_type",
      "integration_name": "Wave"
   },
   {
      "type": "object",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "wave",
      "object_type": "payment_payment",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_contact_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_deal_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_calendar_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_start_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_end_lt",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_calendar_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "human_unique_opens",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "human_opens_total",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "human_open_rate",
      "integration_name": "Mailchimp"
   },
   {
      "type": "object",
      "created_at": "2026-06-30T20:16:26.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_bill",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "customerio",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "human_opens_total",
      "integration_name": "Customer.io"
   },
   {
      "type": "readable_field",
      "integration_type": "customerio",
      "created_at": "2026-06-30T20:16:26.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "human_open_rate",
      "integration_name": "Customer.io"
   },
   {
      "type": "integration",
      "created_at": "2026-06-30T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "wecom",
      "integration_name": "WeCom (WeChat Work)"
   },
   {
      "type": "integration",
      "created_at": "2026-06-30T00:00:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "telegrambot",
      "integration_name": "Telegram (bot)"
   },
   {
      "type": "integration",
      "created_at": "2026-06-30T00:00:00.000Z",
      "categories": [
         "ats",
         "ads",
         "passthrough"
      ],
      "integration_type": "jobcase",
      "integration_name": "Jobcase"
   },
   {
      "type": "integration",
      "created_at": "2026-06-30T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "absorb",
      "integration_name": "Absorb"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "revsport",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Rev Sport"
   },
   {
      "type": "method",
      "integration_type": "revsport",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rev Sport"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pipedrive"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "lightfield",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Lightfield"
   },
   {
      "type": "method",
      "integration_type": "lightfield",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lightfield"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2026-06-29T17:29:38.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlesa360",
      "object_type": "ads_organization",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "object",
      "created_at": "2026-06-29T17:29:38.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlesa360",
      "object_type": "ads_campaign",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "object",
      "created_at": "2026-06-29T17:29:38.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlesa360",
      "object_type": "ads_group",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "object",
      "created_at": "2026-06-29T17:29:38.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlesa360",
      "object_type": "ads_ad",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "method",
      "integration_type": "googlesa360",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "gainsight",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gainsight"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2026-06-29T17:29:38.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2026-06-29T17:29:38.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2026-06-29T17:29:38.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "slow_fields",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "object_type": "crm_picklist",
      "integration_type": "agencyzoom",
      "categories": [
         "crm",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-06-29T17:29:38.000Z",
      "integration_name": "AgencyZoom"
   },
   {
      "type": "method",
      "integration_type": "agencyzoom",
      "created_at": "2026-06-29T17:29:38.000Z",
      "object_type": "crm_picklist",
      "categories": [
         "crm",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AgencyZoom"
   },
   {
      "type": "writable_field",
      "integration_type": "yotpodeveloper",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "commerce",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Yotpo (Developer)"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpodeveloper",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "commerce",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Yotpo (Developer)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-06-29T10:24:31.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "payworks",
      "object_type": "hris_timeshift",
      "integration_name": "Payworks"
   },
   {
      "type": "method",
      "integration_type": "payworks",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Payworks"
   },
   {
      "type": "writable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "klaviyo",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Klaviyo"
   },
   {
      "type": "writable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "writable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "student_id",
      "integration_name": "FactorialHR"
   },
   {
      "type": "writable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "course_id",
      "integration_name": "FactorialHR"
   },
   {
      "type": "writable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "completed_at",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "d2l",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-06-29T10:24:31.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "object",
      "created_at": "2026-06-26T12:13:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "taleo",
      "object_type": "ats_document",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "method",
      "integration_type": "taleo",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Atlas"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jungle",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_company",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jungle",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_company",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-06-26T12:13:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_company_id",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-06-26T12:13:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "object",
      "created_at": "2026-06-26T12:13:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jungle",
      "object_type": "ats_company",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "method",
      "integration_type": "jungle",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "method",
      "integration_type": "jungle",
      "created_at": "2026-06-26T12:13:32.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "googlesa360",
      "created_at": "2026-06-26T12:13:32.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_limit",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "pagination",
      "integration_type": "googlesa360",
      "created_at": "2026-06-26T12:13:32.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_offset",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "integration",
      "created_at": "2026-06-26T00:00:00.000Z",
      "categories": [
         "analytics",
         "auth",
         "passthrough"
      ],
      "integration_type": "visier",
      "integration_name": "Visier"
   },
   {
      "type": "integration",
      "created_at": "2026-06-26T00:00:00.000Z",
      "categories": [
         "ticketing",
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "pylon",
      "integration_name": "Pylon"
   },
   {
      "type": "integration",
      "created_at": "2026-06-26T00:00:00.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "integration_type": "mintlify",
      "integration_name": "Mintlify"
   },
   {
      "type": "writable_field",
      "integration_type": "mongodb_data",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "MongoDB Database"
   },
   {
      "type": "writable_field",
      "integration_type": "mongodb_data",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "field": "database_id",
      "integration_name": "MongoDB Database"
   },
   {
      "type": "pagination",
      "integration_type": "mongodb_data",
      "created_at": "2026-06-24T18:19:22.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "object_type": "datastore_record",
      "pagination": "list_limit",
      "integration_name": "MongoDB Database"
   },
   {
      "type": "method",
      "integration_type": "mongodb_data",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MongoDB Database"
   },
   {
      "type": "method",
      "integration_type": "mongodb_data",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MongoDB Database"
   },
   {
      "type": "object",
      "created_at": "2026-06-24T18:19:22.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deputy",
      "object_type": "hris_location",
      "integration_name": "Deputy"
   },
   {
      "type": "object",
      "created_at": "2026-06-24T18:19:22.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deputy",
      "object_type": "hris_group",
      "integration_name": "Deputy"
   },
   {
      "type": "object",
      "created_at": "2026-06-24T18:19:22.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deputy",
      "object_type": "hris_timeshift",
      "integration_name": "Deputy"
   },
   {
      "type": "object",
      "created_at": "2026-06-24T18:19:22.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deputy",
      "object_type": "hris_timeoff",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2026-06-24T18:19:22.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Deputy"
   },
   {
      "type": "object",
      "object_type": "analytics_property",
      "integration_type": "youtubeanalytics",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "object",
      "object_type": "analytics_report",
      "integration_type": "youtubeanalytics",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "method",
      "integration_type": "youtubeanalytics",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "method",
      "integration_type": "youtubeanalytics",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "method",
      "integration_type": "youtubeanalytics",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_report",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "object",
      "created_at": "2026-06-24T11:20:02.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruitwithatlas",
      "object_type": "crm_company",
      "integration_name": "Atlas"
   },
   {
      "type": "object",
      "created_at": "2026-06-24T11:20:02.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruitwithatlas",
      "object_type": "crm_contact",
      "integration_name": "Atlas"
   },
   {
      "type": "object",
      "created_at": "2026-06-24T11:20:02.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruitwithatlas",
      "object_type": "crm_deal",
      "integration_name": "Atlas"
   },
   {
      "type": "object",
      "created_at": "2026-06-24T11:20:02.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruitwithatlas",
      "object_type": "crm_pipeline",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlas"
   },
   {
      "type": "object",
      "object_type": "analytics_property",
      "integration_type": "posthog",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "PostHog"
   },
   {
      "type": "object",
      "object_type": "analytics_event",
      "integration_type": "posthog",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "PostHog"
   },
   {
      "type": "object",
      "object_type": "analytics_report",
      "integration_type": "posthog",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "PostHog"
   },
   {
      "type": "object",
      "object_type": "analytics_visitor",
      "integration_type": "posthog",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "PostHog"
   },
   {
      "type": "object",
      "object_type": "analytics_session",
      "integration_type": "posthog",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "PostHog"
   },
   {
      "type": "object",
      "created_at": "2026-06-24T11:20:02.000Z",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "posthog",
      "object_type": "hris_employee",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_session",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_session",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_report",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "hris_employee",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "hris_employee",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "hris_employee",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "PostHog"
   },
   {
      "type": "method",
      "integration_type": "posthog",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "hris_employee",
      "categories": [
         "analytics",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "PostHog"
   },
   {
      "type": "object",
      "object_type": "analytics_property",
      "integration_type": "pendo",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Pendo"
   },
   {
      "type": "object",
      "object_type": "analytics_event",
      "integration_type": "pendo",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Pendo"
   },
   {
      "type": "object",
      "object_type": "analytics_report",
      "integration_type": "pendo",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Pendo"
   },
   {
      "type": "object",
      "object_type": "analytics_visitor",
      "integration_type": "pendo",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_report",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pendo"
   },
   {
      "type": "method",
      "integration_type": "pendo",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_report",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pendo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "mixpanel",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "integration_name": "Mixpanel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "mixpanel",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "integration_name": "Mixpanel"
   },
   {
      "type": "object",
      "object_type": "analytics_property",
      "integration_type": "mixpanel",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Mixpanel"
   },
   {
      "type": "object",
      "object_type": "analytics_event",
      "integration_type": "mixpanel",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Mixpanel"
   },
   {
      "type": "object",
      "object_type": "analytics_report",
      "integration_type": "mixpanel",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Mixpanel"
   },
   {
      "type": "object",
      "object_type": "analytics_visitor",
      "integration_type": "mixpanel",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_event",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_visitor",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mixpanel"
   },
   {
      "type": "method",
      "integration_type": "mixpanel",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_report",
      "categories": [
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mixpanel"
   },
   {
      "type": "object",
      "object_type": "analytics_property",
      "integration_type": "googleanalytics",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Google Analytics"
   },
   {
      "type": "object",
      "object_type": "analytics_event",
      "integration_type": "googleanalytics",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Google Analytics"
   },
   {
      "type": "object",
      "object_type": "analytics_report",
      "integration_type": "googleanalytics",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "created_at": "2026-06-24T11:20:02.000Z",
      "integration_name": "Google Analytics"
   },
   {
      "type": "method",
      "integration_type": "googleanalytics",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Analytics"
   },
   {
      "type": "method",
      "integration_type": "googleanalytics",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Analytics"
   },
   {
      "type": "method",
      "integration_type": "googleanalytics",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_property",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Analytics"
   },
   {
      "type": "method",
      "integration_type": "googleanalytics",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_event",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Analytics"
   },
   {
      "type": "method",
      "integration_type": "googleanalytics",
      "created_at": "2026-06-24T11:20:02.000Z",
      "object_type": "analytics_report",
      "categories": [
         "auth",
         "analytics",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Analytics"
   },
   {
      "type": "integration",
      "created_at": "2026-06-24T00:00:00.000Z",
      "categories": [
         "hris",
         "accounting",
         "payment",
         "commerce",
         "passthrough"
      ],
      "integration_type": "unit4erpx",
      "integration_name": "Unit4 ERPx"
   },
   {
      "type": "integration",
      "created_at": "2026-06-24T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "rotageek",
      "integration_name": "Rotageek"
   },
   {
      "type": "integration",
      "created_at": "2026-06-24T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "rotacloud",
      "integration_name": "RotaCloud"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "twilio",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "uc_call",
      "integration_name": "Twilio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "twilio",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "uc_call",
      "integration_name": "Twilio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "twilio",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "uc_recording",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "sendcloud",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "shipping_carrier",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sendcloud"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "won_reason",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "lost_reason",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "easypost",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "EasyPost"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "easypost",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "EasyPost"
   },
   {
      "type": "pagination",
      "integration_type": "easypost",
      "created_at": "2026-06-23T19:38:41.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "list_updated_gte",
      "integration_name": "EasyPost"
   },
   {
      "type": "pagination",
      "integration_type": "easypost",
      "created_at": "2026-06-23T19:38:41.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "list_limit",
      "integration_name": "EasyPost"
   },
   {
      "type": "pagination",
      "integration_type": "easypost",
      "created_at": "2026-06-23T19:38:41.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "list_offset",
      "integration_name": "EasyPost"
   },
   {
      "type": "pagination",
      "integration_type": "easypost",
      "created_at": "2026-06-23T19:38:41.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "EasyPost"
   },
   {
      "type": "pagination",
      "integration_type": "easypost",
      "created_at": "2026-06-23T19:38:41.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "virtual_webhook_limit",
      "integration_name": "EasyPost"
   },
   {
      "type": "method",
      "integration_type": "easypost",
      "created_at": "2026-06-23T19:38:41.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "EasyPost"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-06-23T13:21:40.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-06-23T13:21:40.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "duration_type",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-06-23T13:21:40.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Workday"
   },
   {
      "type": "integration",
      "created_at": "2026-06-23T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "tripadvisor",
      "integration_name": "Tripadvisor"
   },
   {
      "type": "integration",
      "created_at": "2026-06-23T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "taleo",
      "integration_name": "Oracle Taleo Business Edition"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteamsbot",
      "created_at": "2026-06-22T12:57:26.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "is_unread",
      "integration_name": "Microsoft Teams (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-22T12:57:26.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "is_unread",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-06-22T12:57:26.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2026-06-22T12:57:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2026-06-22T12:57:26.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2026-06-22T12:57:26.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2026-06-22T12:57:26.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-06-22T12:57:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-06-22T12:57:26.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Jobvite"
   },
   {
      "type": "integration",
      "created_at": "2026-06-22T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "trexity",
      "integration_name": "Trexity"
   },
   {
      "type": "integration",
      "created_at": "2026-06-20T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "alibabacloud",
      "integration_name": "Alibaba Cloud Model Studio"
   },
   {
      "type": "integration",
      "created_at": "2026-06-19T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "talentech",
      "integration_name": "Talentech"
   },
   {
      "type": "integration",
      "created_at": "2026-06-19T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "snipeit",
      "integration_name": "Snipe-IT"
   },
   {
      "type": "integration",
      "created_at": "2026-06-19T00:00:00.000Z",
      "categories": [
         "uc",
         "martech",
         "hris",
         "passthrough"
      ],
      "integration_type": "salesfinity",
      "integration_name": "Salesfinity"
   },
   {
      "type": "integration",
      "created_at": "2026-06-19T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "kevel",
      "integration_name": "Kevel"
   },
   {
      "type": "integration",
      "created_at": "2026-06-19T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "condens",
      "integration_name": "Condens"
   },
   {
      "type": "integration",
      "created_at": "2026-06-19T00:00:00.000Z",
      "categories": [
         "hris",
         "lms",
         "passthrough"
      ],
      "integration_type": "aptem",
      "integration_name": "Aptem"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jungle",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jungle",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "readable_field",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "method",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "method",
      "integration_type": "jungle",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-06-18T11:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2026-06-18T11:59:42.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Jobvite"
   },
   {
      "type": "integration",
      "created_at": "2026-06-18T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "spott",
      "integration_name": "Spott"
   },
   {
      "type": "integration",
      "created_at": "2026-06-18T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "onlyfy",
      "integration_name": "onlyfy"
   },
   {
      "type": "integration",
      "created_at": "2026-06-18T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "occupop",
      "integration_name": "Occupop"
   },
   {
      "type": "integration",
      "created_at": "2026-06-18T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "cezannehr",
      "integration_name": "Cezanne HR"
   },
   {
      "type": "integration",
      "created_at": "2026-06-18T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "applovinpublisher",
      "integration_name": "AppLovin (Publisher)"
   },
   {
      "type": "integration",
      "created_at": "2026-06-18T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "applovinadvertiser",
      "integration_name": "AppLovin (Advertiser)"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "taleez",
      "integration_name": "Taleez"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "personio",
      "object_type": "hris_company",
      "integration_name": "Personio"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "personio",
      "object_type": "hris_group",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "mercuryats",
      "object_type": "ats_document",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_query",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_location_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_group_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_location_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "hris_location",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "integration_name": "Freshteam"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Freshteam"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Freshteam"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_application",
      "integration_name": "Freshteam"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "integration_name": "Freshteam"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Freshteam"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Freshteam"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_application",
      "integration_name": "Freshteam"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "freshteam",
      "object_type": "hris_group",
      "integration_name": "Freshteam"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "freshteam",
      "object_type": "hris_timeoff",
      "integration_name": "Freshteam"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "freshteam",
      "object_type": "ats_job",
      "integration_name": "Freshteam"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "freshteam",
      "object_type": "ats_candidate",
      "integration_name": "Freshteam"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "freshteam",
      "object_type": "ats_application",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshteam"
   },
   {
      "type": "readable_field",
      "integration_type": "docusign",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "download_url",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "slow_fields",
      "integration_name": "DocuSign"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "response_redirect_url",
      "integration_name": "Certn"
   },
   {
      "type": "pagination",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "object_type": "verification_package",
      "pagination": "list_limit",
      "integration_name": "Certn"
   },
   {
      "type": "pagination",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "object_type": "verification_package",
      "pagination": "list_offset",
      "integration_name": "Certn"
   },
   {
      "type": "pagination",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "object_type": "verification_request",
      "pagination": "list_limit",
      "integration_name": "Certn"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "integration_type": "certn",
      "object_type": "hris_employee",
      "integration_name": "Certn"
   },
   {
      "type": "object",
      "created_at": "2026-06-17T16:32:25.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "integration_type": "certn",
      "object_type": "hris_group",
      "integration_name": "Certn"
   },
   {
      "type": "method",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Certn"
   },
   {
      "type": "method",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Certn"
   },
   {
      "type": "method",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Certn"
   },
   {
      "type": "method",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Certn"
   },
   {
      "type": "method",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Certn"
   },
   {
      "type": "method",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Certn"
   },
   {
      "type": "method",
      "integration_type": "certn",
      "created_at": "2026-06-17T16:32:25.000Z",
      "object_type": "hris_group",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Certn"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "traffit",
      "integration_name": "Traffit"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "softgarden",
      "integration_name": "softgarden"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "polymer",
      "integration_name": "Polymer"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "logicmelon",
      "integration_name": "LogicMelon"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "kula",
      "integration_name": "Kula"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "join",
      "integration_name": "JOIN"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "jobylon",
      "integration_name": "Jobylon"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobsoid",
      "integration_name": "Jobsoid"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "dvinci",
      "integration_name": "d.vinci"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "comeet",
      "integration_name": "Comeet"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "clockworkrecruiting",
      "integration_name": "Clockwork Recruiting"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "forms",
         "passthrough"
      ],
      "integration_type": "clayhr",
      "integration_name": "ClayHR"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "ceipal",
      "integration_name": "Ceipal"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "apploi",
      "integration_name": "Apploi"
   },
   {
      "type": "integration",
      "created_at": "2026-06-17T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "afas",
      "integration_name": "AFAS Profit"
   },
   {
      "type": "object",
      "created_at": "2026-06-15T17:18:12.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "ats_document",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "slack",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "uc_recording",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "slack",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "uc_recording",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "created_at": "2026-06-15T17:18:12.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "uc",
         "passthrough"
      ],
      "integration_type": "slack",
      "object_type": "uc_recording",
      "integration_name": "Slack"
   },
   {
      "type": "method",
      "integration_type": "slack",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Slack"
   },
   {
      "type": "method",
      "integration_type": "slack",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "created_at": "2026-06-15T17:18:12.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "integration_type": "quickbooks",
      "object_type": "commerce_inventory",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "ats_document",
      "integration_name": "Pinpoint"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "ats_document",
      "integration_name": "Pinpoint"
   },
   {
      "type": "object",
      "created_at": "2026-06-15T17:18:12.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "pinpoint",
      "object_type": "ats_document",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "timeoff_days_used",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "timeoff_days_total",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "relationships",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "pronouns",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "created_at": "2026-06-15T17:18:12.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "integration_type": "factorialhr",
      "object_type": "lms_course",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "created_at": "2026-06-15T17:18:12.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "integration_type": "factorialhr",
      "object_type": "lms_activity",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "lms_course",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "lms_course",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "lms_course",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "lms_activity",
      "categories": [
         "hris",
         "ats",
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "writable_field",
      "integration_type": "eploy",
      "created_at": "2026-06-15T17:18:12.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Eploy"
   },
   {
      "type": "sign-in",
      "integration_type": "supabase",
      "created_at": "2026-06-12T15:42:29.000Z",
      "integration_name": "Supabase",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-06-12T15:42:29.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_type",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-06-12T15:42:29.000Z",
      "object_type": "ads_report",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "Workstream"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgready",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "UKG Ready"
   },
   {
      "type": "readable_field",
      "integration_type": "trakstarhire",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "object",
      "object_type": "datastore_database",
      "integration_type": "supabase",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Supabase"
   },
   {
      "type": "object",
      "object_type": "datastore_table",
      "integration_type": "supabase",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Supabase"
   },
   {
      "type": "object",
      "object_type": "datastore_record",
      "integration_type": "supabase",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Supabase"
   },
   {
      "type": "object",
      "object_type": "datastore_query",
      "integration_type": "supabase",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Supabase"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "snowflake",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "integration_name": "Snowflake"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "snowflake",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "integration_name": "Snowflake"
   },
   {
      "type": "object",
      "object_type": "datastore_database",
      "integration_type": "snowflake",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Snowflake"
   },
   {
      "type": "object",
      "object_type": "datastore_table",
      "integration_type": "snowflake",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Snowflake"
   },
   {
      "type": "object",
      "object_type": "datastore_record",
      "integration_type": "snowflake",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Snowflake"
   },
   {
      "type": "object",
      "object_type": "datastore_query",
      "integration_type": "snowflake",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Snowflake"
   },
   {
      "type": "method",
      "integration_type": "snowflake",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_query",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Snowflake"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "fees",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2026-06-11T15:28:44.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "slow_fields",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-11T15:28:44.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_limit",
      "integration_name": "Atlas"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-11T15:28:44.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_offset",
      "integration_name": "Atlas"
   },
   {
      "type": "method",
      "integration_type": "recruitwithatlas",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlas"
   },
   {
      "type": "object",
      "object_type": "datastore_database",
      "integration_type": "notion",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Notion"
   },
   {
      "type": "object",
      "object_type": "datastore_table",
      "integration_type": "notion",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Notion"
   },
   {
      "type": "object",
      "object_type": "datastore_record",
      "integration_type": "notion",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Notion"
   },
   {
      "type": "object",
      "object_type": "datastore_query",
      "integration_type": "notion",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_query",
      "categories": [
         "kms",
         "datastore",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Notion"
   },
   {
      "type": "object",
      "object_type": "datastore_database",
      "integration_type": "mongodb",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "MongoDB"
   },
   {
      "type": "object",
      "object_type": "datastore_table",
      "integration_type": "mongodb",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "MongoDB"
   },
   {
      "type": "method",
      "integration_type": "mongodb",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MongoDB"
   },
   {
      "type": "method",
      "integration_type": "mongodb",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MongoDB"
   },
   {
      "type": "method",
      "integration_type": "mongodb",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MongoDB"
   },
   {
      "type": "method",
      "integration_type": "mongodb",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MongoDB"
   },
   {
      "type": "method",
      "integration_type": "mongodb",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MongoDB"
   },
   {
      "type": "method",
      "integration_type": "mongodb",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MongoDB"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-06-11T15:28:44.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_report",
      "pagination": "list_type",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-06-11T15:28:44.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "pagination",
      "integration_type": "jungle",
      "created_at": "2026-06-11T15:28:44.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "method",
      "integration_type": "jobtetris",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobTetris"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "Greenhouse"
   },
   {
      "type": "object",
      "object_type": "datastore_database",
      "integration_type": "googlesheets",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Google Sheets"
   },
   {
      "type": "object",
      "object_type": "datastore_table",
      "integration_type": "googlesheets",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Google Sheets"
   },
   {
      "type": "object",
      "object_type": "datastore_record",
      "integration_type": "googlesheets",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Google Sheets"
   },
   {
      "type": "object",
      "object_type": "datastore_query",
      "integration_type": "googlesheets",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_query",
      "categories": [
         "datastore",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Sheets"
   },
   {
      "type": "writable_field",
      "integration_type": "eploy",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Eploy"
   },
   {
      "type": "writable_field",
      "integration_type": "eploy",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "filename",
      "integration_name": "Eploy"
   },
   {
      "type": "writable_field",
      "integration_type": "eploy",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "document_data",
      "integration_name": "Eploy"
   },
   {
      "type": "writable_field",
      "integration_type": "eploy",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "careerplug",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "CareerPlug"
   },
   {
      "type": "object",
      "object_type": "datastore_database",
      "integration_type": "bigquery",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Google BigQuery"
   },
   {
      "type": "object",
      "object_type": "datastore_table",
      "integration_type": "bigquery",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Google BigQuery"
   },
   {
      "type": "object",
      "object_type": "datastore_record",
      "integration_type": "bigquery",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Google BigQuery"
   },
   {
      "type": "object",
      "object_type": "datastore_query",
      "integration_type": "bigquery",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Google BigQuery"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_substatus",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonsellercentral",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "fees",
      "integration_name": "Amazon Seller Central"
   },
   {
      "type": "object",
      "object_type": "datastore_database",
      "integration_type": "airtable",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Airtable"
   },
   {
      "type": "object",
      "object_type": "datastore_table",
      "integration_type": "airtable",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Airtable"
   },
   {
      "type": "object",
      "object_type": "datastore_record",
      "integration_type": "airtable",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-06-11T15:28:44.000Z",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_database",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_table",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Airtable"
   },
   {
      "type": "method",
      "integration_type": "airtable",
      "created_at": "2026-06-11T15:28:44.000Z",
      "object_type": "datastore_record",
      "categories": [
         "datastore",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Airtable"
   },
   {
      "type": "integration",
      "created_at": "2026-06-11T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "payment",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "lightspeedkseries",
      "integration_name": "Lightspeed Restaurant (K-Series)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "ats_document",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "ats_document",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2026-06-10T22:35:45.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "ats_document",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "accounting_contact",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "accounting_contact",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-06-10T22:35:45.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-06-10T22:35:45.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-06-10T22:35:45.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-06-10T22:35:45.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Lemlist"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Lemlist"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Lemlist"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "Lemlist"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Lemlist"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Lemlist"
   },
   {
      "type": "writable_field",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_project_id",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "Lemlist"
   },
   {
      "type": "method",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Lemlist"
   },
   {
      "type": "method",
      "integration_type": "lemlist",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Lemlist"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "updated_at",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2026-06-10T22:35:45.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "duration",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "hris_employee",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_order",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_journal",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_account",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_contact",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "hris_employee",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_order",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_journal",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_account",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_contact",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_type",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_limit",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_type",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_limit",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_limit",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_type",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "myob",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "hris_company",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_order",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_account",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_account",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_account",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "hris_company",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_order",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_account",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_account",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-09T09:10:33.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-06-09T09:10:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_account_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "integration",
      "created_at": "2026-06-09T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "supabase",
      "integration_name": "Supabase"
   },
   {
      "type": "integration",
      "created_at": "2026-06-09T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "pendo",
      "integration_name": "Pendo"
   },
   {
      "type": "integration",
      "created_at": "2026-06-09T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "mongodb_data",
      "integration_name": "MongoDB Database"
   },
   {
      "type": "integration",
      "created_at": "2026-06-09T00:00:00.000Z",
      "categories": [
         "datastore",
         "passthrough"
      ],
      "integration_type": "bigquery",
      "integration_name": "Google BigQuery"
   },
   {
      "type": "integration",
      "created_at": "2026-06-07T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobtetris",
      "integration_name": "JobTetris"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-05T16:21:10.000Z",
      "object_type": "uc_recording",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-05T16:21:10.000Z",
      "object_type": "uc_recording",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_call_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_end_lt",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_call_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-06-05T16:21:10.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-06-05T11:43:59.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_query",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-06-05T11:43:59.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_query",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-06-05T11:43:59.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_query",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_eu_political_ads",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "data",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "creative_type",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "creative_ids",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "width",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "height",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "creative_ids",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_campaign_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "slow_fields",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_limit",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_offset",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "eploy",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Eploy"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "eploy",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-05T09:43:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-06-05T09:43:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-06-05T09:43:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-06-05T09:43:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "object",
      "object_type": "clubs_group",
      "integration_type": "teamsnap",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "integration_name": "TeamSnap"
   },
   {
      "type": "object",
      "object_type": "clubs_member",
      "integration_type": "teamsnap",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "integration_name": "TeamSnap"
   },
   {
      "type": "object",
      "object_type": "clubs_event",
      "integration_type": "teamsnap",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "integration_name": "TeamSnap"
   },
   {
      "type": "object",
      "object_type": "clubs_location",
      "integration_type": "teamsnap",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "integration_name": "TeamSnap"
   },
   {
      "type": "object",
      "object_type": "clubs_group",
      "integration_type": "strava",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "integration_name": "Strava"
   },
   {
      "type": "object",
      "object_type": "clubs_member",
      "integration_type": "strava",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "integration_name": "Strava"
   },
   {
      "type": "object",
      "object_type": "clubs_activity",
      "integration_type": "strava",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "integration_name": "Strava"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "revsport",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "object_type": "clubs_member",
      "integration_name": "Rev Sport"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "revsport",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "object_type": "clubs_member",
      "integration_name": "Rev Sport"
   },
   {
      "type": "object",
      "object_type": "clubs_group",
      "integration_type": "revsport",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "integration_name": "Rev Sport"
   },
   {
      "type": "object",
      "object_type": "clubs_member",
      "integration_type": "revsport",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "integration_name": "Rev Sport"
   },
   {
      "type": "method",
      "integration_type": "revsport",
      "created_at": "2026-06-03T15:50:47.000Z",
      "object_type": "clubs_group",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rev Sport"
   },
   {
      "type": "method",
      "integration_type": "revsport",
      "created_at": "2026-06-03T15:50:47.000Z",
      "object_type": "clubs_group",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rev Sport"
   },
   {
      "type": "method",
      "integration_type": "revsport",
      "created_at": "2026-06-03T15:50:47.000Z",
      "object_type": "clubs_member",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rev Sport"
   },
   {
      "type": "method",
      "integration_type": "revsport",
      "created_at": "2026-06-03T15:50:47.000Z",
      "object_type": "clubs_member",
      "categories": [
         "clubs",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rev Sport"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "object_type": "hris_employee",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "object_type": "hris_employee",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2026-06-03T15:50:47.000Z",
      "object_type": "hris_employee",
      "integration_name": "BambooHR"
   },
   {
      "type": "integration",
      "created_at": "2026-06-03T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruitwithatlas",
      "integration_name": "Atlas"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-06-02T13:32:37.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "advertising_channel_type",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftads",
      "created_at": "2026-06-02T13:32:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftads",
      "created_at": "2026-06-02T13:32:37.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-06-02T13:32:37.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "integration",
      "created_at": "2026-06-02T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "yoobic",
      "integration_name": "YOOBIC"
   },
   {
      "type": "integration",
      "created_at": "2026-06-02T00:00:00.000Z",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "integration_type": "teamsnap",
      "integration_name": "TeamSnap"
   },
   {
      "type": "integration",
      "created_at": "2026-06-02T00:00:00.000Z",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "integration_type": "strava",
      "integration_name": "Strava"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-06-01T11:22:39.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "size",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-06-01T11:22:39.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "data",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "pageup",
      "created_at": "2026-06-01T11:22:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "PageUp"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteamsbot",
      "created_at": "2026-06-01T11:22:39.000Z",
      "object_type": "messaging_event",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "button",
      "integration_name": "Microsoft Teams (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2026-06-01T11:22:39.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "integration",
      "created_at": "2026-06-01T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zellis",
      "integration_name": "Zellis"
   },
   {
      "type": "integration",
      "created_at": "2026-05-31T00:00:00.000Z",
      "categories": [
         "clubs",
         "passthrough"
      ],
      "integration_type": "playhq",
      "integration_name": "PlayHQ"
   },
   {
      "type": "integration",
      "created_at": "2026-05-30T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "collage",
      "integration_name": "Collage"
   },
   {
      "type": "object",
      "created_at": "2026-05-29T12:41:44.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "monday",
      "object_type": "crm_contact",
      "integration_name": "Monday"
   },
   {
      "type": "object",
      "created_at": "2026-05-29T12:41:44.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "monday",
      "object_type": "crm_company",
      "integration_name": "Monday"
   },
   {
      "type": "object",
      "created_at": "2026-05-29T12:41:44.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "monday",
      "object_type": "crm_deal",
      "integration_name": "Monday"
   },
   {
      "type": "object",
      "created_at": "2026-05-29T12:41:44.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "monday",
      "object_type": "crm_lead",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_company",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_company",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_company",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_company",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_company",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_deal",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_deal",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_deal",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_deal",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_deal",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_lead",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_lead",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_lead",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_lead",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2026-05-29T12:41:44.000Z",
      "object_type": "crm_lead",
      "categories": [
         "task",
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Monday"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2026-05-29T12:41:44.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2026-05-28T17:09:16.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "openaiads",
      "object_type": "ads_target",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "method",
      "integration_type": "openaiads",
      "created_at": "2026-05-28T17:09:16.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2026-05-28T17:09:16.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2026-05-28T17:09:16.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lightfield",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-28T13:05:51.000Z",
      "object_type": "crm_company",
      "integration_name": "Lightfield"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lightfield",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-28T13:05:51.000Z",
      "object_type": "crm_contact",
      "integration_name": "Lightfield"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lightfield",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-28T13:05:51.000Z",
      "object_type": "crm_deal",
      "integration_name": "Lightfield"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lightfield",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-28T13:05:51.000Z",
      "object_type": "crm_lead",
      "integration_name": "Lightfield"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lightfield",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-28T13:05:51.000Z",
      "object_type": "crm_company",
      "integration_name": "Lightfield"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lightfield",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-28T13:05:51.000Z",
      "object_type": "crm_contact",
      "integration_name": "Lightfield"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lightfield",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-28T13:05:51.000Z",
      "object_type": "crm_deal",
      "integration_name": "Lightfield"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lightfield",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-28T13:05:51.000Z",
      "object_type": "crm_lead",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "Lightfield"
   },
   {
      "type": "pagination",
      "integration_type": "lightfield",
      "created_at": "2026-05-28T13:05:51.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Lightfield"
   },
   {
      "type": "writable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_employee",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_location",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_employee",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_application",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_candidate",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_job",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_group",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_location",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_employee",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_application",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_candidate",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_job",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_group",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_employee",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_location",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_employee",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_application",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_candidate",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_job",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_group",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "created_at": "2026-05-27T13:01:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "factorialhr",
      "object_type": "ats_applicationstatus",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "created_at": "2026-05-27T13:01:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "factorialhr",
      "object_type": "ats_application",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-05-27T13:01:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "FactorialHR"
   },
   {
      "type": "integration",
      "created_at": "2026-05-27T00:00:00.000Z",
      "categories": [
         "calendar",
         "crm",
         "passthrough"
      ],
      "integration_type": "calendarhero",
      "integration_name": "CalendarHero"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "openai",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "mcp_deferred_tools",
      "integration_name": "OpenAI"
   },
   {
      "type": "writable_field",
      "integration_type": "openai",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "mcp_authorization_token",
      "integration_name": "OpenAI"
   },
   {
      "type": "sign-in",
      "integration_type": "monday",
      "created_at": "2026-05-26T12:42:10.000Z",
      "integration_name": "Monday",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_limit",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_limit",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "metadata_metadata",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "task_project",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "task_task",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "ticketing_customer",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "ticketing_ticket",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "ats_application",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "ats_candidate",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "ats_interview",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "ats_job",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "ats_scorecard",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "task_project",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "task_project",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "task_task",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "task_task",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ticketing_customer",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_interview",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_interview",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "task",
         "metadata",
         "ticketing",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_cashflow",
      "pagination": "list_offset",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_balancesheet",
      "pagination": "list_offset",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_trialbalance",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2026-05-26T12:42:10.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "easycruit",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "EasyCruit"
   },
   {
      "type": "pagination",
      "integration_type": "easycruit",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "EasyCruit"
   },
   {
      "type": "pagination",
      "integration_type": "easycruit",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "EasyCruit"
   },
   {
      "type": "pagination",
      "integration_type": "easycruit",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "EasyCruit"
   },
   {
      "type": "pagination",
      "integration_type": "easycruit",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "EasyCruit"
   },
   {
      "type": "pagination",
      "integration_type": "easycruit",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "EasyCruit"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_limit",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "avionte",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Avionté"
   },
   {
      "type": "pagination",
      "integration_type": "avionte",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Avionté"
   },
   {
      "type": "pagination",
      "integration_type": "avionte",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Avionté"
   },
   {
      "type": "pagination",
      "integration_type": "avionte",
      "created_at": "2026-05-26T12:42:10.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "Avionté"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "ats_application",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "ats_job",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "hris_employee",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "ats_application",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "ats_job",
      "integration_name": "OTYS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "otys",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "hris_employee",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_created_at",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_order",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_name",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_order",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_name",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_created_at",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_order",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "OTYS"
   },
   {
      "type": "pagination",
      "integration_type": "otys",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Monday"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Monday"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "uc_call",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "uc_recording",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "uc_call",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "uc_recording",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_contact_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_offset",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_limit",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_contact_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_limit",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_offset",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-05-22T12:55:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_signatory",
      "pagination": "list_document_id",
      "integration_name": "DocuSign"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "ats_interview",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-22T12:55:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "permissions",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "mime_type",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "download_url",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "data",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "version",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "permissions",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "slow_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_sort_by_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-05-20T13:32:47.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-05-20T13:32:47.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-05-20T13:32:47.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "carerix",
      "created_at": "2026-05-20T13:32:47.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "Carerix"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2026-05-20T11:07:18.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2026-05-20T11:07:18.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Teamtailor"
   },
   {
      "type": "method",
      "integration_type": "teamtailor",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Teamtailor"
   },
   {
      "type": "object",
      "created_at": "2026-05-20T11:07:18.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "object_type": "accounting_transaction",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_list",
      "integration_name": "ConstantContact"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_member",
      "integration_name": "ConstantContact"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_campaign",
      "integration_name": "ConstantContact"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_report",
      "integration_name": "ConstantContact"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_list",
      "integration_name": "ConstantContact"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_member",
      "integration_name": "ConstantContact"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_campaign",
      "integration_name": "ConstantContact"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "constantcontact",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_report",
      "integration_name": "ConstantContact"
   },
   {
      "type": "object",
      "created_at": "2026-05-20T11:07:18.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "constantcontact",
      "object_type": "martech_list",
      "integration_name": "ConstantContact"
   },
   {
      "type": "object",
      "created_at": "2026-05-20T11:07:18.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "constantcontact",
      "object_type": "martech_member",
      "integration_name": "ConstantContact"
   },
   {
      "type": "object",
      "created_at": "2026-05-20T11:07:18.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "constantcontact",
      "object_type": "martech_campaign",
      "integration_name": "ConstantContact"
   },
   {
      "type": "object",
      "created_at": "2026-05-20T11:07:18.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "constantcontact",
      "object_type": "martech_report",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ConstantContact"
   },
   {
      "type": "method",
      "integration_type": "constantcontact",
      "created_at": "2026-05-20T11:07:18.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ConstantContact"
   },
   {
      "type": "integration",
      "created_at": "2026-05-20T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "posthog",
      "integration_name": "PostHog"
   },
   {
      "type": "integration",
      "created_at": "2026-05-20T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "mixpanel",
      "integration_name": "Mixpanel"
   },
   {
      "type": "integration",
      "created_at": "2026-05-20T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "easycruit",
      "integration_name": "EasyCruit"
   },
   {
      "type": "integration",
      "created_at": "2026-05-20T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "avionte",
      "integration_name": "Avionté"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "weight_unit",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "user_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "updated_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "type",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "type",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "total_stock",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "total_amount",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "total_amount",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "total_amount",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "title",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "terminated_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "telephones",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "telephones",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "telephones",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "taxrate_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "status",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "start_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "ssn_sin",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "shipping_address",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "shipping_address",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "salutation",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "relationships",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "reference",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "reference",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "prices",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "payment_method",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "payment_method",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "parent_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "parent_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "parent_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "notes",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "notes",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "notes",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "manager_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "last_name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "last_name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "is_supplier",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "is_payable",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "is_customer",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "is_active",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "is_active",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "is_active",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "is_active",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "invoice_number",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "hours",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "hired_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "groups",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "gender",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "first_name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "first_name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "employment_type",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "employment_status",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "employee_user_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "emails",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "emails",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "due_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "due_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "due_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "description",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "description",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "description",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "description",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "date_of_birth",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "customer_defined_code",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "currency",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "currency",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "currency",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "creditmemo_number",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "created_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "company_name",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "bio",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "billing_address",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "billing_address",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "bill_number",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "balance",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "associated_contacts",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "address",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "address",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "account_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "account_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "account_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "user_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "updated_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "parent_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "is_active",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "created_at",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "create",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "method",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-05-19T13:12:48.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "method": "remove",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "integration",
      "created_at": "2026-05-19T00:00:00.000Z",
      "categories": [
         "crm",
         "martech",
         "commerce",
         "accounting",
         "payment",
         "forms",
         "storage",
         "calendar",
         "passthrough"
      ],
      "integration_type": "wix",
      "integration_name": "Wix"
   },
   {
      "type": "integration",
      "created_at": "2026-05-19T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "lightfield",
      "integration_name": "Lightfield"
   },
   {
      "type": "integration",
      "created_at": "2026-05-19T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "imanage",
      "integration_name": "iManage"
   },
   {
      "type": "integration",
      "created_at": "2026-05-19T00:00:00.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "followupboss",
      "integration_name": "Follow Up Boss"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-05-15T20:32:02.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_limit",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-05-15T20:32:02.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_target",
      "pagination": "list_offset",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-05-15T20:32:02.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_start_gte",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-05-15T20:32:02.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_end_lt",
      "integration_name": "Google Ads"
   },
   {
      "type": "integration",
      "created_at": "2026-05-15T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "openaiads",
      "integration_name": "OpenAI Ads"
   },
   {
      "type": "integration",
      "created_at": "2026-05-15T00:00:00.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlesa360",
      "integration_name": "Google Search Ads 360"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "audience_count_min",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "audience_count_max",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_start_gte",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_end_lt",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Manatal"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Fountain"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_reference",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_limit",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-05-14T18:15:31.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_offset",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-05-14T18:15:31.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "type",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "slow_fields",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_account",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_contact",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_company",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_deal",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_group",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_journal",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_bill",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_expense",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "task_project",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "task_task",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_event",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_collection",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_item",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_location",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_refund",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_payment",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_subscription",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_payout",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_payslip",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_account",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_contact",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_company",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_deal",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_group",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_journal",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_bill",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_expense",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "task_project",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "task_task",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_event",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_collection",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_item",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_location",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_refund",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_payment",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_subscription",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_payout",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_payslip",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "payment_reference",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "payment_payout",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "has_tasks",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "carrier_status_description",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "carrier_status_code",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "carrier_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_account_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_account_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_status",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "list_payment_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "virtual_webhook_payment_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_order_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_carrier_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_sort_by_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_sort_by_created_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "virtual_webhook_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "virtual_webhook_order_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "virtual_webhook_carrier_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "list_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "list_offset",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-05-13T12:14:24.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_user_id",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-05-13T12:14:24.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Eploy"
   },
   {
      "type": "object",
      "created_at": "2026-05-12T09:08:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "eploy",
      "object_type": "ats_applicationstatus",
      "integration_name": "Eploy"
   },
   {
      "type": "object",
      "created_at": "2026-05-12T09:08:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "eploy",
      "object_type": "ats_company",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Eploy"
   },
   {
      "type": "method",
      "integration_type": "eploy",
      "created_at": "2026-05-12T09:08:02.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Eploy"
   },
   {
      "type": "object",
      "created_at": "2026-05-07T18:06:19.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicssales",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-05-07T18:06:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-05-07T18:06:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-05-07T18:06:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-05-07T18:06:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-05-07T18:06:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-05-07T18:06:19.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "completed_at",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-07T15:13:17.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-07T15:13:17.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-07T15:13:17.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-07T15:13:17.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-07T15:13:17.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-07T15:13:17.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-07T15:13:17.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-07T15:13:17.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "integration",
      "created_at": "2026-05-07T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "otys",
      "integration_name": "OTYS"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "identification",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "associated_contacts",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "slow_fields",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Sage HR"
   },
   {
      "type": "method",
      "integration_type": "sagehr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage HR"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "ringcentral",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "uc_recording",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-05-06T17:34:58.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "job_ids",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "jazzhr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "concurcompany",
      "created_at": "2026-05-06T17:34:58.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_reference",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "pagination",
      "integration_type": "concur",
      "created_at": "2026-05-06T17:34:58.000Z",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_reference",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "type",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "timeoff_days_total",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2026-05-06T17:34:58.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_type",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-05-06T17:34:58.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-05-06T17:34:58.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "uc_recording",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "uc_call",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "uc_recording",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-05-06T17:34:58.000Z",
      "object_type": "uc_call",
      "integration_name": "AirCall.io"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-05-05T16:07:11.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-05-05T16:07:11.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-05-05T16:07:11.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2026-05-05T16:07:11.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2026-05-05T16:07:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2026-05-05T16:07:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2026-05-05T16:07:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Loxo"
   },
   {
      "type": "integration",
      "created_at": "2026-05-04T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "callswitchone",
      "integration_name": "CallSwitch One"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-05-01T11:14:44.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-05-01T11:14:44.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-05-01T11:14:44.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Mailchimp"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "linkedinlearning",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-05-01T11:14:44.000Z",
      "object_type": "lms_collection",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "linkedinlearning",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-05-01T11:14:44.000Z",
      "object_type": "lms_collection",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "object",
      "created_at": "2026-05-01T11:14:44.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "linkedinlearning",
      "object_type": "lms_collection",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "method",
      "integration_type": "linkedinlearning",
      "created_at": "2026-05-01T11:14:44.000Z",
      "object_type": "lms_collection",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "method",
      "integration_type": "linkedinlearning",
      "created_at": "2026-05-01T11:14:44.000Z",
      "object_type": "lms_collection",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "integration",
      "created_at": "2026-04-29T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "cegid_recruiting",
      "integration_name": "Cegid Recruiting"
   },
   {
      "type": "integration",
      "created_at": "2026-04-29T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "cegid_learning",
      "integration_name": "Cegid Learning"
   },
   {
      "type": "integration",
      "created_at": "2026-04-29T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "cegid_hr",
      "integration_name": "Cegid HR"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "pacing",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_strategy",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "tiktokads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_ad",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "tiktokads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_ad",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "pacing",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_strategy",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_query",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_start_gte",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_end_lt",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_query",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_start_gte",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_end_lt",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_updated_gte",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "virtual_webhook_campaign_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "virtual_webhook_group_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "virtual_webhook_limit",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "pagination",
      "integration_type": "snapchat",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_limit",
      "integration_name": "Snapchat"
   },
   {
      "type": "pagination",
      "integration_type": "snapchat",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_offset",
      "integration_name": "Snapchat"
   },
   {
      "type": "pagination",
      "integration_type": "snapchat",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Snapchat"
   },
   {
      "type": "pagination",
      "integration_type": "snapchat",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Snapchat"
   },
   {
      "type": "pagination",
      "integration_type": "snapchat",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Snapchat"
   },
   {
      "type": "pagination",
      "integration_type": "snapchat",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Snapchat"
   },
   {
      "type": "pagination",
      "integration_type": "snapchat",
      "created_at": "2026-04-28T19:55:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Snapchat"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_strategy",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_strategy",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-04-28T19:55:54.000Z",
      "object_type": "ads_promoted",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "whatsapp",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_limit",
      "integration_name": "WhatsApp"
   },
   {
      "type": "pagination",
      "integration_type": "whatsapp",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_offset",
      "integration_name": "WhatsApp"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_user_id",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_bankaccount",
      "pagination": "list_limit",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_bankaccount",
      "pagination": "list_offset",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_bankaccount",
      "pagination": "list_user_id",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_deduction",
      "pagination": "list_start_gte",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_deduction",
      "pagination": "list_end_lt",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_deduction",
      "pagination": "list_user_id",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_start_gte",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_end_lt",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "ukgready",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "UKG Ready"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_query",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_company_id",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_parent_id",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_query",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_limit",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_offset",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_start_gte",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_end_lt",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_limit",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_offset",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_user_id",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_company_id",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_group_id",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_query",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_limit",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_offset",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_org_id",
      "integration_name": "Rydoo"
   },
   {
      "type": "pagination",
      "integration_type": "rydoo",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_parent_id",
      "integration_name": "Rydoo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_employee",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_location",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_group",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ats_job",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ats_application",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_employee",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_location",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_group",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ats_job",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ats_application",
      "integration_name": "Rippling"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_order",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_order",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_offset",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_order",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_order",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_order",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_order",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_updated_gte",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_order",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "redditads",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_limit",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "pagination",
      "integration_type": "redditads",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_offset",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "pagination",
      "integration_type": "redditads",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_org_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "pagination",
      "integration_type": "pandadoc",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_query",
      "integration_name": "PandaDoc"
   },
   {
      "type": "pagination",
      "integration_type": "pandadoc",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_limit",
      "integration_name": "PandaDoc"
   },
   {
      "type": "pagination",
      "integration_type": "pandadoc",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_offset",
      "integration_name": "PandaDoc"
   },
   {
      "type": "pagination",
      "integration_type": "pandadoc",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "object_type": "signing_signatory",
      "pagination": "list_document_id",
      "integration_name": "PandaDoc"
   },
   {
      "type": "pagination",
      "integration_type": "pandadoc",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_query",
      "integration_name": "PandaDoc"
   },
   {
      "type": "pagination",
      "integration_type": "pandadoc",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_limit",
      "integration_name": "PandaDoc"
   },
   {
      "type": "pagination",
      "integration_type": "pandadoc",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_offset",
      "integration_name": "PandaDoc"
   },
   {
      "type": "pagination",
      "integration_type": "pageup",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "PageUp"
   },
   {
      "type": "pagination",
      "integration_type": "pageup",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "PageUp"
   },
   {
      "type": "pagination",
      "integration_type": "pageup",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "PageUp"
   },
   {
      "type": "pagination",
      "integration_type": "pageup",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "PageUp"
   },
   {
      "type": "pagination",
      "integration_type": "pageup",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "PageUp"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ads_report",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "ads_promoted",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "crm_lead",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "crm_contact",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "crm_event",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "crm_company",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "martech_campaign",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "martech_member",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "martech_list",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "task_task",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "task_project",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "crm_lead",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "crm_contact",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "crm_event",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "crm_company",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "martech_campaign",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "martech_member",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "martech_list",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "task_task",
      "integration_name": "Lemlist"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lemlist",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "task_project",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_offset",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_order",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_offset",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_order",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_offset",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_order",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_offset",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_order",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_query",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_offset",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_order",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_query",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_offset",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_order",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_query",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_offset",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_order",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_query",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_offset",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_order",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_query",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_offset",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_order",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "lemlist",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lemlist"
   },
   {
      "type": "pagination",
      "integration_type": "dropboxsign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_limit",
      "integration_name": "Dropbox Sign"
   },
   {
      "type": "pagination",
      "integration_type": "dropboxsign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_offset",
      "integration_name": "Dropbox Sign"
   },
   {
      "type": "pagination",
      "integration_type": "dropboxsign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "passthrough"
      ],
      "object_type": "signing_signatory",
      "pagination": "list_document_id",
      "integration_name": "Dropbox Sign"
   },
   {
      "type": "pagination",
      "integration_type": "dropboxsign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_limit",
      "integration_name": "Dropbox Sign"
   },
   {
      "type": "pagination",
      "integration_type": "dropboxsign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_offset",
      "integration_name": "Dropbox Sign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_query",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_limit",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_offset",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_query",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "DocuSign"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "dhl",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "DHL"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "dhl",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "shipping_shipment",
      "integration_name": "DHL"
   },
   {
      "type": "pagination",
      "integration_type": "dhl",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_updated_gte",
      "integration_name": "DHL"
   },
   {
      "type": "pagination",
      "integration_type": "dhl",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_limit",
      "integration_name": "DHL"
   },
   {
      "type": "pagination",
      "integration_type": "dhl",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "list_offset",
      "integration_name": "DHL"
   },
   {
      "type": "pagination",
      "integration_type": "dhl",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "virtual_webhook_limit",
      "integration_name": "DHL"
   },
   {
      "type": "pagination",
      "integration_type": "dhl",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_shipment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "DHL"
   },
   {
      "type": "pagination",
      "integration_type": "dhl",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_label",
      "pagination": "list_limit",
      "integration_name": "DHL"
   },
   {
      "type": "pagination",
      "integration_type": "dhl",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_label",
      "pagination": "list_offset",
      "integration_name": "DHL"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "azuredevops",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "task_task",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "azuredevops",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-27T09:46:05.000Z",
      "object_type": "task_task",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "list_limit",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "list_offset",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_org_id",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_limit",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_offset",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_repo_id",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_limit",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_offset",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_repo_id",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_limit",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_offset",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_repo_id",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_limit",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_offset",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_updated_gte",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_offset",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_project_id",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "list_limit",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "list_offset",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "azuredevops",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "list_task_id",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_limit",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_offset",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "adobesign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_limit",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "pagination",
      "integration_type": "adobesign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_document",
      "pagination": "list_offset",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "pagination",
      "integration_type": "adobesign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_limit",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "pagination",
      "integration_type": "adobesign",
      "created_at": "2026-04-27T09:46:05.000Z",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "object_type": "signing_template",
      "pagination": "list_offset",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "timeoff_days_total",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "timeoff_days_used",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "timeoff_days_total",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2026-04-23T21:05:04.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timeoff_days_total",
      "integration_name": "PeopleHR"
   },
   {
      "type": "writable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "writable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timeoff_days_used",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timeoff_days_total",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "charliehr",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timeoff_days_used",
      "integration_name": "CharlieHR"
   },
   {
      "type": "readable_field",
      "integration_type": "charliehr",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timeoff_days_total",
      "integration_name": "CharlieHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-04-23T21:05:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "timeoff_days_used",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2026-04-23T21:05:04.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "BambooHR"
   },
   {
      "type": "integration",
      "created_at": "2026-04-23T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "crustdata",
      "integration_name": "Crustdata"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Ring Central"
   },
   {
      "type": "object",
      "created_at": "2026-04-22T15:57:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "recruitcrm",
      "object_type": "metadata_metadata",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-04-22T15:57:02.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2026-04-22T15:57:02.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2026-04-22T15:57:02.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2026-04-22T15:57:02.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googlesheets",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Sheets"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "googlesheets",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Sheets"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googlesheets",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Sheets"
   },
   {
      "type": "object",
      "created_at": "2026-04-22T15:57:02.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlesheets",
      "object_type": "storage_file",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Sheets"
   },
   {
      "type": "method",
      "integration_type": "googlesheets",
      "created_at": "2026-04-22T15:57:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Sheets"
   },
   {
      "type": "integration",
      "created_at": "2026-04-22T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "ticketing",
         "passthrough"
      ],
      "integration_type": "nooks",
      "integration_name": "Nooks"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-04-20T12:08:08.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_reference",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-04-20T12:08:08.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_reference",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "readable_field",
      "integration_type": "concurcompany",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-04-20T12:08:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "references",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "eightfold",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Eightfold"
   },
   {
      "type": "writable_field",
      "integration_type": "eightfold",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Eightfold"
   },
   {
      "type": "writable_field",
      "integration_type": "eightfold",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Eightfold"
   },
   {
      "type": "writable_field",
      "integration_type": "eightfold",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Eightfold"
   },
   {
      "type": "pagination",
      "integration_type": "eightfold",
      "created_at": "2026-04-20T08:29:46.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_limit",
      "integration_name": "Eightfold"
   },
   {
      "type": "pagination",
      "integration_type": "eightfold",
      "created_at": "2026-04-20T08:29:46.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_offset",
      "integration_name": "Eightfold"
   },
   {
      "type": "method",
      "integration_type": "eightfold",
      "created_at": "2026-04-20T08:29:46.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Eightfold"
   },
   {
      "type": "integration",
      "created_at": "2026-04-20T00:00:00.000Z",
      "categories": [
         "crm",
         "martech",
         "enrich",
         "task",
         "passthrough"
      ],
      "integration_type": "lemlist",
      "integration_name": "Lemlist"
   },
   {
      "type": "integration",
      "created_at": "2026-04-19T00:00:00.000Z",
      "categories": [
         "hris",
         "metadata",
         "accounting",
         "passthrough"
      ],
      "integration_type": "rydoo",
      "integration_name": "Rydoo"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "slow_fields",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "loxo",
      "object_type": "metadata_metadata",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "linkedinlearning",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "lms_course",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "linkedinlearning",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "lms_course",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "time_estimate_minutes",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "published_at",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "localizations",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "instructors",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "pagination",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "list_query",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "pagination",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "list_updated_gte",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "pagination",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "pagination",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "virtual_webhook_limit",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "pagination",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "list_limit",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "pagination",
      "integration_type": "linkedinlearning",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_content",
      "pagination": "list_offset",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2026-04-16T17:08:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "ashby",
      "object_type": "ats_scorecard",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2026-04-16T17:08:59.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "signing_document",
      "integration_type": "pandadoc",
      "categories": [
         "signing",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "PandaDoc"
   },
   {
      "type": "object",
      "object_type": "signing_signatory",
      "integration_type": "pandadoc",
      "categories": [
         "signing",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "PandaDoc"
   },
   {
      "type": "object",
      "object_type": "signing_template",
      "integration_type": "pandadoc",
      "categories": [
         "signing",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "PandaDoc"
   },
   {
      "type": "integration",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "ats",
         "assessment",
         "passthrough"
      ],
      "integration_type": "pageup",
      "integration_name": "PageUp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_report",
      "pagination": "list_start_gte",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_report",
      "pagination": "list_end_lt",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_report",
      "pagination": "list_limit",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_report",
      "pagination": "list_offset",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "eightfold",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Eightfold"
   },
   {
      "type": "object",
      "object_type": "signing_document",
      "integration_type": "dropboxsign",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "Dropbox Sign"
   },
   {
      "type": "object",
      "object_type": "signing_signatory",
      "integration_type": "dropboxsign",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "Dropbox Sign"
   },
   {
      "type": "object",
      "object_type": "signing_template",
      "integration_type": "dropboxsign",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "Dropbox Sign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_limit",
      "integration_name": "DocuSign"
   },
   {
      "type": "pagination",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_offset",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "object_type": "signing_document",
      "integration_type": "docusign",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "object_type": "signing_signatory",
      "integration_type": "docusign",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "object_type": "signing_template",
      "integration_type": "docusign",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "docusign",
      "object_type": "hris_group",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "created_at": "2026-04-15T16:47:16.000Z",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "docusign",
      "object_type": "storage_file",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_signatory",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_signatory",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_signatory",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_signatory",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_template",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_template",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "hris_group",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "storage_file",
      "categories": [
         "signing",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "object_type": "signing_document",
      "integration_type": "adobesign",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "object",
      "object_type": "signing_signatory",
      "integration_type": "adobesign",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "object",
      "object_type": "signing_template",
      "integration_type": "adobesign",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-15T16:47:16.000Z",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "method",
      "integration_type": "adobesign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "method",
      "integration_type": "adobesign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "method",
      "integration_type": "adobesign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_document",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "method",
      "integration_type": "adobesign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_signatory",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "method",
      "integration_type": "adobesign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_signatory",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "method",
      "integration_type": "adobesign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_template",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "method",
      "integration_type": "adobesign",
      "created_at": "2026-04-15T16:47:16.000Z",
      "object_type": "signing_template",
      "categories": [
         "signing",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2026-04-15T10:13:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-04-15T10:13:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-04-15T10:13:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2026-04-15T00:00:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "whatsapp",
      "integration_name": "WhatsApp"
   },
   {
      "type": "integration",
      "created_at": "2026-04-15T00:00:00.000Z",
      "categories": [
         "signing",
         "passthrough"
      ],
      "integration_type": "pandadoc",
      "integration_name": "PandaDoc"
   },
   {
      "type": "integration",
      "created_at": "2026-04-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "passthrough"
      ],
      "integration_type": "expensify",
      "integration_name": "Expensify"
   },
   {
      "type": "integration",
      "created_at": "2026-04-15T00:00:00.000Z",
      "categories": [
         "signing",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "dropboxsign",
      "integration_name": "Dropbox Sign"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "section",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "reimbursed_amount",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "subsection",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "slow_fields",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_order",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "mailchimp",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "martech_member",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2026-04-14T09:42:52.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "native_webhook_list_id",
      "integration_name": "Mailchimp"
   },
   {
      "type": "sign-in",
      "integration_type": "greenhouse",
      "created_at": "2026-04-14T09:42:52.000Z",
      "integration_name": "Greenhouse",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-04-14T09:42:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "answers",
      "integration_name": "BambooHR"
   },
   {
      "type": "integration",
      "created_at": "2026-04-11T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "socure",
      "integration_name": "Socure"
   },
   {
      "type": "integration",
      "created_at": "2026-04-11T00:00:00.000Z",
      "categories": [
         "repo",
         "task",
         "auth",
         "passthrough"
      ],
      "integration_type": "azuredevops",
      "integration_name": "Azure DevOps"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-04-10T13:27:48.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "rejected_at",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2026-04-10T13:27:48.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "size",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_parent_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_offset",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "list_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_status",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_status",
      "integration_name": "Linear"
   },
   {
      "type": "object",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "integration_type": "concurcompany",
      "object_type": "storage_file",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "method",
      "integration_type": "concurcompany",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "object",
      "created_at": "2026-04-09T13:40:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "integration_type": "concur",
      "object_type": "storage_file",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "text",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "writable_field",
      "integration_type": "atlassianjira",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "task_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2026-04-09T13:40:11.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "walmart",
      "created_at": "2026-04-08T16:37:24.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_limit",
      "integration_name": "Walmart"
   },
   {
      "type": "pagination",
      "integration_type": "walmart",
      "created_at": "2026-04-08T16:37:24.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_offset",
      "integration_name": "Walmart"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "quickbooksdesktop",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "payment_payment",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "total_amount",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "tax_amount",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "status",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "reference",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "paid_amount",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "invoice_number",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooksdesktop",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "field": "balance_amount",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "object",
      "created_at": "2026-04-08T16:37:24.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "payment"
      ],
      "integration_type": "quickbooksdesktop",
      "object_type": "payment_payment",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-08T16:37:24.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-04-07T16:49:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro_ats",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "tribepad",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Tribepad"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "oraclehcm",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "icims",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Fountain"
   },
   {
      "type": "writable_field",
      "integration_type": "eploy",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "hiring_managers",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "boondmanager",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "BoondManager"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "hiring_managers",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "hiring_managers",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "atsanywhere",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "readable_field",
      "integration_type": "atsanywhere",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-04-07T16:49:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "hiring_managers",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-04-07T16:12:13.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-04-07T16:12:13.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-04-07T16:12:13.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Vincere"
   },
   {
      "type": "object",
      "created_at": "2026-04-07T16:12:13.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "hris_timeoff",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-04-07T16:12:13.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-04-07T16:12:13.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-04-07T16:12:13.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-04-07T16:12:13.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Rippling"
   },
   {
      "type": "integration",
      "created_at": "2026-04-07T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris"
      ],
      "integration_type": "quickbooksdesktop",
      "integration_name": "QuickBooks Desktop"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "created_at": "2026-04-06T11:58:52.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "ats_candidate",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2026-04-06T11:58:52.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "ats_job",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2026-04-06T11:58:52.000Z",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "ats_application",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Outreach.io"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "subgroup",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-04-06T11:58:52.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "slow_fields",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "subsection",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "section",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "learnupon",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "student_id",
      "integration_name": "LearnUpon"
   },
   {
      "type": "writable_field",
      "integration_type": "learnupon",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "field": "course_id",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "LearnUpon"
   },
   {
      "type": "writable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "progress_percentage",
      "integration_name": "Google Classroom"
   },
   {
      "type": "writable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "course_id",
      "integration_name": "Google Classroom"
   },
   {
      "type": "writable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "content_id",
      "integration_name": "Google Classroom"
   },
   {
      "type": "writable_field",
      "integration_type": "googleclassroom",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "assigned_grade",
      "integration_name": "Google Classroom"
   },
   {
      "type": "method",
      "integration_type": "googleclassroom",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Classroom"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "go1",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "student_id",
      "integration_name": "Go1"
   },
   {
      "type": "writable_field",
      "integration_type": "go1",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "progress_percentage",
      "integration_name": "Go1"
   },
   {
      "type": "writable_field",
      "integration_type": "go1",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "is_completed",
      "integration_name": "Go1"
   },
   {
      "type": "writable_field",
      "integration_type": "go1",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "content_id",
      "integration_name": "Go1"
   },
   {
      "type": "writable_field",
      "integration_type": "go1",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "completed_at",
      "integration_name": "Go1"
   },
   {
      "type": "method",
      "integration_type": "go1",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Go1"
   },
   {
      "type": "method",
      "integration_type": "go1",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Go1"
   },
   {
      "type": "method",
      "integration_type": "go1",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Go1"
   },
   {
      "type": "writable_field",
      "integration_type": "d2l",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "student_id",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "writable_field",
      "integration_type": "d2l",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "course_id",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "method",
      "integration_type": "d2l",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "method",
      "integration_type": "d2l",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-04-06T11:58:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2026-04-06T11:58:52.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2026-04-06T11:58:52.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_query",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2026-04-06T11:58:52.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_company_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2026-04-06T11:58:52.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "integration",
      "created_at": "2026-04-06T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgready",
      "integration_name": "UKG Ready"
   },
   {
      "type": "integration",
      "created_at": "2026-04-06T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "concurcompany",
      "integration_name": "Concur (Company)"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "SendGrid"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_code",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "legal_name",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_org_id",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "object_type": "hris_company",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_company",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_company",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "JobDiva"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "crm_contact",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "crm_contact",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "FourthHR"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "payment_method",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "SAP Concur"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "concur",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "SAP Concur"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "concur",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "SAP Concur"
   },
   {
      "type": "readable_field",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "SAP Concur"
   },
   {
      "type": "pagination",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "slow_fields",
      "integration_name": "SAP Concur"
   },
   {
      "type": "object",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "concur",
      "object_type": "accounting_invoice",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP Concur"
   },
   {
      "type": "writable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_contact_id",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-03-31T13:02:05.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2026-03-31T13:02:05.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "integration",
      "created_at": "2026-03-31T00:00:00.000Z",
      "categories": [
         "crm",
         "metadata",
         "passthrough"
      ],
      "integration_type": "agencyzoom",
      "integration_name": "AgencyZoom"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2026-03-30T09:47:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "hris_location",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2026-03-30T09:47:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "hris_timeshift",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2026-03-30T09:47:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "rippling",
      "object_type": "passthrough",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rippling"
   },
   {
      "type": "method",
      "integration_type": "rippling",
      "created_at": "2026-03-30T09:47:50.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "hris_company",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_interview",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "lms_content",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "twilio",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "integration_name": "Twilio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "twilio",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "integration_name": "Twilio"
   },
   {
      "type": "object",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "integration_type": "twilio",
      "object_type": "uc_call",
      "integration_name": "Twilio"
   },
   {
      "type": "object",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "integration_type": "twilio",
      "object_type": "uc_recording",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "twilio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Twilio"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Stardex"
   },
   {
      "type": "readable_field",
      "integration_type": "stardex",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Stardex"
   },
   {
      "type": "pagination",
      "integration_type": "stardex",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Stardex"
   },
   {
      "type": "object",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "stardex",
      "object_type": "ats_applicationstatus",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stardex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sendgrid",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "martech_member",
      "integration_name": "SendGrid"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sendgrid",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "martech_member",
      "integration_name": "SendGrid"
   },
   {
      "type": "readable_field",
      "integration_type": "sendgrid",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "SendGrid"
   },
   {
      "type": "readable_field",
      "integration_type": "sendgrid",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_query",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_updated_gte",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_offset",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SendGrid"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Sage HR"
   },
   {
      "type": "writable_field",
      "integration_type": "sagehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "Sage HR"
   },
   {
      "type": "method",
      "integration_type": "sagehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "slow_fields",
      "integration_name": "Ring Central"
   },
   {
      "type": "writable_field",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Remote.com"
   },
   {
      "type": "writable_field",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Remote.com"
   },
   {
      "type": "writable_field",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Remote.com"
   },
   {
      "type": "writable_field",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Remote.com"
   },
   {
      "type": "writable_field",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "Remote.com"
   },
   {
      "type": "writable_field",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Remote.com"
   },
   {
      "type": "writable_field",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Remote.com"
   },
   {
      "type": "readable_field",
      "integration_type": "quo",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QUO"
   },
   {
      "type": "readable_field",
      "integration_type": "quo",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QUO"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "download_url",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "personio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Personio"
   },
   {
      "type": "writable_field",
      "integration_type": "personio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Personio"
   },
   {
      "type": "writable_field",
      "integration_type": "personio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Personio"
   },
   {
      "type": "writable_field",
      "integration_type": "personio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Personio"
   },
   {
      "type": "writable_field",
      "integration_type": "personio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Personio"
   },
   {
      "type": "writable_field",
      "integration_type": "personio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Personio"
   },
   {
      "type": "writable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "PeopleHR"
   },
   {
      "type": "writable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "PeopleHR"
   },
   {
      "type": "writable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "PeopleHR"
   },
   {
      "type": "writable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "PeopleHR"
   },
   {
      "type": "writable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "PeopleHR"
   },
   {
      "type": "writable_field",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "PeopleHR"
   },
   {
      "type": "method",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "PeopleHR"
   },
   {
      "type": "method",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "PeopleHR"
   },
   {
      "type": "method",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "PeopleHR"
   },
   {
      "type": "method",
      "integration_type": "peoplehr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "PeopleHR"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_promoted",
      "pagination": "list_query",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "JustCall"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "JustCall"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HiBob"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "HiBob"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "HiBob"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "HiBob"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "heavenhr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "HeavenHR"
   },
   {
      "type": "readable_field",
      "integration_type": "goto",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "GoTO"
   },
   {
      "type": "readable_field",
      "integration_type": "goto",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "GoTO"
   },
   {
      "type": "pagination",
      "integration_type": "googledrive",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_expand",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "user_id",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "status",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "start_at",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "reason",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "end_at",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "comments",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "create",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "update",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "assembled",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Assembled"
   },
   {
      "type": "writable_field",
      "integration_type": "assembled",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Assembled"
   },
   {
      "type": "writable_field",
      "integration_type": "assembled",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Assembled"
   },
   {
      "type": "writable_field",
      "integration_type": "assembled",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Assembled"
   },
   {
      "type": "method",
      "integration_type": "assembled",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Assembled"
   },
   {
      "type": "method",
      "integration_type": "assembled",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Assembled"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "AirCall.io"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-03-27T17:47:58.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "slow_fields",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "abacus",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Abacus"
   },
   {
      "type": "writable_field",
      "integration_type": "abacus",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Abacus"
   },
   {
      "type": "writable_field",
      "integration_type": "abacus",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Abacus"
   },
   {
      "type": "writable_field",
      "integration_type": "abacus",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Abacus"
   },
   {
      "type": "writable_field",
      "integration_type": "abacus",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Abacus"
   },
   {
      "type": "method",
      "integration_type": "abacus",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Abacus"
   },
   {
      "type": "readable_field",
      "integration_type": "8x8xcaas",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "15five",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "15Five"
   },
   {
      "type": "method",
      "integration_type": "15five",
      "created_at": "2026-03-27T17:47:58.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "15Five"
   },
   {
      "type": "integration",
      "created_at": "2026-03-25T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "ujet",
      "integration_name": "Ujet"
   },
   {
      "type": "object",
      "object_type": "commerce_availability",
      "integration_type": "yelp",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "Yelp"
   },
   {
      "type": "object",
      "object_type": "commerce_reservation",
      "integration_type": "yelp",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "Yelp"
   },
   {
      "type": "integration",
      "created_at": "2026-03-23T14:30:38.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "yelp",
      "integration_name": "Yelp"
   },
   {
      "type": "object",
      "object_type": "commerce_availability",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "object_type": "commerce_reservation",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-03-23T14:30:38.000Z",
      "object_type": "commerce_availability",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-03-23T14:30:38.000Z",
      "object_type": "commerce_reservation",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "object_type": "commerce_availability",
      "integration_type": "sevenrooms",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "SevenRooms"
   },
   {
      "type": "object",
      "object_type": "commerce_reservation",
      "integration_type": "sevenrooms",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "SevenRooms"
   },
   {
      "type": "integration",
      "created_at": "2026-03-23T14:30:38.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "sevenrooms",
      "integration_name": "SevenRooms"
   },
   {
      "type": "object",
      "object_type": "commerce_availability",
      "integration_type": "resos",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "resOS"
   },
   {
      "type": "object",
      "object_type": "commerce_reservation",
      "integration_type": "resos",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "resOS"
   },
   {
      "type": "integration",
      "created_at": "2026-03-23T14:30:38.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "resos",
      "integration_name": "resOS"
   },
   {
      "type": "object",
      "object_type": "commerce_availability",
      "integration_type": "opentable",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "OpenTable"
   },
   {
      "type": "object",
      "object_type": "commerce_reservation",
      "integration_type": "opentable",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-23T14:30:38.000Z",
      "integration_name": "OpenTable"
   },
   {
      "type": "integration",
      "created_at": "2026-03-23T14:30:38.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "opentable",
      "integration_name": "OpenTable"
   },
   {
      "type": "integration",
      "created_at": "2026-03-23T14:30:38.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jungle",
      "integration_name": "Welcome to the Jungle"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-23T14:30:38.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "has_eu_political_ads",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-23T14:30:38.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "has_eu_political_ads",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-03-23T14:30:38.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_group_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "group",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "customer_defined_code",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "zohobooks",
      "object_type": "accounting_transaction",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "strongdm",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "StrongDM"
   },
   {
      "type": "writable_field",
      "integration_type": "strongdm",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "StrongDM"
   },
   {
      "type": "writable_field",
      "integration_type": "strongdm",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "StrongDM"
   },
   {
      "type": "writable_field",
      "integration_type": "strongdm",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "StrongDM"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_start_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_end_lt",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "scoro",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Scoro"
   },
   {
      "type": "writable_field",
      "integration_type": "scoro",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Scoro"
   },
   {
      "type": "writable_field",
      "integration_type": "scoro",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Scoro"
   },
   {
      "type": "writable_field",
      "integration_type": "scoro",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "scoro",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "scoro",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "scoro",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "scoro",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "quo",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "QUO"
   },
   {
      "type": "readable_field",
      "integration_type": "quo",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "QUO"
   },
   {
      "type": "writable_field",
      "integration_type": "plusplus",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "PlusPlus"
   },
   {
      "type": "writable_field",
      "integration_type": "plusplus",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "PlusPlus"
   },
   {
      "type": "writable_field",
      "integration_type": "plusplus",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "PlusPlus"
   },
   {
      "type": "writable_field",
      "integration_type": "plusplus",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "PlusPlus"
   },
   {
      "type": "readable_field",
      "integration_type": "plusplus",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "PlusPlus"
   },
   {
      "type": "readable_field",
      "integration_type": "plusplus",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "PlusPlus"
   },
   {
      "type": "readable_field",
      "integration_type": "plusplus",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "PlusPlus"
   },
   {
      "type": "readable_field",
      "integration_type": "plusplus",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "PlusPlus"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Phenom"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Phenom"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Phenom"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Phenom"
   },
   {
      "type": "writable_field",
      "integration_type": "peakon",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Peakon"
   },
   {
      "type": "writable_field",
      "integration_type": "peakon",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Peakon"
   },
   {
      "type": "writable_field",
      "integration_type": "peakon",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Peakon"
   },
   {
      "type": "writable_field",
      "integration_type": "peakon",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "peakon",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "peakon",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "peakon",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "peakon",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "category",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_group_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "metaads",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "virtual_webhook_group_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "lattice",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Lattice"
   },
   {
      "type": "writable_field",
      "integration_type": "lattice",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Lattice"
   },
   {
      "type": "writable_field",
      "integration_type": "lattice",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Lattice"
   },
   {
      "type": "writable_field",
      "integration_type": "lattice",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "JustCall"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "JustCall"
   },
   {
      "type": "writable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "JumpCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "JumpCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "JumpCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "JumpCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "ironclad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Ironclad"
   },
   {
      "type": "writable_field",
      "integration_type": "ironclad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Ironclad"
   },
   {
      "type": "writable_field",
      "integration_type": "ironclad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Ironclad"
   },
   {
      "type": "writable_field",
      "integration_type": "ironclad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "ironclad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "ironclad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "ironclad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "ironclad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Ironclad"
   },
   {
      "type": "object",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "highlevel",
      "object_type": "crm_event",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "ads_insertionorder",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "ads_insertionorder",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_order",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_order",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "list_query",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "list_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "list_order",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "list_campaign_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "virtual_webhook_campaign_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_insertionorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_order",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_parent_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_order",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_sort_by_name",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_campaign_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Gong"
   },
   {
      "type": "writable_field",
      "integration_type": "enboarder",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Enboarder"
   },
   {
      "type": "writable_field",
      "integration_type": "enboarder",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Enboarder"
   },
   {
      "type": "writable_field",
      "integration_type": "enboarder",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Enboarder"
   },
   {
      "type": "writable_field",
      "integration_type": "enboarder",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "enboarder",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "enboarder",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "enboarder",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "enboarder",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "contact_phone",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "contact_name",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "call_id",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Alexis"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Alexis"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Alexis"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "8x8xcaas",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_phone",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "readable_field",
      "integration_type": "8x8xcaas",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_name",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "object",
      "created_at": "2026-03-20T16:30:54.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "8x8xcaas",
      "object_type": "hris_employee",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "method",
      "integration_type": "8x8xcaas",
      "created_at": "2026-03-20T16:30:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "integration",
      "created_at": "2026-03-19T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "sapfieldglass",
      "integration_name": "SAP Fieldglass"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "twitterads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "object",
      "object_type": "ads_promoted",
      "integration_type": "twitterads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_promoted",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "tiktokads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "thetradedesk",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "The Trade Desk"
   },
   {
      "type": "readable_field",
      "integration_type": "thetradedesk",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "The Trade Desk"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "thetradedesk",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "The Trade Desk"
   },
   {
      "type": "method",
      "integration_type": "thetradedesk",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "The Trade Desk"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "snapchat",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snapchat"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "redditads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "redditads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "pinterestads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "weight_unit",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "weight",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "requires_shipping",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "is_visible",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "is_featured",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "inventory_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "weight_unit",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "weight",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "total_stock",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "requires_shipping",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "prices",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "is_visible",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "is_featured",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "inventory_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "microsoftads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "category",
      "integration_name": "Meta Ads"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "integration_name": "Meta Ads"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "object_type": "ads_promoted",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_promoted",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "linkedin",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "object_type": "ads_promoted",
      "integration_type": "linkedin",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_promoted",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_organization",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_campaign",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_creative",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_organization",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_campaign",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_creative",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_query",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_query",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "list_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_campaign",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "virtual_webhook_group_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_query",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_campaign_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "list_io_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "virtual_webhook_campaign_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "virtual_webhook_io_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_ad",
      "pagination": "list_query",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Google Ads"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "googleads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Google Ads"
   },
   {
      "type": "object",
      "object_type": "ads_promoted",
      "integration_type": "googleads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_promoted",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Clear Company"
   },
   {
      "type": "object",
      "created_at": "2026-03-17T18:34:30.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "breezyhr",
      "object_type": "ats_application",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "telephones",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "name",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "job_id",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "emails",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "candidate_id",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "address",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "create",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "create",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "promoted",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "object",
      "object_type": "ads_target",
      "integration_type": "amazonads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "object",
      "object_type": "ads_promoted",
      "integration_type": "amazonads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-03-17T18:34:30.000Z",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_target",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_promoted",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-03-17T18:34:30.000Z",
      "object_type": "ads_promoted",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "integration",
      "created_at": "2026-03-17T00:00:00.000Z",
      "categories": [
         "martech",
         "commerce",
         "passthrough"
      ],
      "integration_type": "yotpodeveloper",
      "integration_name": "Yotpo (Developer)"
   },
   {
      "type": "integration",
      "created_at": "2026-03-17T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "shapes",
      "integration_name": "Shapes"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "slow_fields",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "zohocrm",
      "object_type": "metadata_metadata",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_expand",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_fulltext",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_fulltext",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_expand",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "Mailchimp"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "sender_phone",
      "integration_name": "Mailchimp"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "sender_name",
      "integration_name": "Mailchimp"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "sender_email",
      "integration_name": "Mailchimp"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "sender_company",
      "integration_name": "Mailchimp"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "language",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "sender_phone",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "sender_name",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "sender_email",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "sender_company",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-13T16:36:18.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "language",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "googledrive",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_fulltext",
      "integration_name": "Google Drive"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_expand",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_expand",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "dropbox",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_expand",
      "integration_name": "Dropbox"
   },
   {
      "type": "pagination",
      "integration_type": "adyen",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Adyen"
   },
   {
      "type": "pagination",
      "integration_type": "adyen",
      "created_at": "2026-03-13T16:36:18.000Z",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "Adyen"
   },
   {
      "type": "method",
      "integration_type": "zohoinvoice",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocalendar",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Calendar"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_location",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trakstarhire",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_order",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_account",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "payment_payout",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "payment_refund",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stardex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stardex"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "shipstation",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ShipStation"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "sap",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "quo",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QUO"
   },
   {
      "type": "method",
      "integration_type": "quo",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QUO"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "pinpoint",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pinpoint"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "personio",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "peoplehr",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "PeopleHR"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "odoo",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Odoo"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "motion",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Motion"
   },
   {
      "type": "method",
      "integration_type": "motion",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Motion"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "crm_company",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "mailchimp",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Mailchimp"
   },
   {
      "type": "method",
      "integration_type": "linkedinlearning",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "lms_instructor",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "kandji",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "integration_name": "JustCall"
   },
   {
      "type": "object",
      "created_at": "2026-03-12T10:45:39.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "justcall",
      "object_type": "hris_employee",
      "integration_name": "JustCall"
   },
   {
      "type": "object",
      "created_at": "2026-03-12T10:45:39.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "justcall",
      "object_type": "hris_group",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "irishr",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Iris HR"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "kms_page",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "kms_space",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "hexnode",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Hexnode"
   },
   {
      "type": "method",
      "integration_type": "helpscout",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Helpscout"
   },
   {
      "type": "method",
      "integration_type": "guru",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Guru"
   },
   {
      "type": "method",
      "integration_type": "guru",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Guru"
   },
   {
      "type": "method",
      "integration_type": "goto",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_device",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GoTO"
   },
   {
      "type": "method",
      "integration_type": "goto",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GoTO"
   },
   {
      "type": "method",
      "integration_type": "goto",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GoTO"
   },
   {
      "type": "method",
      "integration_type": "googleforms",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Forms"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "task_comment",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "flatchr",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Flatchr"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "list",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "get",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "concur",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP Concur"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "clearcompany",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Clear Company"
   },
   {
      "type": "method",
      "integration_type": "circle",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Circle.so"
   },
   {
      "type": "method",
      "integration_type": "circle",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Circle.so"
   },
   {
      "type": "method",
      "integration_type": "circle",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Circle.so"
   },
   {
      "type": "method",
      "integration_type": "charliehr",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "CharlieHR"
   },
   {
      "type": "method",
      "integration_type": "charliehr",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "CharlieHR"
   },
   {
      "type": "method",
      "integration_type": "charliehr",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "CharlieHR"
   },
   {
      "type": "method",
      "integration_type": "cascade",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cascade"
   },
   {
      "type": "method",
      "integration_type": "cascade",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cascade"
   },
   {
      "type": "method",
      "integration_type": "cascade",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cascade"
   },
   {
      "type": "method",
      "integration_type": "cal",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "calendar_link",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cal.com"
   },
   {
      "type": "method",
      "integration_type": "cal",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Cal.com"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "boldcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "method",
      "integration_type": "boldcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "method",
      "integration_type": "boldcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "method",
      "integration_type": "boldcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "method",
      "integration_type": "boldcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "commerce_location",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "assembled",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Assembled"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "ads_report",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "object",
      "created_at": "2026-03-12T10:45:39.000Z",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "adyen",
      "object_type": "hris_company",
      "integration_name": "Adyen"
   },
   {
      "type": "method",
      "integration_type": "adyen",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Adyen"
   },
   {
      "type": "method",
      "integration_type": "adyen",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "hris_company",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Adyen"
   },
   {
      "type": "method",
      "integration_type": "acuityscheduling",
      "created_at": "2026-03-12T10:45:39.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-10T17:05:05.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Mailchimp"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-10T17:05:05.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-10T17:05:05.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-10T17:05:05.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Mailchimp"
   },
   {
      "type": "object",
      "created_at": "2026-03-10T17:05:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "hris_group",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-03-10T17:05:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2026-03-10T17:05:05.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_group_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2026-03-10T17:05:05.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_group_id",
      "integration_name": "GitLab"
   },
   {
      "type": "object",
      "created_at": "2026-03-10T17:05:05.000Z",
      "categories": [
         "hris",
         "ats"
      ],
      "integration_type": "dayforce",
      "object_type": "hris_group",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "pagination",
      "integration_type": "coda",
      "created_at": "2026-03-10T17:05:05.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "slow_fields",
      "integration_name": "Coda"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-10T17:05:05.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-10T17:05:05.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-03-09T14:04:30.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "list_payment_id",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-03-09T14:04:30.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "virtual_webhook_payment_id",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2026-03-09T14:04:30.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2026-03-09T14:04:30.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2026-03-09T14:04:30.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2026-03-09T14:04:30.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "GitLab"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-03-09T14:04:30.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-03-09T14:04:30.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-03-09T14:04:30.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Attio"
   },
   {
      "type": "integration",
      "created_at": "2026-03-09T00:00:00.000Z",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "adyen",
      "integration_name": "Adyen"
   },
   {
      "type": "object",
      "created_at": "2026-03-06T10:23:59.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting",
         "passthrough"
      ],
      "integration_type": "workday",
      "object_type": "passthrough",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-03-06T10:23:59.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_contact_id",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-03-06T10:23:59.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-03-06T10:23:59.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_query",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "task",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "call",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "bill_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Pipedrive"
   },
   {
      "type": "object",
      "created_at": "2026-03-06T10:23:59.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "pipedrive",
      "object_type": "metadata_metadata",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "storage",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pipedrive"
   },
   {
      "type": "integration",
      "created_at": "2026-03-06T10:23:59.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "payfit",
      "integration_name": "PayFit"
   },
   {
      "type": "writable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Mailchimp"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "list_ids",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "list_ids",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2026-03-06T10:23:59.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "gainsight",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gainsight"
   },
   {
      "type": "writable_field",
      "integration_type": "customerio",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Customer.io"
   },
   {
      "type": "writable_field",
      "integration_type": "customerio",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Customer.io"
   },
   {
      "type": "method",
      "integration_type": "customerio",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Customer.io"
   },
   {
      "type": "method",
      "integration_type": "customerio",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Customer.io"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "list_ids",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "object",
      "created_at": "2026-03-06T10:23:59.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "activecampaign",
      "object_type": "crm_event",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-03-06T10:23:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "bill_id",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "bill_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_query",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_type",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_invoice_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_bill_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_type",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_invoice_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_bill_id",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "campaign_budget_identifier",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "asset_urls",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "creative_type",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "pagination",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_limit",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "pagination",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_offset",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "pagination",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_org_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "pagination",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_group_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "object",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "integration_type": "twitterads",
      "object_type": "metadata_metadata",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "toast",
      "object_type": "accounting_contact",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "headline",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "creative_asset_url",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitee",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_activity",
      "integration_name": "Recruitee"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitee",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_activity",
      "integration_name": "Recruitee"
   },
   {
      "type": "object",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "recruitee",
      "object_type": "ats_activity",
      "integration_name": "Recruitee"
   },
   {
      "type": "method",
      "integration_type": "recruitee",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruitee"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "payment_method",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "bill_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "payment_method",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "integration",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "payworks",
      "integration_name": "Payworks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "paypal",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_subscription",
      "integration_name": "Paypal"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "paypal",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_subscription",
      "integration_name": "Paypal"
   },
   {
      "type": "readable_field",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "Paypal"
   },
   {
      "type": "readable_field",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Paypal"
   },
   {
      "type": "readable_field",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "cancelled_at",
      "integration_name": "Paypal"
   },
   {
      "type": "object",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "paypal",
      "object_type": "payment_link",
      "integration_name": "Paypal"
   },
   {
      "type": "object",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "paypal",
      "object_type": "payment_subscription",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paypal"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "bill_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "bill_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path2",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path2",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path1",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path1",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path2",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path2",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path1",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path1",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "advertising_channel_type",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "video_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "special_ad_categories",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "image_hash",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "asset_urls",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "page_identifier",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "integration_type": "metaads",
      "object_type": "metadata_metadata",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "asset_urls",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "ad_group_type",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "optimization_goal",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "creative_type",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "billing_event",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "asset_urls",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "slow_fields",
      "integration_name": "Klaviyo"
   },
   {
      "type": "writable_field",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JustCall"
   },
   {
      "type": "writable_field",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JustCall"
   },
   {
      "type": "writable_field",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_call",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_recording",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_call",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_recording",
      "integration_name": "JustCall"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "JustCall"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_updated_gte",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_start_gte",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_end_lt",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_order",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_updated_gte",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_end_lt",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_order",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "integration_name": "JobDiva"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "filename",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "document_url",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "document_data",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_updated_gte",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path2",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path1",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "display_url",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_budget_identifier",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "advertising_channel_type",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "ad_group_type",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path2",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "path1",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "link_url",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "display_url",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "advertising_channel_type",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "crezco",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "passthrough"
      ],
      "field": "link_id",
      "integration_name": "Crezco"
   },
   {
      "type": "pagination",
      "integration_type": "crezco",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_limit",
      "integration_name": "Crezco"
   },
   {
      "type": "pagination",
      "integration_type": "crezco",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_offset",
      "integration_name": "Crezco"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "campaign_budget_identifier",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "creative_type",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "campaign_budget_identifier",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "body",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "asset_urls",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "field": "advertising_channel_type",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "object",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "integration_type": "amazonads",
      "object_type": "metadata_metadata",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ads",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "object",
      "created_at": "2026-03-02T15:57:20.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "activecampaign",
      "object_type": "metadata_metadata",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-03-02T15:57:20.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "integration",
      "created_at": "2026-03-02T00:00:00.000Z",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "carerix",
      "integration_name": "Carerix"
   },
   {
      "type": "integration",
      "created_at": "2026-02-26T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "abacus",
      "integration_name": "Abacus"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "method",
      "integration_type": "zohoinvoice",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "method",
      "integration_type": "zohoinvoice",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "stage",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_limit",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_offset",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_channel_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_space_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "kms_page",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "kms_page",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "kms_space",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zendesk"
   },
   {
      "type": "method",
      "integration_type": "zendesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "kms_space",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "messaging",
         "kms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "object_type": "commerce_review",
      "pagination": "slow_fields",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "slow_fields",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_query",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_limit",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_offset",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_limit",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_offset",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "create",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "update",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "ats",
         "lms",
         "accounting"
      ],
      "method": "remove",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_location_id",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_limit",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_offset",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_order",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_name",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_company_id",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "slow_fields",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_webinar",
      "pagination": "slow_fields",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "slow_fields",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_company",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_company",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_location",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_location",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_group",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_group",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "slow_fields",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "slow_fields",
      "integration_name": "Trello"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "slow_fields",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_order",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_order",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_offset",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_offset",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_order",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_order",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Toast"
   },
   {
      "type": "method",
      "integration_type": "toast",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "tally",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Tally"
   },
   {
      "type": "pagination",
      "integration_type": "tally",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Tally"
   },
   {
      "type": "pagination",
      "integration_type": "tally",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Tally"
   },
   {
      "type": "pagination",
      "integration_type": "tally",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Tally"
   },
   {
      "type": "method",
      "integration_type": "tally",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Tally"
   },
   {
      "type": "method",
      "integration_type": "tally",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Tally"
   },
   {
      "type": "method",
      "integration_type": "tally",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_group",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Tally"
   },
   {
      "type": "method",
      "integration_type": "tally",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "hris_group",
      "categories": [
         "forms",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Tally"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "slow_fields",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shippo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_limit",
      "integration_name": "Shippo"
   },
   {
      "type": "method",
      "integration_type": "shippo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_order",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shippo"
   },
   {
      "type": "method",
      "integration_type": "shippo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_order",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shippo"
   },
   {
      "type": "method",
      "integration_type": "shippo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "accounting_order",
      "categories": [
         "shipping",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Shippo"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_report",
      "pagination": "slow_fields",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "salsify",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_type",
      "integration_name": "Salsify"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "slow_fields",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "slow_fields",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "ramp",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "slow_fields",
      "integration_name": "Ramp"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_profitloss",
      "pagination": "slow_fields",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "slow_fields",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "slow_fields",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "peoplehr",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "PeopleHR"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "slow_fields",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "slow_fields",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "slow_fields",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "slow_fields",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "slow_fields",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "slow_fields",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteamsbot",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_event",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Teams (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_webinar",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "slow_fields",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "object",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftsharepoint",
      "object_type": "kms_page",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "object",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftsharepoint",
      "object_type": "kms_space",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "kms_page",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "kms_page",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "kms_space",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "kms_space",
      "categories": [
         "storage",
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftplanner",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftintune",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftads",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_report",
      "pagination": "slow_fields",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "kustomer",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Kustomer"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "slow_fields",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_limit",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_offset",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "icims",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "slow_fields",
      "integration_name": "iCIMS"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_type",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "virtual_webhook_type",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "goto",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_webinar",
      "pagination": "slow_fields",
      "integration_name": "GoTO"
   },
   {
      "type": "pagination",
      "integration_type": "googledrive",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "slow_fields",
      "integration_name": "Google Drive"
   },
   {
      "type": "pagination",
      "integration_type": "googleads",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_organization",
      "pagination": "list_offset",
      "integration_name": "Google Ads"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Gainsight"
   },
   {
      "type": "pagination",
      "integration_type": "gainsight",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Gainsight"
   },
   {
      "type": "pagination",
      "integration_type": "gainsight",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Gainsight"
   },
   {
      "type": "object",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "gainsight",
      "object_type": "metadata_metadata",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gainsight"
   },
   {
      "type": "pagination",
      "integration_type": "fireflies",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "slow_fields",
      "integration_name": "Fireflies"
   },
   {
      "type": "pagination",
      "integration_type": "fathom",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Fathom"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "charliehr",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "CharlieHR"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianservicedesk",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "slow_fields",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "slow_fields",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "anthropicclaude",
      "created_at": "2026-02-24T16:22:24.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "mcp_authorization_token",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_report",
      "pagination": "slow_fields",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "8x8",
      "created_at": "2026-02-24T16:22:24.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "integration",
      "created_at": "2026-02-23T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "youtubeanalytics",
      "integration_name": "YouTube Analytics"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zoomphone",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "uc_call",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zoomphone",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "uc_call",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-02-20T09:26:39.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_updated_gte",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-02-20T09:26:39.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-02-20T09:26:39.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-02-20T09:26:39.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-02-20T09:26:39.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "item_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "pagination",
      "integration_type": "revsport",
      "created_at": "2026-02-20T09:26:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Rev Sport"
   },
   {
      "type": "pagination",
      "integration_type": "revsport",
      "created_at": "2026-02-20T09:26:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_updated_gte",
      "integration_name": "Rev Sport"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "hosting_source",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "creative_type",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-02-20T09:26:39.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "walmart",
      "created_at": "2026-02-19T17:37:20.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "items",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-02-19T17:37:20.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2026-02-19T17:37:20.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "integration",
      "created_at": "2026-02-19T17:37:20.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "dealcloud",
      "integration_name": "DealCloud"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "crm_event",
      "integration_name": "Vincere"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "crm_event",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_company_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_deal_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_type",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "item_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "item_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "thetradedesk",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "The Trade Desk"
   },
   {
      "type": "writable_field",
      "integration_type": "thetradedesk",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "The Trade Desk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "snapchat",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_campaign",
      "integration_name": "Snapchat"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "snapchat",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_group",
      "integration_name": "Snapchat"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "snapchat",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_creative",
      "integration_name": "Snapchat"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "snapchat",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_campaign",
      "integration_name": "Snapchat"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "snapchat",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_group",
      "integration_name": "Snapchat"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "snapchat",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_creative",
      "integration_name": "Snapchat"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "snapchat",
      "object_type": "ads_organization",
      "integration_name": "Snapchat"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "snapchat",
      "object_type": "ads_campaign",
      "integration_name": "Snapchat"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "snapchat",
      "object_type": "ads_group",
      "integration_name": "Snapchat"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "snapchat",
      "object_type": "ads_ad",
      "integration_name": "Snapchat"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "snapchat",
      "object_type": "ads_creative",
      "integration_name": "Snapchat"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "snapchat",
      "object_type": "ads_report",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Snapchat"
   },
   {
      "type": "method",
      "integration_type": "snapchat",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_report",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Snapchat"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "recruiteeassessment",
      "object_type": "assessment_package",
      "integration_name": "Recruitee Assessment"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "recruiteeassessment",
      "object_type": "assessment_order",
      "integration_name": "Recruitee Assessment"
   },
   {
      "type": "method",
      "integration_type": "recruiteeassessment",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruitee Assessment"
   },
   {
      "type": "method",
      "integration_type": "recruiteeassessment",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruitee Assessment"
   },
   {
      "type": "method",
      "integration_type": "recruiteeassessment",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruitee Assessment"
   },
   {
      "type": "method",
      "integration_type": "recruiteeassessment",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruitee Assessment"
   },
   {
      "type": "method",
      "integration_type": "recruiteeassessment",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recruitee Assessment"
   },
   {
      "type": "method",
      "integration_type": "recruiteeassessment",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "assessment_order",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruitee Assessment"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "LinkedIn"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "linkedin",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "messaging_event",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "linkedin",
      "object_type": "messaging_message",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "linkedin",
      "object_type": "messaging_channel",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "linkedin",
      "object_type": "messaging_event",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "created_at": "2026-02-19T14:05:51.000Z",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "linkedin",
      "object_type": "hris_employee",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "messaging_message",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ads",
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-02-19T14:05:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2026-02-19T09:58:00.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-02-19T09:58:00.000Z",
      "object_type": "crm_event",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-02-19T09:58:00.000Z",
      "object_type": "crm_event",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-02-19T09:58:00.000Z",
      "object_type": "crm_event",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2026-02-19T09:58:00.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "task",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2026-02-19T09:58:00.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "meeting",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-02-19T09:58:00.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "native_webhook_type",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-02-19T09:58:00.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_type",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2026-02-19T09:52:01.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "workableassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "object_type": "assessment_order",
      "pagination": "list_limit",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "pagination",
      "integration_type": "workableassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "object_type": "assessment_order",
      "pagination": "list_offset",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "method",
      "integration_type": "workableassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "method",
      "integration_type": "workableassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "method",
      "integration_type": "workableassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "method",
      "integration_type": "workableassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "method",
      "integration_type": "workableassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "method",
      "integration_type": "workableassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_order",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_limit",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_offset",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_calendar",
      "pagination": "list_limit",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_calendar",
      "pagination": "list_offset",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_calendar",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_calendar",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "talentlyftassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "object_type": "assessment_order",
      "pagination": "list_limit",
      "integration_name": "TalentLyft Assessment"
   },
   {
      "type": "pagination",
      "integration_type": "talentlyftassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "object_type": "assessment_order",
      "pagination": "list_offset",
      "integration_name": "TalentLyft Assessment"
   },
   {
      "type": "method",
      "integration_type": "talentlyftassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_order",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TalentLyft Assessment"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors_lms",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "lms_class",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors_lms",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "lms_class",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "list_query",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "list_updated_gte",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "list_limit",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "list_offset",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "method",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "lms_class",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "method",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "lms_class",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforcemarketingcloud",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_list",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforcemarketingcloud",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_list",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_limit",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_offset",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_order",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_name",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_limit",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_offset",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "learnupon",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "list_query",
      "integration_name": "LearnUpon"
   },
   {
      "type": "pagination",
      "integration_type": "learnupon",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "list_offset",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "lms_course",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LearnUpon"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "crm_deal",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "crm_deal",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_offset",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_offset",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouseassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "object_type": "assessment_order",
      "pagination": "list_limit",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouseassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "object_type": "assessment_order",
      "pagination": "list_offset",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "method",
      "integration_type": "greenhouseassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "method",
      "integration_type": "greenhouseassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "method",
      "integration_type": "greenhouseassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "method",
      "integration_type": "greenhouseassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "method",
      "integration_type": "greenhouseassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "method",
      "integration_type": "greenhouseassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_order",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "method",
      "integration_type": "greenhouseassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_order",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "pagination",
      "integration_type": "firstadvantage",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "object_type": "verification_request",
      "pagination": "list_limit",
      "integration_name": "First Advantage"
   },
   {
      "type": "pagination",
      "integration_type": "firstadvantage",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "object_type": "verification_request",
      "pagination": "list_offset",
      "integration_name": "First Advantage"
   },
   {
      "type": "method",
      "integration_type": "firstadvantage",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "verification_package",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "First Advantage"
   },
   {
      "type": "method",
      "integration_type": "firstadvantage",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "First Advantage"
   },
   {
      "type": "method",
      "integration_type": "firstadvantage",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "First Advantage"
   },
   {
      "type": "pagination",
      "integration_type": "ashbyassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "object_type": "assessment_order",
      "pagination": "list_limit",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "pagination",
      "integration_type": "ashbyassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "object_type": "assessment_order",
      "pagination": "list_offset",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "method",
      "integration_type": "ashbyassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_order",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "method",
      "integration_type": "ashbyassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "method",
      "integration_type": "ashbyassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "method",
      "integration_type": "ashbyassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "method",
      "integration_type": "ashbyassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "method",
      "integration_type": "ashbyassessment",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "assessment_package",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_calendar",
      "pagination": "list_limit",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2026-02-18T23:13:26.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_calendar",
      "pagination": "list_offset",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "method",
      "integration_type": "acuityscheduling",
      "created_at": "2026-02-18T23:13:26.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "created_at": "2026-02-18T17:38:35.000Z",
      "categories": [
         "hris",
         "ats",
         "lms"
      ],
      "integration_type": "workday",
      "object_type": "lms_content",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "lms_content",
      "categories": [
         "hris",
         "ats",
         "lms"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "lms_content",
      "categories": [
         "hris",
         "ats",
         "lms"
      ],
      "method": "get",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "trinet",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2026-02-18T17:38:35.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_query",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2026-02-18T17:38:35.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "Ring Central"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "paylocity",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "created_at": "2026-02-18T17:38:35.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paylocity",
      "object_type": "hris_company",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "paycor",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "paycom",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "Paycom"
   },
   {
      "type": "method",
      "integration_type": "paycom",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycom"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paychex"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "HiBob"
   },
   {
      "type": "method",
      "integration_type": "hibob",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "deel",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deel"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "dayforce",
      "categories": [
         "hris",
         "ats"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "list",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "breathehr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "BreatheHR"
   },
   {
      "type": "method",
      "integration_type": "breathehr",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreatheHR"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-02-18T17:38:35.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_type",
      "integration_name": "Attio"
   },
   {
      "type": "object",
      "object_type": "hris_bankaccount",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-02-18T17:38:35.000Z",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2026-02-18T17:38:35.000Z",
      "object_type": "hris_bankaccount",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "integration",
      "created_at": "2026-02-18T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "stardex",
      "integration_name": "Stardex"
   },
   {
      "type": "integration",
      "created_at": "2026-02-18T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "joinwarp",
      "integration_name": "Warp"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "object",
      "created_at": "2026-02-17T07:53:52.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicssales",
      "object_type": "metadata_metadata",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-02-17T07:53:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "HiBob"
   },
   {
      "type": "integration",
      "created_at": "2026-02-17T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "granola",
      "integration_name": "Granola"
   },
   {
      "type": "integration",
      "created_at": "2026-02-17T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "go1",
      "integration_name": "Go1"
   },
   {
      "type": "integration",
      "created_at": "2026-02-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "exelare",
      "integration_name": "Exelare"
   },
   {
      "type": "integration",
      "created_at": "2026-02-17T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "eightfold",
      "integration_name": "Eightfold"
   },
   {
      "type": "integration",
      "created_at": "2026-02-17T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "apple",
      "integration_name": "Apple"
   },
   {
      "type": "integration",
      "created_at": "2026-02-16T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "talentlyft",
      "integration_name": "TalentLyft"
   },
   {
      "type": "integration",
      "created_at": "2026-02-15T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "thetradedesk",
      "integration_name": "The Trade Desk"
   },
   {
      "type": "integration",
      "created_at": "2026-02-15T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "googlecampaignmanager360",
      "integration_name": "Google Campaign Manager 360"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors_lms",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors_lms",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_activity",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors_lms",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors_lms",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_activity",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "object",
      "object_type": "lms_content",
      "integration_type": "successfactors_lms",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "object",
      "object_type": "lms_activity",
      "integration_type": "successfactors_lms",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "method",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "method",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "method",
      "integration_type": "successfactors_lms",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "object",
      "object_type": "lms_content",
      "integration_type": "linkedinlearning",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "method",
      "integration_type": "linkedinlearning",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "method",
      "integration_type": "linkedinlearning",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "object",
      "object_type": "lms_content",
      "integration_type": "learnupon",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "LearnUpon"
   },
   {
      "type": "object",
      "object_type": "lms_activity",
      "integration_type": "learnupon",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LearnUpon"
   },
   {
      "type": "method",
      "integration_type": "learnupon",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LearnUpon"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-13T15:18:10.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "list_list_id",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-13T15:18:10.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_campaign",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "googledrive",
      "created_at": "2026-02-13T15:18:10.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "native_webhook_parent_id",
      "integration_name": "Google Drive"
   },
   {
      "type": "object",
      "object_type": "lms_content",
      "integration_type": "googleclassroom",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "Google Classroom"
   },
   {
      "type": "object",
      "object_type": "lms_collection",
      "integration_type": "googleclassroom",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "Google Classroom"
   },
   {
      "type": "object",
      "object_type": "lms_activity",
      "integration_type": "googleclassroom",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "Google Classroom"
   },
   {
      "type": "method",
      "integration_type": "googleclassroom",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Classroom"
   },
   {
      "type": "method",
      "integration_type": "googleclassroom",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_collection",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Classroom"
   },
   {
      "type": "method",
      "integration_type": "googleclassroom",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Classroom"
   },
   {
      "type": "object",
      "object_type": "lms_content",
      "integration_type": "d2l",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "object",
      "object_type": "lms_collection",
      "integration_type": "d2l",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "object",
      "object_type": "lms_activity",
      "integration_type": "d2l",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "method",
      "integration_type": "d2l",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "method",
      "integration_type": "d2l",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_collection",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "method",
      "integration_type": "d2l",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "object",
      "object_type": "lms_content",
      "integration_type": "coursera",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "Coursera"
   },
   {
      "type": "object",
      "object_type": "lms_collection",
      "integration_type": "coursera",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "Coursera"
   },
   {
      "type": "object",
      "object_type": "lms_activity",
      "integration_type": "coursera",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2026-02-13T15:18:10.000Z",
      "integration_name": "Coursera"
   },
   {
      "type": "method",
      "integration_type": "coursera",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Coursera"
   },
   {
      "type": "method",
      "integration_type": "coursera",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_content",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Coursera"
   },
   {
      "type": "method",
      "integration_type": "coursera",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_collection",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Coursera"
   },
   {
      "type": "method",
      "integration_type": "coursera",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Coursera"
   },
   {
      "type": "method",
      "integration_type": "coursera",
      "created_at": "2026-02-13T15:18:10.000Z",
      "object_type": "lms_activity",
      "categories": [
         "lms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Coursera"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-02-13T11:45:02.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-02-13T11:45:02.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-02-13T11:45:02.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-02-13T11:45:02.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-02-13T11:45:02.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "asset_urls",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-02-13T11:45:02.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-02-13T11:45:02.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-02-13T11:45:02.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Ads"
   },
   {
      "type": "integration",
      "created_at": "2026-02-13T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "amazonsellercentral",
      "integration_name": "Amazon Seller Central"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "website_url",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "phone",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T17:43:31.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2026-02-12T15:15:06.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slack",
      "created_at": "2026-02-12T15:15:06.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "created_at": "2026-02-12T15:15:06.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "attio",
      "object_type": "metadata_metadata",
      "integration_name": "Attio"
   },
   {
      "type": "method",
      "integration_type": "attio",
      "created_at": "2026-02-12T15:15:06.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Attio"
   },
   {
      "type": "method",
      "integration_type": "attio",
      "created_at": "2026-02-12T15:15:06.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Attio"
   },
   {
      "type": "method",
      "integration_type": "attio",
      "created_at": "2026-02-12T15:15:06.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Attio"
   },
   {
      "type": "method",
      "integration_type": "attio",
      "created_at": "2026-02-12T15:15:06.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Attio"
   },
   {
      "type": "method",
      "integration_type": "attio",
      "created_at": "2026-02-12T15:15:06.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "webex",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Webex"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteamsbot",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft Teams (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteamsbot",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft Teams (bot)"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "imap",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging"
      ],
      "field": "parent_id",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "imap",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging"
      ],
      "field": "parent_id",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "discord",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2026-02-12T13:44:18.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "group",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2026-02-12T12:38:18.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_organization",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "myob",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "group",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2026-02-12T12:38:18.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "taxonomy",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T10:59:08.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T10:59:08.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2026-02-12T10:59:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "integration",
      "created_at": "2026-02-12T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "talentlyftassessment",
      "integration_name": "TalentLyft Assessment"
   },
   {
      "type": "integration",
      "created_at": "2026-02-12T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "recruiteeassessment",
      "integration_name": "Recruitee Assessment"
   },
   {
      "type": "integration",
      "created_at": "2026-02-12T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "cornerstoneassessment",
      "integration_name": "Cornerstone Assessment"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-02-11T20:42:56.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-02-11T20:42:56.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-02-11T20:42:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-02-11T20:42:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-02-11T20:42:56.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2026-02-11T20:42:56.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_item_id",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-02-11T17:17:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-02-11T17:17:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-11T16:31:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-11T16:31:20.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "assessment_order",
      "integration_type": "workableassessment",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "created_at": "2026-02-11T16:31:20.000Z",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "object",
      "object_type": "assessment_package",
      "integration_type": "workableassessment",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "created_at": "2026-02-11T16:31:20.000Z",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2026-02-11T16:31:20.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "assessment_order",
      "integration_type": "greenhouseassessment",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "created_at": "2026-02-11T16:31:20.000Z",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "object",
      "object_type": "assessment_package",
      "integration_type": "greenhouseassessment",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "created_at": "2026-02-11T16:31:20.000Z",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "pagination",
      "integration_type": "concur",
      "created_at": "2026-02-11T16:31:20.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_start_gte",
      "integration_name": "SAP Concur"
   },
   {
      "type": "pagination",
      "integration_type": "concur",
      "created_at": "2026-02-11T16:31:20.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_end_lt",
      "integration_name": "SAP Concur"
   },
   {
      "type": "pagination",
      "integration_type": "concur",
      "created_at": "2026-02-11T16:31:20.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "SAP Concur"
   },
   {
      "type": "pagination",
      "integration_type": "concur",
      "created_at": "2026-02-11T16:31:20.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "SAP Concur"
   },
   {
      "type": "object",
      "object_type": "assessment_order",
      "integration_type": "ashbyassessment",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "created_at": "2026-02-11T16:31:20.000Z",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "object",
      "object_type": "assessment_package",
      "integration_type": "ashbyassessment",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "created_at": "2026-02-11T16:31:20.000Z",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "zoom",
      "object_type": "calendar_calendar",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohomeeting",
      "object_type": "calendar_calendar",
      "integration_name": "Zoho Meeting"
   },
   {
      "type": "method",
      "integration_type": "zohomeeting",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Meeting"
   },
   {
      "type": "method",
      "integration_type": "zohomeeting",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Meeting"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "zohobooks",
      "object_type": "commerce_collection",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "integration_type": "xero",
      "object_type": "commerce_collection",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "squareup",
      "object_type": "calendar_calendar",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "squarespace",
      "object_type": "commerce_collection",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Squarespace"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "shipstation",
      "object_type": "commerce_collection",
      "integration_name": "ShipStation"
   },
   {
      "type": "method",
      "integration_type": "shipstation",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ShipStation"
   },
   {
      "type": "method",
      "integration_type": "shipstation",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ShipStation"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "savvycal",
      "object_type": "calendar_calendar",
      "integration_name": "SavvyCal"
   },
   {
      "type": "method",
      "integration_type": "savvycal",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SavvyCal"
   },
   {
      "type": "method",
      "integration_type": "savvycal",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SavvyCal"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "integration_type": "salsify",
      "object_type": "commerce_collection",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salsify"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "ringcentral",
      "object_type": "calendar_calendar",
      "integration_name": "Ring Central"
   },
   {
      "type": "method",
      "integration_type": "ringcentral",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ring Central"
   },
   {
      "type": "method",
      "integration_type": "ringcentral",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ring Central"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "integration_type": "quickbooks",
      "object_type": "commerce_collection",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "integration_type": "pennylane",
      "object_type": "commerce_collection",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pennylane"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "commerce",
         "passthrough"
      ],
      "integration_type": "paypal",
      "object_type": "commerce_collection",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paypal"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicscustomerengagement",
      "object_type": "task_project",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "messaging_channel",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Intercom"
   },
   {
      "type": "method",
      "integration_type": "intercom",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "integration_type": "holded",
      "object_type": "commerce_collection",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Holded"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "gitlab",
      "object_type": "repo_organization",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "repo_organization",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "repo_organization",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GitLab"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "integration_type": "fathom",
      "object_type": "calendar_calendar",
      "integration_name": "Fathom"
   },
   {
      "type": "method",
      "integration_type": "fathom",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Fathom"
   },
   {
      "type": "method",
      "integration_type": "fathom",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fathom"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "dialpad",
      "object_type": "calendar_calendar",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Dialpad"
   },
   {
      "type": "method",
      "integration_type": "dialpad",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "calendly",
      "object_type": "calendar_calendar",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Calendly"
   },
   {
      "type": "object",
      "created_at": "2026-02-11T12:19:52.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "bill",
      "object_type": "commerce_collection",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-02-11T12:19:52.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bill.com"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "integration_type": "yotpo",
      "object_type": "martech_list",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "sendfox",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SendFox"
   },
   {
      "type": "method",
      "integration_type": "sendfox",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SendFox"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "list_ids",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "integration_name": "Klaviyo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_query",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_updated_gte",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_limit",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_offset",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_order",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_name",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Klaviyo"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "integration_type": "keap",
      "object_type": "martech_list",
      "integration_name": "Keap"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T21:37:29.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "integration_type": "keap",
      "object_type": "martech_member",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Keap"
   },
   {
      "type": "writable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "customerio",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Customer.io"
   },
   {
      "type": "writable_field",
      "integration_type": "customerio",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "list_ids",
      "integration_name": "Customer.io"
   },
   {
      "type": "writable_field",
      "integration_type": "customerio",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Customer.io"
   },
   {
      "type": "method",
      "integration_type": "customerio",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Customer.io"
   },
   {
      "type": "method",
      "integration_type": "customerio",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Customer.io"
   },
   {
      "type": "method",
      "integration_type": "customerio",
      "created_at": "2026-02-10T21:37:29.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Customer.io"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contact_phone",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "slow_fields",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_call_id",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_call_id",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "slow_fields",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "slow_fields",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "hris_group",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "hris_company",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "hris_timeoff",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "linear",
      "object_type": "storage_file",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Linear"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "crm_deal",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "crm_pipeline",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_contact",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_contact",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_contact",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "integration_type": "hubspot",
      "object_type": "uc_call",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "integration_type": "hubspot",
      "object_type": "uc_recording",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2026-02-10T15:54:49.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "integration_type": "hubspot",
      "object_type": "uc_contact",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "uc",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "affinity",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Affinity"
   },
   {
      "type": "writable_field",
      "integration_type": "affinity",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Affinity"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Affinity"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2026-02-10T15:54:49.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Affinity"
   },
   {
      "type": "integration",
      "created_at": "2026-02-07T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "sap",
      "integration_name": "SAP S/4HANA Cloud"
   },
   {
      "type": "integration",
      "created_at": "2026-02-07T00:00:00.000Z",
      "categories": [
         "lms",
         "hris",
         "passthrough"
      ],
      "integration_type": "learnupon",
      "integration_name": "LearnUpon"
   },
   {
      "type": "integration",
      "created_at": "2026-02-07T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "ashbyassessment",
      "integration_name": "Ashby Assessment"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2026-02-06T14:31:52.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_offset",
      "integration_name": "SendGrid"
   },
   {
      "type": "object",
      "object_type": "martech_campaign",
      "integration_type": "sendgrid",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "SendGrid"
   },
   {
      "type": "object",
      "object_type": "martech_report",
      "integration_type": "sendgrid",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SendGrid"
   },
   {
      "type": "method",
      "integration_type": "sendgrid",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SendGrid"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "task",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "marketing_email",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "call",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "mailchimp",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "integration_name": "Mailchimp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "mailchimp",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "mailchimp",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2026-02-06T14:31:52.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Mailchimp"
   },
   {
      "type": "object",
      "object_type": "martech_campaign",
      "integration_type": "mailchimp",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "Mailchimp"
   },
   {
      "type": "object",
      "object_type": "martech_report",
      "integration_type": "mailchimp",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "Mailchimp"
   },
   {
      "type": "method",
      "integration_type": "mailchimp",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mailchimp"
   },
   {
      "type": "method",
      "integration_type": "mailchimp",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mailchimp"
   },
   {
      "type": "method",
      "integration_type": "mailchimp",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mailchimp"
   },
   {
      "type": "method",
      "integration_type": "mailchimp",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Mailchimp"
   },
   {
      "type": "method",
      "integration_type": "mailchimp",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Mailchimp"
   },
   {
      "type": "method",
      "integration_type": "mailchimp",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mailchimp"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "integration_name": "Klaviyo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "integration_name": "Klaviyo"
   },
   {
      "type": "object",
      "object_type": "martech_campaign",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "Klaviyo"
   },
   {
      "type": "object",
      "object_type": "martech_report",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "Klaviyo"
   },
   {
      "type": "method",
      "integration_type": "klaviyo",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Klaviyo"
   },
   {
      "type": "method",
      "integration_type": "klaviyo",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Klaviyo"
   },
   {
      "type": "method",
      "integration_type": "klaviyo",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Klaviyo"
   },
   {
      "type": "method",
      "integration_type": "klaviyo",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Klaviyo"
   },
   {
      "type": "method",
      "integration_type": "klaviyo",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Klaviyo"
   },
   {
      "type": "method",
      "integration_type": "klaviyo",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Klaviyo"
   },
   {
      "type": "method",
      "integration_type": "klaviyo",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "pagination",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_campaign_id",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "pagination",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_query",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "object",
      "object_type": "martech_campaign",
      "integration_type": "instantlyai",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "object",
      "object_type": "martech_report",
      "integration_type": "instantlyai",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "method",
      "integration_type": "instantlyai",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "customerio",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "integration_name": "Customer.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "customerio",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "integration_name": "Customer.io"
   },
   {
      "type": "pagination",
      "integration_type": "customerio",
      "created_at": "2026-02-06T14:31:52.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "slow_fields",
      "integration_name": "Customer.io"
   },
   {
      "type": "object",
      "object_type": "martech_campaign",
      "integration_type": "customerio",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "Customer.io"
   },
   {
      "type": "object",
      "object_type": "martech_report",
      "integration_type": "customerio",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "Customer.io"
   },
   {
      "type": "method",
      "integration_type": "customerio",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Customer.io"
   },
   {
      "type": "method",
      "integration_type": "customerio",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Customer.io"
   },
   {
      "type": "method",
      "integration_type": "customerio",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_report",
      "categories": [
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Customer.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "object",
      "object_type": "martech_campaign",
      "integration_type": "activecampaign",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "object",
      "object_type": "martech_report",
      "integration_type": "activecampaign",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-02-06T14:31:52.000Z",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_campaign",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "method",
      "integration_type": "activecampaign",
      "created_at": "2026-02-06T14:31:52.000Z",
      "object_type": "martech_report",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "integration",
      "created_at": "2026-02-06T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "workableassessment",
      "integration_name": "Workable Assessment"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-02-05T17:24:45.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "accounting_bill",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-02-05T17:24:45.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "accounting_salesorder",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "created_at": "2026-02-05T17:24:45.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2026-02-05T17:24:45.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-02-05T16:54:41.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-02-05T16:54:41.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-05T16:54:41.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "slow_fields",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-02-05T16:16:54.000Z",
      "object_type": "hris_group",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-02-05T16:16:54.000Z",
      "object_type": "hris_group",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-02-05T16:16:54.000Z",
      "object_type": "hris_group",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-02-05T16:16:54.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-02-05T13:26:01.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "slow_fields",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-02-05T13:26:01.000Z",
      "object_type": "ats_interview",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-02-05T13:26:01.000Z",
      "object_type": "ats_interview",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2026-02-05T13:26:01.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2026-02-05T13:26:01.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2026-02-05T13:26:01.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2026-02-05T13:26:01.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-02-05T10:59:11.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-05T10:59:11.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "payment_method",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "payment_method",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_sort_by_created_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_limit",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_offset",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_limit",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-02-04T16:20:46.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QuickBooks"
   },
   {
      "type": "integration",
      "created_at": "2026-02-04T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "crm",
         "passthrough"
      ],
      "integration_type": "boondmanager",
      "integration_name": "BoondManager"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-02-03T17:58:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "subgroup",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-02-03T17:58:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "section",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2026-02-03T17:58:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "group",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-02-03T13:44:01.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-02-03T13:44:01.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-02-03T13:44:01.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-02-03T13:44:01.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-02-03T13:44:01.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-02-03T13:44:01.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-02-03T13:44:01.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "payment_methods",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_order",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_order",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_order",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_start_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_end_lt",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_order",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_contact_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_order",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_itemvariant",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_offset",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_contact_id",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2026-02-03T09:28:57.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2026-02-03T09:28:57.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2026-02-03T09:28:57.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2026-02-03T09:28:57.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2026-02-03T09:28:57.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "apollo",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "Apollo.io"
   },
   {
      "type": "pagination",
      "integration_type": "apollo",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_limit",
      "integration_name": "Apollo.io"
   },
   {
      "type": "pagination",
      "integration_type": "apollo",
      "created_at": "2026-02-03T09:28:57.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_offset",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2026-02-03T09:28:57.000Z",
      "object_type": "crm_event",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apollo.io"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "crm_contact",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "crm_company",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "crm_deal",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "crm_contact",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "crm_company",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "crm_deal",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "hris_employee",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "crm_contact",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "crm_company",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-31T19:03:56.000Z",
      "object_type": "crm_deal",
      "integration_name": "Attio"
   },
   {
      "type": "object",
      "created_at": "2026-01-30T17:07:11.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "vincere",
      "object_type": "crm_event",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Calendly"
   },
   {
      "type": "writable_field",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Calendly"
   },
   {
      "type": "writable_field",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "organizer",
      "integration_name": "Calendly"
   },
   {
      "type": "writable_field",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Calendly"
   },
   {
      "type": "writable_field",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Calendly"
   },
   {
      "type": "writable_field",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "calendar_id",
      "integration_name": "Calendly"
   },
   {
      "type": "writable_field",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "attendees",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2026-01-30T17:07:11.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2026-01-30T13:25:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "created_at": "2026-01-30T13:25:00.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "apollo",
      "object_type": "crm_event",
      "integration_name": "Apollo.io"
   },
   {
      "type": "object",
      "object_type": "calendar_webinar",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoom"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Webex"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Webex"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Webex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Webex"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Webex"
   },
   {
      "type": "object",
      "object_type": "calendar_webinar",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Webex"
   },
   {
      "type": "method",
      "integration_type": "webex",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Webex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "calendar_webinar",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "calendar_webinar",
      "integration_type": "goto",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "created_at": "2026-01-30T09:44:32.000Z",
      "integration_name": "GoTO"
   },
   {
      "type": "method",
      "integration_type": "goto",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GoTO"
   },
   {
      "type": "method",
      "integration_type": "goto",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GoTO"
   },
   {
      "type": "method",
      "integration_type": "goto",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "GoTO"
   },
   {
      "type": "method",
      "integration_type": "goto",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "GoTO"
   },
   {
      "type": "method",
      "integration_type": "goto",
      "created_at": "2026-01-30T09:44:32.000Z",
      "object_type": "calendar_webinar",
      "categories": [
         "uc",
         "hris",
         "auth",
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GoTO"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_account",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_account",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_account",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "created_at": "2026-01-29T17:02:04.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "stripe",
      "object_type": "accounting_account",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "created_at": "2026-01-29T17:02:04.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "stripe",
      "object_type": "accounting_creditmemo",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "created_at": "2026-01-29T17:02:04.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "stripe",
      "object_type": "accounting_transaction",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_account",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_account",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-01-29T17:02:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_limit",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-01-29T17:02:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_offset",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-01-29T17:02:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_group_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-01-29T17:02:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_campaign_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "pagination",
      "integration_type": "linkedin",
      "created_at": "2026-01-29T17:02:04.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "object_type": "ads_creative",
      "pagination": "list_org_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "headline",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "final_url",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-29T17:02:04.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Ads"
   },
   {
      "type": "integration",
      "created_at": "2026-01-29T00:00:00.000Z",
      "categories": [
         "assessment",
         "passthrough"
      ],
      "integration_type": "greenhouseassessment",
      "integration_name": "Greenhouse Assessment"
   },
   {
      "type": "integration",
      "created_at": "2026-01-27T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "kustomer",
      "integration_name": "Kustomer"
   },
   {
      "type": "integration",
      "created_at": "2026-01-26T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "concur",
      "integration_name": "SAP Concur"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wealthbox",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-25T10:27:30.000Z",
      "object_type": "hris_employee",
      "integration_name": "Wealthbox"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wealthbox",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-25T10:27:30.000Z",
      "object_type": "hris_group",
      "integration_name": "Wealthbox"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wealthbox",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-25T10:27:30.000Z",
      "object_type": "hris_employee",
      "integration_name": "Wealthbox"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wealthbox",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-25T10:27:30.000Z",
      "object_type": "hris_group",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_query",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_limit",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_offset",
      "integration_name": "Wealthbox"
   },
   {
      "type": "pagination",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_type",
      "integration_name": "Wealthbox"
   },
   {
      "type": "method",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wealthbox"
   },
   {
      "type": "method",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wealthbox"
   },
   {
      "type": "method",
      "integration_type": "wealthbox",
      "created_at": "2026-01-25T10:27:30.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "hris",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wealthbox"
   },
   {
      "type": "readable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-25T10:03:30.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "pagination",
      "integration_type": "zohomail",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_order",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "pagination",
      "integration_type": "zohomail",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shipstation",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-25T10:03:30.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "ShipStation"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shipstation",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-25T10:03:30.000Z",
      "object_type": "shipping_tracking",
      "integration_name": "ShipStation"
   },
   {
      "type": "pagination",
      "integration_type": "shipstation",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "list_updated_gte",
      "integration_name": "ShipStation"
   },
   {
      "type": "pagination",
      "integration_type": "shipstation",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "list_limit",
      "integration_name": "ShipStation"
   },
   {
      "type": "pagination",
      "integration_type": "shipstation",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "list_offset",
      "integration_name": "ShipStation"
   },
   {
      "type": "pagination",
      "integration_type": "shipstation",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ShipStation"
   },
   {
      "type": "pagination",
      "integration_type": "shipstation",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "shipping_tracking",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ShipStation"
   },
   {
      "type": "pagination",
      "integration_type": "shipstation",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "shipping_rate",
      "pagination": "list_limit",
      "integration_name": "ShipStation"
   },
   {
      "type": "pagination",
      "integration_type": "shipstation",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "shipping_rate",
      "pagination": "list_offset",
      "integration_name": "ShipStation"
   },
   {
      "type": "method",
      "integration_type": "shipstation",
      "created_at": "2026-01-25T10:03:30.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ShipStation"
   },
   {
      "type": "pagination",
      "integration_type": "shippo",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "object_type": "shipping_rate",
      "pagination": "list_limit",
      "integration_name": "Shippo"
   },
   {
      "type": "pagination",
      "integration_type": "shippo",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "object_type": "shipping_rate",
      "pagination": "list_offset",
      "integration_name": "Shippo"
   },
   {
      "type": "method",
      "integration_type": "shippo",
      "created_at": "2026-01-25T10:03:30.000Z",
      "object_type": "shipping_rate",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shippo"
   },
   {
      "type": "method",
      "integration_type": "shippo",
      "created_at": "2026-01-25T10:03:30.000Z",
      "object_type": "shipping_rate",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shippo"
   },
   {
      "type": "method",
      "integration_type": "shippo",
      "created_at": "2026-01-25T10:03:30.000Z",
      "object_type": "shipping_rate",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Shippo"
   },
   {
      "type": "method",
      "integration_type": "shippo",
      "created_at": "2026-01-25T10:03:30.000Z",
      "object_type": "shipping_rate",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Shippo"
   },
   {
      "type": "pagination",
      "integration_type": "easypost",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_rate",
      "pagination": "list_limit",
      "integration_name": "EasyPost"
   },
   {
      "type": "pagination",
      "integration_type": "easypost",
      "created_at": "2026-01-25T10:03:30.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "object_type": "shipping_rate",
      "pagination": "list_offset",
      "integration_name": "EasyPost"
   },
   {
      "type": "integration",
      "created_at": "2026-01-24T00:00:00.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "wealthbox",
      "integration_name": "Wealthbox"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "hris_employee",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "hris_employee",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2026-01-23T18:45:10.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "hris_employee",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "goal",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "creative_ids",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "goal",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "creative_ids",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "object",
      "created_at": "2026-01-23T18:45:10.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "tiktokads",
      "object_type": "ads_creative",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "cancelled_at",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-23T18:45:10.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "cancelled_at",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "integration",
      "created_at": "2026-01-23T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "usps",
      "integration_name": "USPS"
   },
   {
      "type": "integration",
      "created_at": "2026-01-23T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "ups",
      "integration_name": "UPS"
   },
   {
      "type": "integration",
      "created_at": "2026-01-23T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "sendcloud",
      "integration_name": "Sendcloud"
   },
   {
      "type": "integration",
      "created_at": "2026-01-23T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "fedex",
      "integration_name": "FedEx"
   },
   {
      "type": "integration",
      "created_at": "2026-01-23T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "dhl",
      "integration_name": "DHL"
   },
   {
      "type": "integration",
      "created_at": "2026-01-23T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "canadapost",
      "integration_name": "Canada Post"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "object",
      "object_type": "ads_creative",
      "integration_type": "twitterads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "method",
      "integration_type": "twitterads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "final_url",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "ad_copy",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "method",
      "integration_type": "tiktokads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "headline",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "final_url",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "ad_copy",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "object",
      "object_type": "ads_creative",
      "integration_type": "redditads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "headline",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "final_url",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "ad_copy",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "object",
      "object_type": "ads_creative",
      "integration_type": "pinterestads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "method",
      "integration_type": "pinterestads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "outreach",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Outreach.io"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "headline",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "final_url",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "ad_copy",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "object",
      "object_type": "ads_creative",
      "integration_type": "microsoftads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "method",
      "integration_type": "microsoftads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "goal",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "creative_ids",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "Meta Ads"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "integration_name": "Meta Ads"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "goal",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "creative_ids",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "object_type": "ads_creative",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Meta Ads"
   },
   {
      "type": "method",
      "integration_type": "metaads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Meta Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "targeting",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "headline",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "final_url",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "cta",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "creative_asset_url",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "ad_copy",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "LinkedIn"
   },
   {
      "type": "readable_field",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "object_type": "ads_creative",
      "integration_type": "linkedin",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "LinkedIn"
   },
   {
      "type": "writable_field",
      "integration_type": "insightly",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Insightly"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "planned_spend_amount",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "pacing",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "insertionorder_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "has_eu_political_ads",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "goal",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "frequency_cap",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "frequency_cap",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "creative_ids",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_unit",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_max_amount",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_allocation_type",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "bid_strategy",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "planned_spend_amount",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "pacing",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "insertionorder_id",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "has_eu_political_ads",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "goal",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "frequency_cap",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "frequency_cap",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "creative_ids",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_unit",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_max_amount",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "budget_allocation_type",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "bid_strategy",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "object",
      "object_type": "ads_creative",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "object",
      "object_type": "ads_insertionorder",
      "integration_type": "googledv360",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_insertionorder",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_insertionorder",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_insertionorder",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_insertionorder",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_insertionorder",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "googleads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Google Ads"
   },
   {
      "type": "object",
      "object_type": "ads_creative",
      "integration_type": "googleads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Ads"
   },
   {
      "type": "method",
      "integration_type": "googleads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "organization_id",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "item_id",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "group_id",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "campaign_id",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_period",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "budget_amount",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "writable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "bid_amount",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "field": "item_id",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "object",
      "object_type": "ads_creative",
      "integration_type": "amazonads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2026-01-22T19:40:52.000Z",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "method",
      "integration_type": "amazonads",
      "created_at": "2026-01-22T19:40:52.000Z",
      "object_type": "ads_creative",
      "categories": [
         "ads",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "pagination",
      "integration_type": "8x8xcaas",
      "created_at": "2026-01-22T19:40:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_query",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "integration",
      "created_at": "2026-01-22T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "harri",
      "integration_name": "Harri"
   },
   {
      "type": "readable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "accounting_creditmemo",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "object_type": "accounting_bill",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "object_type": "accounting_salesorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "object",
      "created_at": "2026-01-21T17:54:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "mercuryats",
      "object_type": "crm_event",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemeet",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "organizer",
      "integration_name": "Google Meet"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemeet",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Google Meet"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecalendar",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "organizer",
      "integration_name": "Google Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecalendar",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Google Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "google",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "organizer",
      "integration_name": "Google"
   },
   {
      "type": "readable_field",
      "integration_type": "google",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Google"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2026-01-21T17:54:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Attio"
   },
   {
      "type": "object",
      "created_at": "2026-01-20T17:10:09.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "mailchimp",
      "object_type": "passthrough",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2026-01-20T15:39:18.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2026-01-20T15:39:18.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "googledv360",
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "ads_report",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_contact",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_lead",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_company",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_deal",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_contact",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_lead",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_company",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "attio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_deal",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2026-01-20T13:13:05.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Attio"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2026-01-20T13:13:05.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Apollo.io"
   },
   {
      "type": "integration",
      "created_at": "2026-01-20T00:00:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "zoomcalendar",
      "integration_name": "Zoom Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm"
      ],
      "field": "stages",
      "integration_name": "Salesflare"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_start_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_end_lt",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_category_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "list_group_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "writable_field",
      "integration_type": "keap",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Keap"
   },
   {
      "type": "writable_field",
      "integration_type": "insightly",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Insightly"
   },
   {
      "type": "writable_field",
      "integration_type": "insightly",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Insightly"
   },
   {
      "type": "writable_field",
      "integration_type": "insightly",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Insightly"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Gem"
   },
   {
      "type": "object",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "gem",
      "object_type": "ats_interview",
      "integration_name": "Gem"
   },
   {
      "type": "object",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "gem",
      "object_type": "ats_scorecard",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gainsight",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "hris_employee",
      "integration_name": "Gainsight"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gainsight",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_task",
      "integration_name": "Gainsight"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gainsight",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_project",
      "integration_name": "Gainsight"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gainsight",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "hris_employee",
      "integration_name": "Gainsight"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gainsight",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_task",
      "integration_name": "Gainsight"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gainsight",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_project",
      "integration_name": "Gainsight"
   },
   {
      "type": "object",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "gainsight",
      "object_type": "hris_employee",
      "integration_name": "Gainsight"
   },
   {
      "type": "object",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "gainsight",
      "object_type": "task_task",
      "integration_name": "Gainsight"
   },
   {
      "type": "object",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "gainsight",
      "object_type": "task_project",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gainsight"
   },
   {
      "type": "method",
      "integration_type": "gainsight",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "bunny",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Bunny.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bunny",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Bunny.com"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Attio"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "asana",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_comment",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "asana",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_comment",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "asana",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "task_comment",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "native_webhook_task_id",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "apollo",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Apollo.io"
   },
   {
      "type": "writable_field",
      "integration_type": "apollo",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Apollo.io"
   },
   {
      "type": "object",
      "created_at": "2026-01-19T15:15:41.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "apollo",
      "object_type": "crm_pipeline",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "Affinity"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2026-01-19T15:15:41.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "pipelines",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "integration",
      "created_at": "2026-01-15T00:00:00.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "googledv360",
      "integration_name": "Google Display & Video 360"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-01-14T19:58:49.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_limit",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2026-01-14T19:58:49.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_offset",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-01-14T18:52:48.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_profitloss",
      "pagination": "slow_fields",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2026-01-14T18:52:48.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_trialbalance",
      "pagination": "slow_fields",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "WooCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "wayfair",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Wayfair"
   },
   {
      "type": "readable_field",
      "integration_type": "wayfair",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Wayfair"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Wave"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "walmart",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "chargebee",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Chargebee"
   },
   {
      "type": "readable_field",
      "integration_type": "chargebee",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Chargebee"
   },
   {
      "type": "readable_field",
      "integration_type": "bunny",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Bunny.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bunny",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "crm_contact",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Bunny.com"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2026-01-14T18:52:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "collection_ids",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "slackbot",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "messaging_event",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "message",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "writable_field",
      "integration_type": "slackbot",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "messaging_event",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_replacing_original",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "messaging_event",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "object",
      "object_type": "shipping_shipment",
      "integration_type": "shipstation",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "ShipStation"
   },
   {
      "type": "object",
      "object_type": "shipping_label",
      "integration_type": "shipstation",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "ShipStation"
   },
   {
      "type": "object",
      "object_type": "shipping_tracking",
      "integration_type": "shipstation",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "ShipStation"
   },
   {
      "type": "object",
      "object_type": "shipping_rate",
      "integration_type": "shipstation",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "ShipStation"
   },
   {
      "type": "object",
      "object_type": "shipping_carrier",
      "integration_type": "shipstation",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "ShipStation"
   },
   {
      "type": "object",
      "object_type": "shipping_shipment",
      "integration_type": "shippo",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "Shippo"
   },
   {
      "type": "object",
      "object_type": "shipping_label",
      "integration_type": "shippo",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "Shippo"
   },
   {
      "type": "object",
      "object_type": "shipping_tracking",
      "integration_type": "shippo",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "Shippo"
   },
   {
      "type": "object",
      "object_type": "shipping_rate",
      "integration_type": "shippo",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "Shippo"
   },
   {
      "type": "object",
      "object_type": "shipping_carrier",
      "integration_type": "shippo",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "Shippo"
   },
   {
      "type": "object",
      "object_type": "shipping_shipment",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "shipping_tracking",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "shipping_shipment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "shipping_tracking",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "shipping",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "shipping_shipment",
      "integration_type": "easypost",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "EasyPost"
   },
   {
      "type": "object",
      "object_type": "shipping_label",
      "integration_type": "easypost",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "EasyPost"
   },
   {
      "type": "object",
      "object_type": "shipping_tracking",
      "integration_type": "easypost",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "EasyPost"
   },
   {
      "type": "object",
      "object_type": "shipping_rate",
      "integration_type": "easypost",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "EasyPost"
   },
   {
      "type": "object",
      "object_type": "shipping_carrier",
      "integration_type": "easypost",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "created_at": "2026-01-14T11:48:51.000Z",
      "integration_name": "EasyPost"
   },
   {
      "type": "writable_field",
      "integration_type": "discord",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "reactions",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "reactions",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-01-14T11:48:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "compensation",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "integration",
      "created_at": "2026-01-14T00:00:00.000Z",
      "categories": [
         "shipping",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "shipstation",
      "integration_name": "ShipStation"
   },
   {
      "type": "integration",
      "created_at": "2026-01-14T00:00:00.000Z",
      "categories": [
         "shipping",
         "commerce",
         "passthrough"
      ],
      "integration_type": "shippo",
      "integration_name": "Shippo"
   },
   {
      "type": "integration",
      "created_at": "2026-01-14T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "goco",
      "integration_name": "Intuit GoCo"
   },
   {
      "type": "integration",
      "created_at": "2026-01-14T00:00:00.000Z",
      "categories": [
         "shipping",
         "passthrough"
      ],
      "integration_type": "easypost",
      "integration_name": "EasyPost"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2026-01-13T19:55:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2026-01-13T19:55:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "slow_fields",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "root_message_id",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "parent_message_id",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "message_html",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "message",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "mentioned_members",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "hidden_members",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "destination_members",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "channel_id",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "author_member",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "method",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "method",
      "integration_type": "zohomail",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "yotpo",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "yotpo"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "yotpo",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "yotpo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "WooCommerce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "WooCommerce"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "woocommerce",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "WooCommerce"
   },
   {
      "type": "method",
      "integration_type": "woocommerce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "WooCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "wayfair",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Wayfair"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "wayfair",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wayfair"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Wave"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Wave"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Wave"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "relationships",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "SquareUp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SquareUp"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "squarespace",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Squarespace"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "squarespace",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Squarespace"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "squarespace",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Squarespace"
   },
   {
      "type": "method",
      "integration_type": "squarespace",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Squarespace"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "Seven20",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "Seven20"
   },
   {
      "type": "pagination",
      "integration_type": "Seven20",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "subsection",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "subgroup",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "section",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "is_payable",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "group",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "slow_fields",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "slow_fields",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "document_ids",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "document_ids",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Personio"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "Pennylane"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "pennylane",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Pennylane"
   },
   {
      "type": "object",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "integration_type": "pennylane",
      "object_type": "accounting_taxrate",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "odoo",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Odoo"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "myob",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "keap",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Keap"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "keap",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Keap"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "keap",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Keap"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Holded"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "holded",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Holded"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "application_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_updated_gte",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Gladly"
   },
   {
      "type": "writable_field",
      "integration_type": "eploy",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Eploy"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "relationships",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "last_name",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "first_name",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "relationships",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "ClickUp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2026-01-09T18:39:24.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Clear Company"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "bunny",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Bunny.com"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "boldcommerce",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "method",
      "integration_type": "boldcommerce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "method",
      "integration_type": "boldcommerce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "Bill.com"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bigcommerce",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "BigCommerce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bigcommerce",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "integration_name": "BigCommerce"
   },
   {
      "type": "object",
      "object_type": "commerce_itemvariant",
      "integration_type": "bigcommerce",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-09T18:39:24.000Z",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2026-01-09T18:39:24.000Z",
      "object_type": "commerce_itemvariant",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "locations",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recommendation",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "departments",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-01-08T09:25:51.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "ats_activity",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-01-08T09:25:51.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "hris_company",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-01-08T09:25:51.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "hris_location",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-01-08T09:25:51.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "hris_payslip",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-01-08T09:25:51.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "hris_timeoff",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2026-01-08T09:25:51.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "hris_group",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "strongdm",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "ServiceNow"
   },
   {
      "type": "writable_field",
      "integration_type": "scoro",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "scoro",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth"
      ],
      "field": "locations",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ramp",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Ramp"
   },
   {
      "type": "readable_field",
      "integration_type": "ramp",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Ramp"
   },
   {
      "type": "readable_field",
      "integration_type": "prismhr",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "PrismHR"
   },
   {
      "type": "writable_field",
      "integration_type": "plusplus",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "PlusPlus"
   },
   {
      "type": "readable_field",
      "integration_type": "plusplus",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "PlusPlus"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Phenom"
   },
   {
      "type": "writable_field",
      "integration_type": "peopleforce",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "PeopleForce"
   },
   {
      "type": "readable_field",
      "integration_type": "peopleforce",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "PeopleForce"
   },
   {
      "type": "writable_field",
      "integration_type": "peakon",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "peakon",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "odoo",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Odoo"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Monday"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftintune",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "leapsome",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Leapsome"
   },
   {
      "type": "writable_field",
      "integration_type": "lattice",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2026-01-08T09:25:51.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "kandji",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "writable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "jumpcloud",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "JumpCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jamf",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Jamf"
   },
   {
      "type": "writable_field",
      "integration_type": "ironclad",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "ironclad",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humanforce",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Humanforce"
   },
   {
      "type": "writable_field",
      "integration_type": "hrcloud",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "HR Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "hrcloud",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "HR Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecloudplatform",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Google Cloud Platform"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "foundU"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Engagedly"
   },
   {
      "type": "writable_field",
      "integration_type": "enboarder",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "enboarder",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "dropbox",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Dropbox"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Deel"
   },
   {
      "type": "writable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "circle",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Circle.so"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "locations",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "15five",
      "created_at": "2026-01-08T09:25:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "15Five"
   },
   {
      "type": "integration",
      "created_at": "2026-01-08T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "peoplehr",
      "integration_name": "PeopleHR"
   },
   {
      "type": "method",
      "integration_type": "zohomail",
      "created_at": "2026-01-07T11:18:37.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2026-01-07T11:18:37.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "GitHub"
   },
   {
      "type": "integration",
      "created_at": "2026-01-07T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "quo",
      "integration_name": "QUO"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gainsight",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_contact",
      "integration_name": "Gainsight"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gainsight",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_contact",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Gainsight"
   },
   {
      "type": "pagination",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Gainsight"
   },
   {
      "type": "pagination",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_order",
      "integration_name": "Gainsight"
   },
   {
      "type": "pagination",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gainsight"
   },
   {
      "type": "pagination",
      "integration_type": "gainsight",
      "created_at": "2026-01-06T14:26:55.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gainsight"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "typeform",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "forms_form",
      "integration_name": "Typeform"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "typeform",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "forms_form",
      "integration_name": "Typeform"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "typeform",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "forms_submission",
      "integration_name": "Typeform"
   },
   {
      "type": "object",
      "object_type": "forms_form",
      "integration_type": "typeform",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-05T11:34:10.000Z",
      "integration_name": "Typeform"
   },
   {
      "type": "object",
      "object_type": "forms_submission",
      "integration_type": "typeform",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-05T11:34:10.000Z",
      "integration_name": "Typeform"
   },
   {
      "type": "method",
      "integration_type": "typeform",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Typeform"
   },
   {
      "type": "method",
      "integration_type": "typeform",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "forms_form",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Typeform"
   },
   {
      "type": "method",
      "integration_type": "typeform",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "forms_submission",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Typeform"
   },
   {
      "type": "object",
      "object_type": "forms_form",
      "integration_type": "tally",
      "categories": [
         "forms",
         "passthrough"
      ],
      "created_at": "2026-01-05T11:34:10.000Z",
      "integration_name": "Tally"
   },
   {
      "type": "object",
      "object_type": "forms_submission",
      "integration_type": "tally",
      "categories": [
         "forms",
         "passthrough"
      ],
      "created_at": "2026-01-05T11:34:10.000Z",
      "integration_name": "Tally"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2026-01-05T11:34:10.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_expand",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2026-01-05T11:34:10.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2026-01-05T11:34:10.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_expand",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2026-01-05T11:34:10.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "prismhr",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "PrismHR"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paychex",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Paychex"
   },
   {
      "type": "readable_field",
      "integration_type": "namely",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Namely"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Humi"
   },
   {
      "type": "object",
      "object_type": "forms_form",
      "integration_type": "googleforms",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-05T11:34:10.000Z",
      "integration_name": "Google Forms"
   },
   {
      "type": "object",
      "object_type": "forms_submission",
      "integration_type": "googleforms",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "created_at": "2026-01-05T11:34:10.000Z",
      "integration_name": "Google Forms"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "employmentheropayroll",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "termination_reason",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "writable_field",
      "integration_type": "anthropicclaude",
      "created_at": "2026-01-05T11:34:10.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "mcp_deferred_tools",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "integration",
      "created_at": "2026-01-03T00:00:00.000Z",
      "categories": [
         "forms",
         "passthrough"
      ],
      "integration_type": "tally",
      "integration_name": "Tally"
   },
   {
      "type": "integration",
      "created_at": "2026-01-03T00:00:00.000Z",
      "categories": [
         "forms",
         "auth",
         "passthrough"
      ],
      "integration_type": "googleforms",
      "integration_name": "Google Forms"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "redditads",
      "object_type": "ads_organization",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "redditads",
      "object_type": "ads_campaign",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "redditads",
      "object_type": "ads_group",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "redditads",
      "object_type": "ads_ad",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "redditads",
      "object_type": "ads_report",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "method",
      "integration_type": "redditads",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_report",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "linkedin",
      "object_type": "ads_organization",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "linkedin",
      "object_type": "ads_campaign",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "linkedin",
      "object_type": "ads_group",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "linkedin",
      "object_type": "ads_ad",
      "integration_name": "LinkedIn"
   },
   {
      "type": "object",
      "created_at": "2026-01-01T23:27:33.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "linkedin",
      "object_type": "ads_report",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_organization",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_campaign",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_group",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_ad",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "method",
      "integration_type": "linkedin",
      "created_at": "2026-01-01T23:27:33.000Z",
      "object_type": "ads_report",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "LinkedIn"
   },
   {
      "type": "integration",
      "created_at": "2026-01-01T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "pinterestads",
      "integration_name": "Pinterest Ads"
   },
   {
      "type": "integration",
      "created_at": "2026-01-01T00:00:00.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftads",
      "integration_name": "Microsoft Advertising"
   },
   {
      "type": "integration",
      "created_at": "2026-01-01T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "amazonads",
      "integration_name": "Amazon Advertising"
   },
   {
      "type": "readable_field",
      "integration_type": "zohomail",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "created_at": "2025-12-31T12:54:45.000Z",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "trello",
      "object_type": "hris_employee",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "storage",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trello"
   },
   {
      "type": "object",
      "object_type": "ads_organization",
      "integration_type": "tiktokads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "object",
      "object_type": "ads_campaign",
      "integration_type": "tiktokads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "object",
      "object_type": "ads_group",
      "integration_type": "tiktokads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "object",
      "object_type": "ads_ad",
      "integration_type": "tiktokads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "object",
      "object_type": "ads_report",
      "integration_type": "tiktokads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "snowflake",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "Snowflake"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "ServiceNow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "closing_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "object",
      "object_type": "ads_organization",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "object_type": "ads_campaign",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "object_type": "ads_group",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "object_type": "ads_ad",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Meta Ads"
   },
   {
      "type": "object",
      "object_type": "ads_report",
      "integration_type": "metaads",
      "categories": [
         "ads",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Meta Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "heroku",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "Heroku"
   },
   {
      "type": "object",
      "object_type": "ads_organization",
      "integration_type": "googleads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Google Ads"
   },
   {
      "type": "object",
      "object_type": "ads_campaign",
      "integration_type": "googleads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Google Ads"
   },
   {
      "type": "object",
      "object_type": "ads_group",
      "integration_type": "googleads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Google Ads"
   },
   {
      "type": "object",
      "object_type": "ads_ad",
      "integration_type": "googleads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Google Ads"
   },
   {
      "type": "object",
      "object_type": "ads_report",
      "integration_type": "googleads",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-31T12:54:45.000Z",
      "integration_name": "Google Ads"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "dashlane",
      "created_at": "2025-12-31T12:54:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "has_mfa",
      "integration_name": "Dashlane"
   },
   {
      "type": "integration",
      "created_at": "2025-12-31T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "twitterads",
      "integration_name": "X Ads (Twitter Ads)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-12-30T20:02:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-12-30T20:02:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "integration",
      "created_at": "2025-12-30T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "tiktokads",
      "integration_name": "TikTok Ads"
   },
   {
      "type": "integration",
      "created_at": "2025-12-30T00:00:00.000Z",
      "categories": [
         "ads",
         "passthrough"
      ],
      "integration_type": "metaads",
      "integration_name": "Meta Ads"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-29T11:53:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-29T11:53:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-29T11:53:51.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "ats_company",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "certn",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "verification_request",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "parameters",
      "integration_name": "Certn"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "verification_package",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "valid_regions",
      "integration_name": "Certn"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "verification_package",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "parameters",
      "integration_name": "Certn"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "verification_package",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "has_target_url",
      "integration_name": "Certn"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2025-12-29T11:53:51.000Z",
      "object_type": "verification_package",
      "categories": [
         "verification",
         "passthrough"
      ],
      "field": "aliases",
      "integration_name": "Certn"
   },
   {
      "type": "integration",
      "created_at": "2025-12-29T00:00:00.000Z",
      "categories": [
         "ads",
         "auth",
         "passthrough"
      ],
      "integration_type": "googleads",
      "integration_name": "Google Ads"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-12-24T10:14:43.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-12-24T10:14:43.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-12-24T10:14:43.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-12-24T10:14:43.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "keap",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_company",
      "integration_name": "Keap"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "keap",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_company",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Keap"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_company",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_lead",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "hris_employee",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_contact",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_deal",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_company",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_lead",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "hris_employee",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_contact",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "insightly",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "crm_deal",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-12-22T13:25:01.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "ats_job",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "ats_candidate",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "ats_application",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "ats_job",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "ats_candidate",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-22T13:25:01.000Z",
      "object_type": "ats_application",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_company",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_company",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "object",
      "created_at": "2025-12-19T15:28:32.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "crm_contact",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "object",
      "created_at": "2025-12-19T15:28:32.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "crm_company",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "object",
      "created_at": "2025-12-19T15:28:32.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "crm_event",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "auth",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "JobDiva"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_lead",
      "integration_name": "JobDiva"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_event",
      "integration_name": "JobDiva"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_lead",
      "integration_name": "JobDiva"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_event",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "JobDiva"
   },
   {
      "type": "object",
      "created_at": "2025-12-19T15:28:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobdiva",
      "object_type": "crm_lead",
      "integration_name": "JobDiva"
   },
   {
      "type": "object",
      "created_at": "2025-12-19T15:28:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobdiva",
      "object_type": "crm_contact",
      "integration_name": "JobDiva"
   },
   {
      "type": "object",
      "created_at": "2025-12-19T15:28:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobdiva",
      "object_type": "crm_company",
      "integration_name": "JobDiva"
   },
   {
      "type": "object",
      "created_at": "2025-12-19T15:28:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobdiva",
      "object_type": "crm_event",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2025-12-19T15:28:32.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "bullhorn",
      "object_type": "ats_applicationstatus",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2025-12-19T15:28:32.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-12-17T14:07:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-12-17T14:07:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-12-17T14:07:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "slackbot",
      "created_at": "2025-12-16T20:43:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "destination_members",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "writable_field",
      "integration_type": "slackbot",
      "created_at": "2025-12-16T20:43:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "buttons",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "slackbot",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-16T20:43:31.000Z",
      "object_type": "messaging_event",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-12-16T20:43:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "buttons",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "object",
      "object_type": "messaging_event",
      "integration_type": "slackbot",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-16T20:43:31.000Z",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2025-12-16T20:43:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "destination_members",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2025-12-16T20:43:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "buttons",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-12-16T20:43:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "buttons",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-12-16T20:43:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "buttons",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-12-16T20:43:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "buttons",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "relationships",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "relationships",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "prismhr",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "relationships",
      "integration_name": "PrismHR"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Paycor"
   },
   {
      "type": "writable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "net_amount",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "details",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_start_gte",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_limit",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_offset",
      "integration_name": "Paycor"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_company_id",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "hris_company",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "hris_group",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "hris_location",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "hris_benefit",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "hris_deduction",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "hris_timeoff",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "ats_company",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "ats_job",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "created_at": "2025-12-15T09:56:49.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycor",
      "object_type": "passthrough",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paycor"
   },
   {
      "type": "method",
      "integration_type": "paycor",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "namely",
      "created_at": "2025-12-15T09:56:49.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "relationships",
      "integration_name": "Namely"
   },
   {
      "type": "integration",
      "created_at": "2025-12-15T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "gainsight",
      "integration_name": "Gainsight"
   },
   {
      "type": "integration",
      "created_at": "2025-12-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "integration_type": "8x8xcaas",
      "integration_name": "8x8 Work & Contact Center"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-12T15:04:02.000Z",
      "object_type": "martech_list",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-12T15:04:02.000Z",
      "object_type": "martech_member",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-12T15:04:02.000Z",
      "object_type": "martech_list",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-12-12T15:04:02.000Z",
      "object_type": "martech_member",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-12-12T15:04:02.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-12-12T15:04:02.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-12-12T15:04:02.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-12-12T15:04:02.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "slow_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-12-12T15:04:02.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-12-12T15:04:02.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-12-12T15:04:02.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2025-12-12T15:04:02.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2025-12-12T15:04:02.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2025-12-12T15:04:02.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2025-12-12T15:04:02.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Gong"
   },
   {
      "type": "integration",
      "created_at": "2025-12-10T00:00:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftteamsbot",
      "integration_name": "Microsoft Teams (bot)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_event",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_event",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "created_at": "2025-12-09T15:32:36.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zohocrm",
      "object_type": "crm_event",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-12-09T15:32:36.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-12-09T13:04:11.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "trello",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "trello",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Trello"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Google"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_message",
      "integration_name": "Google"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_calendar",
      "integration_name": "Google"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_message",
      "integration_name": "Google"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_calendar",
      "integration_name": "Google"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Google"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_message",
      "integration_name": "Google"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "google",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_calendar",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "calendar_event",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "calendar_calendar",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "calendar_busy",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "calendar_recording",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "messaging_channel",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "messaging_message",
      "integration_name": "Google"
   },
   {
      "type": "object",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "object_type": "crm_contact",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_busy",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "messaging_message",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google"
   },
   {
      "type": "method",
      "integration_type": "google",
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "crm_contact",
      "categories": [
         "calendar",
         "messaging",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "ats_job",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-08T11:16:03.000Z",
      "object_type": "ats_job",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-12-08T11:16:03.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-12-03T12:40:38.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_order",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-12-03T12:40:38.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-12-03T12:40:38.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-12-03T12:40:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-12-03T12:40:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-12-03T12:40:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-12-03T12:40:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-12-03T12:40:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "JobDiva"
   },
   {
      "type": "object",
      "created_at": "2025-12-03T12:40:38.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deel",
      "object_type": "hris_benefit",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2025-12-03T12:40:38.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deel"
   },
   {
      "type": "object",
      "created_at": "2025-12-03T12:40:38.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "hris_deduction",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-12-03T12:40:38.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-12-03T12:40:38.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2025-12-02T16:05:39.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-12-02T16:05:39.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "collections",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "monday",
      "created_at": "2025-12-02T16:05:39.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Monday"
   },
   {
      "type": "pagination",
      "integration_type": "monday",
      "created_at": "2025-12-02T16:05:39.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Monday"
   },
   {
      "type": "pagination",
      "integration_type": "monday",
      "created_at": "2025-12-02T16:05:39.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Monday"
   },
   {
      "type": "pagination",
      "integration_type": "monday",
      "created_at": "2025-12-02T16:05:39.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Monday"
   },
   {
      "type": "pagination",
      "integration_type": "monday",
      "created_at": "2025-12-02T16:05:39.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-12-02T16:05:39.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-12-02T16:05:39.000Z",
      "object_type": "task_project",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "gong",
      "created_at": "2025-12-02T16:05:39.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gong"
   },
   {
      "type": "integration",
      "created_at": "2025-12-02T00:00:00.000Z",
      "categories": [
         "payment",
         "hris",
         "accounting",
         "commerce",
         "crm",
         "passthrough"
      ],
      "integration_type": "bunny",
      "integration_name": "Bunny.com"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "Seven20",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-01T17:14:13.000Z",
      "object_type": "ats_document",
      "integration_name": "Seven20"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "Seven20",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-12-01T17:14:13.000Z",
      "object_type": "ats_document",
      "integration_name": "Seven20"
   },
   {
      "type": "object",
      "created_at": "2025-12-01T17:14:13.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "Seven20",
      "object_type": "ats_document",
      "integration_name": "Seven20"
   },
   {
      "type": "method",
      "integration_type": "Seven20",
      "created_at": "2025-12-01T17:14:13.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Seven20"
   },
   {
      "type": "method",
      "integration_type": "Seven20",
      "created_at": "2025-12-01T17:14:13.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Seven20"
   },
   {
      "type": "method",
      "integration_type": "Seven20",
      "created_at": "2025-12-01T17:14:13.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Seven20"
   },
   {
      "type": "integration",
      "created_at": "2025-12-01T00:00:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohomeeting",
      "integration_name": "Zoho Meeting"
   },
   {
      "type": "integration",
      "created_at": "2025-12-01T00:00:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohomail",
      "integration_name": "Zoho Mail"
   },
   {
      "type": "integration",
      "created_at": "2025-12-01T00:00:00.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohocalendar",
      "integration_name": "Zoho Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemeet",
      "created_at": "2025-11-26T19:10:38.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "send_notifications",
      "integration_name": "Google Meet"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-11-26T19:10:38.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "send_notifications",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_order",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_start_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_end_lt",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-11-26T14:13:55.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "calendar_link",
      "pagination": "list_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_type",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_type",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_type",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_type",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_type",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_type",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-24T17:17:20.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-24T17:17:20.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_type",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_query",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_type",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_channel_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_user_mentioned_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-24T17:17:20.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_type",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "commerce_saleschannel",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-24T14:56:00.000Z",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-24T14:56:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_saleschannel_id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-24T14:56:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_saleschannel_id",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "object_type": "commerce_saleschannel",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-24T14:56:00.000Z",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Seven20"
   },
   {
      "type": "writable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Seven20"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "integration_name": "Akeneo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "integration_name": "Akeneo"
   },
   {
      "type": "object",
      "object_type": "commerce_saleschannel",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-24T14:56:00.000Z",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-11-24T14:56:00.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Akeneo"
   },
   {
      "type": "object",
      "object_type": "commerce_saleschannel",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-21T19:13:04.000Z",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-21T19:13:04.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_saleschannel_id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-21T19:13:04.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_saleschannel_id",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "object_type": "commerce_saleschannel",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-21T19:13:04.000Z",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "integration_name": "Akeneo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "integration_name": "Akeneo"
   },
   {
      "type": "object",
      "object_type": "commerce_saleschannel",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-21T19:13:04.000Z",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-11-21T19:13:04.000Z",
      "object_type": "commerce_saleschannel",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-11-20T18:09:05.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-11-20T18:09:05.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-20T18:09:05.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-11-20T18:09:05.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2025-11-20T18:09:05.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Gmail"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2025-11-20T18:09:05.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "message_thread_identifier",
      "integration_name": "Discord"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:37:54.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:37:54.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-20T16:37:54.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "object_type": "hris_deduction",
      "integration_type": "workday_legacy",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "object_type": "hris_deduction",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "object_type": "hris_benefit",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-11-20T16:21:40.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-11-20T16:21:40.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-11-20T16:21:40.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-11-20T16:21:40.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "object_type": "hris_deduction",
      "integration_type": "paylocity",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "object_type": "hris_benefit",
      "integration_type": "paylocity",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "object_type": "hris_deduction",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "integration_name": "Paychex"
   },
   {
      "type": "object",
      "object_type": "hris_benefit",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_benefit",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paychex"
   },
   {
      "type": "method",
      "integration_type": "paychex",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paychex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_employee",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_employee",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "object_type": "hris_deduction",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-20T16:21:40.000Z",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2025-11-20T16:21:40.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "hris_employee",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2025-11-20T16:21:40.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "hris_payslip",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "object",
      "created_at": "2025-11-20T16:21:40.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "object_type": "hris_location",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_deduction",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "method",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2025-11-20T16:21:40.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_user_mentioned_id",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_user_mentioned_id",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_user_mentioned_id",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_user_mentioned_id",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_limit",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_offset",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "Seven20",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Seven20"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "hris_company",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "hris_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "hris_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_user_mentioned_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "JustCall"
   },
   {
      "type": "readable_field",
      "integration_type": "goto",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "GoTO"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "is_private",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_start_gte",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_end_lt",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_user_id",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_call_id",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_call_id",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-20T10:26:51.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "dialpad",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Dialpad"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-11-20T10:26:51.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "websites",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "user_id",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "telephones",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "tags",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "link_urls",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "employees",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "emails",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "domains",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "description",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm"
      ],
      "field": "address",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "revsport",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Rev Sport"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "Affinity"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-11-18T16:48:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "domains",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2025-11-18T12:03:56.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2025-11-18T12:03:56.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2025-11-18T12:03:56.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-11-18T12:03:56.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "integration",
      "created_at": "2025-11-18T00:00:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "Seven20",
      "integration_name": "Seven20"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohopeople",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho People"
   },
   {
      "type": "pagination",
      "integration_type": "zohopayment",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Payments"
   },
   {
      "type": "pagination",
      "integration_type": "zohopayment",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Payments"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "object_type": "commerce_review",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yotpo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "yotpo"
   },
   {
      "type": "pagination",
      "integration_type": "yardstik",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "object_type": "verification_request",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Yardstik"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "walmart",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Walmart"
   },
   {
      "type": "pagination",
      "integration_type": "walmart",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Walmart"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_ats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_ats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro_ats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Trello"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Trello"
   },
   {
      "type": "pagination",
      "integration_type": "trakstarhire",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors_lms",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "pagination",
      "integration_type": "strongdm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "StrongDM"
   },
   {
      "type": "pagination",
      "integration_type": "strongdm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "StrongDM"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "squareup",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SquareUp"
   },
   {
      "type": "pagination",
      "integration_type": "squarespace",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Squarespace"
   },
   {
      "type": "pagination",
      "integration_type": "squarespace",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Squarespace"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "salsify",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salsify"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_calendar",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesflare"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesflare"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesflare"
   },
   {
      "type": "pagination",
      "integration_type": "salesflare",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Salesflare"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sageintacct",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "revsport",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Rev Sport"
   },
   {
      "type": "pagination",
      "integration_type": "revsport",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Rev Sport"
   },
   {
      "type": "pagination",
      "integration_type": "revsport",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Rev Sport"
   },
   {
      "type": "pagination",
      "integration_type": "revsport",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Rev Sport"
   },
   {
      "type": "pagination",
      "integration_type": "remote",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Remote.com"
   },
   {
      "type": "pagination",
      "integration_type": "remote",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Remote.com"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitee",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruitee"
   },
   {
      "type": "pagination",
      "integration_type": "recruitee",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Recruitee"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "quickbookspayment",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "phenom",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Phenom"
   },
   {
      "type": "pagination",
      "integration_type": "phenom",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Phenom"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "peopleforce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PeopleForce"
   },
   {
      "type": "pagination",
      "integration_type": "peakon",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Peakon"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "paypal",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Paypal"
   },
   {
      "type": "pagination",
      "integration_type": "paylocityrecruiting",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Paylocity Recruiting"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paychex",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Paychex"
   },
   {
      "type": "pagination",
      "integration_type": "paychex",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Paychex"
   },
   {
      "type": "pagination",
      "integration_type": "paychex",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Paychex"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Paradox"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "odoo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_device",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Odoo"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftplanner",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftplanner",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-11-17T14:42:50.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftintune",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftintune",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_list",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "lucca",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lucca"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "keap",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Keap"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "jumpcloud",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JumpCloud"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jboard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Jboard"
   },
   {
      "type": "pagination",
      "integration_type": "jboard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Jboard"
   },
   {
      "type": "pagination",
      "integration_type": "jboard",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Jboard"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "ironclad",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ironclad"
   },
   {
      "type": "pagination",
      "integration_type": "ironclad",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ironclad"
   },
   {
      "type": "pagination",
      "integration_type": "ironclad",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ironclad"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "imap",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "messaging"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "IMAP"
   },
   {
      "type": "pagination",
      "integration_type": "icims",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "iCIMS"
   },
   {
      "type": "pagination",
      "integration_type": "icims",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "iCIMS"
   },
   {
      "type": "pagination",
      "integration_type": "icims",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "iCIMS"
   },
   {
      "type": "pagination",
      "integration_type": "icims",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "iCIMS"
   },
   {
      "type": "pagination",
      "integration_type": "humaans",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Humaans"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hrcloud",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HR Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "hrcloud",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HR Cloud"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "heroku",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Heroku"
   },
   {
      "type": "pagination",
      "integration_type": "heavenhr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HeavenHR"
   },
   {
      "type": "pagination",
      "integration_type": "heavenhr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HeavenHR"
   },
   {
      "type": "pagination",
      "integration_type": "haileyhr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "HaileyHR"
   },
   {
      "type": "pagination",
      "integration_type": "guru",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Guru"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "goto",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GoTO"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Meet"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Meet"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "freshteam",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Freshteam"
   },
   {
      "type": "pagination",
      "integration_type": "freshdesk",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "freshdesk"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "foundu",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "foundU"
   },
   {
      "type": "pagination",
      "integration_type": "fireflies",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Fireflies"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "fathom",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Fathom"
   },
   {
      "type": "pagination",
      "integration_type": "fathom",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Fathom"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "employmentheropayroll",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "dialpad",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Dialpad"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "clover",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Clover"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "checkr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Checkr"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_expense",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bill",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Bill.com"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "atsanywhere",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "assembled",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Assembled"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "ameego",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ameego"
   },
   {
      "type": "pagination",
      "integration_type": "alexis",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Alexis"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_comment",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "ableteams",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "Ableteams"
   },
   {
      "type": "pagination",
      "integration_type": "8x8",
      "created_at": "2025-11-17T14:42:50.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_updated_gte",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "lead_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "lead_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_contact_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_lead_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_deal_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_lead_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T18:03:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_event",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_calendar",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_event",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_calendar",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2025-11-14T15:57:31.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "calendar_event",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2025-11-14T15:57:31.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "calendar_calendar",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "calendar",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "is_primary",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "is_primary",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemeet",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "is_primary",
      "integration_name": "Google Meet"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "is_primary",
      "integration_name": "Google Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-14T15:57:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2025-11-13T14:33:21.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-13T14:33:21.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-13T14:33:21.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-12T14:14:38.000Z",
      "object_type": "ats_document",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-11-12T14:14:38.000Z",
      "object_type": "ats_document",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-12T14:14:38.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-12T14:14:38.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-12T14:14:38.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-12T14:14:38.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-11-12T14:14:38.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2025-11-12T08:56:54.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workday_legacy",
      "object_type": "passthrough",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2025-11-12T08:56:54.000Z",
      "object_type": "ats_activity",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "user_ids",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiteronprem",
      "created_at": "2025-11-12T08:56:54.000Z",
      "object_type": "ats_activity",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "user_ids",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "writable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-11-12T08:56:54.000Z",
      "object_type": "ats_activity",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "user_ids",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-11-12T08:56:54.000Z",
      "object_type": "ats_activity",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "user_ids",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-12T08:56:54.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "postings",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-12T08:56:54.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-12T08:56:54.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2025-11-11T13:23:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2025-11-11T13:23:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2025-11-11T13:23:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-11-11T10:46:58.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-11T10:46:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-11T10:46:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-11T10:46:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-11T10:46:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-11T10:46:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-11-11T10:46:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-11-11T10:46:58.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2025-11-11T10:46:58.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "bullhorn",
      "object_type": "metadata_metadata",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2025-11-11T10:46:58.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bullhorn"
   },
   {
      "type": "method",
      "integration_type": "bullhorn",
      "created_at": "2025-11-11T10:46:58.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "crm",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bullhorn"
   },
   {
      "type": "integration",
      "created_at": "2025-11-07T15:53:33.000Z",
      "categories": [
         "uc",
         "hris",
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "dialpad",
      "integration_name": "Dialpad"
   },
   {
      "type": "object",
      "created_at": "2025-11-07T10:34:58.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "integration_type": "wayfair",
      "object_type": "commerce_collection",
      "integration_name": "Wayfair"
   },
   {
      "type": "object",
      "created_at": "2025-11-07T10:34:58.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "integration_type": "wayfair",
      "object_type": "commerce_item",
      "integration_name": "Wayfair"
   },
   {
      "type": "object",
      "created_at": "2025-11-07T10:34:58.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "integration_type": "wayfair",
      "object_type": "metadata_metadata",
      "integration_name": "Wayfair"
   },
   {
      "type": "object",
      "created_at": "2025-11-07T10:34:58.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "integration_type": "wayfair",
      "object_type": "commerce_inventory",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wayfair"
   },
   {
      "type": "method",
      "integration_type": "wayfair",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wayfair"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "collection_ids",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "walmart",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "collection_ids",
      "integration_name": "Walmart"
   },
   {
      "type": "object",
      "created_at": "2025-11-07T10:34:58.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "walmart",
      "object_type": "commerce_collection",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "trello",
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Trello"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "hris_employee",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-11-07T10:34:58.000Z",
      "object_type": "hris_employee",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-07T10:34:58.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-07T10:34:58.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-11-07T10:34:58.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-06T14:09:09.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-11-06T14:09:09.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-11-06T14:09:09.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "hash",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-11-04T11:30:00.000Z",
      "object_type": "kms_page",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "notion",
      "created_at": "2025-11-04T11:30:00.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Notion"
   },
   {
      "type": "readable_field",
      "integration_type": "coda",
      "created_at": "2025-11-04T11:30:00.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Coda"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2025-11-04T11:30:00.000Z",
      "object_type": "kms_page",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2025-11-04T11:30:00.000Z",
      "object_type": "kms_page",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-11-04T11:30:00.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "integration",
      "created_at": "2025-11-04T00:00:00.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "integration_type": "pcrecruiteronprem",
      "integration_name": "PCRecruiter (On-prem)"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-11-03T14:24:00.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_limit",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-11-03T14:24:00.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-31T15:16:33.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-31T15:16:33.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-10-31T15:16:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-10-31T15:16:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-10-31T15:16:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_order",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-10-31T15:16:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_name",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-10-31T15:16:33.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_document",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_document",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-10-31T09:14:38.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-10-31T09:14:38.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-10-31T09:14:38.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-10-31T09:14:38.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "parent_page_id",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-10-31T09:14:38.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_parent_id",
      "integration_name": "Gladly"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "openings",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-31T09:14:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "openings",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-10-30T11:32:24.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2025-10-30T11:32:24.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2025-10-30T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "squarespace",
      "integration_name": "Squarespace"
   },
   {
      "type": "writable_field",
      "integration_type": "slackbot",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "object_type": "accounting_cashflow",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "created_at": "2025-10-29T14:15:45.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "accounting_cashflow",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "accounting_cashflow",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "channel_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemail",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Gmail"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemail",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Gmail"
   },
   {
      "type": "object",
      "object_type": "accounting_cashflow",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-10-29T14:15:45.000Z",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2025-10-29T14:15:45.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_balancesheet",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "accounting_cashflow",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "accounting_cashflow",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "writable_field",
      "integration_type": "discord",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Discord"
   },
   {
      "type": "writable_field",
      "integration_type": "discord",
      "created_at": "2025-10-29T14:15:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-28T16:10:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-10-28T16:10:48.000Z",
      "object_type": "ats_application",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "oraclehcm",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-10-28T16:10:48.000Z",
      "object_type": "ats_application",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2025-10-28T16:10:48.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2025-10-28T16:10:48.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "eploy",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-28T16:10:48.000Z",
      "object_type": "ats_application",
      "integration_name": "Eploy"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "eploy",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-28T16:10:48.000Z",
      "object_type": "ats_application",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2025-10-28T16:10:48.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2025-10-28T16:10:48.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Eploy"
   },
   {
      "type": "pagination",
      "integration_type": "eploy",
      "created_at": "2025-10-28T16:10:48.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Eploy"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "atsanywhere",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-10-28T16:10:48.000Z",
      "object_type": "ats_application",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "atsanywhere",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-10-28T16:10:48.000Z",
      "object_type": "ats_application",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "pagination",
      "integration_type": "atsanywhere",
      "created_at": "2025-10-28T16:10:48.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "pagination",
      "integration_type": "atsanywhere",
      "created_at": "2025-10-28T16:10:48.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "pagination",
      "integration_type": "atsanywhere",
      "created_at": "2025-10-28T16:10:48.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "division",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2025-10-27T15:21:53.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "integration_type": "quickbooks",
      "object_type": "task_project",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "task",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "meeting",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "task",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "meeting",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "ats_job",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "ats_application",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "ats_job",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "adp",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "ats_application",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-10-27T15:21:53.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-10-27T15:21:53.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-10-27T15:21:53.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-10-27T15:21:53.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-10-27T15:21:53.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-10-27T15:21:53.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-10-27T15:21:53.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "integration",
      "created_at": "2025-10-23T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "odoo",
      "integration_name": "Odoo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "readable_field",
      "integration_type": "zoomphone",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zambion",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "readable_field",
      "integration_type": "zambion",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "yotpo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Workstream"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Workstream"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Workstream"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Workstream"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "last_name",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "last_name",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "last_name",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "first_name",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "first_name",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "first_name",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "last_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "last_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "first_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "first_name",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "webex",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Webex"
   },
   {
      "type": "readable_field",
      "integration_type": "webex",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Webex"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "wave",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "uplead",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "UpLead"
   },
   {
      "type": "readable_field",
      "integration_type": "uplead",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "UpLead"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro_ats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro_ats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "ukg_hr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "readable_field",
      "integration_type": "ukg_hr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "readable_field",
      "integration_type": "twitter",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "auth"
      ],
      "field": "last_name",
      "integration_name": "Twitter"
   },
   {
      "type": "readable_field",
      "integration_type": "twitter",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "auth"
      ],
      "field": "first_name",
      "integration_name": "Twitter"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "trakstarhire",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "readable_field",
      "integration_type": "trakstarhire",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "sympa",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Sympa"
   },
   {
      "type": "readable_field",
      "integration_type": "sympa",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Sympa"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "squareup",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "snowflake",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Snowflake"
   },
   {
      "type": "readable_field",
      "integration_type": "snowflake",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Snowflake"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "slintel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Slintel"
   },
   {
      "type": "readable_field",
      "integration_type": "slintel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Slintel"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ServiceNow"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ServiceNow"
   },
   {
      "type": "readable_field",
      "integration_type": "sendgrid",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SendGrid"
   },
   {
      "type": "readable_field",
      "integration_type": "sendgrid",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SendGrid"
   },
   {
      "type": "readable_field",
      "integration_type": "sendfox",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "SendFox"
   },
   {
      "type": "readable_field",
      "integration_type": "sendfox",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "SendFox"
   },
   {
      "type": "readable_field",
      "integration_type": "scoro",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "scoro",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforcemarketingcloud",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm"
      ],
      "field": "last_name",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm"
      ],
      "field": "last_name",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm"
      ],
      "field": "first_name",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm"
      ],
      "field": "first_name",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "rocketreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "RocketReach"
   },
   {
      "type": "readable_field",
      "integration_type": "rocketreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "RocketReach"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth"
      ],
      "field": "last_name",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth"
      ],
      "field": "first_name",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "ringcentral",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ring Central"
   },
   {
      "type": "readable_field",
      "integration_type": "revsport",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Rev Sport"
   },
   {
      "type": "readable_field",
      "integration_type": "revsport",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Rev Sport"
   },
   {
      "type": "readable_field",
      "integration_type": "revsport",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Rev Sport"
   },
   {
      "type": "readable_field",
      "integration_type": "revsport",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Rev Sport"
   },
   {
      "type": "readable_field",
      "integration_type": "remote",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Remote.com"
   },
   {
      "type": "readable_field",
      "integration_type": "remote",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Remote.com"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Recruitee"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Recruitee"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "ramp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ramp"
   },
   {
      "type": "readable_field",
      "integration_type": "ramp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ramp"
   },
   {
      "type": "readable_field",
      "integration_type": "ramp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ramp"
   },
   {
      "type": "readable_field",
      "integration_type": "ramp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ramp"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "qlik",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Qlik"
   },
   {
      "type": "readable_field",
      "integration_type": "qlik",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Qlik"
   },
   {
      "type": "readable_field",
      "integration_type": "prismhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "PrismHR"
   },
   {
      "type": "readable_field",
      "integration_type": "prismhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "PrismHR"
   },
   {
      "type": "readable_field",
      "integration_type": "prismhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "PrismHR"
   },
   {
      "type": "readable_field",
      "integration_type": "prismhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "PrismHR"
   },
   {
      "type": "readable_field",
      "integration_type": "plusplus",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "PlusPlus"
   },
   {
      "type": "readable_field",
      "integration_type": "plusplus",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "PlusPlus"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Plum"
   },
   {
      "type": "readable_field",
      "integration_type": "pitchbook",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Pitchbook"
   },
   {
      "type": "readable_field",
      "integration_type": "pitchbook",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Pitchbook"
   },
   {
      "type": "readable_field",
      "integration_type": "pipl",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Pipl"
   },
   {
      "type": "readable_field",
      "integration_type": "pipl",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Pipl"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "pinpoint",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Pinpoint"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "peopleforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "PeopleForce"
   },
   {
      "type": "readable_field",
      "integration_type": "peopleforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "PeopleForce"
   },
   {
      "type": "readable_field",
      "integration_type": "peopledatalabs",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "PeopleDataLabs"
   },
   {
      "type": "readable_field",
      "integration_type": "peopledatalabs",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "PeopleDataLabs"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "peakon",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "peakon",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "last_name",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "last_name",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "first_name",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "first_name",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "paypal",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "commerce",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Paypal"
   },
   {
      "type": "readable_field",
      "integration_type": "paypal",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "commerce",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Paypal"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris"
      ],
      "field": "last_name",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris"
      ],
      "field": "first_name",
      "integration_name": "Paycor"
   },
   {
      "type": "readable_field",
      "integration_type": "paycom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Paycom"
   },
   {
      "type": "readable_field",
      "integration_type": "paycom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Paycom"
   },
   {
      "type": "readable_field",
      "integration_type": "paychex",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Paychex"
   },
   {
      "type": "readable_field",
      "integration_type": "paychex",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Paychex"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "outreach",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehcm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "oraclehcm",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "okta",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Okta"
   },
   {
      "type": "readable_field",
      "integration_type": "okta",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Okta"
   },
   {
      "type": "readable_field",
      "integration_type": "notion",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Notion"
   },
   {
      "type": "readable_field",
      "integration_type": "notion",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Notion"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "namely",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Namely"
   },
   {
      "type": "readable_field",
      "integration_type": "namely",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Namely"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "motion",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Motion"
   },
   {
      "type": "readable_field",
      "integration_type": "motion",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Motion"
   },
   {
      "type": "readable_field",
      "integration_type": "mongodb",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "MongoDB"
   },
   {
      "type": "readable_field",
      "integration_type": "mongodb",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "MongoDB"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftintune",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftintune",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mattermark",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Mattermark"
   },
   {
      "type": "readable_field",
      "integration_type": "mattermark",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Mattermark"
   },
   {
      "type": "readable_field",
      "integration_type": "marketing360",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Marketing360"
   },
   {
      "type": "readable_field",
      "integration_type": "marketing360",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Marketing360"
   },
   {
      "type": "readable_field",
      "integration_type": "marketing360",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Marketing360"
   },
   {
      "type": "readable_field",
      "integration_type": "marketing360",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Marketing360"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "lusha",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Lusha"
   },
   {
      "type": "readable_field",
      "integration_type": "lusha",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Lusha"
   },
   {
      "type": "readable_field",
      "integration_type": "lucca",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Lucca"
   },
   {
      "type": "readable_field",
      "integration_type": "lucca",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Lucca"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "leapsome",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Leapsome"
   },
   {
      "type": "readable_field",
      "integration_type": "leapsome",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Leapsome"
   },
   {
      "type": "readable_field",
      "integration_type": "leadsift",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "LeadSift"
   },
   {
      "type": "readable_field",
      "integration_type": "leadsift",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "LeadSift"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "klaviyo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "klaviyo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "keap",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Keap"
   },
   {
      "type": "readable_field",
      "integration_type": "karbonhq",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "readable_field",
      "integration_type": "karbonhq",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "readable_field",
      "integration_type": "kandji",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "readable_field",
      "integration_type": "kandji",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JustCall"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JustCall"
   },
   {
      "type": "readable_field",
      "integration_type": "jumpcloud",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "jumpcloud",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jboard",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Jboard"
   },
   {
      "type": "readable_field",
      "integration_type": "jboard",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Jboard"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "jamf",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Jamf"
   },
   {
      "type": "readable_field",
      "integration_type": "jamf",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Jamf"
   },
   {
      "type": "readable_field",
      "integration_type": "ironclad",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "ironclad",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "irishr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Iris HR"
   },
   {
      "type": "readable_field",
      "integration_type": "irishr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Iris HR"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "hunter",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Hunter.io"
   },
   {
      "type": "readable_field",
      "integration_type": "hunter",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Hunter.io"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humantic",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Humantic.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "humantic",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Humantic.ai"
   },
   {
      "type": "readable_field",
      "integration_type": "humanforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Humanforce"
   },
   {
      "type": "readable_field",
      "integration_type": "humanforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Humanforce"
   },
   {
      "type": "readable_field",
      "integration_type": "humaans",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris"
      ],
      "field": "last_name",
      "integration_name": "Humaans"
   },
   {
      "type": "readable_field",
      "integration_type": "humaans",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris"
      ],
      "field": "first_name",
      "integration_name": "Humaans"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hrcloud",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HR Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "hrcloud",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HR Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "homerun",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats"
      ],
      "field": "last_name",
      "integration_name": "Homerun"
   },
   {
      "type": "readable_field",
      "integration_type": "homerun",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats"
      ],
      "field": "first_name",
      "integration_name": "Homerun"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "hireology",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Hireology"
   },
   {
      "type": "readable_field",
      "integration_type": "hireology",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Hireology"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hexnode",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Hexnode"
   },
   {
      "type": "readable_field",
      "integration_type": "hexnode",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Hexnode"
   },
   {
      "type": "readable_field",
      "integration_type": "heroku",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Heroku"
   },
   {
      "type": "readable_field",
      "integration_type": "heroku",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Heroku"
   },
   {
      "type": "readable_field",
      "integration_type": "heavenhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HeavenHR"
   },
   {
      "type": "readable_field",
      "integration_type": "heavenhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HeavenHR"
   },
   {
      "type": "readable_field",
      "integration_type": "haileyhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "HaileyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "haileyhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "HaileyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "guru",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Guru"
   },
   {
      "type": "readable_field",
      "integration_type": "guru",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Guru"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "goto",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "GoTO"
   },
   {
      "type": "readable_field",
      "integration_type": "goto",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "GoTO"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "googledrive",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "googledrive",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Google Contacts"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Google Contacts"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Google Classroom"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_instructor",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Google Classroom"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Google Classroom"
   },
   {
      "type": "readable_field",
      "integration_type": "googleclassroom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_instructor",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Google Classroom"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gong",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Gong"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "getprospect",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "GetProspect"
   },
   {
      "type": "readable_field",
      "integration_type": "getprospect",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "GetProspect"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "fullcontact",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "FullContact"
   },
   {
      "type": "readable_field",
      "integration_type": "fullcontact",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "FullContact"
   },
   {
      "type": "readable_field",
      "integration_type": "freshteam",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Freshteam"
   },
   {
      "type": "readable_field",
      "integration_type": "freshteam",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Freshteam"
   },
   {
      "type": "readable_field",
      "integration_type": "freshsales",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm"
      ],
      "field": "last_name",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "freshsales",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm"
      ],
      "field": "last_name",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "freshsales",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm"
      ],
      "field": "first_name",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "freshsales",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm"
      ],
      "field": "first_name",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "fountain",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Fountain"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "foundU"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "foundU"
   },
   {
      "type": "readable_field",
      "integration_type": "firstadvantage",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "First Advantage"
   },
   {
      "type": "readable_field",
      "integration_type": "firstadvantage",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "First Advantage"
   },
   {
      "type": "readable_field",
      "integration_type": "fireflies",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Fireflies"
   },
   {
      "type": "readable_field",
      "integration_type": "fireflies",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Fireflies"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "fathom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Fathom"
   },
   {
      "type": "readable_field",
      "integration_type": "fathom",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Fathom"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "exactbuyer",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "ExactBuyer"
   },
   {
      "type": "readable_field",
      "integration_type": "exactbuyer",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "ExactBuyer"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "eploy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Eploy"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "enboarder",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "enboarder",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "employmentheropayroll",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "readable_field",
      "integration_type": "employmentheropayroll",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ELMO"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ELMO"
   },
   {
      "type": "readable_field",
      "integration_type": "dropcontact",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "DropContact"
   },
   {
      "type": "readable_field",
      "integration_type": "dropcontact",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "DropContact"
   },
   {
      "type": "readable_field",
      "integration_type": "dropbox",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Dropbox"
   },
   {
      "type": "readable_field",
      "integration_type": "dropbox",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Dropbox"
   },
   {
      "type": "readable_field",
      "integration_type": "docusign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "DocuSign"
   },
   {
      "type": "readable_field",
      "integration_type": "docusign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "DocuSign"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "last_name",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "first_name",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "datagma",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Datagma"
   },
   {
      "type": "readable_field",
      "integration_type": "datagma",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Datagma"
   },
   {
      "type": "readable_field",
      "integration_type": "dashlane",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Dashlane"
   },
   {
      "type": "readable_field",
      "integration_type": "dashlane",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Dashlane"
   },
   {
      "type": "readable_field",
      "integration_type": "d2l",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_instructor",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "readable_field",
      "integration_type": "d2l",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "readable_field",
      "integration_type": "d2l",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_instructor",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "readable_field",
      "integration_type": "d2l",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "readable_field",
      "integration_type": "cultureamp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Culture Amp"
   },
   {
      "type": "readable_field",
      "integration_type": "cultureamp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Culture Amp"
   },
   {
      "type": "readable_field",
      "integration_type": "crystalknows",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "CrystalKnows"
   },
   {
      "type": "readable_field",
      "integration_type": "crystalknows",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "CrystalKnows"
   },
   {
      "type": "readable_field",
      "integration_type": "crunchbase",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Crunchbase"
   },
   {
      "type": "readable_field",
      "integration_type": "crunchbase",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Crunchbase"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "coursera",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_instructor",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Coursera"
   },
   {
      "type": "readable_field",
      "integration_type": "coursera",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Coursera"
   },
   {
      "type": "readable_field",
      "integration_type": "coursera",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_instructor",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Coursera"
   },
   {
      "type": "readable_field",
      "integration_type": "coursera",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "lms_student",
      "categories": [
         "lms",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Coursera"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "contactout",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ContactOut"
   },
   {
      "type": "readable_field",
      "integration_type": "contactout",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ContactOut"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "clover",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "cleon1",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Cleon1"
   },
   {
      "type": "readable_field",
      "integration_type": "cleon1",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Cleon1"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearcompany",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "clearbit",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "last_name",
      "integration_name": "Clearbit"
   },
   {
      "type": "readable_field",
      "integration_type": "clearbit",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "first_name",
      "integration_name": "Clearbit"
   },
   {
      "type": "readable_field",
      "integration_type": "circle",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Circle.so"
   },
   {
      "type": "readable_field",
      "integration_type": "circle",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Circle.so"
   },
   {
      "type": "readable_field",
      "integration_type": "checkr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Checkr"
   },
   {
      "type": "readable_field",
      "integration_type": "checkr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Checkr"
   },
   {
      "type": "readable_field",
      "integration_type": "checkr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Checkr"
   },
   {
      "type": "readable_field",
      "integration_type": "checkr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Checkr"
   },
   {
      "type": "readable_field",
      "integration_type": "charliehr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "CharlieHR"
   },
   {
      "type": "readable_field",
      "integration_type": "charliehr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "CharlieHR"
   },
   {
      "type": "readable_field",
      "integration_type": "chargebee",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Chargebee"
   },
   {
      "type": "readable_field",
      "integration_type": "chargebee",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Chargebee"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Certn"
   },
   {
      "type": "readable_field",
      "integration_type": "certn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Certn"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cascade",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Cascade"
   },
   {
      "type": "readable_field",
      "integration_type": "cascade",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Cascade"
   },
   {
      "type": "readable_field",
      "integration_type": "careerplug",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "CareerPlug"
   },
   {
      "type": "readable_field",
      "integration_type": "careerplug",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "CareerPlug"
   },
   {
      "type": "readable_field",
      "integration_type": "careerplug",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "CareerPlug"
   },
   {
      "type": "readable_field",
      "integration_type": "careerplug",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "CareerPlug"
   },
   {
      "type": "readable_field",
      "integration_type": "canvas",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Canvas"
   },
   {
      "type": "readable_field",
      "integration_type": "canvas",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Canvas"
   },
   {
      "type": "readable_field",
      "integration_type": "calendly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Calendly"
   },
   {
      "type": "readable_field",
      "integration_type": "calendly",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Calendly"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "brex",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Brex"
   },
   {
      "type": "readable_field",
      "integration_type": "brex",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Brex"
   },
   {
      "type": "readable_field",
      "integration_type": "brex",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Brex"
   },
   {
      "type": "readable_field",
      "integration_type": "brex",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Brex"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breathehr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "BreatheHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breathehr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "BreatheHR"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "boldcommerce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "readable_field",
      "integration_type": "boldcommerce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "bill",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Bill.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bill",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Bill.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bill",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Bill.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bill",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Bill.com"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "last_name",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "last_name",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "first_name",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "first_name",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "atsanywhere",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "readable_field",
      "integration_type": "atsanywhere",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "assembled",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Assembled"
   },
   {
      "type": "readable_field",
      "integration_type": "assembled",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Assembled"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "applicantstack",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "readable_field",
      "integration_type": "applicantstack",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "ameego",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ameego"
   },
   {
      "type": "readable_field",
      "integration_type": "ameego",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ameego"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Affinity"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Affinity"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Affinity"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Affinity"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "ableteams",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "Ableteams"
   },
   {
      "type": "readable_field",
      "integration_type": "ableteams",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "Ableteams"
   },
   {
      "type": "readable_field",
      "integration_type": "8x8",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "readable_field",
      "integration_type": "8x8",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "readable_field",
      "integration_type": "15five",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "last_name",
      "integration_name": "15Five"
   },
   {
      "type": "readable_field",
      "integration_type": "15five",
      "created_at": "2025-10-22T15:03:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "first_name",
      "integration_name": "15Five"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-10-22T12:35:37.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_start_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-10-22T12:35:37.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_end_lt",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-10-22T12:35:37.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-10-22T12:35:37.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "created_at": "2025-10-22T12:35:37.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruitcrm",
      "object_type": "ats_document",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T12:35:37.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T12:35:37.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2025-10-22T12:35:37.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "object",
      "object_type": "accounting_expense",
      "integration_type": "zohoinvoice",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "method",
      "integration_type": "zohoinvoice",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "method",
      "integration_type": "zohoinvoice",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "method",
      "integration_type": "zohoinvoice",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "method",
      "integration_type": "zohoinvoice",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "method",
      "integration_type": "zohoinvoice",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_expense",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_expense",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "walmart",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_user_id",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_user_id",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "object_type": "accounting_expense",
      "integration_type": "sageintacct",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "method",
      "integration_type": "sageintacct",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "object",
      "object_type": "accounting_expense",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paylocity",
      "object_type": "hris_group",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paylocity"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "variants",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "collection_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "variants",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "collection_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_expense",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "accounting_expense",
      "integration_type": "keap",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Keap"
   },
   {
      "type": "method",
      "integration_type": "keap",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Keap"
   },
   {
      "type": "object",
      "object_type": "accounting_expense",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_category",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "brex",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Brex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "brex",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "integration_name": "Brex"
   },
   {
      "type": "object",
      "object_type": "accounting_expense",
      "integration_type": "brex",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "accounting_expense",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Brex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "ats_activity",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "ats_activity",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "integration_type": "bamboohr",
      "object_type": "ats_activity",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "list",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "create",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "AirCall.io"
   },
   {
      "type": "writable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "AirCall.io"
   },
   {
      "type": "writable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "contact_phone",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_start_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_end_lt",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "hris_location",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "hris_group",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "created_at": "2025-10-17T15:24:56.000Z",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "metadata_metadata",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-10-17T15:24:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "ats",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-10-15T14:05:15.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-10-15T14:05:15.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "list_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-10-15T14:05:15.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "list_contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors_oidc",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-10-15T10:52:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-10-15T10:52:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-10-15T10:52:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_limit",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-10-15T10:52:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_offset",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-10-15T10:52:28.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_user_id",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "fathom",
      "created_at": "2025-10-15T10:52:28.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Fathom"
   },
   {
      "type": "integration",
      "created_at": "2025-10-14T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "goto",
      "integration_name": "GoTO"
   },
   {
      "type": "writable_field",
      "integration_type": "paylocity",
      "created_at": "2025-10-10T10:39:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Paylocity"
   },
   {
      "type": "writable_field",
      "integration_type": "paylocity",
      "created_at": "2025-10-10T10:39:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Paylocity"
   },
   {
      "type": "writable_field",
      "integration_type": "paylocity",
      "created_at": "2025-10-10T10:39:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Paylocity"
   },
   {
      "type": "writable_field",
      "integration_type": "paylocity",
      "created_at": "2025-10-10T10:39:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Paylocity"
   },
   {
      "type": "writable_field",
      "integration_type": "paylocity",
      "created_at": "2025-10-10T10:39:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "created_at": "2025-10-10T10:39:55.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paylocity",
      "object_type": "hris_location",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "created_at": "2025-10-10T10:39:55.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paylocity",
      "object_type": "hris_timeshift",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-10-10T10:39:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-10-10T10:39:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "gladly",
      "created_at": "2025-10-10T10:39:55.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "field": "download_url",
      "integration_name": "Gladly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_application",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "crm_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "crm_contact",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_application",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_job",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "crm_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "crm_contact",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_application",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "ats_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "crm_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-09T11:17:00.000Z",
      "object_type": "crm_contact",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-10-09T11:17:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "toast",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "sales_channel",
      "integration_name": "Toast"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "sales_channel",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "sales_channel",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "sales_channel",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "field": "sales_channel",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-08T15:39:09.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Gmail"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2025-10-08T15:39:09.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channels",
      "integration_name": "Discord"
   },
   {
      "type": "pagination",
      "integration_type": "discord",
      "created_at": "2025-10-08T15:39:09.000Z",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "slow_fields",
      "integration_name": "Discord"
   },
   {
      "type": "object",
      "created_at": "2025-10-08T10:56:58.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "integration_type": "gladly",
      "object_type": "hris_company",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-10-08T10:56:58.000Z",
      "object_type": "hris_company",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-10-07T20:32:35.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-10-07T20:32:35.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-10-07T20:32:35.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-10-07T20:32:35.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-10-07T15:02:11.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-10-07T15:02:11.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "created_at": "2025-10-07T15:02:11.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "accounting_salesorder",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-10-07T15:02:11.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-10-07T15:02:11.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-10-07T15:02:11.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-10-07T15:02:11.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-10-07T15:02:11.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_contact",
      "integration_name": "Vincere"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_contact",
      "integration_name": "Vincere"
   },
   {
      "type": "object",
      "created_at": "2025-10-07T11:11:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "vincere",
      "object_type": "crm_company",
      "integration_name": "Vincere"
   },
   {
      "type": "object",
      "created_at": "2025-10-07T11:11:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "vincere",
      "object_type": "crm_contact",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-10-07T11:11:23.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Vincere"
   },
   {
      "type": "object",
      "created_at": "2025-10-06T14:33:10.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "zoominfo",
      "object_type": "passthrough",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "youtube_url",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "yelp_url",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "year_founded",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "updated_at",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "updated_at",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "twitter_url",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "title",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "stock",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "sic_code",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "revenue",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "naics_code",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "linkedin_url",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "instagram_url",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "industry",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "image_url",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "id",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "id",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "github_url",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "facebook_url",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "employees",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "crunchbase_url",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "created_at",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "created_at",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "company_domain",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "company",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "address",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "readable_field",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "object_type": "enrich_company",
      "categories": [
         "enrich"
      ],
      "field": "address",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "pagination",
      "integration_type": "zoominfo",
      "created_at": "2025-10-06T10:57:54.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_company",
      "pagination": "search_name",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "departments",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_company",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "hris_group",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_company",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "hris_group",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "object",
      "created_at": "2025-10-03T09:01:59.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "ats_company",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "object",
      "created_at": "2025-10-03T09:01:59.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "hris_group",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-10-03T09:01:59.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-10-02T18:19:02.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "slow_fields",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-02T15:01:52.000Z",
      "object_type": "uc_recording",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-02T15:01:52.000Z",
      "object_type": "uc_recording",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_updated_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_end_lt",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_limit",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_offset",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_order",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_created_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_user_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_contact_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2025-10-02T15:01:52.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "uc_recording",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "uc_recording",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "uc_recording",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "created_at": "2025-10-02T10:35:38.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftteams",
      "object_type": "uc_call",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "created_at": "2025-10-02T10:35:38.000Z",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftteams",
      "object_type": "uc_recording",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "uc_call",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "uc_recording",
      "categories": [
         "messaging",
         "calendar",
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "mercuryats",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_contact",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "mercuryats",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_company",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "mercuryats",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_contact",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "mercuryats",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_company",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "object",
      "created_at": "2025-10-02T10:35:38.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "mercuryats",
      "object_type": "crm_contact",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "object",
      "created_at": "2025-10-02T10:35:38.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "mercuryats",
      "object_type": "crm_company",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-10-02T10:35:38.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "integration",
      "created_at": "2025-10-02T00:00:00.000Z",
      "categories": [
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohopayment",
      "integration_name": "Zoho Payments"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-10-01T10:15:06.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "primary",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-10-01T10:15:06.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "primary",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "integration",
      "created_at": "2025-10-01T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "vercel",
      "integration_name": "Vercel"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-30T11:43:21.000Z",
      "object_type": "ats_document",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-30T11:43:21.000Z",
      "object_type": "ats_document",
      "integration_name": "Manatal"
   },
   {
      "type": "object",
      "created_at": "2025-09-30T11:43:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "manatal",
      "object_type": "ats_document",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2025-09-30T11:43:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2025-09-30T11:43:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2025-09-30T11:43:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2025-09-30T11:43:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Manatal"
   },
   {
      "type": "method",
      "integration_type": "manatal",
      "created_at": "2025-09-30T11:43:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Manatal"
   },
   {
      "type": "integration",
      "created_at": "2025-09-30T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "charliehr",
      "integration_name": "CharlieHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2025-09-28T18:31:27.000Z",
      "object_type": "uc_contact",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "justcall",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2025-09-28T18:31:27.000Z",
      "object_type": "uc_contact",
      "integration_name": "JustCall"
   },
   {
      "type": "object",
      "created_at": "2025-09-28T18:31:27.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "justcall",
      "object_type": "uc_contact",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2025-09-28T18:31:27.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2025-09-28T18:31:27.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2025-09-28T18:31:27.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2025-09-28T18:31:27.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2025-09-28T18:31:27.000Z",
      "object_type": "uc_contact",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-27T09:18:26.000Z",
      "object_type": "hris_employee",
      "integration_name": "Paychex"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-27T09:18:26.000Z",
      "object_type": "hris_employee",
      "integration_name": "Paychex"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "paychex",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-27T09:18:26.000Z",
      "object_type": "hris_employee",
      "integration_name": "Paychex"
   },
   {
      "type": "pagination",
      "integration_type": "paychex",
      "created_at": "2025-09-27T09:18:26.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "native_webhook_company_id",
      "integration_name": "Paychex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "created_at": "2025-09-26T18:40:19.000Z",
      "object_type": "kms_page",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "created_at": "2025-09-26T18:40:19.000Z",
      "object_type": "kms_page",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2025-09-26T18:40:19.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "kms_page",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2025-09-26T18:40:19.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "kms_space",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-09-26T18:40:19.000Z",
      "object_type": "kms_page",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-09-26T18:40:19.000Z",
      "object_type": "kms_page",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-09-26T18:40:19.000Z",
      "object_type": "kms_space",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-09-26T18:40:19.000Z",
      "object_type": "kms_space",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "kms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-09-26T14:15:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_unread",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-09-26T14:15:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_unread",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-26T10:45:59.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "is_unread",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2025-09-26T10:45:59.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "is_unread",
      "integration_name": "Gmail"
   },
   {
      "type": "integration",
      "created_at": "2025-09-26T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paychex",
      "integration_name": "Paychex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-25T22:32:59.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Zoom"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-25T22:32:59.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_updated_gte",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_event_id",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Zoom"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-25T22:32:59.000Z",
      "object_type": "calendar_event",
      "integration_name": "Webex"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-25T22:32:59.000Z",
      "object_type": "calendar_event",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_updated_gte",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_calendar_id",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Webex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-25T22:32:59.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-25T22:32:59.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_start_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_end_lt",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_event_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "fathom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_start_gte",
      "integration_name": "Fathom"
   },
   {
      "type": "pagination",
      "integration_type": "fathom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_end_lt",
      "integration_name": "Fathom"
   },
   {
      "type": "pagination",
      "integration_type": "fathom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Fathom"
   },
   {
      "type": "pagination",
      "integration_type": "fathom",
      "created_at": "2025-09-25T22:32:59.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Fathom"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_user_id",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ringcentral",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-25T09:17:40.000Z",
      "object_type": "uc_recording",
      "integration_name": "Ring Central"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ringcentral",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-25T09:17:40.000Z",
      "object_type": "uc_recording",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_query",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_updated_gte",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_end_lt",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Ring Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "8x8",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2025-09-25T09:17:40.000Z",
      "object_type": "uc_recording",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "8x8",
      "categories": [
         "uc",
         "passthrough"
      ],
      "created_at": "2025-09-25T09:17:40.000Z",
      "object_type": "uc_recording",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "pagination",
      "integration_type": "8x8",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_updated_gte",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "pagination",
      "integration_type": "8x8",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "pagination",
      "integration_type": "8x8",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "pagination",
      "integration_type": "8x8",
      "created_at": "2025-09-25T09:17:40.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_expand",
      "integration_name": "Zoom"
   },
   {
      "type": "writable_field",
      "integration_type": "slackbot",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_message_id",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_end_lt",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_start_gte",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_message_id",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_start_gte",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_end_lt",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_expand",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_expand",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_parent_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_expand",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_expand",
      "integration_name": "Google Meet"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Google Meet"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemail",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Gmail"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2025-09-23T10:55:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Gmail"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_expand",
      "integration_name": "Gmail"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_expand",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-09-23T10:55:33.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_expand",
      "integration_name": "Google Calendar"
   },
   {
      "type": "method",
      "integration_type": "workday_legacy",
      "created_at": "2025-09-22T15:44:21.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris"
      ],
      "method": "list",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "type",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "title",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "is_private",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "description",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "candidate_id",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "postings",
      "integration_name": "Workday"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "create",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "writable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "original_status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "workday_legacy",
      "created_at": "2025-09-22T15:27:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "original_status",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "object",
      "created_at": "2025-09-22T15:27:38.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "workday_legacy",
      "object_type": "ats_applicationstatus",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_salesorder",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_purchaseorder",
      "pagination": "slow_fields",
      "integration_name": "NetSuite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-22T14:48:31.000Z",
      "object_type": "ats_job",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-22T14:48:31.000Z",
      "object_type": "ats_job",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_name",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_order",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-09-22T14:48:31.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Loxo"
   },
   {
      "type": "integration",
      "created_at": "2025-09-22T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ableteams",
      "integration_name": "Ableteams"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2025-09-19T17:00:53.000Z",
      "object_type": "accounting_account",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2025-09-19T17:00:53.000Z",
      "object_type": "accounting_account",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "customer_defined_code",
      "integration_name": "Holded"
   },
   {
      "type": "object",
      "created_at": "2025-09-19T17:00:53.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "integration_type": "holded",
      "object_type": "accounting_organization",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-09-19T17:00:53.000Z",
      "object_type": "accounting_account",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-09-19T17:00:53.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-09-19T17:00:53.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2025-09-19T17:00:53.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "postings",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-09-19T17:00:53.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2025-09-19T17:00:53.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "updated_at",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-09-19T17:00:53.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "trakstarhire",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "pagination",
      "integration_type": "trakstarhire",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "method",
      "integration_type": "trakstarhire",
      "created_at": "2025-09-18T13:55:15.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_status",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Google Meet"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Google Meet"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Google Meet"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Google Meet"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_call_id",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_contact_id",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_start_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-09-18T13:55:15.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_end_lt",
      "integration_name": "BambooHR"
   },
   {
      "type": "integration",
      "created_at": "2025-09-18T00:00:00.000Z",
      "categories": [
         "crm",
         "storage",
         "hris",
         "commerce",
         "accounting",
         "metadata",
         "auth",
         "passthrough"
      ],
      "integration_type": "keap",
      "integration_name": "Keap"
   },
   {
      "type": "integration",
      "created_at": "2025-09-18T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "hrcloud",
      "integration_name": "HR Cloud"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "revsport",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "hris_company",
      "integration_name": "Rev Sport"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "revsport",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Rev Sport"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "revsport",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "hris_company",
      "integration_name": "Rev Sport"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "revsport",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "hris_employee",
      "integration_name": "Rev Sport"
   },
   {
      "type": "object",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "revsport",
      "object_type": "hris_company",
      "integration_name": "Rev Sport"
   },
   {
      "type": "object",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "revsport",
      "object_type": "hris_employee",
      "integration_name": "Rev Sport"
   },
   {
      "type": "method",
      "integration_type": "revsport",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "hris_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rev Sport"
   },
   {
      "type": "method",
      "integration_type": "revsport",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "hris_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rev Sport"
   },
   {
      "type": "method",
      "integration_type": "revsport",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Rev Sport"
   },
   {
      "type": "method",
      "integration_type": "revsport",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Rev Sport"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gladly",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_call",
      "integration_name": "Gladly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gladly",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_contact",
      "integration_name": "Gladly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gladly",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_call",
      "integration_name": "Gladly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gladly",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_contact",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_limit",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_offset",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_updated_gte",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_limit",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_offset",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_query",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_limit",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_offset",
      "integration_name": "Gladly"
   },
   {
      "type": "pagination",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_recording",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_recording",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_call",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_call",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_contact",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_contact",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_contact",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_contact",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gladly"
   },
   {
      "type": "method",
      "integration_type": "gladly",
      "created_at": "2025-09-17T18:27:11.000Z",
      "object_type": "uc_contact",
      "categories": [
         "kms",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Gladly"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-09-17T17:23:15.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-09-17T17:23:15.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "field": "category_ids",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "slow_fields",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-09-17T11:03:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Loxo"
   },
   {
      "type": "integration",
      "created_at": "2025-09-17T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "qlik",
      "integration_name": "Qlik"
   },
   {
      "type": "integration",
      "created_at": "2025-09-17T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "hexnode",
      "integration_name": "Hexnode"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "kms_space",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "kms_space",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "helpscout",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Helpscout"
   },
   {
      "type": "readable_field",
      "integration_type": "guru",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Guru"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "kms_space",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "website_url",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "departments",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "CATS"
   },
   {
      "type": "writable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "CATS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_candidate",
      "integration_name": "CATS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_company",
      "integration_name": "CATS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "integration_name": "CATS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_application",
      "integration_name": "CATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_candidate",
      "integration_name": "CATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_company",
      "integration_name": "CATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "integration_name": "CATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_application",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_query",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_updated_gte",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "CATS"
   },
   {
      "type": "object",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "cats",
      "object_type": "ats_applicationstatus",
      "integration_name": "CATS"
   },
   {
      "type": "object",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "cats",
      "object_type": "ats_application",
      "integration_name": "CATS"
   },
   {
      "type": "object",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "cats",
      "object_type": "ats_activity",
      "integration_name": "CATS"
   },
   {
      "type": "object",
      "created_at": "2025-09-16T14:23:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "cats",
      "object_type": "ats_document",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2025-09-16T14:23:21.000Z",
      "object_type": "uc_comment",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "call_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "integration",
      "created_at": "2025-09-16T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "karbonhq",
      "integration_name": "Karbon HQ"
   },
   {
      "type": "integration",
      "created_at": "2025-09-16T00:00:00.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "gladly",
      "integration_name": "Gladly"
   },
   {
      "type": "integration",
      "created_at": "2025-09-16T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "assembled",
      "integration_name": "Assembled"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "website_url",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "phone",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "website_url",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_query",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2025-09-15T11:49:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_limit",
      "integration_name": "Brex"
   },
   {
      "type": "pagination",
      "integration_type": "brex",
      "created_at": "2025-09-15T11:49:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_offset",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Brex"
   },
   {
      "type": "method",
      "integration_type": "brex",
      "created_at": "2025-09-15T11:49:00.000Z",
      "object_type": "payment_payment",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Brex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google Meet"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google Meet"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_calendar",
      "integration_name": "Google Meet"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google Meet"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_calendar",
      "integration_name": "Google Meet"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google Meet"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google Meet"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_calendar",
      "integration_name": "Google Meet"
   },
   {
      "type": "object",
      "created_at": "2025-09-10T11:49:07.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlemeet",
      "object_type": "calendar_busy",
      "integration_name": "Google Meet"
   },
   {
      "type": "object",
      "created_at": "2025-09-10T11:49:07.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlemeet",
      "object_type": "calendar_event",
      "integration_name": "Google Meet"
   },
   {
      "type": "object",
      "created_at": "2025-09-10T11:49:07.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlemeet",
      "object_type": "calendar_calendar",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_busy",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Meet"
   },
   {
      "type": "method",
      "integration_type": "googlemeet",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Meet"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googlecalendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Google Calendar"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googlecalendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_recording",
      "integration_name": "Google Calendar"
   },
   {
      "type": "object",
      "created_at": "2025-09-10T11:49:07.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlecalendar",
      "object_type": "calendar_recording",
      "integration_name": "Google Calendar"
   },
   {
      "type": "method",
      "integration_type": "googlecalendar",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Calendar"
   },
   {
      "type": "method",
      "integration_type": "googlecalendar",
      "created_at": "2025-09-10T11:49:07.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Calendar"
   },
   {
      "type": "integration",
      "created_at": "2025-09-10T00:00:00.000Z",
      "categories": [
         "genai",
         "auth",
         "passthrough"
      ],
      "integration_type": "huggingface",
      "integration_name": "Hugging Face"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2025-09-09T10:05:59.000Z",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "slow_fields",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-09-09T10:05:59.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "JobAdder"
   },
   {
      "type": "integration",
      "created_at": "2025-09-09T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "recooty",
      "integration_name": "Recooty"
   },
   {
      "type": "integration",
      "created_at": "2025-09-09T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "peopleforce",
      "integration_name": "PeopleForce"
   },
   {
      "type": "object",
      "created_at": "2025-09-08T14:16:35.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "ashby",
      "object_type": "ats_document",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2025-09-08T14:16:35.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2025-09-08T14:16:35.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2025-09-08T14:16:35.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2025-09-06T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "trakstarhire",
      "integration_name": "Trakstar Hire"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-09-04T21:14:42.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "slow_fields",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "status",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "reason",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "pagination",
      "integration_type": "trinet",
      "created_at": "2025-09-04T21:14:42.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "slow_fields",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth"
      ],
      "field": "reason",
      "integration_name": "Rippling"
   },
   {
      "type": "readable_field",
      "integration_type": "remote",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Remote.com"
   },
   {
      "type": "readable_field",
      "integration_type": "remote",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "Remote.com"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "comments",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "heavenhr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "HeavenHR"
   },
   {
      "type": "readable_field",
      "integration_type": "heavenhr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "HeavenHR"
   },
   {
      "type": "readable_field",
      "integration_type": "haileyhr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "HaileyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "slow_fields",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "ELMO"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "ELMO"
   },
   {
      "type": "pagination",
      "integration_type": "elmo",
      "created_at": "2025-09-04T21:14:42.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "slow_fields",
      "integration_name": "ELMO"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "reason",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "approver_user_id",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "reason",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-09-04T21:14:42.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "is_paid",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "text",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "task_id",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "project_id",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "follower_user_ids",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "creator_user_id",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Trello"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitwizard",
      "created_at": "2025-09-04T13:32:22.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "writable_field",
      "integration_type": "servicenow",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "category_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "category_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "object",
      "object_type": "genai_embedding",
      "integration_type": "openai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2025-09-02T18:29:55.000Z",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "OpenAI"
   },
   {
      "type": "method",
      "integration_type": "openai",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "object_type": "genai_embedding",
      "integration_type": "mistralai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2025-09-02T18:29:55.000Z",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MistralAI"
   },
   {
      "type": "method",
      "integration_type": "mistralai",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MistralAI"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "field": "category_id",
      "integration_name": "Intercom"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "category_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "category_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "object_type": "ticketing_category",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-09-02T18:29:55.000Z",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "groq",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Groq"
   },
   {
      "type": "method",
      "integration_type": "grok",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "X.ai Grok"
   },
   {
      "type": "object",
      "object_type": "genai_embedding",
      "integration_type": "googlegemini",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2025-09-02T18:29:55.000Z",
      "integration_name": "Google Gemini"
   },
   {
      "type": "method",
      "integration_type": "googlegemini",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Gemini"
   },
   {
      "type": "method",
      "integration_type": "googlegemini",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Gemini"
   },
   {
      "type": "method",
      "integration_type": "deepseek",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "DeepSeek"
   },
   {
      "type": "object",
      "object_type": "genai_embedding",
      "integration_type": "cohere",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2025-09-02T18:29:55.000Z",
      "integration_name": "Cohere"
   },
   {
      "type": "method",
      "integration_type": "cohere",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cohere"
   },
   {
      "type": "method",
      "integration_type": "cohere",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_embedding",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Cohere"
   },
   {
      "type": "writable_field",
      "integration_type": "atlassianservicedesk",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "field": "category_id",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianservicedesk",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "field": "category_id",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "object",
      "object_type": "ticketing_category",
      "integration_type": "atlassianservicedesk",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "created_at": "2025-09-02T18:29:55.000Z",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "method",
      "integration_type": "atlassianservicedesk",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "method",
      "integration_type": "atlassianservicedesk",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "method",
      "integration_type": "atlassianservicedesk",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "method",
      "integration_type": "atlassianservicedesk",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "ticketing_category",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "method",
      "integration_type": "anyscale",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AnyScale"
   },
   {
      "type": "method",
      "integration_type": "anthropicclaude",
      "created_at": "2025-09-02T18:29:55.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftintune",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-02T15:13:51.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftintune",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-02T15:13:51.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftintune",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-02T15:13:51.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftintune",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-02T15:13:51.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftintune",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-09-02T15:13:51.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "object",
      "created_at": "2025-09-02T15:13:51.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftintune",
      "object_type": "hris_group",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "method",
      "integration_type": "microsoftintune",
      "created_at": "2025-09-02T15:13:51.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "method",
      "integration_type": "microsoftintune",
      "created_at": "2025-09-02T15:13:51.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "writable_field",
      "integration_type": "openai",
      "created_at": "2025-09-01T17:30:47.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "max_tokens",
      "integration_name": "OpenAI"
   },
   {
      "type": "readable_field",
      "integration_type": "openai",
      "created_at": "2025-09-01T17:30:47.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "temperature",
      "integration_name": "OpenAI"
   },
   {
      "type": "pagination",
      "integration_type": "mistralai",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_limit",
      "integration_name": "MistralAI"
   },
   {
      "type": "pagination",
      "integration_type": "mistralai",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_offset",
      "integration_name": "MistralAI"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-01T17:30:47.000Z",
      "object_type": "repo_commit",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-09-01T17:30:47.000Z",
      "object_type": "repo_commit",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_offset",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_branch_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "anyscale",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_limit",
      "integration_name": "AnyScale"
   },
   {
      "type": "pagination",
      "integration_type": "anyscale",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_offset",
      "integration_name": "AnyScale"
   },
   {
      "type": "pagination",
      "integration_type": "anthropicclaude",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_limit",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "pagination",
      "integration_type": "anthropicclaude",
      "created_at": "2025-09-01T17:30:47.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_offset",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "integration",
      "created_at": "2025-09-01T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "grok",
      "integration_name": "X.ai Grok"
   },
   {
      "type": "pagination",
      "integration_type": "groq",
      "created_at": "2025-08-31T22:55:44.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_limit",
      "integration_name": "Groq"
   },
   {
      "type": "pagination",
      "integration_type": "groq",
      "created_at": "2025-08-31T22:55:44.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_offset",
      "integration_name": "Groq"
   },
   {
      "type": "writable_field",
      "integration_type": "openai",
      "created_at": "2025-08-31T18:44:42.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "mcp_url",
      "integration_name": "OpenAI"
   },
   {
      "type": "writable_field",
      "integration_type": "groq",
      "created_at": "2025-08-31T18:44:42.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "mcp_url",
      "integration_name": "Groq"
   },
   {
      "type": "writable_field",
      "integration_type": "googlegemini",
      "created_at": "2025-08-31T18:44:42.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "temperature",
      "integration_name": "Google Gemini"
   },
   {
      "type": "writable_field",
      "integration_type": "googlegemini",
      "created_at": "2025-08-31T18:44:42.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "mcp_url",
      "integration_name": "Google Gemini"
   },
   {
      "type": "writable_field",
      "integration_type": "cohere",
      "created_at": "2025-08-31T18:44:42.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "mcp_url",
      "integration_name": "Cohere"
   },
   {
      "type": "readable_field",
      "integration_type": "cohere",
      "created_at": "2025-08-31T18:44:42.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "Cohere"
   },
   {
      "type": "writable_field",
      "integration_type": "anthropicclaude",
      "created_at": "2025-08-31T18:44:42.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "mcp_url",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_event",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_contact",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_company",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_event",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_contact",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_company",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_offset",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_contact_id",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_offset",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_offset",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "method",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-29T15:02:07.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-29T14:40:19.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-08-29T14:40:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-08-29T14:40:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_query",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-08-29T14:40:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_name",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-08-29T14:40:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_candidate_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-08-29T10:41:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-08-29T10:41:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-08-29T10:41:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-08-29T10:41:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-08-29T10:41:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-08-29T10:41:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-08-29T10:41:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-08-29T10:41:32.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-08-29T10:41:32.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Gem"
   },
   {
      "type": "integration",
      "created_at": "2025-08-29T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "chargify",
      "integration_name": "Maxio (Chargify)"
   },
   {
      "type": "integration",
      "created_at": "2025-08-29T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "adobesign",
      "integration_name": "Adobe Sign"
   },
   {
      "type": "object",
      "created_at": "2025-08-28T16:18:48.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "recruitwizard",
      "object_type": "crm_event",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "object",
      "created_at": "2025-08-28T16:18:48.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "recruitwizard",
      "object_type": "crm_contact",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "object",
      "created_at": "2025-08-28T16:18:48.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "recruitwizard",
      "object_type": "crm_company",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "object",
      "object_type": "verification_package",
      "integration_type": "yardstik",
      "categories": [
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "Yardstik"
   },
   {
      "type": "object",
      "object_type": "verification_request",
      "integration_type": "yardstik",
      "categories": [
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "Yardstik"
   },
   {
      "type": "object",
      "object_type": "verification_package",
      "integration_type": "verifiable",
      "categories": [
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "Verifiable"
   },
   {
      "type": "object",
      "object_type": "verification_request",
      "integration_type": "verifiable",
      "categories": [
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "Verifiable"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "object_type": "verification_package",
      "integration_type": "firstadvantage",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "First Advantage"
   },
   {
      "type": "object",
      "object_type": "verification_request",
      "integration_type": "firstadvantage",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "First Advantage"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Checkr"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_request",
      "integration_name": "Checkr"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_package",
      "integration_name": "Checkr"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_package",
      "integration_name": "Checkr"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Checkr"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_request",
      "integration_name": "Checkr"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_package",
      "integration_name": "Checkr"
   },
   {
      "type": "object",
      "object_type": "verification_package",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "Checkr"
   },
   {
      "type": "object",
      "object_type": "verification_request",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_request",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_request",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_request",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_request",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_request",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_package",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2025-08-28T14:03:36.000Z",
      "object_type": "verification_package",
      "categories": [
         "hris",
         "ats",
         "verification",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Checkr"
   },
   {
      "type": "object",
      "object_type": "verification_package",
      "integration_type": "certn",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "Certn"
   },
   {
      "type": "object",
      "object_type": "verification_request",
      "integration_type": "certn",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-28T14:03:36.000Z",
      "integration_name": "Certn"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "yardstik",
      "integration_name": "Yardstik"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "verification",
         "passthrough"
      ],
      "integration_type": "verifiable",
      "integration_name": "Verifiable"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "redditads",
      "integration_name": "Reddit Ads"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "integration_type": "firstadvantage",
      "integration_name": "First Advantage"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "verification",
         "hris",
         "passthrough"
      ],
      "integration_type": "certn",
      "integration_name": "Certn"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "aweber",
      "integration_name": "AWeber"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "airtable",
      "integration_name": "Airtable"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "aha",
      "integration_name": "Aha!"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "acerta",
      "integration_name": "Acerta"
   },
   {
      "type": "integration",
      "created_at": "2025-08-28T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "1passwordevents",
      "integration_name": "1Password (Events)"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "method",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "method",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "method",
      "integration_type": "microsoftplanner",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "method",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "method",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "method",
      "integration_type": "microsoft_ad",
      "created_at": "2025-08-27T12:03:16.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Holded"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Holded"
   },
   {
      "type": "object",
      "created_at": "2025-08-26T16:20:03.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "integration_type": "holded",
      "object_type": "accounting_bill",
      "integration_name": "Holded"
   },
   {
      "type": "object",
      "created_at": "2025-08-26T16:20:03.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "integration_type": "holded",
      "object_type": "accounting_creditmemo",
      "integration_name": "Holded"
   },
   {
      "type": "object",
      "created_at": "2025-08-26T16:20:03.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "integration_type": "holded",
      "object_type": "accounting_salesorder",
      "integration_name": "Holded"
   },
   {
      "type": "object",
      "created_at": "2025-08-26T16:20:03.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "integration_type": "holded",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2025-08-26T16:20:03.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Holded"
   },
   {
      "type": "integration",
      "created_at": "2025-08-26T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftintune",
      "integration_name": "Microsoft Intune"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_document",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_document",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zambion",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "pagination",
      "integration_type": "zambion",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "pagination",
      "integration_type": "zambion",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "pagination",
      "integration_type": "zambion",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "commerce_item",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "accounting_account",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "commerce_item",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "accounting_account",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_offset",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_offset",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_offset",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_offset",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workstream",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workstream"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workstream",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "Workstream"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workstream",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Workstream"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workstream",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_application",
      "integration_name": "Workstream"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workstream",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workstream"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workstream",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "Workstream"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workstream",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Workstream"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workstream",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_application",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "Vincere"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukg_hr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_limit",
      "integration_name": "Trello"
   },
   {
      "type": "pagination",
      "integration_type": "trello",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_offset",
      "integration_name": "Trello"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_location",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_location",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "toast",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_timeshift",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_updated_gte",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_limit",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "list_offset",
      "integration_name": "Toast"
   },
   {
      "type": "pagination",
      "integration_type": "toast",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeshift",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "remote",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_company",
      "integration_name": "Remote.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "remote",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_company",
      "integration_name": "Remote.com"
   },
   {
      "type": "pagination",
      "integration_type": "remote",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_updated_gte",
      "integration_name": "Remote.com"
   },
   {
      "type": "pagination",
      "integration_type": "remote",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_limit",
      "integration_name": "Remote.com"
   },
   {
      "type": "pagination",
      "integration_type": "remote",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_offset",
      "integration_name": "Remote.com"
   },
   {
      "type": "pagination",
      "integration_type": "remote",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Remote.com"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_application",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_activity",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_interview",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_group",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_application",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_activity",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_interview",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitwizard",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_group",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_offset",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_offset",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruitwizard",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitee",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "Recruitee"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitee",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "Recruitee"
   },
   {
      "type": "pagination",
      "integration_type": "recruitee",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Recruitee"
   },
   {
      "type": "pagination",
      "integration_type": "recruitee",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Recruitee"
   },
   {
      "type": "pagination",
      "integration_type": "recruitee",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Recruitee"
   },
   {
      "type": "pagination",
      "integration_type": "recruitee",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Recruitee"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbookspayment",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "accounting_account",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbookspayment",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "accounting_account",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "pagination",
      "integration_type": "quickbookspayment",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_updated_gte",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "pagination",
      "integration_type": "quickbookspayment",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_limit",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "pagination",
      "integration_type": "quickbookspayment",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_offset",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "pagination",
      "integration_type": "quickbookspayment",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_type",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "pagination",
      "integration_type": "quickbookspayment",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "pagination",
      "integration_type": "prismhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_limit",
      "integration_name": "PrismHR"
   },
   {
      "type": "pagination",
      "integration_type": "prismhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_offset",
      "integration_name": "PrismHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "paylocityrecruiting",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "Paylocity Recruiting"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "paylocityrecruiting",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "Paylocity Recruiting"
   },
   {
      "type": "pagination",
      "integration_type": "paylocityrecruiting",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Paylocity Recruiting"
   },
   {
      "type": "pagination",
      "integration_type": "paylocityrecruiting",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Paylocity Recruiting"
   },
   {
      "type": "pagination",
      "integration_type": "paylocityrecruiting",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Paylocity Recruiting"
   },
   {
      "type": "pagination",
      "integration_type": "paylocityrecruiting",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Paylocity Recruiting"
   },
   {
      "type": "pagination",
      "integration_type": "openai",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_limit",
      "integration_name": "OpenAI"
   },
   {
      "type": "pagination",
      "integration_type": "openai",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_offset",
      "integration_name": "OpenAI"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "mercuryats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "mercuryats",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_limit",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_offset",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "marketing360",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Marketing360"
   },
   {
      "type": "pagination",
      "integration_type": "marketing360",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Marketing360"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "lemcal",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_link",
      "pagination": "list_limit",
      "integration_name": "lemcal"
   },
   {
      "type": "pagination",
      "integration_type": "lemcal",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_link",
      "pagination": "list_offset",
      "integration_name": "lemcal"
   },
   {
      "type": "pagination",
      "integration_type": "lemcal",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_calendar",
      "pagination": "list_limit",
      "integration_name": "lemcal"
   },
   {
      "type": "pagination",
      "integration_type": "lemcal",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_calendar",
      "pagination": "list_offset",
      "integration_name": "lemcal"
   },
   {
      "type": "pagination",
      "integration_type": "lemcal",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_limit",
      "integration_name": "lemcal"
   },
   {
      "type": "pagination",
      "integration_type": "lemcal",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_offset",
      "integration_name": "lemcal"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "JobDiva"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobdiva",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_limit",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_offset",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "instantlyai",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_limit",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "pagination",
      "integration_type": "instantlyai",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_offset",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "pagination",
      "integration_type": "icims",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "iCIMS"
   },
   {
      "type": "pagination",
      "integration_type": "icims",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "iCIMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "crm_company",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "crm_company",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_offset",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_limit",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_offset",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "heroku",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_group",
      "integration_name": "Heroku"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "heroku",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_group",
      "integration_name": "Heroku"
   },
   {
      "type": "pagination",
      "integration_type": "heroku",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Heroku"
   },
   {
      "type": "pagination",
      "integration_type": "heroku",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Heroku"
   },
   {
      "type": "pagination",
      "integration_type": "heroku",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Heroku"
   },
   {
      "type": "pagination",
      "integration_type": "heroku",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Heroku"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "haileyhr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "HaileyHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "haileyhr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "HaileyHR"
   },
   {
      "type": "pagination",
      "integration_type": "haileyhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "HaileyHR"
   },
   {
      "type": "pagination",
      "integration_type": "haileyhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "HaileyHR"
   },
   {
      "type": "pagination",
      "integration_type": "haileyhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "HaileyHR"
   },
   {
      "type": "pagination",
      "integration_type": "haileyhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "HaileyHR"
   },
   {
      "type": "pagination",
      "integration_type": "haileyhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "HaileyHR"
   },
   {
      "type": "pagination",
      "integration_type": "haileyhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HaileyHR"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_limit",
      "integration_name": "Gmail"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_offset",
      "integration_name": "Gmail"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fourthhr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "FourthHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fourthhr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "FourthHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fourthhr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "FourthHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fourthhr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "fireflies",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Fireflies"
   },
   {
      "type": "pagination",
      "integration_type": "fireflies",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Fireflies"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Firefish"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "deputy",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Deputy"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "deputy",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deputy",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Deputy"
   },
   {
      "type": "pagination",
      "integration_type": "deepseek",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_limit",
      "integration_name": "DeepSeek"
   },
   {
      "type": "pagination",
      "integration_type": "deepseek",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_offset",
      "integration_name": "DeepSeek"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_limit",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_offset",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "customerio",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_limit",
      "integration_name": "Customer.io"
   },
   {
      "type": "pagination",
      "integration_type": "customerio",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_offset",
      "integration_name": "Customer.io"
   },
   {
      "type": "pagination",
      "integration_type": "crezco",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "object_type": "payment_link",
      "pagination": "list_limit",
      "integration_name": "Crezco"
   },
   {
      "type": "pagination",
      "integration_type": "crezco",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "object_type": "payment_link",
      "pagination": "list_offset",
      "integration_name": "Crezco"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_busy",
      "pagination": "list_limit",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_busy",
      "pagination": "list_offset",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2025-08-25T16:24:00.000Z",
      "object_type": "ats_job",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "apollo",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_limit",
      "integration_name": "Apollo.io"
   },
   {
      "type": "pagination",
      "integration_type": "apollo",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "auth",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_offset",
      "integration_name": "Apollo.io"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_link",
      "pagination": "list_limit",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T16:24:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_link",
      "pagination": "list_offset",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-08-25T09:58:29.000Z",
      "object_type": "task_task",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-08-25T09:58:29.000Z",
      "object_type": "task_task",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_updated_gte",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_query",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_start_gte",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_end_lt",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_limit",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_order",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "pagination",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T09:58:29.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_calendar_id",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "method",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T09:58:29.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "method",
      "integration_type": "acuityscheduling",
      "created_at": "2025-08-25T09:58:29.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "integration",
      "created_at": "2025-08-25T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "successfactors_lms",
      "integration_name": "SAP SuccessFactors (LMS)"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-24T19:58:19.000Z",
      "object_type": "storage_file",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-24T19:58:19.000Z",
      "object_type": "storage_file",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_limit",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_offset",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_order",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-24T19:58:19.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "Pinpoint"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pinpoint",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-24T19:58:19.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_updated_gte",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_order",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "pinpoint",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Pinpoint"
   },
   {
      "type": "pagination",
      "integration_type": "paypal",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "commerce",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Paypal"
   },
   {
      "type": "pagination",
      "integration_type": "paypal",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "commerce",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Paypal"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_limit",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "oraclehcm",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_offset",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "HiBob"
   },
   {
      "type": "pagination",
      "integration_type": "hibob",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "HiBob"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gitlab",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-24T19:58:19.000Z",
      "object_type": "repo_commit",
      "integration_name": "GitLab"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gitlab",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-24T19:58:19.000Z",
      "object_type": "repo_commit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_offset",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_branch_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_offset",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_offset",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "list_limit",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "list_offset",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_query",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "clearcompany",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_order",
      "integration_name": "Clear Company"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_busy",
      "pagination": "list_user_id",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-08-24T19:58:19.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2025-08-24T10:11:22.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "acuityscheduling",
      "object_type": "calendar_calendar",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "object",
      "created_at": "2025-08-24T10:11:22.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "acuityscheduling",
      "object_type": "calendar_event",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zambion",
      "object_type": "hris_location",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "method",
      "integration_type": "zambion",
      "created_at": "2025-08-24T09:43:52.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "method",
      "integration_type": "zambion",
      "created_at": "2025-08-24T09:43:52.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "ukg_hr",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "pagination",
      "integration_type": "streamtime",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Streamtime"
   },
   {
      "type": "pagination",
      "integration_type": "streamtime",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Streamtime"
   },
   {
      "type": "pagination",
      "integration_type": "streamtime",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Streamtime"
   },
   {
      "type": "pagination",
      "integration_type": "streamtime",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "Streamtime"
   },
   {
      "type": "pagination",
      "integration_type": "streamtime",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "Streamtime"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_limit",
      "integration_name": "Ring Central"
   },
   {
      "type": "pagination",
      "integration_type": "ringcentral",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_offset",
      "integration_name": "Ring Central"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "deel",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-24T09:43:52.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Deel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "deel",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-24T09:43:52.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_query",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_updated_gte",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_start_gte",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_end_lt",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-08-24T09:43:52.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_query",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "googledrive",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_type",
      "integration_name": "Google Drive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "repo_commit",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "repo_repository",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "repo_organization",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "hris_employee",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "hris_company",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "task_project",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "task_task",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "repo_commit",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "repo_repository",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "repo_organization",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "hris_employee",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "hris_company",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "task_project",
      "integration_name": "BitBucket"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bitbucket",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "task_task",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_offset",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_order",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_offset",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_order",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_offset",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_sort_by_name",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "list_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "list_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "list_offset",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "list_order",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_offset",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_order",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_offset",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_name",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_offset",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_order",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2025-08-22T15:14:29.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2025-08-22T15:14:29.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "slow_fields",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "Firefish"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "firefish",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-20T14:35:24.000Z",
      "object_type": "crm_event",
      "integration_name": "Firefish"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "firefish",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-08-20T14:35:24.000Z",
      "object_type": "crm_event",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_limit",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_offset",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_type",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-08-20T14:35:24.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-19T11:52:56.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "has_tasks",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-19T11:52:56.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "integration",
      "created_at": "2025-08-19T00:00:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "integration_type": "fathom",
      "integration_name": "Fathom"
   },
   {
      "type": "integration",
      "created_at": "2025-08-19T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "clover",
      "integration_name": "Clover"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-08-18T16:14:05.000Z",
      "object_type": "ats_document",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "document_url",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "object",
      "created_at": "2025-08-18T11:12:55.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "autodesk",
      "object_type": "passthrough",
      "integration_name": "Autodesk"
   },
   {
      "type": "integration",
      "created_at": "2025-08-18T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "telegram",
      "integration_name": "Telegram"
   },
   {
      "type": "integration",
      "created_at": "2025-08-18T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "revsport",
      "integration_name": "Rev Sport"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "tribepad",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "Tribepad"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "minimum_experience_years",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "minimum_experience_years",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "googlecontacts",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Contacts"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "minimum_degree",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-08-15T11:05:26.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "native_webhook_parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "minimum_experience_years",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "minimum_degree",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "object_type": "task_change",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-08-15T11:05:26.000Z",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "task_change",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2025-08-15T11:05:26.000Z",
      "object_type": "task_change",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "integration",
      "created_at": "2025-08-15T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "threads",
      "integration_name": "Threads"
   },
   {
      "type": "integration",
      "created_at": "2025-08-15T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "recruitwizard",
      "integration_name": "Recruit Wizard"
   },
   {
      "type": "integration",
      "created_at": "2025-08-15T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "mastodon",
      "integration_name": "Mastodon"
   },
   {
      "type": "integration",
      "created_at": "2025-08-15T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "bluesky",
      "integration_name": "Bluesky"
   },
   {
      "type": "integration",
      "created_at": "2025-08-14T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgpro_ats",
      "integration_name": "UKG Pro ATS"
   },
   {
      "type": "integration",
      "created_at": "2025-08-14T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "twilio",
      "integration_name": "Twilio"
   },
   {
      "type": "integration",
      "created_at": "2025-08-14T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "tiktok",
      "integration_name": "TikTok"
   },
   {
      "type": "integration",
      "created_at": "2025-08-14T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "instagram",
      "integration_name": "Instagram"
   },
   {
      "type": "integration",
      "created_at": "2025-08-14T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "capsulecrm",
      "integration_name": "Capsule CRM"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_report",
      "pagination": "list_category_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_balancesheet",
      "pagination": "list_category_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_profitloss",
      "pagination": "list_category_id",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "customer_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "object_type": "kms_page",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "ServiceNow"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "customer_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_query",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_order",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_user_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_customer_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_query",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_order",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_query",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_order",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_space_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "list_query",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "list_order",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_report",
      "pagination": "list_category_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_report",
      "pagination": "list_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_balancesheet",
      "pagination": "list_category_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_balancesheet",
      "pagination": "list_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_profitloss",
      "pagination": "list_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-08-08T13:09:59.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_profitloss",
      "pagination": "list_category_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "integration",
      "created_at": "2025-08-08T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "snapchat",
      "integration_name": "Snapchat"
   },
   {
      "type": "integration",
      "created_at": "2025-08-08T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "canva",
      "integration_name": "Canva"
   },
   {
      "type": "integration",
      "created_at": "2025-08-07T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "wayfair",
      "integration_name": "Wayfair"
   },
   {
      "type": "integration",
      "created_at": "2025-08-07T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "surveymonkey",
      "integration_name": "SurveyMonkey"
   },
   {
      "type": "integration",
      "created_at": "2025-08-07T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "spotify",
      "integration_name": "Spotify"
   },
   {
      "type": "integration",
      "created_at": "2025-08-07T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "figma",
      "integration_name": "Figma"
   },
   {
      "type": "integration",
      "created_at": "2025-08-07T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "digitalocean",
      "integration_name": "DigitalOcean"
   },
   {
      "type": "integration",
      "created_at": "2025-08-07T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "airwallex",
      "integration_name": "Airwallex"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "vendor_name",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "variants",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "global_code",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Walmart"
   },
   {
      "type": "object",
      "created_at": "2025-08-06T18:12:53.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "integration_type": "walmart",
      "object_type": "metadata_metadata",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2025-08-06T18:12:53.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-05T16:24:52.000Z",
      "object_type": "storage_file",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-08-05T16:24:52.000Z",
      "object_type": "storage_file",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2025-08-05T16:24:52.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2025-08-05T16:24:52.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "object",
      "created_at": "2025-08-05T16:24:52.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "sageaccounting",
      "object_type": "storage_file",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-08-05T16:24:52.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-08-05T16:24:52.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-08-05T16:24:52.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-08-05T16:24:52.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-08-05T16:24:52.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "storage_file",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "storage_file",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-08-01T14:32:48.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_bill",
      "pagination": "slow_fields",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-08-01T14:32:48.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_creditmemo",
      "pagination": "slow_fields",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "created_at": "2025-08-01T14:32:48.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "quickbooks",
      "object_type": "storage_file",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "is_private",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "is_free",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "is_all_day",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "has_conference",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "conference",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "calendar_id",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "writable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "attendees",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "method",
      "integration_type": "appleicloud",
      "created_at": "2025-08-01T14:32:48.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "object",
      "object_type": "accounting_category",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-31T16:45:20.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_category",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-31T16:45:20.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_category",
      "integration_type": "pennylane",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-07-31T16:45:20.000Z",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-07-31T16:45:20.000Z",
      "object_type": "accounting_category",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pennylane"
   },
   {
      "type": "integration",
      "created_at": "2025-07-31T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "youtube",
      "integration_name": "YouTube"
   },
   {
      "type": "integration",
      "created_at": "2025-07-31T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "googletasks",
      "integration_name": "Google Tasks"
   },
   {
      "type": "integration",
      "created_at": "2025-07-31T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "googleslides",
      "integration_name": "Google Slides"
   },
   {
      "type": "integration",
      "created_at": "2025-07-31T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "googlesheets",
      "integration_name": "Google Sheets"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-07-30T16:03:44.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-07-30T16:03:44.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "native_webhook_parent_id",
      "integration_name": "Notion"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-07-30T16:03:44.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-07-30T16:03:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-07-30T16:03:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-07-30T16:03:44.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-07-30T16:03:44.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "integration",
      "created_at": "2025-07-28T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "googleanalyticsadmin",
      "integration_name": "Google Analytics (Admin)"
   },
   {
      "type": "integration",
      "created_at": "2025-07-26T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "googlemerchant",
      "integration_name": "Google Merchant Center"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2025-07-25T15:01:02.000Z",
      "object_type": "kms_page",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-07-25T15:01:02.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-07-25T15:01:02.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "slow_fields",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-07-25T11:14:49.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_balancesheet",
      "pagination": "slow_fields",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-07-25T11:14:49.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "root_message_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemail",
      "created_at": "2025-07-25T11:14:49.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "root_message_id",
      "integration_name": "Gmail"
   },
   {
      "type": "integration",
      "created_at": "2025-07-25T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "teamleader",
      "integration_name": "TeamLeader"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "task",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "meeting",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "marketing_email",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "email",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "task",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "meeting",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "marketing_email",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "email",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-07-24T10:39:44.000Z",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "monday",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-07-22T12:52:03.000Z",
      "object_type": "task_task",
      "integration_name": "Monday"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "monday",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-07-22T12:52:03.000Z",
      "object_type": "task_task",
      "integration_name": "Monday"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "monday",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-07-22T12:52:03.000Z",
      "object_type": "task_task",
      "integration_name": "Monday"
   },
   {
      "type": "pagination",
      "integration_type": "monday",
      "created_at": "2025-07-22T12:52:03.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "native_webhook_project_id",
      "integration_name": "Monday"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2025-07-22T12:52:03.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-07-18T10:08:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "integration",
      "created_at": "2025-07-18T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "yahoo",
      "integration_name": "Yahoo"
   },
   {
      "type": "integration",
      "created_at": "2025-07-18T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "8x8",
      "integration_name": "8x8 Connect"
   },
   {
      "type": "integration",
      "created_at": "2025-07-17T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "googledocs",
      "integration_name": "Google Docs"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-07-16T11:04:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-07-16T11:04:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-07-16T11:04:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-07-16T11:04:30.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2025-07-16T11:04:30.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2025-07-16T11:04:30.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2025-07-16T11:04:30.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2025-07-16T11:04:30.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-07-14T12:59:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-07-11T10:59:17.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_balancesheet",
      "pagination": "list_start_gte",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-07-11T10:59:17.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_trialbalance",
      "pagination": "list_start_gte",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-10T15:58:15.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-07-10T15:58:15.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2025-07-09T17:24:04.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2025-07-09T17:24:04.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2025-07-09T17:24:04.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "integration_type": "myob",
      "object_type": "storage_file",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-09T17:24:04.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-07-09T16:57:28.000Z",
      "object_type": "ats_application",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2025-07-09T16:57:28.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "writable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "readable_field",
      "integration_type": "mercuryats",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Google Contacts"
   },
   {
      "type": "method",
      "integration_type": "googlecontacts",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Contacts"
   },
   {
      "type": "method",
      "integration_type": "googlecontacts",
      "created_at": "2025-07-09T11:45:46.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Contacts"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_bill",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_salesorder",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_purchaseorder",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_salesorder",
      "integration_type": "yotpo",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "yotpo"
   },
   {
      "type": "method",
      "integration_type": "yotpo",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "yotpo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_type",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_type",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_bill",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_purchaseorder",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_balancesheet",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_trialbalance",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_profitloss",
      "integration_type": "xero",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Walmart"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Walmart"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Walmart"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Walmart"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "Walmart"
   },
   {
      "type": "object",
      "object_type": "accounting_purchaseorder",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Walmart"
   },
   {
      "type": "object",
      "object_type": "accounting_salesorder",
      "integration_type": "toast",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "object",
      "object_type": "accounting_bill",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "object",
      "object_type": "accounting_trialbalance",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "object",
      "object_type": "accounting_bill",
      "integration_type": "ramp",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Ramp"
   },
   {
      "type": "object",
      "object_type": "accounting_purchaseorder",
      "integration_type": "ramp",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ramp"
   },
   {
      "type": "method",
      "integration_type": "ramp",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ramp"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_bill",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_creditmemo",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_purchaseorder",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_balancesheet",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_trialbalance",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_profitloss",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_balancesheet",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_trialbalance",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_profitloss",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_bill",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_creditmemo",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_salesorder",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_purchaseorder",
      "integration_type": "netsuite",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "object_type": "accounting_bill",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "object_type": "accounting_salesorder",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "object_type": "accounting_purchaseorder",
      "integration_type": "myob",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_salesorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_purchaseorder",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "integration_name": "Bill.com"
   },
   {
      "type": "object",
      "object_type": "accounting_bill",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Bill.com"
   },
   {
      "type": "object",
      "object_type": "accounting_creditmemo",
      "integration_type": "bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-07-04T18:35:05.000Z",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_bill",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Bill.com"
   },
   {
      "type": "method",
      "integration_type": "bill",
      "created_at": "2025-07-04T18:35:05.000Z",
      "object_type": "accounting_creditmemo",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bill.com"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2025-07-02T16:57:36.000Z",
      "object_type": "crm_deal",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2025-07-02T16:57:36.000Z",
      "object_type": "crm_contact",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2025-07-02T16:57:36.000Z",
      "object_type": "crm_company",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2025-07-02T16:57:36.000Z",
      "object_type": "crm_deal",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2025-07-02T16:57:36.000Z",
      "object_type": "crm_contact",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2025-07-02T16:57:36.000Z",
      "object_type": "crm_company",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2025-07-02T16:57:36.000Z",
      "object_type": "crm_deal",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2025-07-02T16:57:36.000Z",
      "object_type": "crm_contact",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2025-07-02T16:57:36.000Z",
      "object_type": "crm_company",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-07-02T14:36:23.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-07-02T14:36:23.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-07-02T14:36:23.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "slackbot",
      "created_at": "2025-07-02T14:07:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "reactions",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "slackbot",
      "created_at": "2025-07-02T14:07:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "reactions",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2025-07-02T14:07:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2025-07-02T14:07:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "reactions",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-07-02T14:07:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "reactions",
      "integration_name": "Slack"
   },
   {
      "type": "method",
      "integration_type": "slack",
      "created_at": "2025-07-02T14:07:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-07-02T14:07:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "reactions",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-07-02T14:07:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "reactions",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-07-02T14:07:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2025-07-02T14:07:13.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Asana"
   },
   {
      "type": "integration",
      "created_at": "2025-07-02T00:00:00.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "phoneburner",
      "integration_name": "PhoneBurner"
   },
   {
      "type": "writable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-06-27T19:16:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "phone",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "writable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-06-27T19:16:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "name",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "writable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-06-27T19:16:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "address",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "method",
      "integration_type": "pcrecruiter",
      "created_at": "2025-06-27T19:16:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "method": "create",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "method",
      "integration_type": "pcrecruiter",
      "created_at": "2025-06-27T19:16:11.000Z",
      "object_type": "ats_company",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "method": "update",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "object",
      "created_at": "2025-06-27T14:38:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "mercuryats",
      "object_type": "ats_activity",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-06-27T14:38:05.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-06-27T14:38:05.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "method",
      "integration_type": "mercuryats",
      "created_at": "2025-06-27T14:38:05.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "monday",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "hris_group",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Monday"
   },
   {
      "type": "object",
      "created_at": "2025-06-26T11:38:22.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "monday",
      "object_type": "task_project",
      "integration_name": "Monday"
   },
   {
      "type": "object",
      "created_at": "2025-06-26T11:38:22.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "monday",
      "object_type": "task_task",
      "integration_name": "Monday"
   },
   {
      "type": "object",
      "created_at": "2025-06-26T11:38:22.000Z",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "monday",
      "object_type": "metadata_metadata",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "task_project",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "task_project",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "task_project",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "task_project",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "task_task",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "task_task",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "task_task",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "task_task",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Monday"
   },
   {
      "type": "method",
      "integration_type": "monday",
      "created_at": "2025-06-26T11:38:22.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Monday"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-06-24T16:58:35.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-23T11:24:03.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-23T11:24:03.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-23T11:24:03.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "members",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "imap",
      "created_at": "2025-06-23T11:24:03.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging"
      ],
      "field": "parent_id",
      "integration_name": "IMAP"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2025-06-23T11:24:03.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2025-06-23T11:24:03.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "webex",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "conference",
      "integration_name": "Webex"
   },
   {
      "type": "readable_field",
      "integration_type": "savvycal",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "conference",
      "integration_name": "SavvyCal"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "has_conference",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "conference",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "has_conference",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "conference",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-20T15:39:19.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "has_conference",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "conference",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "has_conference",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "conference",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-06-20T15:39:19.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "conference",
      "integration_name": "Google Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "conference",
      "integration_name": "Google Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-06-20T15:39:19.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Google Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-20T12:03:26.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-20T12:03:26.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-20T12:03:26.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-20T12:03:26.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-20T12:03:26.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "task",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-06-20T12:03:26.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "mercuryats",
      "created_at": "2025-06-20T12:03:26.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-06-19T10:48:47.000Z",
      "object_type": "ats_document",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-06-19T10:48:47.000Z",
      "object_type": "ats_document",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2025-06-19T10:48:47.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "ats_document",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-06-19T10:48:47.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-06-19T10:48:47.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-06-19T10:48:47.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-06-19T10:48:47.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-06-19T10:48:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-06-19T10:48:47.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-06-19T10:48:47.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_limit",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-06-19T10:48:47.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-06-18T10:01:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-06-18T10:01:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-06-18T10:01:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-06-18T10:01:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-06-17T14:10:13.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "slow_fields",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_message_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "message_markdown",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "message_html",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "message",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "mentioned_members",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channel_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "author_member",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_message_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_query",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_query",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_parent_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-17T14:10:13.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "accounting_order",
      "integration_name": "Walmart"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "accounting_order",
      "integration_name": "Walmart"
   },
   {
      "type": "pagination",
      "integration_type": "walmart",
      "created_at": "2025-06-17T09:52:36.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_updated_gte",
      "integration_name": "Walmart"
   },
   {
      "type": "pagination",
      "integration_type": "walmart",
      "created_at": "2025-06-17T09:52:36.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_limit",
      "integration_name": "Walmart"
   },
   {
      "type": "pagination",
      "integration_type": "walmart",
      "created_at": "2025-06-17T09:52:36.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_offset",
      "integration_name": "Walmart"
   },
   {
      "type": "pagination",
      "integration_type": "walmart",
      "created_at": "2025-06-17T09:52:36.000Z",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "accounting_order",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "accounting_order",
      "categories": [
         "commerce",
         "accounting",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pcrecruiter",
      "created_at": "2025-06-17T09:52:36.000Z",
      "object_type": "hris_employee",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "field": "employment_status",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "integration",
      "created_at": "2025-06-14T00:00:00.000Z",
      "categories": [
         "calendar",
         "hris",
         "passthrough"
      ],
      "integration_type": "fireflies",
      "integration_name": "Fireflies"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "postings",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "writable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_company",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_project",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_event",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_activity",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_company",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_project",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_event",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trackerrms",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_activity",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "rejected_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "postings",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "pagination",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2025-06-13T15:59:42.000Z",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "crm_company",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2025-06-13T15:59:42.000Z",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "task_project",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2025-06-13T15:59:42.000Z",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "task_task",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2025-06-13T15:59:42.000Z",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "crm_event",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "object",
      "created_at": "2025-06-13T15:59:42.000Z",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "object_type": "ats_activity",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_project",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "method",
      "integration_type": "trackerrms",
      "created_at": "2025-06-13T15:59:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "crm",
         "ats",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-06-13T15:34:13.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "stage",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-06-13T15:34:13.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2025-06-13T15:34:13.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_pipeline_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2025-06-13T15:34:13.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2025-06-13T15:34:13.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_pipeline_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:34:13.000Z",
      "object_type": "accounting_order",
      "integration_name": "Walmart"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:34:13.000Z",
      "object_type": "accounting_order",
      "integration_name": "Walmart"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "walmart",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2025-06-13T15:34:13.000Z",
      "object_type": "accounting_order",
      "integration_name": "Walmart"
   },
   {
      "type": "object",
      "created_at": "2025-06-13T15:34:13.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "walmart",
      "object_type": "accounting_order",
      "integration_name": "Walmart"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-06-13T15:34:13.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-06-13T15:34:13.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_pipeline_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-06-13T15:34:13.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_pipeline_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-06-13T15:34:13.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_pipeline_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-06-13T15:34:13.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_pipeline_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-06-13T14:49:38.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-06-13T14:49:38.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-06-13T14:49:38.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-06-13T14:49:38.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-06-13T14:49:38.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-06-13T14:49:38.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-06-13T14:49:38.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-06-13T14:49:38.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "walmart",
      "created_at": "2025-06-13T14:33:57.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_item_id",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Walmart"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_limit",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_offset",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_channel_id",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "method",
      "integration_type": "slackbot",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "has_tasks",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-06-13T14:33:57.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "slow_fields",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2025-06-13T14:33:57.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-06-13T14:33:57.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "slow_fields",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "has_conference",
      "integration_name": "Google Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "has_conference",
      "integration_name": "Google Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "size",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "mime_type",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "hash",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "data",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2025-06-13T11:25:34.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Box"
   },
   {
      "type": "integration",
      "created_at": "2025-06-13T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "mercuryats",
      "integration_name": "Mercury ATS"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-06-12T12:24:21.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_status",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2025-06-12T12:24:21.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "message_markdown",
      "integration_name": "Slack"
   },
   {
      "type": "integration",
      "created_at": "2025-06-12T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "slackbot",
      "integration_name": "Slack (bot)"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-06-10T15:39:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_candidate_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "breezyhr",
      "created_at": "2025-06-09T08:19:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "breezyhr",
      "created_at": "2025-06-09T08:19:48.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2025-06-09T08:19:48.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2025-06-09T08:19:48.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2025-06-09T08:19:48.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_company_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2025-06-09T08:19:48.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2025-06-09T08:19:48.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_company_id",
      "integration_name": "BreezyHR"
   },
   {
      "type": "object",
      "created_at": "2025-06-09T08:19:48.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "breezyhr",
      "object_type": "ats_company",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2025-06-09T08:19:48.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2025-06-09T08:19:48.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BreezyHR"
   },
   {
      "type": "object",
      "created_at": "2025-06-06T09:15:48.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "walmart",
      "object_type": "commerce_item",
      "integration_name": "Walmart"
   },
   {
      "type": "object",
      "created_at": "2025-06-06T09:15:48.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "walmart",
      "object_type": "commerce_inventory",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Walmart"
   },
   {
      "type": "method",
      "integration_type": "walmart",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-06-06T09:15:48.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_busy",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-06-06T09:15:48.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_busy",
      "pagination": "list_user_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "object",
      "created_at": "2025-06-06T09:15:48.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftoutlook",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "ssn_sin",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "name",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "locations",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "language_locale",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "id",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "hired_at",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "gender",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "employment_type",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "employment_status",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "employee_roles",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "date_of_birth",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "compensation",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "writable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "address",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "locations",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "create",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "update",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "method",
      "integration_type": "dayforce",
      "created_at": "2025-06-06T09:15:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "remove",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_taxrate",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "commerce_inventory",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "commerce_collection",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "commerce_item",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "commerce_location",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "payment_refund",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "payment_payment",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "payment_subscription",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "payment_payout",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-06-05T09:52:24.000Z",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "hris_payslip",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_refund",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_refund",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_payout",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "payment_payout",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-06-05T09:52:24.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "accounting",
         "payment",
         "crm",
         "task",
         "commerce",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "integration",
      "created_at": "2025-06-05T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "prismhr",
      "integration_name": "PrismHR"
   },
   {
      "type": "integration",
      "created_at": "2025-06-04T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "walmart",
      "integration_name": "Walmart"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "workday_legacy",
      "created_at": "2025-06-02T22:42:07.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "readable_field",
      "integration_type": "trackerrms",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "ats",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesflare",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm"
      ],
      "field": "image_url",
      "integration_name": "Salesflare"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "myob",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "MYOB"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "marketing360",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Marketing360"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecontacts",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Google Contacts"
   },
   {
      "type": "writable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2025-06-02T22:42:07.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2025-06-02T13:39:28.000Z",
      "categories": [
         "accounting",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_type",
      "integration_name": "Pennylane"
   },
   {
      "type": "integration",
      "created_at": "2025-06-02T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "payment",
         "storage",
         "passthrough"
      ],
      "integration_type": "bill",
      "integration_name": "Bill.com"
   },
   {
      "type": "object",
      "created_at": "2025-05-28T16:56:57.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "firefish",
      "object_type": "crm_event",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-05-28T16:56:57.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-05-28T16:56:57.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-05-28T16:56:57.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Firefish"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2025-05-27T13:18:55.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2025-05-27T13:18:55.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "field": "download_url",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-05-27T13:18:55.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_updated_gte",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2025-05-27T11:57:34.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Gmail"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2025-05-27T11:57:34.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_updated_gte",
      "integration_name": "Gmail"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2025-05-27T11:57:34.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "slow_fields",
      "integration_name": "Gmail"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-05-26T13:31:34.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-05-26T13:31:34.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "salsify",
      "created_at": "2025-05-26T13:31:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salsify"
   },
   {
      "type": "integration",
      "created_at": "2025-05-26T00:00:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "quickbookspayment",
      "integration_name": "Quickbooks Payments"
   },
   {
      "type": "object",
      "object_type": "hris_timeshift",
      "integration_type": "trinet",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-05-25T15:00:03.000Z",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2025-05-25T15:00:03.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2025-05-25T15:00:03.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "object",
      "object_type": "hris_timeshift",
      "integration_type": "toast",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-05-25T15:00:03.000Z",
      "integration_name": "Toast"
   },
   {
      "type": "object",
      "object_type": "hris_timeshift",
      "integration_type": "squareup",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "created_at": "2025-05-25T15:00:03.000Z",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2025-05-25T15:00:03.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SquareUp"
   },
   {
      "type": "method",
      "integration_type": "squareup",
      "created_at": "2025-05-25T15:00:03.000Z",
      "object_type": "hris_timeshift",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SquareUp"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-05-25T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "FourthHR"
   },
   {
      "type": "object",
      "created_at": "2025-05-25T15:00:03.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "fourthhr",
      "object_type": "hris_location",
      "integration_name": "FourthHR"
   },
   {
      "type": "method",
      "integration_type": "fourthhr",
      "created_at": "2025-05-25T15:00:03.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "pagination",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "pagination",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_location_id",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "pagination",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_query",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "object",
      "created_at": "2025-05-25T12:14:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "trinet",
      "object_type": "hris_group",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "object",
      "created_at": "2025-05-25T12:14:05.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "trinet",
      "object_type": "hris_timeoff",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "method",
      "integration_type": "trinet",
      "created_at": "2025-05-25T12:14:05.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "integration",
      "created_at": "2025-05-25T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "toast",
      "integration_name": "Toast"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "googlecalendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-23T16:46:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Google Calendar"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "googlecalendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-23T16:46:43.000Z",
      "object_type": "calendar_calendar",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-23T16:46:43.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "native_webhook_calendar_id",
      "integration_name": "Google Calendar"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "firefish",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-05-23T16:46:43.000Z",
      "object_type": "crm_contact",
      "integration_name": "Firefish"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "firefish",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-05-23T16:46:43.000Z",
      "object_type": "crm_contact",
      "integration_name": "Firefish"
   },
   {
      "type": "object",
      "created_at": "2025-05-23T16:46:43.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "firefish",
      "object_type": "crm_contact",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-05-23T16:46:43.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-05-23T16:46:43.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-05-23T16:46:43.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-05-23T16:46:43.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-05-23T16:46:43.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-05-23T16:46:43.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-05-23T16:46:43.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-05-23T16:46:43.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2025-05-23T16:46:43.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "objects",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-05-23T15:42:59.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-05-23T15:42:59.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2025-05-22T15:08:43.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "ats_document",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-05-22T15:08:43.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-05-22T15:08:43.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "integration",
      "created_at": "2025-05-22T00:00:00.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "eploy",
      "integration_name": "Eploy"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2025-05-21T17:20:38.000Z",
      "object_type": "hris_employee",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2025-05-21T17:20:38.000Z",
      "object_type": "hris_employee",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-05-21T17:20:38.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-05-21T17:20:38.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-05-21T17:20:38.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "hris",
         "ats"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_type",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "pcrecruiter",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_type",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_type",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "icims",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "iCIMS"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "firefish",
      "created_at": "2025-05-21T16:01:07.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_type",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2025-05-21T16:01:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_type",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "paradox",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Paradox"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "paradox",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Paradox"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Paradox"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Paradox"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "send",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "section",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "paid_amount",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "invoice_number",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "balance",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "amount",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "section",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_type",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_contact",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_journal",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_order",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "task_project",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "task_task",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "crm_event",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_company",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_deal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_event",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_event",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_event",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_event",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "NetSuite"
   },
   {
      "type": "method",
      "integration_type": "netsuite",
      "created_at": "2025-05-21T11:59:12.000Z",
      "object_type": "crm_event",
      "categories": [
         "accounting",
         "crm",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-05-21T11:59:12.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_parent_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_call",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_contact",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_recording",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_call",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_contact",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_recording",
      "integration_name": "Outreach.io"
   },
   {
      "type": "object",
      "created_at": "2025-05-16T12:11:04.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "integration_type": "outreach",
      "object_type": "uc_call",
      "integration_name": "Outreach.io"
   },
   {
      "type": "object",
      "created_at": "2025-05-16T12:11:04.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "integration_type": "outreach",
      "object_type": "uc_contact",
      "integration_name": "Outreach.io"
   },
   {
      "type": "object",
      "created_at": "2025-05-16T12:11:04.000Z",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "integration_type": "outreach",
      "object_type": "uc_recording",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Outreach.io"
   },
   {
      "type": "method",
      "integration_type": "outreach",
      "created_at": "2025-05-16T12:11:04.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "hris",
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_org_id",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_org_id",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "object",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohoinvoice",
      "object_type": "accounting_organization",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "method",
      "integration_type": "zohoinvoice",
      "created_at": "2025-05-16T11:55:45.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "freshbooks",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_org_id",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2025-05-16T11:55:45.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2025-05-16T11:55:45.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_org_id",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-05-16T11:55:45.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "zoom",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Zoom"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "recurring_event_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "field": "recurring_event_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Google Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "recurring_event_id",
      "integration_name": "Google Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Google Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "appleicloud",
      "created_at": "2025-05-16T10:13:34.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "field": "recurrence",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "integration",
      "created_at": "2025-05-16T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "messaging",
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "ringcentral",
      "integration_name": "Ring Central"
   },
   {
      "type": "integration",
      "created_at": "2025-05-16T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "adpsso",
      "integration_name": "ADP Workforce Now - SSO"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2025-05-15T11:36:03.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2025-05-15T11:36:03.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_sort_by_name",
      "integration_name": "Zendesk"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-15T11:36:03.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Google Calendar"
   },
   {
      "type": "readable_field",
      "integration_type": "calendly",
      "created_at": "2025-05-15T11:36:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-05-15T11:36:03.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_busy",
      "pagination": "list_start_gte",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-05-15T11:36:03.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_busy",
      "pagination": "list_end_lt",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2025-05-15T11:36:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Calendly"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2025-05-15T11:36:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-05-15T11:36:03.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "object",
      "created_at": "2025-05-15T11:36:03.000Z",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "bitbucket",
      "object_type": "hris_company",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2025-05-15T11:36:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2025-05-15T11:36:03.000Z",
      "object_type": "hris_company",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2025-05-15T11:36:03.000Z",
      "object_type": "hris_company",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2025-05-15T11:36:03.000Z",
      "object_type": "task_project",
      "categories": [
         "repo",
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-05-12T17:03:25.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "trial_balance",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-05-12T17:03:25.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "profit_and_loss",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-05-12T17:03:25.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "balance_sheet",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "fourthhr",
      "created_at": "2025-05-09T14:15:02.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "FourthHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sagehr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-05-09T11:19:05.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Sage HR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sagehr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-05-09T11:19:05.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Sage HR"
   },
   {
      "type": "object",
      "created_at": "2025-05-09T11:19:05.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "sagehr",
      "object_type": "hris_timeoff",
      "integration_name": "Sage HR"
   },
   {
      "type": "method",
      "integration_type": "sagehr",
      "created_at": "2025-05-09T11:19:05.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-09T11:19:05.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Google Calendar"
   },
   {
      "type": "object",
      "created_at": "2025-05-09T11:19:05.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "breezyhr",
      "object_type": "ats_activity",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2025-05-09T11:19:05.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2025-05-09T11:19:05.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-05-08T14:08:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-05-08T14:08:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-05-08T14:08:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-05-08T14:08:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-05-08T14:08:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2025-05-08T14:08:37.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "FourthHR"
   },
   {
      "type": "object",
      "created_at": "2025-05-07T13:18:07.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "integration_type": "justcall",
      "object_type": "uc_recording",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2025-05-07T13:18:07.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JustCall"
   },
   {
      "type": "method",
      "integration_type": "justcall",
      "created_at": "2025-05-07T13:18:07.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JustCall"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "commerce_item",
      "integration_name": "Wave"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Wave"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "commerce_item",
      "integration_name": "Wave"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "wave",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_org_id",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_limit",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_offset",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_updated_gte",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_limit",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_offset",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_name",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_collection_id",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wave"
   },
   {
      "type": "object",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "wave",
      "object_type": "accounting_invoice",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "object",
      "created_at": "2025-05-07T12:55:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "sageaccounting",
      "object_type": "accounting_report",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Calendar"
   },
   {
      "type": "method",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Calendar"
   },
   {
      "type": "method",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-07T12:55:55.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Google Calendar"
   },
   {
      "type": "object",
      "object_type": "commerce_review",
      "integration_type": "yotpo",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "created_at": "2025-05-07T11:47:13.000Z",
      "integration_name": "yotpo"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2025-05-07T11:47:13.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2025-05-07T11:47:13.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2025-05-07T11:47:13.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-05-07T11:47:13.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-05-07T11:47:13.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-05-06T13:44:50.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-05-06T10:42:42.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-05-06T10:42:42.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-05-06T10:42:42.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-05-05T14:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_order",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-05-05T14:24:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "slow_fields",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-05-05T14:24:00.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-05-05T14:24:00.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-05-05T14:24:00.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-05-05T14:24:00.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-05-05T12:11:34.000Z",
      "object_type": "crm_event",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-05-05T12:11:34.000Z",
      "object_type": "crm_event",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_query",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_company_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_contact_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_contact_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-05-05T12:11:34.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_call",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_recording",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_contact",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_call",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_recording",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_contact",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_query",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_offset",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_order",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_query",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_offset",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_order",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_sort_by_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_query",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_offset",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_order",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_sort_by_name",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_call",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "uc_contact",
      "categories": [
         "crm",
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Employment Hero"
   },
   {
      "type": "pagination",
      "integration_type": "employmenthero",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_company_id",
      "integration_name": "Employment Hero"
   },
   {
      "type": "pagination",
      "integration_type": "employmenthero",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "Employment Hero"
   },
   {
      "type": "pagination",
      "integration_type": "employmenthero",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_company_id",
      "integration_name": "Employment Hero"
   },
   {
      "type": "object",
      "created_at": "2025-05-05T08:24:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "employmenthero",
      "object_type": "hris_company",
      "integration_name": "Employment Hero"
   },
   {
      "type": "method",
      "integration_type": "employmenthero",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Employment Hero"
   },
   {
      "type": "method",
      "integration_type": "employmenthero",
      "created_at": "2025-05-05T08:24:32.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Employment Hero"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2025-05-01T11:50:00.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2025-05-01T11:50:00.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "created_at": "2025-05-01T11:50:00.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "salesloft",
      "object_type": "uc_call",
      "integration_name": "Salesloft"
   },
   {
      "type": "object",
      "created_at": "2025-05-01T11:50:00.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "salesloft",
      "object_type": "uc_recording",
      "integration_name": "Salesloft"
   },
   {
      "type": "object",
      "created_at": "2025-05-01T11:50:00.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "salesloft",
      "object_type": "uc_contact",
      "integration_name": "Salesloft"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-05-01T11:50:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-05-01T11:50:00.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "googlecalendar",
      "created_at": "2025-05-01T11:50:00.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "field": "calendar_id",
      "integration_name": "Google Calendar"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-05-01T11:50:00.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-05-01T11:50:00.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-05-01T11:50:00.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-05-01T11:50:00.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "salsify",
      "created_at": "2025-05-01T10:02:14.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salsify"
   },
   {
      "type": "object",
      "created_at": "2025-05-01T09:38:26.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "wave",
      "object_type": "accounting_account",
      "integration_name": "Wave"
   },
   {
      "type": "object",
      "created_at": "2025-05-01T09:38:26.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "wave",
      "object_type": "commerce_collection",
      "integration_name": "Wave"
   },
   {
      "type": "object",
      "created_at": "2025-05-01T09:38:26.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "wave",
      "object_type": "commerce_item",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-01T09:38:26.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-01T09:38:26.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-01T09:38:26.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-01T09:38:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Wave"
   },
   {
      "type": "method",
      "integration_type": "wave",
      "created_at": "2025-05-01T09:38:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-05-01T09:38:26.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_user_id",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-05-01T09:38:26.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-04-30T17:01:50.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_user_id",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-04-30T17:01:50.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_start_gte",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_end_lt",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoomphone",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_end_lt",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_start_gte",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_end_lt",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_start_gte",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_end_lt",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_start_gte",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_end_lt",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_start_gte",
      "integration_name": "Webex"
   },
   {
      "type": "pagination",
      "integration_type": "webex",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_end_lt",
      "integration_name": "Webex"
   },
   {
      "type": "readable_field",
      "integration_type": "sageintacct",
      "created_at": "2025-04-29T11:21:41.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "balance",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_start_gte",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_end_lt",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_start_gte",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_end_lt",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_start_gte",
      "integration_name": "Google Meet"
   },
   {
      "type": "pagination",
      "integration_type": "googlemeet",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_recording",
      "pagination": "list_end_lt",
      "integration_name": "Google Meet"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_start_gte",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "googlecalendar",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_end_lt",
      "integration_name": "Google Calendar"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_start_gte",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_recording",
      "pagination": "list_end_lt",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_start_gte",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "calendly",
      "created_at": "2025-04-29T11:21:41.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "calendar_event",
      "pagination": "list_end_lt",
      "integration_name": "Calendly"
   },
   {
      "type": "writable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Freshbooks"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "firefish",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2025-04-29T10:28:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Firefish"
   },
   {
      "type": "integration",
      "created_at": "2025-04-29T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "snowflake",
      "integration_name": "Snowflake"
   },
   {
      "type": "integration",
      "created_at": "2025-04-28T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "mongodb",
      "integration_name": "MongoDB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gong",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-25T16:06:32.000Z",
      "object_type": "uc_recording",
      "integration_name": "Gong"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gong",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-25T16:06:32.000Z",
      "object_type": "uc_recording",
      "integration_name": "Gong"
   },
   {
      "type": "object",
      "object_type": "uc_recording",
      "integration_type": "gong",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-25T16:06:32.000Z",
      "integration_name": "Gong"
   },
   {
      "type": "method",
      "integration_type": "gong",
      "created_at": "2025-04-25T16:06:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gong"
   },
   {
      "type": "method",
      "integration_type": "gong",
      "created_at": "2025-04-25T16:06:32.000Z",
      "object_type": "uc_recording",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gong"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-25T16:06:32.000Z",
      "object_type": "uc_comment",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-25T16:06:32.000Z",
      "object_type": "uc_comment",
      "integration_name": "AirCall.io"
   },
   {
      "type": "object",
      "object_type": "uc_recording",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-25T16:06:32.000Z",
      "integration_name": "AirCall.io"
   },
   {
      "type": "object",
      "object_type": "uc_comment",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-25T16:06:32.000Z",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2025-04-25T16:06:32.000Z",
      "object_type": "uc_comment",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2025-04-25T16:06:32.000Z",
      "object_type": "uc_comment",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "AirCall.io"
   },
   {
      "type": "method",
      "integration_type": "aircall",
      "created_at": "2025-04-25T16:06:32.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "AirCall.io"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "variants",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "payment_methods",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "invoice_number",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "identification",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "customer_defined_code",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Pennylane"
   },
   {
      "type": "writable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "variants",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "payment_methods",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "paid_amount",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "identification",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "customer_defined_code",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_offset",
      "integration_name": "Pennylane"
   },
   {
      "type": "object",
      "created_at": "2025-04-25T13:58:26.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "integration_type": "pennylane",
      "object_type": "accounting_organization",
      "integration_name": "Pennylane"
   },
   {
      "type": "object",
      "created_at": "2025-04-25T13:58:26.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "integration_type": "pennylane",
      "object_type": "storage_file",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-25T13:58:26.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pennylane"
   },
   {
      "type": "integration",
      "created_at": "2025-04-25T00:00:00.000Z",
      "categories": [
         "uc",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "zoomphone",
      "integration_name": "Zoom Phone"
   },
   {
      "type": "object",
      "created_at": "2025-04-24T13:44:55.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "integration_type": "xero",
      "object_type": "accounting_report",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "trial_balance",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "profit_and_loss",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "balance_sheet",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_report",
      "pagination": "list_start_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_report",
      "pagination": "list_end_lt",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-04-24T13:44:55.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_location",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_company",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_group",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_location",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_company",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_group",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "division",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "created_at": "2025-04-24T10:49:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "successfactors",
      "object_type": "hris_location",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "created_at": "2025-04-24T10:49:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "successfactors",
      "object_type": "hris_company",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "created_at": "2025-04-24T10:49:05.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "successfactors",
      "object_type": "hris_group",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2025-04-24T10:49:05.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "object_type": "hris_device",
      "integration_type": "microsoft_ad",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-23T16:33:05.000Z",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "method",
      "integration_type": "microsoft_ad",
      "created_at": "2025-04-23T16:33:05.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "method",
      "integration_type": "microsoft_ad",
      "created_at": "2025-04-23T16:33:05.000Z",
      "object_type": "hris_device",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "object",
      "object_type": "hris_device",
      "integration_type": "kandji",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-23T16:33:05.000Z",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "object",
      "object_type": "hris_device",
      "integration_type": "jamf",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-23T16:33:05.000Z",
      "integration_name": "Jamf"
   },
   {
      "type": "readable_field",
      "integration_type": "zohoinvoice",
      "created_at": "2025-04-23T15:38:22.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "field": "associated_contacts",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2025-04-23T15:38:22.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "associated_contacts",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-04-23T15:38:22.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "associated_contacts",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-04-23T15:38:22.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-04-23T15:38:22.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-04-23T15:38:22.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-04-23T15:38:22.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "stage",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-04-23T15:38:22.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-04-23T15:38:22.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_raw_fields",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-04-23T15:38:22.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "slow_fields",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2025-04-23T12:12:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "send",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-04-23T12:12:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "send",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-23T12:12:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "send",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-04-23T12:12:13.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "send",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2025-04-23T12:12:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "openings",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-04-23T12:12:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "openings",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2025-04-23T12:12:13.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "openings",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2025-04-23T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "task",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "sageintacct",
      "integration_name": "Sage Intacct"
   },
   {
      "type": "integration",
      "created_at": "2025-04-23T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "kandji",
      "integration_name": "Iru (Kandji)"
   },
   {
      "type": "integration",
      "created_at": "2025-04-23T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "jamf",
      "integration_name": "Jamf"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2025-04-22T10:56:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2025-04-22T10:56:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-04-22T10:56:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-04-22T10:56:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "notion",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-22T10:56:31.000Z",
      "object_type": "kms_page",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "notion",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-22T10:56:31.000Z",
      "object_type": "kms_page",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "notion",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-22T10:56:31.000Z",
      "object_type": "kms_page",
      "integration_name": "Notion"
   },
   {
      "type": "integration",
      "created_at": "2025-04-22T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "ramp",
      "integration_name": "Ramp"
   },
   {
      "type": "integration",
      "created_at": "2025-04-22T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "dashlane",
      "integration_name": "Dashlane"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "ats_application",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "ats_job",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_employee",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_employee",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_employee",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "ats_application",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "ats_job",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_employee",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_employee",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "personio",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Personio"
   },
   {
      "type": "readable_field",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_updated_gte",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_user_id",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Personio"
   },
   {
      "type": "pagination",
      "integration_type": "personio",
      "created_at": "2025-04-21T16:10:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Personio"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-04-21T09:49:47.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2025-04-21T08:28:03.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "interval",
      "integration_name": "Stripe"
   },
   {
      "type": "integration",
      "created_at": "2025-04-21T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "personio",
      "integration_name": "Personio"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "calendar_event",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "calendar_event",
      "integration_name": "Calendly"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "calendar_event",
      "integration_name": "Calendly"
   },
   {
      "type": "object",
      "created_at": "2025-04-18T10:17:04.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "calendly",
      "object_type": "hris_employee",
      "integration_name": "Calendly"
   },
   {
      "type": "object",
      "created_at": "2025-04-18T10:17:04.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "calendly",
      "object_type": "hris_company",
      "integration_name": "Calendly"
   },
   {
      "type": "object",
      "created_at": "2025-04-18T10:17:04.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "calendly",
      "object_type": "hris_group",
      "integration_name": "Calendly"
   },
   {
      "type": "object",
      "created_at": "2025-04-18T10:17:04.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "calendly",
      "object_type": "calendar_event",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "hris_company",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "hris_company",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "hris_group",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "hris_group",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Calendly"
   },
   {
      "type": "method",
      "integration_type": "calendly",
      "created_at": "2025-04-18T10:17:04.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Calendly"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-04-17T20:17:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "imap",
      "created_at": "2025-04-17T20:17:59.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging"
      ],
      "field": "has_subchannels",
      "integration_name": "IMAP"
   },
   {
      "type": "pagination",
      "integration_type": "imap",
      "created_at": "2025-04-17T20:17:59.000Z",
      "categories": [
         "messaging"
      ],
      "object_type": "messaging_message",
      "pagination": "list_query",
      "integration_name": "IMAP"
   },
   {
      "type": "object",
      "created_at": "2025-04-17T20:17:59.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "heroku",
      "object_type": "hris_employee",
      "integration_name": "Heroku"
   },
   {
      "type": "object",
      "created_at": "2025-04-17T20:17:59.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "heroku",
      "object_type": "hris_group",
      "integration_name": "Heroku"
   },
   {
      "type": "method",
      "integration_type": "heroku",
      "created_at": "2025-04-17T20:17:59.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Heroku"
   },
   {
      "type": "method",
      "integration_type": "heroku",
      "created_at": "2025-04-17T20:17:59.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Heroku"
   },
   {
      "type": "method",
      "integration_type": "heroku",
      "created_at": "2025-04-17T20:17:59.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Heroku"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2025-04-17T20:17:59.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2025-04-17T20:17:59.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2025-04-15T16:15:40.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "created_at": "2025-04-15T16:15:40.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "integration_type": "xero",
      "object_type": "storage_file",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2025-04-15T16:15:40.000Z",
      "object_type": "storage_file",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "storage",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2025-04-15T16:15:40.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_offset",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "googledrive",
      "created_at": "2025-04-14T16:37:35.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Google Drive"
   },
   {
      "type": "object",
      "created_at": "2025-04-14T15:01:32.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "pennylane",
      "object_type": "accounting_transaction",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-14T15:01:32.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pennylane"
   },
   {
      "type": "method",
      "integration_type": "pennylane",
      "created_at": "2025-04-14T15:01:32.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pennylane"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "foundu",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-09T16:20:39.000Z",
      "object_type": "hris_employee",
      "integration_name": "foundU"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "foundu",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-09T16:20:39.000Z",
      "object_type": "hris_employee",
      "integration_name": "foundU"
   },
   {
      "type": "pagination",
      "integration_type": "foundu",
      "created_at": "2025-04-09T16:20:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "foundU"
   },
   {
      "type": "pagination",
      "integration_type": "foundu",
      "created_at": "2025-04-09T16:20:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "foundU"
   },
   {
      "type": "sign-in",
      "integration_type": "apollo",
      "created_at": "2025-04-09T16:20:39.000Z",
      "integration_name": "Apollo.io",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-04-09T15:31:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-04-09T15:31:47.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-09T15:00:52.000Z",
      "object_type": "ats_interview",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-04-09T15:00:52.000Z",
      "object_type": "hris_employee",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2025-04-09T00:00:00.000Z",
      "categories": [
         "task",
         "storage",
         "passthrough"
      ],
      "integration_type": "dovetail",
      "integration_name": "Dovetail"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2025-04-08T12:21:10.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2025-04-08T12:21:10.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "hidden_members",
      "integration_name": "Gmail"
   },
   {
      "type": "integration",
      "created_at": "2025-04-08T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "jboard",
      "integration_name": "Jboard"
   },
   {
      "type": "integration",
      "created_at": "2025-04-08T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "hireology",
      "integration_name": "Hireology"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "stage",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_contact_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2025-04-07T13:15:10.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "object",
      "created_at": "2025-04-07T13:15:10.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "highlevel",
      "object_type": "crm_pipeline",
      "integration_name": "HighLevel"
   },
   {
      "type": "object",
      "created_at": "2025-04-07T09:32:17.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "ats_activity",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobDiva"
   },
   {
      "type": "object",
      "created_at": "2025-04-07T09:32:17.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobdiva",
      "object_type": "metadata_metadata",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-04-07T09:32:17.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "integration",
      "created_at": "2025-04-07T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "martech",
         "passthrough"
      ],
      "integration_type": "yotpo",
      "integration_name": "yotpo"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-04-04T11:27:05.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-04-04T10:33:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2025-04-04T10:33:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Pipedrive"
   },
   {
      "type": "object",
      "created_at": "2025-04-04T10:33:50.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "pipedrive",
      "object_type": "crm_event",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-04-04T10:33:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-04-04T10:33:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-04-04T10:33:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-04-04T10:33:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-04-04T10:33:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pipedrive"
   },
   {
      "type": "integration",
      "created_at": "2025-04-04T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "trinet",
      "integration_name": "Trinet Zenefits"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "WooCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "salsify",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Salsify"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Apollo.io"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2025-04-03T14:30:10.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "storage_quota_used",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "storage_quota_available",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "storage_quota_allocated",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "storage_quota_used",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "storage_quota_available",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "storage_quota_allocated",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "storage_quota_used",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "storage_quota_available",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "storage_quota_allocated",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "storage_quota_used",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "storage_quota_available",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "storage_quota_allocated",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "storage_quota_used",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "storage_quota_available",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "storage_quota_allocated",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "object",
      "created_at": "2025-04-02T21:09:09.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "googledrive",
      "object_type": "hris_employee",
      "integration_name": "Google Drive"
   },
   {
      "type": "method",
      "integration_type": "googledrive",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Google Drive"
   },
   {
      "type": "method",
      "integration_type": "googledrive",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Google Drive"
   },
   {
      "type": "object",
      "created_at": "2025-04-02T21:09:09.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "dropbox",
      "object_type": "hris_employee",
      "integration_name": "Dropbox"
   },
   {
      "type": "method",
      "integration_type": "dropbox",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Dropbox"
   },
   {
      "type": "method",
      "integration_type": "dropbox",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Dropbox"
   },
   {
      "type": "object",
      "created_at": "2025-04-02T21:09:09.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "box",
      "object_type": "hris_employee",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Box"
   },
   {
      "type": "method",
      "integration_type": "box",
      "created_at": "2025-04-02T21:09:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Box"
   },
   {
      "type": "object",
      "object_type": "accounting_report",
      "integration_type": "quickbooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2025-04-02T13:24:40.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2025-04-02T13:24:40.000Z",
      "object_type": "accounting_report",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "payment_subscription",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "payment_payout",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "payment_refund",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "payment_payment",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "commerce_item",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "payment_subscription",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "payment_payout",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "payment_refund",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "payment_payment",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "commerce_item",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "list_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "list_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_contact",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_deal",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_contact",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gem",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_deal",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Gem"
   },
   {
      "type": "object",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "gem",
      "object_type": "crm_contact",
      "integration_name": "Gem"
   },
   {
      "type": "object",
      "created_at": "2025-04-01T12:32:31.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "gem",
      "object_type": "crm_deal",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2025-04-01T12:32:31.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "workday",
      "created_at": "2025-03-31T15:47:02.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats"
      ],
      "method": "list",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2025-03-31T15:47:02.000Z",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "pipedrive",
      "object_type": "storage_file",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-03-31T15:47:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-03-31T15:47:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-03-31T15:47:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-03-31T15:47:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-03-31T15:47:02.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pipedrive"
   },
   {
      "type": "object",
      "created_at": "2025-03-31T09:48:11.000Z",
      "categories": [
         "hris",
         "ats"
      ],
      "integration_type": "workday",
      "object_type": "ats_activity",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2025-03-31T09:40:46.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "ashby",
      "created_at": "2025-03-31T09:40:46.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2025-03-31T09:40:46.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2025-03-31T00:00:00.000Z",
      "categories": [
         "messaging"
      ],
      "integration_type": "imap",
      "integration_name": "IMAP"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2025-03-28T14:30:06.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2025-03-28T14:30:06.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Jobvite"
   },
   {
      "type": "object",
      "created_at": "2025-03-28T14:30:06.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "ats_document",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-28T14:30:06.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-28T14:30:06.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-28T14:30:06.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-28T14:30:06.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-28T14:30:06.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-03-28T14:30:06.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-03-28T14:30:06.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "posted_at",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "sageaccounting",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "pennylane",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Pennylane"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "writable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "freshbooks",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "chargebee",
      "created_at": "2025-03-27T11:40:03.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "field": "posted_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_job",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "slow_fields",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "slow_fields",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-03-27T09:38:57.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "slow_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-03-27T09:38:57.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-03-27T09:38:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-26T13:08:46.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-26T13:08:46.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemail",
      "created_at": "2025-03-26T11:49:10.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "channel_id",
      "integration_name": "Gmail"
   },
   {
      "type": "method",
      "integration_type": "googlemail",
      "created_at": "2025-03-26T11:49:10.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gmail"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-03-26T11:15:23.000Z",
      "object_type": "crm_event",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-03-26T11:15:23.000Z",
      "object_type": "crm_event",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2025-03-26T11:15:23.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "crm_event",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-03-26T11:15:23.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-03-26T11:15:23.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2025-03-25T20:34:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "myob",
      "object_type": "accounting_order",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2025-03-25T20:34:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "myob",
      "object_type": "accounting_invoice",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2025-03-25T20:34:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "myob",
      "object_type": "accounting_journal",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2025-03-25T20:34:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "myob",
      "object_type": "accounting_account",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2025-03-25T20:34:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "myob",
      "object_type": "accounting_transaction",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2025-03-25T20:34:31.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "myob",
      "object_type": "accounting_contact",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "MYOB"
   },
   {
      "type": "method",
      "integration_type": "myob",
      "created_at": "2025-03-25T20:34:31.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "MYOB"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-03-25T11:55:51.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-03-25T09:27:24.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-03-25T09:27:24.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2025-03-22T00:46:41.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-03-22T00:46:41.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_user_id",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-03-22T00:46:41.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Paylocity"
   },
   {
      "type": "integration",
      "created_at": "2025-03-22T00:00:00.000Z",
      "categories": [
         "payment",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "brex",
      "integration_name": "Brex"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "paylocity",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Paylocity"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "paylocity",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_updated_gte",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_limit",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_offset",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_payslip",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Paylocity"
   },
   {
      "type": "pagination",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Paylocity"
   },
   {
      "type": "method",
      "integration_type": "paylocity",
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paylocity"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_contact",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_deal",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_lead",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_company",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_event",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_contact",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_deal",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_lead",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_company",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-03-21T18:22:10.000Z",
      "object_type": "crm_event",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_order",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-21T18:22:10.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "integration",
      "created_at": "2025-03-21T00:00:00.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "workday_legacy",
      "integration_name": "Workday (Legacy)"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2025-03-20T09:41:22.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_offset",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2025-03-20T09:41:22.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_offset",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "pennylane",
      "created_at": "2025-03-20T09:41:22.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_offset",
      "integration_name": "Pennylane"
   },
   {
      "type": "object",
      "created_at": "2025-03-20T09:41:22.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "ats_activity",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-20T09:41:22.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-20T09:41:22.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-20T09:41:22.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-20T09:41:22.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-20T09:41:22.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2025-03-19T13:47:00.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Salesforce"
   },
   {
      "type": "integration",
      "created_at": "2025-03-19T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "sympa",
      "integration_name": "Sympa"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "task",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "marketing_email",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "call",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-18T17:23:29.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_type",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2025-03-17T12:54:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "skills",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2025-03-17T12:54:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "experiences",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2025-03-17T12:54:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "education",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workday",
      "created_at": "2025-03-17T12:54:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "address",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-03-17T12:54:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "skills",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-03-17T12:54:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "experiences",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-03-17T12:54:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "education",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2025-03-17T12:54:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "address",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-17T09:57:28.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2025-03-17T09:57:28.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Freshbooks"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "freshbooks",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2025-03-13T12:25:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_journal",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2025-03-13T12:25:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_invoice",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2025-03-13T12:25:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_contact",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2025-03-13T12:25:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "accounting_account",
      "integration_name": "Freshbooks"
   },
   {
      "type": "object",
      "created_at": "2025-03-13T12:25:54.000Z",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "freshbooks",
      "object_type": "hris_employee",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Freshbooks"
   },
   {
      "type": "method",
      "integration_type": "freshbooks",
      "created_at": "2025-03-13T12:25:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Freshbooks"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-11T15:25:39.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-03-11T15:25:39.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "object",
      "created_at": "2025-03-11T13:39:38.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "metadata_metadata",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-11T13:39:38.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-11T13:39:38.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-11T13:39:38.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-11T13:39:38.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2025-03-11T13:39:38.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Jobvite"
   },
   {
      "type": "object",
      "created_at": "2025-03-11T11:28:15.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobdiva",
      "object_type": "ats_activity",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-03-11T11:28:15.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-03-11T11:28:15.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-03-11T11:28:15.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2025-03-11T11:28:15.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2025-03-10T11:49:12.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Teamtailor"
   },
   {
      "type": "object",
      "created_at": "2025-03-10T11:18:16.000Z",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "integration_type": "greenhouse",
      "object_type": "metadata_metadata",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2025-03-10T11:18:16.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2025-03-10T11:18:16.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2025-03-10T11:18:16.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2025-03-10T11:18:16.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2025-03-10T11:18:16.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-03-07T10:00:34.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2025-03-07T10:00:34.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Crelate"
   },
   {
      "type": "integration",
      "created_at": "2025-03-07T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "pinpoint",
      "integration_name": "Pinpoint"
   },
   {
      "type": "integration",
      "created_at": "2025-03-07T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "oraclehcm",
      "integration_name": "Oracle HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "icims",
      "created_at": "2025-03-06T12:20:47.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "iCIMS"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-06T11:49:02.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-06T11:49:02.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "note",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-06T11:49:02.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-06T11:49:02.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-06T11:49:02.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-06T11:49:02.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "object_type": "calendar_link",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "object_type": "calendar_calendar",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "object_type": "calendar_recording",
      "integration_type": "zoom",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_link",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoom"
   },
   {
      "type": "method",
      "integration_type": "zoom",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_link",
      "categories": [
         "calendar",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoom"
   },
   {
      "type": "object",
      "object_type": "calendar_calendar",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Webex"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Webex"
   },
   {
      "type": "object",
      "object_type": "calendar_recording",
      "integration_type": "webex",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Webex"
   },
   {
      "type": "object",
      "object_type": "calendar_link",
      "integration_type": "squareup",
      "categories": [
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "squareup",
      "categories": [
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "SquareUp"
   },
   {
      "type": "object",
      "object_type": "calendar_link",
      "integration_type": "simplemeet",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "SimpleMeet.me"
   },
   {
      "type": "object",
      "object_type": "calendar_link",
      "integration_type": "savvycal",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "SavvyCal"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "savvycal",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "SavvyCal"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "calendar_calendar",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "calendar_busy",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "calendar_recording",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_busy",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_recording",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "messaging",
         "calendar",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-06T09:39:43.000Z",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_query",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "object",
      "object_type": "calendar_calendar",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "object",
      "object_type": "calendar_busy",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_event",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_busy",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_calendar",
      "categories": [
         "auth",
         "messaging",
         "calendar",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "object",
      "object_type": "calendar_link",
      "integration_type": "lemcal",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "lemcal"
   },
   {
      "type": "object",
      "object_type": "calendar_calendar",
      "integration_type": "lemcal",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "lemcal"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "lemcal",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "lemcal"
   },
   {
      "type": "object",
      "object_type": "calendar_link",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_link",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2025-03-06T09:39:43.000Z",
      "object_type": "calendar_link",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "calendar",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "object_type": "calendar_recording",
      "integration_type": "googlemeet",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Google Meet"
   },
   {
      "type": "object",
      "object_type": "calendar_calendar",
      "integration_type": "googlecalendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Google Calendar"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "googlecalendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Google Calendar"
   },
   {
      "type": "object",
      "object_type": "calendar_busy",
      "integration_type": "googlecalendar",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Google Calendar"
   },
   {
      "type": "object",
      "object_type": "calendar_link",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Calendly"
   },
   {
      "type": "object",
      "object_type": "calendar_busy",
      "integration_type": "calendly",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Calendly"
   },
   {
      "type": "object",
      "object_type": "calendar_link",
      "integration_type": "cal",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Cal.com"
   },
   {
      "type": "object",
      "object_type": "calendar_calendar",
      "integration_type": "cal",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Cal.com"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "cal",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Cal.com"
   },
   {
      "type": "object",
      "object_type": "calendar_calendar",
      "integration_type": "appleicloud",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "object",
      "object_type": "calendar_event",
      "integration_type": "appleicloud",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "object",
      "object_type": "calendar_link",
      "integration_type": "acuityscheduling",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "created_at": "2025-03-06T09:39:43.000Z",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "webex",
      "integration_name": "Webex"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "auth",
         "payment",
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "squareup",
      "integration_name": "SquareUp"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "simplemeet",
      "integration_name": "SimpleMeet.me"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "savvycal",
      "integration_name": "SavvyCal"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "lemcal",
      "integration_name": "lemcal"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlemeet",
      "integration_name": "Google Meet"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlecalendar",
      "integration_name": "Google Calendar"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "auth",
         "passthrough"
      ],
      "integration_type": "calendly",
      "integration_name": "Calendly"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "cal",
      "integration_name": "Cal.com"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "appleicloud",
      "integration_name": "Apple iCloud"
   },
   {
      "type": "integration",
      "created_at": "2025-03-06T00:00:00.000Z",
      "categories": [
         "calendar",
         "passthrough"
      ],
      "integration_type": "acuityscheduling",
      "integration_name": "Acuity Scheduling"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-05T10:49:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-05T10:49:29.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-05T10:49:29.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-05T10:49:29.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2025-03-05T10:49:29.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "crm_event",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-05T10:49:29.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-03-05T10:49:29.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "atlassianconfluence",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-05T10:49:29.000Z",
      "object_type": "kms_space",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "atlassianconfluence",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-05T10:49:29.000Z",
      "object_type": "kms_page",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "atlassianconfluence",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-05T10:49:29.000Z",
      "object_type": "kms_space",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "atlassianconfluence",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-05T10:49:29.000Z",
      "object_type": "kms_page",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "atlassianconfluence",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-05T10:49:29.000Z",
      "object_type": "kms_space",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "atlassianconfluence",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-03-05T10:49:29.000Z",
      "object_type": "kms_page",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "integration",
      "created_at": "2025-03-05T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "passthrough"
      ],
      "integration_type": "pennylane",
      "integration_name": "Pennylane"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-03-04T14:33:02.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_query",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zambion",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "hris",
         "ats"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "slow_fields",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "slow_fields",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "slow_fields",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_end_lt",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_start_gte",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_fields",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftplanner",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicsbusinesscentral",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "slow_fields",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "slow_fields",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "slow_fields",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "guru",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Guru"
   },
   {
      "type": "pagination",
      "integration_type": "googledirectory",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "slow_fields",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_link",
      "pagination": "slow_fields",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "slow_fields",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "foundu",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "foundU"
   },
   {
      "type": "pagination",
      "integration_type": "dropbox",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "slow_fields",
      "integration_name": "Dropbox"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "slow_fields",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "slow_fields",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "slow_fields",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "slow_fields",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2025-03-04T09:39:43.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "slow_fields",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-02-27T09:13:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-02-27T09:13:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-02-27T09:13:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-27T09:13:36.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-02-27T09:13:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-02-27T09:13:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2025-02-27T09:13:36.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-02-27T09:13:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-02-27T09:13:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-02-27T09:13:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-02-27T09:13:36.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2025-02-27T09:13:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "skills",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Phenom"
   },
   {
      "type": "pagination",
      "integration_type": "phenom",
      "created_at": "2025-02-26T15:46:03.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "CATS"
   },
   {
      "type": "pagination",
      "integration_type": "cats",
      "created_at": "2025-02-26T15:46:03.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "experiences",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2025-02-26T15:46:03.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "education",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2025-02-26T15:24:52.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "crm_contact",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2025-02-26T15:24:52.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "crm_deal",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2025-02-26T15:24:52.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "crm_lead",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2025-02-26T15:24:52.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "crm_pipeline",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_deal",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-26T15:24:52.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "ats",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-02-25T20:43:37.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "slow_fields",
      "integration_name": "Notion"
   },
   {
      "type": "writable_field",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "iCIMS"
   },
   {
      "type": "writable_field",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "iCIMS"
   },
   {
      "type": "writable_field",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "iCIMS"
   },
   {
      "type": "writable_field",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "iCIMS"
   },
   {
      "type": "object",
      "created_at": "2025-02-25T18:30:54.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "icims",
      "object_type": "ats_document",
      "integration_name": "iCIMS"
   },
   {
      "type": "object",
      "created_at": "2025-02-25T18:30:54.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "icims",
      "object_type": "ats_activity",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "iCIMS"
   },
   {
      "type": "method",
      "integration_type": "icims",
      "created_at": "2025-02-25T18:30:54.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "iCIMS"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2025-02-25T14:44:45.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_end_lt",
      "integration_name": "Gmail"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2025-02-25T14:44:45.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_start_gte",
      "integration_name": "Gmail"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-02-25T12:47:56.000Z",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_start_gte",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-02-25T12:47:56.000Z",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_end_lt",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gitlab",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_repository",
      "integration_name": "GitLab"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gitlab",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_repository",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "owner",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "org_id",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "is_private",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_updated_gte",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_query",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_sort_by_name",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_sort_by_created_at",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_order",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_project_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "GitLab"
   },
   {
      "type": "object",
      "created_at": "2025-02-24T10:20:33.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "gitlab",
      "object_type": "repo_pullrequest",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2025-02-24T10:20:33.000Z",
      "object_type": "repo_pullrequest",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GitLab"
   },
   {
      "type": "integration",
      "created_at": "2025-02-24T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "flatchr",
      "integration_name": "Flatchr"
   },
   {
      "type": "integration",
      "created_at": "2025-02-23T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "motion",
      "integration_name": "Motion"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-02-22T12:45:59.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-02-22T12:45:59.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-02-21T17:15:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "document_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2025-02-21T17:15:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_ids",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-02-21T17:15:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "document_ids",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2025-02-21T17:15:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_ids",
      "integration_name": "Crelate"
   },
   {
      "type": "integration",
      "created_at": "2025-02-21T00:00:00.000Z",
      "categories": [
         "crm",
         "ats",
         "passthrough"
      ],
      "integration_type": "trackerrms",
      "integration_name": "TrackerRMS"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-02-20T21:28:17.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "document_id",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-02-19T19:53:51.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_limit",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-02-19T19:53:51.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "list_offset",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2025-02-19T19:53:51.000Z",
      "object_type": "hris_company",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2025-02-19T19:53:51.000Z",
      "object_type": "hris_company",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "object_type",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "salsify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Salsify"
   },
   {
      "type": "writable_field",
      "integration_type": "salsify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Salsify"
   },
   {
      "type": "readable_field",
      "integration_type": "salsify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Salsify"
   },
   {
      "type": "readable_field",
      "integration_type": "salsify",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Salsify"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-02-19T19:52:11.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_updated_gte",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Apollo.io"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "original_format",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2025-02-19T19:52:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "format",
      "integration_name": "Akeneo"
   },
   {
      "type": "integration",
      "created_at": "2025-02-19T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "clearcompany",
      "integration_name": "Clear Company"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "tribepad",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Tribepad"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitee",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Recruitee"
   },
   {
      "type": "writable_field",
      "integration_type": "phenom",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "phenom",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Phenom"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocityrecruiting",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Paylocity Recruiting"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-02-18T21:58:14.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_company_id",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "created_at": "2025-02-18T21:58:14.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "github",
      "object_type": "hris_company",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "careerplug",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "CareerPlug"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "groups",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "groups",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "applicantstack",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "readable_field",
      "integration_type": "applicantstack",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-02-18T21:58:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "created_at": "2025-02-18T16:45:17.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "pipedrive",
      "object_type": "crm_pipeline",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-02-18T16:45:17.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-02-18T16:45:17.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-02-18T16:45:17.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-02-18T16:45:17.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "pipedrive",
      "created_at": "2025-02-18T16:45:17.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2025-02-18T13:25:02.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2025-02-18T13:25:02.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-18T13:25:02.000Z",
      "object_type": "ats_activity",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-18T13:25:02.000Z",
      "object_type": "ats_activity",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-02-18T13:25:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_query",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-02-18T13:25:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_updated_gte",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-02-18T13:25:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_candidate_id",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-02-18T13:25:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_job_id",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-02-18T13:25:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-02-18T13:25:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2025-02-18T13:25:02.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "freshsales",
      "created_at": "2025-02-18T13:25:02.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm"
      ],
      "field": "telephones",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "freshsales",
      "created_at": "2025-02-18T13:25:02.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm"
      ],
      "field": "company_id",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "freshsales",
      "created_at": "2025-02-18T13:25:02.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm"
      ],
      "field": "address",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-02-14T10:34:44.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-02-14T10:34:44.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-02-14T10:34:44.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-14T10:34:44.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-14T10:34:44.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-02-14T10:32:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2025-02-14T10:32:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-02-14T10:32:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "permissions",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-02-14T10:32:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "permissions",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-02-14T10:32:31.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "slow_fields",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-02-14T10:32:31.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2025-02-14T10:32:31.000Z",
      "categories": [
         "crm"
      ],
      "integration_type": "freshsales",
      "object_type": "crm_event",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "method",
      "integration_type": "freshsales",
      "created_at": "2025-02-14T10:32:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm"
      ],
      "method": "list",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "method",
      "integration_type": "freshsales",
      "created_at": "2025-02-14T10:32:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm"
      ],
      "method": "get",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "method",
      "integration_type": "freshsales",
      "created_at": "2025-02-14T10:32:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm"
      ],
      "method": "create",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "method",
      "integration_type": "freshsales",
      "created_at": "2025-02-14T10:32:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm"
      ],
      "method": "update",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "method",
      "integration_type": "freshsales",
      "created_at": "2025-02-14T10:32:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm"
      ],
      "method": "remove",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "dropbox",
      "created_at": "2025-02-14T10:32:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "permissions",
      "integration_name": "Dropbox"
   },
   {
      "type": "integration",
      "created_at": "2025-02-13T00:00:00.000Z",
      "categories": [
         "passthrough",
         "ats",
         "hris"
      ],
      "integration_type": "pcrecruiter",
      "integration_name": "PCRecruiter"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-02-10T08:11:49.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "root_message_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-02-10T08:11:49.000Z",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "slow_fields",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2025-02-10T08:11:49.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "field": "message_html",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2025-02-10T08:11:49.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "ticketing",
         "hris",
         "auth",
         "kms",
         "passthrough"
      ],
      "field": "destination_members",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2025-02-10T08:11:49.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-02-07T16:15:19.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sub_type",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_contact",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_contact",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_contact",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2025-02-07T14:10:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "loxo",
      "object_type": "crm_company",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2025-02-07T14:10:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "loxo",
      "object_type": "crm_contact",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2025-02-07T14:10:50.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "loxo",
      "object_type": "crm_event",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Lever"
   },
   {
      "type": "object",
      "created_at": "2025-02-07T14:10:50.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "integration_type": "clickup",
      "object_type": "kms_page",
      "integration_name": "ClickUp"
   },
   {
      "type": "object",
      "created_at": "2025-02-07T14:10:50.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "integration_type": "clickup",
      "object_type": "kms_space",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "kms_page",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "kms_page",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "kms_page",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "kms_page",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "kms_space",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "kms_space",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-02-07T14:10:50.000Z",
      "object_type": "kms_space",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "kms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-02-06T21:35:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "postings",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-02-06T21:35:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "postings",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2025-02-06T21:35:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "postings",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2025-02-06T21:35:15.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "postings",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "woocommerce",
      "created_at": "2025-02-06T10:33:29.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "WooCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-02-06T10:33:29.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2025-02-06T10:33:29.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Apollo.io"
   },
   {
      "type": "object",
      "created_at": "2025-02-06T09:42:56.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "integration_type": "salsify",
      "object_type": "metadata_metadata",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2025-02-06T09:42:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2025-02-06T09:42:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2025-02-06T09:42:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2025-02-06T09:42:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2025-02-06T09:42:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salsify"
   },
   {
      "type": "object",
      "created_at": "2025-02-06T09:42:56.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "metadata_metadata",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-02-06T09:42:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2025-02-06T09:42:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-02-06T09:42:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-02-05T15:36:11.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apollo.io"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2025-02-05T12:29:21.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2025-02-05T12:29:21.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2025-02-05T12:29:21.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2025-02-05T12:29:21.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "field": "options",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-02-05T12:29:21.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-02-05T12:29:21.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2025-02-05T12:29:21.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2025-02-04T13:45:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Greenhouse"
   },
   {
      "type": "object",
      "created_at": "2025-02-04T13:04:44.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "integration_type": "hubspot",
      "object_type": "metadata_metadata",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2025-02-04T13:04:44.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HubSpot"
   },
   {
      "type": "method",
      "integration_type": "hubspot",
      "created_at": "2025-02-04T13:04:44.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-04T12:09:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-04T12:09:47.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "remote",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Remote.com"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "remote",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_payslip",
      "integration_name": "Remote.com"
   },
   {
      "type": "object",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "remote",
      "object_type": "hris_timeoff",
      "integration_name": "Remote.com"
   },
   {
      "type": "object",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "remote",
      "object_type": "hris_payslip",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Remote.com"
   },
   {
      "type": "method",
      "integration_type": "remote",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Remote.com"
   },
   {
      "type": "readable_field",
      "integration_type": "paycor",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris"
      ],
      "field": "company_id",
      "integration_name": "Paycor"
   },
   {
      "type": "sign-in",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "integration_name": "Deel",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_user_id",
      "integration_name": "Deel"
   },
   {
      "type": "object",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deel",
      "object_type": "hris_group",
      "integration_name": "Deel"
   },
   {
      "type": "object",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deel",
      "object_type": "hris_timeoff",
      "integration_name": "Deel"
   },
   {
      "type": "object",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deel",
      "object_type": "hris_payslip",
      "integration_name": "Deel"
   },
   {
      "type": "object",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deel",
      "object_type": "hris_location",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_payslip",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Deel"
   },
   {
      "type": "method",
      "integration_type": "deel",
      "created_at": "2025-02-04T00:29:45.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Deel"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-02-04T00:29:45.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "slow_fields",
      "integration_name": "ClickUp"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_job",
      "integration_name": "Vincere"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_job",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_name",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_limit",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Vincere"
   },
   {
      "type": "object",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "vincere",
      "object_type": "ats_applicationstatus",
      "integration_name": "Vincere"
   },
   {
      "type": "object",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "vincere",
      "object_type": "ats_job",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-02T11:04:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-02-02T11:04:52.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "integration",
      "created_at": "2025-01-30T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "remote",
      "integration_name": "Remote.com"
   },
   {
      "type": "integration",
      "created_at": "2025-01-30T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "linkedinlearning",
      "integration_name": "LinkedIn Learning"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-29T17:04:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-29T17:04:51.000Z",
      "object_type": "ats_application",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-29T17:04:51.000Z",
      "object_type": "ats_application",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-29T17:04:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-29T17:04:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-29T17:04:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-29T17:04:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-29T17:04:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-29T17:04:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-29T17:04:51.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-29T17:04:51.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-01-29T17:04:51.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_updated_gte",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-01-29T08:35:19.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2025-01-29T08:35:19.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_offset",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "list_type",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "virtual_webhook_type",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "metadata_metadata",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-01-29T08:35:19.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-01-28T17:25:51.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-01-28T15:59:51.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_parent_id",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-01-28T15:59:51.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_query",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-01-28T15:59:51.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-01-28T15:59:51.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "list_parent_id",
      "integration_name": "Notion"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2025-01-28T11:58:56.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2025-01-28T11:58:56.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "org_id",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2025-01-28T11:58:56.000Z",
      "object_type": "repo_repository",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "created_at": "2025-01-28T08:59:34.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "metadata_metadata",
      "integration_name": "JobAdder"
   },
   {
      "type": "integration",
      "created_at": "2025-01-27T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "deepseek",
      "integration_name": "DeepSeek"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "apollo",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_contact",
      "integration_name": "Apollo.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "apollo",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_company",
      "integration_name": "Apollo.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "apollo",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_contact",
      "integration_name": "Apollo.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "apollo",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_company",
      "integration_name": "Apollo.io"
   },
   {
      "type": "object",
      "created_at": "2025-01-24T17:18:51.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "apollo",
      "object_type": "metadata_metadata",
      "integration_name": "Apollo.io"
   },
   {
      "type": "object",
      "created_at": "2025-01-24T17:18:51.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "apollo",
      "object_type": "hris_employee",
      "integration_name": "Apollo.io"
   },
   {
      "type": "object",
      "created_at": "2025-01-24T17:18:51.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "apollo",
      "object_type": "crm_contact",
      "integration_name": "Apollo.io"
   },
   {
      "type": "object",
      "created_at": "2025-01-24T17:18:51.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "apollo",
      "object_type": "crm_company",
      "integration_name": "Apollo.io"
   },
   {
      "type": "object",
      "created_at": "2025-01-24T17:18:51.000Z",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "apollo",
      "object_type": "crm_deal",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_contact",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_company",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_company",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_company",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_company",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_deal",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_deal",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_deal",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Apollo.io"
   },
   {
      "type": "method",
      "integration_type": "apollo",
      "created_at": "2025-01-24T17:18:51.000Z",
      "object_type": "crm_deal",
      "categories": [
         "enrich",
         "crm",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Apollo.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trello",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_project",
      "integration_name": "Trello"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "trello",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_task",
      "integration_name": "Trello"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trello",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_project",
      "integration_name": "Trello"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "trello",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_task",
      "integration_name": "Trello"
   },
   {
      "type": "object",
      "created_at": "2025-01-24T13:58:29.000Z",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "trello",
      "object_type": "task_project",
      "integration_name": "Trello"
   },
   {
      "type": "object",
      "created_at": "2025-01-24T13:58:29.000Z",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "trello",
      "object_type": "task_task",
      "integration_name": "Trello"
   },
   {
      "type": "object",
      "created_at": "2025-01-24T13:58:29.000Z",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "trello",
      "object_type": "task_comment",
      "integration_name": "Trello"
   },
   {
      "type": "object",
      "created_at": "2025-01-24T13:58:29.000Z",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "trello",
      "object_type": "storage_file",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Trello"
   },
   {
      "type": "method",
      "integration_type": "trello",
      "created_at": "2025-01-24T13:58:29.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Trello"
   },
   {
      "type": "integration",
      "created_at": "2025-01-24T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "trello",
      "integration_name": "Trello"
   },
   {
      "type": "writable_field",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Coda"
   },
   {
      "type": "writable_field",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Coda"
   },
   {
      "type": "writable_field",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "space_id",
      "integration_name": "Coda"
   },
   {
      "type": "writable_field",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Coda"
   },
   {
      "type": "writable_field",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Coda"
   },
   {
      "type": "writable_field",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Coda"
   },
   {
      "type": "method",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Coda"
   },
   {
      "type": "method",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Coda"
   },
   {
      "type": "method",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Coda"
   },
   {
      "type": "method",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Coda"
   },
   {
      "type": "method",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Coda"
   },
   {
      "type": "method",
      "integration_type": "coda",
      "created_at": "2025-01-23T23:26:38.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Coda"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "project_id",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "creator_user_id",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "field": "completed_at",
      "integration_name": "Streamtime"
   },
   {
      "type": "object",
      "created_at": "2025-01-23T21:05:36.000Z",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "streamtime",
      "object_type": "crm_company",
      "integration_name": "Streamtime"
   },
   {
      "type": "object",
      "created_at": "2025-01-23T21:05:36.000Z",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "streamtime",
      "object_type": "crm_contact",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "crm_company",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "crm_company",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "crm_contact",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-23T21:05:36.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "accounting",
         "hris",
         "crm",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Streamtime"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T16:23:34.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T16:23:34.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T16:23:34.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T16:23:34.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T16:23:34.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T16:23:34.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_note",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_note",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "virtual_webhook_ticket_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_customer_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_created_at",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "woocommerce",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "commerce",
         "accounting",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_name",
      "integration_name": "WooCommerce"
   },
   {
      "type": "sign-in",
      "integration_type": "vincere",
      "created_at": "2025-01-23T10:21:23.000Z",
      "integration_name": "Vincere",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "tribepad",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_job",
      "integration_name": "Tribepad"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "tribepad",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_job",
      "integration_name": "Tribepad"
   },
   {
      "type": "pagination",
      "integration_type": "tribepad",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Tribepad"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_candidate",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_contact",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_lead",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_deal",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_job",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_candidate",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_contact",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_lead",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_deal",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_job",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_created_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_created_at",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "notion",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "kms_page",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "notion",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "kms_page",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_space_id",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "namely",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Namely"
   },
   {
      "type": "pagination",
      "integration_type": "namely",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Namely"
   },
   {
      "type": "pagination",
      "integration_type": "namely",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "Namely"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_channel_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicssales",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_group",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "manager_ids",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_group",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_group",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftdynamicscustomerengagement",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_group",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "manager_ids",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_group",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_group",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "linear",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "integration_name": "Linear"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "linear",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Linear"
   },
   {
      "type": "object",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "linear",
      "object_type": "task_comment",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_name",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_name",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_application",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_application",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_company",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "helpscout",
      "categories": [
         "kms",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "kms_page",
      "integration_name": "Helpscout"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "helpscout",
      "categories": [
         "kms",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "kms_space",
      "integration_name": "Helpscout"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "helpscout",
      "categories": [
         "kms",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "kms_page",
      "integration_name": "Helpscout"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "helpscout",
      "categories": [
         "kms",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "kms_space",
      "integration_name": "Helpscout"
   },
   {
      "type": "pagination",
      "integration_type": "helpscout",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Helpscout"
   },
   {
      "type": "pagination",
      "integration_type": "helpscout",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_space_id",
      "integration_name": "Helpscout"
   },
   {
      "type": "pagination",
      "integration_type": "helpscout",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Helpscout"
   },
   {
      "type": "pagination",
      "integration_type": "helpscout",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Helpscout"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "guru",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "kms_space",
      "integration_name": "Guru"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "guru",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "kms_space",
      "integration_name": "Guru"
   },
   {
      "type": "pagination",
      "integration_type": "guru",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Guru"
   },
   {
      "type": "pagination",
      "integration_type": "guru",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Guru"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gorgias",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Gorgias"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gorgias",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Gorgias"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gorgias",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_note",
      "integration_name": "Gorgias"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gorgias",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_employee",
      "integration_name": "Gorgias"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gorgias",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Gorgias"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gorgias",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "Gorgias"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gorgias",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ticketing_note",
      "integration_name": "Gorgias"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gorgias",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_employee",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "virtual_webhook_ticket_id",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_parent_id",
      "integration_name": "Gmail"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "repo_repository",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "storage_file",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "repo_repository",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "storage_file",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_sort_by_created_at",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_sort_by_name",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshsales",
      "categories": [
         "crm"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_lead",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshsales",
      "categories": [
         "crm"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_contact",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshsales",
      "categories": [
         "crm"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_lead",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshsales",
      "categories": [
         "crm"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "crm_contact",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "pagination",
      "integration_type": "freshsales",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "crm"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "pagination",
      "integration_type": "freshsales",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "crm"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_task",
      "integration_name": "ClickUp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_task",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_subscription",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "pagination",
      "integration_type": "chargebee",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Chargebee"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "canvas",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_employee",
      "integration_name": "Canvas"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "canvas",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "hris_employee",
      "integration_name": "Canvas"
   },
   {
      "type": "pagination",
      "integration_type": "canvas",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Canvas"
   },
   {
      "type": "pagination",
      "integration_type": "canvas",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "Canvas"
   },
   {
      "type": "pagination",
      "integration_type": "canvas",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Canvas"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_task",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_task",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_comment",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "atlassianjira",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-23T10:21:23.000Z",
      "object_type": "task_task",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_comment",
      "pagination": "native_webhook_task_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-01-23T10:21:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "native_webhook_project_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "integration",
      "created_at": "2025-01-23T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "typeform",
      "integration_name": "Typeform"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2025-01-21T13:05:34.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-21T11:59:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-21T11:59:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2025-01-21T11:59:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "ats_application",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2025-01-21T11:59:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "ats_applicationstatus",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2025-01-21T11:59:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "ats_document",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-21T11:59:50.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-21T11:59:50.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-21T11:59:50.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-21T11:59:50.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-21T11:59:50.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-21T11:59:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-01-20T10:52:48.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-01-20T10:52:48.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-01-20T10:52:48.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_offset",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-01-20T10:52:48.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_user_id",
      "integration_name": "Workable"
   },
   {
      "type": "object",
      "object_type": "kms_comment",
      "integration_type": "notion",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-20T10:52:48.000Z",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2025-01-20T10:52:48.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "notion",
      "created_at": "2025-01-20T10:52:48.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "atlassianconfluence",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-20T10:52:48.000Z",
      "object_type": "kms_comment",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "atlassianconfluence",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-20T10:52:48.000Z",
      "object_type": "kms_comment",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "object",
      "object_type": "kms_comment",
      "integration_type": "atlassianconfluence",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-20T10:52:48.000Z",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "method",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-01-20T10:52:48.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "method",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-01-20T10:52:48.000Z",
      "object_type": "kms_comment",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "coda",
      "created_at": "2025-01-20T09:32:32.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Coda"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "slow_fields",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "slow_fields",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "pitchbook",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "slow_fields",
      "integration_name": "Pitchbook"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "slow_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "haileyhr",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "HaileyHR"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "googleclassroom",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "slow_fields",
      "integration_name": "Google Classroom"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "payment",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "slow_fields",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "slow_fields",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "slow_fields",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "slow_fields",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "elmo",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "slow_fields",
      "integration_name": "ELMO"
   },
   {
      "type": "pagination",
      "integration_type": "d2l",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "object_type": "lms_student",
      "pagination": "slow_fields",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "pagination",
      "integration_type": "d2l",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "slow_fields",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "slow_fields",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "slow_fields",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_organization",
      "pagination": "slow_fields",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_candidate",
      "pagination": "slow_fields",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "slow_fields",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "slow_fields",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "slow_fields",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "slow_fields",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "slow_fields",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2025-01-20T08:20:06.000Z",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "slow_fields",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-01-19T21:04:48.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-01-19T21:04:48.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2025-01-19T21:04:48.000Z",
      "object_type": "repo_organization",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2025-01-19T21:04:48.000Z",
      "object_type": "repo_organization",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "bitbucket",
      "created_at": "2025-01-19T21:04:48.000Z",
      "object_type": "repo_organization",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-19T19:26:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_candidate_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "coda",
      "created_at": "2025-01-19T19:26:23.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_parent_id",
      "integration_name": "Coda"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianjira",
      "created_at": "2025-01-19T19:26:23.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_parent_id",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "offers",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "root_message_id",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "created_at": "2025-01-19T10:07:11.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruitcrm",
      "object_type": "ats_application",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "object",
      "created_at": "2025-01-19T10:07:11.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruitcrm",
      "object_type": "ats_applicationstatus",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "mentioned_members",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2025-01-19T10:07:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "loxo",
      "object_type": "ats_applicationstatus",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-01-19T10:07:11.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "pagination",
      "integration_type": "adp",
      "created_at": "2025-01-19T10:07:11.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "method",
      "integration_type": "adp",
      "created_at": "2025-01-19T10:07:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "integration",
      "created_at": "2025-01-17T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "irishr",
      "integration_name": "Iris HR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-15T08:27:43.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Vincere"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-15T08:27:43.000Z",
      "object_type": "ats_company",
      "integration_name": "Vincere"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-15T08:27:43.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Vincere"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "vincere",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-15T08:27:43.000Z",
      "object_type": "ats_company",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Vincere"
   },
   {
      "type": "readable_field",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_order",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_query",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_updated_gte",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_order",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_query",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2025-01-15T08:27:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_user_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-01-14T16:48:04.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_location_id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2025-01-14T16:48:04.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_item_variant_id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2025-01-14T16:48:04.000Z",
      "categories": [
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "freshdesk",
      "created_at": "2025-01-14T16:48:04.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "freshdesk"
   },
   {
      "type": "pagination",
      "integration_type": "freshdesk",
      "created_at": "2025-01-14T16:48:04.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_limit",
      "integration_name": "freshdesk"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-01-14T16:48:04.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_offset",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-01-14T16:48:04.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_space_id",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-01-14T12:24:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2025-01-14T12:24:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2025-01-14T12:24:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2025-01-14T12:24:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Gmail"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2025-01-14T12:24:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2025-01-14T12:24:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "circle",
      "created_at": "2025-01-14T12:24:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "channel_ids",
      "integration_name": "Circle.so"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-01-14T12:24:19.000Z",
      "categories": [
         "kms",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_order",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-01-14T08:07:45.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "created_at": "2025-01-13T08:58:45.000Z",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftteams",
      "object_type": "hris_group",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-01-13T08:58:45.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-01-13T08:58:45.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "object",
      "created_at": "2025-01-13T08:58:45.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftsharepoint",
      "object_type": "hris_group",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftplanner",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftplanner",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftplanner",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftplanner",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftplanner",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftplanner",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-01-13T08:58:45.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "object",
      "created_at": "2025-01-13T08:58:45.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftonedrive",
      "object_type": "hris_group",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_group",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2025-01-13T08:58:45.000Z",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2025-01-13T08:58:45.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2025-01-13T08:58:45.000Z",
      "categories": [
         "task",
         "auth",
         "hris",
         "metadata",
         "storage",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-01-12T11:27:41.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_type",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2025-01-12T11:27:41.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_type",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_member",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_member",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2025-01-12T11:27:41.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "martech_list",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2025-01-12T11:27:41.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "martech_member",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesforce"
   },
   {
      "type": "method",
      "integration_type": "salesforce",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "martech",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "openai",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "OpenAI"
   },
   {
      "type": "readable_field",
      "integration_type": "mistralai",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "MistralAI"
   },
   {
      "type": "readable_field",
      "integration_type": "klaviyo",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "groq",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "Groq"
   },
   {
      "type": "readable_field",
      "integration_type": "googlegemini",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "genai_model",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "has_temperature",
      "integration_name": "Google Gemini"
   },
   {
      "type": "pagination",
      "integration_type": "googlegemini",
      "created_at": "2025-01-12T11:27:41.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_limit",
      "integration_name": "Google Gemini"
   },
   {
      "type": "pagination",
      "integration_type": "googlegemini",
      "created_at": "2025-01-12T11:27:41.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "object_type": "genai_model",
      "pagination": "list_offset",
      "integration_name": "Google Gemini"
   },
   {
      "type": "readable_field",
      "integration_type": "customerio",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "categories": [
         "martech",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Customer.io"
   },
   {
      "type": "readable_field",
      "integration_type": "azureopenai",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "Azure OpenAI"
   },
   {
      "type": "readable_field",
      "integration_type": "anyscale",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "AnyScale"
   },
   {
      "type": "readable_field",
      "integration_type": "anthropicclaude",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "tokens_used",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2025-01-12T11:27:41.000Z",
      "object_type": "martech_list",
      "categories": [
         "crm",
         "martech",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "integration",
      "created_at": "2025-01-12T00:00:00.000Z",
      "categories": [
         "martech",
         "auth",
         "passthrough"
      ],
      "integration_type": "salesforcemarketingcloud",
      "integration_name": "Salesforce Marketing Cloud"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2025-01-10T17:03:35.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-10T16:59:53.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "created_at": "2025-01-10T16:59:53.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-01-10T16:59:53.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2025-01-10T16:59:53.000Z",
      "categories": [
         "payment",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2025-01-10T16:59:53.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2025-01-09T18:18:16.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-09T10:16:46.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2025-01-09T10:16:46.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruiterflow",
      "object_type": "ats_company",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-09T10:16:46.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "recruiterflow",
      "created_at": "2025-01-09T10:16:46.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "googlemail",
      "created_at": "2025-01-09T10:16:46.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Gmail"
   },
   {
      "type": "readable_field",
      "integration_type": "notion",
      "created_at": "2025-01-08T16:47:54.000Z",
      "object_type": "kms_page",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Notion"
   },
   {
      "type": "readable_field",
      "integration_type": "coda",
      "created_at": "2025-01-08T16:47:54.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Coda"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2025-01-08T16:47:54.000Z",
      "object_type": "kms_page",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2025-01-08T11:01:55.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2025-01-08T11:01:55.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "googledrive",
      "created_at": "2025-01-08T11:01:55.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "dropbox",
      "created_at": "2025-01-08T11:01:55.000Z",
      "object_type": "storage_file",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Dropbox"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2025-01-08T11:01:55.000Z",
      "object_type": "storage_file",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2025-01-08T08:48:24.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "task_task",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Streamtime"
   },
   {
      "type": "pagination",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_sort_by_name",
      "integration_name": "Streamtime"
   },
   {
      "type": "pagination",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_parent_id",
      "integration_name": "Streamtime"
   },
   {
      "type": "object",
      "created_at": "2025-01-07T13:57:12.000Z",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "streamtime",
      "object_type": "crm_contact",
      "integration_name": "Streamtime"
   },
   {
      "type": "object",
      "created_at": "2025-01-07T13:57:12.000Z",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "streamtime",
      "object_type": "crm_company",
      "integration_name": "Streamtime"
   },
   {
      "type": "object",
      "created_at": "2025-01-07T13:57:12.000Z",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "streamtime",
      "object_type": "hris_employee",
      "integration_name": "Streamtime"
   },
   {
      "type": "object",
      "created_at": "2025-01-07T13:57:12.000Z",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "streamtime",
      "object_type": "task_project",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "ats_company",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "ats_company",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Streamtime"
   },
   {
      "type": "method",
      "integration_type": "streamtime",
      "created_at": "2025-01-07T13:57:12.000Z",
      "object_type": "task_project",
      "categories": [
         "accounting",
         "task",
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Streamtime"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-01-07T13:29:16.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "mentioned_members",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2025-01-07T10:57:17.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-01-07T09:37:11.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-01-07T09:37:11.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-01-07T09:37:11.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-01-07T09:37:11.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-01-07T09:37:11.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-01-07T09:37:11.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-01-07T09:37:11.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-01-07T09:37:11.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2025-01-07T09:37:11.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2025-01-07T09:37:11.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2025-01-07T09:37:11.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2025-01-07T09:37:11.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2025-01-07T09:37:11.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "task_id",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-01-02T14:59:39.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2025-01-02T14:59:39.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2025-01-02T13:44:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_offset",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "root_message_id",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-01-02T13:44:08.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_parent_id",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2025-01-02T13:44:08.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "object_type": "task_comment",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2025-01-02T13:44:08.000Z",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GitHub"
   },
   {
      "type": "method",
      "integration_type": "github",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GitHub"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "ClickUp"
   },
   {
      "type": "object",
      "object_type": "task_comment",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-02T13:44:08.000Z",
      "integration_name": "ClickUp"
   },
   {
      "type": "object",
      "created_at": "2025-01-02T13:44:08.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "integration_type": "clickup",
      "object_type": "storage_file",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "task",
         "hris",
         "auth",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "hris",
         "task",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "object",
      "object_type": "task_comment",
      "integration_type": "atlassianjira",
      "categories": [
         "auth",
         "hris",
         "task",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-02T13:44:08.000Z",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "object",
      "created_at": "2025-01-02T13:44:08.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "storage",
         "passthrough"
      ],
      "integration_type": "atlassianjira",
      "object_type": "storage_file",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "hris",
         "task",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "hris",
         "task",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "auth",
         "hris",
         "task",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "field": "attachment_ids",
      "integration_name": "Asana"
   },
   {
      "type": "object",
      "object_type": "task_comment",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "created_at": "2025-01-02T13:44:08.000Z",
      "integration_name": "Asana"
   },
   {
      "type": "object",
      "created_at": "2025-01-02T13:44:08.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "integration_type": "asana",
      "object_type": "storage_file",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "storage_file",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2025-01-02T13:44:08.000Z",
      "object_type": "task_comment",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "storage",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Asana"
   },
   {
      "type": "integration",
      "created_at": "2025-01-02T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlecloudplatform",
      "integration_name": "Google Cloud Platform"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-12-31T11:13:46.000Z",
      "object_type": "payment_subscription",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-12-31T11:13:46.000Z",
      "object_type": "payment_subscription",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-12-31T11:13:46.000Z",
      "object_type": "payment_subscription",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "object_type": "payment_subscription",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-12-31T11:13:46.000Z",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-12-31T11:13:46.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-12-31T11:13:46.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gocardless",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-12-31T11:13:46.000Z",
      "object_type": "payment_subscription",
      "integration_name": "GoCardless"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gocardless",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-12-31T11:13:46.000Z",
      "object_type": "payment_subscription",
      "integration_name": "GoCardless"
   },
   {
      "type": "object",
      "object_type": "payment_subscription",
      "integration_type": "gocardless",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-12-31T11:13:46.000Z",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-12-31T11:13:46.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-12-31T11:13:46.000Z",
      "object_type": "payment_subscription",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2024-12-31T09:17:53.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "has_tasks",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "marketing_email",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "form",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "page_view",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "marketing_email",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "form",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "task_project",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "task_task",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "task_project",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "task_task",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "task_project",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "task_task",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "field": "priority",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2024-12-30T10:16:59.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "native_webhook_parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2024-12-30T10:16:59.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "native_webhook_project_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2024-12-30T10:16:59.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "native_webhook_parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2024-12-30T10:16:59.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "native_webhook_project_id",
      "integration_name": "Asana"
   },
   {
      "type": "object",
      "created_at": "2024-12-30T10:16:59.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "integration_type": "asana",
      "object_type": "metadata_metadata",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2024-12-30T10:16:59.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "auth",
         "hris",
         "task",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Asana"
   },
   {
      "type": "integration",
      "created_at": "2024-12-27T00:00:00.000Z",
      "categories": [
         "accounting",
         "metadata",
         "commerce",
         "passthrough"
      ],
      "integration_type": "woocommerce",
      "integration_name": "WooCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2024-12-24T13:02:17.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "list_parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2024-12-24T13:02:17.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-24T12:05:30.000Z",
      "object_type": "ats_interview",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-24T12:05:30.000Z",
      "object_type": "ats_application",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-24T12:05:30.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-24T12:05:30.000Z",
      "object_type": "ats_job",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-24T12:05:30.000Z",
      "object_type": "ats_interview",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-24T12:05:30.000Z",
      "object_type": "ats_application",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-24T12:05:30.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-24T12:05:30.000Z",
      "object_type": "ats_job",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-24T12:05:30.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-24T12:05:30.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-24T12:05:30.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-24T12:05:30.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-24T12:05:30.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-24T12:05:30.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-24T12:05:30.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "pagination",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-24T12:05:30.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-12-23T18:26:18.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2024-12-23T18:26:18.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "azureopenai",
      "created_at": "2024-12-23T18:26:18.000Z",
      "object_type": "genai_prompt",
      "categories": [
         "genai",
         "passthrough"
      ],
      "field": "max_tokens",
      "integration_name": "Azure OpenAI"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2024-12-23T18:26:18.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2024-12-23T08:47:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "integration",
      "created_at": "2024-12-23T00:00:00.000Z",
      "categories": [
         "payment",
         "commerce",
         "accounting",
         "passthrough"
      ],
      "integration_type": "chargebee",
      "integration_name": "Chargebee"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-20T18:22:38.000Z",
      "object_type": "ats_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-20T18:22:38.000Z",
      "object_type": "ats_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-20T18:22:38.000Z",
      "object_type": "ats_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-20T18:22:38.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-20T18:22:38.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-20T18:22:38.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-20T18:22:38.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-20T18:22:38.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-20T18:22:38.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "object",
      "created_at": "2024-12-20T18:22:38.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruitcrm",
      "object_type": "ats_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "integration",
      "created_at": "2024-12-20T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "azureopenai",
      "integration_name": "Azure OpenAI"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2024-12-19T13:54:15.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-12-19T13:46:10.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-12-18T17:11:01.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2024-12-18T16:15:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-12-17T10:48:55.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-12-17T10:48:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-12-17T10:48:55.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-12-17T10:48:55.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "created_at": "2024-12-17T10:48:55.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zendesksell",
      "object_type": "hris_employee",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "object",
      "created_at": "2024-12-17T10:48:55.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zendesksell",
      "object_type": "crm_company",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "method",
      "integration_type": "zendesksell",
      "created_at": "2024-12-17T10:48:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "method",
      "integration_type": "zendesksell",
      "created_at": "2024-12-17T10:48:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "method",
      "integration_type": "zendesksell",
      "created_at": "2024-12-17T10:48:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "method",
      "integration_type": "zendesksell",
      "created_at": "2024-12-17T10:48:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "method",
      "integration_type": "smartrecruiters",
      "created_at": "2024-12-17T10:48:55.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "object",
      "created_at": "2024-12-17T10:48:55.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "heroku",
      "object_type": "passthrough",
      "integration_name": "Heroku"
   },
   {
      "type": "object",
      "created_at": "2024-12-17T10:48:55.000Z",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "greenhouseingest",
      "object_type": "passthrough",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "object",
      "created_at": "2024-12-17T10:48:55.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris",
         "passthrough"
      ],
      "integration_type": "gitlab",
      "object_type": "passthrough",
      "integration_name": "GitLab"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-12-17T09:36:38.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-12-17T09:36:38.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2024-12-13T15:04:06.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "workday",
      "object_type": "accounting_invoice",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2024-12-13T15:04:06.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "workday",
      "object_type": "accounting_contact",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable"
   },
   {
      "type": "object",
      "created_at": "2024-12-13T10:23:42.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgpro",
      "object_type": "ats_activity",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "created_at": "2024-12-13T10:23:42.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jazzhr",
      "object_type": "ats_activity",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "jazzhr",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "jazzhr",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JazzHR"
   },
   {
      "type": "method",
      "integration_type": "jazzhr",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JazzHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "original_status",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "bamboohr",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "method": "get",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2024-12-13T10:23:42.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "ashby",
      "object_type": "ats_activity",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Ashby"
   },
   {
      "type": "method",
      "integration_type": "ashby",
      "created_at": "2024-12-13T10:23:42.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2024-12-12T18:00:36.000Z",
      "object_type": "crm_event",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "affinity",
      "categories": [
         "crm",
         "passthrough"
      ],
      "created_at": "2024-12-12T18:00:36.000Z",
      "object_type": "crm_event",
      "integration_name": "Affinity"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2024-12-12T16:50:23.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2024-12-12T16:50:23.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-12-11T16:29:30.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BambooHR"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2024-12-11T13:15:12.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2024-12-11T13:15:12.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Greenhouse"
   },
   {
      "type": "integration",
      "created_at": "2024-12-11T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "googleanalytics",
      "integration_name": "Google Analytics"
   },
   {
      "type": "integration",
      "created_at": "2024-12-11T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "careerplug",
      "integration_name": "CareerPlug"
   },
   {
      "type": "writable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-12-10T15:51:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-12-10T15:51:57.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-12-10T15:51:57.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2024-12-10T13:46:19.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "object_type": "metadata_metadata",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-10T13:34:56.000Z",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-12-10T13:34:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-12-10T13:34:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-10T13:34:56.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "Akeneo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-10T13:34:56.000Z",
      "object_type": "metadata_metadata",
      "integration_name": "Akeneo"
   },
   {
      "type": "object",
      "object_type": "metadata_metadata",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "created_at": "2024-12-10T13:34:56.000Z",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2024-12-10T13:34:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2024-12-10T13:34:56.000Z",
      "object_type": "metadata_metadata",
      "categories": [
         "commerce",
         "metadata",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Akeneo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-09T13:30:51.000Z",
      "object_type": "hris_employee",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-12-09T13:30:51.000Z",
      "object_type": "hris_employee",
      "integration_name": "HighLevel"
   },
   {
      "type": "object",
      "created_at": "2024-12-09T13:30:51.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "highlevel",
      "object_type": "hris_employee",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2024-12-09T13:30:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HighLevel"
   },
   {
      "type": "object",
      "created_at": "2024-12-09T13:30:51.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "greenhouse",
      "object_type": "ats_activity",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2024-12-05T16:59:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2024-12-05T16:59:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2024-12-05T16:59:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2024-12-05T16:59:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "stage_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-05T16:53:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-05T16:53:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-05T16:53:30.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-05T16:53:30.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-12-05T12:24:58.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "web_url",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-05T12:06:16.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-05T12:06:16.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-05T12:06:16.000Z",
      "object_type": "crm_contact",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-12-05T12:06:16.000Z",
      "object_type": "crm_lead",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2024-12-05T12:06:16.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "writable_field",
      "integration_type": "highlevel",
      "created_at": "2024-12-05T12:06:16.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "HighLevel"
   },
   {
      "type": "method",
      "integration_type": "highlevel",
      "created_at": "2024-12-05T12:06:16.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "HighLevel"
   },
   {
      "type": "integration",
      "created_at": "2024-12-05T00:00:00.000Z",
      "categories": [
         "accounting",
         "task",
         "passthrough"
      ],
      "integration_type": "streamtime",
      "integration_name": "Streamtime"
   },
   {
      "type": "integration",
      "created_at": "2024-12-05T00:00:00.000Z",
      "categories": [
         "auth",
         "crm",
         "passthrough"
      ],
      "integration_type": "googlecontacts",
      "integration_name": "Google Contacts"
   },
   {
      "type": "readable_field",
      "integration_type": "notion",
      "created_at": "2024-12-04T12:46:28.000Z",
      "object_type": "kms_space",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "parent_page_id",
      "integration_name": "Notion"
   },
   {
      "type": "readable_field",
      "integration_type": "notion",
      "created_at": "2024-12-04T12:46:28.000Z",
      "object_type": "kms_page",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Notion"
   },
   {
      "type": "readable_field",
      "integration_type": "notion",
      "created_at": "2024-12-04T12:46:28.000Z",
      "object_type": "kms_page",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "has_children",
      "integration_name": "Notion"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salsify",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Salsify"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "salesloft",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Salesloft"
   },
   {
      "type": "method",
      "integration_type": "phenom",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Phenom"
   },
   {
      "type": "method",
      "integration_type": "phenom",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Phenom"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paypal",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paypal"
   },
   {
      "type": "method",
      "integration_type": "paycom",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycom"
   },
   {
      "type": "method",
      "integration_type": "paycom",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Paycom"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicssales",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "task_task",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_order",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_order",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_account",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_account",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "microsoftdynamicscustomerengagement",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "humanforce",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Humanforce"
   },
   {
      "type": "method",
      "integration_type": "helpscout",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "kms_page",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Helpscout"
   },
   {
      "type": "method",
      "integration_type": "heavenhr",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HeavenHR"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "repo_organization",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "method": "get",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "method": "get",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "method": "get",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "method": "get",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gitlab",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "method": "get",
      "integration_name": "GitLab"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "gem",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Gem"
   },
   {
      "type": "method",
      "integration_type": "firefish",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Firefish"
   },
   {
      "type": "method",
      "integration_type": "elmo",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_timeoff",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ELMO"
   },
   {
      "type": "method",
      "integration_type": "elmo",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ELMO"
   },
   {
      "type": "method",
      "integration_type": "deputy",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Deputy"
   },
   {
      "type": "method",
      "integration_type": "coda",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "kms_space",
      "categories": [
         "kms",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Coda"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "circle",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Circle.so"
   },
   {
      "type": "method",
      "integration_type": "circle",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Circle.so"
   },
   {
      "type": "method",
      "integration_type": "circle",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Circle.so"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "checkr",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Checkr"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cats",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "CATS"
   },
   {
      "type": "method",
      "integration_type": "cascade",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cascade"
   },
   {
      "type": "method",
      "integration_type": "cascade",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cascade"
   },
   {
      "type": "method",
      "integration_type": "cascade",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Cascade"
   },
   {
      "type": "method",
      "integration_type": "canvas",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Canvas"
   },
   {
      "type": "method",
      "integration_type": "breezyhr",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "BreezyHR"
   },
   {
      "type": "method",
      "integration_type": "boldcommerce",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "method",
      "integration_type": "bitbucket",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "repo_organization",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BitBucket"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "hris_employee",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "commerce_location",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "atsanywhere",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "applicantstack",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "method",
      "integration_type": "applicantstack",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "method",
      "integration_type": "applicantstack",
      "created_at": "2024-12-03T18:27:33.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2024-11-29T15:19:30.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2024-11-29T15:19:30.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2024-11-29T15:19:30.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2024-11-29T15:19:30.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2024-11-29T15:19:30.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "vincere",
      "created_at": "2024-11-29T15:19:30.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2024-11-29T15:19:30.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2024-11-29T15:19:30.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Vincere"
   },
   {
      "type": "method",
      "integration_type": "vincere",
      "created_at": "2024-11-29T15:19:30.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Vincere"
   },
   {
      "type": "integration",
      "created_at": "2024-11-29T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "atsanywhere",
      "integration_name": "ATS Anywhere"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2024-11-28T14:10:12.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_channel_id",
      "integration_name": "Gmail"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_document",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_activity",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_document",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_activity",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_application",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-26T14:33:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-26T14:33:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gitlab",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "repo_commit",
      "integration_name": "GitLab"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gitlab",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "repo_commit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2024-11-26T14:33:07.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "repo_commit",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "repo_branch",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "repo_commit",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "repo_branch",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "repo_pullrequest",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-26T14:33:07.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-26T14:33:07.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-26T14:33:07.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitHub"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gem",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_document",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gem",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_application",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gem",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_document",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gem",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_application",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_application",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-26T14:33:07.000Z",
      "object_type": "ats_application",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-11-26T13:58:59.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zoom",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoom"
   },
   {
      "type": "pagination",
      "integration_type": "zohopeople",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoho People"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohoinvoice",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_invoice_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_type",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "wave",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Wave"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "vincere",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Vincere"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "strongdm",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "StrongDM"
   },
   {
      "type": "pagination",
      "integration_type": "strongdm",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "StrongDM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "payment_link",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "payment_payout",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "payment_refund",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "payment_payment",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "commerce_item",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "commerce_item",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "payment_link",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "payment_payout",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "payment_refund",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "payment_payment",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "commerce_item",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_link",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "ats_document",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_channel_id",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_type",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "virtual_webhook_ticket_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "salsify",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salsify"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "sageaccounting",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "pagination",
      "integration_type": "recruitee",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Recruitee"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "crm_event",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "crm_event",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "crm_event",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_order",
      "pagination": "virtual_webhook_type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "phenom",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Phenom"
   },
   {
      "type": "pagination",
      "integration_type": "phenom",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Phenom"
   },
   {
      "type": "pagination",
      "integration_type": "peakon",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Peakon"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "monday",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Monday"
   },
   {
      "type": "pagination",
      "integration_type": "monday",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Monday"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftplanner",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftplanner",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_channel_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "linear",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "Linear"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "jumpcloud",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JumpCloud"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Jobvite"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-22T16:30:39.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_location",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_company",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobdiva",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "ironclad",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Ironclad"
   },
   {
      "type": "pagination",
      "integration_type": "ironclad",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Ironclad"
   },
   {
      "type": "pagination",
      "integration_type": "ironclad",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Ironclad"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_customer_id",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "instantlyai",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_customer_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "heavenhr",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "HeavenHR"
   },
   {
      "type": "pagination",
      "integration_type": "heavenhr",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "HeavenHR"
   },
   {
      "type": "pagination",
      "integration_type": "guru",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_space_id",
      "integration_name": "Guru"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "googlemail",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gmail"
   },
   {
      "type": "pagination",
      "integration_type": "googledrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Google Drive"
   },
   {
      "type": "pagination",
      "integration_type": "googledrive",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Google Drive"
   },
   {
      "type": "pagination",
      "integration_type": "googleclassroom",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "virtual_webhook_student_id",
      "integration_name": "Google Classroom"
   },
   {
      "type": "pagination",
      "integration_type": "googleclassroom",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "object_type": "lms_course",
      "pagination": "virtual_webhook_teacher_id",
      "integration_name": "Google Classroom"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_payout",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gocardless",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_refund",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_branch_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "object_type": "repo_organization",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "gitlab",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_limit",
      "integration_name": "GitLab"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_branch_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_application_id",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "freshteam",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Freshteam"
   },
   {
      "type": "pagination",
      "integration_type": "freshdesk",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "virtual_webhook_limit",
      "integration_name": "freshdesk"
   },
   {
      "type": "pagination",
      "integration_type": "freshdesk",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_limit",
      "integration_name": "freshdesk"
   },
   {
      "type": "pagination",
      "integration_type": "freshdesk",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "freshdesk"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "firefish",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Firefish"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_limit",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "dropbox",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Dropbox"
   },
   {
      "type": "pagination",
      "integration_type": "dropbox",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Dropbox"
   },
   {
      "type": "pagination",
      "integration_type": "discord",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_channel_id",
      "integration_name": "Discord"
   },
   {
      "type": "pagination",
      "integration_type": "discord",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Discord"
   },
   {
      "type": "pagination",
      "integration_type": "customerio",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "Customer.io"
   },
   {
      "type": "pagination",
      "integration_type": "customerio",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "Customer.io"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "coursera",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "object_type": "lms_class",
      "pagination": "virtual_webhook_course_id",
      "integration_name": "Coursera"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "native_webhook_project_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "clickup",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "native_webhook_project_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "circle",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "virtual_webhook_space_id",
      "integration_name": "Circle.so"
   },
   {
      "type": "pagination",
      "integration_type": "checkr",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Checkr"
   },
   {
      "type": "pagination",
      "integration_type": "cascade",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Cascade"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_candidate_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "box",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Box"
   },
   {
      "type": "pagination",
      "integration_type": "box",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Box"
   },
   {
      "type": "pagination",
      "integration_type": "box",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "native_webhook_parent_id",
      "integration_name": "Box"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "virtual_webhook_repo_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "virtual_webhook_org_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_item_variant_id",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "virtual_webhook_location_id",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_candidate",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "atlassianconfluence",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "virtual_webhook_job_id",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "task_project",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_project_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "asana",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "object_type": "task_task",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Asana"
   },
   {
      "type": "pagination",
      "integration_type": "ameego",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Ameego"
   },
   {
      "type": "pagination",
      "integration_type": "alexis",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Alexis"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_limit",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "virtual_webhook_parent_id",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "virtual_webhook_collection_id",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_contact_id",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_deal_id",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_user_id",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "virtual_webhook_type",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "virtual_webhook_company_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_limit",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-11-22T16:30:39.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "virtual_webhook_list_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-20T16:52:40.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-20T16:52:40.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-20T16:52:40.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2024-11-20T15:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "pronouns",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2024-11-20T15:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Slack"
   },
   {
      "type": "method",
      "integration_type": "slack",
      "created_at": "2024-11-20T15:52:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "recruitcrm",
      "created_at": "2024-11-20T15:52:11.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_type",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-20T15:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-11-20T15:52:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_candidate_id",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2024-11-20T15:52:11.000Z",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_repo_id",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-11-20T12:03:54.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Pipedrive"
   },
   {
      "type": "integration",
      "created_at": "2024-11-20T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "customerio",
      "integration_name": "Customer.io"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2024-11-19T14:52:04.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-19T13:53:46.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_commit",
      "pagination": "list_repo_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-19T13:53:46.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_branch",
      "pagination": "list_repo_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-19T13:53:46.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_pullrequest",
      "pagination": "list_repo_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "github",
      "created_at": "2024-11-19T13:53:46.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_org_id",
      "integration_name": "GitHub"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2024-11-19T13:38:41.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_user_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "method",
      "integration_type": "googledrive",
      "created_at": "2024-11-19T13:38:41.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-11-15T18:05:46.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "marital_status",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-11-15T18:05:46.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-11-15T18:05:46.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-11-15T18:05:46.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-11-15T18:05:46.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-11-15T18:05:46.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Crelate"
   },
   {
      "type": "integration",
      "created_at": "2024-11-15T00:00:00.000Z",
      "categories": [
         "crm",
         "accounting",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicssales",
      "integration_name": "Microsoft Dynamics 365 Sales"
   },
   {
      "type": "integration",
      "created_at": "2024-11-15T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "task",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicscustomerengagement",
      "integration_name": "Microsoft Dynamics 365 Customer Engagement"
   },
   {
      "type": "integration",
      "created_at": "2024-11-15T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "passthrough"
      ],
      "integration_type": "microsoftdynamicsbusinesscentral",
      "integration_name": "Microsoft Dynamics 365 Business Central"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_query",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_query",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "pagination",
      "integration_type": "zohocrm",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "Workstream"
   },
   {
      "type": "pagination",
      "integration_type": "workstream",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Workstream"
   },
   {
      "type": "method",
      "integration_type": "slack",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_limit",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_offset",
      "integration_name": "ServiceNow"
   },
   {
      "type": "pagination",
      "integration_type": "servicenow",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_ticket_id",
      "integration_name": "ServiceNow"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "creator_user_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftplanner",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_tasks",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "mailchimp",
      "categories": [
         "martech",
         "auth"
      ],
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "martech_member",
      "integration_name": "Mailchimp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "mailchimp",
      "categories": [
         "martech",
         "auth"
      ],
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "martech_member",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "has_tasks",
      "integration_name": "Linear"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "martech_member",
      "integration_name": "Klaviyo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "martech_member",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "instantlyai",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_query",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "pagination",
      "integration_type": "instantlyai",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "pagination",
      "integration_type": "holded",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_offset",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "gitlab",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "field": "has_tasks",
      "integration_name": "GitLab"
   },
   {
      "type": "readable_field",
      "integration_type": "github",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "field": "has_tasks",
      "integration_name": "GitHub"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "has_tasks",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "ClickUp"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_updated_gte",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "bitbucket",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "object_type": "repo_repository",
      "pagination": "list_order",
      "integration_name": "BitBucket"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "martech_member",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-14T22:24:16.000Z",
      "object_type": "martech_member",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-11-14T22:24:16.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "object",
      "object_type": "repo_commit",
      "integration_type": "gitlab",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "GitLab"
   },
   {
      "type": "object",
      "object_type": "repo_branch",
      "integration_type": "gitlab",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "GitLab"
   },
   {
      "type": "object",
      "object_type": "repo_repository",
      "integration_type": "gitlab",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "GitLab"
   },
   {
      "type": "object",
      "object_type": "repo_organization",
      "integration_type": "gitlab",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "GitLab"
   },
   {
      "type": "object",
      "object_type": "repo_commit",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "object_type": "repo_branch",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "object_type": "repo_pullrequest",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "object_type": "repo_repository",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "object_type": "repo_organization",
      "integration_type": "github",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "GitHub"
   },
   {
      "type": "object",
      "object_type": "repo_commit",
      "integration_type": "bitbucket",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "BitBucket"
   },
   {
      "type": "object",
      "object_type": "repo_branch",
      "integration_type": "bitbucket",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "BitBucket"
   },
   {
      "type": "object",
      "object_type": "repo_pullrequest",
      "integration_type": "bitbucket",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "BitBucket"
   },
   {
      "type": "object",
      "object_type": "repo_repository",
      "integration_type": "bitbucket",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "BitBucket"
   },
   {
      "type": "object",
      "object_type": "repo_organization",
      "integration_type": "bitbucket",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-10T13:13:06.000Z",
      "integration_name": "BitBucket"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-11-08T17:18:57.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2024-11-08T17:18:57.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Gmail"
   },
   {
      "type": "object",
      "object_type": "lms_instructor",
      "integration_type": "googleclassroom",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "Google Classroom"
   },
   {
      "type": "object",
      "object_type": "lms_student",
      "integration_type": "googleclassroom",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "Google Classroom"
   },
   {
      "type": "object",
      "object_type": "lms_course",
      "integration_type": "googleclassroom",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "Google Classroom"
   },
   {
      "type": "object",
      "object_type": "lms_instructor",
      "integration_type": "d2l",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "object",
      "object_type": "lms_student",
      "integration_type": "d2l",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "object",
      "object_type": "lms_course",
      "integration_type": "d2l",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "object",
      "object_type": "lms_instructor",
      "integration_type": "coursera",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "Coursera"
   },
   {
      "type": "object",
      "object_type": "lms_student",
      "integration_type": "coursera",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "Coursera"
   },
   {
      "type": "object",
      "object_type": "lms_class",
      "integration_type": "coursera",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "Coursera"
   },
   {
      "type": "object",
      "object_type": "lms_course",
      "integration_type": "coursera",
      "categories": [
         "lms",
         "passthrough"
      ],
      "created_at": "2024-11-08T17:18:57.000Z",
      "integration_name": "Coursera"
   },
   {
      "type": "integration",
      "created_at": "2024-11-08T00:00:00.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "integration_type": "googleclassroom",
      "integration_name": "Google Classroom"
   },
   {
      "type": "integration",
      "created_at": "2024-11-08T00:00:00.000Z",
      "categories": [
         "repo",
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "gitlabdedicated",
      "integration_name": "GitLab Dedicated"
   },
   {
      "type": "integration",
      "created_at": "2024-11-08T00:00:00.000Z",
      "categories": [
         "auth",
         "task",
         "repo",
         "hris"
      ],
      "integration_type": "gitlab",
      "integration_name": "GitLab"
   },
   {
      "type": "integration",
      "created_at": "2024-11-08T00:00:00.000Z",
      "categories": [
         "repo",
         "auth",
         "storage",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "githubenterpriseserver",
      "integration_name": "GitHub Enterprise Server"
   },
   {
      "type": "integration",
      "created_at": "2024-11-08T00:00:00.000Z",
      "categories": [
         "auth",
         "storage",
         "task",
         "hris",
         "repo",
         "passthrough"
      ],
      "integration_type": "github",
      "integration_name": "GitHub"
   },
   {
      "type": "integration",
      "created_at": "2024-11-08T00:00:00.000Z",
      "categories": [
         "lms",
         "auth",
         "passthrough"
      ],
      "integration_type": "d2l",
      "integration_name": "D2L Brightspace"
   },
   {
      "type": "integration",
      "created_at": "2024-11-08T00:00:00.000Z",
      "categories": [
         "lms",
         "passthrough"
      ],
      "integration_type": "coursera",
      "integration_name": "Coursera"
   },
   {
      "type": "integration",
      "created_at": "2024-11-08T00:00:00.000Z",
      "categories": [
         "auth",
         "repo",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "bitbucket",
      "integration_name": "BitBucket"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2024-11-06T12:06:52.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2024-11-06T12:06:52.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2024-11-06T12:06:52.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_limit",
      "integration_name": "Attio"
   },
   {
      "type": "pagination",
      "integration_type": "attio",
      "created_at": "2024-11-06T12:06:52.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_offset",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "googledrive",
      "created_at": "2024-11-06T08:26:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "version",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2024-11-06T08:26:31.000Z",
      "object_type": "storage_file",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "version",
      "integration_name": "Box"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_message",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "kms_page",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_message",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "kms_page",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_message",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "kms_page",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_message",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "kms_page",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_message",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "kms_page",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_channel",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "messaging_message",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "kms_page",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "zendesk",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "Zendesk"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "task_task",
      "integration_name": "ClickUp"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "task_project",
      "integration_name": "ClickUp"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "task_task",
      "integration_name": "ClickUp"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "task_project",
      "integration_name": "ClickUp"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "task_task",
      "integration_name": "ClickUp"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "clickup",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "task_project",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2024-11-01T21:22:14.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "Asana"
   },
   {
      "type": "integration",
      "created_at": "2024-11-01T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "firefish",
      "integration_name": "Firefish"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-10-31T15:20:23.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "success_url",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2024-10-31T15:20:23.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "success_url",
      "integration_name": "GoCardless"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2024-10-31T15:20:23.000Z",
      "object_type": "task_task",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2024-10-31T15:20:23.000Z",
      "object_type": "task_task",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "workstream",
      "created_at": "2024-10-30T19:31:42.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Workstream"
   },
   {
      "type": "method",
      "integration_type": "workstream",
      "created_at": "2024-10-30T19:31:42.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workstream"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2024-10-30T19:31:42.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-10-30T19:31:42.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_data",
      "integration_name": "Workable"
   },
   {
      "type": "object",
      "created_at": "2024-10-30T19:31:42.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "facebook",
      "object_type": "passthrough",
      "integration_name": "Facebook"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "atlassianconfluence",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-10-30T19:31:42.000Z",
      "object_type": "kms_page",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "atlassianconfluence",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-10-30T19:31:42.000Z",
      "object_type": "kms_page",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "atlassianconfluence",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-10-30T19:31:42.000Z",
      "object_type": "kms_page",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-10-28T17:56:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-10-28T17:56:30.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Crelate"
   },
   {
      "type": "integration",
      "created_at": "2024-10-28T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workstream",
      "integration_name": "Workstream"
   },
   {
      "type": "integration",
      "created_at": "2024-10-28T00:00:00.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "integration_type": "cleon1",
      "integration_name": "Cleon1"
   },
   {
      "type": "integration",
      "created_at": "2024-10-27T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftplanner",
      "integration_name": "Microsoft Planner"
   },
   {
      "type": "integration",
      "created_at": "2024-10-25T00:00:00.000Z",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "integration_type": "indeed",
      "integration_name": "Indeed"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable"
   },
   {
      "type": "method",
      "integration_type": "workable",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "size",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "mime_type",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "download_url",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "data",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "size",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "mime_type",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "download_url",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "data",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "method",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "discord",
      "created_at": "2024-10-23T17:25:36.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_channel_id",
      "integration_name": "Discord"
   },
   {
      "type": "method",
      "integration_type": "discord",
      "created_at": "2024-10-23T17:25:36.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Discord"
   },
   {
      "type": "integration",
      "created_at": "2024-10-23T00:00:00.000Z",
      "categories": [
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohoinvoice",
      "integration_name": "Zoho Invoice"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2024-10-22T14:47:31.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "type",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_order",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-10-22T13:33:53.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Books"
   },
   {
      "type": "method",
      "integration_type": "zohobooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_order",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-10-22T13:33:53.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Xero"
   },
   {
      "type": "method",
      "integration_type": "xero",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "sageaccounting",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "invoice_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_order",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-10-22T13:33:53.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_order",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "paypal",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Paypal"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2024-10-22T13:33:53.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "BigCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-10-17T15:41:25.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-10-17T15:41:25.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-10-17T15:41:25.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "start_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-10-17T15:41:25.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-10-17T15:41:25.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-10-17T15:41:25.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "end_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-10-17T15:41:25.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2024-10-17T15:41:25.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2024-10-17T15:41:25.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "object",
      "created_at": "2024-10-17T12:22:41.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgpro",
      "object_type": "ats_document",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-10-17T12:22:41.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-10-17T12:22:41.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-10-17T12:22:41.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ameego",
      "created_at": "2024-10-17T11:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Ameego"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2024-10-17T11:35:47.000Z",
      "object_type": "commerce_item",
      "integration_name": "Akeneo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "akeneo",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "created_at": "2024-10-17T11:35:47.000Z",
      "object_type": "commerce_item",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2024-10-17T11:35:47.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_updated_gte",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2024-10-17T11:35:47.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_offset",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2024-10-16T17:56:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "googledrive",
      "created_at": "2024-10-16T17:56:51.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2024-10-15T10:52:07.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "loxo",
      "object_type": "ats_activity",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "googledrive",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "data",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "bigcommerce",
      "created_at": "2024-10-15T10:52:07.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "BigCommerce"
   },
   {
      "type": "integration",
      "created_at": "2024-10-15T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "salsify",
      "integration_name": "Salsify"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2024-10-14T10:09:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "sub_type",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2024-10-14T10:09:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "sub_type",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-10-14T10:09:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sub_type",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-10-14T10:09:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sub_type",
      "integration_name": "Bullhorn"
   },
   {
      "type": "integration",
      "created_at": "2024-10-13T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "vincere",
      "integration_name": "Vincere"
   },
   {
      "type": "writable_field",
      "integration_type": "googledrive",
      "created_at": "2024-10-10T17:02:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Google Drive"
   },
   {
      "type": "writable_field",
      "integration_type": "googledrive",
      "created_at": "2024-10-10T17:02:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Google Drive"
   },
   {
      "type": "writable_field",
      "integration_type": "googledrive",
      "created_at": "2024-10-10T17:02:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "mime_type",
      "integration_name": "Google Drive"
   },
   {
      "type": "writable_field",
      "integration_type": "googledrive",
      "created_at": "2024-10-10T17:02:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "download_url",
      "integration_name": "Google Drive"
   },
   {
      "type": "method",
      "integration_type": "googledrive",
      "created_at": "2024-10-10T17:02:36.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Google Drive"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-10-10T16:18:47.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_query",
      "integration_name": "QuickBooks"
   },
   {
      "type": "integration",
      "created_at": "2024-10-10T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zambion",
      "integration_name": "Readytech Zambion"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-10-08T22:48:40.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "sageaccounting",
      "created_at": "2024-10-08T22:48:40.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-10-08T22:48:40.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-10-08T22:48:40.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-10-08T22:48:40.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "contacts",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "created_at": "2024-10-04T15:12:59.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "docusign",
      "object_type": "hris_employee",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "created_at": "2024-10-04T15:12:59.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "docusign",
      "object_type": "hris_company",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "created_at": "2024-10-04T15:12:59.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "docusign",
      "object_type": "passthrough",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2024-10-04T15:12:59.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DocuSign"
   },
   {
      "type": "method",
      "integration_type": "docusign",
      "created_at": "2024-10-04T15:12:59.000Z",
      "object_type": "hris_company",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "DocuSign"
   },
   {
      "type": "object",
      "created_at": "2024-10-03T16:50:04.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "pipedrive",
      "object_type": "passthrough",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2024-10-01T23:20:52.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-10-01T13:51:18.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2024-09-30T09:58:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2024-09-30T09:58:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2024-09-30T09:58:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-09-30T09:58:04.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_candidate_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "method",
      "integration_type": "jobadder",
      "created_at": "2024-09-30T09:58:04.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobvite",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-26T10:42:28.000Z",
      "object_type": "ats_job",
      "integration_name": "Jobvite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobvite",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-26T10:42:28.000Z",
      "object_type": "ats_job",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-09-26T10:42:28.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-09-24T14:01:30.000Z",
      "object_type": "martech_member",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "list_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-24T13:26:30.000Z",
      "object_type": "ats_interview",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-24T13:26:30.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-24T13:26:30.000Z",
      "object_type": "ats_job",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-24T13:26:30.000Z",
      "object_type": "ats_application",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-24T13:26:30.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-24T13:26:30.000Z",
      "object_type": "ats_interview",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-24T13:26:30.000Z",
      "object_type": "ats_job",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-24T13:26:30.000Z",
      "object_type": "ats_application",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2024-09-20T19:51:40.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Ashby"
   },
   {
      "type": "object",
      "created_at": "2024-09-20T14:30:53.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "lever",
      "object_type": "ats_activity",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2024-09-20T14:30:53.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2024-09-20T14:30:53.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2024-09-20T14:30:53.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2024-09-20T14:30:53.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Lever"
   },
   {
      "type": "method",
      "integration_type": "lever",
      "created_at": "2024-09-20T14:30:53.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2024-09-20T14:30:53.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2024-09-20T14:30:53.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2024-09-20T14:30:53.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "project_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "priority",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "ClickUp"
   },
   {
      "type": "writable_field",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "assigned_user_ids",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "clickup",
      "created_at": "2024-09-19T13:01:01.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ClickUp"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-09-18T11:37:09.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2024-09-18T11:37:09.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "subgroup",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "section",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "parent_account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "group",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "balance",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2024-09-16T16:24:37.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-09-16T15:07:39.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "sageaccounting",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-09-16T15:07:39.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "object",
      "created_at": "2024-09-16T15:07:39.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "sageaccounting",
      "object_type": "accounting_transaction",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-09-16T15:07:39.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-09-16T15:07:39.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2024-09-16T15:07:39.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2024-09-16T15:07:39.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "variants",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Akeneo"
   },
   {
      "type": "writable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "collection_ids",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Akeneo"
   },
   {
      "type": "pagination",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_query",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "akeneo",
      "created_at": "2024-09-13T18:24:34.000Z",
      "object_type": "commerce_item",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Akeneo"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-09-13T18:16:49.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-09-13T18:16:49.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-09-13T18:16:49.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-09-13T18:16:49.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-09-13T18:16:49.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-09-13T18:16:49.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-13T14:08:45.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-13T14:08:45.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "metadata",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-09-10T19:59:44.000Z",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "vendor_name",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "variants",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "slug",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "public_name",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "public_description",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_taxable",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "collection_ids",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-09-10T18:08:36.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-09-09T23:48:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "offers",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2024-09-09T23:48:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "offers",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-09-09T23:48:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "offers",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-09-09T23:48:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "offers",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-09-09T23:48:52.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_raw_fields",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-09-09T23:48:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "offers",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-09-09T23:48:52.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_raw_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-09-09T23:48:52.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_raw_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-09-09T23:48:52.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_raw_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-09-09T23:48:52.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_raw_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-09-09T23:48:52.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "list_raw_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-09-09T23:48:52.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_raw_fields",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-09-09T23:48:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "offers",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2024-09-09T23:48:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "offers",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "discord",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-06T14:50:31.000Z",
      "object_type": "messaging_message",
      "integration_name": "Discord"
   },
   {
      "type": "pagination",
      "integration_type": "discord",
      "created_at": "2024-09-06T14:50:31.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_offset",
      "integration_name": "Discord"
   },
   {
      "type": "method",
      "integration_type": "discord",
      "created_at": "2024-09-06T14:50:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Discord"
   },
   {
      "type": "method",
      "integration_type": "discord",
      "created_at": "2024-09-06T14:50:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Discord"
   },
   {
      "type": "method",
      "integration_type": "discord",
      "created_at": "2024-09-06T14:50:31.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-09-06T14:22:30.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Jobvite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googlemail",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-09-05T14:41:58.000Z",
      "object_type": "messaging_message",
      "integration_name": "Gmail"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "googlemail",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-09-05T14:41:58.000Z",
      "object_type": "messaging_message",
      "integration_name": "Gmail"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "googlemail",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-09-05T14:41:58.000Z",
      "object_type": "messaging_message",
      "integration_name": "Gmail"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-09-05T14:41:58.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-04T22:29:04.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-09-04T22:29:04.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-09-02T10:39:21.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "lead_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-09-02T10:39:21.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-09-02T10:39:21.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-09-02T10:39:21.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "lead_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-09-02T10:39:21.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "contact_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "integration",
      "created_at": "2024-08-29T00:00:00.000Z",
      "categories": [
         "ticketing",
         "passthrough"
      ],
      "integration_type": "atlassianservicedesk",
      "integration_name": "Atlassian Service Desk"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-08-28T12:35:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "method",
      "integration_type": "zohocrm",
      "created_at": "2024-08-28T12:35:00.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-08-28T12:35:00.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-08-28T12:35:00.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-08-28T12:05:28.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "subgroup",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-08-28T12:05:28.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "section",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-08-28T12:05:28.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "group",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-08-27T15:57:16.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-08-27T15:57:16.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-08-27T15:57:16.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "jobscore",
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "hris_location",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_interview",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "hris_location",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_interview",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-08-23T13:16:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobscore",
      "object_type": "hris_location",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-08-23T13:16:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobscore",
      "object_type": "ats_applicationstatus",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-08-23T13:16:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobscore",
      "object_type": "ats_scorecard",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-08-23T13:16:11.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobscore",
      "object_type": "ats_interview",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-08-23T13:16:11.000Z",
      "object_type": "ats_interview",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-08-21T14:10:19.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "to",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-08-21T14:10:19.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "from",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-08-21T14:10:19.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "cc",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-08-21T14:10:19.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "bcc",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-08-21T14:10:19.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "to",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-08-21T14:10:19.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "from",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-08-21T14:10:19.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "cc",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-08-21T14:10:19.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "bcc",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "departments",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Jobvite"
   },
   {
      "type": "writable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Jobvite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobvite",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Jobvite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobvite",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_application",
      "integration_name": "Jobvite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobvite",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Jobvite"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobvite",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_application",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Jobvite"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2024-08-19T16:19:52.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "web_url",
      "integration_name": "Ashby"
   },
   {
      "type": "object",
      "created_at": "2024-08-13T10:16:49.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruitcrm",
      "object_type": "crm_event",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2024-08-13T10:16:49.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2024-08-13T10:16:49.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2024-08-13T10:16:49.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2024-08-13T10:16:49.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2024-08-13T10:16:49.000Z",
      "object_type": "crm_event",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-13T10:16:49.000Z",
      "object_type": "crm_event",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-13T10:16:49.000Z",
      "object_type": "crm_event",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-08-13T10:16:49.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_offset",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-08T12:37:31.000Z",
      "object_type": "crm_company",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-08T12:37:31.000Z",
      "object_type": "crm_contact",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-08T12:37:31.000Z",
      "object_type": "crm_deal",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-08T12:37:31.000Z",
      "object_type": "crm_company",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-08T12:37:31.000Z",
      "object_type": "crm_contact",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-08T12:37:31.000Z",
      "object_type": "crm_deal",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-08T12:37:31.000Z",
      "object_type": "crm_company",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-08T12:37:31.000Z",
      "object_type": "crm_contact",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-08-08T12:37:31.000Z",
      "object_type": "crm_deal",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2024-08-07T14:29:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_data",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2024-08-07T14:29:20.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-08-07T14:29:20.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-08-07T14:29:20.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "group_ids",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2024-08-06T23:03:12.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2024-08-06T22:26:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "foundU"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2024-08-06T22:26:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "foundU"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2024-08-06T22:26:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "foundU"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2024-08-06T22:26:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "foundU"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2024-08-06T22:26:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "foundU"
   },
   {
      "type": "pagination",
      "integration_type": "foundu",
      "created_at": "2024-08-06T22:26:11.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "foundU"
   },
   {
      "type": "method",
      "integration_type": "foundu",
      "created_at": "2024-08-06T22:26:11.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "foundU"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2024-08-02T12:41:36.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-08-02T12:41:36.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_candidate_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "method",
      "integration_type": "successfactors",
      "created_at": "2024-08-02T12:41:36.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "integration",
      "created_at": "2024-08-02T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "phenom",
      "integration_name": "Phenom"
   },
   {
      "type": "object",
      "created_at": "2024-08-01T13:04:33.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruitcrm",
      "object_type": "ats_activity",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "method",
      "integration_type": "recruitcrm",
      "created_at": "2024-08-01T13:04:33.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "writable_field",
      "integration_type": "zoom",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "groups",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "strongdm",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "StrongDM"
   },
   {
      "type": "writable_field",
      "integration_type": "scoro",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "scoro",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "rippling",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth"
      ],
      "field": "groups",
      "integration_name": "Rippling"
   },
   {
      "type": "writable_field",
      "integration_type": "plusplus",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "PlusPlus"
   },
   {
      "type": "readable_field",
      "integration_type": "plusplus",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "PlusPlus"
   },
   {
      "type": "writable_field",
      "integration_type": "peakon",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "peakon",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "lucca",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Lucca"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "leapsome",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Leapsome"
   },
   {
      "type": "writable_field",
      "integration_type": "lattice",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Lattice"
   },
   {
      "type": "writable_field",
      "integration_type": "jumpcloud",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "jumpcloud",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "jobvite",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "JobDiva"
   },
   {
      "type": "writable_field",
      "integration_type": "ironclad",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "ironclad",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Ironclad"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humanforce",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Humanforce"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "heavenhr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "HeavenHR"
   },
   {
      "type": "readable_field",
      "integration_type": "haileyhr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "HaileyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "haileyhr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "HaileyHR"
   },
   {
      "type": "object",
      "object_type": "hris_location",
      "integration_type": "haileyhr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-31T15:00:03.000Z",
      "integration_name": "HaileyHR"
   },
   {
      "type": "method",
      "integration_type": "haileyhr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "HaileyHR"
   },
   {
      "type": "method",
      "integration_type": "haileyhr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "HaileyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Greenhouse"
   },
   {
      "type": "object",
      "object_type": "hris_location",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-31T15:00:03.000Z",
      "integration_name": "Greenhouse"
   },
   {
      "type": "method",
      "integration_type": "greenhouse",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_location",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "object",
      "object_type": "hris_location",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-31T15:00:03.000Z",
      "integration_name": "Freshteam"
   },
   {
      "type": "method",
      "integration_type": "freshteam",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Freshteam"
   },
   {
      "type": "object",
      "object_type": "hris_location",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-07-31T15:00:03.000Z",
      "integration_name": "FactorialHR"
   },
   {
      "type": "method",
      "integration_type": "factorialhr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Engagedly"
   },
   {
      "type": "writable_field",
      "integration_type": "enboarder",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "enboarder",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "elmo",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "ELMO"
   },
   {
      "type": "writable_field",
      "integration_type": "deel",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "groups",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "division",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "breathehr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "BreatheHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breathehr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "locations",
      "integration_name": "BreatheHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breathehr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "BreatheHR"
   },
   {
      "type": "object",
      "object_type": "hris_location",
      "integration_type": "breathehr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-31T15:00:03.000Z",
      "integration_name": "BreatheHR"
   },
   {
      "type": "method",
      "integration_type": "breathehr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_location",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BreatheHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "groups",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "locations",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "groups",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "object_type": "hris_location",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2024-07-31T15:00:03.000Z",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "ameego",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Ameego"
   },
   {
      "type": "writable_field",
      "integration_type": "alexis",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2024-07-31T15:00:03.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "groups",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "accounting_organization",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "organization_code",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "vendor_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "variants",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "public_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "public_description",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "is_taxable",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "vendor_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2024-07-29T21:53:40.000Z",
      "object_type": "commerce_item",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-26T13:16:01.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-26T13:16:01.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-26T13:16:01.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-26T13:16:01.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-07-25T20:37:32.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "parent_message_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-07-25T20:37:32.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "parent_message_id",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2024-07-25T17:49:14.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2024-07-25T17:49:14.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-07-25T17:49:14.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2024-07-24T19:07:26.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "created_at": "2024-07-24T19:07:26.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "ukgpro",
      "object_type": "hris_company",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-24T19:07:26.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-24T19:07:26.000Z",
      "object_type": "hris_company",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-07-24T19:07:26.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2024-07-23T09:41:28.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-07-22T17:27:07.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_updated_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-07-21T11:51:01.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "collection_ids",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2024-07-21T11:51:01.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "is_chargeable_now",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2024-07-16T17:56:05.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "public_job_urls",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2024-07-16T13:19:07.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "is_chargeable_now",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "project_id",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "priority",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "follower_user_ids",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "creator_user_id",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "completed_at",
      "integration_name": "Linear"
   },
   {
      "type": "writable_field",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "assigned_user_ids",
      "integration_name": "Linear"
   },
   {
      "type": "method",
      "integration_type": "linear",
      "created_at": "2024-07-13T20:56:27.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Linear"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-07-13T11:30:37.000Z",
      "object_type": "ats_job",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-07-13T11:30:37.000Z",
      "object_type": "ats_job",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2024-07-13T11:30:37.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BreezyHR"
   },
   {
      "type": "pagination",
      "integration_type": "breezyhr",
      "created_at": "2024-07-13T11:30:37.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-13T10:58:41.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-07-13T10:58:41.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_sort_by_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-07-13T10:58:41.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_query",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-07-13T10:58:41.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "method",
      "integration_type": "quickbooks",
      "created_at": "2024-07-13T10:58:41.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_application",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_application",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_job",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_application",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_job",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_job_id",
      "integration_name": "JobScore"
   },
   {
      "type": "pagination",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-07-12T20:01:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobscore",
      "object_type": "ats_document",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-07-12T20:01:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobscore",
      "object_type": "ats_activity",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-07-12T20:01:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobscore",
      "object_type": "hris_group",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-07-12T20:01:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobscore",
      "object_type": "ats_application",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-07-12T20:01:08.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobscore",
      "object_type": "passthrough",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobScore"
   },
   {
      "type": "method",
      "integration_type": "jobscore",
      "created_at": "2024-07-12T20:01:08.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "notion",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-12T15:16:58.000Z",
      "object_type": "kms_page",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "notion",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-12T15:16:58.000Z",
      "object_type": "kms_space",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "notion",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-12T15:16:58.000Z",
      "object_type": "kms_page",
      "integration_name": "Notion"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "notion",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-12T15:16:58.000Z",
      "object_type": "kms_space",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2024-07-12T15:16:58.000Z",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_page",
      "pagination": "list_order",
      "integration_name": "Notion"
   },
   {
      "type": "pagination",
      "integration_type": "notion",
      "created_at": "2024-07-12T15:16:58.000Z",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "object_type": "kms_space",
      "pagination": "list_order",
      "integration_name": "Notion"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2024-07-12T10:18:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2024-07-12T10:18:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2024-07-12T10:18:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2024-07-12T10:18:51.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2024-07-11T13:27:44.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "payment_methods",
      "integration_name": "GoCardless"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_candidate",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_application",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_job",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_candidate",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_application",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ukgpro",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_job",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "pagination",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T10:55:25.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "created_at": "2024-07-11T09:42:29.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro",
      "object_type": "ats_candidate",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "created_at": "2024-07-11T09:42:29.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro",
      "object_type": "ats_application",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "object",
      "created_at": "2024-07-11T09:42:29.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro",
      "object_type": "ats_job",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "method",
      "integration_type": "ukgpro",
      "created_at": "2024-07-11T09:42:29.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "priority",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "freshdesk"
   },
   {
      "type": "writable_field",
      "integration_type": "freshdesk",
      "created_at": "2024-07-10T19:17:04.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "customer_id",
      "integration_name": "freshdesk"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-07-05T15:26:50.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-07-05T15:26:50.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-07-05T15:26:50.000Z",
      "object_type": "accounting_transaction",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-07-05T15:26:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_sort_by_created_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-07-05T15:26:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_limit",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-07-05T15:26:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_transaction",
      "pagination": "list_offset",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "jobvite",
      "created_at": "2024-07-05T12:04:14.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Jobvite"
   },
   {
      "type": "object",
      "created_at": "2024-07-05T12:04:14.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "ats_application",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-07-05T12:04:14.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-07-05T12:04:14.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-07-05T12:04:14.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Jobvite"
   },
   {
      "type": "method",
      "integration_type": "jobvite",
      "created_at": "2024-07-05T12:04:14.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Jobvite"
   },
   {
      "type": "integration",
      "created_at": "2024-07-03T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "namely",
      "integration_name": "Namely"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-02T18:36:40.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-02T18:36:40.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "rejected_reason",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-02T18:36:40.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-02T18:36:40.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-02T18:36:40.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-02T18:36:40.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-02T18:36:40.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-02T18:36:40.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-07-02T18:36:40.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "ServiceNow"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "freshdesk",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "ticketing_ticket",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "freshdesk"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "cascade",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "task_task",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Cascade"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2024-07-02T16:35:08.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "atlassianjira",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "writable_field",
      "integration_type": "atlassianjira",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "writable_field",
      "integration_type": "atlassianjira",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Asana"
   },
   {
      "type": "writable_field",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Asana"
   },
   {
      "type": "readable_field",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Asana"
   },
   {
      "type": "method",
      "integration_type": "asana",
      "created_at": "2024-07-02T13:59:55.000Z",
      "object_type": "task_project",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-02T12:53:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-02T12:53:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2024-07-02T12:53:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "method",
      "integration_type": "microsoftteams",
      "created_at": "2024-07-02T12:53:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-02T12:53:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-07-02T12:53:48.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-07-02T12:53:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "method",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-07-02T12:53:48.000Z",
      "object_type": "hris_employee",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "humi",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Humi"
   },
   {
      "type": "readable_field",
      "integration_type": "humaans",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris"
      ],
      "field": "timezone",
      "integration_name": "Humaans"
   },
   {
      "type": "readable_field",
      "integration_type": "humaans",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris"
      ],
      "field": "language_locale",
      "integration_name": "Humaans"
   },
   {
      "type": "readable_field",
      "integration_type": "humaans",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris"
      ],
      "field": "company_id",
      "integration_name": "Humaans"
   },
   {
      "type": "readable_field",
      "integration_type": "humaans",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris"
      ],
      "field": "bio",
      "integration_name": "Humaans"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "heavenhr",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "HeavenHR"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "engagedly",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Engagedly"
   },
   {
      "type": "readable_field",
      "integration_type": "employmentheropayroll",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "employmenthero",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Employment Hero"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianjira",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "readable_field",
      "integration_type": "atlassianconfluence",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "AirCall.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2024-06-29T00:28:57.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "AirCall.io"
   },
   {
      "type": "integration",
      "created_at": "2024-06-29T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "canvas",
      "integration_name": "Canvas"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohopeople",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Zoho People"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "pronouns",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukgpro",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "readable_field",
      "integration_type": "ukg_hr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "slack",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Slack"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "ServiceNow"
   },
   {
      "type": "readable_field",
      "integration_type": "servicenow",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "ServiceNow"
   },
   {
      "type": "readable_field",
      "integration_type": "salesloft",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Salesloft"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paylocity",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Paylocity"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "netsuite",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "NetSuite"
   },
   {
      "type": "readable_field",
      "integration_type": "myob",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "MYOB"
   },
   {
      "type": "object",
      "created_at": "2024-06-28T23:42:09.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftsharepoint",
      "object_type": "hris_employee",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "object",
      "created_at": "2024-06-28T23:42:09.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftonedrive",
      "object_type": "hris_employee",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "linear",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Linear"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "leapsome",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Leapsome"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "employee_roles",
      "integration_name": "JobScore"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "intercom",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Intercom"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "gorgias",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "fourthhr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "FourthHR"
   },
   {
      "type": "readable_field",
      "integration_type": "foundu",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "foundU"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "ssn_sin",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "dayforce",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats"
      ],
      "field": "ssn_sin",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "clickup",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "ClickUp"
   },
   {
      "type": "readable_field",
      "integration_type": "circle",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Circle.so"
   },
   {
      "type": "readable_field",
      "integration_type": "circle",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Circle.so"
   },
   {
      "type": "readable_field",
      "integration_type": "checkr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Checkr"
   },
   {
      "type": "readable_field",
      "integration_type": "checkr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Checkr"
   },
   {
      "type": "readable_field",
      "integration_type": "cats",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "CATS"
   },
   {
      "type": "readable_field",
      "integration_type": "breathehr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "BreatheHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breathehr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "BreatheHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "ssn_sin",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "compensation",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ameego",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Ameego"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "readable_field",
      "integration_type": "adp",
      "created_at": "2024-06-28T23:42:09.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "created_at": "2024-06-28T23:18:04.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftteams",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "bio",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "pronouns",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "location",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "deputy",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "Deputy"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "salutation",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "15five",
      "created_at": "2024-06-28T23:18:04.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_roles",
      "integration_name": "15Five"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "subject",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "message_html",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "message",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "mentioned_members",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "hidden_members",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "destination_members",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "author_member",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "message_html",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemail",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "message_html",
      "integration_name": "Gmail"
   },
   {
      "type": "writable_field",
      "integration_type": "googlemail",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Gmail"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "message_html",
      "integration_name": "Gmail"
   },
   {
      "type": "readable_field",
      "integration_type": "googlemail",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "field": "attachments",
      "integration_name": "Gmail"
   },
   {
      "type": "writable_field",
      "integration_type": "discord",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "parent_message_id",
      "integration_name": "Discord"
   },
   {
      "type": "writable_field",
      "integration_type": "discord",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "message",
      "integration_name": "Discord"
   },
   {
      "type": "writable_field",
      "integration_type": "discord",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "channel_id",
      "integration_name": "Discord"
   },
   {
      "type": "method",
      "integration_type": "discord",
      "created_at": "2024-06-28T19:21:43.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2024-06-28T16:01:45.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "portal_url",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-06-27T14:26:29.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "stage",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-06-25T23:03:30.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "method",
      "integration_type": "atlassianjira",
      "created_at": "2024-06-23T23:38:49.000Z",
      "object_type": "task_task",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-06-23T21:07:21.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftoutlook",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-06-23T21:07:21.000Z",
      "object_type": "messaging_message",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-23T21:07:21.000Z",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_sort_by_name",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-23T21:07:21.000Z",
      "categories": [
         "auth",
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_sort_by_name",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-22T11:11:50.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_data",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-22T11:11:50.000Z",
      "object_type": "ats_document",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-22T11:11:50.000Z",
      "object_type": "ats_document",
      "integration_name": "Crelate"
   },
   {
      "type": "object",
      "created_at": "2024-06-22T11:11:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "crelate",
      "object_type": "ats_document",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2024-06-22T11:11:50.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2024-06-22T11:11:50.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2024-06-22T11:11:50.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Crelate"
   },
   {
      "type": "method",
      "integration_type": "crelate",
      "created_at": "2024-06-22T11:11:50.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2024-06-22T10:12:55.000Z",
      "object_type": "payment_payout",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "GoCardless"
   },
   {
      "type": "readable_field",
      "integration_type": "gocardless",
      "created_at": "2024-06-22T10:12:55.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-06-21T11:56:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "user_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-06-21T11:56:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "telephones",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-06-21T11:56:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "emails",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-06-21T11:56:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "company_ids",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-06-21T11:56:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "company",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-06-21T11:56:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "address",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-06-21T11:56:29.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "address",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "refunded_at",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "refund_reason",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "refund_amount",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "invoice_number",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "discount_amount",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "cancelled_at",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-06-20T17:27:38.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Loxo"
   },
   {
      "type": "writable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_job",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_job",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_job",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_company",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "loxo",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "applied_at",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_limit",
      "integration_name": "Loxo"
   },
   {
      "type": "pagination",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_offset",
      "integration_name": "Loxo"
   },
   {
      "type": "object",
      "created_at": "2024-06-20T16:47:39.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "loxo",
      "object_type": "ats_document",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Loxo"
   },
   {
      "type": "method",
      "integration_type": "loxo",
      "created_at": "2024-06-20T16:47:39.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Loxo"
   },
   {
      "type": "integration",
      "created_at": "2024-06-20T00:00:00.000Z",
      "categories": [
         "commerce",
         "passthrough"
      ],
      "integration_type": "akeneo",
      "integration_name": "Akeneo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-17T11:04:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "loxo",
      "created_at": "2024-06-17T11:04:25.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Loxo"
   },
   {
      "type": "integration",
      "created_at": "2024-06-17T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "ironclad",
      "integration_name": "Ironclad"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "location_id",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "item_variant_id",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "available",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "item_variant_id",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_item_variant_id",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-06-15T12:08:09.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-14T16:12:34.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "Close"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-14T16:12:34.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "Close"
   },
   {
      "type": "object",
      "created_at": "2024-06-14T16:12:34.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "closeio",
      "object_type": "crm_pipeline",
      "integration_name": "Close"
   },
   {
      "type": "method",
      "integration_type": "closeio",
      "created_at": "2024-06-14T16:12:34.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Close"
   },
   {
      "type": "object",
      "created_at": "2024-06-14T10:07:21.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zohorecruit",
      "object_type": "hris_employee",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "zohorecruit",
      "created_at": "2024-06-14T10:07:21.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2024-06-14T09:11:43.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_payout",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_payout",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_refund",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_refund",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "stripe",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Stripe"
   },
   {
      "type": "method",
      "integration_type": "slack",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Slack"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_location",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "shopify",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Shopify"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "kms_page",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "kms_page",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "kms_space",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "servicenow",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "kms_space",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "ServiceNow"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "accounting_taxrate",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "sageaccounting",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "jobdiva",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "hris_company",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "JobDiva"
   },
   {
      "type": "method",
      "integration_type": "holded",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_location",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Holded"
   },
   {
      "type": "method",
      "integration_type": "googlemail",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "messaging_message",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "method": "create",
      "integration_name": "Gmail"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_payout",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_payout",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_refund",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_refund",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "update",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "gocardless",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "GoCardless"
   },
   {
      "type": "method",
      "integration_type": "crezco",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "Crezco"
   },
   {
      "type": "method",
      "integration_type": "crezco",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Crezco"
   },
   {
      "type": "method",
      "integration_type": "crezco",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "payment_link",
      "categories": [
         "payment",
         "passthrough"
      ],
      "method": "remove",
      "integration_name": "Crezco"
   },
   {
      "type": "method",
      "integration_type": "boldcommerce",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "method": "get",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_inventory",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BigCommerce"
   },
   {
      "type": "method",
      "integration_type": "bigcommerce",
      "created_at": "2024-06-13T21:52:19.000Z",
      "object_type": "commerce_location",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "method": "list",
      "integration_name": "BigCommerce"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gem",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_job",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gem",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_job",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Gem"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2024-06-13T19:58:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Gem"
   },
   {
      "type": "object",
      "created_at": "2024-06-13T19:58:14.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "gem",
      "object_type": "ats_job",
      "integration_name": "Gem"
   },
   {
      "type": "object",
      "created_at": "2024-06-13T19:58:14.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "gem",
      "object_type": "ats_application",
      "integration_name": "Gem"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-06-13T14:04:51.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-06-13T14:04:51.000Z",
      "object_type": "accounting_transaction",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-06-13T14:04:51.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_order",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-06-13T14:04:51.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-06-13T14:04:51.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_transaction",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-06-13T14:04:51.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_transaction",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-06-13T14:04:51.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "integration",
      "created_at": "2024-06-13T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "paylocityrecruiting",
      "integration_name": "Paylocity Recruiting"
   },
   {
      "type": "object",
      "created_at": "2024-06-12T15:26:15.000Z",
      "categories": [
         "hris",
         "ats"
      ],
      "integration_type": "dayforce",
      "object_type": "ats_job",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "object",
      "created_at": "2024-06-12T15:26:15.000Z",
      "categories": [
         "hris",
         "ats"
      ],
      "integration_type": "dayforce",
      "object_type": "ats_candidate",
      "integration_name": "Ceridian Dayforce"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2024-06-12T15:09:43.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "JobDiva"
   },
   {
      "type": "object",
      "created_at": "2024-06-12T15:09:43.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobdiva",
      "object_type": "hris_company",
      "integration_name": "JobDiva"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-11T17:51:50.000Z",
      "object_type": "ats_document",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-11T17:51:50.000Z",
      "object_type": "ats_document",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "created_at": "2024-06-11T17:51:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "successfactors",
      "object_type": "ats_document",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "sign-in",
      "integration_type": "microsoftoutlook",
      "created_at": "2024-06-10T22:47:55.000Z",
      "integration_name": "Microsoft Outlook",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Zendesk"
   },
   {
      "type": "object",
      "created_at": "2024-06-10T16:01:22.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zendesk",
      "object_type": "messaging_channel",
      "integration_name": "Zendesk"
   },
   {
      "type": "object",
      "created_at": "2024-06-10T16:01:22.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zendesk",
      "object_type": "messaging_message",
      "integration_name": "Zendesk"
   },
   {
      "type": "object",
      "created_at": "2024-06-10T16:01:22.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zendesk",
      "object_type": "kms_page",
      "integration_name": "Zendesk"
   },
   {
      "type": "object",
      "created_at": "2024-06-10T16:01:22.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zendesk",
      "object_type": "kms_space",
      "integration_name": "Zendesk"
   },
   {
      "type": "object",
      "created_at": "2024-06-10T16:01:22.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zendesk",
      "object_type": "hris_group",
      "integration_name": "Zendesk"
   },
   {
      "type": "writable_field",
      "integration_type": "paradox",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Paradox"
   },
   {
      "type": "readable_field",
      "integration_type": "paradox",
      "created_at": "2024-06-10T16:01:22.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Paradox"
   },
   {
      "type": "integration",
      "created_at": "2024-06-10T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "clickup",
      "integration_name": "ClickUp"
   },
   {
      "type": "integration",
      "created_at": "2024-06-09T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "zohopeople",
      "integration_name": "Zoho People"
   },
   {
      "type": "integration",
      "created_at": "2024-06-09T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "cultureamp",
      "integration_name": "Culture Amp"
   },
   {
      "type": "integration",
      "created_at": "2024-06-09T00:00:00.000Z",
      "categories": [
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "cascade",
      "integration_name": "Cascade"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2024-06-08T21:38:09.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2024-06-08T21:38:09.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2024-06-08T21:38:09.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2024-06-08T21:38:09.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2024-06-08T21:38:09.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "messaging_message",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2024-06-08T21:38:09.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "kms_page",
      "integration_name": "Intercom"
   },
   {
      "type": "object",
      "created_at": "2024-06-08T21:38:09.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "kms",
         "messaging",
         "passthrough"
      ],
      "integration_type": "intercom",
      "object_type": "kms_space",
      "integration_name": "Intercom"
   },
   {
      "type": "integration",
      "created_at": "2024-06-08T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ukgpro",
      "integration_name": "UKG Pro HCM"
   },
   {
      "type": "integration",
      "created_at": "2024-06-08T00:00:00.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "servicenow",
      "integration_name": "ServiceNow"
   },
   {
      "type": "integration",
      "created_at": "2024-06-08T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "humanforce",
      "integration_name": "Humanforce"
   },
   {
      "type": "integration",
      "created_at": "2024-06-08T00:00:00.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "helpscout",
      "integration_name": "Helpscout"
   },
   {
      "type": "integration",
      "created_at": "2024-06-08T00:00:00.000Z",
      "categories": [
         "ticketing",
         "kms",
         "hris",
         "messaging",
         "passthrough"
      ],
      "integration_type": "freshdesk",
      "integration_name": "freshdesk"
   },
   {
      "type": "integration",
      "created_at": "2024-06-08T00:00:00.000Z",
      "categories": [
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "circle",
      "integration_name": "Circle.so"
   },
   {
      "type": "object",
      "created_at": "2024-06-07T16:14:26.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "ats_job",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "created_at": "2024-06-07T16:14:26.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "ats_candidate",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "created_at": "2024-06-07T16:14:26.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "adp",
      "object_type": "ats_application",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "object_type": "task_project",
      "integration_type": "linear",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-07T14:58:54.000Z",
      "integration_name": "Linear"
   },
   {
      "type": "object",
      "object_type": "task_task",
      "integration_type": "linear",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-07T14:58:54.000Z",
      "integration_name": "Linear"
   },
   {
      "type": "sign-in",
      "integration_type": "foundu",
      "created_at": "2024-06-07T14:58:54.000Z",
      "integration_name": "foundU",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "object",
      "object_type": "task_project",
      "integration_type": "atlassianjira",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2024-06-07T14:58:54.000Z",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "object",
      "object_type": "task_task",
      "integration_type": "atlassianjira",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2024-06-07T14:58:54.000Z",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "object",
      "object_type": "task_project",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2024-06-07T14:58:54.000Z",
      "integration_name": "Asana"
   },
   {
      "type": "object",
      "object_type": "task_task",
      "integration_type": "asana",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "created_at": "2024-06-07T14:58:54.000Z",
      "integration_name": "Asana"
   },
   {
      "type": "integration",
      "created_at": "2024-06-07T00:00:00.000Z",
      "categories": [
         "auth",
         "task",
         "hris",
         "passthrough"
      ],
      "integration_type": "linear",
      "integration_name": "Linear"
   },
   {
      "type": "integration",
      "created_at": "2024-06-07T00:00:00.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "atlassianjira",
      "integration_name": "Atlassian Jira"
   },
   {
      "type": "integration",
      "created_at": "2024-06-07T00:00:00.000Z",
      "categories": [
         "auth",
         "hris",
         "task",
         "passthrough"
      ],
      "integration_type": "asana",
      "integration_name": "Asana"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-06T22:20:09.000Z",
      "object_type": "ats_activity",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-06T22:20:09.000Z",
      "object_type": "ats_activity",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-06-06T22:20:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-06-06T22:20:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_sort_by_created_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "created_at": "2024-06-06T22:20:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "successfactors",
      "object_type": "ats_activity",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "created_at": "2024-06-06T22:20:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "ats_candidate",
      "integration_name": "Jobvite"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "created_at": "2024-06-06T21:55:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "zohocrm",
      "object_type": "hris_employee",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "pipeline_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "insightly",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "Insightly"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_pipeline",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "stages",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "holded",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "Holded"
   },
   {
      "type": "readable_field",
      "integration_type": "highlevel",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "Attio"
   },
   {
      "type": "object",
      "created_at": "2024-06-06T21:55:50.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "attio",
      "object_type": "hris_employee",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2024-06-06T21:55:50.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "pipeline_id",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-06-06T21:55:50.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-06-06T21:55:50.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-06-06T21:55:50.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-06-06T21:55:50.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_query",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-06-06T21:55:50.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "object",
      "created_at": "2024-06-06T21:55:50.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "activecampaign",
      "object_type": "crm_pipeline",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-06T12:49:19.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-06-06T12:49:19.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-06-06T12:49:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_query",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-06-06T12:49:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_updated_gte",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-06-06T12:49:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-06-06T12:49:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-06-06T12:49:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_sort_by_name",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-06-06T12:49:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-06-06T12:49:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_sort_by_created_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "created_at": "2024-06-06T12:49:19.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "successfactors",
      "object_type": "passthrough",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-06-06T10:45:23.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "document_url",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-06-06T10:45:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-06-06T10:45:23.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-06-06T10:45:23.000Z",
      "object_type": "ats_document",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "document_url",
      "integration_name": "BambooHR"
   },
   {
      "type": "integration",
      "created_at": "2024-06-06T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "cohere",
      "integration_name": "Cohere"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-06-04T14:20:12.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-06-04T14:20:12.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-06-04T14:20:12.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "closed_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-06-04T14:20:12.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "slack",
      "created_at": "2024-06-03T23:27:58.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_message",
      "pagination": "list_channel_id",
      "integration_name": "Slack"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-06-03T23:27:58.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_item_id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-06-03T23:27:58.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_item_variant_id",
      "integration_name": "BigCommerce"
   },
   {
      "type": "object",
      "created_at": "2024-06-03T15:30:03.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "loxo",
      "object_type": "hris_employee",
      "integration_name": "Loxo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-06-03T15:30:03.000Z",
      "object_type": "hris_employee",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-06-03T15:30:03.000Z",
      "object_type": "hris_employee",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-06-03T15:30:03.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "jobscore",
      "object_type": "hris_employee",
      "integration_name": "JobScore"
   },
   {
      "type": "object",
      "created_at": "2024-06-03T14:35:54.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "jobvite",
      "object_type": "hris_employee",
      "integration_name": "Jobvite"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2024-06-03T14:35:54.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Discord"
   },
   {
      "type": "pagination",
      "integration_type": "discord",
      "created_at": "2024-06-03T14:35:54.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Discord"
   },
   {
      "type": "pagination",
      "integration_type": "discord",
      "created_at": "2024-06-03T14:35:54.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Discord"
   },
   {
      "type": "pagination",
      "integration_type": "discord",
      "created_at": "2024-06-03T14:35:54.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_limit",
      "integration_name": "Discord"
   },
   {
      "type": "pagination",
      "integration_type": "discord",
      "created_at": "2024-06-03T14:35:54.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_offset",
      "integration_name": "Discord"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-05-31T16:17:47.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-05-31T16:17:47.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-05-31T16:17:47.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-05-31T16:17:47.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "compensation",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2024-05-29T18:00:21.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "parent_message_id",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2024-05-29T18:00:21.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "message",
      "integration_name": "Slack"
   },
   {
      "type": "writable_field",
      "integration_type": "slack",
      "created_at": "2024-05-29T18:00:21.000Z",
      "object_type": "messaging_message",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "channel_id",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "created_at": "2024-05-28T21:25:25.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohocrm",
      "object_type": "crm_pipeline",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2024-05-28T21:25:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "pipeline",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-05-28T21:25:25.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-05-28T21:25:25.000Z",
      "object_type": "crm_pipeline",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-05-28T21:25:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "pipeline",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2024-05-28T21:25:25.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "crm_pipeline",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-05-28T21:25:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "pipeline",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2024-05-28T21:25:25.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "hubspot",
      "object_type": "crm_pipeline",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "attio",
      "created_at": "2024-05-28T21:25:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "pipeline",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "attio",
      "created_at": "2024-05-28T21:25:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "pipeline",
      "integration_name": "Attio"
   },
   {
      "type": "object",
      "created_at": "2024-05-28T21:25:25.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "attio",
      "object_type": "crm_pipeline",
      "integration_name": "Attio"
   },
   {
      "type": "readable_field",
      "integration_type": "affinity",
      "created_at": "2024-05-28T21:25:25.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "passthrough"
      ],
      "field": "pipeline",
      "integration_name": "Affinity"
   },
   {
      "type": "object",
      "created_at": "2024-05-28T21:25:25.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "affinity",
      "object_type": "crm_pipeline",
      "integration_name": "Affinity"
   },
   {
      "type": "object",
      "object_type": "kms_space",
      "integration_type": "notion",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-28T20:07:52.000Z",
      "integration_name": "Notion"
   },
   {
      "type": "object",
      "object_type": "kms_page",
      "integration_type": "notion",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-28T20:07:52.000Z",
      "integration_name": "Notion"
   },
   {
      "type": "object",
      "object_type": "kms_space",
      "integration_type": "guru",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-28T20:07:52.000Z",
      "integration_name": "Guru"
   },
   {
      "type": "object",
      "object_type": "kms_page",
      "integration_type": "guru",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-28T20:07:52.000Z",
      "integration_name": "Guru"
   },
   {
      "type": "object",
      "object_type": "kms_space",
      "integration_type": "coda",
      "categories": [
         "kms",
         "passthrough"
      ],
      "created_at": "2024-05-28T20:07:52.000Z",
      "integration_name": "Coda"
   },
   {
      "type": "object",
      "object_type": "kms_page",
      "integration_type": "coda",
      "categories": [
         "kms",
         "passthrough"
      ],
      "created_at": "2024-05-28T20:07:52.000Z",
      "integration_name": "Coda"
   },
   {
      "type": "object",
      "object_type": "kms_space",
      "integration_type": "atlassianconfluence",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-28T20:07:52.000Z",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "object",
      "object_type": "kms_page",
      "integration_type": "atlassianconfluence",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-28T20:07:52.000Z",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "sign-in",
      "integration_type": "microsoftteams",
      "created_at": "2024-05-28T13:03:43.000Z",
      "integration_name": "Microsoft Teams",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftteams",
      "created_at": "2024-05-28T12:28:59.000Z",
      "object_type": "messaging_channel",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "field": "parent_channel_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2024-05-28T12:28:59.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_limit",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2024-05-28T12:28:59.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_offset",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2024-05-28T12:28:59.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_order",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2024-05-28T12:28:59.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_parent_id",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2024-05-28T12:28:59.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftteams",
      "created_at": "2024-05-28T12:28:59.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "object_type": "messaging_channel",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "integration",
      "created_at": "2024-05-28T00:00:00.000Z",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "notion",
      "integration_name": "Notion"
   },
   {
      "type": "integration",
      "created_at": "2024-05-28T00:00:00.000Z",
      "categories": [
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "guru",
      "integration_name": "Guru"
   },
   {
      "type": "integration",
      "created_at": "2024-05-28T00:00:00.000Z",
      "categories": [
         "kms",
         "passthrough"
      ],
      "integration_type": "coda",
      "integration_name": "Coda"
   },
   {
      "type": "integration",
      "created_at": "2024-05-28T00:00:00.000Z",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "integration_type": "atlassianconfluence",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-05-24T15:35:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-05-24T15:35:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-05-24T15:35:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-05-24T15:35:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-05-24T15:35:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-05-24T15:35:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-05-24T15:35:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-05-24T15:35:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-05-24T15:35:59.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-05-24T14:25:00.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-05-24T14:25:00.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-05-24T14:25:00.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "identification",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-05-24T14:25:00.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-05-24T14:25:00.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "integration",
      "created_at": "2024-05-24T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "foundu",
      "integration_name": "foundU"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "googledrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-05-23T22:08:14.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Drive"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2024-05-23T12:42:37.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "public_job_urls",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "integration_type": "workday",
      "object_type": "ats_document",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "paid_at",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "jobdiva",
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "JobDiva"
   },
   {
      "type": "readable_field",
      "integration_type": "discord",
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Discord"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_activity",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_application",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_company",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_job",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_interview",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_lead",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "hris_employee",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "hris_group",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_company",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_contact",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_deal",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_event",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_activity",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_application",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_company",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_job",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_interview",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_lead",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "hris_employee",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "hris_group",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_company",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_contact",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_deal",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "crm_event",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "object_type": "ats_document",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_url",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-05-22T20:02:51.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "object_type": "kms_space",
      "integration_type": "atlassianconfluence",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T17:28:35.000Z",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "object",
      "object_type": "kms_page",
      "integration_type": "atlassianconfluence",
      "categories": [
         "auth",
         "kms",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T17:28:35.000Z",
      "integration_name": "Atlassian Confluence"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "object_type": "messaging_message",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "object_type": "messaging_message",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "object_type": "messaging_message",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "object_type": "messaging_message",
      "integration_name": "Slack"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "object_type": "messaging_message",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "object_type": "messaging_message",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "object_type": "messaging_channel",
      "integration_type": "slack",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "created_at": "2024-05-21T14:02:17.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "slack",
      "object_type": "hris_employee",
      "integration_name": "Slack"
   },
   {
      "type": "object",
      "object_type": "messaging_message",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "messaging_channel",
      "integration_type": "microsoftteams",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "object",
      "object_type": "messaging_message",
      "integration_type": "microsoftoutlook",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "object",
      "object_type": "messaging_channel",
      "integration_type": "microsoftoutlook",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "object",
      "object_type": "messaging_message",
      "integration_type": "googlemail",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Gmail"
   },
   {
      "type": "object",
      "object_type": "messaging_channel",
      "integration_type": "googlemail",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Gmail"
   },
   {
      "type": "object",
      "object_type": "messaging_message",
      "integration_type": "discord",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Discord"
   },
   {
      "type": "object",
      "object_type": "messaging_channel",
      "integration_type": "discord",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-21T14:02:17.000Z",
      "integration_name": "Discord"
   },
   {
      "type": "object",
      "created_at": "2024-05-21T14:02:17.000Z",
      "categories": [
         "auth",
         "messaging",
         "hris",
         "passthrough"
      ],
      "integration_type": "discord",
      "object_type": "hris_employee",
      "integration_name": "Discord"
   },
   {
      "type": "integration",
      "created_at": "2024-05-21T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "sageaccounting",
      "integration_name": "Sage Accounting"
   },
   {
      "type": "integration",
      "created_at": "2024-05-21T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "microsoftteams",
      "integration_name": "Microsoft Teams"
   },
   {
      "type": "integration",
      "created_at": "2024-05-21T00:00:00.000Z",
      "categories": [
         "messaging",
         "passthrough"
      ],
      "integration_type": "microsoftoutlook",
      "integration_name": "Microsoft Outlook"
   },
   {
      "type": "integration",
      "created_at": "2024-05-21T00:00:00.000Z",
      "categories": [
         "messaging",
         "auth",
         "passthrough"
      ],
      "integration_type": "googlemail",
      "integration_name": "Gmail"
   },
   {
      "type": "integration",
      "created_at": "2024-05-21T00:00:00.000Z",
      "categories": [
         "payment",
         "passthrough"
      ],
      "integration_type": "crezco",
      "integration_name": "Crezco"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-05-17T21:02:10.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-05-17T15:24:14.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "parent_account_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-05-17T15:24:14.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "parent_account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-17T15:24:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-17T15:24:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Greenhouse"
   },
   {
      "type": "object",
      "created_at": "2024-05-17T15:24:14.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "greenhouse",
      "object_type": "hris_employee",
      "integration_name": "Greenhouse"
   },
   {
      "type": "integration",
      "created_at": "2024-05-17T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "uber",
      "integration_name": "Uber"
   },
   {
      "type": "integration",
      "created_at": "2024-05-17T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "twitch",
      "integration_name": "Twitch"
   },
   {
      "type": "integration",
      "created_at": "2024-05-17T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "etsy",
      "integration_name": "Etsy"
   },
   {
      "type": "integration",
      "created_at": "2024-05-17T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "autodesk",
      "integration_name": "Autodesk"
   },
   {
      "type": "integration",
      "created_at": "2024-05-17T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "amazon",
      "integration_name": "Amazon"
   },
   {
      "type": "integration",
      "created_at": "2024-05-17T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "adobe",
      "integration_name": "Adobe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-05-16T08:38:32.000Z",
      "object_type": "hris_group",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-05-16T08:38:32.000Z",
      "object_type": "hris_group",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "created_at": "2024-05-16T08:38:32.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "integration_type": "quickbooks",
      "object_type": "hris_group",
      "integration_name": "QuickBooks"
   },
   {
      "type": "integration",
      "created_at": "2024-05-16T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "jobdiva",
      "integration_name": "JobDiva"
   },
   {
      "type": "integration",
      "created_at": "2024-05-16T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "fourthhr",
      "integration_name": "FourthHR"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_user_id",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "payment_link",
      "pagination": "list_updated_gte",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "stripe",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_collection_id",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_query",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_location_id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_item_id",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "outreach",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_name",
      "integration_name": "Outreach.io"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_query",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_limit",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "netsuite",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_offset",
      "integration_name": "NetSuite"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_updated_gte",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "manatal",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Manatal"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_limit",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_offset",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "instantlyai",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_limit",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "pagination",
      "integration_type": "instantlyai",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_offset",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_offset",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_offset",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_offset",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_pipeline",
      "pagination": "list_offset",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_limit",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "insightly",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_offset",
      "integration_name": "Insightly"
   },
   {
      "type": "pagination",
      "integration_type": "heavenhr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "HeavenHR"
   },
   {
      "type": "pagination",
      "integration_type": "heavenhr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "HeavenHR"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_limit",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_applicationstatus",
      "pagination": "list_offset",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_user_id",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "elmo",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_query",
      "integration_name": "ELMO"
   },
   {
      "type": "pagination",
      "integration_type": "elmo",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_limit",
      "integration_name": "ELMO"
   },
   {
      "type": "pagination",
      "integration_type": "elmo",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "ELMO"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_sort_by_name",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_updated_gte",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_limit",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_offset",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_company",
      "pagination": "list_sort_by_name",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_user_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "closeio",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "Close"
   },
   {
      "type": "object",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "closeio",
      "object_type": "passthrough",
      "integration_name": "Close"
   },
   {
      "type": "pagination",
      "integration_type": "checkr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Checkr"
   },
   {
      "type": "pagination",
      "integration_type": "checkr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Checkr"
   },
   {
      "type": "pagination",
      "integration_type": "checkr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Checkr"
   },
   {
      "type": "pagination",
      "integration_type": "checkr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Checkr"
   },
   {
      "type": "pagination",
      "integration_type": "checkr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Checkr"
   },
   {
      "type": "pagination",
      "integration_type": "checkr",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Checkr"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_sort_by_name",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_name",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_limit",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_offset",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_sort_by_name",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_name",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_sort_by_name",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_collection_id",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_order",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_query",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_limit",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_offset",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_order",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_sort_by_name",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_inventory",
      "pagination": "list_order",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_location",
      "pagination": "list_order",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_updated_gte",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "bigcommerce",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_order",
      "integration_name": "BigCommerce"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2024-05-15T23:28:09.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_application_id",
      "integration_name": "Ashby"
   },
   {
      "type": "object",
      "created_at": "2024-05-15T15:14:32.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "elmo",
      "object_type": "hris_timeoff",
      "integration_name": "ELMO"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T15:14:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T15:14:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T15:14:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_name",
      "integration_name": "Crelate"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-05-15T15:14:32.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-14T09:47:12.000Z",
      "object_type": "ats_job",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-05-14T09:47:12.000Z",
      "object_type": "ats_job",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2024-05-14T09:47:12.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2024-05-14T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "employmentheropayroll",
      "integration_name": "Employment Hero Payroll"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-05-10T13:33:09.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-05-10T13:33:09.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "shopify",
      "created_at": "2024-05-10T09:17:53.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "media",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2024-05-10T09:17:53.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "employment_status",
      "integration_name": "Close"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "box",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-05-03T21:13:16.000Z",
      "object_type": "storage_file",
      "integration_name": "Box"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "box",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-05-03T21:13:16.000Z",
      "object_type": "storage_file",
      "integration_name": "Box"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "box",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-05-03T21:13:16.000Z",
      "object_type": "storage_file",
      "integration_name": "Box"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2024-05-02T16:12:38.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Workable"
   },
   {
      "type": "object",
      "object_type": "genai_prompt",
      "integration_type": "openai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "object_type": "genai_model",
      "integration_type": "openai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "OpenAI"
   },
   {
      "type": "object",
      "object_type": "genai_prompt",
      "integration_type": "mistralai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "MistralAI"
   },
   {
      "type": "object",
      "object_type": "genai_model",
      "integration_type": "mistralai",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "MistralAI"
   },
   {
      "type": "object",
      "object_type": "genai_prompt",
      "integration_type": "groq",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "Groq"
   },
   {
      "type": "object",
      "object_type": "genai_model",
      "integration_type": "groq",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "Groq"
   },
   {
      "type": "object",
      "object_type": "genai_prompt",
      "integration_type": "googlegemini",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "Google Gemini"
   },
   {
      "type": "object",
      "object_type": "genai_model",
      "integration_type": "googlegemini",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "Google Gemini"
   },
   {
      "type": "object",
      "object_type": "genai_prompt",
      "integration_type": "anyscale",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "AnyScale"
   },
   {
      "type": "object",
      "object_type": "genai_model",
      "integration_type": "anyscale",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "AnyScale"
   },
   {
      "type": "object",
      "object_type": "genai_prompt",
      "integration_type": "anthropicclaude",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "object",
      "object_type": "genai_model",
      "integration_type": "anthropicclaude",
      "categories": [
         "genai",
         "passthrough"
      ],
      "created_at": "2024-05-02T16:12:38.000Z",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-05-02T11:16:05.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-05-02T11:16:05.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Greenhouse"
   },
   {
      "type": "integration",
      "created_at": "2024-05-02T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "openai",
      "integration_name": "OpenAI"
   },
   {
      "type": "integration",
      "created_at": "2024-05-02T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "mistralai",
      "integration_name": "MistralAI"
   },
   {
      "type": "integration",
      "created_at": "2024-05-02T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "groq",
      "integration_name": "Groq"
   },
   {
      "type": "integration",
      "created_at": "2024-05-02T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "googlegemini",
      "integration_name": "Google Gemini"
   },
   {
      "type": "integration",
      "created_at": "2024-05-02T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "anyscale",
      "integration_name": "AnyScale"
   },
   {
      "type": "integration",
      "created_at": "2024-05-01T00:00:00.000Z",
      "categories": [
         "hris",
         "accounting",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "wave",
      "integration_name": "Wave"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-04-30T13:51:42.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2024-04-28T21:32:01.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "questions",
      "integration_name": "Workday"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-04-28T21:32:01.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-04-28T21:32:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-04-28T21:32:01.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Greenhouse"
   },
   {
      "type": "object",
      "created_at": "2024-04-28T21:32:01.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "bullhorn",
      "object_type": "ats_document",
      "integration_name": "Bullhorn"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2024-04-28T21:32:01.000Z",
      "object_type": "ats_candidate",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2024-04-28T21:32:01.000Z",
      "object_type": "ats_application",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2024-04-28T21:32:01.000Z",
      "object_type": "ats_candidate",
      "integration_name": "BambooHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2024-04-28T21:32:01.000Z",
      "object_type": "ats_application",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-04-28T21:32:01.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-04-28T21:32:01.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-04-28T21:32:01.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-04-28T21:32:01.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_application",
      "pagination": "list_limit",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-04-28T21:32:01.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2024-04-28T21:32:01.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "integration_type": "bamboohr",
      "object_type": "ats_candidate",
      "integration_name": "BambooHR"
   },
   {
      "type": "writable_field",
      "integration_type": "workable",
      "created_at": "2024-04-26T13:25:34.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-04-26T13:25:34.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-04-26T13:25:34.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-04-26T13:25:34.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-04-26T13:25:34.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-04-26T13:25:34.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-04-26T13:25:34.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-04-26T13:25:34.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Workable"
   },
   {
      "type": "object",
      "created_at": "2024-04-26T13:25:34.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workable",
      "object_type": "ats_activity",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T12:16:45.000Z",
      "object_type": "crm_company",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T12:16:45.000Z",
      "object_type": "crm_contact",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T12:16:45.000Z",
      "object_type": "crm_company",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T12:16:45.000Z",
      "object_type": "crm_contact",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "crm_contact",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "ats_company",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "ats_job",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "ats_application",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "ats_interview",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2024-04-25T09:51:19.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "crm_company",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2024-04-25T09:51:19.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "crm_contact",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "HiBob"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2024-04-25T09:51:19.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "HiBob"
   },
   {
      "type": "integration",
      "created_at": "2024-04-25T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "applicantstack",
      "integration_name": "Applicant Stack"
   },
   {
      "type": "integration",
      "created_at": "2024-04-24T00:00:00.000Z",
      "categories": [
         "accounting",
         "hris",
         "commerce",
         "auth",
         "passthrough"
      ],
      "integration_type": "paypal",
      "integration_name": "Paypal"
   },
   {
      "type": "integration",
      "created_at": "2024-04-24T00:00:00.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "integration_type": "instantlyai",
      "integration_name": "Instantly.ai"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-23T22:53:17.000Z",
      "object_type": "ats_application",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-23T22:53:17.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-23T22:53:17.000Z",
      "object_type": "ats_job",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-23T22:53:17.000Z",
      "object_type": "ats_application",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-23T22:53:17.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-23T22:53:17.000Z",
      "object_type": "ats_job",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-04-23T22:53:17.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-04-23T22:53:17.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-04-23T22:53:17.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Workable"
   },
   {
      "type": "integration",
      "created_at": "2024-04-23T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "insightly",
      "integration_name": "Insightly"
   },
   {
      "type": "integration",
      "created_at": "2024-04-20T00:00:00.000Z",
      "categories": [
         "genai",
         "passthrough"
      ],
      "integration_type": "anthropicclaude",
      "integration_name": "Anthropic Claude"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "commerce_item",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_account",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "commerce_item",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_organization",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_account",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_account",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_query",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_name",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_taxrate",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_order",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "xero",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_interview_id",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "tribepad",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_order",
      "integration_name": "Tribepad"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_application_id",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_order",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_sort_by_created_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_sort_by_name",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_application_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_candidate_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_job_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_application_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_application_id",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "slintel",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "Slintel"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_collection",
      "pagination": "list_type",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendfox",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "SendFox"
   },
   {
      "type": "pagination",
      "integration_type": "salesloft",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_type",
      "integration_name": "Salesloft"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_type",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_contact_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_contact_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_deal_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_company_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_deal_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "rocketreach",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "RocketReach"
   },
   {
      "type": "pagination",
      "integration_type": "rippling",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_user_id",
      "integration_name": "Rippling"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_candidate_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_limit",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "pagination",
      "integration_type": "recruiterflow",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_offset",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_organization",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "accounting_organization",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_query",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_order",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_sort_by_created_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_sort_by_name",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_query",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_organization",
      "pagination": "list_updated_gte",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "payment_payment",
      "pagination": "list_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_contact",
      "pagination": "list_type",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "quickbooks",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "object_type": "accounting_invoice",
      "pagination": "list_contact_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "plum",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Plum"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "plum",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_order",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "plum",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Plum"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_order",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_order",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_created_at",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_name",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "okta",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Okta"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_query",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "mailchimp",
      "categories": [
         "martech",
         "auth"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "martech_list",
      "integration_name": "Mailchimp"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "mailchimp",
      "categories": [
         "martech",
         "auth"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "martech_list",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_list",
      "pagination": "list_limit",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_list",
      "pagination": "list_offset",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_list",
      "pagination": "list_order",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_list",
      "pagination": "list_sort_by_name",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_application_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_application_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_query",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_query",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "leadsift",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "LeadSift"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "Klaviyo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "ats_interview",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "ats_interview",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_updated_gte",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jobadder",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_application_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "jazzhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "JazzHR"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_customer_id",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "intercom",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_customer_id",
      "integration_name": "Intercom"
   },
   {
      "type": "pagination",
      "integration_type": "humi",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_offset",
      "integration_name": "Humi"
   },
   {
      "type": "pagination",
      "integration_type": "humi",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_user_id",
      "integration_name": "Humi"
   },
   {
      "type": "pagination",
      "integration_type": "humi",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Humi"
   },
   {
      "type": "pagination",
      "integration_type": "humantic",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "Humantic.ai"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_contact_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_parent_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_type",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "heavenhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "HeavenHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_application_id",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "greenhouse",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_updated_gte",
      "integration_name": "Greenhouse"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "list_offset",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_offset",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_offset",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "googledirectory",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "pagination",
      "integration_type": "getprospect",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "GetProspect"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_candidate_id",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_application_id",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "gem",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_updated_gte",
      "integration_name": "Gem"
   },
   {
      "type": "pagination",
      "integration_type": "freshteam",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Freshteam"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_limit",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "dropcontact",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "DropContact"
   },
   {
      "type": "pagination",
      "integration_type": "datagma",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "Datagma"
   },
   {
      "type": "pagination",
      "integration_type": "crystalknows",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "CrystalKnows"
   },
   {
      "type": "pagination",
      "integration_type": "crelate",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "hris_group",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "hris_group",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-18T19:40:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "cornerstone",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Cornerstone"
   },
   {
      "type": "pagination",
      "integration_type": "contactout",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "ContactOut"
   },
   {
      "type": "pagination",
      "integration_type": "clearbit",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_company",
      "pagination": "search_domain",
      "integration_name": "Clearbit"
   },
   {
      "type": "pagination",
      "integration_type": "clearbit",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "search_email",
      "integration_name": "Clearbit"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_job_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "box",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_query",
      "integration_name": "Box"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "hris_timeoff",
      "pagination": "list_user_id",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "apollo",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedinurl",
      "integration_name": "Apollo.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_created_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_created_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_name",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_order",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_order",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-04-18T19:40:50.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-17T21:35:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-04-17T21:35:31.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_activity",
      "pagination": "list_candidate_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bamboohr",
      "created_at": "2024-04-17T21:35:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "field": "status",
      "integration_name": "BambooHR"
   },
   {
      "type": "pagination",
      "integration_type": "bamboohr",
      "created_at": "2024-04-17T21:35:31.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2024-04-17T21:35:31.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "integration_type": "bamboohr",
      "object_type": "ats_document",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2024-04-17T13:00:29.000Z",
      "object_type": "ats_document",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "document_url",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-16T12:33:41.000Z",
      "object_type": "hris_employee",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-16T12:33:41.000Z",
      "object_type": "hris_employee",
      "integration_name": "Crelate"
   },
   {
      "type": "object",
      "created_at": "2024-04-16T12:33:41.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "crelate",
      "object_type": "hris_employee",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-04-16T11:37:50.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-04-16T11:37:50.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "balance_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "created_at": "2024-04-16T11:37:50.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_account",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2024-04-16T11:37:50.000Z",
      "categories": [
         "crm",
         "hris",
         "accounting",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "object_type": "accounting_invoice",
      "integration_name": "NetSuite"
   },
   {
      "type": "object",
      "created_at": "2024-04-16T11:37:50.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "integration_type": "holded",
      "object_type": "accounting_invoice",
      "integration_name": "Holded"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-16T09:36:31.000Z",
      "object_type": "ats_activity",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-16T09:36:31.000Z",
      "object_type": "ats_activity",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "created_at": "2024-04-16T09:36:31.000Z",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "jobadder",
      "object_type": "ats_activity",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2024-04-15T16:29:24.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2024-04-15T16:29:24.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-04-15T16:29:24.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "created_at": "2024-04-12T15:41:13.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "integration_type": "holded",
      "object_type": "accounting_journal",
      "integration_name": "Holded"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth"
      ],
      "field": "external_identifier",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth"
      ],
      "field": "external_identifier",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "readable_field",
      "integration_type": "gem",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Cornerstone"
   },
   {
      "type": "writable_field",
      "integration_type": "checkr",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Checkr"
   },
   {
      "type": "readable_field",
      "integration_type": "checkr",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Checkr"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-12T15:41:13.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2024-04-12T15:41:13.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "affinity",
      "object_type": "crm_event",
      "integration_name": "Affinity"
   },
   {
      "type": "integration",
      "created_at": "2024-04-12T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "haileyhr",
      "integration_name": "HaileyHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "crm_lead",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "crm_company",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "crm_contact",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "crm_deal",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "crm_lead",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "crm_company",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "crm_contact",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohocrm",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "crm_deal",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "commerce_collection",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Shopify"
   },
   {
      "type": "pagination",
      "integration_type": "shopify",
      "created_at": "2024-04-11T13:47:26.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_collection_id",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "hris_employee",
      "integration_name": "Freshteam"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "freshteam",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-11T13:47:26.000Z",
      "object_type": "hris_employee",
      "integration_name": "Freshteam"
   },
   {
      "type": "pagination",
      "integration_type": "boldcommerce",
      "created_at": "2024-04-11T13:47:26.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "object_type": "commerce_item",
      "pagination": "list_collection_id",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "object",
      "created_at": "2024-04-11T13:47:26.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "boldcommerce",
      "object_type": "commerce_collection",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "pagination",
      "integration_type": "paycor",
      "created_at": "2024-04-10T09:03:50.000Z",
      "categories": [
         "hris"
      ],
      "object_type": "hris_payslip",
      "pagination": "list_user_id",
      "integration_name": "Paycor"
   },
   {
      "type": "integration",
      "created_at": "2024-04-07T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "bigcommerce",
      "integration_name": "BigCommerce"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "terminated_at",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "gender",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "workday",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "Workday"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "rippling",
      "categories": [
         "hris",
         "auth"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "created_at": "2024-04-03T15:35:47.000Z",
      "categories": [
         "hris",
         "auth"
      ],
      "integration_type": "rippling",
      "object_type": "hris_group",
      "integration_name": "Rippling"
   },
   {
      "type": "object",
      "object_type": "hris_payslip",
      "integration_type": "paylocity",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "Paylocity"
   },
   {
      "type": "object",
      "object_type": "hris_payslip",
      "integration_type": "paycor",
      "categories": [
         "hris"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "Paycor"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "humi",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "Humi"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "HiBob"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "HiBob"
   },
   {
      "type": "writable_field",
      "integration_type": "hibob",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "HiBob"
   },
   {
      "type": "readable_field",
      "integration_type": "hibob",
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "hibob",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "created_at": "2024-04-03T15:35:47.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "hibob",
      "object_type": "passthrough",
      "integration_name": "HiBob"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "heavenhr",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "HeavenHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "FactorialHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "object_type": "hris_timeoff",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "factorialhr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "employmenthero",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "Employment Hero"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough",
         "auth"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "adp",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "object",
      "object_type": "hris_timeoff",
      "integration_type": "15five",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-03T15:35:47.000Z",
      "integration_name": "15Five"
   },
   {
      "type": "sign-in",
      "integration_type": "bamboohr",
      "created_at": "2024-04-03T09:06:40.000Z",
      "integration_name": "BambooHR",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "integration",
      "created_at": "2024-04-03T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "heavenhr",
      "integration_name": "HeavenHR"
   },
   {
      "type": "pagination",
      "integration_type": "zoominfo",
      "created_at": "2024-04-01T19:39:55.000Z",
      "categories": [
         "enrich"
      ],
      "object_type": "enrich_person",
      "pagination": "search_name",
      "integration_name": "ZoomInfo"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "paid_amount",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "invoice_id",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_payment",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "paid_amount",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "myob",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "hris_employee",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "myob",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "hris_employee",
      "integration_name": "MYOB"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "hris_employee",
      "integration_name": "iCIMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "hris_employee",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "iCIMS"
   },
   {
      "type": "object",
      "created_at": "2024-04-01T19:39:55.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "icims",
      "object_type": "hris_employee",
      "integration_name": "iCIMS"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "GoCardless"
   },
   {
      "type": "writable_field",
      "integration_type": "gocardless",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "payment_link",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "field": "amount",
      "integration_name": "GoCardless"
   },
   {
      "type": "pagination",
      "integration_type": "dropbox",
      "created_at": "2024-04-01T19:39:55.000Z",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_offset",
      "integration_name": "Dropbox"
   },
   {
      "type": "readable_field",
      "integration_type": "crystalknows",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich"
      ],
      "field": "emails",
      "integration_name": "CrystalKnows"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "ats_interview",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "ats_interview",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "is_active",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "ats_application",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_candidate_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "pagination",
      "integration_type": "bullhorn",
      "created_at": "2024-04-01T19:39:55.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "won_reason",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "external_identifier",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "division",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "department",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-03-22T15:40:06.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2024-03-22T15:40:06.000Z",
      "categories": [
         "crm",
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "bullhorn",
      "object_type": "passthrough",
      "integration_name": "Bullhorn"
   },
   {
      "type": "integration",
      "created_at": "2024-03-22T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ameego",
      "integration_name": "Ameego"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-03-20T18:49:34.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-03-20T18:49:34.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "factorialhr",
      "created_at": "2024-03-20T18:49:34.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "FactorialHR"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-20T15:45:27.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "type",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-20T15:45:27.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-20T15:45:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-20T15:45:27.000Z",
      "object_type": "ats_activity",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-20T15:45:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Crelate"
   },
   {
      "type": "integration",
      "created_at": "2024-03-20T00:00:00.000Z",
      "categories": [
         "commerce",
         "accounting",
         "auth",
         "passthrough"
      ],
      "integration_type": "boldcommerce",
      "integration_name": "Bold Commerce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "parent_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "hash",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-03-19T15:15:22.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_query",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-03-19T15:15:22.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_parent_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "dropbox",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-03-19T15:15:22.000Z",
      "object_type": "storage_file",
      "integration_name": "Dropbox"
   },
   {
      "type": "integration",
      "created_at": "2024-03-19T00:00:00.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "myob",
      "integration_name": "MYOB"
   },
   {
      "type": "integration",
      "created_at": "2024-03-19T00:00:00.000Z",
      "categories": [
         "ticketing",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "intercom",
      "integration_name": "Intercom"
   },
   {
      "type": "integration",
      "created_at": "2024-03-18T00:00:00.000Z",
      "categories": [
         "accounting",
         "payment",
         "auth",
         "passthrough"
      ],
      "integration_type": "gocardless",
      "integration_name": "GoCardless"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "dropbox",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-03-14T13:50:21.000Z",
      "object_type": "storage_file",
      "integration_name": "Dropbox"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "dropbox",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-03-14T13:50:21.000Z",
      "object_type": "storage_file",
      "integration_name": "Dropbox"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gong",
      "categories": [
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2024-03-14T09:32:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Gong"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gong",
      "categories": [
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2024-03-14T09:32:14.000Z",
      "object_type": "hris_employee",
      "integration_name": "Gong"
   },
   {
      "type": "pagination",
      "integration_type": "gong",
      "created_at": "2024-03-14T09:32:14.000Z",
      "categories": [
         "hris",
         "uc",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Gong"
   },
   {
      "type": "sign-in",
      "integration_type": "stripe",
      "created_at": "2024-03-14T09:03:30.000Z",
      "integration_name": "Stripe",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "object",
      "created_at": "2024-03-14T09:03:30.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "attio",
      "object_type": "crm_event",
      "integration_name": "Attio"
   },
   {
      "type": "object",
      "created_at": "2024-03-14T09:03:30.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "attio",
      "object_type": "crm_lead",
      "integration_name": "Attio"
   },
   {
      "type": "object",
      "object_type": "crm_pipeline",
      "integration_type": "holded",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-03-08T10:25:42.000Z",
      "integration_name": "Holded"
   },
   {
      "type": "integration",
      "created_at": "2024-03-08T00:00:00.000Z",
      "categories": [
         "hris",
         "crm",
         "passthrough"
      ],
      "integration_type": "marketing360",
      "integration_name": "Marketing360"
   },
   {
      "type": "integration",
      "created_at": "2024-03-08T00:00:00.000Z",
      "categories": [
         "hris",
         "crm",
         "accounting",
         "commerce",
         "martech",
         "payment",
         "passthrough"
      ],
      "integration_type": "holded",
      "integration_name": "Holded"
   },
   {
      "type": "integration",
      "created_at": "2024-03-08T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "gem",
      "integration_name": "Gem"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-07T16:22:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-07T16:22:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-07T16:22:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-07T16:22:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-07T16:22:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "date_of_birth",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-07T16:22:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-07T16:22:33.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-03-06T17:43:14.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-06T17:43:14.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-06T17:43:14.000Z",
      "object_type": "ats_application",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-06T17:43:14.000Z",
      "object_type": "ats_job",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-06T17:43:14.000Z",
      "object_type": "ats_company",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-06T17:43:14.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-06T17:43:14.000Z",
      "object_type": "ats_application",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-06T17:43:14.000Z",
      "object_type": "ats_job",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-06T17:43:14.000Z",
      "object_type": "ats_company",
      "integration_name": "Crelate"
   },
   {
      "type": "object",
      "created_at": "2024-03-06T17:43:14.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "crelate",
      "object_type": "ats_company",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-05T12:50:32.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-05T12:50:32.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-05T12:50:32.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "payment_methods",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-01T17:43:07.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "payment_collection_method",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-01T17:43:07.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-01T17:43:07.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-01T17:43:07.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "due_at",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-01T17:43:07.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-01T17:43:07.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "contact_id",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-01T17:43:07.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "portal_url",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-03-01T17:43:07.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "payment_collection_method",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_group",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_group",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "payment_link",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "payment_link",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "commerce_item",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "commerce_item",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "crm_contact",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "crm_company",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "crm_deal",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_group",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "crm_lead",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "crm_contact",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "crm_company",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "crm_deal",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_group",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "outreach",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "crm_lead",
      "integration_name": "Outreach.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_job",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_application",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_job",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_application",
      "integration_name": "Manatal"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_company",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_job",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_application",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_company",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_job",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_application",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "integration_name": "JobAdder"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Checkr"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "checkr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Checkr"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "writable_field",
      "integration_type": "adp",
      "created_at": "2024-03-01T15:48:24.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "ADP Workforce Now"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "payment_payment",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "payment_payment",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Zoho Books"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_application",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_interview",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_job",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "hris_employee",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_application",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_interview",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_job",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "hris_employee",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_company",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "hris_employee",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "hris_group",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_event",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_company",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "hris_employee",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "hris_group",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesloft",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_event",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "recruitee",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Recruitee"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "recruitee",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Recruitee"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_interview",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_document",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_job",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_application",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "hris_employee",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_interview",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_document",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_job",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_application",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "hris_employee",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_company",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_deal",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "storage_file",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_company",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_deal",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "storage_file",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ticketing_customer",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "hubspot",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ticketing_ticket",
      "integration_name": "HubSpot"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_activity",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_activity",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Crelate"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_job",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cornerstone",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_job",
      "integration_name": "Cornerstone"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_company",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_deal",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_company",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "copper",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "crm_deal",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_interview",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_application",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_interview",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-29T09:11:52.000Z",
      "object_type": "ats_application",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_interview",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_application",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_interview",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_application",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_interview",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_application",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_interview",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_application",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "plum",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Plum"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "plum",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Plum"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "peakon",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Peakon"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "peakon",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Peakon"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "okta",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Okta"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "okta",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_group",
      "integration_name": "Okta"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "okta",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Okta"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "okta",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_group",
      "integration_name": "Okta"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "lucca",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Lucca"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "lucca",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Lucca"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "martech_list",
      "integration_name": "Klaviyo"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "klaviyo",
      "categories": [
         "martech",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "martech_list",
      "integration_name": "Klaviyo"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jumpcloud",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "JumpCloud"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jumpcloud",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "JumpCloud"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jobscore",
      "categories": [
         "ats"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "JobScore"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jazzhr",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JazzHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "jazzhr",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "JazzHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jazzhr",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "JazzHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "jazzhr",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "JazzHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "humaans",
      "categories": [
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Humaans"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "humaans",
      "categories": [
         "hris"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Humaans"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_interview",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_application",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_document",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_interview",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_application",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_document",
      "integration_name": "Greenhouse"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "googledrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "storage_file",
      "integration_name": "Google Drive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "gong",
      "categories": [
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "uc_call",
      "integration_name": "Gong"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "gong",
      "categories": [
         "hris",
         "uc",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "uc_call",
      "integration_name": "Gong"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "fountain",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_job",
      "integration_name": "Fountain"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "uc_call",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "cloudtalk",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "uc_call",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "breezyhr",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "ats_candidate",
      "integration_name": "BreezyHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "alexis",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Alexis"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "alexis",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-28T15:30:34.000Z",
      "object_type": "hris_employee",
      "integration_name": "Alexis"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-02-27T21:46:36.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-02-27T21:46:36.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-02-27T21:46:36.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "url",
      "integration_name": "Shopify"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-02-27T08:58:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-02-27T08:58:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-02-27T08:58:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Crelate"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-02-27T08:58:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-02-27T08:58:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Crelate"
   },
   {
      "type": "object",
      "object_type": "payment_link",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2024-02-26T19:33:16.000Z",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-02-26T19:33:16.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-02-26T19:33:16.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "field": "notes",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "box",
      "created_at": "2024-02-26T19:33:16.000Z",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_updated_gte",
      "integration_name": "Box"
   },
   {
      "type": "object",
      "object_type": "ats_activity",
      "integration_type": "recruiterflow",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-23T11:59:22.000Z",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "object",
      "object_type": "ats_activity",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2024-02-23T11:59:22.000Z",
      "integration_name": "Crelate"
   },
   {
      "type": "object",
      "object_type": "ats_activity",
      "integration_type": "bullhorn",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "created_at": "2024-02-23T11:59:22.000Z",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-02-21T16:47:03.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-02-21T16:47:03.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-02-21T16:47:03.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-02-21T16:47:03.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-02-21T16:47:03.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "currency",
      "integration_name": "Stripe"
   },
   {
      "type": "writable_field",
      "integration_type": "stripe",
      "created_at": "2024-02-21T16:47:03.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "Stripe"
   },
   {
      "type": "pagination",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-02-21T16:47:03.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "object_type": "storage_file",
      "pagination": "list_query",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "commerce_item",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "variants",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "stripe",
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "field": "billing_address",
      "integration_name": "Stripe"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftsharepoint",
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "hash",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoftonedrive",
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "hash",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "readable_field",
      "integration_type": "googledrive",
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "field": "hash",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "dropbox",
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "storage_file",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "hash",
      "integration_name": "Dropbox"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "box",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "storage_file",
      "integration_name": "Box"
   },
   {
      "type": "webhook-deleted-virtual",
      "integration_type": "box",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "storage_file",
      "integration_name": "Box"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "box",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "storage_file",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "box",
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "storage_file",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "field": "hash",
      "integration_name": "Box"
   },
   {
      "type": "readable_field",
      "integration_type": "awss3",
      "created_at": "2024-02-21T15:51:57.000Z",
      "object_type": "storage_file",
      "categories": [
         "storage"
      ],
      "field": "hash",
      "integration_name": "Amazon S3"
   },
   {
      "type": "integration",
      "created_at": "2024-02-16T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "loxo",
      "integration_name": "Loxo"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-02-14T21:12:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2024-02-14T21:12:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "jazzhr",
      "created_at": "2024-02-14T21:12:30.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "answers",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2024-02-14T21:12:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-02-14T21:12:30.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2024-02-14T14:42:27.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruiterflow",
      "created_at": "2024-02-14T14:42:27.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "integration",
      "created_at": "2024-02-14T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "checkr",
      "integration_name": "Checkr"
   },
   {
      "type": "integration",
      "created_at": "2024-02-14T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "breathehr",
      "integration_name": "BreatheHR"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2024-02-12T17:13:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2024-02-12T17:13:42.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "sources",
      "integration_name": "Lever"
   },
   {
      "type": "object",
      "object_type": "payment_payout",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2024-02-11T13:36:49.000Z",
      "integration_name": "Stripe"
   },
   {
      "type": "object",
      "object_type": "payment_refund",
      "integration_type": "stripe",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "created_at": "2024-02-11T13:36:49.000Z",
      "integration_name": "Stripe"
   },
   {
      "type": "integration",
      "created_at": "2024-02-11T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "cats",
      "integration_name": "CATS"
   },
   {
      "type": "integration",
      "created_at": "2024-02-09T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "outreach",
      "integration_name": "Outreach.io"
   },
   {
      "type": "object",
      "created_at": "2024-02-08T23:35:06.000Z",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "integration_type": "bullhorn",
      "object_type": "ats_application",
      "integration_name": "Bullhorn"
   },
   {
      "type": "integration",
      "created_at": "2024-02-08T00:00:00.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "recruitee",
      "integration_name": "Recruitee"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-02-07T13:52:48.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "questions",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2024-02-07T13:52:48.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-02-07T13:52:48.000Z",
      "object_type": "ats_scorecard",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "questions",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-02-07T10:50:16.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "field": "user_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-02-07T10:50:16.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "field": "company_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2024-02-07T10:50:16.000Z",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "integration_type": "bullhorn",
      "object_type": "ats_company",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2024-02-07T10:50:16.000Z",
      "object_type": "ats_applicationstatus",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2024-02-07T10:50:16.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2024-02-07T10:50:16.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_job_id",
      "integration_name": "Ashby"
   },
   {
      "type": "object",
      "created_at": "2024-02-07T10:50:16.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "ashby",
      "object_type": "ats_interview",
      "integration_name": "Ashby"
   },
   {
      "type": "integration",
      "created_at": "2024-02-07T00:00:00.000Z",
      "categories": [
         "accounting",
         "commerce",
         "passthrough"
      ],
      "integration_type": "stripe",
      "integration_name": "Stripe"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_application",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_job",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_candidate",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_application",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_job",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_candidate",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_applicationstatus",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_scorecard",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_application",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_job",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-02-06T17:15:33.000Z",
      "object_type": "ats_candidate",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "tribepad",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Tribepad"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "number_of_openings",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "number_of_openings",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "writable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "plum",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Plum"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Manatal"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Greenhouse"
   },
   {
      "type": "writable_field",
      "integration_type": "crelate",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "number_of_openings",
      "integration_name": "Cornerstone"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "field": "number_of_openings",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-02-05T22:23:27.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "field": "number_of_openings",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2024-02-05T17:00:52.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "object_type": "ats_company",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-05T12:15:56.000Z",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "title",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "websites",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "stage",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "probability",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "pipeline",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "lost_reason",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_ids",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_user_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_company_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_deal_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_user_id",
      "integration_name": "Copper"
   },
   {
      "type": "pagination",
      "integration_type": "copper",
      "created_at": "2024-02-05T12:15:56.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "Copper"
   },
   {
      "type": "object",
      "created_at": "2024-02-05T12:15:56.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "copper",
      "object_type": "hris_employee",
      "integration_name": "Copper"
   },
   {
      "type": "object",
      "created_at": "2024-02-05T12:15:56.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "copper",
      "object_type": "passthrough",
      "integration_name": "Copper"
   },
   {
      "type": "integration",
      "created_at": "2024-02-02T00:00:00.000Z",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "deputy",
      "integration_name": "Deputy"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_location",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_item",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_location",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_item",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_location",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_inventory",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_collection",
      "integration_name": "Shopify"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "commerce_item",
      "integration_name": "Shopify"
   },
   {
      "type": "sign-in",
      "integration_type": "shopify",
      "created_at": "2024-02-01T14:36:55.000Z",
      "integration_name": "Shopify",
      "categories": [
         "auth"
      ]
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-02-01T14:36:55.000Z",
      "object_type": "hris_employee",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "object_type": "commerce_location",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "object_type": "commerce_inventory",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "object_type": "commerce_collection",
      "integration_type": "shopify",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-02-01T14:36:55.000Z",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "created_at": "2024-02-01T14:36:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "accounting_invoice",
      "integration_name": "Shopify"
   },
   {
      "type": "object",
      "created_at": "2024-02-01T14:36:55.000Z",
      "categories": [
         "accounting",
         "commerce",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "shopify",
      "object_type": "accounting_contact",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-31T16:48:06.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-01-31T16:48:06.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-01-31T16:48:06.000Z",
      "object_type": "accounting_account",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "is_payable",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "workable",
      "created_at": "2024-01-31T16:48:06.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_query",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-31T16:48:06.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "lineitems",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-31T16:48:06.000Z",
      "object_type": "accounting_account",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "is_payable",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "is_supplier",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "is_customer",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "breezyhr",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2024-01-23T16:56:12.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "origin",
      "integration_name": "BreezyHR"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-01-23T10:33:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-01-23T10:33:38.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "field": "company_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-01-23T10:33:38.000Z",
      "object_type": "ats_job",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2024-01-23T10:33:38.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "ats",
         "hris"
      ],
      "field": "company_ids",
      "integration_name": "Bullhorn"
   },
   {
      "type": "integration",
      "created_at": "2024-01-23T00:00:00.000Z",
      "categories": [
         "hris",
         "uc",
         "passthrough"
      ],
      "integration_type": "gong",
      "integration_name": "Gong"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "googledirectory",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-01-22T12:58:44.000Z",
      "object_type": "hris_employee",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "googledirectory",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-01-22T12:58:44.000Z",
      "object_type": "hris_employee",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "googledirectory",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2024-01-22T12:58:44.000Z",
      "object_type": "hris_employee",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2024-01-22T10:01:09.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "work_histories",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2024-01-22T10:01:09.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "apollo",
      "created_at": "2024-01-22T10:01:09.000Z",
      "object_type": "enrich_person",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Apollo.io"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_account_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_ticket_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Xero"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_interview",
      "pagination": "list_interview_id",
      "integration_name": "Workday"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Workable"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "workable",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Workable"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_interview_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_application_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_candidate_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendfox",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "SendFox"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "ats_candidate",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_contact",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_lead",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_deal",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "ats_job",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "hris_employee",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "ats_candidate",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_contact",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_lead",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_deal",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "ats_job",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "hris_employee",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "ats_candidate",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_company",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_contact",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_lead",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "crm_deal",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "ats_job",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "recruitcrm",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "hris_employee",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-21T23:01:58.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "Mailchimp"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "Klaviyo"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_query",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_ticket_id",
      "integration_name": "Gorgias"
   },
   {
      "type": "pagination",
      "integration_type": "apollo",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedin_url",
      "integration_name": "Apollo.io"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-01-21T23:01:58.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "writable_field",
      "integration_type": "zoom",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "accounting_account",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zohobooks",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "accounting_journal",
      "pagination": "list_account_id",
      "integration_name": "Zoho Books"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_ticket_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workday",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "user_ids",
      "integration_name": "Workday"
   },
   {
      "type": "pagination",
      "integration_type": "workday",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_interview",
      "pagination": "list_interview_id",
      "integration_name": "Workday"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_interview_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_application_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "pagination",
      "integration_type": "successfactors",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "ats",
         "hris"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_candidate_id",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "writable_field",
      "integration_type": "strongdm",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "StrongDM"
   },
   {
      "type": "pagination",
      "integration_type": "sendgrid",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "SendGrid"
   },
   {
      "type": "pagination",
      "integration_type": "sendfox",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "SendFox"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "taxrate_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "accounting_journal",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "tax_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "monday",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "mailchimp",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "martech",
         "auth"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "Mailchimp"
   },
   {
      "type": "readable_field",
      "integration_type": "leapsome",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Leapsome"
   },
   {
      "type": "pagination",
      "integration_type": "klaviyo",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "martech",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "Klaviyo"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_query",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_list_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "gorgias",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_note",
      "pagination": "list_ticket_id",
      "integration_name": "Gorgias"
   },
   {
      "type": "writable_field",
      "integration_type": "googledirectory",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "writable_field",
      "integration_type": "factorialhr",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "FactorialHR"
   },
   {
      "type": "readable_field",
      "integration_type": "factorialhr",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "FactorialHR"
   },
   {
      "type": "pagination",
      "integration_type": "apollo",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "enrich",
         "passthrough"
      ],
      "object_type": "enrich_person",
      "pagination": "search_linkedin_url",
      "integration_name": "Apollo.io"
   },
   {
      "type": "pagination",
      "integration_type": "activecampaign",
      "created_at": "2024-01-20T22:00:21.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_list",
      "pagination": "list_list_id",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "15five",
      "created_at": "2024-01-20T22:00:21.000Z",
      "object_type": "hris_group",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "user_ids",
      "integration_name": "15Five"
   },
   {
      "type": "readable_field",
      "integration_type": "zoom",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Zoom"
   },
   {
      "type": "readable_field",
      "integration_type": "strongdm",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "StrongDM"
   },
   {
      "type": "readable_field",
      "integration_type": "shopify",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Shopify"
   },
   {
      "type": "readable_field",
      "integration_type": "scoro",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Scoro"
   },
   {
      "type": "readable_field",
      "integration_type": "plusplus",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "PlusPlus"
   },
   {
      "type": "readable_field",
      "integration_type": "peakon",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Peakon"
   },
   {
      "type": "readable_field",
      "integration_type": "monday",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "microsoft_ad",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "readable_field",
      "integration_type": "lattice",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Lattice"
   },
   {
      "type": "readable_field",
      "integration_type": "jumpcloud",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "JumpCloud"
   },
   {
      "type": "readable_field",
      "integration_type": "enboarder",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Enboarder"
   },
   {
      "type": "readable_field",
      "integration_type": "deel",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Deel"
   },
   {
      "type": "readable_field",
      "integration_type": "alexis",
      "created_at": "2024-01-17T23:08:50.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Alexis"
   },
   {
      "type": "integration",
      "created_at": "2024-01-17T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "auth",
         "passthrough"
      ],
      "integration_type": "salesloft",
      "integration_name": "Salesloft"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_event",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_deal",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_company",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "hris_employee",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_event",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_deal",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_lead",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_company",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_contact",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesforce",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "hris_employee",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2024-01-16T16:50:52.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "storage_file",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "hris_employee",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Manatal"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-16T16:50:52.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2024-01-16T16:50:52.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "storage",
         "passthrough"
      ],
      "integration_type": "hubspot",
      "object_type": "storage_file",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-10T20:21:50.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2024-01-10T20:21:50.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2024-01-10T20:21:50.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-01-10T20:21:50.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-10T20:21:50.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "zendesk",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesk",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "pagination",
      "integration_type": "zendesk",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "ticketing",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_user_id",
      "integration_name": "Zendesk"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "payment_payment",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "payment_payment",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "account_id",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_user_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "user_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "user_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "user_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "user_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "user_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "justcall",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "JustCall"
   },
   {
      "type": "pagination",
      "integration_type": "justcall",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "uc",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_user_id",
      "integration_name": "JustCall"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_deal",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_company_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_company_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_user_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "gorgias",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "ticketing_note",
      "categories": [
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Gorgias"
   },
   {
      "type": "readable_field",
      "integration_type": "cloudtalk",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "pagination",
      "integration_type": "cloudtalk",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "uc",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_user_id",
      "integration_name": "Cloudtalk.io"
   },
   {
      "type": "readable_field",
      "integration_type": "aircall",
      "created_at": "2024-01-10T18:46:43.000Z",
      "object_type": "uc_call",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "user_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2024-01-10T18:46:43.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_user_id",
      "integration_name": "AirCall.io"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2024-01-07T20:51:14.000Z",
      "object_type": "payment_payment",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2024-01-07T20:51:14.000Z",
      "object_type": "payment_payment",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "reference",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2024-01-07T20:51:14.000Z",
      "object_type": "payment_payment",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "invoice_id",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "created_at": "2024-01-07T20:51:14.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workable",
      "object_type": "hris_group",
      "integration_name": "Workable"
   },
   {
      "type": "object",
      "created_at": "2024-01-07T20:51:14.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "workable",
      "object_type": "hris_employee",
      "integration_name": "Workable"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-07T20:51:14.000Z",
      "object_type": "payment_payment",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "invoice_id",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-07T20:51:14.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "paid_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "greenhouse",
      "created_at": "2024-01-07T20:51:14.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Greenhouse"
   },
   {
      "type": "integration",
      "created_at": "2024-01-07T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "ukg_hr",
      "integration_name": "UKG HR Service Delivery"
   },
   {
      "type": "integration",
      "created_at": "2024-01-05T00:00:00.000Z",
      "categories": [
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "netsuite",
      "integration_name": "NetSuite"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-01T11:22:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "invoice_number",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "quickbooks",
      "created_at": "2024-01-01T11:22:26.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "invoice_number",
      "integration_name": "QuickBooks"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "cancelled_at",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Salesforce"
   },
   {
      "type": "writable_field",
      "integration_type": "quickbooks",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "field": "total_amount",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_employee",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "microsoft_ad",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_group",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2023-12-30T20:51:35.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2023-12-30T20:51:35.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2023-12-30T20:51:35.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2023-12-30T20:51:35.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2023-12-30T20:51:35.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "pagination",
      "integration_type": "microsoft_ad",
      "created_at": "2023-12-30T20:51:35.000Z",
      "categories": [
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "Microsoft Active Directory / Entra ID"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "timezone",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "industry",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "employees",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "manager_id",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "image_url",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2023-12-30T20:51:35.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "teamtailor",
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_limit",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_offset",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "smartrecruiters",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_offset",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "sagehr",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Sage HR"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Paradox"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Paradox"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Paradox"
   },
   {
      "type": "pagination",
      "integration_type": "paradox",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Paradox"
   },
   {
      "type": "object",
      "object_type": "storage_file",
      "integration_type": "microsoftsharepoint",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "object",
      "object_type": "storage_file",
      "integration_type": "microsoftonedrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_offset",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_interview",
      "pagination": "list_limit",
      "integration_name": "Lever"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "crm_deal",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "crm_contact",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "crm_lead",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "crm_company",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "crm_deal",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "crm_contact",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "crm_lead",
      "integration_name": "HighLevel"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "highlevel",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "crm_company",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_offset",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_offset",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_offset",
      "integration_name": "HighLevel"
   },
   {
      "type": "pagination",
      "integration_type": "highlevel",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_offset",
      "integration_name": "HighLevel"
   },
   {
      "type": "object",
      "object_type": "storage_file",
      "integration_type": "googledrive",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "integration_name": "Google Drive"
   },
   {
      "type": "readable_field",
      "integration_type": "googledirectory",
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "hris_employee",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "language_locale",
      "integration_name": "Google Workspace Directory"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_limit",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_limit",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "fountain",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Fountain"
   },
   {
      "type": "pagination",
      "integration_type": "factorialhr",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "FactorialHR"
   },
   {
      "type": "object",
      "object_type": "storage_file",
      "integration_type": "dropbox",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "integration_name": "Dropbox"
   },
   {
      "type": "object",
      "object_type": "storage_file",
      "integration_type": "box",
      "categories": [
         "auth",
         "storage",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "integration_name": "Box"
   },
   {
      "type": "object",
      "object_type": "storage_file",
      "integration_type": "awss3",
      "categories": [
         "storage"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "integration_name": "Amazon S3"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_limit",
      "integration_name": "Ashby"
   },
   {
      "type": "pagination",
      "integration_type": "ashby",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Ashby"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "uc_call",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "uc_contact",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "uc_call",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "uc_contact",
      "integration_name": "AirCall.io"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "aircall",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-27T17:43:00.000Z",
      "object_type": "hris_employee",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_call",
      "pagination": "list_offset",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "uc_contact",
      "pagination": "list_offset",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "aircall",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "uc",
         "auth",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "AirCall.io"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_limit",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_limit",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_limit",
      "integration_name": "Affinity"
   },
   {
      "type": "pagination",
      "integration_type": "affinity",
      "created_at": "2023-12-27T17:43:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_limit",
      "integration_name": "Affinity"
   },
   {
      "type": "integration",
      "created_at": "2023-12-27T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "lucca",
      "integration_name": "Lucca"
   },
   {
      "type": "integration",
      "created_at": "2023-12-22T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftsharepoint",
      "integration_name": "Microsoft SharePoint"
   },
   {
      "type": "integration",
      "created_at": "2023-12-22T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoftonedrive",
      "integration_name": "Microsoft OneDrive"
   },
   {
      "type": "integration",
      "created_at": "2023-12-22T00:00:00.000Z",
      "categories": [
         "storage",
         "auth",
         "passthrough"
      ],
      "integration_type": "googledrive",
      "integration_name": "Google Drive"
   },
   {
      "type": "integration",
      "created_at": "2023-12-22T00:00:00.000Z",
      "categories": [
         "storage"
      ],
      "integration_type": "awss3",
      "integration_name": "Amazon S3"
   },
   {
      "type": "object",
      "object_type": "commerce_item",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "invoice_number",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "commerce_item",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_account",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "payment_payment",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "hris_employee",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "commerce_item",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_account",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_journal",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "payment_payment",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_contact",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "hris_employee",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "commerce_item",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "commerce_item",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_account",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_journal",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "payment_payment",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_contact",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "hris_employee",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "commerce_item",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_account",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_journal",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_taxrate",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "payment_payment",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_contact",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "accounting_invoice",
      "integration_name": "QuickBooks"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "commerce",
         "payment",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "hris_employee",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "commerce_item",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-20T10:31:54.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "company",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "crm_company",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "deal_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-20T10:31:54.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "zohorecruit",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "readable_field",
      "integration_type": "zohorecruit",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "zohorecruit",
      "categories": [
         "ats",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Zoho Recruit"
   },
   {
      "type": "writable_field",
      "integration_type": "zohocrm",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohocrm",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "readable_field",
      "integration_type": "zohobooks",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_organization",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_account",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_journal",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "object",
      "object_type": "accounting_taxrate",
      "integration_type": "zohobooks",
      "categories": [
         "accounting",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Zoho Books"
   },
   {
      "type": "readable_field",
      "integration_type": "zendesksell",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "shipping_address",
      "integration_name": "Xero"
   },
   {
      "type": "writable_field",
      "integration_type": "xero",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "accounting_invoice",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "paid_amount",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "accounting_contact",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "tax_number",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "employee_number",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "xero",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "hris_employee",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_organization",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_account",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_journal",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "object",
      "object_type": "accounting_taxrate",
      "integration_type": "xero",
      "categories": [
         "auth",
         "hris",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Xero"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "workable",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Workable"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "workable",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Workable"
   },
   {
      "type": "readable_field",
      "integration_type": "tribepad",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Tribepad"
   },
   {
      "type": "readable_field",
      "integration_type": "tribepad",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Tribepad"
   },
   {
      "type": "readable_field",
      "integration_type": "tribepad",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Tribepad"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_document",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_job",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "hris_employee",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "hris_group",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_document",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_job",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "hris_employee",
      "integration_name": "Teamtailor"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "hris_group",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Teamtailor"
   },
   {
      "type": "readable_field",
      "integration_type": "teamtailor",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "pagination",
      "integration_type": "teamtailor",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_group",
      "pagination": "list_updated_gte",
      "integration_name": "Teamtailor"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "teamtailor",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Teamtailor"
   },
   {
      "type": "writable_field",
      "integration_type": "successfactors",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "hired_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "original_status",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "successfactors",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris"
      ],
      "field": "hired_at",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "successfactors",
      "categories": [
         "ats",
         "hris"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "SAP SuccessFactors"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "readable_field",
      "integration_type": "smartrecruiters",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "smartrecruiters",
      "categories": [
         "ats",
         "auth",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "SmartRecruiters"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "Salesforce"
   },
   {
      "type": "object",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "auth",
         "hris",
         "passthrough"
      ],
      "integration_type": "salesforce",
      "object_type": "passthrough",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "sagehr",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Sage HR"
   },
   {
      "type": "readable_field",
      "integration_type": "recruiterflow",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Recruiterflow"
   },
   {
      "type": "readable_field",
      "integration_type": "recruitcrm",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "object",
      "object_type": "accounting_organization",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_account",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_journal",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "object",
      "object_type": "accounting_taxrate",
      "integration_type": "quickbooks",
      "categories": [
         "hris",
         "auth",
         "accounting",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "QuickBooks"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "telephones",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "pipedrive",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "emails",
      "integration_name": "Pipedrive"
   },
   {
      "type": "readable_field",
      "integration_type": "pipedrive",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth"
      ],
      "field": "company_name",
      "integration_name": "Pipedrive"
   },
   {
      "type": "writable_field",
      "integration_type": "manatal",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "manatal",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Manatal"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "manatal",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Manatal"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_limit",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_document",
      "pagination": "list_offset",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_candidate",
      "pagination": "list_offset",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_job",
      "pagination": "list_offset",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_scorecard",
      "pagination": "list_offset",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "ats_application",
      "pagination": "list_offset",
      "integration_name": "Lever"
   },
   {
      "type": "pagination",
      "integration_type": "lever",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "object_type": "hris_employee",
      "pagination": "list_offset",
      "integration_name": "Lever"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "lever",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Lever"
   },
   {
      "type": "object",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "lever",
      "object_type": "ats_interview",
      "integration_name": "Lever"
   },
   {
      "type": "readable_field",
      "integration_type": "jobscore",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats"
      ],
      "field": "link_urls",
      "integration_name": "JobScore"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "job_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "jobadder",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "candidate_id",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "JobAdder"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "jobadder",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "JazzHR"
   },
   {
      "type": "readable_field",
      "integration_type": "jazzhr",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "JazzHR"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "integration_name": "iCIMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_job",
      "integration_name": "iCIMS"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "integration_name": "iCIMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "integration_name": "iCIMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_job",
      "integration_name": "iCIMS"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "icims",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "updated_at",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "departments",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "iCIMS"
   },
   {
      "type": "readable_field",
      "integration_type": "icims",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "created_at",
      "integration_name": "iCIMS"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "icims",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "iCIMS"
   },
   {
      "type": "object",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "icims",
      "object_type": "ats_application",
      "integration_name": "iCIMS"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "task",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "meeting",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "email",
      "integration_name": "HubSpot"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "call",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "hris_employee",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "employment_status",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_company",
      "pagination": "list_query",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_query",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_contact",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_deal",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_query",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_event",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "martech_member",
      "pagination": "list_query",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_customer",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_updated_gte",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_sort_by_created_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_sort_by_updated_at",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-12-18T09:02:31.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "ticketing_ticket",
      "pagination": "list_order",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouseingest",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "auth"
      ],
      "field": "original_status",
      "integration_name": "Greenhouse (Ingest)"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Greenhouse"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "greenhouse",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "source",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "crelate",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Crelate"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "crelate",
      "categories": [
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Crelate"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Cornerstone"
   },
   {
      "type": "readable_field",
      "integration_type": "cornerstone",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "hired_at",
      "integration_name": "Cornerstone"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "cornerstone",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Cornerstone"
   },
   {
      "type": "writable_field",
      "integration_type": "copper",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm"
      ],
      "field": "company_name",
      "integration_name": "Copper"
   },
   {
      "type": "readable_field",
      "integration_type": "copper",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm"
      ],
      "field": "company_name",
      "integration_name": "Copper"
   },
   {
      "type": "writable_field",
      "integration_type": "closeio",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "telephones",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "closeio",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "contact_id",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "closeio",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "company_name",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "closeio",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_contact",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "company_ids",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "closeio",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "company_id",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "telephones",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "emails",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "company_name",
      "integration_name": "Close"
   },
   {
      "type": "readable_field",
      "integration_type": "closeio",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "hris"
      ],
      "field": "company_id",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "auth",
         "hris"
      ],
      "field": "company_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "auth",
         "hris"
      ],
      "field": "company_name",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "breezyhr",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "BreezyHR"
   },
   {
      "type": "readable_field",
      "integration_type": "bamboohr",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "bamboohr",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "BambooHR"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_application",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "original_status",
      "integration_name": "Ashby"
   },
   {
      "type": "readable_field",
      "integration_type": "ashby",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "link_urls",
      "integration_name": "Ashby"
   },
   {
      "type": "object",
      "object_type": "ats_applicationstatus",
      "integration_type": "ashby",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-12-18T09:02:31.000Z",
      "integration_name": "Ashby"
   },
   {
      "type": "writable_field",
      "integration_type": "activecampaign",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "readable_field",
      "integration_type": "activecampaign",
      "created_at": "2023-12-18T09:02:31.000Z",
      "object_type": "crm_lead",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "field": "company_name",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "integration",
      "created_at": "2023-12-08T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "elmo",
      "integration_name": "ELMO"
   },
   {
      "type": "integration",
      "created_at": "2023-12-01T00:00:00.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "paycom",
      "integration_name": "Paycom"
   },
   {
      "type": "integration",
      "created_at": "2023-12-01T00:00:00.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "attio",
      "integration_name": "Attio"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "telephones",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "tags",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "remote",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "name",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "employment_type",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "emails",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "description",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "departments",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "addresses",
      "integration_name": "Lever"
   },
   {
      "type": "writable_field",
      "integration_type": "lever",
      "created_at": "2023-11-20T19:51:39.000Z",
      "object_type": "ats_candidate",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "field": "address",
      "integration_name": "Lever"
   },
   {
      "type": "integration",
      "created_at": "2023-11-20T00:00:00.000Z",
      "categories": [
         "passthrough"
      ],
      "integration_type": "datadog",
      "integration_name": "Datadog"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zoom",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zoom"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "zoom",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_group",
      "integration_name": "Zoom"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zoom",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Zoom"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "zoom",
      "categories": [
         "hris",
         "auth",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_group",
      "integration_name": "Zoom"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "strongdm",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "StrongDM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "strongdm",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_group",
      "integration_name": "StrongDM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "strongdm",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "StrongDM"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "strongdm",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_group",
      "integration_name": "StrongDM"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris"
      ],
      "field": "lead_ids",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "auth",
         "hris"
      ],
      "field": "lead_ids",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2023-11-17T17:02:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris"
      ],
      "object_type": "crm_lead",
      "pagination": "list_contact_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "salesforce",
      "created_at": "2023-11-17T17:02:50.000Z",
      "categories": [
         "crm",
         "auth",
         "hris"
      ],
      "object_type": "crm_lead",
      "pagination": "list_company_id",
      "integration_name": "Salesforce"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2023-11-17T17:02:50.000Z",
      "categories": [
         "crm",
         "auth"
      ],
      "object_type": "crm_lead",
      "pagination": "list_company_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "pagination",
      "integration_type": "pipedrive",
      "created_at": "2023-11-17T17:02:50.000Z",
      "categories": [
         "crm",
         "auth"
      ],
      "object_type": "crm_lead",
      "pagination": "list_contact_id",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "monday",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_group",
      "integration_name": "Monday"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "monday",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Monday"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "monday",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_group",
      "integration_name": "Monday"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "monday",
      "categories": [
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "hris_employee",
      "integration_name": "Monday"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "status",
      "integration_name": "JobAdder"
   },
   {
      "type": "readable_field",
      "integration_type": "jobadder",
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "hris",
         "auth",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "JobAdder"
   },
   {
      "type": "writable_field",
      "integration_type": "hubspot",
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "lead_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "crm_event",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "lead_ids",
      "integration_name": "HubSpot"
   },
   {
      "type": "readable_field",
      "integration_type": "hubspot",
      "created_at": "2023-11-17T17:02:50.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "field": "company_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-11-17T17:02:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_contact_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "pagination",
      "integration_type": "hubspot",
      "created_at": "2023-11-17T17:02:50.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "object_type": "crm_lead",
      "pagination": "list_company_id",
      "integration_name": "HubSpot"
   },
   {
      "type": "integration",
      "created_at": "2023-11-13T00:00:00.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "cornerstone",
      "integration_name": "Cornerstone"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "zohocrm",
      "object_type": "crm_lead",
      "integration_name": "Zoho CRM"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "zendesksell",
      "object_type": "crm_lead",
      "integration_name": "ZendeskSell"
   },
   {
      "type": "writable_field",
      "integration_type": "salesforce",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris"
      ],
      "field": "status",
      "integration_name": "Salesforce"
   },
   {
      "type": "readable_field",
      "integration_type": "salesforce",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "auth",
         "hris"
      ],
      "field": "status",
      "integration_name": "Salesforce"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesflare",
      "categories": [
         "crm"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_company",
      "integration_name": "Salesflare"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesflare",
      "categories": [
         "crm"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "Salesflare"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesflare",
      "categories": [
         "crm"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "integration_name": "Salesflare"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "salesflare",
      "categories": [
         "crm"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Salesflare"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesflare",
      "categories": [
         "crm"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_company",
      "integration_name": "Salesflare"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesflare",
      "categories": [
         "crm"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "Salesflare"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesflare",
      "categories": [
         "crm"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "integration_name": "Salesflare"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "salesflare",
      "categories": [
         "crm"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Salesflare"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm"
      ],
      "integration_type": "salesflare",
      "object_type": "crm_lead",
      "integration_name": "Salesflare"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "hris",
         "ats",
         "passthrough"
      ],
      "integration_type": "sagehr",
      "object_type": "ats_application",
      "integration_name": "Sage HR"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "ats",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "recruitcrm",
      "object_type": "crm_lead",
      "integration_name": "RecruitCRM"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_company",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_company",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_company",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-deleted-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_company",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_company",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "Pipedrive"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "pipedrive",
      "categories": [
         "crm",
         "auth"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Pipedrive"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm",
         "auth"
      ],
      "integration_type": "pipedrive",
      "object_type": "crm_lead",
      "integration_name": "Pipedrive"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm",
         "martech",
         "auth",
         "ticketing",
         "hris",
         "passthrough"
      ],
      "integration_type": "hubspot",
      "object_type": "crm_lead",
      "integration_name": "HubSpot"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm",
         "auth",
         "passthrough"
      ],
      "integration_type": "highlevel",
      "object_type": "crm_lead",
      "integration_name": "HighLevel"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "recruiter_ids",
      "integration_name": "Greenhouse"
   },
   {
      "type": "readable_field",
      "integration_type": "greenhouse",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "ats_job",
      "categories": [
         "ats",
         "passthrough"
      ],
      "field": "hiring_manager_ids",
      "integration_name": "Greenhouse"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm"
      ],
      "integration_type": "freshsales",
      "object_type": "crm_lead",
      "integration_name": "Freshsales CRM"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm"
      ],
      "integration_type": "copper",
      "object_type": "crm_lead",
      "integration_name": "Copper"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Close"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_company",
      "integration_name": "Close"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "Close"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Close"
   },
   {
      "type": "webhook-updated-native",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "hris_employee",
      "integration_name": "Close"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Close"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_company",
      "integration_name": "Close"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "Close"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "Close"
   },
   {
      "type": "webhook-created-native",
      "integration_type": "closeio",
      "categories": [
         "crm",
         "hris"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "hris_employee",
      "integration_name": "Close"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm",
         "hris"
      ],
      "integration_type": "closeio",
      "object_type": "crm_lead",
      "integration_name": "Close"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "auth",
         "hris"
      ],
      "field": "status",
      "integration_name": "Bullhorn"
   },
   {
      "type": "writable_field",
      "integration_type": "bullhorn",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "auth",
         "hris"
      ],
      "field": "source",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "auth",
         "hris"
      ],
      "field": "status",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "auth",
         "hris"
      ],
      "field": "source",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "auth",
         "hris"
      ],
      "field": "is_active",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "auth",
         "hris"
      ],
      "field": "contact_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "readable_field",
      "integration_type": "bullhorn",
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "categories": [
         "crm",
         "ats",
         "auth",
         "hris"
      ],
      "field": "company_id",
      "integration_name": "Bullhorn"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "bamboohr",
      "object_type": "ats_job",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "hris",
         "passthrough"
      ],
      "integration_type": "bamboohr",
      "object_type": "ats_application",
      "integration_name": "BambooHR"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "crm",
         "passthrough"
      ],
      "integration_type": "affinity",
      "object_type": "crm_lead",
      "integration_name": "Affinity"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "webhook-updated-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_deal",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_contact",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "webhook-created-virtual",
      "integration_type": "activecampaign",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "created_at": "2023-11-10T13:43:22.000Z",
      "object_type": "crm_lead",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "object",
      "created_at": "2023-11-10T13:43:22.000Z",
      "categories": [
         "martech",
         "crm",
         "hris",
         "passthrough"
      ],
      "integration_type": "activecampaign",
      "object_type": "crm_lead",
      "integration_name": "ActiveCampaign"
   },
   {
      "type": "object",
      "created_at": "2023-11-08T09:51:40.000Z",
      "categories": [
         "ats",
         "passthrough"
      ],
      "integration_type": "workable",
      "object_type": "ats_document",
      "integration_name": "Workable"
   },
   {
      "type": "object",
      "created_at": "2023-11-08T09:51:40.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "teamtailor",
      "object_type": "ats_document",
      "integration_name": "Teamtailor"
   },
   {
      "type": "integration",
      "created_at": "2023-09-23T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "docusign",
      "integration_name": "DocuSign"
   },
   {
      "type": "integration",
      "created_at": "2023-03-16T00:00:00.000Z",
      "categories": [
         "ats",
         "hris",
         "passthrough"
      ],
      "integration_type": "successfactors_oidc",
      "integration_name": "SAP SuccessFactors (OpenID Connect)"
   },
   {
      "type": "integration",
      "created_at": "2023-01-12T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "microsoft",
      "integration_name": "Microsoft"
   },
   {
      "type": "integration",
      "created_at": "2023-01-12T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "heroku",
      "integration_name": "Heroku"
   },
   {
      "type": "integration",
      "created_at": "2023-01-11T00:00:00.000Z",
      "categories": [
         "auth",
         "passthrough"
      ],
      "integration_type": "google",
      "integration_name": "Google"
   },
   {
      "type": "integration",
      "created_at": "2023-01-11T00:00:00.000Z",
      "categories": [
         "auth"
      ],
      "integration_type": "facebook",
      "integration_name": "Facebook"
   }
]